(function () {  (function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kmBYL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ed335297f596d06b$export$6503ec6e8aabbaf; }, function (v) { return $ed335297f596d06b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ed335297f596d06b$export$f7ad0328861e2f03; }, function (v) { return $ed335297f596d06b$export$f7ad0328861e2f03 = v; });
var $ed335297f596d06b$export$6503ec6e8aabbaf;
var $ed335297f596d06b$export$f7ad0328861e2f03;
"use strict";
var $ed335297f596d06b$var$mapping = new Map();
function $ed335297f596d06b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ed335297f596d06b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ed335297f596d06b$var$resolve(id) {
    var resolved = $ed335297f596d06b$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ed335297f596d06b$export$6503ec6e8aabbaf = $ed335297f596d06b$var$register;
$ed335297f596d06b$export$f7ad0328861e2f03 = $ed335297f596d06b$var$resolve;

});

parcelRegister("acCeR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $76d8afccef593a30$export$bdfd709ae4826697; }, function (v) { return $76d8afccef593a30$export$bdfd709ae4826697 = v; });
var $76d8afccef593a30$export$bdfd709ae4826697;
var $76d8afccef593a30$export$c9e73fbda7da57b6;
var $76d8afccef593a30$export$5a759dc7a1cfb72a;
"use strict";
var $76d8afccef593a30$var$bundleURL = {};
function $76d8afccef593a30$var$getBundleURLCached(id) {
    var value = $76d8afccef593a30$var$bundleURL[id];
    if (!value) {
        value = $76d8afccef593a30$var$getBundleURL();
        $76d8afccef593a30$var$bundleURL[id] = value;
    }
    return value;
}
function $76d8afccef593a30$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $76d8afccef593a30$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $76d8afccef593a30$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $76d8afccef593a30$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$76d8afccef593a30$export$bdfd709ae4826697 = $76d8afccef593a30$var$getBundleURLCached;
$76d8afccef593a30$export$c9e73fbda7da57b6 = $76d8afccef593a30$var$getBaseURL;
$76d8afccef593a30$export$5a759dc7a1cfb72a = $76d8afccef593a30$var$getOrigin;

});

parcelRegister("7tffA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $570712438761e3da$export$71511d61b312f219; });
function $570712438761e3da$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("3CDbU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a3352405221b396$export$71511d61b312f219; });
function $2a3352405221b396$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("jyA4z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e3cd2c94b54532ef$export$71511d61b312f219; });
function $e3cd2c94b54532ef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e3cd2c94b54532ef$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $e3cd2c94b54532ef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e3cd2c94b54532ef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("gzN0P", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $933fe0576ddd6db1$export$e506a1d27d1eaa20; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $933fe0576ddd6db1$export$e506a1d27d1eaa20 = /*#__PURE__*/ function() {
    "use strict";
    function config() {
        (0, $3CDbU._)(this, config);
    }
    (0, $jyA4z._)(config, null, [
        {
            key: "import",
            value: function _import(product) {
                this.product = product;
            }
        }
    ]);
    return config;
}();
$933fe0576ddd6db1$export$e506a1d27d1eaa20.websiteUrl = undefined;
var $933fe0576ddd6db1$var$_httpssedestralcom;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.domain = ($933fe0576ddd6db1$var$_httpssedestralcom = "https://sedestral.com") !== null && $933fe0576ddd6db1$var$_httpssedestralcom !== void 0 ? $933fe0576ddd6db1$var$_httpssedestralcom : window.location.origin;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.version = "0fa1aa38";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.environment = "prod";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.isDev = false;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.isProd = $933fe0576ddd6db1$export$e506a1d27d1eaa20.environment == "prod";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.httpPanelUrl = "https://sedestral.com/panel";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.httpCommunityUrl = undefined;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.websocketPanelUrl = "wss://livechat.sedestral.com/websocket";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.websocketCommunityUrl = "";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.editorCollaborationUrl = undefined;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.rumEnabled = false;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.blogSubDomain = undefined;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.tenorKey = "1HFPKNKBSCVT";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.tenorHost = "https://g.tenor.com/v1/";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.tenorMediaHost = "https://media.tenor.com/";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.domainParent = "sedestral.com";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.prestaShopModuleVersion = "1.0.14";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.prestaShopFileName = "sedestral_v" + $933fe0576ddd6db1$export$e506a1d27d1eaa20.prestaShopModuleVersion + ".zip";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.prestaShopModuleLink = "/module/" + $933fe0576ddd6db1$export$e506a1d27d1eaa20.prestaShopFileName;
$933fe0576ddd6db1$export$e506a1d27d1eaa20.hotjarId = "5125087";
$933fe0576ddd6db1$export$e506a1d27d1eaa20.hotjarPanelId = undefined;

});

parcelRegister("sLFOe", function(module, exports) {


module.exports = (parcelRequire("e3Pk5"))((parcelRequire("kmBYL")).resolve("2MyrY")).then(function() {
    return parcelRequire('3VVYy');
});

});
parcelRegister("e3Pk5", function(module, exports) {
"use strict";

var $5JB0P = parcelRequire("5JB0P");
module.exports = $5JB0P(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("5JB0P", function(module, exports) {
"use strict";
var $42cddd9f086dcdf6$var$cachedBundles = {};
var $42cddd9f086dcdf6$var$cachedPreloads = {};
var $42cddd9f086dcdf6$var$cachedPrefetches = {};
function $42cddd9f086dcdf6$var$getCache(type) {
    switch(type){
        case 'preload':
            return $42cddd9f086dcdf6$var$cachedPreloads;
        case 'prefetch':
            return $42cddd9f086dcdf6$var$cachedPrefetches;
        default:
            return $42cddd9f086dcdf6$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $42cddd9f086dcdf6$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lThic", function(module, exports) {

$parcel$export(module.exports, "EntityService", function () { return $49565aada8ffadd8$export$714c657d7d597c58; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $fIUGb = parcelRequire("fIUGb");

var $gFQjy = parcelRequire("gFQjy");

var $8GOyH = parcelRequire("8GOyH");

var $7WDX1 = parcelRequire("7WDX1");

var $igmb3 = parcelRequire("igmb3");

var $38D2A = parcelRequire("38D2A");

var $3PS2c = parcelRequire("3PS2c");

var $kk7Zr = parcelRequire("kk7Zr");

var $1LZ0s = parcelRequire("1LZ0s");

var $co7RM = parcelRequire("co7RM");

var $gzN0P = parcelRequire("gzN0P");

var $9IvVr = parcelRequire("9IvVr");

var $yJnBa = parcelRequire("yJnBa");

var $62tsD = parcelRequire("62tsD");
var $49565aada8ffadd8$export$714c657d7d597c58 = /*#__PURE__*/ function() {
    "use strict";
    function EntityService() {
        (0, $3CDbU._)(this, EntityService);
    }
    (0, $jyA4z._)(EntityService, null, [
        {
            key: "activeEntity",
            get: /**
     * get and set
     */ function get() {
                var _EntityService_activeEntities_find;
                this.initActives();
                return (_EntityService_activeEntities_find = EntityService.activeEntities.find(function(value) {
                    return value.product == (0, $gzN0P.config).product;
                })) === null || _EntityService_activeEntities_find === void 0 ? void 0 : _EntityService_activeEntities_find.entity;
            },
            set: function set(entity) {
                EntityService.activeEntities.push({
                    product: (0, $gzN0P.config).product,
                    entity: entity
                });
            }
        },
        {
            key: "activeSite",
            get: function get() {
                var _EntityService_activeSites_find;
                this.initActives();
                return (_EntityService_activeSites_find = EntityService.activeSites.find(function(value) {
                    return value.product == (0, $gzN0P.config).product;
                })) === null || _EntityService_activeSites_find === void 0 ? void 0 : _EntityService_activeSites_find.site;
            },
            set: function set(entity) {
                EntityService.activeSites.push({
                    product: (0, $gzN0P.config).product,
                    site: entity
                });
            }
        },
        {
            key: "activeWebPushToken",
            get: function get() {
                return this._activeWebPushTokenValue;
            },
            set: function set(token) {
                this._activeWebPushTokenValue = token;
                (0, $yJnBa.SedestralStorage).setItem(this._activeWebPushToken, this._activeWebPushTokenValue);
            }
        },
        {
            key: "activeToken",
            get: function get() {
                return (0, $yJnBa.SedestralStorage).getItem("_activeToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment);
            },
            set: function set(token) {
                (0, $yJnBa.SedestralStorage).setItem("_activeToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment, token);
            }
        },
        {
            key: "clearActiveToken",
            value: function clearActiveToken() {
                (0, $yJnBa.SedestralStorage).removeItem("_activeToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment);
            }
        },
        {
            key: "saveActiveToken",
            get: function get() {
                return (0, $62tsD.SedestralMemory).getItem("_saveActiveToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment);
            },
            set: function set(token) {
                (0, $62tsD.SedestralMemory).setItem("_saveActiveToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment, token);
            }
        },
        {
            key: "clearSaveActiveToken",
            value: function clearSaveActiveToken() {
                (0, $62tsD.SedestralMemory).removeItem("_saveActiveToken" + (0, $gzN0P.config).product + (0, $gzN0P.config).environment);
            }
        },
        {
            key: "activeTokenCookie",
            get: function get() {
                this.initActives();
                return (0, $yJnBa.SedestralStorage).getCookie("_activeTokenCookie" + (0, $gzN0P.config).environment + (0, $gzN0P.config).product);
            },
            set: function set(token) {
                this.initActives();
                (0, $yJnBa.SedestralStorage).setCookie("_activeTokenCookie" + (0, $gzN0P.config).environment + (0, $gzN0P.config).product, token, "." + (0, $gzN0P.config).domainParent);
            }
        },
        {
            key: "clearTokenCookie",
            value: function clearTokenCookie() {
                (0, $yJnBa.SedestralStorage).deleteCookie("_activeTokenCookie" + (0, $gzN0P.config).environment + (0, $gzN0P.config).product);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.typingEvents = [];
            }
        },
        {
            key: "initActives",
            value: function initActives() {
                if (!EntityService.activeEntities) EntityService.activeEntities = [];
                if (!EntityService.activeSites) EntityService.activeSites = [];
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.initActives();
                (0, $8GOyH.Services).beforeInit(this);
                this._activeWebPushTokenValue = (0, $yJnBa.SedestralStorage).getItem(this._activeWebPushToken);
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ENTITY_UPDATE, function(data) {
                    var entity = data;
                    if ((0, $gFQjy.Models).isAccountModel(entity)) (0, $fIUGb.AccountService).store(entity);
                });
                //TODO remove typing only if typing is active
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ENTITY_TYPING, function(data) {
                    // console.log(data)
                    var entity = _this.store(data.entity, data.entityType);
                    data.files = (0, $38D2A.FileService).storeAll(data.files);
                    data.previews = (0, $3PS2c.PreviewService).storeAll(data.previews);
                    _this.typingEvents.forEach(function(value) {
                        return value(entity, data.content, data.files, data.previews);
                    });
                });
                if ((0, $gzN0P.config).product != (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).LIVECHAT)) window["EntityService"] = this;
            }
        },
        {
            key: "updateAvatar",
            value: /**
     * http
     */ function updateAvatar(accountId, files, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postFormData((0, $co7RM.ProductType).PANEL, "/account/avatar/update", {
                                        files: files,
                                        accountId: accountId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEntity",
            value: /**
     * get
     */ function getEntity(type, id) {
                if (type == (0, $igmb3.EntityType).ACCOUNT) return (0, $fIUGb.AccountService).accounts.filter(function(value) {
                    return value.id == id;
                })[0];
            }
        },
        {
            key: "getType",
            value: function getType(entity) {
                return (0, $gFQjy.Models).isContactModel(entity) ? (0, $igmb3.EntityType).CONTACT : (0, $igmb3.EntityType).ACCOUNT;
            }
        },
        {
            key: "typing",
            value: /**
     * websocket
     */ function typing(conversationId, _typing, content, files, previews) {
                (0, $3Qm5T.Network).emit((0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ENTITY_TYPING, {
                    conversationId: conversationId,
                    typing: _typing,
                    content: content,
                    filesIds: files ? files.map(function(value) {
                        return value.id;
                    }) : undefined,
                    previewsIds: previews ? previews.map(function(value) {
                        return value.id;
                    }) : undefined
                });
            }
        },
        {
            key: "headersToken",
            value: /**
     * headers
     */ function headersToken(headers) {
                var saveCookie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (headers !== undefined && headers[(0, $kk7Zr.NetworkHeaders).SESSION_HEADER] != undefined) {
                    EntityService.activeToken = headers[(0, $kk7Zr.NetworkHeaders).SESSION_HEADER];
                    if (saveCookie) EntityService.activeTokenCookie = headers[(0, $kk7Zr.NetworkHeaders).SESSION_HEADER];
                }
            }
        },
        {
            key: "virtualGenerate",
            value: /**
     * virtual
     */ function virtualGenerate(avatar) {
                return {
                    work: "",
                    avatar: avatar,
                    siteId: "virtualId",
                    name: "name",
                    id: "virtualId",
                    email: "email",
                    active: true,
                    avatarId: avatar.id,
                    twoFactor: false
                };
            }
        },
        {
            key: "onTyping",
            value: /**
     * events
     */ function onTyping(func, component) {
                var _this = this;
                this.typingEvents.push(func);
                component.onRemove(function() {
                    return _this.typingEvents.splice(_this.typingEvents.indexOf(func), 1);
                });
            }
        },
        {
            key: "storeContext",
            value: /**
     * store
     */ function storeContext(entity, site) {
                this.activeEntity = this.store(entity, entity.type);
                this.activeSite = (0, $1LZ0s.SiteService).store(site);
            }
        },
        {
            key: "storeAll",
            value: function storeAll(entities, type) {
                for(var key in entities)entities[key] = this.store(entities[key], type);
                return (0, $8GOyH.Services).storeAll(entities);
            }
        },
        {
            key: "store",
            value: function store(entity, type) {
                if (type == undefined) {
                    if ((0, $gFQjy.Models).isAccountModel(entity)) entity = (0, $fIUGb.AccountService).store(entity);
                } else if (type == (0, $igmb3.EntityType).ACCOUNT) // @ts-ignore
                entity = (0, $fIUGb.AccountService).store(entity);
                return entity;
            }
        }
    ]);
    return EntityService;
}();
$49565aada8ffadd8$export$714c657d7d597c58.typingEvents = [];
$49565aada8ffadd8$export$714c657d7d597c58.activeOfferProducts = {};
$49565aada8ffadd8$export$714c657d7d597c58.activeOfferIsFailureToPay = false;
$49565aada8ffadd8$export$714c657d7d597c58._activeWebPushToken = "_activeWebPushToken";

});
parcelRegister("hWZw8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d117928768e4b3cc$export$71511d61b312f219; });
function $d117928768e4b3cc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d117928768e4b3cc$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d117928768e4b3cc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d117928768e4b3cc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("eJDpD", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $aba3d7275d146aa5$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $aba3d7275d146aa5$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $7tffA = parcelRequire("7tffA");
var $aba3d7275d146aa5$var$extendStatics = function extendStatics1(d, b) {
    $aba3d7275d146aa5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $aba3d7275d146aa5$var$extendStatics(d, b);
};
function $aba3d7275d146aa5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $aba3d7275d146aa5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $aba3d7275d146aa5$export$18ce0697a983be9b = function __assign1() {
    $aba3d7275d146aa5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aba3d7275d146aa5$export$18ce0697a983be9b.apply(this, arguments);
};
function $aba3d7275d146aa5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $aba3d7275d146aa5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7tffA._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $aba3d7275d146aa5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $aba3d7275d146aa5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7tffA._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $aba3d7275d146aa5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $aba3d7275d146aa5$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7tffA._)(x)) === "symbol" ? x : "".concat(x);
}
function $aba3d7275d146aa5$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7tffA._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $aba3d7275d146aa5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7tffA._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $aba3d7275d146aa5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $aba3d7275d146aa5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $aba3d7275d146aa5$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $aba3d7275d146aa5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $aba3d7275d146aa5$export$45d3717a4c69092e(o, m, p);
}
function $aba3d7275d146aa5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $aba3d7275d146aa5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $aba3d7275d146aa5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($aba3d7275d146aa5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $aba3d7275d146aa5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $aba3d7275d146aa5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $aba3d7275d146aa5$export$10c90e4f7922046c(v) {
    return this instanceof $aba3d7275d146aa5$export$10c90e4f7922046c ? (this.v = v, this) : new $aba3d7275d146aa5$export$10c90e4f7922046c(v);
}
function $aba3d7275d146aa5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $aba3d7275d146aa5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $aba3d7275d146aa5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $aba3d7275d146aa5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $aba3d7275d146aa5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $aba3d7275d146aa5$export$19a8beecd37a4c45 === "function" ? $aba3d7275d146aa5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $aba3d7275d146aa5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $aba3d7275d146aa5$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $aba3d7275d146aa5$var$ownKeys = function ownKeys1(o) {
    $aba3d7275d146aa5$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $aba3d7275d146aa5$var$ownKeys(o);
};
function $aba3d7275d146aa5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $aba3d7275d146aa5$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $aba3d7275d146aa5$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $aba3d7275d146aa5$var$__setModuleDefault(result, mod);
    return result;
}
function $aba3d7275d146aa5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $aba3d7275d146aa5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $aba3d7275d146aa5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $aba3d7275d146aa5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $7tffA._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $aba3d7275d146aa5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $aba3d7275d146aa5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $aba3d7275d146aa5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $aba3d7275d146aa5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $aba3d7275d146aa5$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $aba3d7275d146aa5$export$2e2bcd8739ae039 = {
    __extends: $aba3d7275d146aa5$export$a8ba968b8961cb8a,
    __assign: $aba3d7275d146aa5$export$18ce0697a983be9b,
    __rest: $aba3d7275d146aa5$export$3c9a16f847548506,
    __decorate: $aba3d7275d146aa5$export$29e00dfd3077644b,
    __param: $aba3d7275d146aa5$export$d5ad3fd78186038f,
    __esDecorate: $aba3d7275d146aa5$export$3a84e1ae4e97e9b0,
    __runInitializers: $aba3d7275d146aa5$export$d831c04e792af3d,
    __propKey: $aba3d7275d146aa5$export$6a2a36740a146cb8,
    __setFunctionName: $aba3d7275d146aa5$export$d1a06452d3489bc7,
    __metadata: $aba3d7275d146aa5$export$f1db080c865becb9,
    __awaiter: $aba3d7275d146aa5$export$1050f835b63b671e,
    __generator: $aba3d7275d146aa5$export$67ebef60e6f28a6,
    __createBinding: $aba3d7275d146aa5$export$45d3717a4c69092e,
    __exportStar: $aba3d7275d146aa5$export$f33643c0debef087,
    __values: $aba3d7275d146aa5$export$19a8beecd37a4c45,
    __read: $aba3d7275d146aa5$export$8d051b38c9118094,
    __spread: $aba3d7275d146aa5$export$afc72e2116322959,
    __spreadArrays: $aba3d7275d146aa5$export$6388937ca91ccae8,
    __spreadArray: $aba3d7275d146aa5$export$1216008129fb82ed,
    __await: $aba3d7275d146aa5$export$10c90e4f7922046c,
    __asyncGenerator: $aba3d7275d146aa5$export$e427f37a30a4de9b,
    __asyncDelegator: $aba3d7275d146aa5$export$bbd80228419bb833,
    __asyncValues: $aba3d7275d146aa5$export$e3b29a3d6162315f,
    __makeTemplateObject: $aba3d7275d146aa5$export$4fb47efe1390b86f,
    __importStar: $aba3d7275d146aa5$export$c21735bcef00d192,
    __importDefault: $aba3d7275d146aa5$export$da59b14a69baef04,
    __classPrivateFieldGet: $aba3d7275d146aa5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $aba3d7275d146aa5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $aba3d7275d146aa5$export$81fdc39f203e4e04,
    __addDisposableResource: $aba3d7275d146aa5$export$88ac25d8e944e405,
    __disposeResources: $aba3d7275d146aa5$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $aba3d7275d146aa5$export$889dfb5d17574b0b
};

});

parcelRegister("3Qm5T", function(module, exports) {

$parcel$export(module.exports, "Network", function () { return $6a080dd3d1c2695a$export$95be4ae94445245a; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $cgG2i = parcelRequire("cgG2i");

var $hiGMu = parcelRequire("hiGMu");

var $eJDpD = parcelRequire("eJDpD");
parcelRequire("eQWdu");
var $8GLXl = parcelRequire("8GLXl");

var $gzN0P = parcelRequire("gzN0P");

var $lThic = parcelRequire("lThic");

var $5m1WU = parcelRequire("5m1WU");

var $kk7Zr = parcelRequire("kk7Zr");

var $dNI0C = parcelRequire("dNI0C");

var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");

var $wYO7b = parcelRequire("wYO7b");

var $9IvVr = parcelRequire("9IvVr");

var $yJnBa = parcelRequire("yJnBa");

var $dI4pn = parcelRequire("dI4pn");

var $aFPFV = parcelRequire("aFPFV");

var $12UO1 = parcelRequire("12UO1");

var $iRchI = parcelRequire("iRchI");

var $bXtBT = parcelRequire("bXtBT");

var $3sBK3 = parcelRequire("3sBK3");

var $5Co1u = parcelRequire("5Co1u");
var $6a080dd3d1c2695a$export$95be4ae94445245a = /*#__PURE__*/ function() {
    "use strict";
    function Network() {
        (0, $3CDbU._)(this, Network);
    }
    (0, $jyA4z._)(Network, null, [
        {
            key: "logged",
            get: /**
     * logged
     */ function get() {
                return this._logged;
            },
            set: function set(value) {
                this._logged = value;
                (0, $yJnBa.SedestralStorage).setItem("".concat(this.productName, "-online"), this._logged + "");
            }
        },
        {
            key: "init",
            value: /**
     * init
     */ function init(productName) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _config_httpCommunityUrl;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.productName = productName;
                        _this._logged = (0, $yJnBa.SedestralStorage).getItem("".concat(_this.productName, "-online")) == undefined ? false : (0, $yJnBa.SedestralStorage).getItem("".concat(_this.productName, "-online")) == "true";
                        _this.vendor = (0, $5Co1u.generateVendor)((0, $gzN0P.config).domain);
                        _this.tenor = (0, $8GLXl.default).create({
                            baseURL: (0, $gzN0P.config).tenorHost,
                            timeout: _this.timeoutTenor
                        });
                        _this.tenor.defaults.params = {
                            key: (0, $gzN0P.config).tenorKey
                        };
                        _this.httpResources = (0, $8GLXl.default).create({
                            baseURL: (0, $gzN0P.config).httpPanelUrl,
                            withCredentials: false,
                            timeout: _this.timeoutApi
                        });
                        _this.registerAxios((0, $co7RM.ProductType).PANEL, (0, $gzN0P.config).httpPanelUrl);
                        _this.registerAxios((0, $co7RM.ProductType).COMMUNITY, (_config_httpCommunityUrl = (0, $gzN0P.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $gzN0P.config).domain);
                        _this.registerSocket((0, $co7RM.ProductType).PANEL, (0, $gzN0P.config).websocketPanelUrl);
                        _this.registerSocket((0, $co7RM.ProductType).COMMUNITY, (0, $gzN0P.config).websocketCommunityUrl);
                        if ((0, $gzN0P.config).product != (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).LIVECHAT)) window["NetworkService"] = _this;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initErrors",
            value: function initErrors() {
                this.commonErrors = [
                    {
                        errorCode: (0, $dNI0C.ErrorCode).SITE_CHANNEL_NO_FOUND,
                        message: (0, $wYO7b.Resources).t("words.errorSITE_CHANNEL_NO_FOUND")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).NO_RECIPIENT,
                        message: (0, $wYO7b.Resources).t("words.errorNO_RECIPIENT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).NO_SITE_CHANEl,
                        message: (0, $wYO7b.Resources).t("words.errorNO_SITE_CHANNEL")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_TECHNICAL,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_TECHNICAL")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).CAPTCHA_INCORRECT,
                        message: (0, $wYO7b.Resources).t("words.errorCAPTCHA_INCORRECT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_CODE_INCORRECT,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_CODE_INCORRECT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_TRANSACTION_NO_FOUND,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_TRANSACTION_NO_FOUND")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_EXPIRE_CODE,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_EXPIRE_CODE")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_ATTEMPT,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_ATTEMPT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_BAND_WIDTH_LIMIT,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_BAND_WIDTH_LIMIT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_METHOD_UNAUTHORIZED,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_METHOD_UNAUTHORIZED")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TWO_FACTOR_CREATE_INVALID_CODE,
                        message: (0, $wYO7b.Resources).t("words.errorTWO_FACTOR_CREATE_INVALID_CODE")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).SITE_CHANNEL_PERMISSION,
                        message: (0, $wYO7b.Resources).t("words.errorSITE_CHANNEL_PERMISSION")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).PERMISSION,
                        message: (0, $wYO7b.Resources).t("words.errorPERMISSION")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).VERIFICATION,
                        message: (0, $wYO7b.Resources).t("words.errorVERIFICATION")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                        message: (0, $wYO7b.Resources).t("words.errorSIZE_MAX")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).NULLITY,
                        message: (0, $wYO7b.Resources).t("words.errorNULLITY")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).EXCEPTION,
                        message: (0, $wYO7b.Resources).t("words.errorEXCEPTION")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).CACHE,
                        message: (0, $wYO7b.Resources).t("words.errorCACHE")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).K8S_DOMAIN_ERROR,
                        message: (0, $wYO7b.Resources).t("words.errorK8S_DOMAIN_ERROR")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).DOMAIN_FORMAT,
                        message: (0, $wYO7b.Resources).t("words.errorDOMAIN_FORMAT"),
                        displayValue: true
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).DOMAIN_FULL,
                        message: (0, $wYO7b.Resources).t("words.errorDOMAIN_FULL")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).HOST_INCORRECT,
                        message: (0, $wYO7b.Resources).t("words.errorHOST_INCORRECT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).HOST_EXIST,
                        message: (0, $wYO7b.Resources).t("words.errorHOST_EXIST")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).NAME_EXIST,
                        message: (0, $wYO7b.Resources).t("words.errorNAME_EXIST")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).WINDOW_EXPIRED,
                        message: (0, $wYO7b.Resources).t("words.errorWINDOW_EXPIRED")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).EMAIL_ALIAS_EXIST,
                        message: (0, $wYO7b.Resources).t("words.errorEMAIL_ALIAS_EXIST")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).EMAIL_ALIAS,
                        message: (0, $wYO7b.Resources).t("words.errorEMAIL_ALIAS")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).EMAIL_EXIST,
                        message: (0, $wYO7b.Resources).t("words.errorEMAIL_EXIST")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).EMAIL_BLACKLIST,
                        message: (0, $wYO7b.Resources).t("words.errorEMAIL_BLACKLIST")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).MAIL_FORMAT,
                        message: (0, $wYO7b.Resources).t("words.errorMAIL_FORMAT"),
                        displayValue: true
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).PHONE_FORMAT,
                        message: (0, $wYO7b.Resources).t("words.errorPHONE_FORMAT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).MAIL_DOMAIN,
                        message: (0, $wYO7b.Resources).t("words.errorMAIL_DOMAIN")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).RECIPIENT_FULL,
                        message: (0, $wYO7b.Resources).t("words.errorRECIPIENT_FULL")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).IMAGE_FORMAT,
                        message: (0, $wYO7b.Resources).t("words.errorIMAGE_FORMAT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).NO_CONTACT,
                        message: (0, $wYO7b.Resources).t("words.errorNO_CONTACT")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TAX_COUNTRY,
                        message: (0, $wYO7b.Resources).t("words.postalCountryTaxCountry")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TAX_TYPE,
                        message: (0, $wYO7b.Resources).t("words.taxTypeNotAvailable")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TAX_VALUE_INVALID,
                        message: (0, $wYO7b.Resources).t("words.taxValueInvalid")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).LOCATION_INVALID,
                        message: (0, $wYO7b.Resources).t("words.locationInvalid")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TOKEN_INVALID,
                        message: (0, $wYO7b.Resources).t("words.tokenInvalidMessage")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).PAYMENT_PROVIDER_CREATE_SUBSCRIPTION,
                        message: (0, $wYO7b.Resources).t("words.paymentProviderCreateSubscriptionMessage")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).OFFER_QUOTE_EXISTS,
                        message: (0, $wYO7b.Resources).t("words.quoteExistsErrorMessage")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).CREATE_ARTICLE_IA_FORM_EMPTY,
                        message: (0, $wYO7b.Resources).t("words.errorcreateArticleFormEmpty")
                    },
                    {
                        errorCode: (0, $dNI0C.ErrorCode).TASK_IN_PROGRESS,
                        message: (0, $wYO7b.Resources).t("words.taskInProgress")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).UNAUTHORIZED,
                        message: (0, $wYO7b.Resources).t("words.errorUNAUTHORIZED")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                        message: (0, $wYO7b.Resources).t("words.errorNOT_FOUND")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).PRECONDITION_FAILED,
                        message: (0, $wYO7b.Resources).t("words.errorPRECONDITION_FAILED")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).BAD_GATEWAY,
                        message: (0, $wYO7b.Resources).t("words.errorSERVICE_UNAVAILABLE")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).SERVICE_UNAVAILABLE,
                        message: (0, $wYO7b.Resources).t("words.errorSERVICE_UNAVAILABLE")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).INTERNAL_SERVER_ERROR,
                        message: (0, $wYO7b.Resources).t("words.errorINTERNAL_SERVER_ERROR")
                    },
                    {
                        status: (0, $cKMRi.HttpStatus).TOO_MANY_REQUESTS,
                        message: (0, $wYO7b.Resources).t("words.errorTOO_MANY_REQUESTS")
                    }
                ];
            }
        },
        {
            key: "start",
            value: /**
     * starting
     */ function start(router) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (router != undefined) {
                                    _this.router = router;
                                    _this.router.onStarted = function() {
                                        return _this.startedFunctions.forEach(function(value) {
                                            return value();
                                        });
                                    };
                                }
                                return [
                                    4,
                                    _this.onToken()
                                ];
                            case 1:
                                if (!_state.sent()) return [
                                    3,
                                    4
                                ];
                                if (!Network.logged) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.startLogin()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this.executeNetworkLost();
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startLogin",
            value: function startLogin() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.onLogin()
                                ];
                            case 1:
                                if (!_state.sent()) {
                                    _this.executeNetworkLost();
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startWebSocket",
            value: function startWebSocket(type, onDisconnect) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _EntityService_activeSite, socket;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                socket = _this.getSocket(type);
                                socket.onDisconnect = function() {
                                    if (type == (0, $co7RM.ProductType).PANEL) _this.executeNetworkLost();
                                    if (onDisconnect) onDisconnect();
                                };
                                return [
                                    4,
                                    socket.start({
                                        siteId: (_EntityService_activeSite = (0, $lThic.EntityService).activeSite) === null || _EntityService_activeSite === void 0 ? void 0 : _EntityService_activeSite.id,
                                        entityType: (0, $lThic.EntityService).activeEntity.type,
                                        activeToken: (0, $lThic.EntityService).activeToken
                                    })
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    2,
                                    socket
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: /**
     * websocket
     */ function disconnect(type, logout) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.getSocket(type).disconnect(logout);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "emit",
            value: function emit(type, event, value) {
                Network.getSocket(type).emit(event, value);
            }
        },
        {
            key: "emitSync",
            value: function emitSync(type, event, value) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Network.getSocket(type).emitSync(event, value)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(type, event, func) {
                var _Network_getSocket;
                (_Network_getSocket = Network.getSocket(type)) === null || _Network_getSocket === void 0 ? void 0 : _Network_getSocket.on(event, func);
            }
        },
        {
            key: "join",
            value: function join(type, data, route) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Network.emitSync(type, route, data)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSocket",
            value: function getSocket(type) {
                var _this_sockets_find, _this_sockets_find1;
                if (type) return (_this_sockets_find = this.sockets.find(function(value) {
                    return value.type == type;
                })) === null || _this_sockets_find === void 0 ? void 0 : _this_sockets_find.socket;
                return (_this_sockets_find1 = this.sockets.find(function(value) {
                    return value.type == (0, $co7RM.ProductType).PANEL;
                })) === null || _this_sockets_find1 === void 0 ? void 0 : _this_sockets_find1.socket;
            }
        },
        {
            key: "removeSocket",
            value: function removeSocket(type) {
                var socket = this.sockets.find(function(value) {
                    return value.type == type;
                });
                if (socket) this.sockets.splice(this.sockets.indexOf(socket), 1);
            }
        },
        {
            key: "registerSocket",
            value: function registerSocket(type, host) {
                this.removeSocket(type);
                this.sockets.push({
                    type: type,
                    socket: new (0, $aFPFV.NetworkSocket)(host)
                });
            }
        },
        {
            key: "registerAxios",
            value: /**
     * axios
     */ function registerAxios(type, host) {
                var instance = this.axios.find(function(value) {
                    return value.type == type;
                });
                if (instance) this.axios.splice(this.axios.indexOf(instance), 1);
                var http = (0, $8GLXl.default).create({
                    baseURL: host,
                    withCredentials: false,
                    timeout: this.timeoutApi
                });
                http.interceptors.request.use(function(config) {
                    if ((0, $lThic.EntityService).activeToken) config.headers[(0, $kk7Zr.NetworkHeaders).SESSION_HEADER] = (0, $lThic.EntityService).activeToken;
                    if ((0, $lThic.EntityService).activeSite) config.headers[(0, $kk7Zr.NetworkHeaders).SITE_HEADER] = (0, $lThic.EntityService).activeSite.id;
                    return config;
                });
                this.axios.push({
                    type: type,
                    http: http
                });
            }
        },
        {
            key: "getAxios",
            value: function getAxios(type) {
                var _this_axios_find, _this_axios_find1;
                if (type) return (_this_axios_find = this.axios.find(function(value) {
                    return value.type == type;
                })) === null || _this_axios_find === void 0 ? void 0 : _this_axios_find.http;
                return (_this_axios_find1 = this.axios.find(function(value) {
                    return value.type == (0, $co7RM.ProductType).PANEL;
                })) === null || _this_axios_find1 === void 0 ? void 0 : _this_axios_find1.http;
            }
        },
        {
            key: "request",
            value: /**
     * http
     */ function request(type, _request, component, config) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var tokenSource;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        tokenSource = (0, $8GLXl.default).CancelToken.source();
                        if (config === null || config === void 0 ? void 0 : config.cancelableCallback) config.cancelableCallback(tokenSource);
                        if (component && component.onRemove) component.onRemove(function() {
                            tokenSource.cancel();
                        });
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(function(resolve) {
                                var axiosRequest = _request(tokenSource.token);
                                axiosRequest.then(function(response) {
                                    var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router, _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                                    resolve(response);
                                    if ((_Network_router = Network.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router["static"]) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.onSuccess) (_Network_router1 = Network.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1["static"]) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.onSuccess(response);
                                    if (response && response.headers) _this.requestAlert(response.headers);
                                })["catch"](function(response) {
                                    //Si pas de réponse, on en simule une
                                    if (!response.response && (response === null || response === void 0 ? void 0 : response.code) !== "ERR_CANCELED") response = {
                                        response: {
                                            status: (0, $cKMRi.HttpStatus).SERVICE_UNAVAILABLE,
                                            data: ''
                                        }
                                    };
                                    if (response.response && response.response.data && (response.response.data.status || response.response.data.errorCode) && response.response.status) {
                                        var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router;
                                        _this.requestTwoFactor(component, (0, $hiGMu._)((0, $cgG2i._)({}, response), {
                                            productType: type
                                        }));
                                        _this.requestError(component, response.response.data);
                                        if (response.response.status !== (0, $cKMRi.HttpStatus).LOCKED) (_Network_router = Network.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router["static"]) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.clear();
                                    } else {
                                        var _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                                        if (response.response && response.response.status != (0, $cKMRi.HttpStatus).OK) _this.requestError(component, {
                                            status: response.response.status
                                        });
                                        (_Network_router1 = Network.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1["static"]) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.clear();
                                    }
                                    resolve(response.response);
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "requestAlert",
            value: function requestAlert(headers) {
                return (0, $hWZw8._)(function() {
                    var alertCode;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        alertCode = headers[(0, $kk7Zr.NetworkHeaders).ALERT_HEADER];
                        if (alertCode) Network.router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.alert." + alertCode), undefined, 8000, "success");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "requestError",
            value: function requestError(component, data) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _SedestralDebugger_rum, resultCheckError, _SedestralDebugger_rum1, message;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!data) return [
                                    3,
                                    5
                                ];
                                if (!(data.status == (0, $cKMRi.HttpStatus).PAYMENT_REQUIRED)) return [
                                    3,
                                    1
                                ];
                                _this.onPaymentRequired(data.currentQuantity, data.limitQuantity, data.solutionType, data.productType);
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                if (!(data.errorCode != (0, $dNI0C.ErrorCode)[(0, $dNI0C.ErrorCode).TWO_FACTOR_REQUIRED])) return [
                                    3,
                                    5
                                ];
                                if (!(data.errorCode == (0, $dNI0C.ErrorCode)[(0, $dNI0C.ErrorCode).SURFACE_CONTROL])) return [
                                    3,
                                    2
                                ];
                                if (data.subErrors) data.subErrors.forEach(function(subError) {
                                    _this.onError((0, $wYO7b.Resources).r("words.errorFieldErrorMessage", {
                                        field: subError.field,
                                        message: subError.message
                                    }));
                                });
                                else if (data.message && data.message.includes("parameter is missing")) _this.onError((0, $wYO7b.Resources).t("words.errorfillEmptyFieldsError"));
                                else {
                                    ;
                                    _this.onError((0, $wYO7b.Resources).t("words.errorgenericErrorMessage"));
                                    (_SedestralDebugger_rum = (0, $12UO1.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.unHandledError(data.errorCode);
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(data.status === (0, $cKMRi.HttpStatus).NETWORK_AUTHENTICATION_REQUIRED)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.createLogout()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                resultCheckError = Network.checkError(component === null || component === void 0 ? void 0 : component.networkErrorsHandler, data) || Network.checkError(_this.commonErrors, data);
                                if (!resultCheckError) {
                                    ;
                                    message = data.error + ": " + data.message + " | code: " + data.errorCode + " | type: " + data.errorType + " | status: " + data.status;
                                    (_SedestralDebugger_rum1 = (0, $12UO1.SedestralDebugger).rum) === null || _SedestralDebugger_rum1 === void 0 ? void 0 : _SedestralDebugger_rum1.unHandledError(data.errorCode);
                                    _this.onError(message);
                                }
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestTwoFactor",
            value: function requestTwoFactor(component, response) {
                if (response.response.data.errorCode == (0, $dNI0C.ErrorCode)[(0, $dNI0C.ErrorCode).TWO_FACTOR_REQUIRED]) {
                    if (Network.router["static"].components.twoFactor.onSuccess) try {
                        var data = response.response.headers[(0, $kk7Zr.NetworkHeaders).TF_TRANSACTION_DATA_HEADER];
                        var method = +parseInt(response.response.headers[(0, $kk7Zr.NetworkHeaders).TF_TRANSACTION_METHOD_HEADER]);
                        if (method !== undefined && (method == (0, $dI4pn.IAccountTwoFactorMethod).TOTP || method == (0, $dI4pn.IAccountTwoFactorMethod).EMAIL && data != undefined)) Network.router["static"].components.twoFactor.create(data, response);
                        else this.onError("TWO_FACTOR_REQUIRED not data.");
                    } catch (e) {
                        this.onError("TWO_FACTOR_REQUIRED not data.");
                    }
                    else this.onError("TWO_FACTOR_REQUIRED not active.");
                }
            }
        },
        {
            key: "postJson",
            value: function postJson(type, url, data, component, config) {
                return (0, $hWZw8._)(function() {
                    var jsonHeaders;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jsonHeaders = {
                                    'Content-Type': 'application/json'
                                };
                                if (!config) config = {};
                                config.headers = (0, $iRchI.jsonConcat)(jsonHeaders, config.headers);
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).post(url, JSON.stringify(data), (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postFormData",
            value: function postFormData(type, url, data, component, config) {
                return (0, $hWZw8._)(function() {
                    var jsonHeaders, formData;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jsonHeaders = {
                                    'Content-Type': 'multipart/form-data'
                                };
                                if (!config) config = {};
                                config.headers = (0, $iRchI.jsonConcat)(jsonHeaders, config.headers);
                                formData = new FormData();
                                Object.keys(data).forEach(function(key) {
                                    if (key != "files") formData.append(key, data[key]);
                                });
                                if (data.files) data.files.forEach(function(file) {
                                    return formData.append('files', file);
                                });
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).post(url, formData, (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(type, url, data, component, config) {
                var parseQuery = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).post(url, data ? parseQuery ? (0, $3sBK3.queryString)(data) : data : undefined, (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "put",
            value: function put(type, url, data, component, config) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).put(url, data ? (0, $3sBK3.queryString)(data) : undefined, (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "putJson",
            value: function putJson(type, url, data, component, config) {
                return (0, $hWZw8._)(function() {
                    var jsonHeaders;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jsonHeaders = {
                                    'Content-Type': 'application/json'
                                };
                                if (!config) config = {};
                                config.headers = (0, $iRchI.jsonConcat)(jsonHeaders, config.headers);
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).put(url, JSON.stringify(data), (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(type, url, component, config) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type).get(url, (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(type, url, component, config) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Network.request(type, function(token) {
                                        return Network.getAxios(type)["delete"](url, (0, $iRchI.jsonConcat)({
                                            cancelToken: token
                                        }, config));
                                    }, component, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "retry",
            value: function retry(response, component, config) {
                return (0, $hWZw8._)(function() {
                    var _response_productType, type, _, jsonData, e, jsonData1, e1;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                type = (_response_productType = response.productType) !== null && _response_productType !== void 0 ? _response_productType : (0, $co7RM.ProductType).PANEL;
                                _ = response.config.method;
                                switch(_){
                                    case "post":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "put":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "get":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "delete":
                                        return [
                                            3,
                                            11
                                        ];
                                }
                                return [
                                    3,
                                    13
                                ];
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                jsonData = JSON.parse(response.config.data);
                                return [
                                    4,
                                    Network.postJson(type, response.config.url, jsonData, component, config)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    4,
                                    Network.post(type, response.config.url, response.config.data, component, config, false)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    9
                                ]);
                                jsonData1 = JSON.parse(response.config.data);
                                return [
                                    4,
                                    Network.putJson(type, response.config.url, jsonData1, component, config)
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 7:
                                e1 = _state.sent();
                                return [
                                    4,
                                    Network.put(type, response.config.url, response.config.data, component, config)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                return [
                                    4,
                                    Network.get(type, response.config.url, component, config)
                                ];
                            case 10:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 11:
                                return [
                                    4,
                                    Network["delete"](type, response.config.url, component, config)
                                ];
                            case 12:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createLogout",
            value: function createLogout() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                Network.router.onLogout();
                                return [
                                    4,
                                    Network.onLogout()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onToken",
            value: /**
     * to override
     */ function onToken() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "onLogin",
            value: function onLogin() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "onLogout",
            value: function onLogout() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "onError",
            value: function onError(message) {}
        },
        {
            key: "onPaymentRequired",
            value: function onPaymentRequired(currentQuantity, limitQuantity, solutionType, productType) {}
        },
        {
            key: "onNetworkLost",
            value: /**
     * network error
     */ function onNetworkLost(func) {
                this.lostFunctions.push(func);
            }
        },
        {
            key: "onNetworkLostSolved",
            value: function onNetworkLostSolved(func) {
                this.lostSolvedFunctions.push(func);
            }
        },
        {
            key: "executeNetworkLost",
            value: function executeNetworkLost() {
                if (!this.lostConnection) {
                    this.lostConnection = true;
                    this.lostFunctions.forEach(function(value) {
                        return value();
                    });
                    var _this = this;
                    this.lostConnectionInterval = setInterval(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this.start()
                                    ];
                                case 1:
                                    if (_state.sent()) {
                                        _this.lostConnection = false;
                                        clearInterval(_this.lostConnectionInterval);
                                        _this.lostSolvedFunctions.forEach(function(value) {
                                            return value();
                                        });
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), this.getSecondsRetry());
                }
            }
        },
        {
            key: "getSecondsRetry",
            value: function getSecondsRetry() {
                return (0, $bXtBT.randomInteger)(3000, 6000);
            }
        },
        {
            key: "onStarted",
            value: /**
     * initialized
     */ function onStarted(func) {
                this.startedFunctions.push(func);
            }
        },
        {
            key: "ssrRegisterDomain",
            value: /**
     * SSR
     */ function ssrRegisterDomain(context) {
                (0, $gzN0P.config).domain = context;
                this.vendor = (0, $5Co1u.generateVendor)((0, $gzN0P.config).domain);
                return context;
            }
        },
        {
            key: "checkError",
            value: function checkError(errors, data) {
                var error = undefined;
                if (errors !== undefined) {
                    if (data.errorCode != undefined) error = errors.find(function(value) {
                        return (0, $dNI0C.ErrorCode)[value.errorCode] === data.errorCode;
                    });
                    if (data.status != undefined && error === undefined) error = errors.find(function(value) {
                        return value.status === data.status;
                    });
                    if (error === undefined) error = errors.find(function(value) {
                        return (value === null || value === void 0 ? void 0 : value.defaultError) === true;
                    });
                    if (error !== undefined) {
                        if (error.message && error.message !== "none") this.onError(error.message + (error.displayValue ? " (" + data.message + ")" : ""));
                        else if (error.handle) error.handle();
                    }
                }
                return error !== undefined;
            }
        }
    ]);
    return Network;
}();
$6a080dd3d1c2695a$export$95be4ae94445245a.sockets = [];
$6a080dd3d1c2695a$export$95be4ae94445245a.axios = [];
$6a080dd3d1c2695a$export$95be4ae94445245a.timeoutApi = 60000;
$6a080dd3d1c2695a$export$95be4ae94445245a.timeoutTenor = 10000;
$6a080dd3d1c2695a$export$95be4ae94445245a.lostConnectionInterval = 0;
$6a080dd3d1c2695a$export$95be4ae94445245a.lostConnection = false;
$6a080dd3d1c2695a$export$95be4ae94445245a.lostFunctions = [];
$6a080dd3d1c2695a$export$95be4ae94445245a.lostSolvedFunctions = [];
$6a080dd3d1c2695a$export$95be4ae94445245a.startedFunctions = [];

});
parcelRegister("cgG2i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ee7962380855015$export$71511d61b312f219; });

var $fEm89 = parcelRequire("fEm89");
function $8ee7962380855015$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fEm89._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("fEm89", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b64bc214abd818c1$export$71511d61b312f219; });
function $b64bc214abd818c1$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hiGMu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c9854d8d7f706dad$export$71511d61b312f219; });
function $c9854d8d7f706dad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c9854d8d7f706dad$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $c9854d8d7f706dad$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("eQWdu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8GLXl")).default; });

var $8GLXl = parcelRequire("8GLXl");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $ad031498d2e1470f$export$1c00760e9e5a4e95 = (0, $8GLXl.default).Axios, $ad031498d2e1470f$export$c1fbed17c2f6a328 = (0, $8GLXl.default).AxiosError, $ad031498d2e1470f$export$1ab0c6b20d94fa14 = (0, $8GLXl.default).CanceledError, $ad031498d2e1470f$export$3b22524397b493c6 = (0, $8GLXl.default).isCancel, $ad031498d2e1470f$export$fd08e3cb425f0d61 = (0, $8GLXl.default).CancelToken, $ad031498d2e1470f$export$a4ad2735b021c132 = (0, $8GLXl.default).VERSION, $ad031498d2e1470f$export$84bf76cd7afc7469 = (0, $8GLXl.default).all, $ad031498d2e1470f$export$848c9b7ead0df967 = (0, $8GLXl.default).Cancel, $ad031498d2e1470f$export$fbafdbe06a5b5a9a = (0, $8GLXl.default).isAxiosError, $ad031498d2e1470f$export$3ae0fd4797ed47c8 = (0, $8GLXl.default).spread, $ad031498d2e1470f$export$10ae0d317ea97f8b = (0, $8GLXl.default).toFormData, $ad031498d2e1470f$export$4e7d6ff0f3e6520 = (0, $8GLXl.default).AxiosHeaders, $ad031498d2e1470f$export$a972f69c851492b3 = (0, $8GLXl.default).HttpStatusCode, $ad031498d2e1470f$export$86d7c59254d6a2c9 = (0, $8GLXl.default).formToJSON, $ad031498d2e1470f$export$17ddc20a97d669e2 = (0, $8GLXl.default).getAdapter, $ad031498d2e1470f$export$7ec1ebcfa9d8bd6a = (0, $8GLXl.default).mergeConfig;

});
parcelRegister("8GLXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $653772144e42f97b$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $LnsnW = parcelRequire("LnsnW");

var $fbcjs = parcelRequire("fbcjs");

var $4SkkI = parcelRequire("4SkkI");

var $4y0cc = parcelRequire("4y0cc");

var $8WNNn = parcelRequire("8WNNn");

var $k68rj = parcelRequire("k68rj");

var $9oh0A = parcelRequire("9oh0A");

var $02xxh = parcelRequire("02xxh");

var $1JhGV = parcelRequire("1JhGV");

var $1q8ze = parcelRequire("1q8ze");

var $7Xdj3 = parcelRequire("7Xdj3");

var $c9DQf = parcelRequire("c9DQf");

var $fj26T = parcelRequire("fj26T");

var $irFHt = parcelRequire("irFHt");

var $h9vBo = parcelRequire("h9vBo");

var $2wp1Y = parcelRequire("2wp1Y");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $653772144e42f97b$var$createInstance(defaultConfig) {
    var context = new (0, $fbcjs.default)(defaultConfig);
    var instance = (0, $LnsnW.default)((0, $fbcjs.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8Iuhi.default).extend(instance, (0, $fbcjs.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8Iuhi.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $653772144e42f97b$var$createInstance((0, $4SkkI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $653772144e42f97b$var$axios = $653772144e42f97b$var$createInstance((0, $4y0cc.default));
// Expose Axios class to allow class inheritance
$653772144e42f97b$var$axios.Axios = (0, $fbcjs.default);
// Expose Cancel & CancelToken
$653772144e42f97b$var$axios.CanceledError = (0, $k68rj.default);
$653772144e42f97b$var$axios.CancelToken = (0, $9oh0A.default);
$653772144e42f97b$var$axios.isCancel = (0, $02xxh.default);
$653772144e42f97b$var$axios.VERSION = (0, $1JhGV.VERSION);
$653772144e42f97b$var$axios.toFormData = (0, $1q8ze.default);
// Expose AxiosError class
$653772144e42f97b$var$axios.AxiosError = (0, $7Xdj3.default);
// alias for CanceledError for backward compatibility
$653772144e42f97b$var$axios.Cancel = $653772144e42f97b$var$axios.CanceledError;
// Expose all/spread
$653772144e42f97b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$653772144e42f97b$var$axios.spread = (0, $c9DQf.default);
// Expose isAxiosError
$653772144e42f97b$var$axios.isAxiosError = (0, $fj26T.default);
// Expose mergeConfig
$653772144e42f97b$var$axios.mergeConfig = (0, $4SkkI.default);
$653772144e42f97b$var$axios.AxiosHeaders = (0, $irFHt.default);
$653772144e42f97b$var$axios.formToJSON = function(thing) {
    return (0, $8WNNn.default)((0, $8Iuhi.default).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$653772144e42f97b$var$axios.getAdapter = (0, $h9vBo.default).getAdapter;
$653772144e42f97b$var$axios.HttpStatusCode = (0, $2wp1Y.default);
$653772144e42f97b$var$axios["default"] = $653772144e42f97b$var$axios;
var // this module should only have a default export
$653772144e42f97b$export$2e2bcd8739ae039 = $653772144e42f97b$var$axios;

});
parcelRegister("8Iuhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6589eb5d4a359efe$export$2e2bcd8739ae039; });

var $bN2zx = parcelRequire("bN2zx");

var $7tffA = parcelRequire("7tffA");

var $LnsnW = parcelRequire("LnsnW");

var $cDSXo = parcelRequire("cDSXo");
'use strict';
// utils is a library of generic helper functions non-specific to axios
var $6589eb5d4a359efe$var$toString = Object.prototype.toString;
var $6589eb5d4a359efe$var$getPrototypeOf = Object.getPrototypeOf;
var $6589eb5d4a359efe$var$kindOf = function(cache) {
    return function(thing) {
        var str = $6589eb5d4a359efe$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $6589eb5d4a359efe$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $6589eb5d4a359efe$var$kindOf(thing) === type;
    };
};
var $6589eb5d4a359efe$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $7tffA._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $6589eb5d4a359efe$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $6589eb5d4a359efe$var$isUndefined = $6589eb5d4a359efe$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $6589eb5d4a359efe$var$isBuffer(val) {
    return val !== null && !$6589eb5d4a359efe$var$isUndefined(val) && val.constructor !== null && !$6589eb5d4a359efe$var$isUndefined(val.constructor) && $6589eb5d4a359efe$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $6589eb5d4a359efe$var$isArrayBuffer = $6589eb5d4a359efe$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $6589eb5d4a359efe$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $6589eb5d4a359efe$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $6589eb5d4a359efe$var$isString = $6589eb5d4a359efe$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $6589eb5d4a359efe$var$isFunction = $6589eb5d4a359efe$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $6589eb5d4a359efe$var$isNumber = $6589eb5d4a359efe$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $6589eb5d4a359efe$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $7tffA._)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $6589eb5d4a359efe$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $6589eb5d4a359efe$var$isPlainObject = function(val) {
    if ($6589eb5d4a359efe$var$kindOf(val) !== 'object') return false;
    var prototype = $6589eb5d4a359efe$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $6589eb5d4a359efe$var$isDate = $6589eb5d4a359efe$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $6589eb5d4a359efe$var$isFile = $6589eb5d4a359efe$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $6589eb5d4a359efe$var$isBlob = $6589eb5d4a359efe$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $6589eb5d4a359efe$var$isFileList = $6589eb5d4a359efe$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $6589eb5d4a359efe$var$isStream = function(val) {
    return $6589eb5d4a359efe$var$isObject(val) && $6589eb5d4a359efe$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $6589eb5d4a359efe$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $6589eb5d4a359efe$var$isFunction(thing.append) && ((kind = $6589eb5d4a359efe$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $6589eb5d4a359efe$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $6589eb5d4a359efe$var$isURLSearchParams = $6589eb5d4a359efe$var$kindOfTest('URLSearchParams');
var $6589eb5d4a359efe$var$_map = (0, $bN2zx._)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($6589eb5d4a359efe$var$kindOfTest), 4), $6589eb5d4a359efe$var$isReadableStream = $6589eb5d4a359efe$var$_map[0], $6589eb5d4a359efe$var$isRequest = $6589eb5d4a359efe$var$_map[1], $6589eb5d4a359efe$var$isResponse = $6589eb5d4a359efe$var$_map[2], $6589eb5d4a359efe$var$isHeaders = $6589eb5d4a359efe$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $6589eb5d4a359efe$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $6589eb5d4a359efe$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $7tffA._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($6589eb5d4a359efe$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $6589eb5d4a359efe$var$findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $6589eb5d4a359efe$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $6589eb5d4a359efe$var$isContextDefined = function(context) {
    return !$6589eb5d4a359efe$var$isUndefined(context) && context !== $6589eb5d4a359efe$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $6589eb5d4a359efe$var$merge() {
    var caseless = ($6589eb5d4a359efe$var$isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $6589eb5d4a359efe$var$findKey(result, key) || key;
        if ($6589eb5d4a359efe$var$isPlainObject(result[targetKey]) && $6589eb5d4a359efe$var$isPlainObject(val)) result[targetKey] = $6589eb5d4a359efe$var$merge(result[targetKey], val);
        else if ($6589eb5d4a359efe$var$isPlainObject(val)) result[targetKey] = $6589eb5d4a359efe$var$merge({}, val);
        else if ($6589eb5d4a359efe$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $6589eb5d4a359efe$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $6589eb5d4a359efe$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $6589eb5d4a359efe$var$forEach(b, function(val, key) {
        if (thisArg && $6589eb5d4a359efe$var$isFunction(val)) a[key] = (0, $LnsnW.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $6589eb5d4a359efe$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $6589eb5d4a359efe$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $6589eb5d4a359efe$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $6589eb5d4a359efe$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $6589eb5d4a359efe$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $6589eb5d4a359efe$var$toArray = function(thing) {
    if (!thing) return null;
    if ($6589eb5d4a359efe$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$6589eb5d4a359efe$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $6589eb5d4a359efe$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $6589eb5d4a359efe$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $6589eb5d4a359efe$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $6589eb5d4a359efe$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $6589eb5d4a359efe$var$isHTMLForm = $6589eb5d4a359efe$var$kindOfTest('HTMLFormElement');
var $6589eb5d4a359efe$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $6589eb5d4a359efe$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $6589eb5d4a359efe$var$isRegExp = $6589eb5d4a359efe$var$kindOfTest('RegExp');
var $6589eb5d4a359efe$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $6589eb5d4a359efe$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $6589eb5d4a359efe$var$freezeMethods = function(obj) {
    $6589eb5d4a359efe$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($6589eb5d4a359efe$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$6589eb5d4a359efe$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
var $6589eb5d4a359efe$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $6589eb5d4a359efe$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $6589eb5d4a359efe$var$noop = function() {};
var $6589eb5d4a359efe$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $6589eb5d4a359efe$var$isSpecCompliantForm(thing) {
    return !!(thing && $6589eb5d4a359efe$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
var $6589eb5d4a359efe$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($6589eb5d4a359efe$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                var target = $6589eb5d4a359efe$var$isArray(source) ? [] : {};
                $6589eb5d4a359efe$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$6589eb5d4a359efe$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $6589eb5d4a359efe$var$isAsyncFn = $6589eb5d4a359efe$var$kindOfTest('AsyncFunction');
var $6589eb5d4a359efe$var$isThenable = function(thing) {
    return thing && ($6589eb5d4a359efe$var$isObject(thing) || $6589eb5d4a359efe$var$isFunction(thing)) && $6589eb5d4a359efe$var$isFunction(thing.then) && $6589eb5d4a359efe$var$isFunction(thing["catch"]);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $6589eb5d4a359efe$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $6589eb5d4a359efe$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $6589eb5d4a359efe$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $6589eb5d4a359efe$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $6589eb5d4a359efe$var$isFunction($6589eb5d4a359efe$var$_global.postMessage));
var $6589eb5d4a359efe$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($6589eb5d4a359efe$var$_global) : typeof $cDSXo !== 'undefined' && $cDSXo.nextTick || $6589eb5d4a359efe$var$_setImmediate;
var // *********************
$6589eb5d4a359efe$export$2e2bcd8739ae039 = {
    isArray: $6589eb5d4a359efe$var$isArray,
    isArrayBuffer: $6589eb5d4a359efe$var$isArrayBuffer,
    isBuffer: $6589eb5d4a359efe$var$isBuffer,
    isFormData: $6589eb5d4a359efe$var$isFormData,
    isArrayBufferView: $6589eb5d4a359efe$var$isArrayBufferView,
    isString: $6589eb5d4a359efe$var$isString,
    isNumber: $6589eb5d4a359efe$var$isNumber,
    isBoolean: $6589eb5d4a359efe$var$isBoolean,
    isObject: $6589eb5d4a359efe$var$isObject,
    isPlainObject: $6589eb5d4a359efe$var$isPlainObject,
    isReadableStream: $6589eb5d4a359efe$var$isReadableStream,
    isRequest: $6589eb5d4a359efe$var$isRequest,
    isResponse: $6589eb5d4a359efe$var$isResponse,
    isHeaders: $6589eb5d4a359efe$var$isHeaders,
    isUndefined: $6589eb5d4a359efe$var$isUndefined,
    isDate: $6589eb5d4a359efe$var$isDate,
    isFile: $6589eb5d4a359efe$var$isFile,
    isBlob: $6589eb5d4a359efe$var$isBlob,
    isRegExp: $6589eb5d4a359efe$var$isRegExp,
    isFunction: $6589eb5d4a359efe$var$isFunction,
    isStream: $6589eb5d4a359efe$var$isStream,
    isURLSearchParams: $6589eb5d4a359efe$var$isURLSearchParams,
    isTypedArray: $6589eb5d4a359efe$var$isTypedArray,
    isFileList: $6589eb5d4a359efe$var$isFileList,
    forEach: $6589eb5d4a359efe$var$forEach,
    merge: $6589eb5d4a359efe$var$merge,
    extend: $6589eb5d4a359efe$var$extend,
    trim: $6589eb5d4a359efe$var$trim,
    stripBOM: $6589eb5d4a359efe$var$stripBOM,
    inherits: $6589eb5d4a359efe$var$inherits,
    toFlatObject: $6589eb5d4a359efe$var$toFlatObject,
    kindOf: $6589eb5d4a359efe$var$kindOf,
    kindOfTest: $6589eb5d4a359efe$var$kindOfTest,
    endsWith: $6589eb5d4a359efe$var$endsWith,
    toArray: $6589eb5d4a359efe$var$toArray,
    forEachEntry: $6589eb5d4a359efe$var$forEachEntry,
    matchAll: $6589eb5d4a359efe$var$matchAll,
    isHTMLForm: $6589eb5d4a359efe$var$isHTMLForm,
    hasOwnProperty: $6589eb5d4a359efe$var$hasOwnProperty,
    hasOwnProp: $6589eb5d4a359efe$var$hasOwnProperty,
    reduceDescriptors: $6589eb5d4a359efe$var$reduceDescriptors,
    freezeMethods: $6589eb5d4a359efe$var$freezeMethods,
    toObjectSet: $6589eb5d4a359efe$var$toObjectSet,
    toCamelCase: $6589eb5d4a359efe$var$toCamelCase,
    noop: $6589eb5d4a359efe$var$noop,
    toFiniteNumber: $6589eb5d4a359efe$var$toFiniteNumber,
    findKey: $6589eb5d4a359efe$var$findKey,
    global: $6589eb5d4a359efe$var$_global,
    isContextDefined: $6589eb5d4a359efe$var$isContextDefined,
    isSpecCompliantForm: $6589eb5d4a359efe$var$isSpecCompliantForm,
    toJSONObject: $6589eb5d4a359efe$var$toJSONObject,
    isAsyncFn: $6589eb5d4a359efe$var$isAsyncFn,
    isThenable: $6589eb5d4a359efe$var$isThenable,
    setImmediate: $6589eb5d4a359efe$var$_setImmediate,
    asap: $6589eb5d4a359efe$var$asap
};

});
parcelRegister("bN2zx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8956441dfd47dc32$export$71511d61b312f219; });

var $7cZ6u = parcelRequire("7cZ6u");

var $fuxru = parcelRequire("fuxru");

var $adZsl = parcelRequire("adZsl");

var $cCTAr = parcelRequire("cCTAr");
function $8956441dfd47dc32$export$71511d61b312f219(arr, i) {
    return (0, $7cZ6u._)(arr) || (0, $fuxru._)(arr, i) || (0, $cCTAr._)(arr, i) || (0, $adZsl._)();
}

});
parcelRegister("7cZ6u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53f90d4ec7d08424$export$71511d61b312f219; });
function $53f90d4ec7d08424$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fuxru", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b47399513892024c$export$71511d61b312f219; });
function $b47399513892024c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("adZsl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $771aca3541324fe1$export$71511d61b312f219; });
function $771aca3541324fe1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("cCTAr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $931426fe80ebced0$export$71511d61b312f219; });

var $5YQhh = parcelRequire("5YQhh");
function $931426fe80ebced0$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5YQhh._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5YQhh._)(o, minLen);
}

});
parcelRegister("5YQhh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45ab1b98caf5bb55$export$71511d61b312f219; });
function $45ab1b98caf5bb55$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("LnsnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08e695f01cdd3bd0$export$2e2bcd8739ae039; });
'use strict';
function $08e695f01cdd3bd0$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("cDSXo", function(module, exports) {
// shim for using process in browser
var $9343c1d844fe8fe0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $9343c1d844fe8fe0$var$cachedSetTimeout;
var $9343c1d844fe8fe0$var$cachedClearTimeout;
function $9343c1d844fe8fe0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $9343c1d844fe8fe0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $9343c1d844fe8fe0$var$cachedSetTimeout = setTimeout;
        else $9343c1d844fe8fe0$var$cachedSetTimeout = $9343c1d844fe8fe0$var$defaultSetTimout;
    } catch (e) {
        $9343c1d844fe8fe0$var$cachedSetTimeout = $9343c1d844fe8fe0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $9343c1d844fe8fe0$var$cachedClearTimeout = clearTimeout;
        else $9343c1d844fe8fe0$var$cachedClearTimeout = $9343c1d844fe8fe0$var$defaultClearTimeout;
    } catch (e) {
        $9343c1d844fe8fe0$var$cachedClearTimeout = $9343c1d844fe8fe0$var$defaultClearTimeout;
    }
})();
function $9343c1d844fe8fe0$var$runTimeout(fun) {
    if ($9343c1d844fe8fe0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($9343c1d844fe8fe0$var$cachedSetTimeout === $9343c1d844fe8fe0$var$defaultSetTimout || !$9343c1d844fe8fe0$var$cachedSetTimeout) && setTimeout) {
        $9343c1d844fe8fe0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9343c1d844fe8fe0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $9343c1d844fe8fe0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $9343c1d844fe8fe0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $9343c1d844fe8fe0$var$runClearTimeout(marker) {
    if ($9343c1d844fe8fe0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($9343c1d844fe8fe0$var$cachedClearTimeout === $9343c1d844fe8fe0$var$defaultClearTimeout || !$9343c1d844fe8fe0$var$cachedClearTimeout) && clearTimeout) {
        $9343c1d844fe8fe0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9343c1d844fe8fe0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $9343c1d844fe8fe0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $9343c1d844fe8fe0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $9343c1d844fe8fe0$var$queue = [];
var $9343c1d844fe8fe0$var$draining = false;
var $9343c1d844fe8fe0$var$currentQueue;
var $9343c1d844fe8fe0$var$queueIndex = -1;
function $9343c1d844fe8fe0$var$cleanUpNextTick() {
    if (!$9343c1d844fe8fe0$var$draining || !$9343c1d844fe8fe0$var$currentQueue) return;
    $9343c1d844fe8fe0$var$draining = false;
    if ($9343c1d844fe8fe0$var$currentQueue.length) $9343c1d844fe8fe0$var$queue = $9343c1d844fe8fe0$var$currentQueue.concat($9343c1d844fe8fe0$var$queue);
    else $9343c1d844fe8fe0$var$queueIndex = -1;
    if ($9343c1d844fe8fe0$var$queue.length) $9343c1d844fe8fe0$var$drainQueue();
}
function $9343c1d844fe8fe0$var$drainQueue() {
    if ($9343c1d844fe8fe0$var$draining) return;
    var timeout = $9343c1d844fe8fe0$var$runTimeout($9343c1d844fe8fe0$var$cleanUpNextTick);
    $9343c1d844fe8fe0$var$draining = true;
    var len = $9343c1d844fe8fe0$var$queue.length;
    while(len){
        $9343c1d844fe8fe0$var$currentQueue = $9343c1d844fe8fe0$var$queue;
        $9343c1d844fe8fe0$var$queue = [];
        while(++$9343c1d844fe8fe0$var$queueIndex < len)if ($9343c1d844fe8fe0$var$currentQueue) $9343c1d844fe8fe0$var$currentQueue[$9343c1d844fe8fe0$var$queueIndex].run();
        $9343c1d844fe8fe0$var$queueIndex = -1;
        len = $9343c1d844fe8fe0$var$queue.length;
    }
    $9343c1d844fe8fe0$var$currentQueue = null;
    $9343c1d844fe8fe0$var$draining = false;
    $9343c1d844fe8fe0$var$runClearTimeout(timeout);
}
$9343c1d844fe8fe0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $9343c1d844fe8fe0$var$queue.push(new $9343c1d844fe8fe0$var$Item(fun, args));
    if ($9343c1d844fe8fe0$var$queue.length === 1 && !$9343c1d844fe8fe0$var$draining) $9343c1d844fe8fe0$var$runTimeout($9343c1d844fe8fe0$var$drainQueue);
};
// v8 likes predictible objects
function $9343c1d844fe8fe0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$9343c1d844fe8fe0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$9343c1d844fe8fe0$var$process.title = 'browser';
$9343c1d844fe8fe0$var$process.browser = true;
$9343c1d844fe8fe0$var$process.env = {};
$9343c1d844fe8fe0$var$process.argv = [];
$9343c1d844fe8fe0$var$process.version = ''; // empty string to avoid regexp issues
$9343c1d844fe8fe0$var$process.versions = {};
function $9343c1d844fe8fe0$var$noop() {}
$9343c1d844fe8fe0$var$process.on = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.addListener = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.once = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.off = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.removeListener = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.removeAllListeners = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.emit = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.prependListener = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.prependOnceListener = $9343c1d844fe8fe0$var$noop;
$9343c1d844fe8fe0$var$process.listeners = function(name) {
    return [];
};
$9343c1d844fe8fe0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$9343c1d844fe8fe0$var$process.cwd = function() {
    return '/';
};
$9343c1d844fe8fe0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$9343c1d844fe8fe0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("fbcjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d16f2d3dbe9783$export$2e2bcd8739ae039; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $8Iuhi = parcelRequire("8Iuhi");

var $8dh9o = parcelRequire("8dh9o");

var $9YPOp = parcelRequire("9YPOp");

var $3SPhV = parcelRequire("3SPhV");

var $4SkkI = parcelRequire("4SkkI");

var $jMeQa = parcelRequire("jMeQa");

var $hnRRg = parcelRequire("hnRRg");

var $irFHt = parcelRequire("irFHt");
'use strict';
var $b0d16f2d3dbe9783$var$validators = (0, $hnRRg.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $b0d16f2d3dbe9783$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $3CDbU._)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $9YPOp.default)(),
            response: new (0, $9YPOp.default)()
        };
    }
    (0, $jyA4z._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var err, dummy, stack;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $4SkkI.default)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $hnRRg.default).assertOptions(transitional, {
                    silentJSONParsing: $b0d16f2d3dbe9783$var$validators.transitional($b0d16f2d3dbe9783$var$validators["boolean"]),
                    forcedJSONParsing: $b0d16f2d3dbe9783$var$validators.transitional($b0d16f2d3dbe9783$var$validators["boolean"]),
                    clarifyTimeoutError: $b0d16f2d3dbe9783$var$validators.transitional($b0d16f2d3dbe9783$var$validators["boolean"])
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $8Iuhi.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $hnRRg.default).assertOptions(paramsSerializer, {
                        encode: $b0d16f2d3dbe9783$var$validators["function"],
                        serialize: $b0d16f2d3dbe9783$var$validators["function"]
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $hnRRg.default).assertOptions(config, {
                    baseUrl: $b0d16f2d3dbe9783$var$validators.spelling('baseURL'),
                    withXsrfToken: $b0d16f2d3dbe9783$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = (config.method || this.defaults.method || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $8Iuhi.default).merge(headers.common, headers[config.method]);
                headers && (0, $8Iuhi.default).forEach([
                    'delete',
                    'get',
                    'head',
                    'post',
                    'put',
                    'patch',
                    'common'
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $irFHt.default).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, $3SPhV.default).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $3SPhV.default).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $4SkkI.default)(this.defaults, config);
                var fullPath = (0, $jMeQa.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
                return (0, $8dh9o.default)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $8Iuhi.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $b0d16f2d3dbe9783$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4SkkI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8Iuhi.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4SkkI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $b0d16f2d3dbe9783$var$Axios.prototype[method] = generateHTTPMethod();
    $b0d16f2d3dbe9783$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $b0d16f2d3dbe9783$export$2e2bcd8739ae039 = $b0d16f2d3dbe9783$var$Axios;

});
parcelRegister("8dh9o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5facd7623c037f07$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $h7360 = parcelRequire("h7360");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $5facd7623c037f07$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $5facd7623c037f07$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $5facd7623c037f07$var$encode;
    if ((0, $8Iuhi.default).isFunction(options)) options = {
        serialize: options
    };
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8Iuhi.default).isURLSearchParams(params) ? params.toString() : new (0, $h7360.default)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("h7360", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7557de5125b3745$export$2e2bcd8739ae039; });

var $1q8ze = parcelRequire("1q8ze");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $c7557de5125b3745$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $c7557de5125b3745$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1q8ze.default)(params, this, options);
}
var $c7557de5125b3745$var$prototype = $c7557de5125b3745$var$AxiosURLSearchParams.prototype;
$c7557de5125b3745$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$c7557de5125b3745$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $c7557de5125b3745$var$encode);
    } : $c7557de5125b3745$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $c7557de5125b3745$export$2e2bcd8739ae039 = $c7557de5125b3745$var$AxiosURLSearchParams;

});
parcelRegister("1q8ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $108edd6a861a1082$export$2e2bcd8739ae039; });

var $7tffA = parcelRequire("7tffA");

var $8Iuhi = parcelRequire("8Iuhi");

var $7Xdj3 = parcelRequire("7Xdj3");

var $dRckg = parcelRequire("dRckg");

var $eWKeP = parcelRequire("eWKeP");
var $108edd6a861a1082$require$Buffer = $eWKeP.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $108edd6a861a1082$var$isVisitable(thing) {
    return (0, $8Iuhi.default).isPlainObject(thing) || (0, $8Iuhi.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $108edd6a861a1082$var$removeBrackets(key) {
    return (0, $8Iuhi.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $108edd6a861a1082$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $108edd6a861a1082$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $108edd6a861a1082$var$isFlatArray(arr) {
    return (0, $8Iuhi.default).isArray(arr) && !arr.some($108edd6a861a1082$var$isVisitable);
}
var $108edd6a861a1082$var$predicates = (0, $8Iuhi.default).toFlatObject((0, $8Iuhi.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $108edd6a861a1082$var$toFormData(obj, formData, options) {
    if (!(0, $8Iuhi.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $dRckg.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8Iuhi.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8Iuhi.default).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var useBlob = _Blob && (0, $8Iuhi.default).isSpecCompliantForm(formData);
    if (!(0, $8Iuhi.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $8Iuhi.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8Iuhi.default).isBlob(value)) throw new (0, $7Xdj3.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $8Iuhi.default).isArrayBuffer(value) || (0, $8Iuhi.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $108edd6a861a1082$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) === 'object') {
            if ((0, $8Iuhi.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8Iuhi.default).isArray(value) && $108edd6a861a1082$var$isFlatArray(value) || ((0, $8Iuhi.default).isFileList(value) || (0, $8Iuhi.default).endsWith(key, '[]')) && (arr = (0, $8Iuhi.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $108edd6a861a1082$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8Iuhi.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $108edd6a861a1082$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($108edd6a861a1082$var$isVisitable(value)) return true;
        formData.append($108edd6a861a1082$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($108edd6a861a1082$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $108edd6a861a1082$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8Iuhi.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $8Iuhi.default).forEach(value, function each(el, key) {
            var result = !((0, $8Iuhi.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8Iuhi.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8Iuhi.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $108edd6a861a1082$export$2e2bcd8739ae039 = $108edd6a861a1082$var$toFormData;

});
parcelRegister("7Xdj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ca85d777b8c0be7$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $5ca85d777b8c0be7$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $8Iuhi.default).inherits($5ca85d777b8c0be7$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8Iuhi.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $5ca85d777b8c0be7$var$prototype = $5ca85d777b8c0be7$var$AxiosError.prototype;
var $5ca85d777b8c0be7$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach(function(code) {
    $5ca85d777b8c0be7$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5ca85d777b8c0be7$var$AxiosError, $5ca85d777b8c0be7$var$descriptors);
Object.defineProperty($5ca85d777b8c0be7$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$5ca85d777b8c0be7$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($5ca85d777b8c0be7$var$prototype);
    (0, $8Iuhi.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== 'isAxiosError';
    });
    $5ca85d777b8c0be7$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $5ca85d777b8c0be7$export$2e2bcd8739ae039 = $5ca85d777b8c0be7$var$AxiosError;

});

parcelRegister("dRckg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a169c93df489f0d2$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $a169c93df489f0d2$export$2e2bcd8739ae039 = null;

});

parcelRegister("eWKeP", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $ae1a59643b6dbf30$export$a143d493d941bafc; }, function (v) { return $ae1a59643b6dbf30$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $ae1a59643b6dbf30$export$f99ded8fe4b79145; }, function (v) { return $ae1a59643b6dbf30$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $7tffA = parcelRequire("7tffA");
var $ae1a59643b6dbf30$export$a143d493d941bafc;
var $ae1a59643b6dbf30$export$e4cf37d7f6fb9e0a;
var $ae1a59643b6dbf30$export$f99ded8fe4b79145;
var $ae1a59643b6dbf30$export$599f31c3813fae4d;
'use strict';

var $5zXL4 = parcelRequire("5zXL4");

var $e3LXm = parcelRequire("e3LXm");
var $ae1a59643b6dbf30$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ae1a59643b6dbf30$export$a143d493d941bafc = $ae1a59643b6dbf30$var$Buffer;
$ae1a59643b6dbf30$export$e4cf37d7f6fb9e0a = $ae1a59643b6dbf30$var$SlowBuffer;
$ae1a59643b6dbf30$export$f99ded8fe4b79145 = 50;
var $ae1a59643b6dbf30$var$K_MAX_LENGTH = 0x7fffffff;
$ae1a59643b6dbf30$export$599f31c3813fae4d = $ae1a59643b6dbf30$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ae1a59643b6dbf30$var$Buffer.TYPED_ARRAY_SUPPORT = $ae1a59643b6dbf30$var$typedArraySupport();
if (!$ae1a59643b6dbf30$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ae1a59643b6dbf30$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ae1a59643b6dbf30$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ae1a59643b6dbf30$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ae1a59643b6dbf30$var$createBuffer(length) {
    if (length > $ae1a59643b6dbf30$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ae1a59643b6dbf30$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ae1a59643b6dbf30$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ae1a59643b6dbf30$var$allocUnsafe(arg);
    }
    return $ae1a59643b6dbf30$var$from(arg, encodingOrOffset, length);
}
$ae1a59643b6dbf30$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ae1a59643b6dbf30$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ae1a59643b6dbf30$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ae1a59643b6dbf30$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)));
    if ($ae1a59643b6dbf30$var$isInstance(value, ArrayBuffer) || value && $ae1a59643b6dbf30$var$isInstance(value.buffer, ArrayBuffer)) return $ae1a59643b6dbf30$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ae1a59643b6dbf30$var$isInstance(value, SharedArrayBuffer) || value && $ae1a59643b6dbf30$var$isInstance(value.buffer, SharedArrayBuffer))) return $ae1a59643b6dbf30$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ae1a59643b6dbf30$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $ae1a59643b6dbf30$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ae1a59643b6dbf30$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ae1a59643b6dbf30$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ae1a59643b6dbf30$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ae1a59643b6dbf30$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ae1a59643b6dbf30$var$Buffer, Uint8Array);
function $ae1a59643b6dbf30$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ae1a59643b6dbf30$var$alloc(size, fill, encoding) {
    $ae1a59643b6dbf30$var$assertSize(size);
    if (size <= 0) return $ae1a59643b6dbf30$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ae1a59643b6dbf30$var$createBuffer(size).fill(fill, encoding) : $ae1a59643b6dbf30$var$createBuffer(size).fill(fill);
    return $ae1a59643b6dbf30$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ae1a59643b6dbf30$var$Buffer.alloc = function(size, fill, encoding) {
    return $ae1a59643b6dbf30$var$alloc(size, fill, encoding);
};
function $ae1a59643b6dbf30$var$allocUnsafe(size) {
    $ae1a59643b6dbf30$var$assertSize(size);
    return $ae1a59643b6dbf30$var$createBuffer(size < 0 ? 0 : $ae1a59643b6dbf30$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ae1a59643b6dbf30$var$Buffer.allocUnsafe = function(size) {
    return $ae1a59643b6dbf30$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ae1a59643b6dbf30$var$Buffer.allocUnsafeSlow = function(size) {
    return $ae1a59643b6dbf30$var$allocUnsafe(size);
};
function $ae1a59643b6dbf30$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ae1a59643b6dbf30$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $ae1a59643b6dbf30$var$byteLength(string, encoding) | 0;
    var buf = $ae1a59643b6dbf30$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ae1a59643b6dbf30$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $ae1a59643b6dbf30$var$checked(array.length) | 0;
    var buf = $ae1a59643b6dbf30$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ae1a59643b6dbf30$var$fromArrayView(arrayView) {
    if ($ae1a59643b6dbf30$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $ae1a59643b6dbf30$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ae1a59643b6dbf30$var$fromArrayLike(arrayView);
}
function $ae1a59643b6dbf30$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ae1a59643b6dbf30$var$Buffer.prototype);
    return buf;
}
function $ae1a59643b6dbf30$var$fromObject(obj) {
    if ($ae1a59643b6dbf30$var$Buffer.isBuffer(obj)) {
        var len = $ae1a59643b6dbf30$var$checked(obj.length) | 0;
        var buf = $ae1a59643b6dbf30$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ae1a59643b6dbf30$var$numberIsNaN(obj.length)) return $ae1a59643b6dbf30$var$createBuffer(0);
        return $ae1a59643b6dbf30$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ae1a59643b6dbf30$var$fromArrayLike(obj.data);
}
function $ae1a59643b6dbf30$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ae1a59643b6dbf30$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ae1a59643b6dbf30$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ae1a59643b6dbf30$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ae1a59643b6dbf30$var$Buffer.alloc(+length);
}
$ae1a59643b6dbf30$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ae1a59643b6dbf30$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ae1a59643b6dbf30$var$Buffer.compare = function compare(a, b) {
    if ($ae1a59643b6dbf30$var$isInstance(a, Uint8Array)) a = $ae1a59643b6dbf30$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ae1a59643b6dbf30$var$isInstance(b, Uint8Array)) b = $ae1a59643b6dbf30$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(a) || !$ae1a59643b6dbf30$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ae1a59643b6dbf30$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ae1a59643b6dbf30$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ae1a59643b6dbf30$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $ae1a59643b6dbf30$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($ae1a59643b6dbf30$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(buf)) buf = $ae1a59643b6dbf30$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ae1a59643b6dbf30$var$byteLength(string, encoding) {
    if ($ae1a59643b6dbf30$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ae1a59643b6dbf30$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $7tffA._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ae1a59643b6dbf30$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ae1a59643b6dbf30$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ae1a59643b6dbf30$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ae1a59643b6dbf30$var$Buffer.byteLength = $ae1a59643b6dbf30$var$byteLength;
function $ae1a59643b6dbf30$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ae1a59643b6dbf30$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ae1a59643b6dbf30$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ae1a59643b6dbf30$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ae1a59643b6dbf30$var$latin1Slice(this, start, end);
        case 'base64':
            return $ae1a59643b6dbf30$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ae1a59643b6dbf30$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ae1a59643b6dbf30$var$Buffer.prototype._isBuffer = true;
function $ae1a59643b6dbf30$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ae1a59643b6dbf30$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$ae1a59643b6dbf30$var$swap(this, i, i + 1);
    return this;
};
$ae1a59643b6dbf30$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $ae1a59643b6dbf30$var$swap(this, i, i + 3);
        $ae1a59643b6dbf30$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ae1a59643b6dbf30$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $ae1a59643b6dbf30$var$swap(this, i, i + 7);
        $ae1a59643b6dbf30$var$swap(this, i + 1, i + 6);
        $ae1a59643b6dbf30$var$swap(this, i + 2, i + 5);
        $ae1a59643b6dbf30$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ae1a59643b6dbf30$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ae1a59643b6dbf30$var$utf8Slice(this, 0, length);
    return $ae1a59643b6dbf30$var$slowToString.apply(this, arguments);
};
$ae1a59643b6dbf30$var$Buffer.prototype.toLocaleString = $ae1a59643b6dbf30$var$Buffer.prototype.toString;
$ae1a59643b6dbf30$var$Buffer.prototype.equals = function equals(b) {
    if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ae1a59643b6dbf30$var$Buffer.compare(this, b) === 0;
};
$ae1a59643b6dbf30$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $ae1a59643b6dbf30$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ae1a59643b6dbf30$var$customInspectSymbol) $ae1a59643b6dbf30$var$Buffer.prototype[$ae1a59643b6dbf30$var$customInspectSymbol] = $ae1a59643b6dbf30$var$Buffer.prototype.inspect;
$ae1a59643b6dbf30$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ae1a59643b6dbf30$var$isInstance(target, Uint8Array)) target = $ae1a59643b6dbf30$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $7tffA._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ae1a59643b6dbf30$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ae1a59643b6dbf30$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ae1a59643b6dbf30$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ae1a59643b6dbf30$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ae1a59643b6dbf30$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ae1a59643b6dbf30$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ae1a59643b6dbf30$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ae1a59643b6dbf30$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ae1a59643b6dbf30$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ae1a59643b6dbf30$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ae1a59643b6dbf30$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ae1a59643b6dbf30$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ae1a59643b6dbf30$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ae1a59643b6dbf30$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ae1a59643b6dbf30$var$utf8Write(buf, string, offset, length) {
    return $ae1a59643b6dbf30$var$blitBuffer($ae1a59643b6dbf30$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ae1a59643b6dbf30$var$asciiWrite(buf, string, offset, length) {
    return $ae1a59643b6dbf30$var$blitBuffer($ae1a59643b6dbf30$var$asciiToBytes(string), buf, offset, length);
}
function $ae1a59643b6dbf30$var$base64Write(buf, string, offset, length) {
    return $ae1a59643b6dbf30$var$blitBuffer($ae1a59643b6dbf30$var$base64ToBytes(string), buf, offset, length);
}
function $ae1a59643b6dbf30$var$ucs2Write(buf, string, offset, length) {
    return $ae1a59643b6dbf30$var$blitBuffer($ae1a59643b6dbf30$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ae1a59643b6dbf30$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ae1a59643b6dbf30$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ae1a59643b6dbf30$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ae1a59643b6dbf30$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ae1a59643b6dbf30$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ae1a59643b6dbf30$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ae1a59643b6dbf30$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ae1a59643b6dbf30$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5zXL4.fromByteArray(buf);
    else return $5zXL4.fromByteArray(buf.slice(start, end));
}
function $ae1a59643b6dbf30$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ae1a59643b6dbf30$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $ae1a59643b6dbf30$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ae1a59643b6dbf30$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $ae1a59643b6dbf30$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ae1a59643b6dbf30$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ae1a59643b6dbf30$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ae1a59643b6dbf30$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ae1a59643b6dbf30$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $ae1a59643b6dbf30$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ae1a59643b6dbf30$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ae1a59643b6dbf30$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ae1a59643b6dbf30$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ae1a59643b6dbf30$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ae1a59643b6dbf30$var$Buffer.prototype.readUintLE = $ae1a59643b6dbf30$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUintBE = $ae1a59643b6dbf30$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUint8 = $ae1a59643b6dbf30$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUint16LE = $ae1a59643b6dbf30$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUint16BE = $ae1a59643b6dbf30$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUint32LE = $ae1a59643b6dbf30$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readUint32BE = $ae1a59643b6dbf30$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ae1a59643b6dbf30$var$Buffer.prototype.readBigUInt64LE = $ae1a59643b6dbf30$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ae1a59643b6dbf30$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ae1a59643b6dbf30$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ae1a59643b6dbf30$var$Buffer.prototype.readBigUInt64BE = $ae1a59643b6dbf30$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ae1a59643b6dbf30$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ae1a59643b6dbf30$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ae1a59643b6dbf30$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ae1a59643b6dbf30$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ae1a59643b6dbf30$var$Buffer.prototype.readBigInt64LE = $ae1a59643b6dbf30$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ae1a59643b6dbf30$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ae1a59643b6dbf30$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$ae1a59643b6dbf30$var$Buffer.prototype.readBigInt64BE = $ae1a59643b6dbf30$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ae1a59643b6dbf30$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ae1a59643b6dbf30$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$ae1a59643b6dbf30$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return $e3LXm.read(this, offset, true, 23, 4);
};
$ae1a59643b6dbf30$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 4, this.length);
    return $e3LXm.read(this, offset, false, 23, 4);
};
$ae1a59643b6dbf30$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 8, this.length);
    return $e3LXm.read(this, offset, true, 52, 8);
};
$ae1a59643b6dbf30$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkOffset(offset, 8, this.length);
    return $e3LXm.read(this, offset, false, 52, 8);
};
function $ae1a59643b6dbf30$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ae1a59643b6dbf30$var$Buffer.prototype.writeUintLE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ae1a59643b6dbf30$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUintBE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ae1a59643b6dbf30$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUint8 = $ae1a59643b6dbf30$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUint16LE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUint16BE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUint32LE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeUint32BE = $ae1a59643b6dbf30$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ae1a59643b6dbf30$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ae1a59643b6dbf30$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ae1a59643b6dbf30$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ae1a59643b6dbf30$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ae1a59643b6dbf30$var$Buffer.prototype.writeBigUInt64LE = $ae1a59643b6dbf30$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ae1a59643b6dbf30$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ae1a59643b6dbf30$var$Buffer.prototype.writeBigUInt64BE = $ae1a59643b6dbf30$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ae1a59643b6dbf30$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ae1a59643b6dbf30$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ae1a59643b6dbf30$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ae1a59643b6dbf30$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeBigInt64LE = $ae1a59643b6dbf30$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ae1a59643b6dbf30$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ae1a59643b6dbf30$var$Buffer.prototype.writeBigInt64BE = $ae1a59643b6dbf30$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ae1a59643b6dbf30$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ae1a59643b6dbf30$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ae1a59643b6dbf30$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $e3LXm.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ae1a59643b6dbf30$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ae1a59643b6dbf30$var$writeFloat(this, value, offset, true, noAssert);
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ae1a59643b6dbf30$var$writeFloat(this, value, offset, false, noAssert);
};
function $ae1a59643b6dbf30$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ae1a59643b6dbf30$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $e3LXm.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ae1a59643b6dbf30$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ae1a59643b6dbf30$var$writeDouble(this, value, offset, true, noAssert);
};
$ae1a59643b6dbf30$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ae1a59643b6dbf30$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ae1a59643b6dbf30$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ae1a59643b6dbf30$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ae1a59643b6dbf30$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ae1a59643b6dbf30$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $ae1a59643b6dbf30$var$Buffer.isBuffer(val) ? val : $ae1a59643b6dbf30$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $ae1a59643b6dbf30$var$errors = {};
function $ae1a59643b6dbf30$var$E(sym, getMessage, Base) {
    $ae1a59643b6dbf30$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $jCmGC._)(NodeError, Base);
        function NodeError() {
            (0, $3CDbU._)(this, NodeError);
            var _this;
            _this = (0, $ep9cZ._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $jyA4z._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$ae1a59643b6dbf30$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ae1a59643b6dbf30$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $7tffA._)(actual));
}, TypeError);
$ae1a59643b6dbf30$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $ae1a59643b6dbf30$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $7tffA._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $ae1a59643b6dbf30$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $ae1a59643b6dbf30$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $ae1a59643b6dbf30$var$checkBounds(buf, offset, byteLength) {
    $ae1a59643b6dbf30$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ae1a59643b6dbf30$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ae1a59643b6dbf30$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $7tffA._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $ae1a59643b6dbf30$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ae1a59643b6dbf30$var$checkBounds(buf, offset, byteLength);
}
function $ae1a59643b6dbf30$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ae1a59643b6dbf30$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ae1a59643b6dbf30$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ae1a59643b6dbf30$var$validateNumber(value, type);
        throw new $ae1a59643b6dbf30$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ae1a59643b6dbf30$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ae1a59643b6dbf30$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $ae1a59643b6dbf30$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ae1a59643b6dbf30$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ae1a59643b6dbf30$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ae1a59643b6dbf30$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ae1a59643b6dbf30$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ae1a59643b6dbf30$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ae1a59643b6dbf30$var$base64ToBytes(str) {
    return $5zXL4.toByteArray($ae1a59643b6dbf30$var$base64clean(str));
}
function $ae1a59643b6dbf30$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ae1a59643b6dbf30$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ae1a59643b6dbf30$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $ae1a59643b6dbf30$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ae1a59643b6dbf30$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ae1a59643b6dbf30$var$BufferBigIntNotDefined : fn;
}
function $ae1a59643b6dbf30$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("ep9cZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a7ca8b1aeb846ba3$export$71511d61b312f219; });

var $5q8bQ = parcelRequire("5q8bQ");

var $9OFVA = parcelRequire("9OFVA");

var $lCP4g = parcelRequire("lCP4g");
function $a7ca8b1aeb846ba3$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $5q8bQ._)(derived);
    return (0, $lCP4g._)(_this, (0, $9OFVA._)() ? Reflect.construct(derived, args || [], (0, $5q8bQ._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("5q8bQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f25bbd911056124$export$71511d61b312f219; });
function $3f25bbd911056124$export$71511d61b312f219(o) {
    $3f25bbd911056124$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3f25bbd911056124$export$71511d61b312f219(o);
}

});

parcelRegister("9OFVA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $72594e95abeb91f9$export$71511d61b312f219; });
function $72594e95abeb91f9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($72594e95abeb91f9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("lCP4g", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fbe4c2964a211ec7$export$71511d61b312f219; });

var $cBxnR = parcelRequire("cBxnR");

var $7tffA = parcelRequire("7tffA");
function $fbe4c2964a211ec7$export$71511d61b312f219(self, call) {
    if (call && ((0, $7tffA._)(call) === "object" || typeof call === "function")) return call;
    return (0, $cBxnR._)(self);
}

});
parcelRegister("cBxnR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $92d2d6173667b751$export$71511d61b312f219; });
function $92d2d6173667b751$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("jCmGC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e48329fb31d72cc9$export$71511d61b312f219; });

var $eq1Wd = parcelRequire("eq1Wd");
function $e48329fb31d72cc9$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eq1Wd._)(subClass, superClass);
}

});
parcelRegister("eq1Wd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a7f4ff39e4251999$export$71511d61b312f219; });
function $a7f4ff39e4251999$export$71511d61b312f219(o, p) {
    $a7f4ff39e4251999$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a7f4ff39e4251999$export$71511d61b312f219(o, p);
}

});


parcelRegister("5zXL4", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $40fe936347c82aad$export$d622b2ad8d90c771; }, function (v) { return $40fe936347c82aad$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $40fe936347c82aad$export$6100ba28696e12de; }, function (v) { return $40fe936347c82aad$export$6100ba28696e12de = v; });
var $40fe936347c82aad$export$a48f0734ac7c2329;
var $40fe936347c82aad$export$d622b2ad8d90c771;
var $40fe936347c82aad$export$6100ba28696e12de;
'use strict';
$40fe936347c82aad$export$a48f0734ac7c2329 = $40fe936347c82aad$var$byteLength;
$40fe936347c82aad$export$d622b2ad8d90c771 = $40fe936347c82aad$var$toByteArray;
$40fe936347c82aad$export$6100ba28696e12de = $40fe936347c82aad$var$fromByteArray;
var $40fe936347c82aad$var$lookup = [];
var $40fe936347c82aad$var$revLookup = [];
var $40fe936347c82aad$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $40fe936347c82aad$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $40fe936347c82aad$var$i = 0, $40fe936347c82aad$var$len = $40fe936347c82aad$var$code.length; $40fe936347c82aad$var$i < $40fe936347c82aad$var$len; ++$40fe936347c82aad$var$i){
    $40fe936347c82aad$var$lookup[$40fe936347c82aad$var$i] = $40fe936347c82aad$var$code[$40fe936347c82aad$var$i];
    $40fe936347c82aad$var$revLookup[$40fe936347c82aad$var$code.charCodeAt($40fe936347c82aad$var$i)] = $40fe936347c82aad$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$40fe936347c82aad$var$revLookup['-'.charCodeAt(0)] = 62;
$40fe936347c82aad$var$revLookup['_'.charCodeAt(0)] = 63;
function $40fe936347c82aad$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $40fe936347c82aad$var$byteLength(b64) {
    var lens = $40fe936347c82aad$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $40fe936347c82aad$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $40fe936347c82aad$var$toByteArray(b64) {
    var tmp;
    var lens = $40fe936347c82aad$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $40fe936347c82aad$var$Arr($40fe936347c82aad$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $40fe936347c82aad$var$revLookup[b64.charCodeAt(i)] << 18 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $40fe936347c82aad$var$revLookup[b64.charCodeAt(i)] << 2 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $40fe936347c82aad$var$revLookup[b64.charCodeAt(i)] << 10 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $40fe936347c82aad$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $40fe936347c82aad$var$tripletToBase64(num) {
    return $40fe936347c82aad$var$lookup[num >> 18 & 0x3F] + $40fe936347c82aad$var$lookup[num >> 12 & 0x3F] + $40fe936347c82aad$var$lookup[num >> 6 & 0x3F] + $40fe936347c82aad$var$lookup[num & 0x3F];
}
function $40fe936347c82aad$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($40fe936347c82aad$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $40fe936347c82aad$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($40fe936347c82aad$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($40fe936347c82aad$var$lookup[tmp >> 2] + $40fe936347c82aad$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($40fe936347c82aad$var$lookup[tmp >> 10] + $40fe936347c82aad$var$lookup[tmp >> 4 & 0x3F] + $40fe936347c82aad$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("e3LXm", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $a3c68ba5dce34a09$export$aafa59e2e03f2942; }, function (v) { return $a3c68ba5dce34a09$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $a3c68ba5dce34a09$export$68d8715fc104d294; }, function (v) { return $a3c68ba5dce34a09$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a3c68ba5dce34a09$export$aafa59e2e03f2942;
var $a3c68ba5dce34a09$export$68d8715fc104d294;
$a3c68ba5dce34a09$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a3c68ba5dce34a09$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("9YPOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7441e86f90f13ac3$export$2e2bcd8739ae039; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
var $7441e86f90f13ac3$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $3CDbU._)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $jyA4z._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $8Iuhi.default).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $7441e86f90f13ac3$export$2e2bcd8739ae039 = $7441e86f90f13ac3$var$InterceptorManager;

});

parcelRegister("3SPhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d3e32fff3ad901b$export$2e2bcd8739ae039; });

var $lpY53 = parcelRequire("lpY53");

var $02xxh = parcelRequire("02xxh");

var $4y0cc = parcelRequire("4y0cc");

var $k68rj = parcelRequire("k68rj");

var $irFHt = parcelRequire("irFHt");

var $h9vBo = parcelRequire("h9vBo");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $2d3e32fff3ad901b$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $k68rj.default)(null, config);
}
function $2d3e32fff3ad901b$export$2e2bcd8739ae039(config) {
    $2d3e32fff3ad901b$var$throwIfCancellationRequested(config);
    config.headers = (0, $irFHt.default).from(config.headers);
    // Transform request data
    config.data = (0, $lpY53.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $h9vBo.default).getAdapter(config.adapter || (0, $4y0cc.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $2d3e32fff3ad901b$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $lpY53.default).call(config, config.transformResponse, response);
        response.headers = (0, $irFHt.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $02xxh.default)(reason)) {
            $2d3e32fff3ad901b$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $lpY53.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $irFHt.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("lpY53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f97a897d61907847$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $4y0cc = parcelRequire("4y0cc");

var $irFHt = parcelRequire("irFHt");
'use strict';
function $f97a897d61907847$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $4y0cc.default);
    var context = response || config;
    var headers = (0, $irFHt.default).from(context.headers);
    var data = context.data;
    (0, $8Iuhi.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("4y0cc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34fa7d46566ce194$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $7Xdj3 = parcelRequire("7Xdj3");

var $464aR = parcelRequire("464aR");

var $1q8ze = parcelRequire("1q8ze");

var $fWkaE = parcelRequire("fWkaE");

var $jZDmV = parcelRequire("jZDmV");

var $8WNNn = parcelRequire("8WNNn");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $34fa7d46566ce194$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8Iuhi.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8Iuhi.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $34fa7d46566ce194$var$defaults = {
    transitional: (0, $464aR.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $8Iuhi.default).isObject(data);
            if (isObjectPayload && (0, $8Iuhi.default).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $8Iuhi.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8WNNn.default)(data)) : data;
            if ((0, $8Iuhi.default).isArrayBuffer(data) || (0, $8Iuhi.default).isBuffer(data) || (0, $8Iuhi.default).isStream(data) || (0, $8Iuhi.default).isFile(data) || (0, $8Iuhi.default).isBlob(data) || (0, $8Iuhi.default).isReadableStream(data)) return data;
            if ((0, $8Iuhi.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $8Iuhi.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $fWkaE.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8Iuhi.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $1q8ze.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $34fa7d46566ce194$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $34fa7d46566ce194$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if ((0, $8Iuhi.default).isResponse(data) || (0, $8Iuhi.default).isReadableStream(data)) return data;
            if (data && (0, $8Iuhi.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $7Xdj3.default).from(e, (0, $7Xdj3.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $jZDmV.default).classes.FormData,
        Blob: (0, $jZDmV.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $8Iuhi.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], function(method) {
    $34fa7d46566ce194$var$defaults.headers[method] = {};
});
var $34fa7d46566ce194$export$2e2bcd8739ae039 = $34fa7d46566ce194$var$defaults;

});
parcelRegister("464aR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fbaf5e1134b8b33$export$2e2bcd8739ae039; });
'use strict';
var $2fbaf5e1134b8b33$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("fWkaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9abeb4bed6a58d9$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $1q8ze = parcelRequire("1q8ze");

var $jZDmV = parcelRequire("jZDmV");
'use strict';
function $b9abeb4bed6a58d9$export$2e2bcd8739ae039(data, options) {
    return (0, $1q8ze.default)(data, new (0, $jZDmV.default).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $jZDmV.default).isNode && (0, $8Iuhi.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("jZDmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e240aad5b75111$export$2e2bcd8739ae039; });

var $cgG2i = parcelRequire("cgG2i");

var $dKvyU = parcelRequire("dKvyU");

var $9zoM4 = parcelRequire("9zoM4");
var $e8e240aad5b75111$export$2e2bcd8739ae039 = (0, $cgG2i._)({}, $9zoM4, (0, $dKvyU.default));

});
parcelRegister("dKvyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0280dd277baa77e$export$2e2bcd8739ae039; });

var $8ves1 = parcelRequire("8ves1");

var $apYOt = parcelRequire("apYOt");

var $3bOlG = parcelRequire("3bOlG");
var $a0280dd277baa77e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $8ves1.default),
        FormData: (0, $apYOt.default),
        Blob: (0, $3bOlG.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("8ves1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $630c6daa11a6109c$export$2e2bcd8739ae039; });

var $h7360 = parcelRequire("h7360");
'use strict';
var $630c6daa11a6109c$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $h7360.default);

});

parcelRegister("apYOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $795b69654178c0b7$export$2e2bcd8739ae039; });
'use strict';
var $795b69654178c0b7$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("3bOlG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $252974621ff3d41f$export$2e2bcd8739ae039; });
'use strict';
var $252974621ff3d41f$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("9zoM4", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $6f7a99970bae9893$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $6f7a99970bae9893$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $6f7a99970bae9893$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $6f7a99970bae9893$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $6f7a99970bae9893$export$f710a83a91838a36; });

var $7tffA = parcelRequire("7tffA");
var $6f7a99970bae9893$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $6f7a99970bae9893$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $7tffA._)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $6f7a99970bae9893$export$c0bcc9250309d66 = $6f7a99970bae9893$export$c4996c4b7b93b0bf && (!$6f7a99970bae9893$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($6f7a99970bae9893$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $6f7a99970bae9893$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $6f7a99970bae9893$export$f710a83a91838a36 = $6f7a99970bae9893$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8WNNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683a5ddbffbd24c1$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $683a5ddbffbd24c1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8Iuhi.default).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $683a5ddbffbd24c1$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $683a5ddbffbd24c1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $8Iuhi.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8Iuhi.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8Iuhi.default).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $8Iuhi.default).isArray(target[name])) target[name] = $683a5ddbffbd24c1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8Iuhi.default).isFormData(formData) && (0, $8Iuhi.default).isFunction(formData.entries)) {
        var obj = {};
        (0, $8Iuhi.default).forEachEntry(formData, function(name, value) {
            buildPath($683a5ddbffbd24c1$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $683a5ddbffbd24c1$export$2e2bcd8739ae039 = $683a5ddbffbd24c1$var$formDataToJSON;

});


parcelRegister("irFHt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6db186b3b7ae07b$export$2e2bcd8739ae039; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $bN2zx = parcelRequire("bN2zx");

var $78NO5 = parcelRequire("78NO5");

var $8Iuhi = parcelRequire("8Iuhi");

var $hqXWI = parcelRequire("hqXWI");
'use strict';
var $d6db186b3b7ae07b$var$$internals = Symbol('internals');
function $d6db186b3b7ae07b$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d6db186b3b7ae07b$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8Iuhi.default).isArray(value) ? value.map($d6db186b3b7ae07b$var$normalizeValue) : String(value);
}
function $d6db186b3b7ae07b$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $d6db186b3b7ae07b$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $d6db186b3b7ae07b$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8Iuhi.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8Iuhi.default).isString(value)) return;
    if ((0, $8Iuhi.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8Iuhi.default).isRegExp(filter)) return filter.test(value);
}
function $d6db186b3b7ae07b$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function $d6db186b3b7ae07b$var$buildAccessors(obj, header) {
    var accessorName = (0, $8Iuhi.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $d6db186b3b7ae07b$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $3CDbU._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $jyA4z._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $d6db186b3b7ae07b$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error('header name must be a non-empty string');
                    var key = (0, $8Iuhi.default).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d6db186b3b7ae07b$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $8Iuhi.default).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, $8Iuhi.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $8Iuhi.default).isString(header) && (header = header.trim()) && !$d6db186b3b7ae07b$var$isValidHeaderName(header)) setHeaders((0, $hqXWI.default)(header), valueOrRewrite);
                else if ((0, $8Iuhi.default).isHeaders(header)) try {
                    for(var _iterator = header.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        setHeader(value, key, rewrite);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $d6db186b3b7ae07b$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $8Iuhi.default).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $d6db186b3b7ae07b$var$parseTokens(value);
                        if ((0, $8Iuhi.default).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $8Iuhi.default).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $d6db186b3b7ae07b$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $8Iuhi.default).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $d6db186b3b7ae07b$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $d6db186b3b7ae07b$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $8Iuhi.default).findKey(self, _header);
                        if (key && (!matcher || $d6db186b3b7ae07b$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $8Iuhi.default).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $d6db186b3b7ae07b$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $8Iuhi.default).forEach(this, function(value, header) {
                    var key = (0, $8Iuhi.default).findKey(headers, header);
                    if (key) {
                        self[key] = $d6db186b3b7ae07b$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $d6db186b3b7ae07b$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $d6db186b3b7ae07b$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $78NO5._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $8Iuhi.default).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $8Iuhi.default).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $bN2zx._)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$d6db186b3b7ae07b$var$$internals] = this[$d6db186b3b7ae07b$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $d6db186b3b7ae07b$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $d6db186b3b7ae07b$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $8Iuhi.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$d6db186b3b7ae07b$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $8Iuhi.default).reduceDescriptors($d6db186b3b7ae07b$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8Iuhi.default).freezeMethods($d6db186b3b7ae07b$var$AxiosHeaders);
var $d6db186b3b7ae07b$export$2e2bcd8739ae039 = $d6db186b3b7ae07b$var$AxiosHeaders;

});
parcelRegister("78NO5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $532fea55ed8db739$export$71511d61b312f219; });

var $2xsym = parcelRequire("2xsym");

var $kASkX = parcelRequire("kASkX");

var $h0m8c = parcelRequire("h0m8c");

var $cCTAr = parcelRequire("cCTAr");
function $532fea55ed8db739$export$71511d61b312f219(arr) {
    return (0, $2xsym._)(arr) || (0, $kASkX._)(arr) || (0, $cCTAr._)(arr) || (0, $h0m8c._)();
}

});
parcelRegister("2xsym", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d94cfea302d5860$export$71511d61b312f219; });

var $5YQhh = parcelRequire("5YQhh");
function $1d94cfea302d5860$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $5YQhh._)(arr);
}

});

parcelRegister("kASkX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efe151a5fbb6d164$export$71511d61b312f219; });
function $efe151a5fbb6d164$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("h0m8c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6139a94d180f910$export$71511d61b312f219; });
function $c6139a94d180f910$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hqXWI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb135d6ae07963c1$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cb135d6ae07963c1$var$ignoreDuplicateOf = (0, $8Iuhi.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cb135d6ae07963c1$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cb135d6ae07963c1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("02xxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $007a33898423b281$export$2e2bcd8739ae039; });
'use strict';
function $007a33898423b281$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("k68rj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea1aea1627e75c80$export$2e2bcd8739ae039; });

var $7Xdj3 = parcelRequire("7Xdj3");

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $ea1aea1627e75c80$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $7Xdj3.default).call(this, message == null ? 'canceled' : message, (0, $7Xdj3.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $8Iuhi.default).inherits($ea1aea1627e75c80$var$CanceledError, (0, $7Xdj3.default), {
    __CANCEL__: true
});
var $ea1aea1627e75c80$export$2e2bcd8739ae039 = $ea1aea1627e75c80$var$CanceledError;

});

parcelRegister("h9vBo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7cbca73e38a1dd4$export$2e2bcd8739ae039; });

var $bN2zx = parcelRequire("bN2zx");

var $8Iuhi = parcelRequire("8Iuhi");

var $dRckg = parcelRequire("dRckg");

var $9Ny5U = parcelRequire("9Ny5U");

var $9dcpX = parcelRequire("9dcpX");

var $7Xdj3 = parcelRequire("7Xdj3");
var $c7cbca73e38a1dd4$var$knownAdapters = {
    http: (0, $dRckg.default),
    xhr: (0, $9Ny5U.default),
    fetch: (0, $9dcpX.default)
};
(0, $8Iuhi.default).forEach($c7cbca73e38a1dd4$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
var $c7cbca73e38a1dd4$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $c7cbca73e38a1dd4$var$isResolvedHandle = function(adapter) {
    return (0, $8Iuhi.default).isFunction(adapter) || adapter === null || adapter === false;
};
var $c7cbca73e38a1dd4$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters) {
        adapters = (0, $8Iuhi.default).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$c7cbca73e38a1dd4$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $c7cbca73e38a1dd4$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $7Xdj3.default)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $bN2zx._)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
            });
            var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c7cbca73e38a1dd4$var$renderReason).join('\n') : ' ' + $c7cbca73e38a1dd4$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $7Xdj3.default)("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $c7cbca73e38a1dd4$var$knownAdapters
};

});
parcelRegister("9Ny5U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7223230dd0942ab8$export$2e2bcd8739ae039; });

var $bN2zx = parcelRequire("bN2zx");

var $8Iuhi = parcelRequire("8Iuhi");

var $3gU6d = parcelRequire("3gU6d");

var $464aR = parcelRequire("464aR");

var $7Xdj3 = parcelRequire("7Xdj3");

var $k68rj = parcelRequire("k68rj");

var $l4sME = parcelRequire("l4sME");

var $jZDmV = parcelRequire("jZDmV");

var $irFHt = parcelRequire("irFHt");

var $jZJFK = parcelRequire("jZJFK");

var $jRPqc = parcelRequire("jRPqc");
var $7223230dd0942ab8$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $7223230dd0942ab8$export$2e2bcd8739ae039 = $7223230dd0942ab8$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $jRPqc.default)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $irFHt.default).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $irFHt.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $3gU6d.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $7Xdj3.default)('Request aborted', (0, $7Xdj3.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $7Xdj3.default)('Network Error', (0, $7Xdj3.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $464aR.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $7Xdj3.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $7Xdj3.default).ETIMEDOUT : (0, $7Xdj3.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $8Iuhi.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8Iuhi.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $bN2zx._)((0, $jZJFK.progressEventReducer)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $bN2zx._)((0, $jZJFK.progressEventReducer)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $k68rj.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $l4sME.default)(_config.url);
        if (protocol && (0, $jZDmV.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $7Xdj3.default)('Unsupported protocol ' + protocol + ':', (0, $7Xdj3.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("3gU6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $261e61d9ef52ee70$export$2e2bcd8739ae039; });

var $7Xdj3 = parcelRequire("7Xdj3");
'use strict';
function $261e61d9ef52ee70$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $7Xdj3.default)('Request failed with status code ' + response.status, [
        (0, $7Xdj3.default).ERR_BAD_REQUEST,
        (0, $7Xdj3.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("l4sME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5704c8cbdca68e3$export$2e2bcd8739ae039; });
'use strict';
function $f5704c8cbdca68e3$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("jZJFK", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $e8e7246ca35ae7f4$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $e8e7246ca35ae7f4$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $e8e7246ca35ae7f4$export$5d35863c355a22a9; });

var $fEm89 = parcelRequire("fEm89");

var $78NO5 = parcelRequire("78NO5");

var $6LrQ3 = parcelRequire("6LrQ3");

var $8Bv5T = parcelRequire("8Bv5T");

var $8Iuhi = parcelRequire("8Iuhi");
var $e8e7246ca35ae7f4$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $6LrQ3.default)(50, 250);
    return (0, $8Bv5T.default)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $fEm89._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $e8e7246ca35ae7f4$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $e8e7246ca35ae7f4$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $8Iuhi.default).asap(function() {
            return fn.apply(void 0, (0, $78NO5._)(args));
        });
    };
};

});
parcelRegister("6LrQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eccba01c5a6969f$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4eccba01c5a6969f$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4eccba01c5a6969f$export$2e2bcd8739ae039 = $4eccba01c5a6969f$var$speedometer;

});

parcelRegister("8Bv5T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6439e614000badf0$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $6439e614000badf0$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $6439e614000badf0$export$2e2bcd8739ae039 = $6439e614000badf0$var$throttle;

});


parcelRegister("jRPqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76adaca18a7b553$export$2e2bcd8739ae039; });

var $7CUUT = parcelRequire("7CUUT");

var $78NO5 = parcelRequire("78NO5");

var $jZDmV = parcelRequire("jZDmV");

var $8Iuhi = parcelRequire("8Iuhi");

var $ifk0S = parcelRequire("ifk0S");

var $iDNs6 = parcelRequire("iDNs6");

var $jMeQa = parcelRequire("jMeQa");

var $4SkkI = parcelRequire("4SkkI");

var $irFHt = parcelRequire("irFHt");

var $8dh9o = parcelRequire("8dh9o");
var $e76adaca18a7b553$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $4SkkI.default)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $irFHt.default).from(headers);
    newConfig.url = (0, $8dh9o.default)((0, $jMeQa.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    var contentType;
    if ((0, $8Iuhi.default).isFormData(data)) {
        if ((0, $jZDmV.default).hasStandardBrowserEnv || (0, $jZDmV.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            var _ref = (0, $7CUUT._)(contentType ? contentType.split(';').map(function(token) {
                return token.trim();
            }).filter(Boolean) : []), type = _ref[0], tokens = _ref.slice(1);
            headers.setContentType([
                type || 'multipart/form-data'
            ].concat((0, $78NO5._)(tokens)).join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $jZDmV.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $8Iuhi.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $ifk0S.default)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $iDNs6.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("7CUUT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $58d83b753631c9e4$export$71511d61b312f219; });

var $7cZ6u = parcelRequire("7cZ6u");

var $kASkX = parcelRequire("kASkX");

var $adZsl = parcelRequire("adZsl");

var $cCTAr = parcelRequire("cCTAr");
function $58d83b753631c9e4$export$71511d61b312f219(arr) {
    return (0, $7cZ6u._)(arr) || (0, $kASkX._)(arr) || (0, $cCTAr._)(arr) || (0, $adZsl._)();
}

});

parcelRegister("ifk0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d48926e7572bb4b1$export$2e2bcd8739ae039; });

var $jZDmV = parcelRequire("jZDmV");
var $d48926e7572bb4b1$export$2e2bcd8739ae039 = (0, $jZDmV.default).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $jZDmV.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $jZDmV.default).origin), (0, $jZDmV.default).navigator && /(msie|trident)/i.test((0, $jZDmV.default).navigator.userAgent)) : function() {
    return true;
};

});

parcelRegister("iDNs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9223aad79375c30$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");

var $jZDmV = parcelRequire("jZDmV");
var $d9223aad79375c30$export$2e2bcd8739ae039 = (0, $jZDmV.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $8Iuhi.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $8Iuhi.default).isString(path) && cookie.push('path=' + path);
        (0, $8Iuhi.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};

});

parcelRegister("jMeQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65e0305d473595b$export$2e2bcd8739ae039; });

var $dHddK = parcelRequire("dHddK");

var $6iYkB = parcelRequire("6iYkB");
'use strict';
function $e65e0305d473595b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeUrl = !(0, $dHddK.default)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $6iYkB.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("dHddK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f898bdbc2718f39$export$2e2bcd8739ae039; });
'use strict';
function $9f898bdbc2718f39$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("6iYkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4973390dd0fafb83$export$2e2bcd8739ae039; });
'use strict';
function $4973390dd0fafb83$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("4SkkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38cbfa4ed463298e$export$2e2bcd8739ae039; });

var $cgG2i = parcelRequire("cgG2i");

var $8Iuhi = parcelRequire("8Iuhi");

var $irFHt = parcelRequire("irFHt");
'use strict';
var $38cbfa4ed463298e$var$headersToObject = function(thing) {
    return thing instanceof (0, $irFHt.default) ? (0, $cgG2i._)({}, thing) : thing;
};
function $38cbfa4ed463298e$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $8Iuhi.default).isPlainObject(target) && (0, $8Iuhi.default).isPlainObject(source)) return (0, $8Iuhi.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8Iuhi.default).isPlainObject(source)) return (0, $8Iuhi.default).merge({}, source);
        else if ((0, $8Iuhi.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $8Iuhi.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $8Iuhi.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8Iuhi.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8Iuhi.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8Iuhi.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($38cbfa4ed463298e$var$headersToObject(a), $38cbfa4ed463298e$var$headersToObject(b), prop, true);
        }
    };
    (0, $8Iuhi.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $8Iuhi.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("9dcpX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b4ef5d58556486c$export$2e2bcd8739ae039; });

var $hWZw8 = parcelRequire("hWZw8");

var $cgG2i = parcelRequire("cgG2i");

var $hiGMu = parcelRequire("hiGMu");

var $bN2zx = parcelRequire("bN2zx");

var $78NO5 = parcelRequire("78NO5");

var $eJDpD = parcelRequire("eJDpD");

var $jZDmV = parcelRequire("jZDmV");

var $8Iuhi = parcelRequire("8Iuhi");

var $7Xdj3 = parcelRequire("7Xdj3");

var $3ygye = parcelRequire("3ygye");

var $9oLRO = parcelRequire("9oLRO");

var $irFHt = parcelRequire("irFHt");

var $jZJFK = parcelRequire("jZJFK");

var $jRPqc = parcelRequire("jRPqc");

var $3gU6d = parcelRequire("3gU6d");
var $6b4ef5d58556486c$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
var $6b4ef5d58556486c$var$isReadableStreamSupported = $6b4ef5d58556486c$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
var $6b4ef5d58556486c$var$encodeText = $6b4ef5d58556486c$var$isFetchSupported && (typeof TextEncoder === 'function' ? function(encoder) {
    return function(str) {
        return encoder.encode(str);
    };
}(new TextEncoder()) : /*#__PURE__*/ function() {
    var _ref = (0, $hWZw8._)(function(str) {
        var _;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Uint8Array.bind;
                    return [
                        4,
                        new Response(str).arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function(str) {
        return _ref.apply(this, arguments);
    };
}());
var $6b4ef5d58556486c$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $78NO5._)(args));
    } catch (e) {
        return false;
    }
};
var $6b4ef5d58556486c$var$supportsRequestStream = $6b4ef5d58556486c$var$isReadableStreamSupported && $6b4ef5d58556486c$var$test(function() {
    var duplexAccessed = false;
    var hasContentType = new Request((0, $jZDmV.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
var $6b4ef5d58556486c$var$DEFAULT_CHUNK_SIZE = 65536;
var $6b4ef5d58556486c$var$supportsResponseStream = $6b4ef5d58556486c$var$isReadableStreamSupported && $6b4ef5d58556486c$var$test(function() {
    return (0, $8Iuhi.default).isReadableStream(new Response('').body);
});
var $6b4ef5d58556486c$var$resolvers = {
    stream: $6b4ef5d58556486c$var$supportsResponseStream && function(res) {
        return res.body;
    }
};
$6b4ef5d58556486c$var$isFetchSupported && function(res) {
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach(function(type) {
        !$6b4ef5d58556486c$var$resolvers[type] && ($6b4ef5d58556486c$var$resolvers[type] = (0, $8Iuhi.default).isFunction(res[type]) ? function(res) {
            return res[type]();
        } : function(_, config) {
            throw new (0, $7Xdj3.default)("Response type '".concat(type, "' is not supported"), (0, $7Xdj3.default).ERR_NOT_SUPPORT, config);
        });
    });
}(new Response);
var $6b4ef5d58556486c$var$getBodyLength = /*#__PURE__*/ function() {
    var _ref = (0, $hWZw8._)(function(body) {
        var _request;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (body == null) return [
                        2,
                        0
                    ];
                    if ((0, $8Iuhi.default).isBlob(body)) return [
                        2,
                        body.size
                    ];
                    if (!(0, $8Iuhi.default).isSpecCompliantForm(body)) return [
                        3,
                        2
                    ];
                    _request = new Request((0, $jZDmV.default).origin, {
                        method: 'POST',
                        body: body
                    });
                    return [
                        4,
                        _request.arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 2:
                    if ((0, $8Iuhi.default).isArrayBufferView(body) || (0, $8Iuhi.default).isArrayBuffer(body)) return [
                        2,
                        body.byteLength
                    ];
                    if ((0, $8Iuhi.default).isURLSearchParams(body)) body = body + '';
                    if (!(0, $8Iuhi.default).isString(body)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $6b4ef5d58556486c$var$encodeText(body)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBodyLength(body) {
        return _ref.apply(this, arguments);
    };
}();
var $6b4ef5d58556486c$var$resolveBodyLength = /*#__PURE__*/ function() {
    var _ref = (0, $hWZw8._)(function(headers, body) {
        var length;
        return (0, $eJDpD.__generator)(this, function(_state) {
            length = (0, $8Iuhi.default).toFiniteNumber(headers.getContentLength());
            return [
                2,
                length == null ? $6b4ef5d58556486c$var$getBodyLength(body) : length
            ];
        });
    });
    return function resolveBodyLength(headers, body) {
        return _ref.apply(this, arguments);
    };
}();
var $6b4ef5d58556486c$export$2e2bcd8739ae039 = $6b4ef5d58556486c$var$isFetchSupported && /*#__PURE__*/ function() {
    var _ref = (0, $hWZw8._)(function(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveConfig = (0, $jRPqc.default)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                    composedSignal = (0, $3ygye.default)([
                        signal,
                        cancelToken && cancelToken.toAbortSignal()
                    ], timeout);
                    unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                        composedSignal.unsubscribe();
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _tmp = onUploadProgress && $6b4ef5d58556486c$var$supportsRequestStream && method !== 'get' && method !== 'head';
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $6b4ef5d58556486c$var$resolveBodyLength(headers, data)
                    ];
                case 2:
                    _tmp = (requestContentLength = _state.sent()) !== 0;
                    _state.label = 3;
                case 3:
                    if (_tmp) {
                        _request = new Request(url, {
                            method: 'POST',
                            body: data,
                            duplex: "half"
                        });
                        ;
                        if ((0, $8Iuhi.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                        if (_request.body) {
                            _progressEventDecorator = (0, $bN2zx._)((0, $jZJFK.progressEventDecorator)(requestContentLength, (0, $jZJFK.progressEventReducer)((0, $jZJFK.asyncDecorator)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                            data = (0, $9oLRO.trackStream)(_request.body, $6b4ef5d58556486c$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                        }
                    }
                    if (!(0, $8Iuhi.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                    // Cloudflare Workers throws when credentials are defined
                    // see https://github.com/cloudflare/workerd/issues/902
                    isCredentialsSupported = "credentials" in Request.prototype;
                    request = new Request(url, (0, $hiGMu._)((0, $cgG2i._)({}, fetchOptions), {
                        signal: composedSignal,
                        method: method.toUpperCase(),
                        headers: headers.normalize().toJSON(),
                        body: data,
                        duplex: "half",
                        credentials: isCredentialsSupported ? withCredentials : undefined
                    }));
                    return [
                        4,
                        fetch(request)
                    ];
                case 4:
                    response = _state.sent();
                    isStreamResponse = $6b4ef5d58556486c$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                    if ($6b4ef5d58556486c$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                        options = {};
                        [
                            'status',
                            'statusText',
                            'headers'
                        ].forEach(function(prop) {
                            options[prop] = response[prop];
                        });
                        responseContentLength = (0, $8Iuhi.default).toFiniteNumber(response.headers.get('content-length'));
                        _ref = (0, $bN2zx._)(onDownloadProgress && (0, $jZJFK.progressEventDecorator)(responseContentLength, (0, $jZJFK.progressEventReducer)((0, $jZJFK.asyncDecorator)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                        response = new Response((0, $9oLRO.trackStream)(response.body, $6b4ef5d58556486c$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                            flush1 && flush1();
                            unsubscribe && unsubscribe();
                        }), options);
                    }
                    responseType = responseType || 'text';
                    return [
                        4,
                        $6b4ef5d58556486c$var$resolvers[(0, $8Iuhi.default).findKey($6b4ef5d58556486c$var$resolvers, responseType) || 'text'](response, config)
                    ];
                case 5:
                    responseData = _state.sent();
                    !isStreamResponse && unsubscribe && unsubscribe();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, $3gU6d.default)(resolve, reject, {
                                data: responseData,
                                headers: (0, $irFHt.default).from(response.headers),
                                status: response.status,
                                statusText: response.statusText,
                                config: config,
                                request: request
                            });
                        })
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    err = _state.sent();
                    unsubscribe && unsubscribe();
                    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $7Xdj3.default)('Network Error', (0, $7Xdj3.default).ERR_NETWORK, config, request), {
                        cause: err.cause || err
                    });
                    throw (0, $7Xdj3.default).from(err, err && err.code, config, request);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("3ygye", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $296162c7e04a67d9$export$2e2bcd8739ae039; });

var $k68rj = parcelRequire("k68rj");

var $7Xdj3 = parcelRequire("7Xdj3");

var $8Iuhi = parcelRequire("8Iuhi");
var $296162c7e04a67d9$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $7Xdj3.default) ? err : new (0, $k68rj.default)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $7Xdj3.default)("timeout ".concat(timeout, " of ms exceeded"), (0, $7Xdj3.default).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener('abort', onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $8Iuhi.default).asap(unsubscribe);
        };
        return signal;
    }
};
var $296162c7e04a67d9$export$2e2bcd8739ae039 = $296162c7e04a67d9$var$composeSignals;

});

parcelRegister("9oLRO", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $6d7b7c57ca113316$export$b0119225647bd83; });

var $17Kdm = parcelRequire("17Kdm");

var $lCalz = parcelRequire("lCalz");

var $hWZw8 = parcelRequire("hWZw8");

var $ak1bw = parcelRequire("ak1bw");

var $cxibG = parcelRequire("cxibG");

var $eJDpD = parcelRequire("eJDpD");

var $eJDpD = parcelRequire("eJDpD");
var $6d7b7c57ca113316$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $eJDpD.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $6d7b7c57ca113316$export$f9f241124ee3198e = /*#__PURE__*/ function() {
    var _ref = (0, $cxibG._)(function(iterable, chunkSize) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $lCalz._)($6d7b7c57ca113316$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $ak1bw._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $eJDpD.__values)((0, $17Kdm._)((0, $lCalz._)($6d7b7c57ca113316$export$71b051935044bd5d(chunk, chunkSize)), (0, $ak1bw._)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $ak1bw._)(_iterator["return"]())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize) {
        return _ref.apply(this, arguments);
    };
}();
var $6d7b7c57ca113316$var$readStream = /*#__PURE__*/ function() {
    var _ref = (0, $cxibG._)(function(stream) {
        var reader, _ref, done, value;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $eJDpD.__values)((0, $17Kdm._)((0, $lCalz._)(stream), (0, $ak1bw._)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $ak1bw._)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $ak1bw._)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function readStream(stream) {
        return _ref.apply(this, arguments);
    };
}();
var $6d7b7c57ca113316$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $6d7b7c57ca113316$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, $hWZw8._)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $eJDpD.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator["return"]();
        }
    }, {
        highWaterMark: 2
    });
};

});
parcelRegister("17Kdm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d1a4b262346b6a9$export$71511d61b312f219; });
function $0d1a4b262346b6a9$export$71511d61b312f219(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        return pump("return", value);
    };
    return iter;
}

});

parcelRegister("lCalz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fbc52c3e5f8358e5$export$71511d61b312f219; });
function $fbc52c3e5f8358e5$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $fbc52c3e5f8358e5$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $fbc52c3e5f8358e5$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $fbc52c3e5f8358e5$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $fbc52c3e5f8358e5$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $fbc52c3e5f8358e5$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("ak1bw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $783cb0e764b6790e$export$71511d61b312f219; });

var $iVGpi = parcelRequire("iVGpi");
function $783cb0e764b6790e$export$71511d61b312f219(value) {
    return new (0, $iVGpi._)(value);
}

});
parcelRegister("iVGpi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dc7e720027f84533$export$71511d61b312f219; });
function $dc7e720027f84533$export$71511d61b312f219(value) {
    this.wrapped = value;
}

});


parcelRegister("cxibG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9206acc05a27e68a$export$71511d61b312f219; });

var $2YzQY = parcelRequire("2YzQY");
function $9206acc05a27e68a$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $2YzQY._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("2YzQY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $22acff157a48721c$export$71511d61b312f219; });

var $iVGpi = parcelRequire("iVGpi");
function $22acff157a48721c$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $iVGpi._);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $22acff157a48721c$export$71511d61b312f219.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$22acff157a48721c$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$22acff157a48721c$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$22acff157a48721c$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});






parcelRegister("hnRRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca7e5cbf6a562b48$export$2e2bcd8739ae039; });

var $7tffA = parcelRequire("7tffA");

var $1JhGV = parcelRequire("1JhGV");

var $7Xdj3 = parcelRequire("7Xdj3");
'use strict';
var $ca7e5cbf6a562b48$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $ca7e5cbf6a562b48$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $7tffA._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $ca7e5cbf6a562b48$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $ca7e5cbf6a562b48$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $1JhGV.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $7Xdj3.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $7Xdj3.default).ERR_DEPRECATED);
        if (version && !$ca7e5cbf6a562b48$var$deprecatedWarnings[opt]) {
            $ca7e5cbf6a562b48$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$ca7e5cbf6a562b48$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $ca7e5cbf6a562b48$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $7tffA._)(options)) !== 'object') throw new (0, $7Xdj3.default)('options must be an object', (0, $7Xdj3.default).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $7Xdj3.default)('option ' + opt + ' must be ' + result, (0, $7Xdj3.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $7Xdj3.default)('Unknown option ' + opt, (0, $7Xdj3.default).ERR_BAD_OPTION);
    }
}
var $ca7e5cbf6a562b48$export$2e2bcd8739ae039 = {
    assertOptions: $ca7e5cbf6a562b48$var$assertOptions,
    validators: $ca7e5cbf6a562b48$var$validators
};

});
parcelRegister("1JhGV", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $1427b787fbd2a606$export$a4ad2735b021c132; });
var $1427b787fbd2a606$export$a4ad2735b021c132 = "1.8.2";

});



parcelRegister("9oh0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d638c75d5ee92be$export$2e2bcd8739ae039; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $k68rj = parcelRequire("k68rj");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $6d638c75d5ee92be$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $3CDbU._)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $k68rj.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $jyA4z._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $6d638c75d5ee92be$export$2e2bcd8739ae039 = $6d638c75d5ee92be$var$CancelToken;

});

parcelRegister("c9DQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d953b02abee7b62$export$2e2bcd8739ae039; });
'use strict';
function $8d953b02abee7b62$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("fj26T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b24a446b8b496f5b$export$2e2bcd8739ae039; });

var $8Iuhi = parcelRequire("8Iuhi");
'use strict';
function $b24a446b8b496f5b$export$2e2bcd8739ae039(payload) {
    return (0, $8Iuhi.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("2wp1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d61fc8331b11469$export$2e2bcd8739ae039; });

var $bN2zx = parcelRequire("bN2zx");
var $1d61fc8331b11469$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($1d61fc8331b11469$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $bN2zx._)(param, 2), key = _param[0], value = _param[1];
    $1d61fc8331b11469$var$HttpStatusCode[value] = key;
});
var $1d61fc8331b11469$export$2e2bcd8739ae039 = $1d61fc8331b11469$var$HttpStatusCode;

});



parcelRegister("5m1WU", function(module, exports) {

$parcel$export(module.exports, "SedestralMachine", function () { return $8e0eaf2a4906244a$export$3241e4b560eb63f6; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $c8CEu = parcelRequire("c8CEu");

var $kVeAF = parcelRequire("kVeAF");
var $8e0eaf2a4906244a$export$3241e4b560eb63f6 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralMachine() {
        (0, $3CDbU._)(this, SedestralMachine);
    }
    (0, $jyA4z._)(SedestralMachine, null, [
        {
            key: "dispose",
            value: function dispose() {
                var _this = this;
                this.listeners.forEach(function(value) {
                    _this.removeListener(value);
                });
                this.resizeObserver.disconnect();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.listeners = [];
                        _this.outsideClickListeners = [];
                        if (_this.log) _this.setInterval(function() {
                            console.log("listeners " + _this.listeners.length);
                        }, 3000);
                        _this.resizeObserver = new ResizeObserver(function(entries) {
                            window.requestAnimationFrame(function() {
                                if (!Array.isArray(entries) || !entries.length) return;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        var entry = _step.value;
                                        try {
                                            for(var _iterator1 = entry.target['resizeFunctions'][Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                var f = _step1.value;
                                                f(entry.contentRect);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                                    _iterator1["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            });
                        });
                        _this.addListener(window, "keydown", function(e) {
                            var nextIndex = e.code == "ArrowDown" ? 1 : e.code == "ArrowUp" ? -1 : 0;
                            if (nextIndex != 0) {
                                var focusedInput = _this.inputs.find(function(value) {
                                    return value.isFocus();
                                });
                                if (focusedInput) {
                                    var nextInput = _this.inputs[_this.inputs.indexOf(focusedInput) + nextIndex];
                                    if (nextInput) nextInput.focus();
                                }
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setTimeout",
            value: /**
     * timeout/interval
     */ function setTimeout1(func, time) {
                return setTimeout(function() {
                    func();
                }, time);
            }
        },
        {
            key: "setInterval",
            value: function setInterval1(func, time) {
                return setInterval(function() {
                    func();
                }, time);
            }
        },
        {
            key: "removeListener",
            value: /**
     * listeners
     */ function removeListener(listener) {
                if (listener == undefined) return;
                listener.element.removeEventListener(listener.name, listener.callback, listener.options);
                var index = this.listeners.indexOf(listener);
                if (index >= 0) this.listeners.splice(index, 1);
                var outsideClickIndex = this.outsideClickListeners.indexOf(listener);
                if (outsideClickIndex >= 0) this.outsideClickListeners.splice(outsideClickIndex, 1);
            }
        },
        {
            key: "addListener",
            value: function addListener(element, name, callback, options) {
                element.addEventListener(name, callback, options);
                var listener = new (0, $c8CEu.MachineListener)(element, name, callback, options);
                this.listeners.push(listener);
                return listener;
            }
        },
        {
            key: "addHotKeyListener",
            value: function addHotKeyListener(component, keys, func) {
                var existingKey = this.hotkeyListeners.find(function(value) {
                    return value.hotkeys == keys && value.element == component.getHTMLElement();
                });
                if (!existingKey) {
                    existingKey = {
                        hotkeys: keys,
                        element: component.getHTMLElement(),
                        entries: []
                    };
                    this.hotkeyListeners.push(existingKey);
                    var map = {};
                    map[keys] = function(event) {
                        existingKey.entries.forEach(function(value) {
                            return value["function"](event);
                        });
                    };
                    var handler = (0, $kVeAF.createKeybindingsHandler)(map);
                    component.getHTMLElement().addEventListener("keydown", handler);
                }
                existingKey.entries.push({
                    "function": function(e) {
                        return func(e);
                    }
                });
                return existingKey;
            }
        },
        {
            key: "deleteHotKeyListener",
            value: function deleteHotKeyListener(component, keys) {
                var existingKey = this.hotkeyListeners.find(function(value) {
                    return value.hotkeys == keys && value.element == component.getHTMLElement();
                });
                if (existingKey) this.hotkeyListeners.splice(this.hotkeyListeners.indexOf(existingKey), 1);
            }
        },
        {
            key: "addOutsideClickListener",
            value: function addOutsideClickListener(listener, component) {
                listener['component'] = component;
                this.outsideClickListeners.push(listener);
            }
        },
        {
            key: "wait",
            value: /**
     * delay
     */ function wait(func, time) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            SedestralMachine.promise(function(end) {
                                var promise = SedestralMachine.promise(/*#__PURE__*/ function() {
                                    var _ref = (0, $hWZw8._)(function(resolve) {
                                        var result;
                                        return (0, $eJDpD.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    setTimeout(function() {
                                                        resolve(-1);
                                                    }, time);
                                                    return [
                                                        4,
                                                        func()
                                                    ];
                                                case 1:
                                                    result = _state.sent();
                                                    resolve(result);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(resolve) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                promise.then(function(data) {
                                    end(data);
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "delay",
            value: function delay(asyncFunc, minimumTime) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var result, run;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = undefined;
                                run = /*#__PURE__*/ function() {
                                    var _ref = (0, $hWZw8._)(function() {
                                        return (0, $eJDpD.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        asyncFunc()
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        result = _state.sent()
                                                    ];
                                            }
                                        });
                                    });
                                    return function run() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    4,
                                    Promise.all([
                                        run(),
                                        _this.sleep(minimumTime)
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sleep",
            value: function sleep(ms) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    SedestralMachine.promise(function(resolve) {
                                        setTimeout(function() {
                                            resolve();
                                        }, ms);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "promiseCancelable",
            value: /**
     * promise
     */ function promiseCancelable(executor) {
                var rejectFn;
                var wrappedPromise = new Promise(function(resolve, reject) {
                    rejectFn = reject;
                    Promise.resolve(new Promise(executor)).then(resolve)["catch"](reject);
                });
                wrappedPromise['cancel'] = function() {
                    rejectFn({
                        canceled: true
                    });
                };
                return wrappedPromise;
            }
        },
        {
            key: "promise",
            value: function promise(executor, displayRequired, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var promise, savedPromise;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        promise = _this.promiseCancelable(executor);
                        savedPromise = {
                            component: component,
                            promise: promise,
                            displayRequired: displayRequired
                        };
                        _this.promises.push(savedPromise);
                        promise.then(function() {
                            _this.promises.splice(_this.promises.indexOf(savedPromise), 1);
                        });
                        if (component) component.onRemove(function() {
                            SedestralMachine.requestFrame()(function() {
                                if (_this.promises.indexOf(savedPromise) >= 0) {
                                    savedPromise.promise['cancel']();
                                    _this.promises.splice(_this.promises.indexOf(savedPromise), 1);
                                }
                            });
                        });
                        return [
                            2,
                            promise
                        ];
                    });
                })();
            }
        },
        {
            key: "requestFrame",
            value: /**
     * frame
     */ function requestFrame() {
                // @ts-ignore
                var raf = window.requestAnimationFrame || window['mozRequestAnimationFrame'] || window.webkitRequestAnimationFrame || function(fn) {
                    return window.setTimeout(fn, 20);
                };
                return function(fn) {
                    return raf(fn);
                };
            }
        },
        {
            key: "cancelFrame",
            value: function cancelFrame() {
                // @ts-ignore
                var cancel = window.cancelAnimationFrame || window['mozCancelAnimationFrame'] || window.webkitCancelAnimationFrame || window.clearTimeout;
                return function(id) {
                    return cancel(id);
                };
            }
        }
    ]);
    return SedestralMachine;
}();
$8e0eaf2a4906244a$export$3241e4b560eb63f6.log = false;
$8e0eaf2a4906244a$export$3241e4b560eb63f6.listeners = [];
$8e0eaf2a4906244a$export$3241e4b560eb63f6.inputs = [];
$8e0eaf2a4906244a$export$3241e4b560eb63f6.hotkeyListeners = [];
$8e0eaf2a4906244a$export$3241e4b560eb63f6.outsideClickListeners = [];
$8e0eaf2a4906244a$export$3241e4b560eb63f6.promises = [];

});
parcelRegister("c8CEu", function(module, exports) {

$parcel$export(module.exports, "MachineListener", function () { return $60a222b6fdc80be4$export$884d1a73c2ef5109; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $60a222b6fdc80be4$export$884d1a73c2ef5109 = /*#__PURE__*/ function() {
    "use strict";
    function MachineListener(element, name, callback, options) {
        (0, $3CDbU._)(this, MachineListener);
        this._element = element;
        this._name = name;
        this._callback = callback;
        this._options = options;
    }
    (0, $jyA4z._)(MachineListener, [
        {
            key: "element",
            get: function get() {
                return this._element;
            },
            set: function set(value) {
                this._element = value;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._name;
            },
            set: function set(value) {
                this._name = value;
            }
        },
        {
            key: "callback",
            get: function get() {
                return this._callback;
            },
            set: function set(value) {
                this._callback = value;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._options;
            },
            set: function set(value) {
                this._options = value;
            }
        }
    ]);
    return MachineListener;
}();

});

parcelRegister("kVeAF", function(module, exports) {

$parcel$export(module.exports, "createKeybindingsHandler", function () { return $f3b472dbfc2d1ef3$export$a3db0ee43d16bb47; });

var $7tffA = parcelRequire("7tffA");
var $f3b472dbfc2d1ef3$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $f3b472dbfc2d1ef3$var$e = "object" == (typeof navigator === "undefined" ? "undefined" : (0, $7tffA._)(navigator)) ? navigator.platform : "", $f3b472dbfc2d1ef3$var$n = /Mac|iPod|iPhone|iPad/.test($f3b472dbfc2d1ef3$var$e), $f3b472dbfc2d1ef3$var$o = $f3b472dbfc2d1ef3$var$n ? "Meta" : "Control", $f3b472dbfc2d1ef3$var$r = "Win32" === $f3b472dbfc2d1ef3$var$e ? [
    "Control",
    "Alt"
] : $f3b472dbfc2d1ef3$var$n ? [
    "Alt"
] : [];
function $f3b472dbfc2d1ef3$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $f3b472dbfc2d1ef3$var$r.includes(e) && t.getModifierState("AltGraph"));
}
function $f3b472dbfc2d1ef3$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop(), r = n.match(/^\((.+)\)$/);
        return r && (n = new RegExp("^" + r[1] + "$")), [
            e = e.map(function(t) {
                return "$mod" === t ? $f3b472dbfc2d1ef3$var$o : t;
            }),
            n
        ];
    });
}
function $f3b472dbfc2d1ef3$export$5eab49042bbaa75(e, n) {
    var o = n[0], r = n[1];
    return !((r instanceof RegExp ? !r.test(e.key) && !r.test(e.code) : r.toUpperCase() !== e.key.toUpperCase() && r !== e.code) || o.find(function(t) {
        return !$f3b472dbfc2d1ef3$var$i(e, t);
    }) || $f3b472dbfc2d1ef3$var$t.find(function(t) {
        return !o.includes(t) && r !== t && $f3b472dbfc2d1ef3$var$i(e, t);
    }));
}
function $f3b472dbfc2d1ef3$export$a3db0ee43d16bb47(t, e) {
    var n;
    void 0 === e && (e = {});
    var o = null != (n = e.timeout) ? n : 1e3, r = Object.keys(t).map(function(e) {
        return [
            $f3b472dbfc2d1ef3$export$d0b30d424c95c5e9(e),
            t[e]
        ];
    }), c = new Map, f = null;
    return function(t) {
        t instanceof KeyboardEvent && (r.forEach(function(e) {
            var n = e[0], o = e[1], r = c.get(n) || n;
            $f3b472dbfc2d1ef3$export$5eab49042bbaa75(t, r[0]) ? r.length > 1 ? c.set(n, r.slice(1)) : (c["delete"](n), o(t)) : $f3b472dbfc2d1ef3$var$i(t, t.key) || c["delete"](n);
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $f3b472dbfc2d1ef3$export$6fc42dca60e28416(t, e, n) {
    var o = void 0 === n ? {} : n, r = o.event, i = void 0 === r ? "keydown" : r, a = o.capture, u = $f3b472dbfc2d1ef3$export$a3db0ee43d16bb47(e, {
        timeout: o.timeout
    });
    return t.addEventListener(i, u, a), function() {
        t.removeEventListener(i, u, a);
    };
}

});


parcelRegister("kk7Zr", function(module, exports) {

$parcel$export(module.exports, "NetworkHeaders", function () { return $55bdf6253c09a9ec$export$6c0c30308e42bb4b; });
var $55bdf6253c09a9ec$export$6c0c30308e42bb4b = /*#__PURE__*/ function(NetworkHeaders) {
    NetworkHeaders["SESSION_HEADER"] = "x-sedestral-session";
    NetworkHeaders["SITE_HEADER"] = "site";
    NetworkHeaders["TF_TRANSACTION_ID_HEADER"] = "tf-transaction-id";
    NetworkHeaders["TF_TRANSACTION_CODE_HEADER"] = "tf-transaction-code";
    NetworkHeaders["TF_TRANSACTION_METHOD_HEADER"] = "tf-transaction-method";
    NetworkHeaders["TF_TRANSACTION_DATA_HEADER"] = "tf-transaction-data";
    NetworkHeaders["ALERT_HEADER"] = "alert";
    return NetworkHeaders;
}({});

});

parcelRegister("dNI0C", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $b2c6a935ede9fff1$export$d4e71bc0b80dc0fb; });
var $b2c6a935ede9fff1$export$d4e71bc0b80dc0fb = /*#__PURE__*/ function(ErrorCode) {
    ErrorCode[ErrorCode["NO_RECIPIENT"] = 0] = "NO_RECIPIENT";
    ErrorCode[ErrorCode["NO_SITE_CHANEl"] = 1] = "NO_SITE_CHANEl";
    ErrorCode[ErrorCode["NO_SITE"] = 2] = "NO_SITE";
    ErrorCode[ErrorCode["RECIPIENT_FULL"] = 3] = "RECIPIENT_FULL";
    ErrorCode[ErrorCode["MAIL_FORMAT"] = 4] = "MAIL_FORMAT";
    ErrorCode[ErrorCode["MAIL_RECEIVE"] = 5] = "MAIL_RECEIVE";
    ErrorCode[ErrorCode["MAIL_DOMAIN"] = 6] = "MAIL_DOMAIN";
    ErrorCode[ErrorCode["MAIL"] = 7] = "MAIL";
    ErrorCode[ErrorCode["EMAIL_EXIST"] = 8] = "EMAIL_EXIST";
    ErrorCode[ErrorCode["EMAIL_BLACKLIST"] = 9] = "EMAIL_BLACKLIST";
    ErrorCode[ErrorCode["EMAIL_FULL"] = 10] = "EMAIL_FULL";
    ErrorCode[ErrorCode["EMAIL_ALIAS_EXIST"] = 11] = "EMAIL_ALIAS_EXIST";
    ErrorCode[ErrorCode["EMAIL_ALIAS"] = 12] = "EMAIL_ALIAS";
    ErrorCode[ErrorCode["URL_FORMAT"] = 13] = "URL_FORMAT";
    ErrorCode[ErrorCode["IMAGE_FORMAT"] = 14] = "IMAGE_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FORMAT"] = 15] = "DOMAIN_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FULL"] = 16] = "DOMAIN_FULL";
    ErrorCode[ErrorCode["WINDOW_EXPIRED"] = 17] = "WINDOW_EXPIRED";
    ErrorCode[ErrorCode["SITE_CHANNEL_NO_FOUND"] = 18] = "SITE_CHANNEL_NO_FOUND";
    ErrorCode[ErrorCode["CHANEl_TYPE_NO_FOUND"] = 19] = "CHANEl_TYPE_NO_FOUND";
    ErrorCode[ErrorCode["CONTACT_NO_FOUND"] = 20] = "CONTACT_NO_FOUND";
    ErrorCode[ErrorCode["SITE_CHANNEL_PERMISSION"] = 21] = "SITE_CHANNEL_PERMISSION";
    ErrorCode[ErrorCode["NAME_EXIST"] = 22] = "NAME_EXIST";
    ErrorCode[ErrorCode["PERMISSION"] = 23] = "PERMISSION";
    ErrorCode[ErrorCode["NULLITY"] = 24] = "NULLITY";
    ErrorCode[ErrorCode["SIZE_MAX"] = 25] = "SIZE_MAX";
    ErrorCode[ErrorCode["SIZE_MIN"] = 26] = "SIZE_MIN";
    ErrorCode[ErrorCode["VERIFICATION"] = 27] = "VERIFICATION";
    ErrorCode[ErrorCode["EXCEPTION"] = 28] = "EXCEPTION";
    ErrorCode[ErrorCode["CACHE"] = 29] = "CACHE";
    ErrorCode[ErrorCode["SURFACE_CONTROL"] = 30] = "SURFACE_CONTROL";
    /*
    {"errorCode":"SURFACE_CONTROL","errorType":"FUNCTIONAL","subErrors":[{"field":"email","rejectedValue":"frrfrffrrfrfrf","message":"doit être une adresse électronique syntaxiquement correcte"},{"field":"password","rejectedValue":"uy","message":"la longueur doit être comprise entre 4 et 2147483647"},{"field":"name","rejectedValue":"  ","message":"ne doit pas être vide"}]}
     */ ErrorCode[ErrorCode["TWO_FACTOR_TECHNICAL"] = 31] = "TWO_FACTOR_TECHNICAL";
    ErrorCode[ErrorCode["TWO_FACTOR_REQUIRED"] = 32] = "TWO_FACTOR_REQUIRED";
    ErrorCode[ErrorCode["TWO_FACTOR_TRANSACTION_NO_FOUND"] = 33] = "TWO_FACTOR_TRANSACTION_NO_FOUND";
    ErrorCode[ErrorCode["TWO_FACTOR_EXPIRE_CODE"] = 34] = "TWO_FACTOR_EXPIRE_CODE";
    ErrorCode[ErrorCode["TWO_FACTOR_ATTEMPT"] = 35] = "TWO_FACTOR_ATTEMPT";
    ErrorCode[ErrorCode["TWO_FACTOR_BAND_WIDTH_LIMIT"] = 36] = "TWO_FACTOR_BAND_WIDTH_LIMIT";
    ErrorCode[ErrorCode["TWO_FACTOR_CODE_INCORRECT"] = 37] = "TWO_FACTOR_CODE_INCORRECT";
    ErrorCode[ErrorCode["TWO_FACTOR_METHOD_UNAUTHORIZED"] = 38] = "TWO_FACTOR_METHOD_UNAUTHORIZED";
    ErrorCode[ErrorCode["TWO_FACTOR_CREATE_INVALID_CODE"] = 39] = "TWO_FACTOR_CREATE_INVALID_CODE";
    ErrorCode[ErrorCode["CAPTCHA_INCORRECT"] = 40] = "CAPTCHA_INCORRECT";
    ErrorCode[ErrorCode["HOST_INCORRECT"] = 41] = "HOST_INCORRECT";
    ErrorCode[ErrorCode["HOST_EXIST"] = 42] = "HOST_EXIST";
    ErrorCode[ErrorCode["K8S_DOMAIN_ERROR"] = 43] = "K8S_DOMAIN_ERROR";
    ErrorCode[ErrorCode["PARTNER_NO_FOUND"] = 44] = "PARTNER_NO_FOUND";
    ErrorCode[ErrorCode["INVALID_LANGUAGE"] = 45] = "INVALID_LANGUAGE";
    ErrorCode[ErrorCode["ROUTE_EXIST"] = 46] = "ROUTE_EXIST";
    ErrorCode[ErrorCode["DATE_RANGE"] = 47] = "DATE_RANGE";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COMBINATION"] = 48] = "PUBLISHER_ATTACHMENT_COMBINATION";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COUNT"] = 49] = "PUBLISHER_ATTACHMENT_COUNT";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_LINK"] = 50] = "PUBLISHER_ATTACHMENT_LINK";
    ErrorCode[ErrorCode["PASSWORD"] = 51] = "PASSWORD";
    ErrorCode[ErrorCode["PARTICIPANTS_EMPTY"] = 52] = "PARTICIPANTS_EMPTY";
    ErrorCode[ErrorCode["ATTACHMENT_MANDATORY"] = 53] = "ATTACHMENT_MANDATORY";
    ErrorCode[ErrorCode["PUBLISHER_POST_EMPTY"] = 54] = "PUBLISHER_POST_EMPTY";
    ErrorCode[ErrorCode["NO_CONTACT"] = 55] = "NO_CONTACT";
    ErrorCode[ErrorCode["GPT_RETRY_LIMIT"] = 56] = "GPT_RETRY_LIMIT";
    ErrorCode[ErrorCode["PAYMENT_REQUIRED"] = 57] = "PAYMENT_REQUIRED";
    ErrorCode[ErrorCode["BUNDLES_SIZE"] = 58] = "BUNDLES_SIZE";
    ErrorCode[ErrorCode["BUNDLE_OPTION_SIZE"] = 59] = "BUNDLE_OPTION_SIZE";
    ErrorCode[ErrorCode["OFFER_ALREADY_EXISTS"] = 60] = "OFFER_ALREADY_EXISTS";
    ErrorCode[ErrorCode["SITE_COUNT_MAX"] = 61] = "SITE_COUNT_MAX";
    ErrorCode[ErrorCode["PROMOTION_CODE_INVALID"] = 62] = "PROMOTION_CODE_INVALID";
    ErrorCode[ErrorCode["ACTIVE_OFFER_IS_FAILURE_TO_PAY"] = 63] = "ACTIVE_OFFER_IS_FAILURE_TO_PAY";
    ErrorCode[ErrorCode["OFFER_PRODUCTS_EMPTY"] = 64] = "OFFER_PRODUCTS_EMPTY";
    ErrorCode[ErrorCode["OFFER_SAME_OFFER_ACTIVE"] = 65] = "OFFER_SAME_OFFER_ACTIVE";
    ErrorCode[ErrorCode["TASK_IN_PROGRESS"] = 66] = "TASK_IN_PROGRESS";
    ErrorCode[ErrorCode["OFFER_ACTIVE_EXISTS"] = 67] = "OFFER_ACTIVE_EXISTS";
    ErrorCode[ErrorCode["OFFER_CANCELLED_EXPIRED"] = 68] = "OFFER_CANCELLED_EXPIRED";
    ErrorCode[ErrorCode["SUSPENDED"] = 69] = "SUSPENDED";
    ErrorCode[ErrorCode["PHONE_FORMAT"] = 70] = "PHONE_FORMAT";
    ErrorCode[ErrorCode["PARTNER_CONFING_INVALID"] = 71] = "PARTNER_CONFING_INVALID";
    ErrorCode[ErrorCode["PARTNER_CONFING_PERMISSIONS"] = 72] = "PARTNER_CONFING_PERMISSIONS";
    ErrorCode[ErrorCode["COMMUNITY_AUTOPILOT_DAYS_MAX"] = 73] = "COMMUNITY_AUTOPILOT_DAYS_MAX";
    ErrorCode[ErrorCode["TAX_COUNTRY"] = 74] = "TAX_COUNTRY";
    ErrorCode[ErrorCode["TAX_TYPE"] = 75] = "TAX_TYPE";
    ErrorCode[ErrorCode["TAX_VALUE_INVALID"] = 76] = "TAX_VALUE_INVALID";
    ErrorCode[ErrorCode["LOCATION_INVALID"] = 77] = "LOCATION_INVALID";
    ErrorCode[ErrorCode["TOKEN_INVALID"] = 78] = "TOKEN_INVALID";
    ErrorCode[ErrorCode["PAYMENT_PROVIDER_CREATE_SUBSCRIPTION"] = 79] = "PAYMENT_PROVIDER_CREATE_SUBSCRIPTION";
    ErrorCode[ErrorCode["OFFER_QUOTE_EXISTS"] = 80] = "OFFER_QUOTE_EXISTS";
    ErrorCode[ErrorCode["CREATE_ARTICLE_IA_FORM_EMPTY"] = 81] = "CREATE_ARTICLE_IA_FORM_EMPTY";
    ErrorCode[ErrorCode["MAX_LIMIT"] = 82] = "MAX_LIMIT";
    ErrorCode[ErrorCode["FORMAT"] = 83] = "FORMAT";
    return ErrorCode;
}({});

});

parcelRegister("cKMRi", function(module, exports) {

$parcel$export(module.exports, "HttpStatus", function () { return $532de8e8dd2f8fdd$export$2b71909294c66558; });
var $532de8e8dd2f8fdd$export$2b71909294c66558 = /*#__PURE__*/ function(HttpStatus) {
    HttpStatus[HttpStatus["CONTINUE"] = 100] = "CONTINUE";
    HttpStatus[HttpStatus["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    HttpStatus[HttpStatus["PROCESSING"] = 102] = "PROCESSING";
    HttpStatus[HttpStatus["OK"] = 200] = "OK";
    HttpStatus[HttpStatus["CREATED"] = 201] = "CREATED";
    HttpStatus[HttpStatus["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatus[HttpStatus["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HttpStatus[HttpStatus["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatus[HttpStatus["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HttpStatus[HttpStatus["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HttpStatus[HttpStatus["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    HttpStatus[HttpStatus["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    HttpStatus[HttpStatus["IM_USED"] = 226] = "IM_USED";
    HttpStatus[HttpStatus["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpStatus[HttpStatus["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpStatus[HttpStatus["FOUND"] = 302] = "FOUND";
    HttpStatus[HttpStatus["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatus[HttpStatus["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpStatus[HttpStatus["USE_PROXY"] = 305] = "USE_PROXY";
    HttpStatus[HttpStatus["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    HttpStatus[HttpStatus["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpStatus[HttpStatus["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatus[HttpStatus["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpStatus[HttpStatus["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpStatus[HttpStatus["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpStatus[HttpStatus["CONFLICT"] = 409] = "CONFLICT";
    HttpStatus[HttpStatus["GONE"] = 410] = "GONE";
    HttpStatus[HttpStatus["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpStatus[HttpStatus["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HttpStatus[HttpStatus["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HttpStatus[HttpStatus["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpStatus[HttpStatus["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HttpStatus[HttpStatus["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpStatus[HttpStatus["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    HttpStatus[HttpStatus["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HttpStatus[HttpStatus["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HttpStatus[HttpStatus["LOCKED"] = 423] = "LOCKED";
    HttpStatus[HttpStatus["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HttpStatus[HttpStatus["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HttpStatus[HttpStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpStatus[HttpStatus["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpStatus[HttpStatus["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpStatus[HttpStatus["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpStatus[HttpStatus["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpStatus[HttpStatus["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpStatus[HttpStatus["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpStatus[HttpStatus["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpStatus[HttpStatus["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HttpStatus[HttpStatus["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HttpStatus[HttpStatus["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HttpStatus[HttpStatus["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HttpStatus[HttpStatus["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["BANDWIDTH_LIMIT"] = 509] = "BANDWIDTH_LIMIT";
    return HttpStatus;
}({});

});

parcelRegister("co7RM", function(module, exports) {

$parcel$export(module.exports, "ProductType", function () { return $02e751329d812713$export$11b099a658b17995; });
var $02e751329d812713$export$11b099a658b17995 = /*#__PURE__*/ function(ProductType) {
    ProductType[ProductType["SEDESTRAL"] = 1] = "SEDESTRAL";
    ProductType[ProductType["INBOX"] = 2] = "INBOX";
    ProductType[ProductType["PUBLISHER"] = 3] = "PUBLISHER";
    ProductType[ProductType["STATISTICS"] = 4] = "STATISTICS";
    ProductType[ProductType["CONTACTS"] = 5] = "CONTACTS";
    ProductType[ProductType["CHANNELS"] = 6] = "CHANNELS";
    ProductType[ProductType["LIVECHAT"] = 7] = "LIVECHAT";
    ProductType[ProductType["PANEL"] = 8] = "PANEL";
    ProductType[ProductType["GENERAL"] = 9] = "GENERAL";
    ProductType[ProductType["CHAT_BOT"] = 10] = "CHAT_BOT";
    ProductType[ProductType["MAILS"] = 11] = "MAILS";
    ProductType[ProductType["SELL"] = 12] = "SELL";
    ProductType[ProductType["ENGAGEMENT"] = 13] = "ENGAGEMENT";
    ProductType[ProductType["ADVERTISING"] = 14] = "ADVERTISING";
    ProductType[ProductType["MAILLING"] = 15] = "MAILLING";
    ProductType[ProductType["MEDIAS"] = 16] = "MEDIAS";
    ProductType[ProductType["CALENDAR"] = 17] = "CALENDAR";
    ProductType[ProductType["DOCUMENTS"] = 18] = "DOCUMENTS";
    ProductType[ProductType["PRODUCTS"] = 19] = "PRODUCTS";
    ProductType[ProductType["ESTIMATE"] = 20] = "ESTIMATE";
    ProductType[ProductType["CONTACTS_GREY"] = 21] = "CONTACTS_GREY";
    ProductType[ProductType["PUBLISHER_GREY"] = 22] = "PUBLISHER_GREY";
    ProductType[ProductType["INBOX_GREY"] = 23] = "INBOX_GREY";
    ProductType[ProductType["HELPCENTER"] = 24] = "HELPCENTER";
    ProductType[ProductType["WEBSITE"] = 25] = "WEBSITE";
    ProductType[ProductType["CLIENT_SERVICE"] = 26] = "CLIENT_SERVICE";
    ProductType[ProductType["BLOG"] = 27] = "BLOG";
    ProductType[ProductType["MOBILE"] = 28] = "MOBILE";
    ProductType[ProductType["COMMUNITY"] = 29] = "COMMUNITY";
    ProductType[ProductType["ADMIN"] = 30] = "ADMIN";
    return ProductType;
}({});

});

parcelRegister("wYO7b", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $5e2eed5e11a8f8bf$export$e9a269813a6315a4; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $cgG2i = parcelRequire("cgG2i");

var $hiGMu = parcelRequire("hiGMu");

var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $gzN0P = parcelRequire("gzN0P");

var $ghWYO = parcelRequire("ghWYO");

var $bjUFp = parcelRequire("bjUFp");

var $yJnBa = parcelRequire("yJnBa");

var $eQCFs = parcelRequire("eQCFs");

var $7su1w = parcelRequire("7su1w");

var $5Co1u = parcelRequire("5Co1u");

var $co7RM = parcelRequire("co7RM");

var $9IvVr = parcelRequire("9IvVr");
var $5e2eed5e11a8f8bf$export$e9a269813a6315a4 = /*#__PURE__*/ function() {
    "use strict";
    function Resources() {
        (0, $3CDbU._)(this, Resources);
    }
    (0, $jyA4z._)(Resources, null, [
        {
            key: "getCountryCode",
            value: function getCountryCode() {
                return this.languageToCountryMap[this.language] || "fr";
            }
        },
        {
            key: "init",
            value: function init(languagesCandidate, languages) {
                var defaultLanguage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.getDefaultLanguage();
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var selectBestLanguageCandidate;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.languages = languages;
                        selectBestLanguageCandidate = _this.getBestLanguageCandidate(languages, languagesCandidate);
                        _this.setLanguage(selectBestLanguageCandidate);
                        if (!_this.language) _this.setLanguage(defaultLanguage);
                        if (!_this.language) _this.setLanguage(_this.getDefaultLanguage());
                        if ((0, $gzN0P.config).product == "blog") _this.theme((0, $co7RM.ProductType).BLOG) == (0, $bjUFp.AppearanceTheme).LIGHT ? (0, $eQCFs.SedestralInterface).html.removeClass("black") : (0, $eQCFs.SedestralInterface).html.addClass("black");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "loadI18n",
            value: function loadI18n(product) {
                var vendor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $5Co1u.generateVendor)(window.location.origin);
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).httpResources.get(vendor + "languages/" + product + "/" + _this.language + ".json?" + (0, $gzN0P.config).version, {
                                        timeout: 60000
                                    })
                                ];
                            case 1:
                                request = _state.sent();
                                if (_this.words !== undefined) _this.words = _this.mergeI18n(_this.words, request.data);
                                else {
                                    _this.words = request.data;
                                    (0, $3Qm5T.Network).initErrors();
                                    (0, $ghWYO.DateIntervalPickerPurposes).init();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadCountries",
            value: function loadCountries() {
                var vendor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $5Co1u.generateVendor)(window.location.origin);
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).httpResources.get(vendor + "countries/" + _this.language + ".json?" + (0, $gzN0P.config).version, {
                                        timeout: 60000
                                    })
                                ];
                            case 1:
                                request = _state.sent();
                                _this.countries = request.data;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadEmojis",
            value: function loadEmojis() {
                var vendor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $5Co1u.generateVendor)(window.location.origin);
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.emojis != undefined) return [
                                    2,
                                    _this.emojis
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).httpResources.get(vendor + "emojis/emojis.json?" + (0, $gzN0P.config).version)
                                ];
                            case 1:
                                request = _state.sent();
                                _this.emojis = request.data;
                                return [
                                    2,
                                    _this.emojis
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadWorldLanguages",
            value: function loadWorldLanguages() {
                var vendor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $5Co1u.generateVendor)(window.location.origin);
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).httpResources.get(vendor + "languages/names.json?" + (0, $gzN0P.config).version, {
                                        timeout: 60000
                                    })
                                ];
                            case 1:
                                request = _state.sent();
                                _this.worldLanguages = request.data;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "t",
            value: function t(value, words) {
                var values = value.split(".");
                var object = words !== null && words !== void 0 ? words : this.words;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        if (object) object = object[val];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return object !== null && object !== void 0 ? object : value;
            }
        },
        {
            key: "r",
            value: function r(value, replacements) {
                var words = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.words;
                var values = value.split(".");
                var object = words;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        if (typeof object !== "undefined") object = object[val];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var result = typeof object === "undefined" || (typeof object === "undefined" ? "undefined" : (0, $7tffA._)(object)) === "object" ? value : object;
                for(var key in replacements)result = result.replace("${".concat(key, "}"), replacements[key]);
                return result;
            }
        },
        {
            key: "exist",
            value: function exist(value, words) {
                var values = value.split(".");
                var object = words !== null && words !== void 0 ? words : this.words;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        if (object) object = object[val];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return object !== undefined;
            }
        },
        {
            key: "country",
            value: function country(a2) {
                a2 = a2.toLowerCase();
                return this.countries.filter(function(value) {
                    return value['a2'] == a2;
                })[0];
            }
        },
        {
            key: "lang",
            value: function lang(code) {
                code = (0, $7su1w.txtSimpleLang)(code);
                for(var key in this.worldLanguages)if (this.worldLanguages.hasOwnProperty(key)) {
                    if (this.worldLanguages[key].code == code) return this.worldLanguages[key];
                }
            }
        },
        {
            key: "getLanguagesCandidate",
            value: function getLanguagesCandidate() {
                var _this = this;
                return (0, $78NO5._)(new Set(navigator.languages.map(function(language) {
                    return _this.removeRegionLanguage(language);
                })));
            }
        },
        {
            key: "getLanguagesCandidateWidthDefault",
            value: function getLanguagesCandidateWidthDefault(bestLanguageCandidate) {
                return (0, $78NO5._)(new Set([
                    Resources.removeRegionLanguage(bestLanguageCandidate)
                ].concat((0, $78NO5._)(Resources.getLanguagesCandidate())).filter(function(language) {
                    return language !== undefined;
                })));
            }
        },
        {
            key: "getBestLanguageCandidate",
            value: function getBestLanguageCandidate(languages) {
                var languagesCandidate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLanguagesCandidate();
                return languagesCandidate.find(function(language) {
                    return languages.includes(language);
                });
            }
        },
        {
            key: "getDefaultLanguage",
            value: function getDefaultLanguage() {
                return "en";
            }
        },
        {
            key: "setLanguage",
            value: function setLanguage(language) {
                if (this.languages.includes(language)) this.language = language;
            }
        },
        {
            key: "removeRegionLanguage",
            value: function removeRegionLanguage(language) {
                if (language == undefined) return undefined;
                var withoutQuality = language.split(";")[0];
                if (withoutQuality.includes("-")) return withoutQuality.split("-")[0];
                if (withoutQuality.includes("_")) return withoutQuality.split("_")[0];
                return withoutQuality;
            }
        },
        {
            key: "theme",
            value: function theme(productType) {
                var theme = this.realTheme(productType);
                if (theme == (0, $bjUFp.AppearanceTheme).AUTO) {
                    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return (0, $bjUFp.AppearanceTheme).DARK;
                    else return (0, $bjUFp.AppearanceTheme).LIGHT;
                }
                return theme;
            }
        },
        {
            key: "realTheme",
            value: function realTheme(productType) {
                var theme = (0, $yJnBa.SedestralStorage).getItem("".concat((0, $9IvVr.ProductName).toString(productType), "-theme"));
                if (theme == null) return (0, $bjUFp.AppearanceTheme).AUTO;
                return parseInt(theme);
            }
        },
        {
            key: "invertTheme",
            value: function invertTheme(productType, theme) {
                return (theme ? theme : Resources.theme(productType)) == (0, $bjUFp.AppearanceTheme).DARK ? (0, $bjUFp.AppearanceTheme).LIGHT : (0, $bjUFp.AppearanceTheme).DARK;
            }
        },
        {
            key: "setTheme",
            value: function setTheme(productType, theme, silent) {
                (0, $yJnBa.SedestralStorage).setItem("".concat((0, $9IvVr.ProductName).toString(productType), "-theme"), "" + theme);
                if (!silent) this.theme(productType) == (0, $bjUFp.AppearanceTheme).LIGHT ? (0, $eQCFs.SedestralInterface).html.removeClass("black") : (0, $eQCFs.SedestralInterface).html.addClass("black");
            }
        },
        {
            key: "mergeI18n",
            value: function mergeI18n(wordsA, wordsB) {
                return (0, $hiGMu._)((0, $cgG2i._)({}, wordsA, wordsB), {
                    words: (0, $cgG2i._)({}, wordsA.words, wordsB.words),
                    network: (0, $cgG2i._)({}, wordsA.network, wordsB.network),
                    errors: (0, $cgG2i._)({}, wordsA.errors, wordsB.errors),
                    placeholders: (0, $cgG2i._)({}, wordsA.placeholders, wordsB.placeholders),
                    sentences: (0, $cgG2i._)({}, wordsA.sentences, wordsB.sentences),
                    products: (0, $cgG2i._)({}, wordsA.products, wordsB.products),
                    time: (0, $cgG2i._)({}, wordsA.time, wordsB.time)
                });
            }
        }
    ]);
    return Resources;
}();
$5e2eed5e11a8f8bf$export$e9a269813a6315a4.languageToCountryMap = {
    fr: "fr",
    en: "en",
    es: "es",
    it: "it",
    pt: "pt",
    nl: "nl",
    de: "de",
    lb: "lu",
    da: "dk" // Denmark
};

});
parcelRegister("ghWYO", function(module, exports) {

$parcel$export(module.exports, "DateIntervalPickerPurposes", function () { return $aabcff3ffa9e4349$export$c965c81194e437f6; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $wYO7b = parcelRequire("wYO7b");

var $3NRZT = parcelRequire("3NRZT");

var $6hmLA = parcelRequire("6hmLA");

var $alboN = parcelRequire("alboN");
var $aabcff3ffa9e4349$export$c965c81194e437f6 = /*#__PURE__*/ function() {
    "use strict";
    function DateIntervalPickerPurposes() {
        (0, $3CDbU._)(this, DateIntervalPickerPurposes);
    }
    (0, $jyA4z._)(DateIntervalPickerPurposes, null, [
        {
            key: "init",
            value: function init() {
                DateIntervalPickerPurposes.basePurposes = [
                    {
                        value: "today",
                        name: (0, $wYO7b.Resources).t("words.todayCalendar"),
                        show: true
                    },
                    {
                        value: "yesterday",
                        name: (0, $wYO7b.Resources).t("words.yesterday"),
                        show: true
                    },
                    {
                        value: "week",
                        name: (0, $wYO7b.Resources).r("words.lastDays", {
                            count: 7
                        }),
                        show: true
                    },
                    {
                        value: "4week",
                        name: (0, $wYO7b.Resources).r("words.lastWeeks", {
                            count: 4
                        }),
                        show: true
                    },
                    {
                        value: "3month",
                        name: (0, $wYO7b.Resources).r("words.lastMonths", {
                            count: 3
                        }),
                        show: true
                    },
                    {
                        value: "6month",
                        name: (0, $wYO7b.Resources).r("words.lastMonths", {
                            count: 6
                        }),
                        show: true
                    },
                    {
                        value: "12month",
                        name: (0, $wYO7b.Resources).r("words.lastMonths", {
                            count: 12
                        }),
                        show: true
                    }
                ];
                DateIntervalPickerPurposes.comparatorPurposes = [
                    {
                        value: "lastPeriod",
                        name: (0, $wYO7b.Resources).t("words.lastPeriod"),
                        show: true
                    },
                    {
                        value: "lastWeek",
                        name: (0, $wYO7b.Resources).t("words.lastWeek"),
                        show: true
                    },
                    {
                        value: "lastMonth",
                        name: (0, $wYO7b.Resources).t("words.lastMonth"),
                        show: true
                    },
                    {
                        value: "lastTrimester",
                        name: (0, $wYO7b.Resources).t("words.lastTrimester"),
                        show: true
                    },
                    {
                        value: "lastSemester",
                        name: (0, $wYO7b.Resources).t("words.lastSemester"),
                        show: true
                    },
                    {
                        value: "lastYear",
                        name: (0, $wYO7b.Resources).t("words.lastYear"),
                        show: true
                    },
                    {
                        value: "undefined",
                        name: (0, $wYO7b.Resources).t("words.noComparison"),
                        show: true
                    }
                ];
            }
        },
        {
            key: "baseCalc",
            value: /**
     * calcs
     */ function baseCalc(purposeValue) {
                switch(purposeValue){
                    case "today":
                        return [
                            new Date(),
                            new Date()
                        ];
                    case "yesterday":
                        return [
                            (0, $6hmLA.datePrevious)(1),
                            (0, $6hmLA.datePrevious)(1)
                        ];
                    case "week":
                        return [
                            (0, $6hmLA.datePrevious)(6),
                            new Date()
                        ];
                    case "4week":
                        return [
                            (0, $6hmLA.datePrevious)(28),
                            new Date()
                        ];
                    case "3month":
                        var month3 = new Date();
                        month3.setMonth(month3.getMonth() - 3);
                        return [
                            month3,
                            new Date()
                        ];
                    case "6month":
                        var month6 = new Date();
                        month6.setMonth(month6.getMonth() - 6);
                        return [
                            month6,
                            new Date()
                        ];
                    case "12month":
                        var month12 = new Date();
                        month12.setMonth(month12.getMonth() - 12);
                        return [
                            month12,
                            new Date()
                        ];
                }
            }
        },
        {
            key: "comparatorCalc",
            value: function comparatorCalc(purposeValue, firstDate, secondDate) {
                var comparatorDays = (0, $3NRZT.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                var difference = 0;
                firstDate = (0, $alboN.dateToCompare)(firstDate);
                secondDate = (0, $alboN.dateToCompare)(secondDate, true);
                switch(purposeValue){
                    case "lastPeriod":
                        return [
                            (0, $6hmLA.datePrevious)(comparatorDays + 1, firstDate),
                            (0, $6hmLA.datePrevious)(comparatorDays + 1, secondDate)
                        ];
                    case "undefined":
                        return [
                            undefined,
                            undefined
                        ];
                    case "lastWeek":
                        return [
                            (0, $6hmLA.datePrevious)(7, firstDate),
                            (0, $6hmLA.datePrevious)(7, secondDate)
                        ];
                    case "lastMonth":
                        firstDate.setMonth(firstDate.getMonth() - 1);
                        secondDate.setMonth(secondDate.getMonth() - 1);
                        difference = comparatorDays - (0, $3NRZT.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                        firstDate.setDate(firstDate.getDate() - difference);
                        return [
                            firstDate,
                            secondDate
                        ];
                    case "lastTrimester":
                        firstDate.setMonth(firstDate.getMonth() - 3);
                        secondDate.setMonth(secondDate.getMonth() - 3);
                        difference = comparatorDays - (0, $3NRZT.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                        firstDate.setDate(firstDate.getDate() - difference);
                        return [
                            firstDate,
                            secondDate
                        ];
                    case "lastSemester":
                        firstDate.setMonth(firstDate.getMonth() - 6);
                        secondDate.setMonth(secondDate.getMonth() - 6);
                        difference = comparatorDays - (0, $3NRZT.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                        firstDate.setDate(firstDate.getDate() - difference);
                        return [
                            firstDate,
                            secondDate
                        ];
                    case "lastYear":
                        firstDate.setFullYear(firstDate.getFullYear() - 1);
                        secondDate.setFullYear(secondDate.getFullYear() - 1);
                        difference = comparatorDays - (0, $3NRZT.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                        firstDate.setDate(firstDate.getDate() - difference);
                        return [
                            firstDate,
                            secondDate
                        ];
                }
            }
        },
        {
            key: "basePurpose",
            value: /**
     * find
     */ function basePurpose(value) {
                return this.basePurposes.filter(function(v) {
                    return v.value == value;
                })[0];
            }
        },
        {
            key: "comparatorPurpose",
            value: function comparatorPurpose(value) {
                return this.comparatorPurposes.filter(function(v) {
                    return v.value == value;
                })[0];
            }
        }
    ]);
    return DateIntervalPickerPurposes;
}();

});
parcelRegister("3NRZT", function(module, exports) {

$parcel$export(module.exports, "dateCountDaysBetweenDates", function () { return $ef44aa1edaca9345$export$4161df2d8c6bdac8; });

var $alboN = parcelRequire("alboN");
function $ef44aa1edaca9345$export$4161df2d8c6bdac8(date, futureDate, noCountToday) {
    date = (0, $alboN.dateToCompare)(new Date(date));
    futureDate = new Date(futureDate);
    var days = [];
    while(date.getTime() < futureDate.getTime()){
        var key = "" + date.getFullYear() + date.getMonth() + date.getDate();
        if (!days.includes(key)) days.push(key);
        date.setDate(date.getDate() + 1);
    }
    return days.length - (noCountToday != undefined && noCountToday ? 1 : 0);
}

});
parcelRegister("alboN", function(module, exports) {

$parcel$export(module.exports, "dateToCompare", function () { return $34dcbf75cae27e3b$export$90108030505d8ba4; });
/**
 * Met les heures, minutes etc à 0 ou les minutes etc à 59
 */ function $34dcbf75cae27e3b$export$90108030505d8ba4(d, end) {
    d = new Date(d);
    if (d != undefined) {
        if (end) {
            d.setUTCHours(23);
            d.setUTCMinutes(59);
            d.setUTCSeconds(59);
            d.setUTCMilliseconds(999);
        } else {
            d.setUTCHours(0);
            d.setUTCMinutes(0);
            d.setUTCSeconds(0);
            d.setUTCMilliseconds(0);
        }
    }
    return d;
}

});


parcelRegister("6hmLA", function(module, exports) {

$parcel$export(module.exports, "datePrevious", function () { return $aec55b6900727294$export$41249170adb44dba; });
/**
 * Retourne la date - x nombre de jours par rapport à la date actuel
 */ function $aec55b6900727294$export$41249170adb44dba(previousDays, fromDate) {
    var myDate = new Date(fromDate == undefined ? new Date() : fromDate);
    myDate.setDate(myDate.getDate() - previousDays);
    return myDate;
}

});


parcelRegister("bjUFp", function(module, exports) {

$parcel$export(module.exports, "AppearanceTheme", function () { return $c7a53390971ade2d$export$81ee01c5982277e7; });
var $c7a53390971ade2d$export$81ee01c5982277e7 = /*#__PURE__*/ function(AppearanceTheme) {
    AppearanceTheme[AppearanceTheme["LIGHT"] = 1] = "LIGHT";
    AppearanceTheme[AppearanceTheme["DARK"] = 2] = "DARK";
    AppearanceTheme[AppearanceTheme["AUTO"] = 3] = "AUTO";
    return AppearanceTheme;
}({});

});

parcelRegister("yJnBa", function(module, exports) {

$parcel$export(module.exports, "SedestralStorage", function () { return $c2995d668acfd932$export$c4d24105fc1cd347; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $62tsD = parcelRequire("62tsD");

var $17jFS = parcelRequire("17jFS");
var $c2995d668acfd932$export$c4d24105fc1cd347 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralStorage() {
        (0, $3CDbU._)(this, SedestralStorage);
    }
    (0, $jyA4z._)(SedestralStorage, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if (!(0, $17jFS.isLocalStorageAvailable)()) _this.isLocalStorageEnabled = false;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                if (this.isLocalStorageEnabled) localStorage.setItem(key, value);
                else (0, $62tsD.SedestralMemory).setItem(key, value);
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                if (this.isLocalStorageEnabled) return localStorage.getItem(key);
                else return (0, $62tsD.SedestralMemory).getItem(key);
            }
        },
        {
            key: "hasItem",
            value: function hasItem(key) {
                return this.getItem(key) != null;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                if (this.isLocalStorageEnabled) localStorage.removeItem(key);
                else (0, $62tsD.SedestralMemory).removeItem(key);
            }
        },
        {
            key: "setCookie",
            value: function setCookie(name, value) {
                var domain = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : location.hostname;
                try {
                    var expireDate = new Date();
                    expireDate.setFullYear(expireDate.getFullYear() + 1); // Expire après le nombre d'années spécifié
                    document.cookie = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value), "; expires=").concat(expireDate.toUTCString(), "; domain=").concat(domain, "; path=/");
                } catch (e) {
                    console.error("Failed to set cookie", e);
                }
            }
        },
        {
            key: "getCookie",
            value: function getCookie(name) {
                var nameEQ = encodeURIComponent(name) + "=";
                var cookies = document.cookie.split(';');
                for(var i = 0; i < cookies.length; i++){
                    var cookie = cookies[i];
                    while(cookie.charAt(0) === ' ')cookie = cookie.substring(1, cookie.length);
                    if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
                }
                return null;
            }
        },
        {
            key: "deleteCookie",
            value: function deleteCookie(name) {
                document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
            }
        }
    ]);
    return SedestralStorage;
}();
$c2995d668acfd932$export$c4d24105fc1cd347.isLocalStorageEnabled = true;

});
parcelRegister("62tsD", function(module, exports) {

$parcel$export(module.exports, "SedestralMemory", function () { return $e8acbdb8645c315a$export$fa0502262c0fea12; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");
var $e8acbdb8645c315a$export$fa0502262c0fea12 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralMemory() {
        (0, $3CDbU._)(this, SedestralMemory);
    }
    (0, $jyA4z._)(SedestralMemory, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this._items = [];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                this._items[key] = value;
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                return this._items[key] ? this._items[key] : null;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                delete this._items[key];
            }
        }
    ]);
    return SedestralMemory;
}();

});

parcelRegister("17jFS", function(module, exports) {

$parcel$export(module.exports, "isLocalStorageAvailable", function () { return $6c5920708d376e64$export$117a30df0da2af20; });
/**
 * vérifie si le localstorage est dispo
 */ function $6c5920708d376e64$export$117a30df0da2af20() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("eQCFs", function(module, exports) {

$parcel$export(module.exports, "SedestralInterface", function () { return $4369250ab112acca$export$a48299ae308b6bd7; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");

var $5m1WU = parcelRequire("5m1WU");
var $4369250ab112acca$export$a48299ae308b6bd7 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralInterface() {
        (0, $3CDbU._)(this, SedestralInterface);
    }
    (0, $jyA4z._)(SedestralInterface, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var listeners;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.components = [];
                        if (_this.log) (0, $5m1WU.SedestralMachine).setInterval(function() {
                            var nullComponents = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _this.components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var component = _step.value;
                                    if (component.element == undefined) // if (component.constructor.name != "PageComponent")
                                    nullComponents.push(component);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            console.log(nullComponents);
                            console.log(_this.components);
                            console.log("comp: " + (_this.components.length - nullComponents.length));
                            console.log("comp n: " + nullComponents.length);
                        }, 3000);
                        _this.html = _this.ec("html");
                        _this.body = _this.ec("body");
                        _this.main = _this.ec("main");
                        listeners = [
                            'dragenter',
                            'dragover',
                            'dragleave',
                            'drop'
                        ];
                        listeners.forEach(function(eventName) {
                            return _this.body.putListener(window, eventName, function(e) {
                                return e.preventDefault();
                            });
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.components.forEach(function(c) {
                    c.nullify();
                });
                this.components = [];
                this.body = undefined;
                this.main = undefined;
            }
        },
        {
            key: "store",
            value: function store(element) {
                this.components.push(element);
            }
        },
        {
            key: "unStore",
            value: function unStore(element) {
                var index = this.components.indexOf(element);
                if (index >= 0) this.components.splice(index, 1);
            }
        },
        {
            key: "ec",
            value: function ec(selector) {
                var e = document.querySelector(selector);
                if (e != undefined) return new (0, $9gCL8.Component)(e);
                return undefined;
            }
        },
        {
            key: "el",
            value: function el(element) {
                return new (0, $9gCL8.Component)(element);
            }
        }
    ]);
    return SedestralInterface;
}();
$4369250ab112acca$export$a48299ae308b6bd7.log = false;

});
parcelRegister("9gCL8", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $df5c5bfa56b8a5f2$export$16fa2f45be04daa8; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $5m1WU = parcelRequire("5m1WU");

var $eQCFs = parcelRequire("eQCFs");

var $ewGkW = parcelRequire("ewGkW");

var $j2lF8 = parcelRequire("j2lF8");

var $lhBiP = parcelRequire("lhBiP");

var $irlxW = parcelRequire("irlxW");

var $12UO1 = parcelRequire("12UO1");

var $ijdsc = parcelRequire("ijdsc");

var $jRZ1w = parcelRequire("jRZ1w");

var $aufP0 = parcelRequire("aufP0");

var $7ewsz = parcelRequire("7ewsz");

var $doRa2 = parcelRequire("doRa2");

var $3D7wv = parcelRequire("3D7wv");

var $hBVyq = parcelRequire("hBVyq");

var $gGX81 = parcelRequire("gGX81");

var $abV4P = parcelRequire("abV4P");
var $df5c5bfa56b8a5f2$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(element) {
        (0, $3CDbU._)(this, Component);
        this.networkErrorsHandler = [];
        this.tagParents = {
            th: "tr",
            td: "tr",
            tr: "tbody"
        };
        this.element = element;
        this.componentId = (0, $gGX81.randomUUID)();
        this.timeOuts = [];
        this.intervals = [];
        this.reactives = [];
        this.listeners = [];
        this.hotKeyListeners = [];
        this.childrens = [];
        this.isHide = false;
        this.savedHtml = undefined;
        this.savedStyle = undefined;
        this.savedScroll = 0;
        this.savedScrollCalc = 0;
        this.template = "<div></div>";
        this.type = "DIV";
        this.committedError = false;
        this.committed = false;
        this.drawCommitted = true;
        this.onCommitFunctions = [];
        this.onRemoveFunctions = [];
        this.tooltipListeners = [];
        this.outsideClickExcludedComponents = [];
        (0, $eQCFs.SedestralInterface).store(this);
    }
    (0, $jyA4z._)(Component, [
        {
            key: "property",
            value: /**
     * Logic
     */ function property(type) {
                var offsets = this.getParentOffsets();
                var offsetProperty = typeof offsets[type] == "undefined" ? 0 : offsets[type];
                if (type == "height") offsetProperty = this.getHeight();
                return offsetProperty;
            }
        },
        {
            key: "sleep",
            value: /**
     * Machine
     */ function sleep(ms) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.promise(function(resolve) {
                                        _this.timeOut(function() {
                                            resolve(undefined);
                                        }, ms);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runAsCommit",
            value: function runAsCommit(func) {
                if (this.committed) func();
                else this.onCommit(function() {
                    return func();
                });
            }
        },
        {
            key: "wait",
            value: function wait(animations) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(animations)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "promise",
            value: function promise(executor, displayRequired) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(executor, displayRequired, _this)
                        ];
                    });
                })();
            }
        },
        {
            key: "simplePromise",
            value: function simplePromise(executor, displayRequired) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(executor)
                        ];
                    });
                })();
            }
        },
        {
            key: "translate",
            value: /**
     * Animations
     */ function translate(params) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.simplePromise(function(resolve) {
                                if (_this.element instanceof HTMLElement) {
                                    var delay = params.delay == undefined ? 100 : params.delay;
                                    var delayStyle = "transition-duration: ".concat(delay / 1000, "s;");
                                    /**
                 * transform
                 */ var transformStyle = "";
                                    if (params.translateX != undefined) transformStyle += "translateX(".concat(params.translateX, "px) ");
                                    if (params.translateY != undefined) transformStyle += "translateY(".concat(params.translateY, "px) ");
                                    if (params.scale != undefined) transformStyle += "scale(".concat(params.scale, ") ");
                                    if (params.rotate != undefined) transformStyle += "rotate(".concat(params.rotate, ") ");
                                    if (transformStyle != "") transformStyle = "transform:".concat(transformStyle, ";");
                                    /**
                 * position
                 */ var offsets = _this.getParentOffsets();
                                    if (offsets == undefined) return;
                                    var positionStyle = "";
                                    if (params.left != undefined) {
                                        _this.element.style.left = "".concat(offsets['left'], "px");
                                        _this.element.style.right = "unset";
                                        positionStyle += "left:".concat(offsets['left'] + params.left, "px;");
                                    }
                                    if (params.top != undefined) {
                                        _this.element.style.top = "".concat(offsets['top'], "px");
                                        _this.element.style.bottom = "unset";
                                        positionStyle += "top:".concat(offsets['top'] + params.top, "px;");
                                    }
                                    if (params.bottom != undefined) {
                                        _this.element.style.bottom = "".concat(offsets['bottom'], "px");
                                        _this.element.style.top = "unset";
                                        positionStyle += "bottom:".concat(offsets['bottom'] + params.bottom, "px;");
                                    }
                                    if (params.right != undefined) {
                                        _this.element.style.right = "".concat(offsets['right'], "px");
                                        _this.element.style.left = "unset";
                                        positionStyle += "right:".concat(offsets['right'] + params.right, "px;");
                                    }
                                    /**
                 * move
                 */ if (params.moveRight != undefined) {
                                        _this.element.style.right = "".concat(offsets['right'], "px");
                                        _this.element.style.left = "unset";
                                        positionStyle += "right:".concat(params.moveRight, "px;");
                                    }
                                    if (params.moveLeft != undefined) {
                                        _this.element.style.left = "".concat(offsets['left'], "px");
                                        _this.element.style.right = "unset";
                                        positionStyle += "left:".concat(params.moveLeft, "px;");
                                    }
                                    if (params.moveTop != undefined) {
                                        _this.element.style.top = "".concat(offsets['top'], "px");
                                        _this.element.style.bottom = "unset";
                                        positionStyle += "top:".concat(params.moveTop, "px;");
                                    }
                                    if (params.moveBottom != undefined) {
                                        _this.element.style.bottom = "".concat(offsets['bottom'], "px");
                                        _this.element.style.top = "unset";
                                        positionStyle += "bottom:".concat(params.moveBottom, "px;");
                                    }
                                    var propertiesStyle = "";
                                    /**
                 * properties
                 */ if (params.opacity != undefined) propertiesStyle += "opacity:".concat(params.opacity, ";");
                                    if (params.padding != undefined) propertiesStyle += "padding:".concat(params.padding, "px;");
                                    if (params.margin != undefined) propertiesStyle += "margin:".concat(params.margin, "px;");
                                    if (params.height != undefined) {
                                        _this.element.style.height = "".concat(_this.getHeight(), "px");
                                        propertiesStyle += "height:".concat(params.height, "px;");
                                    }
                                    if (params.maxHeight != undefined) {
                                        _this.element.style.maxHeight = "".concat(_this.getHeight(), "px");
                                        propertiesStyle += "max-height:".concat(params.maxHeight, "px;");
                                    }
                                    if (params.maxWidth != undefined) {
                                        _this.element.style.maxWidth = "".concat(_this.getWidth(), "px");
                                        propertiesStyle += "max-width:".concat(params.maxWidth, "px;");
                                    }
                                    if (params.width != undefined) {
                                        _this.element.style.width = "".concat(_this.getWidth(), "px");
                                        propertiesStyle += "width:".concat(params.width, "px;");
                                    }
                                    if (params.widthPercent != undefined) propertiesStyle += "width:".concat(params.widthPercent, "%;");
                                    if (params.borderRadius != undefined) propertiesStyle += "border-radius:".concat(params.borderRadius, ";");
                                    /**
                 * execution
                 */ (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                                        setTimeout(function() {
                                            _this.setStyle(transformStyle + delayStyle + positionStyle + propertiesStyle);
                                        });
                                    });
                                    /**
                 * sync
                 */ _this.timeOut(function() {
                                        resolve();
                                        if (params.remove != undefined && params.remove == true) _this.remove();
                                    }, delay);
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "scale",
            value: function scale(start, value, speed) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.element instanceof HTMLElement)) return [
                                    3,
                                    2
                                ];
                                _this.element.style.transform = "scale(" + start + ")";
                                return [
                                    4,
                                    _this.translate({
                                        delay: speed,
                                        scale: value
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fade",
            value: function fade(value, speed) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var start, final;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.element instanceof HTMLElement)) return [
                                    3,
                                    2
                                ];
                                if (value == "in") _this.show();
                                start = value == "in" ? 0 : 1;
                                final = value == "in" ? 1 : 0;
                                _this.setStyle("opacity:".concat(start));
                                return [
                                    4,
                                    _this.translate({
                                        delay: speed,
                                        opacity: final
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toggle",
            value: /**
     * toggle
     */ function toggle(tog, gle) {
                var toggled = false;
                this.onClick(function() {
                    if (!toggled) {
                        tog();
                        toggled = true;
                    } else {
                        gle();
                        toggled = false;
                    }
                });
            }
        },
        {
            key: "openUp",
            value: /**
     * Animations advanced
     */ function openUp(delay) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if (!(0, $abV4P.isMobile)()) return [
                            2,
                            _this.scaleShow(delay)
                        ];
                        else return [
                            2,
                            _this.swapUp()
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "closeDown",
            value: function closeDown(delay, scale, clear) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if (!(0, $abV4P.isMobile)()) return [
                            2,
                            _this.scaleHide(delay, scale, clear)
                        ];
                        else return [
                            2,
                            _this.swapDown(clear)
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "swapUp",
            value: function swapUp() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.displayShow();
                                _this.setStyle("transform:translateY(100%) scale(1);opacity:1;");
                                return [
                                    4,
                                    _this.translate({
                                        translateY: 0,
                                        delay: 400
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "swapDown",
            value: function swapDown(clear) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setStyle("transform:scale(1);opacity:1;");
                                return [
                                    4,
                                    _this.translate({
                                        translateY: window.innerHeight,
                                        delay: 400
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.displayHide();
                                if (clear == undefined || clear == true) _this.clearAll();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scaleShow",
            value: function scaleShow(delay, withoutDisplay) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!withoutDisplay) _this.displayShow();
                                _this.setStyle("transform:scale(0.9);opacity:0;");
                                return [
                                    4,
                                    _this.translate({
                                        delay: delay == undefined ? 80 : delay,
                                        scale: 1,
                                        opacity: 1
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.isHide = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scaleHide",
            value: function scaleHide(delay, scale, clear) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setStyle("transform:scale(1);opacity:1;");
                                return [
                                    4,
                                    _this.simplePromise(function(resolve) {
                                        (0, $5m1WU.SedestralMachine).requestFrame()(/*#__PURE__*/ (0, $hWZw8._)(function() {
                                            return (0, $eJDpD.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this.translate({
                                                                delay: delay == undefined ? 80 : delay,
                                                                scale: scale == undefined ? 0.9 : scale,
                                                                opacity: 0
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        _this.displayHide();
                                                        (0, $5m1WU.SedestralMachine).requestFrame()(/*#__PURE__*/ (0, $hWZw8._)(function() {
                                                            return (0, $eJDpD.__generator)(this, function(_state) {
                                                                _this.timeOut(function() {
                                                                    if (clear == undefined || clear == true) _this.clearAll();
                                                                    resolve(true);
                                                                }, 100);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }));
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.isHide = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scaleShowTranslate",
            value: function scaleShowTranslate(delay) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.show();
                                _this.setStyle("transform:scale(0.9) translateY(20px);opacity:0;");
                                return [
                                    4,
                                    _this.translate({
                                        delay: delay == undefined ? 80 : delay,
                                        translateY: 0,
                                        scale: 1,
                                        opacity: 1
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * outside click
     */ key: "excludeOutsideClickComponent",
            value: function excludeOutsideClickComponent(component) {
                var _this = this;
                this.outsideClickExcludedComponents.push(component);
                component.onRemove(function() {
                    return _this.outsideClickExcludedComponents.splice(_this.outsideClickExcludedComponents.indexOf(component), 1);
                });
            }
        },
        {
            key: "getScrollPercent",
            value: /**
     * Scroll
     */ function getScrollPercent() {
                if (this.element instanceof HTMLElement) return Math.round(this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight) * 100);
                return 0;
            }
        },
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                if (this.element instanceof HTMLElement) return this.element.scrollTop;
                return 0;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                if (this.element instanceof HTMLElement) return this.element.scrollLeft;
                return 0;
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(value) {
                if (this.element instanceof HTMLElement) this.element.scrollLeft = value;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(value) {
                if (this.element instanceof HTMLElement) this.element.scrollTop = value;
            }
        },
        {
            key: "getScrollBottom",
            value: function getScrollBottom() {
                if (this.element instanceof HTMLElement) return this.element.scrollHeight - Math.round(this.element.scrollTop + this.getHeight());
            }
        },
        {
            key: "scrollTop",
            value: function scrollTop(value, speed) {
                var _this = this;
                var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) return c / 2 * t * t + b;
                    t--;
                    return -c / 2 * (t * (t - 2) - 1) + b;
                };
                var start = this.getScrollTop(), change = value - start, currentTime = 0, increment = 20;
                var animateScroll = function() {
                    currentTime += increment;
                    _this.setScrollTop(easeInOutQuad(currentTime, start, change, speed));
                    if (currentTime < speed) (0, $5m1WU.SedestralMachine).setTimeout(animateScroll, increment);
                };
                animateScroll();
            }
        },
        {
            key: "scrollIntoView",
            value: function scrollIntoView(parent, offset, behavior) {
                parent = parent == undefined ? this.element.parentElement : parent;
                if (parent instanceof HTMLElement) {
                    var parentRect = parent.getBoundingClientRect();
                    var childRect = this.getHTMLElement().getBoundingClientRect();
                    parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top + (offset == undefined ? 0 : offset);
                } else {
                    var parentRect1 = parent.getHTMLElement().getBoundingClientRect();
                    var childRect1 = this.getHTMLElement().getBoundingClientRect();
                    var scrollTop = Math.round(childRect1.top + parent.getHTMLElement().scrollTop - parentRect1.top) + (offset == undefined ? 0 : offset);
                    parent.getHTMLElement().scrollTo({
                        top: scrollTop,
                        behavior: behavior ? behavior : "smooth"
                    });
                }
            }
        },
        {
            key: "scrollTo",
            value: function scrollTo(parent, offset) {
                parent.getHTMLElement().scrollTo({
                    top: this.getParentOffsets(parent).top + (offset ? offset : 0),
                    behavior: "smooth"
                });
            }
        },
        {
            key: "scrollBottom",
            value: function scrollBottom(value, speed) {
                var _this = this;
                if (this.element instanceof HTMLElement) {
                    var startDistance = this.element.scrollTop;
                    var endDistance = this.element.scrollHeight - this.getHeight() - value;
                    var frame = 0;
                    var delta = (endDistance - startDistance) / speed / 0.06;
                    var handle = (0, $5m1WU.SedestralMachine).setInterval(function() {
                        if (_this.element instanceof HTMLElement) {
                            frame++;
                            var _$value = startDistance + delta * frame;
                            _this.element.scrollTo(0, _$value);
                            if (_this.element == undefined) clearInterval(handle);
                            if (_$value >= endDistance) clearInterval(handle);
                        }
                    }, 1 / 0.06);
                }
            }
        },
        {
            key: "forceScrollUpdate",
            value: function forceScrollUpdate() {
                var _this = this;
                this.addClass("scroll-sdt-scr");
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    return _this.removeClass("scroll-sdt-scr");
                });
            }
        },
        {
            key: "getPaddingHeight",
            value: /**
     * Dimensions
     */ function getPaddingHeight() {
                var top = this.getHTMLElement().style.paddingTop.length > 0 ? parseInt(this.getHTMLElement().style.paddingTop) : 0;
                var bottom = this.getHTMLElement().style.paddingBottom.length > 0 ? parseInt(this.getHTMLElement().style.paddingBottom) : 0;
                return top + bottom;
            }
        },
        {
            key: "getFullHeight",
            value: function getFullHeight() {
                var height = this.getHTMLElement().clientHeight;
                var style = getComputedStyle(this.getHTMLElement());
                height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
                height += parseInt(style.marginTop) + parseInt(style.marginBottom);
                return height;
            }
        },
        {
            key: "getHeightCalculated",
            value: function getHeightCalculated() {
                var getFullHeight = function(element) {
                    var style = window.getComputedStyle(element);
                    var hauteur = element.offsetHeight;
                    var margeHaut = parseInt(style.marginTop);
                    var margeBas = parseInt(style.marginBottom);
                    return hauteur + margeHaut + margeBas;
                };
                var height = 0;
                var childs = this.getHTMLElement() ? this.getHTMLElement().children : [];
                var parentStyle = window.getComputedStyle(this.getHTMLElement());
                var gap = parseInt(parentStyle.gap) || 0;
                for(var i = 0; i < childs.length; i++)if (!childs[i].hasAttribute('scrolltrack')) height += getFullHeight(childs[i]);
                height += gap * (childs.length - 1);
                return height;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.element instanceof HTMLElement) return this.getHTMLElement().getBoundingClientRect().height + this.getPaddingHeight();
            }
        },
        {
            key: "getHeightWithoutBorders",
            value: function getHeightWithoutBorders() {
                return this.getHeight() - (this.getHTMLElement().offsetHeight - this.getHTMLElement().clientHeight);
            }
        },
        {
            key: "getWidth",
            value: function getWidth() {
                if (this.element instanceof HTMLElement) return this.element.clientWidth;
            }
        },
        {
            key: "getPaddingWidth",
            value: function getPaddingWidth() {
                var left = parseInt(this.getHTMLElement().style.paddingLeft);
                var right = parseInt(this.getHTMLElement().style.paddingRight);
                return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
            }
        },
        {
            key: "getMarginWidth",
            value: function getMarginWidth() {
                var left = parseInt(this.getHTMLElement().style.marginLeft);
                var right = parseInt(this.getHTMLElement().style.marginRight);
                return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
            }
        },
        {
            key: "getParentOffsets",
            value: /**
     * Offsets
     */ function getParentOffsets(element) {
                var parent = this.element.parentNode;
                if (typeof element != "undefined") parent = element.element;
                if (parent == undefined) return undefined;
                var parentOffsets = (0, $7ewsz.elementOffsets)(parent);
                var eOffsets = (0, $7ewsz.elementOffsets)(this.element);
                return {
                    top: eOffsets["top"] - parentOffsets["top"],
                    left: eOffsets["left"] - parentOffsets["left"],
                    right: eOffsets["right"] - parentOffsets["right"],
                    bottom: eOffsets["bottom"] - parentOffsets["bottom"]
                };
            }
        },
        {
            key: "getOffsets",
            value: function getOffsets() {
                return (0, $7ewsz.elementOffsets)(this.element);
            }
        },
        {
            key: "getValue",
            value: /**
     * Value and html and text
     */ function getValue() {
                if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) return this.element.value;
                return "";
            }
        },
        {
            key: "getValueTrim",
            value: function getValueTrim() {
                return this.getValue().trim();
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) this.element.value = value;
                return "";
            }
        },
        {
            key: "streamValue",
            value: function streamValue(text, delay) {
                var _this = this;
                var index = 0;
                this.setValue("");
                var interval = this.interval(function() {
                    if (index < text.length) {
                        _this.setValue(_this.getValue() + text[index]);
                        index++;
                    } else clearInterval(interval);
                }, delay / text.length);
            }
        },
        {
            key: "getHtml",
            value: function getHtml() {
                if (this.element instanceof HTMLElement) return this.element.innerHTML;
            }
        },
        {
            key: "setHtml",
            value: function setHtml(html) {
                if (this.element instanceof HTMLElement) this.element.innerHTML = "" + html;
            }
        },
        {
            key: "getText",
            value: function getText() {
                if (this.element instanceof HTMLElement) return this.element.innerText;
            }
        },
        {
            key: "streamText",
            value: function streamText(text, delay) {
                var _this = this;
                var index = 0;
                this.setHtml(""); // Effacer le contenu initial
                var addHtml = function() {
                    if (index < text.length) {
                        if (text.substring(index, index + 8) === '<strong>') {
                            // On a trouvé le début d'une balise <strong>
                            var endOfStrongTag = text.indexOf('</strong>', index);
                            if (endOfStrongTag !== -1) {
                                // Ajouter la balise <strong>...</strong> entière en une fois
                                _this.setHtml(_this.getHtml() + text.substring(index, endOfStrongTag + 9));
                                index = endOfStrongTag + 9; // Avancer l'index après la balise </strong>
                            }
                        } else {
                            // Ajouter un caractère normal
                            _this.setHtml(_this.getHtml() + text[index]);
                            index++;
                        }
                    } else clearInterval(interval); // Arrêter l'insertion lorsque tout le texte est ajouté
                };
                var interval = setInterval(addHtml, delay / text.length);
            }
        },
        {
            key: "setText",
            value: function setText(text) {
                if (this.element instanceof HTMLElement) this.element.innerText = text;
            }
        },
        {
            key: "setPlaceHolderStyle",
            value: /**
     * style
     */ function setPlaceHolderStyle(value) {
                this.placeHolderSelector = (0, $hBVyq.randomString)(20, false);
                this.addClass(this.placeHolderSelector);
                if (!this.placeholderStyleElement) {
                    this.placeholderStyleElement = document.createElement("style");
                    this.placeholderStyleElement = this.getHTMLElement().appendChild(this.placeholderStyleElement);
                }
                this.placeholderStyleElement.innerHTML = ".".concat(this.placeHolderSelector, "::placeholder { ").concat(value, " }");
            }
        },
        {
            key: "setStyle",
            value: function setStyle(value) {
                if (this.element instanceof HTMLElement || this.element instanceof SVGElement) this.element.style.cssText += value;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(strCssRule) {
                var strValue = "";
                if (this.element instanceof HTMLElement) {
                    if (document.defaultView && document.defaultView.getComputedStyle) strValue = document.defaultView.getComputedStyle(this.element, "").getPropertyValue(strCssRule);
                    else if (this.element['currentStyle']) {
                        strCssRule = strCssRule.replace(/\-(\w)/g, function(strMatch, p1) {
                            return p1.toUpperCase();
                        });
                        strValue = this.element['currentStyle'][strCssRule];
                    }
                }
                return strValue;
            }
        },
        {
            key: "setStyleValue",
            value: function setStyleValue(type, value) {
                if (this.element instanceof HTMLElement) this.element.style[type] = value;
            }
        },
        {
            key: "hide",
            value: /**
     * visibility status
     */ function hide() {
                this.isHide = true;
                this.setStyle("visibility:hidden;");
            }
        },
        {
            key: "show",
            value: function show() {
                this.isHide = false;
                this.setStyle("visibility:visible;");
            }
        },
        {
            key: "displayHide",
            value: function displayHide() {
                this.isHide = true;
                this.setStyle("display:none;");
            }
        },
        {
            key: "displayShow",
            value: function displayShow() {
                this.isHide = false;
                this.setStyle("display:block;");
            }
        },
        {
            key: "displayFlex",
            value: function displayFlex() {
                this.isHide = false;
                this.setStyle("display:flex;");
            }
        },
        {
            key: "isDisplayNone",
            value: function isDisplayNone() {
                return this.getStyle("display") == "none";
            }
        },
        {
            key: "isVisible",
            value: function isVisible() {
                if (this.element instanceof HTMLElement) return this.element.offsetParent !== undefined;
            }
        },
        {
            key: "onHotKeys",
            value: /**
     * On events
     */ function onHotKeys(keys, func) {
                var _this = this;
                keys.forEach(function(key) {
                    _this.hotKeyListeners.push(key);
                    (0, $5m1WU.SedestralMachine).addHotKeyListener(_this, key, func);
                });
            }
        },
        {
            key: "onHotKey",
            value: function onHotKey(keys, func) {
                this.hotKeyListeners.push(keys);
                (0, $5m1WU.SedestralMachine).addHotKeyListener(this, keys, func);
                return keys;
            }
        },
        {
            key: "onChange",
            value: function onChange(func) {
                var _this = this;
                if (this.mutationObserver == undefined) {
                    this.mutationFunctions = [];
                    this.mutationObserver = new MutationObserver(function(mutations) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _this.mutationFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var f = _step.value;
                                f(mutations);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    });
                    this.mutationObserver.observe(this.getHTMLElement(), {
                        subtree: true,
                        childList: true,
                        characterData: true,
                        attributes: true,
                        characterDataOldValue: true,
                        attributeOldValue: true,
                        attributeFilter: [
                            'id',
                            'class'
                        ]
                    });
                }
                this.mutationFunctions.push(func);
                return func;
            }
        },
        {
            key: "onResize",
            value: function onResize(func) {
                var _this = this;
                if (this.element instanceof Element) {
                    var f = function() {
                        var offsets = _this.getOffsets();
                        func({
                            height: _this.getHeight(),
                            width: _this.getWidth(),
                            x: offsets.left,
                            y: offsets.top
                        });
                    };
                    window.addEventListener("resize", f);
                    this.onRemove(function() {
                        return window.removeEventListener("resize", f);
                    });
                    this.onChange(function() {
                        return f();
                    });
                    (0, $5m1WU.SedestralMachine).resizeObserver.observe(this.element);
                    if (this.element['resizeFunctions'] == undefined) this.element['resizeFunctions'] = [];
                    this.element['resizeFunctions'].push(func);
                }
            }
        },
        {
            key: "onInput",
            value: function onInput(func, delay) {
                return this.addListener('input', this.delay(func, typeof delay == "undefined" ? 0 : delay));
            }
        },
        {
            key: "onKey",
            value: function onKey(func, delay) {
                return this.addListener('keydown', this.delay(func, typeof delay == "undefined" ? 0 : delay));
            }
        },
        {
            key: "onKeyUp",
            value: function onKeyUp(func, delay) {
                return this.addListener('keyup', this.delay(func, typeof delay == "undefined" ? 0 : delay));
            }
        },
        {
            key: "onClick",
            value: function onClick(func, stopPropagation, mobileDelay) {
                var _this = this;
                return this.addListener('click', function(e) {
                    if (stopPropagation) {
                        e.stopImmediatePropagation();
                        e.stopPropagation();
                    }
                    if ((0, $abV4P.isMobile)() && mobileDelay) _this.timeOut(function() {
                        return func(e);
                    }, 200);
                    else func(e);
                });
            }
        },
        {
            key: "onDragEvent",
            value: function onDragEvent(onEnter, onLeave) {
                var _this = this;
                var entered = false;
                var leave = true;
                var listeners = [];
                listeners.push(this.putListener(window, "dragleave", function(e) {
                    if (!leave) {
                        if (!(0, $doRa2.elementParents)(e.target).includes(_this.getHTMLElement())) {
                            entered = false;
                            leave = true;
                            onLeave(e);
                        }
                    }
                }));
                listeners.push(this.putListener(window, "dragenter", function(e) {
                    if (!entered) {
                        if (e.target == _this.getHTMLElement() || (0, $doRa2.elementParents)(e.target).includes(_this.getHTMLElement())) {
                            _this.timeOut(function() {
                                return leave = false;
                            }, 50);
                            entered = true;
                            onEnter(e);
                        }
                    }
                }));
                this.putListener(window, "focus", function(e) {
                    return onLeave(e);
                });
                return listeners;
            }
        },
        {
            key: "onDragDrop",
            value: function onDragDrop(func) {
                return this.addListener("drop", function(e) {
                    return func(e);
                });
            }
        },
        {
            key: "onRightClick",
            value: function onRightClick(func) {
                this.addListener("contextmenu", function(e) {
                    e.preventDefault();
                    func(e);
                });
            }
        },
        {
            key: "onWindowResize",
            value: function onWindowResize(func) {
                this.putListener(window, "resize", func);
            }
        },
        {
            key: "onFocus",
            value: function onFocus(func) {
                return this.addListener('focus', function(e) {
                    return func(e);
                });
            }
        },
        {
            key: "onBlur",
            value: function onBlur(func) {
                return this.addListener('blur', function(e) {
                    return func(e);
                });
            }
        },
        {
            key: "onScroll",
            value: function onScroll(callback) {
                return this.addListener("scroll", callback);
            }
        },
        {
            key: "onOutsideClick",
            value: function onOutsideClick(func, propagation) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var listener;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $5m1WU.SedestralMachine).sleep(50)
                                ];
                            case 1:
                                _state.sent();
                                listener = _this.putListener(window, 'click', function(e) {
                                    if (!(0, $jRZ1w.elementNotChildren)(document, e.target)) {
                                        if (!_this.isNull() && (0, $jRZ1w.elementNotChildren)(_this.element, e.target) && _this.outsideClickExcludedComponents.filter(function(value) {
                                            return !(0, $jRZ1w.elementNotChildren)(value.element, e.target);
                                        }).length == 0) {
                                            if (typeof propagation != "undefined") e.stopImmediatePropagation();
                                            func(e);
                                        }
                                    }
                                });
                                (0, $5m1WU.SedestralMachine).addOutsideClickListener(listener, _this);
                                return [
                                    2,
                                    listener
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onOutsideRightClick",
            value: function onOutsideRightClick(func, propagation) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $5m1WU.SedestralMachine).sleep(50)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.putListener(window, "contextmenu", function(e) {
                                        if ((0, $jRZ1w.elementNotChildren)(_this.element, e.target)) {
                                            if (typeof propagation != "undefined") e.stopImmediatePropagation();
                                            func(e);
                                        }
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onComponentClick",
            value: function onComponentClick(name, func) {
                var globalFunc = function globalFunc(e) {
                    var parentsClasses = [];
                    var a = e.target;
                    while(a){
                        a = a.parentNode;
                        if (a != undefined) {
                            if (a.className !== "") parentsClasses.push(a.className);
                        }
                    }
                    var has = false;
                    if ((0, $aufP0.elementHasClass)(e.target.className, name)) has = true;
                    for(var i = 0; i < parentsClasses.length; i++)if ((0, $aufP0.elementHasClass)(parentsClasses[i], name)) has = true;
                    if (has) func();
                };
                return this.addListener('click', globalFunc);
            }
        },
        {
            key: "onHover",
            value: function onHover(func, time) {
                var _this = this;
                return this.addListener('mouseenter', function(e) {
                    if (time == undefined) func(e);
                    else {
                        var timeOut = _this.timeOut(function() {
                            func(e);
                        }, time);
                        var leaveListener = _this.addListener('mouseleave', function(e) {
                            clearTimeout(timeOut);
                            _this.deleteListener(leaveListener);
                        });
                    }
                });
            }
        },
        {
            key: "onLeave",
            value: function onLeave(func, time) {
                var _this = this;
                return this.addListener('mouseleave', function(e) {
                    if (time == undefined) func(e);
                    else {
                        var timeOut = _this.timeOut(function() {
                            func(e);
                        }, time);
                        var leaveListener = _this.addListener('mouseenter', function(e) {
                            clearTimeout(timeOut);
                            _this.deleteListener(leaveListener);
                        });
                    }
                });
            }
        },
        {
            key: "onSubmit",
            value: function onSubmit(func) {
                if (this.element instanceof HTMLElement) this.element.onsubmit = function(e) {
                    func(e);
                };
            }
        },
        {
            key: "onCommit",
            value: function onCommit(func) {
                this.onCommitFunctions.push(func);
            }
        },
        {
            key: "onRemove",
            value: function onRemove(func) {
                this.onRemoveFunctions.push(func);
            }
        },
        {
            key: "onReactiveObserve",
            value: function onReactiveObserve(func) {
                this.reactives.push((0, $j2lF8.observe)(function() {
                    return func();
                }, {
                    lazy: false
                }));
            }
        },
        {
            key: "onBufferReactiveObserve",
            value: function onBufferReactiveObserve(func) {
                var _this = this;
                var scheduled;
                this.reactives.push((0, $j2lF8.observe)(function() {
                    return func();
                }, {
                    lazy: false,
                    scheduler: function() {
                        clearTimeout(scheduled);
                        scheduled = _this.timeOut(function() {
                            if (!_this.isNull()) func();
                        }, 25);
                        return setTimeout(undefined, 0);
                    }
                }));
            }
        },
        {
            key: "onVisible",
            value: function onVisible(callback) {
                var _this = this;
                if (!this.isNull()) new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(entry) {
                        if (entry.intersectionRatio > 0) {
                            callback(_this.getHTMLElement());
                            observer.disconnect();
                        }
                    });
                }).observe(this.getHTMLElement());
            }
        },
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(callback) {
                if (!this.isNull()) new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        callback(entry.isIntersecting);
                    });
                }, {
                    threshold: [
                        0
                    ]
                }).observe(this.getHTMLElement());
            }
        },
        {
            key: "onParentsScroll",
            value: function onParentsScroll(callback) {
                var _this = this;
                return this.putListener(document, "scroll", function(e) {
                    if ((0, $doRa2.elementParents)(_this.getHTMLElement()).includes(e.target)) callback(e);
                }, true);
            }
        },
        {
            key: "isBelowScroll",
            value: function isBelowScroll(callback, mid) {
                var _this = this;
                function isElementBelowViewportBottom(element, currentScrollTop) {
                    var viewportBottom = currentScrollTop + window.innerHeight;
                    var elementTop = element.getBoundingClientRect().top + window.scrollY;
                    return elementTop > viewportBottom - (mid ? window.innerHeight / 2 - 100 : 0);
                }
                this.putListener(document, "scroll", function() {
                    var scrollTop = window.scrollY;
                    var targetElement = _this.getHTMLElement();
                    if (isElementBelowViewportBottom(targetElement, scrollTop)) callback(false);
                    else callback(true);
                });
                callback(false);
            }
        },
        {
            key: "isFocus",
            value: /**
     * focus
     */ function isFocus() {
                return document.activeElement == this.element;
            }
        },
        {
            key: "focus",
            value: function focus() {
                if (this.element instanceof HTMLElement) this.element.focus();
            }
        },
        {
            key: "focusAtEnd",
            value: function focusAtEnd() {
                this.focus();
                var inputElement = this.getHTMLElement();
                if (inputElement) {
                    var strLength = this.getValue().length * 2;
                    (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                        var type = inputElement.type;
                        inputElement.type = "text";
                        inputElement.focus();
                        inputElement.setSelectionRange(strLength, strLength);
                        inputElement.type = type;
                    });
                }
            }
        },
        {
            key: "pendTop",
            value: /**
     * append and prepend html text inside component
     */ function pendTop() {
                var eElement = this.element.parentNode;
                if (eElement.firstChild != this.element) {
                    var newFirstElement = this.element;
                    eElement.insertBefore(newFirstElement, eElement.firstChild);
                }
            }
        },
        {
            key: "pendBottom",
            value: function pendBottom() {
                var eElement = this.element.parentNode;
                var newFirstElement = this.element;
                eElement.appendChild(newFirstElement);
            }
        },
        {
            key: "pendAfter",
            value: function pendAfter(beforeComponent, component) {
                component = component ? component : this;
                beforeComponent.element.parentElement.appendChild(component.element);
                var beforeElement = beforeComponent.element;
                beforeElement = beforeElement.nextSibling == undefined ? beforeElement : beforeElement.nextSibling;
                beforeComponent.element.parentElement.insertBefore(component.element, beforeElement);
            }
        },
        {
            key: "pendBefore",
            value: function pendBefore(beforeComponent, component) {
                component = component ? component : this;
                beforeComponent.element.parentElement.appendChild(component.element);
                beforeComponent.element.parentElement.insertBefore(component.element, beforeComponent.element);
            }
        },
        {
            key: "prepend",
            value: function prepend(html, tag) {
                var component = this.append(html, tag);
                component.pendTop();
                return component;
            }
        },
        {
            key: "append",
            value: function append(html, tag) {
                var _this = this;
                var buffer = document.createElement(typeof tag == "undefined" ? "div" : typeof this.tagParents[tag] == "undefined" ? tag : this.tagParents[tag]);
                buffer.innerHTML = html.trim();
                var element = buffer.firstChild;
                if (buffer.childNodes.length > 1) {
                    var _this_element, _this_element1;
                    (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(buffer);
                    (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(buffer, this.element.lastChild);
                    element = buffer;
                } else {
                    var _this_element2, _this_element3;
                    (_this_element2 = this.element) === null || _this_element2 === void 0 ? void 0 : _this_element2.appendChild(element);
                    (_this_element3 = this.element) === null || _this_element3 === void 0 ? void 0 : _this_element3.insertBefore(element, this.element.lastChild);
                }
                var component = (0, $eQCFs.SedestralInterface).el(element);
                this.childrens.filter(function(value) {
                    return !value.drawCommitted;
                }).forEach(function(value) {
                    return _this.drawCommit(value);
                });
                if (!component.committed) component.tryCommit();
                this.addChildren(component);
                return component;
            }
        },
        {
            key: "reactive",
            value: /**
     * Reactive
     */ function reactive(v) {
                var _this = this;
                var id = (0, $hBVyq.randomString)(18, true);
                this.onReactiveObserve(function() {
                    try {
                        var value = v();
                        if (!_this.isNull()) {
                            var element = _this.getHTMLElement().getElementsByClassName(id)[0];
                            if (element != undefined) element.innerHTML = (0, $3D7wv.filterXSS)(value);
                        }
                    } catch (e) {}
                });
                return '<reactive class="'.concat(id, '">').concat((0, $3D7wv.filterXSS)(v()), "</reactive>");
            }
        },
        {
            key: "reactiveObservable",
            value: function reactiveObservable(obj) {
                return (0, $j2lF8.observable)(obj);
            }
        },
        {
            key: "reactiveUnObserve",
            value: function reactiveUnObserve(v) {
                (0, $j2lF8.unobserve)(v);
            }
        },
        {
            key: "reactivesUnObserve",
            value: function reactivesUnObserve() {
                for(var i = 0; i < this.reactives.length; i++)this.reactiveUnObserve(this.reactives[i]);
                this.reactives = [];
            }
        },
        {
            key: "drawAll",
            value: /**
     * Return the template of an component and added to childrens for final commit
     */ function drawAll(components) {
                var template = "";
                for(var i = 0; i < components.length; i++){
                    var component = components[i];
                    template += this.draw(component);
                }
                return template;
            }
        },
        {
            key: "drawCommit",
            value: function drawCommit(component) {
                component.drawCommitted = true;
                if (!component.committed) {
                    var element = document.getElementById(component.componentId);
                    if (element != undefined) {
                        component.element = element;
                        component.removeAttribute("id");
                    }
                    component.tryCommit();
                }
            }
        },
        {
            key: "draw",
            value: function draw(component) {
                var _this = this;
                component.drawCommitted = false;
                var buffer = document.createElement('div');
                buffer.innerHTML = component.getTemplate().trim();
                if (buffer.childNodes.length > 1) {
                    buffer.id = component.componentId;
                    component.template = buffer['outerHTML'];
                } else {
                    buffer.firstChild['id'] = component.componentId;
                    component.template = buffer['innerHTML'];
                }
                if (this.committed) (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    return _this.drawCommit(component);
                });
                else this.onCommit(function() {
                    return _this.drawCommit(component);
                });
                this.addChildren(component);
                return component.getTemplate();
            }
        },
        {
            key: "drawFly",
            value: function drawFly(component) {
                if (this.committed) {
                    this.render(component);
                    var html = component.getHTMLElement().outerHTML;
                    component.remove();
                    return html;
                }
            }
        },
        {
            key: "prerender",
            value: /**
     * Append a component inside other, better performance than draw()
     */ function prerender(component) {
                return this.render(component, true);
            }
        },
        {
            key: "render",
            value: function render(component, prepend, beforeComponent, beforeAfter) {
                var _this_element, _this_element1;
                var buffer = document.createElement(typeof this.tagParents[component.type] == "undefined" ? component.type : this.tagParents[component.type]);
                buffer.innerHTML = component.getTemplate().trim();
                var element = buffer.firstChild;
                if (buffer.childNodes.length > 1) element = buffer;
                (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(element);
                (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(element, !prepend ? this.element.lastChild : this.element.firstChild);
                component.element = element;
                if (!component.committed) component.tryCommit();
                this.addChildren(component);
                if (beforeComponent) beforeAfter ? this.pendAfter(beforeComponent, component) : this.pendBefore(beforeComponent, component);
                return component;
            }
        },
        {
            key: "tryCommit",
            value: /**
     * call this function after apend in DOM
     */ function tryCommit() {
                try {
                    this.commit();
                    this.committed = true;
                } catch (e) {
                    (0, $12UO1.SedestralDebugger).addError("SEDESTRAL COMMIT ERROR", e);
                    this.committedError = true;
                    this.commitFailed();
                }
            }
        },
        {
            key: "commit",
            value: function commit() {
                this.committed;
                if (!this.committed) {
                    this.committed = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.onCommitFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var commitFunc = _step.value;
                            commitFunc();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "commitFailed",
            value: function commitFailed() {}
        },
        {
            key: "commitTooltips",
            value: function commitTooltips() {
                var _this = this;
                var elements = (0, $ijdsc.elementChildrens)(this.getHTMLElement());
                elements.forEach(function(element) {
                    if (!element['commitTooltips']) {
                        element['commitTooltips'] = true;
                        var tooltipText = element.getAttribute("data-tooltip");
                        var tooltipPosition = element.getAttribute("data-tooltip-position");
                        if (tooltipText != undefined) {
                            var component = _this.ele(element);
                            component.setTooltip(tooltipText, tooltipPosition);
                        }
                    }
                });
            }
        },
        {
            key: "addNetworkErrors",
            value: /**
     * errors
     */ function addNetworkErrors(errors) {
                var _this = this;
                errors.forEach(function(error) {
                    return _this.networkErrorsHandler.push(error);
                });
            }
        },
        {
            key: "virtual",
            value: /**
     * create an empty element in DOM with className
     */ function virtual(name) {
                var buffer = document.createElement('div');
                buffer.className = name;
                this.element = buffer;
                document.body.appendChild(buffer);
                document.body.insertBefore(buffer, this.element.lastChild);
            }
        },
        {
            key: "addChildren",
            value: function addChildren(element) {
                if (!this.childrens.includes(element)) this.childrens.push(element);
            }
        },
        {
            key: "removeChildren",
            value: function removeChildren(element) {
                var index = this.childrens.indexOf(element);
                if (index >= 0) this.childrens.splice(index, 1);
            }
        },
        {
            key: "saveScroll",
            value: /**
     * save and restore headers
     */ function saveScroll() {
                this.savedScroll = this.getHTMLElement().scrollTop;
                this.savedScrollCalc = this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight;
            }
        },
        {
            key: "restoreScroll",
            value: function restoreScroll() {
                this.getHTMLElement().scrollTop = this.savedScroll + (this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight - this.savedScrollCalc);
            }
        },
        {
            key: "save",
            value: function save() {
                if (this.element instanceof HTMLElement) {
                    this.savedStyle = this.element.getAttribute("style");
                    this.savedHtml = this.element.innerHTML;
                }
            }
        },
        {
            key: "saveAndClear",
            value: function saveAndClear() {
                this.save();
                this.clear();
            }
        },
        {
            key: "saveForLoading",
            value: function saveForLoading() {
                this.setStyle("padding:0;height:".concat(this.getHeightWithoutBorders(), "px;width:").concat(this.getWidth(), "px;"));
                this.saveAndClear();
            }
        },
        {
            key: "restore",
            value: function restore() {
                if (this.element instanceof HTMLElement) {
                    this.element.setAttribute("style", this.savedStyle);
                    this.element.innerHTML = this.savedHtml;
                }
            }
        },
        {
            key: "clearListeners",
            value: /**
     * Listeners
     */ function clearListeners() {
                var _this = this;
                for(var i = 0; i < this.listeners.length; i++)(0, $5m1WU.SedestralMachine).removeListener(this.listeners[i]);
                this.hotKeyListeners.forEach(function(value) {
                    return (0, $5m1WU.SedestralMachine).deleteHotKeyListener(_this, value);
                });
                this.listeners = [];
                this.hotKeyListeners = [];
            }
        },
        {
            key: "clearTooltipListeners",
            value: function clearTooltipListeners() {
                for(var i = 0; i < this.tooltipListeners.length; i++)(0, $5m1WU.SedestralMachine).removeListener(this.tooltipListeners[i]);
                this.tooltipListeners = [];
                if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) this.tooltip.tooltipComponent.remove();
                this.tooltip = undefined;
            }
        },
        {
            key: "clearTimeouts",
            value: function clearTimeouts() {
                for(var i = 0; i < this.timeOuts.length; i++)clearTimeout(this.timeOuts[i]);
                this.timeOuts = [];
            }
        },
        {
            key: "clearIntervals",
            value: function clearIntervals() {
                for(var i = 0; i < this.intervals.length; i++)clearInterval(this.intervals[i]);
                this.intervals = [];
            }
        },
        {
            key: "addListener",
            value: function addListener(name, func) {
                var _SedestralDebugger_rum;
                (0, $12UO1.SedestralDebugger).eventTarget(this, name);
                var rum = (_SedestralDebugger_rum = (0, $12UO1.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.eventTarget(name);
                return this.putListener(this.element, name, function(e) {
                    func(e);
                    rum === null || rum === void 0 ? void 0 : rum.end();
                });
            }
        },
        {
            key: "putListener",
            value: function putListener(element, name, func, options) {
                var listener = (0, $5m1WU.SedestralMachine).addListener(element, name, func, options);
                this.listeners.push(listener);
                return listener;
            }
        },
        {
            key: "deleteListener",
            value: function deleteListener(data) {
                if (data != undefined) {
                    (0, $5m1WU.SedestralMachine).removeListener(data);
                    var index = this.listeners.indexOf(data);
                    if (index >= 0) this.listeners.splice(index, 1);
                }
            }
        },
        {
            key: "deleteListeners",
            value: function deleteListeners(listeners) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        this.deleteListener(listener);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "deleteHotKeyListener",
            value: function deleteHotKeyListener(hotkeys) {
                (0, $5m1WU.SedestralMachine).deleteHotKeyListener(this, hotkeys);
                var index = this.hotKeyListeners.indexOf(hotkeys);
                if (index >= 0) this.hotKeyListeners.splice(index, 1);
            }
        },
        {
            key: "deleteHotKeyListeners",
            value: function deleteHotKeyListeners(hotkeys) {
                var _this = this;
                hotkeys.forEach(function(value) {
                    return _this.deleteHotKeyListener(value);
                });
            }
        },
        {
            key: "deleteOnChangeListener",
            value: function deleteOnChangeListener(func) {
                this.mutationFunctions.splice(this.mutationFunctions.indexOf(func), 1);
            }
        },
        {
            key: "runRemoves",
            value: /**
     * run listeners
     */ function runRemoves() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.onRemoveFunctions.length > 0) try {
                    for(var _iterator = this.onRemoveFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var removeFunc = _step.value;
                        removeFunc();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.onRemoveFunctions = [];
            }
        },
        {
            key: "hasClass",
            value: /**
     * Class interaction
     */ function hasClass(cls) {
                if (this.element instanceof HTMLElement) return (0, $aufP0.elementHasClass)(this.element.className, cls);
            }
        },
        {
            key: "addClass",
            value: function addClass(cls) {
                if (this.element instanceof HTMLElement) {
                    if (!this.hasClass(cls)) {
                        var last = this.element.className.charAt(this.element.className.length - 1);
                        this.element.className += (last == " " ? "" : " ") + cls;
                    }
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(cls) {
                if (this.element instanceof HTMLElement) {
                    if (this.hasClass(cls)) {
                        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
                        this.element.className = this.element.className.replace(reg, " ");
                    }
                }
            }
        },
        {
            key: "getAttribute",
            value: /**
     * Attribute interactions
     */ function getAttribute(name) {
                if (this.element instanceof HTMLElement) return this.element.getAttribute(name);
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, content) {
                if (this.element instanceof HTMLElement) this.element.setAttribute(name, content);
            }
        },
        {
            key: "removeAttribute",
            value: function removeAttribute(name) {
                if (this.element instanceof HTMLElement) this.element.removeAttribute(name);
            }
        },
        {
            key: "els",
            value: /**
     * child headers manipulation
     */ function els(className) {
                if (this.element instanceof HTMLElement) {
                    var elements = [];
                    var components = [];
                    if (this.hasClass(className)) elements.push(this.element);
                    var classes = this.element.getElementsByClassName(className);
                    for(var i = 0; i < classes.length; i++)elements.push(classes[i]);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _this, _loop = function() {
                            var element = _step.value;
                            var cache = _this.childrens.filter(function(value) {
                                return value.element == element;
                            })[0];
                            if (cache == undefined) {
                                var e = (0, $eQCFs.SedestralInterface).el(element);
                                e.committed = true;
                                components.push(e);
                                _this.addChildren(e);
                            } else components.push(cache);
                        };
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return components;
                }
            }
        },
        {
            key: "el",
            value: function el(className, noCache) {
                if (!noCache) {
                    var cache = this.childrens.filter(function(value) {
                        return value.element != undefined && value.hasClass(className);
                    })[0];
                    if (cache != undefined) return cache;
                }
                if (this.element instanceof HTMLElement) {
                    var e = (0, $eQCFs.SedestralInterface).el(this.hasClass(className) ? this.element : this.element.getElementsByClassName(className)[0]);
                    e.committed = true;
                    this.addChildren(e);
                    return e;
                }
            }
        },
        {
            key: "ele",
            value: function ele(element) {
                var cache = this.childrens.filter(function(value) {
                    return value.element == element;
                })[0];
                if (cache == undefined) {
                    var e = (0, $eQCFs.SedestralInterface).el(element);
                    e.committed = true;
                    this.addChildren(e);
                    return e;
                }
                return cache;
            }
        },
        {
            key: "has",
            value: function has(className) {
                if (this.element instanceof HTMLElement) {
                    var elements = this.element.getElementsByClassName(className);
                    if (elements.length > 0) return true;
                }
                return false;
            }
        },
        {
            key: "clearChildrens",
            value: function clearChildrens() {
                for(var i = 0; i < this.childrens.length; i++){
                    var child = this.childrens[i];
                    child.destroy();
                }
                this.childrens = [];
            }
        },
        {
            key: "count",
            value: function count(className) {
                if (this.element instanceof HTMLElement) {
                    var elements = this.element.getElementsByTagName("*");
                    var count = 0;
                    for(var i = 0; i < elements.length; i++)if (!!elements[i].className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))) count++;
                    return count;
                }
            }
        },
        {
            key: "delay",
            value: /**
     * apply events
     */ function delay(callback, ms) {
                if (ms == 0) return callback;
                else {
                    var timer = 0;
                    return function(params) {
                        clearTimeout(timer);
                        timer = (0, $5m1WU.SedestralMachine).setTimeout(function() {
                            callback(params);
                        }, ms || 0);
                    };
                }
            }
        },
        {
            key: "timeOut",
            value: function timeOut(callback, ms) {
                var timeout = (0, $5m1WU.SedestralMachine).setTimeout(function() {
                    callback();
                }, ms);
                this.timeOuts.push(timeout);
                return timeout;
            }
        },
        {
            key: "interval",
            value: function interval(callback, ms, lazy) {
                if (!lazy) callback();
                var timeout = (0, $5m1WU.SedestralMachine).setInterval(function() {
                    callback();
                }, ms);
                this.intervals.push(timeout);
                return timeout;
            }
        },
        {
            key: "isNull",
            value: /**
     * others
     */ function isNull() {
                return this.element == undefined;
            }
        },
        {
            key: "remove",
            value: /**
     * end
     */ function remove() {
                if (this.element != undefined && this.element.parentNode !== undefined) {
                    if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
                }
                this.destroy();
            }
        },
        {
            key: "nullify",
            value: function nullify() {
                if (this.getHTMLElement() != undefined) (0, $5m1WU.SedestralMachine).resizeObserver.unobserve(this.getHTMLElement());
                if (this.mutationObserver != undefined) {
                    this.mutationObserver.disconnect();
                    this.mutationObserver = undefined;
                    this.mutationFunctions = [];
                }
                this.clearAll();
                this.element = undefined;
                this.timeOuts = [];
                this.intervals = [];
                this.reactives = [];
                this.listeners = [];
                this.hotKeyListeners = [];
                this.childrens = [];
                this.isHide = undefined;
                this.savedHtml = undefined;
                this.savedStyle = undefined;
                this.savedScroll = undefined;
                this.savedScroll = undefined;
                this.savedScrollCalc = undefined;
                this.outsideClickExcludedComponents = [];
                this.template = undefined;
                this.type = undefined;
                this.scrollbar = undefined;
                this.swapBar = undefined;
                this.runRemoves();
                this.onCommitFunctions = [];
                for(var key in this)if (this.hasOwnProperty(key)) {
                    var value = this[key];
                    var isArray = Array.isArray(value);
                    if (isArray && value['length'] != 0 || !isArray && value != undefined) {
                        if (isArray) value = [];
                        else value = undefined;
                    }
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.nullify();
                (0, $eQCFs.SedestralInterface).unStore(this);
            }
        },
        {
            key: "destroyChildrens",
            value: function destroyChildrens() {
                this.childrens.forEach(function(value) {
                    value.destroyChildrens();
                    value.destroy();
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (this.element instanceof HTMLElement) {
                    this.element.innerHTML = "";
                    this.clearChildrens();
                }
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this.scrollbar = undefined;
                this.swapBar = undefined;
                this.clear();
                this.clearListeners();
                this.clearTooltipListeners();
                this.clearIntervals();
                this.clearTimeouts();
                this.reactivesUnObserve();
            }
        },
        {
            key: "scrollable",
            value: /**
     * change element status
     */ function scrollable(autoPlace) {
                if (this.scrollbar == undefined) this.scrollbar = new (0, $ewGkW.ComponentScrollbar)(this, autoPlace);
                return this.scrollbar;
            }
        },
        {
            key: "swapable",
            value: function swapable(onDispose) {
                if ((0, $abV4P.isMobile)()) {
                    if (this.swapBar == undefined) this.swapBar = new (0, $irlxW.ComponentSwapBar)(this, onDispose);
                    return this.swapBar;
                }
            }
        },
        {
            key: "unClickable",
            value: function unClickable() {
                this.onClick(function(e) {
                    e.preventDefault();
                }, true);
            }
        },
        {
            key: "showShadowTooltip",
            value: /**
     * tooltip
     */ function showShadowTooltip(template, color) {
                var _this = this;
                this.setStyle("box-shadow: 0 0 0 2px ".concat(color, ";"));
                this.showTooltip(template, 2000, "bottom");
                clearTimeout(this.tooltipShowShadowTimeout);
                this.tooltipShowShadowTimeout = this.timeOut(function() {
                    _this.setStyle("box-shadow: unset;");
                }, 2000);
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(template, delay, position, noAnimation) {
                var _this = this;
                clearTimeout(this.tooltipShowTimeout);
                if (!this.tooltip) this.tooltip = new (0, $lhBiP.ComponentTooltip)(this, template, position, noAnimation);
                this.tooltipShowTimeout = this.timeOut(function() {
                    if (_this.tooltip) _this.tooltip.tooltipComponent.remove();
                    _this.tooltip = undefined;
                }, delay ? delay : 3000);
            }
        },
        {
            key: "setTooltip",
            value: function setTooltip(template, position, noAnimation, disabled) {
                var _this = this;
                if ((0, $abV4P.isMobile)()) {
                    var showed = false;
                    var show = function() {
                        if (disabled == undefined || !disabled()) {
                            _this.tooltip = new (0, $lhBiP.ComponentTooltip)(_this, template, position, noAnimation);
                            showed = true;
                        }
                    };
                    var hide = function() {
                        if (_this.tooltip != undefined && _this.tooltip.tooltipComponent != undefined && !_this.tooltip.tooltipComponent.isNull()) {
                            _this.tooltip.tooltipComponent.remove();
                            _this.tooltip = undefined;
                            showed = false;
                        }
                    };
                    this.tooltipListeners.push(this.onClick(function() {
                        if (showed) hide();
                        else show();
                    }));
                    this.onOutsideClick(function() {
                        return hide();
                    }).then(function(value) {
                        return _this.tooltipListeners.push(value);
                    });
                } else {
                    this.tooltipListeners.push(this.onHover(function() {
                        if (disabled == undefined || !disabled()) _this.tooltip = new (0, $lhBiP.ComponentTooltip)(_this, template, position, noAnimation);
                    }));
                    this.tooltipListeners.push(this.onClick(function() {
                        if (_this.tooltip != undefined && _this.tooltip.tooltipComponent != undefined && !_this.tooltip.tooltipComponent.isNull()) {
                            _this.tooltip.tooltipComponent.remove();
                            _this.tooltip = undefined;
                        }
                    }));
                }
            }
        },
        {
            key: "getHTMLElement",
            value: /**
     * getter and setter
     */ function getHTMLElement() {
                if (this.element instanceof HTMLElement) return this.element;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.template;
            }
        }
    ]);
    return Component;
}();

});
parcelRegister("ewGkW", function(module, exports) {

$parcel$export(module.exports, "ComponentScrollbar", function () { return $58fa0b0cdb64a370$export$17759cda9c0355fc; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $5m1WU = parcelRequire("5m1WU");

var $bFIcA = parcelRequire("bFIcA");

var $5CG7B = parcelRequire("5CG7B");
var $58fa0b0cdb64a370$export$17759cda9c0355fc = /*#__PURE__*/ function() {
    "use strict";
    function ComponentScrollbar(component, autoPlace) {
        (0, $3CDbU._)(this, ComponentScrollbar);
        this.track = undefined;
        this.bar = undefined;
        this.dragScrollTop = 0;
        this.timeOutResize = 0;
        this.isDragging = false;
        this.trackRect = undefined;
        this.scrollRatio = 1;
        this.component = component;
        this.now = performance.now();
        this.autoPlace = autoPlace;
        this.build();
        this.binding();
    }
    (0, $jyA4z._)(ComponentScrollbar, [
        {
            key: "build",
            value: function build() {
                var _this = this;
                if (this.component.element instanceof HTMLElement) {
                    var template = '\n                <div scrollTrack class="'.concat($bFIcA.scrollVirtualTrack, '">\n                    <div scrollBar class="').concat($bFIcA.scrollVirtualBar, '"></div>\n                </div>');
                    this.component.prepend(template);
                    this.track = this.component.el($bFIcA.scrollVirtualTrack);
                    this.bar = this.component.el($bFIcA.scrollVirtualBar);
                    this.component.addClass($bFIcA.scrollVirtual);
                    if (this.autoPlace) {
                        this.place();
                        this.component.putListener(window, "resize", function() {
                            return _this.place();
                        });
                    }
                }
            }
        },
        {
            key: "binding",
            value: function binding() {
                var _this = this;
                this.bar.addListener("mousedown", function(e) {
                    _this.onBarMouseDown(e);
                });
                this.track.addListener("click", function(e) {
                    _this.onTrackClick(e);
                });
                this.component.onScroll(function() {
                    return _this.onScrollResize();
                });
                //this.component.onChange(() => this.onScrollResize());
                this.component.onResize(function() {
                    return _this.onScrollResize();
                });
                this.component.interval(function() {
                    return _this.onScrollResize();
                }, 500);
            }
        },
        {
            key: "onScrollResize",
            value: function onScrollResize() {
                var _this = this;
                if (performance.now() - this.now > 1) {
                    if (!(0, $5CG7B.isTabletNative)() && this.component.element instanceof HTMLElement) {
                        var difference = this.component.element.scrollHeight - this.component.element.clientHeight;
                        if (difference <= 0) {
                            this.track.setStyle("display:none;");
                            this.component.removeClass($bFIcA.scrollVirtual);
                            (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                                _this.component.removeAttribute("scrollVirtual");
                            });
                        } else {
                            this.track.setStyle("display:block;");
                            this.component.addClass($bFIcA.scrollVirtual);
                            this.component.setAttribute("scrollVirtual", "");
                        }
                        this.moveBar();
                        this.timeOutResize = this.component.timeOut(function() {
                            return _this.getTrackBounds();
                        }, 200);
                    }
                    this.now = performance.now();
                }
            }
        },
        {
            key: "onDrag",
            value: function onDrag(e) {
                var _this = this;
                this.isDragging = true;
                var delta = e.pageY - this.lastPageY;
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    var sTop = document.documentElement.scrollTop;
                    var isDragWithinTrackBounds = e.pageY >= _this.trackRect.top + sTop && e.pageY <= _this.trackRect.bottom + sTop;
                    if (isDragWithinTrackBounds) _this.component.setScrollTop(_this.dragScrollTop + delta / _this.scrollRatio);
                    else {
                        _this.dragScrollTop = _this.component.getScrollTop();
                        _this.lastPageY = e.pageY;
                    }
                });
            }
        },
        {
            key: "onStopDrag",
            value: function onStopDrag(e) {
                var _this = this;
                this.bar.removeClass($bFIcA.scrollVirtualGrabbed);
                this.track.removeClass($bFIcA.scrollVirtualGrabbed);
                this.bar.removeAttribute("scrollGrabbed");
                this.track.removeAttribute("scrollGrabbed");
                document.body.classList.remove($bFIcA.scrollVirtualSelect);
                this.component.deleteListener(this.mouseDragListener);
                this.component.deleteListener(this.mouseStopDragListener);
                this.component.timeOut(function() {
                    _this.isDragging = false;
                }, 100);
            }
        },
        {
            key: "onBarMouseDown",
            value: function onBarMouseDown(e) {
                var _this = this;
                this.dragScrollTop = this.component.getScrollTop();
                this.lastPageY = e.pageY;
                this.bar.addClass($bFIcA.scrollVirtualGrabbed);
                this.track.addClass($bFIcA.scrollVirtualGrabbed);
                this.bar.setAttribute("scrollGrabbed", "");
                this.track.setAttribute("scrollGrabbed", "");
                document.body.classList.add($bFIcA.scrollVirtualSelect);
                this.mouseDragListener = this.component.putListener(window, "mousemove", function(e) {
                    _this.onDrag(e);
                });
                this.mouseStopDragListener = this.component.putListener(window, "mouseup", function(e) {
                    _this.onStopDrag(e);
                });
            }
        },
        {
            key: "onTrackClick",
            value: function onTrackClick(e) {
                var _this = this;
                if (this.isDragging) return;
                if (this.component.element instanceof HTMLElement) {
                    var perc = (e.clientY - this.trackRect.top) / (this.trackRect.height - this.trackRect['topPad'] - this.trackRect['bottomPad']);
                    var scrollHeight = this.component.element.scrollHeight;
                    var ownHeight = this.component.element.clientHeight;
                    var newScrollTop = perc * (scrollHeight - ownHeight);
                    this.component.element.style.scrollBehavior = 'smooth';
                    this.component.timeOut(function() {
                        if (_this.component.element instanceof HTMLElement) _this.component.element.style.scrollBehavior = 'unset';
                    }, 500);
                    this.component.element.scrollTop = newScrollTop;
                }
            }
        },
        {
            key: "getTrackBounds",
            value: function getTrackBounds() {
                if (this.track.element instanceof HTMLElement) {
                    this.trackRect = this.track.element.getBoundingClientRect();
                    var styles = window.getComputedStyle(this.track.element, undefined);
                    this.trackRect['topPad'] = parseInt(styles.paddingTop, 10);
                    this.trackRect['bottomPad'] = parseInt(styles.paddingBottom, 10);
                }
            }
        },
        {
            key: "moveBar",
            value: function moveBar() {
                var _this = this;
                if (this.component.element instanceof HTMLElement && this.track.element instanceof HTMLElement) {
                    var scrollHeight = this.component.element.scrollHeight;
                    var clientHeight = this.component.element.clientHeight;
                    this.scrollRatio = this.track.element.clientHeight / scrollHeight;
                    (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                        if (_this.component.element instanceof HTMLElement) {
                            var height = clientHeight / scrollHeight * 100;
                            var top = _this.component.element.scrollTop / scrollHeight * 100;
                            _this.bar.setStyle("height:".concat(height.toFixed(1), "%;top:").concat(top.toFixed(1), "%;"));
                        }
                    });
                }
            }
        },
        {
            key: "place",
            value: function place() {
                var _this = this;
                this.track.setStyle("position:fixed;transition:0s;right:".concat(this.component.getOffsets().right + 2, "px;height:").concat(this.component.getHeight() - 8, "px;top: ").concat(this.component.getOffsets().top + 4, "px;"));
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    return _this.track.setStyle("transition: 0.1s");
                });
            }
        }
    ]);
    return ComponentScrollbar;
}();

});
parcelRegister("bFIcA", function(module, exports) {

$parcel$export(module.exports, "scrollVirtual", function () { return $87f5cfa4debc363d$export$c05bc4a5d5bdd591; }, function (v) { return $87f5cfa4debc363d$export$c05bc4a5d5bdd591 = v; });
$parcel$export(module.exports, "scrollVirtualTrack", function () { return $87f5cfa4debc363d$export$f006a8e874a0c0c2; }, function (v) { return $87f5cfa4debc363d$export$f006a8e874a0c0c2 = v; });
$parcel$export(module.exports, "scrollVirtualBar", function () { return $87f5cfa4debc363d$export$f95b7f37ecd6af3f; }, function (v) { return $87f5cfa4debc363d$export$f95b7f37ecd6af3f = v; });
$parcel$export(module.exports, "scrollVirtualSelect", function () { return $87f5cfa4debc363d$export$baea668a85f138e4; }, function (v) { return $87f5cfa4debc363d$export$baea668a85f138e4 = v; });
$parcel$export(module.exports, "scrollVirtualGrabbed", function () { return $87f5cfa4debc363d$export$7fde6f40368c3f64; }, function (v) { return $87f5cfa4debc363d$export$7fde6f40368c3f64 = v; });
var $87f5cfa4debc363d$export$c05bc4a5d5bdd591;
var $87f5cfa4debc363d$export$f006a8e874a0c0c2;
var $87f5cfa4debc363d$export$f95b7f37ecd6af3f;
var $87f5cfa4debc363d$export$baea668a85f138e4;
var $87f5cfa4debc363d$export$7fde6f40368c3f64;
$87f5cfa4debc363d$export$c05bc4a5d5bdd591 = "LrIP1";
$87f5cfa4debc363d$export$f006a8e874a0c0c2 = "yYNu3";
$87f5cfa4debc363d$export$f95b7f37ecd6af3f = "vC-Op";
$87f5cfa4debc363d$export$baea668a85f138e4 = "FN46B";
$87f5cfa4debc363d$export$7fde6f40368c3f64 = "zHL2l";

});

parcelRegister("5CG7B", function(module, exports) {

$parcel$export(module.exports, "isTabletNative", function () { return $dbef9a479407c9cc$export$3d3a4f4557ce39f9; });
/**
 * Vérifie si la largeur est inférieur à 450px
 */ 
var $5Azrw = parcelRequire("5Azrw");
function $dbef9a479407c9cc$export$3d3a4f4557ce39f9() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= 970 && (0, $5Azrw.IS_NATIVE);
}

});
parcelRegister("5Azrw", function(module, exports) {

$parcel$export(module.exports, "IS_NATIVE", function () { return $af6b990eb996c062$export$b8b535c3ef3eecc4; });
$parcel$export(module.exports, "IMG_EMPTY", function () { return $af6b990eb996c062$export$d43b17a7dbe4169b; });
var $af6b990eb996c062$export$b8b535c3ef3eecc4 = false;
var $af6b990eb996c062$export$e5ab80781acdc6e8 = 16732543783000;
var $af6b990eb996c062$export$fa5433ab32a7595b = 20;
var $af6b990eb996c062$export$d43b17a7dbe4169b = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

});



parcelRegister("j2lF8", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $ddbf01f124b09677$export$d1203567a167490e; });
$parcel$export(module.exports, "unobserve", function () { return $ddbf01f124b09677$export$23a2283368c55ea2; });
$parcel$export(module.exports, "observable", function () { return $ddbf01f124b09677$export$5ab46cbf6120b33a; });

var $7tffA = parcelRequire("7tffA");
var $ddbf01f124b09677$var$connectionStore = new WeakMap();
var $ddbf01f124b09677$var$ITERATION_KEY = Symbol('iteration key');
function $ddbf01f124b09677$var$storeObservable(obj) {
    // this will be used to save (obj.key -> reaction) connections later
    $ddbf01f124b09677$var$connectionStore.set(obj, new Map());
}
function $ddbf01f124b09677$var$registerReactionForOperation(reaction, ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    if (type === 'iterate') key = $ddbf01f124b09677$var$ITERATION_KEY;
    var reactionsForObj = $ddbf01f124b09677$var$connectionStore.get(target);
    var reactionsForKey = reactionsForObj.get(key);
    if (!reactionsForKey) {
        reactionsForKey = new Set();
        reactionsForObj.set(key, reactionsForKey);
    }
    // save the fact that the key is used by the reaction during its current run
    if (!reactionsForKey.has(reaction)) {
        reactionsForKey.add(reaction);
        reaction.cleaners.push(reactionsForKey);
    }
}
function $ddbf01f124b09677$var$getReactionsForOperation(ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    var reactionsForTarget = $ddbf01f124b09677$var$connectionStore.get(target);
    var reactionsForKey = new Set();
    if (type === 'clear') reactionsForTarget.forEach(function(_, key) {
        $ddbf01f124b09677$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    });
    else $ddbf01f124b09677$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    if (type === 'add' || type === 'delete' || type === 'clear') {
        var iterationKey = Array.isArray(target) ? 'length' : $ddbf01f124b09677$var$ITERATION_KEY;
        $ddbf01f124b09677$var$addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
    }
    return reactionsForKey;
}
function $ddbf01f124b09677$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(reactionsForKey.add, reactionsForKey);
}
function $ddbf01f124b09677$var$releaseReaction(reaction) {
    if (reaction.cleaners) reaction.cleaners.forEach($ddbf01f124b09677$var$releaseReactionKeyConnection, reaction);
    reaction.cleaners = [];
}
function $ddbf01f124b09677$var$releaseReactionKeyConnection(reactionsForKey) {
    reactionsForKey["delete"](this);
}
// reactions can call each other and form a call stack
var $ddbf01f124b09677$var$reactionStack = [];
var $ddbf01f124b09677$var$isDebugging = false;
function $ddbf01f124b09677$var$runAsReaction(reaction, fn, context, args) {
    // do not build reactive relations, if the reaction is unobserved
    if (reaction.unobserved) return Reflect.apply(fn, context, args);
    // only run the reaction if it is not already in the reaction stack
    // TODO: improve this to allow explicitly recursive reactions
    if ($ddbf01f124b09677$var$reactionStack.indexOf(reaction) === -1) {
        // release the (obj -> key -> reactions) connections
        // and reset the cleaner connections
        $ddbf01f124b09677$var$releaseReaction(reaction);
        try {
            // set the reaction as the currently running one
            // this is required so that we can create (observable.prop -> reaction) pairs in the get trap
            $ddbf01f124b09677$var$reactionStack.push(reaction);
            return Reflect.apply(fn, context, args);
        } finally{
            // always remove the currently running flag from the reaction when it stops execution
            $ddbf01f124b09677$var$reactionStack.pop();
        }
    }
}
// register the currently running reaction to be queued again on obj.key mutations
function $ddbf01f124b09677$var$registerRunningReactionForOperation(operation) {
    // get the current reaction from the top of the stack
    var runningReaction = $ddbf01f124b09677$var$reactionStack[$ddbf01f124b09677$var$reactionStack.length - 1];
    if (runningReaction) {
        $ddbf01f124b09677$var$debugOperation(runningReaction, operation);
        $ddbf01f124b09677$var$registerReactionForOperation(runningReaction, operation);
    }
}
function $ddbf01f124b09677$var$queueReactionsForOperation(operation) {
    // iterate and queue every reaction, which is triggered by obj.key mutation
    $ddbf01f124b09677$var$getReactionsForOperation(operation).forEach($ddbf01f124b09677$var$queueReaction, operation);
}
function $ddbf01f124b09677$var$queueReaction(reaction) {
    $ddbf01f124b09677$var$debugOperation(reaction, this);
    // queue the reaction for later execution or run it immediately
    if (typeof reaction.scheduler === 'function') reaction.scheduler(reaction);
    else if ((0, $7tffA._)(reaction.scheduler) === 'object') reaction.scheduler.add(reaction);
    else reaction();
}
function $ddbf01f124b09677$var$debugOperation(reaction, operation) {
    if (reaction["debugger"] && !$ddbf01f124b09677$var$isDebugging) try {
        $ddbf01f124b09677$var$isDebugging = true;
        reaction["debugger"](operation);
    } finally{
        $ddbf01f124b09677$var$isDebugging = false;
    }
}
function $ddbf01f124b09677$var$hasRunningReaction() {
    return $ddbf01f124b09677$var$reactionStack.length > 0;
}
var $ddbf01f124b09677$var$IS_REACTION = Symbol('is reaction');
function $ddbf01f124b09677$export$d1203567a167490e(fn, options) {
    if (options === void 0) options = {};
    // wrap the passed function in a reaction, if it is not already one
    var reaction = fn[$ddbf01f124b09677$var$IS_REACTION] ? fn : function reaction() {
        return $ddbf01f124b09677$var$runAsReaction(reaction, fn, this, arguments);
    };
    // save the scheduler and debugger on the reaction
    reaction.scheduler = options.scheduler;
    reaction["debugger"] = options["debugger"];
    // save the fact that this is a reaction
    reaction[$ddbf01f124b09677$var$IS_REACTION] = true;
    // run the reaction once if it is not a lazy one
    if (!options.lazy) reaction();
    return reaction;
}
function $ddbf01f124b09677$export$23a2283368c55ea2(reaction) {
    // do nothing, if the reaction is already unobserved
    if (!reaction.unobserved) {
        // indicate that the reaction should not be triggered any more
        reaction.unobserved = true;
        // release (obj -> key -> reaction) connections
        $ddbf01f124b09677$var$releaseReaction(reaction);
    }
    // unschedule the reaction, if it is scheduled
    if ((0, $7tffA._)(reaction.scheduler) === 'object') reaction.scheduler["delete"](reaction);
}
var $ddbf01f124b09677$var$proxyToRaw = new WeakMap();
var $ddbf01f124b09677$var$rawToProxy = new WeakMap();
var $ddbf01f124b09677$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ddbf01f124b09677$var$findObservable(obj) {
    var observableObj = $ddbf01f124b09677$var$rawToProxy.get(obj);
    if ($ddbf01f124b09677$var$hasRunningReaction() && (typeof obj === "undefined" ? "undefined" : (0, $7tffA._)(obj)) === 'object' && obj !== null) {
        if (observableObj) return observableObj;
        return $ddbf01f124b09677$export$5ab46cbf6120b33a(obj);
    }
    return observableObj || obj;
}
function $ddbf01f124b09677$var$patchIterator(iterator, isEntries) {
    var originalNext = iterator.next;
    iterator.next = function() {
        var ref = originalNext.call(iterator);
        var done = ref.done;
        var value = ref.value;
        if (!done) {
            if (isEntries) value[1] = $ddbf01f124b09677$var$findObservable(value[1]);
            else value = $ddbf01f124b09677$var$findObservable(value);
        }
        return {
            done: done,
            value: value
        };
    };
    return iterator;
}
var $ddbf01f124b09677$var$instrumentations = {
    has: function has(key) {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'has'
        });
        return proto.has.apply(target, arguments);
    },
    get: function get(key) {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'get'
        });
        return $ddbf01f124b09677$var$findObservable(proto.get.apply(target, arguments));
    },
    add: function add(key) {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.add.apply(target, arguments);
        if (!hadKey) $ddbf01f124b09677$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: key,
            type: 'add'
        });
        return result;
    },
    set: function set(key, value) {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.set.apply(target, arguments);
        if (!hadKey) $ddbf01f124b09677$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            type: 'add'
        });
        else if (value !== oldValue) $ddbf01f124b09677$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            oldValue: oldValue,
            type: 'set'
        });
        return result;
    },
    "delete": function delete$1(key) {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get ? proto.get.call(target, key) : undefined;
        // forward the operation before queueing reactions
        var result = proto["delete"].apply(target, arguments);
        if (hadKey) $ddbf01f124b09677$var$queueReactionsForOperation({
            target: target,
            key: key,
            oldValue: oldValue,
            type: 'delete'
        });
        return result;
    },
    clear: function clear() {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadItems = target.size !== 0;
        var oldTarget = target instanceof Map ? new Map(target) : new Set(target);
        // forward the operation before queueing reactions
        var result = proto.clear.apply(target, arguments);
        if (hadItems) $ddbf01f124b09677$var$queueReactionsForOperation({
            target: target,
            oldTarget: oldTarget,
            type: 'clear'
        });
        return result;
    },
    forEach: function forEach(cb) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        // swap out the raw values with their observable pairs
        // before passing them to the callback
        var wrappedCb = function wrappedCb(value) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            return cb.apply(void 0, [
                $ddbf01f124b09677$var$findObservable(value)
            ].concat(rest));
        };
        var ref;
        return (ref = proto.forEach).call.apply(ref, [
            target,
            wrappedCb
        ].concat(args));
    },
    keys: function keys() {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return proto.keys.apply(target, arguments);
    },
    values: function values() {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.values.apply(target, arguments);
        return $ddbf01f124b09677$var$patchIterator(iterator, false);
    },
    entries: function entries() {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.entries.apply(target, arguments);
        return $ddbf01f124b09677$var$patchIterator(iterator, true);
    },
    get size () {
        var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $ddbf01f124b09677$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return Reflect.get(proto, 'size', target);
    }
};
$ddbf01f124b09677$var$instrumentations[Symbol.iterator] = function() {
    var target = $ddbf01f124b09677$var$proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    $ddbf01f124b09677$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    var iterator = proto[Symbol.iterator].apply(target, arguments);
    return $ddbf01f124b09677$var$patchIterator(iterator, target instanceof Map);
};
var $ddbf01f124b09677$var$collectionHandlers = {
    get: function get(target, key, receiver) {
        // instrument methods and property accessors to be reactive
        target = $ddbf01f124b09677$var$hasOwnProperty.call($ddbf01f124b09677$var$instrumentations, key) ? $ddbf01f124b09677$var$instrumentations : target;
        return Reflect.get(target, key, receiver);
    }
};
// eslint-disable-next-line
var $ddbf01f124b09677$var$globalObj = (typeof window === "undefined" ? "undefined" : (0, $7tffA._)(window)) === 'object' ? window : Function('return this')();
// built-in object can not be wrapped by Proxies
// their methods expect the object instance as the 'this' instead of the Proxy wrapper
// complex objects are wrapped with a Proxy of instrumented methods
// which switch the proxy to the raw object and to add reactive wiring
var $ddbf01f124b09677$var$handlers = new Map([
    [
        Map,
        $ddbf01f124b09677$var$collectionHandlers
    ],
    [
        Set,
        $ddbf01f124b09677$var$collectionHandlers
    ],
    [
        WeakMap,
        $ddbf01f124b09677$var$collectionHandlers
    ],
    [
        WeakSet,
        $ddbf01f124b09677$var$collectionHandlers
    ],
    [
        Object,
        false
    ],
    [
        Array,
        false
    ],
    [
        Int8Array,
        false
    ],
    [
        Uint8Array,
        false
    ],
    [
        Uint8ClampedArray,
        false
    ],
    [
        Int16Array,
        false
    ],
    [
        Uint16Array,
        false
    ],
    [
        Int32Array,
        false
    ],
    [
        Uint32Array,
        false
    ],
    [
        Float32Array,
        false
    ],
    [
        Float64Array,
        false
    ]
]);
function $ddbf01f124b09677$var$shouldInstrument(ref) {
    var constructor = ref.constructor;
    var isBuiltIn = typeof constructor === 'function' && constructor.name in $ddbf01f124b09677$var$globalObj && $ddbf01f124b09677$var$globalObj[constructor.name] === constructor;
    return !isBuiltIn || $ddbf01f124b09677$var$handlers.has(constructor);
}
function $ddbf01f124b09677$var$getHandlers(obj) {
    return $ddbf01f124b09677$var$handlers.get(obj.constructor);
}
var $ddbf01f124b09677$var$hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $ddbf01f124b09677$var$wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter(function(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) === 'symbol';
}));
// intercept get operations on observables to know which reaction uses their properties
function $ddbf01f124b09677$var$get(target, key, receiver) {
    var result = Reflect.get(target, key, receiver);
    // do not register (observable.prop -> reaction) pairs for well known symbols
    // these symbols are frequently retrieved in low level JavaScript under the hood
    if ((typeof key === "undefined" ? "undefined" : (0, $7tffA._)(key)) === 'symbol' && $ddbf01f124b09677$var$wellKnownSymbols.has(key)) return result;
    // register and save (observable.prop -> runningReaction)
    $ddbf01f124b09677$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        receiver: receiver,
        type: 'get'
    });
    // if we are inside a reaction and observable.prop is an object wrap it in an observable too
    // this is needed to intercept property access on that object too (dynamic observable tree)
    var observableResult = $ddbf01f124b09677$var$rawToProxy.get(result);
    if ($ddbf01f124b09677$var$hasRunningReaction() && (typeof result === "undefined" ? "undefined" : (0, $7tffA._)(result)) === 'object' && result !== null) {
        if (observableResult) return observableResult;
        // do not violate the none-configurable none-writable prop get handler invariant
        // fall back to none reactive mode in this case, instead of letting the Proxy throw a TypeError
        var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
        if (!descriptor || !(descriptor.writable === false && descriptor.configurable === false)) return $ddbf01f124b09677$export$5ab46cbf6120b33a(result);
    }
    // otherwise return the observable wrapper if it is already created and cached or the raw object
    return observableResult || result;
}
function $ddbf01f124b09677$var$has(target, key) {
    var result = Reflect.has(target, key);
    // register and save (observable.prop -> runningReaction)
    $ddbf01f124b09677$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        type: 'has'
    });
    return result;
}
function $ddbf01f124b09677$var$ownKeys(target) {
    $ddbf01f124b09677$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    return Reflect.ownKeys(target);
}
// intercept set operations on observables to know when to trigger reactions
function $ddbf01f124b09677$var$set(target, key, value, receiver) {
    // make sure to do not pollute the raw object with observables
    if ((typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) === 'object' && value !== null) value = $ddbf01f124b09677$var$proxyToRaw.get(value) || value;
    // save if the object had a descriptor for this key
    var hadKey = $ddbf01f124b09677$var$hasOwnProperty$1.call(target, key);
    // save if the value changed because of this set operation
    var oldValue = target[key];
    // execute the set operation before running any reaction
    var result = Reflect.set(target, key, value, receiver);
    // do not queue reactions if the target of the operation is not the raw receiver
    // (possible because of prototypal inheritance)
    if (target !== $ddbf01f124b09677$var$proxyToRaw.get(receiver)) return result;
    // queue a reaction if it's a new property or its value changed
    if (!hadKey) $ddbf01f124b09677$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        receiver: receiver,
        type: 'add'
    });
    else if (value !== oldValue) $ddbf01f124b09677$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        oldValue: oldValue,
        receiver: receiver,
        type: 'set'
    });
    return result;
}
function $ddbf01f124b09677$var$deleteProperty(target, key) {
    // save if the object had the key
    var hadKey = $ddbf01f124b09677$var$hasOwnProperty$1.call(target, key);
    var oldValue = target[key];
    // execute the delete operation before running any reaction
    var result = Reflect.deleteProperty(target, key);
    // only queue reactions for delete operations which resulted in an actual change
    if (hadKey) $ddbf01f124b09677$var$queueReactionsForOperation({
        target: target,
        key: key,
        oldValue: oldValue,
        type: 'delete'
    });
    return result;
}
var $ddbf01f124b09677$var$baseHandlers = {
    get: $ddbf01f124b09677$var$get,
    has: $ddbf01f124b09677$var$has,
    ownKeys: $ddbf01f124b09677$var$ownKeys,
    set: $ddbf01f124b09677$var$set,
    deleteProperty: $ddbf01f124b09677$var$deleteProperty
};
function $ddbf01f124b09677$export$5ab46cbf6120b33a(obj) {
    if (obj === void 0) obj = {};
    // if it is already an observable or it should not be wrapped, return it
    if ($ddbf01f124b09677$var$proxyToRaw.has(obj) || !$ddbf01f124b09677$var$shouldInstrument(obj)) return obj;
    // if it already has a cached observable wrapper, return it
    // otherwise create a new observable
    return $ddbf01f124b09677$var$rawToProxy.get(obj) || $ddbf01f124b09677$var$createObservable(obj);
}
function $ddbf01f124b09677$var$createObservable(obj) {
    // if it is a complex built-in object or a normal object, wrap it
    var handlers = $ddbf01f124b09677$var$getHandlers(obj) || $ddbf01f124b09677$var$baseHandlers;
    var observable = new Proxy(obj, handlers);
    // save these to switch between the raw object and the wrapped object with ease later
    $ddbf01f124b09677$var$rawToProxy.set(obj, observable);
    $ddbf01f124b09677$var$proxyToRaw.set(observable, obj);
    // init basic data structures to save and cleanup later (observable.prop -> reaction) connections
    $ddbf01f124b09677$var$storeObservable(obj);
    return observable;
}
function $ddbf01f124b09677$export$5cd057a6046189f9(obj) {
    return $ddbf01f124b09677$var$proxyToRaw.has(obj);
}
function $ddbf01f124b09677$export$1776c186c69df29e(obj) {
    return $ddbf01f124b09677$var$proxyToRaw.get(obj) || obj;
}

});

parcelRegister("lhBiP", function(module, exports) {

$parcel$export(module.exports, "ComponentTooltip", function () { return $98a272bf512b5674$export$5e82891434456073; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");

var $eQCFs = parcelRequire("eQCFs");

var $aw3OS = parcelRequire("aw3OS");

var $7ewsz = parcelRequire("7ewsz");

var $5m1WU = parcelRequire("5m1WU");
var $98a272bf512b5674$export$5e82891434456073 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentTooltip(component, template, preference, noAnimation) {
        var _this = this;
        (0, $3CDbU._)(this, ComponentTooltip);
        var _this1 = this;
        this.component = component;
        this.hoverDelay = 0;
        this.leaveDelay = 0;
        this.time = performance.now();
        this.noAnimation = noAnimation;
        this.preference = preference;
        this.tooltipComponent = new (0, $9gCL8.Component)();
        //language=HTML
        this.tooltipComponent.template = '\n            <div class="'.concat($aw3OS.tooltip, '">\n                <div class="').concat($aw3OS.content, '">\n                    ').concat(typeof template == "string" ? template : this.tooltipComponent.draw(template()), '\n                </div>\n                <div class="').concat($aw3OS.arrow, '"></div>\n            </div>\n        ');
        (0, $eQCFs.SedestralInterface).main.render(this.tooltipComponent);
        (0, $eQCFs.SedestralInterface).main.removeChildren(this.tooltipComponent);
        this.component.onLeave(/*#__PURE__*/ (0, $hWZw8._)(function() {
            return (0, $eJDpD.__generator)(this, function(_state) {
                return [
                    2,
                    _this1.dispose()
                ];
            });
        }));
        this.tooltipComponent.putListener(window, "resize", function() {
            return _this.replace();
        });
        this.tooltipComponent.putListener(window, "scroll", function() {
            return _this.replace();
        }, true);
        this.place();
    }
    (0, $jyA4z._)(ComponentTooltip, [
        {
            key: "place",
            value: function place(replace) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var tooltipOffsets, places, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, placeFunc, err;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(_this.preference){
                                    case "left":
                                        _this.placeLeft();
                                        break;
                                    case "leftTop":
                                        _this.placeLeftTop();
                                        break;
                                    case "rightTop":
                                        _this.placeRightTop();
                                        break;
                                    case "right":
                                        _this.placeRight();
                                        break;
                                    case "bottom":
                                        _this.placeBottom();
                                        break;
                                    default:
                                        _this.placeTop();
                                        break;
                                }
                                tooltipOffsets = (0, $7ewsz.elementOffsets)(_this.tooltipComponent.element);
                                if (!_this.isOutside(tooltipOffsets)) return [
                                    3,
                                    8
                                ];
                                places = [
                                    "placeTop",
                                    "placeRight",
                                    "placeBottom",
                                    "placeLeft"
                                ];
                                if (_this.preference == "leftTop") places = [
                                    "placeTop",
                                    "placeLeft",
                                    "placeBottom",
                                    "placeRight"
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = places[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                placeFunc = _step.value;
                                return [
                                    4,
                                    _this[placeFunc]()
                                ];
                            case 3:
                                _state.sent();
                                tooltipOffsets = (0, $7ewsz.elementOffsets)(_this.tooltipComponent.element);
                                if (!_this.isOutside(tooltipOffsets)) return [
                                    3,
                                    5
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                if (!_this.noAnimation) {
                                    if (!replace) {
                                        _this.tooltipComponent.setStyle("opacity:0;transform:scale(0.9);");
                                        _this.tooltipComponent.translate({
                                            delay: 40,
                                            opacity: 1,
                                            scale: 1
                                        });
                                    } else _this.tooltipComponent.setStyle("transition-duration: 0s;");
                                } else _this.tooltipComponent.setStyle("transition-duration: 0s;opacity:1;transform:scale(1);");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "replace",
            value: function replace() {
                var timeNow = performance.now();
                if (timeNow - 1 > this.time) {
                    this.time = timeNow;
                    this.place(true);
                }
            }
        },
        {
            key: "placeTop",
            value: function placeTop() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.tooltipComponent.promise(function(resolve) {
                                var offsets = (0, $7ewsz.elementOffsets)(_this.component.element);
                                var left = offsets.left + (_this.component.getWidth() / 2 - _this.tooltipComponent.getWidth() / 2);
                                var top = offsets.top - _this.tooltipComponent.getHeight() - 8;
                                _this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                                    var top = offsets.top - _this.tooltipComponent.getHeight() - 8;
                                    _this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                                    resolve(undefined);
                                });
                                _this.placeArrowTop();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "placeBottom",
            value: function placeBottom() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var left = offsets.left + (this.component.getWidth() / 2 - this.tooltipComponent.getWidth() / 2);
                var top = offsets.top + this.component.getHeight() + 8;
                this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                this.placeArrowBottom();
            }
        },
        {
            key: "placeLeftTop",
            value: function placeLeftTop() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var left = offsets.left;
                var top = offsets.top - this.tooltipComponent.getHeight() - 8;
                this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                this.placeArrowLeftTop();
            }
        },
        {
            key: "placeRightTop",
            value: function placeRightTop() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var left = offsets.left + this.component.getWidth() - this.tooltipComponent.getWidth();
                var top = offsets.top - this.tooltipComponent.getHeight() - 8;
                this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                this.placeArrowRightTop();
            }
        },
        {
            key: "placeLeft",
            value: function placeLeft() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var left = offsets.left - this.tooltipComponent.getWidth() - 8;
                var top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
                this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                this.placeArrowLeft();
            }
        },
        {
            key: "placeRight",
            value: function placeRight() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var left = offsets.left + this.component.getWidth() + 8;
                var top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
                this.tooltipComponent.setStyle("left:".concat(left, "px;top:").concat(top, "px;"));
                this.placeArrowRight();
            }
        },
        {
            key: "placeArrowLeft",
            value: function placeArrowLeft() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var tooltipOffsets = (0, $7ewsz.elementOffsets)(this.tooltipComponent.element);
                this.tooltipComponent.el($aw3OS.arrow).setStyle("right:-5px;left:unset;bottom:unset;top:".concat(offsets.top - tooltipOffsets.top + (this.component.getHeight() / 2 - 5), "px"));
            }
        },
        {
            key: "placeArrowLeftTop",
            value: function placeArrowLeftTop() {
                var left = this.tooltipComponent.getWidth() / 2 - 5;
                this.tooltipComponent.el($aw3OS.arrow).setStyle("bottom:-5px;right:unset;top:unset;left:".concat(left > 15 ? 15 : left, "px"));
            }
        },
        {
            key: "placeArrowRightTop",
            value: function placeArrowRightTop() {
                var left = this.tooltipComponent.getWidth() / 2 - 5;
                this.tooltipComponent.el($aw3OS.arrow).setStyle("bottom:-5px;right:unset;top:unset;right:".concat(left > 15 ? 15 : left, "px"));
            }
        },
        {
            key: "placeArrowRight",
            value: function placeArrowRight() {
                this.placeArrowLeft();
                this.tooltipComponent.el($aw3OS.arrow).setStyle("left:-5px;right:unset;");
            }
        },
        {
            key: "placeArrowTop",
            value: function placeArrowTop() {
                var offsets = (0, $7ewsz.elementOffsets)(this.component.element);
                var tooltipOffsets = (0, $7ewsz.elementOffsets)(this.tooltipComponent.element);
                this.tooltipComponent.el($aw3OS.arrow).setStyle("bottom:-5px;right:unset;top:unset;left:".concat(offsets.left - tooltipOffsets.left + (this.component.getWidth() / 2 - 5), "px"));
            }
        },
        {
            key: "placeArrowBottom",
            value: function placeArrowBottom() {
                this.placeArrowTop();
                this.tooltipComponent.el($aw3OS.arrow).setStyle("bottom:unset;top:-5px");
            }
        },
        {
            key: "isOutside",
            value: function isOutside(offsets) {
                return offsets.top < -1 || offsets.left < -1 || offsets.right < -1 || offsets.bottom < -1;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.noAnimation) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.tooltipComponent.translate({
                                        delay: 40,
                                        opacity: 0,
                                        scale: 0.9
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!_this.tooltipComponent.isNull()) _this.tooltipComponent.remove();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ComponentTooltip;
}();

});
parcelRegister("aw3OS", function(module, exports) {

$parcel$export(module.exports, "tooltip", function () { return $7a7fdb0d48eed9bd$export$4e6f96734dfe12f4; }, function (v) { return $7a7fdb0d48eed9bd$export$4e6f96734dfe12f4 = v; });
$parcel$export(module.exports, "arrow", function () { return $7a7fdb0d48eed9bd$export$f2120bbfa5450bd2; }, function (v) { return $7a7fdb0d48eed9bd$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "content", function () { return $7a7fdb0d48eed9bd$export$a7db06668cad9adb; }, function (v) { return $7a7fdb0d48eed9bd$export$a7db06668cad9adb = v; });
var $7a7fdb0d48eed9bd$export$4e6f96734dfe12f4;
var $7a7fdb0d48eed9bd$export$f2120bbfa5450bd2;
var $7a7fdb0d48eed9bd$export$a7db06668cad9adb;
$7a7fdb0d48eed9bd$export$4e6f96734dfe12f4 = "k4BLk";
$7a7fdb0d48eed9bd$export$f2120bbfa5450bd2 = "R0ByI";
$7a7fdb0d48eed9bd$export$a7db06668cad9adb = "B1zGi";

});

parcelRegister("7ewsz", function(module, exports) {

$parcel$export(module.exports, "elementOffsets", function () { return $37ba064414e92b12$export$ee0dccb429ca5135; });
function $37ba064414e92b12$export$ee0dccb429ca5135(element) {
    if (element instanceof HTMLElement) {
        var offsets = element.getBoundingClientRect();
        return {
            top: offsets.top,
            left: offsets.left,
            right: window.innerWidth - (offsets.left + element.clientWidth),
            bottom: window.innerHeight - (offsets.top + element.clientHeight)
        };
    }
}

});


parcelRegister("irlxW", function(module, exports) {

$parcel$export(module.exports, "ComponentSwapBar", function () { return $ec43a08f3bcc93e3$export$db3c68524c9422f3; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $gzyc4 = parcelRequire("gzyc4");

var $9a4uU = parcelRequire("9a4uU");
var $ec43a08f3bcc93e3$export$db3c68524c9422f3 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentSwapBar(component, onDispose) {
        (0, $3CDbU._)(this, ComponentSwapBar);
        this.component = component;
        this.onDispose = onDispose;
        this.init();
    }
    (0, $jyA4z._)(ComponentSwapBar, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.component.addClass($gzyc4.swap);
                //language=HTML
                var selector = this.component.prepend('\n            <div swapBar class="'.concat($gzyc4.swapBar, '">\n                <div class="').concat($gzyc4.bar, '"></div>\n            </div>\n        '));
                var swiper = (0, $9a4uU.onSwipe)(selector, this.component);
                swiper.onDown = function() {
                    return _this.onDispose();
                };
            }
        }
    ]);
    return ComponentSwapBar;
}();

});
parcelRegister("gzyc4", function(module, exports) {

$parcel$export(module.exports, "swapBar", function () { return $c10a70633adbc910$export$e77117ea01f7e7b4; }, function (v) { return $c10a70633adbc910$export$e77117ea01f7e7b4 = v; });
$parcel$export(module.exports, "bar", function () { return $c10a70633adbc910$export$d927737047eb3867; }, function (v) { return $c10a70633adbc910$export$d927737047eb3867 = v; });
$parcel$export(module.exports, "swap", function () { return $c10a70633adbc910$export$b0e76d9850c64156; }, function (v) { return $c10a70633adbc910$export$b0e76d9850c64156 = v; });
var $c10a70633adbc910$export$e77117ea01f7e7b4;
var $c10a70633adbc910$export$d927737047eb3867;
var $c10a70633adbc910$export$b0e76d9850c64156;
$c10a70633adbc910$export$e77117ea01f7e7b4 = "MHPN0";
$c10a70633adbc910$export$d927737047eb3867 = "SOfAh";
$c10a70633adbc910$export$b0e76d9850c64156 = "JlCaV";

});

parcelRegister("9a4uU", function(module, exports) {

$parcel$export(module.exports, "onSwipe", function () { return $01d6a55d961b3c5c$export$84b1cb3e0372354b; });
/**
 * Swippable
 */ 
var $1JNox = parcelRequire("1JNox");
function $01d6a55d961b3c5c$export$84b1cb3e0372354b(selector, component) {
    return new (0, $1JNox.Swiper)(selector, component ? component : selector);
}

});
parcelRegister("1JNox", function(module, exports) {

$parcel$export(module.exports, "Swiper", function () { return $83ec92fa5e0ae123$export$6b3850921bc5a414; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $lFEFW = parcelRequire("lFEFW");
var $83ec92fa5e0ae123$export$6b3850921bc5a414 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper(selector, component) {
        var _this = this;
        (0, $3CDbU._)(this, Swiper);
        this.yCurrent = 0;
        this.selector = selector;
        component.addListener('touchend', function(evt) {
            var percent = component.getHeight() / 4;
            if (_this.yCurrent > percent) _this.onDown();
            else component.setStyle("bottom:0px !important;transition:0.4s;");
            _this.yCurrent = 0;
        });
        (0, $lFEFW.onDrag)(selector, function(left, top) {
            if (top > 0) {
                _this.yCurrent = top;
                component.setStyle("bottom:calc(".concat(-top, "px - env(safe-area-inset-top)) !important;transition:0s;"));
            }
        });
    }
    (0, $jyA4z._)(Swiper, [
        {
            /**
     * override
     */ key: "onLeft",
            value: function onLeft() {}
        },
        {
            key: "onRight",
            value: function onRight() {}
        },
        {
            key: "onUp",
            value: function onUp() {}
        },
        {
            key: "onDown",
            value: function onDown() {}
        }
    ]);
    return Swiper;
}();

});
parcelRegister("lFEFW", function(module, exports) {

$parcel$export(module.exports, "onDrag", function () { return $918e3a299e1f6002$export$11a07b18d6f8f6d2; });

var $eQCFs = parcelRequire("eQCFs");
function $918e3a299e1f6002$export$11a07b18d6f8f6d2(component, func, onFinish, selector) {
    var initX, initY, mousePressX, mousePressY;
    var down = false;
    var tDown = false;
    var moveListener = undefined;
    var upListener = undefined;
    var tMoveListener = undefined;
    var tUpListener = undefined;
    var componentListener = selector ? selector : component;
    var touchDown = function(e) {
        (0, $eQCFs.SedestralInterface).body.setStyle("user-select:none;");
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = e.touches[0].pageX;
            mousePressY = e.touches[0].pageY;
            tDown = true;
            tMoveListener = componentListener.putListener(window, 'touchmove', move);
            tUpListener = componentListener.putListener(window, 'touchend', touchUp);
        }
    };
    var touchUp = function(e) {
        (0, $eQCFs.SedestralInterface).body.setStyle("user-select:unset;");
        if (tDown) {
            tDown = false;
            componentListener.deleteListener(tMoveListener);
            componentListener.deleteListener(tUpListener);
            if (onFinish) onFinish();
        }
    };
    var mouseDown = function(event) {
        (0, $eQCFs.SedestralInterface).body.setStyle("user-select:none;");
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = event.pageX;
            mousePressY = event.pageY;
            down = true;
            moveListener = componentListener.putListener(window, 'mousemove', move);
            upListener = componentListener.putListener(window, 'mouseup', mouseUp);
        }
    };
    var mouseUp = function() {
        (0, $eQCFs.SedestralInterface).body.setStyle("user-select:unset;");
        if (down) {
            down = false;
            componentListener.deleteListener(moveListener);
            componentListener.deleteListener(upListener);
            if (onFinish) onFinish();
        }
    };
    componentListener.addListener('touchstart', touchDown);
    componentListener.addListener('mousedown', mouseDown);
    var move = function(event) {
        if (tDown) {
            var left = initX + event.touches[0].pageX - mousePressX;
            var top = initY + event.touches[0].pageY - mousePressY;
            func(left, top);
        }
        if (down) {
            var left1 = initX + event.pageX - mousePressX;
            var top1 = initY + event.pageY - mousePressY;
            func(left1, top1);
        }
    };
}

});




parcelRegister("12UO1", function(module, exports) {

$parcel$export(module.exports, "SedestralDebugger", function () { return $0d7d03da3893f3cd$export$455e2f1284cdadf9; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $eQCFs = parcelRequire("eQCFs");

var $gzN0P = parcelRequire("gzN0P");

var $0d7d03da3893f3cd$export$455e2f1284cdadf9 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralDebugger() {
        (0, $3CDbU._)(this, SedestralDebugger);
    }
    (0, $jyA4z._)(SedestralDebugger, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var e;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $gzN0P.config).rumEnabled) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (parcelRequire("sLFOe"))
                                ];
                            case 2:
                                _this.rum = new (_state.sent()).SedestralRum();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                console.error(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                window.onerror = function(error, url, line, column, e) {
                                    /*
            console.log(error);
            console.log(url);
            console.log(line);
            console.log(column);

             */ _this.addError("UNDEFINED", e);
                                };
                                window.onabort = function() {
                                    console.log("abort");
                                };
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addError",
            value: function addError(title, error) {
                if (error) {
                    var _this_rum;
                    var now = performance.now();
                    var listeners = this.listenersLogs.filter(function(value) {
                        return value.time > now - 100;
                    });
                    var trace = listeners.map(function(value) {
                        return value.log;
                    }).join("\n=> ");
                    console.log('%c' + title, 'color: white;font-size:14px;background:red;padding:3px;');
                    if (listeners.length > 0) console.log("=> " + trace);
                    console.error(error);
                    (_this_rum = this.rum) === null || _this_rum === void 0 ? void 0 : _this_rum.error(error, trace);
                }
            }
        },
        {
            key: "eventTarget",
            value: function eventTarget(component, name) {
                var child = (0, $eQCFs.SedestralInterface).components.filter(function(value) {
                    return value.childrens.find(function(value) {
                        return value == component;
                    }) != undefined;
                })[0];
                this.listenersLogs.push({
                    log: "[[" + name + " - " + (child == undefined ? "" : child.constructor.name) + " - " + component.constructor.name + " - " + component.element['className'] + "]]",
                    time: performance.now()
                });
            }
        }
    ]);
    return SedestralDebugger;
}();
$0d7d03da3893f3cd$export$455e2f1284cdadf9.listenersLogs = [];

});

parcelRegister("ijdsc", function(module, exports) {

$parcel$export(module.exports, "elementChildrens", function () { return $9f3e2308144d6ba5$export$7ee75abb6f48dde2; });
/**
 * retourne tous les enfants d'un élément ainsi que lui même
 */ function $9f3e2308144d6ba5$export$7ee75abb6f48dde2(element) {
    var elements = [];
    var childs = element.getElementsByTagName("*");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = childs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            elements.push(child);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    elements.push(element);
    return elements;
}

});

parcelRegister("jRZ1w", function(module, exports) {

$parcel$export(module.exports, "elementNotChildren", function () { return $836f02fc5f1d9454$export$81078fe376cc4110; });
/**
 * Vérifie si un élément n'est pas le fils
 */ function $836f02fc5f1d9454$export$81078fe376cc4110(parent, element) {
    var childrens = Array.from(parent.getElementsByTagName("*"));
    if (element != parent && childrens.indexOf(element) == -1) return true;
}

});

parcelRegister("aufP0", function(module, exports) {

$parcel$export(module.exports, "elementHasClass", function () { return $d0e16b2806c42cc1$export$2122b72d0e83e4af; });
/**
 * Vérifie si un élément a une class
 */ function $d0e16b2806c42cc1$export$2122b72d0e83e4af(classes, name) {
    if (typeof classes == "undefined" || classes == "") return false;
    return !!classes.match(new RegExp('(\\s|^)' + name + '(\\s|$)'));
}

});

parcelRegister("doRa2", function(module, exports) {

$parcel$export(module.exports, "elementParents", function () { return $df9160e1874be90f$export$aedc7b608ca8e855; });
/**
 * Retourne la liste des parents des éléments
 */ function $df9160e1874be90f$export$aedc7b608ca8e855(element) {
    var nodes = [];
    nodes.push(element);
    while(element.parentNode){
        nodes.unshift(element.parentNode);
        element = element.parentNode;
    }
    return nodes;
}

});

parcelRegister("3D7wv", function(module, exports) {

$parcel$export(module.exports, "filterXSS", function () { return $9d6ce4c26b420654$export$95c1dcf5e40cf598; });

var $kSsiO = parcelRequire("kSsiO");
function $9d6ce4c26b420654$export$95c1dcf5e40cf598(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kSsiO))).sanitize(string, {
        USE_PROFILES: {
            html: true
        }
    });
}

});
parcelRegister("kSsiO", function(module, exports) {

var $96jaL = parcelRequire("96jaL");

var $bN2zx = parcelRequire("bN2zx");

var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    'use strict';
    var entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return (0, $96jaL._)(Func, (0, $78NO5._)(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var arraySplice = unapply(Array.prototype.splice);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        var transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(var index = 0; index < array.length; index++){
            var isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        var newObject = create(null);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $bN2zx._)(_step.value, 2), property = _step_value[0], value = _step_value[1];
                var isPropertyExist = objectHasOwnProperty(object, property);
                if (isPropertyExist) {
                    if (Array.isArray(value)) newObject[property] = cleanArray(value);
                    else if (value && (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) === 'object' && value.constructor === Object) newObject[property] = clone(value);
                    else newObject[property] = value;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    var NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if ((typeof trustedTypes === "undefined" ? "undefined" : (0, $7tffA._)(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function(html) {
                    return html;
                },
                createScriptURL: function(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    var _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function(root) {
            return createDOMPurify(root);
        };
        DOMPurify.version = '3.2.4';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var document = window1.document;
        var originalDocument = document;
        var currentScript = originalDocument.currentScript;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window_NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window_NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window_NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var remove = lookupGetter(ElementPrototype, 'remove');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy;
        var emptyHTML = '';
        var implementation = document.implementation, createNodeIterator = document.createNodeIterator, createDocumentFragment = document.createDocumentFragment, getElementsByTagName = document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        var MUSTACHE_EXPR = EXPRESSIONS.MUSTACHE_EXPR, ERB_EXPR = EXPRESSIONS.ERB_EXPR, TMPLIT_EXPR = EXPRESSIONS.TMPLIT_EXPR, DATA_ATTR = EXPRESSIONS.DATA_ATTR, ARIA_ATTR = EXPRESSIONS.ARIA_ATTR, IS_SCRIPT_OR_DATA = EXPRESSIONS.IS_SCRIPT_OR_DATA, ATTR_WHITESPACE = EXPRESSIONS.ATTR_WHITESPACE, CUSTOM_ELEMENT = EXPRESSIONS.CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = EXPRESSIONS.IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, (0, $78NO5._)(html$1).concat((0, $78NO5._)(svg$1), (0, $78NO5._)(svgFilters), (0, $78NO5._)(mathMl$1), (0, $78NO5._)(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, (0, $78NO5._)(html).concat((0, $78NO5._)(svg), (0, $78NO5._)(mathMl), (0, $78NO5._)(xml)));
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE = null;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig() {
            var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || (typeof cfg === "undefined" ? "undefined" : (0, $7tffA._)(cfg)) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, (0, $78NO5._)(svg$1).concat((0, $78NO5._)(svgFilters), (0, $78NO5._)(svgDisallowed)));
        var ALL_MATHML_TAGS = addToSet({}, (0, $78NO5._)(mathMl$1).concat((0, $78NO5._)(mathMlDisallowed)));
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ var _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc = null;
            var leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ var _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ var _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], function(expr) {
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ var _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var _loop = function() {
                var attr = attributes[l];
                var name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                var lcName = transformCaseFunc(name);
                var value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    return "continue";
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) return "continue";
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) return "continue";
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    return "continue";
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], function(expr) {
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) return "continue";
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && (typeof trustedTypes === "undefined" ? "undefined" : (0, $7tffA._)(trustedTypes)) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            };
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            var l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--)_loop();
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode = null;
            var shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body = null;
            var importedNode = null;
            var currentNode = null;
            var returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], function(expr) {
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                var index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});
parcelRegister("96jaL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a038be49179dd96$export$71511d61b312f219; });

var $9OFVA = parcelRequire("9OFVA");

var $eq1Wd = parcelRequire("eq1Wd");
function $6a038be49179dd96$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $9OFVA._)()) $6a038be49179dd96$export$71511d61b312f219 = Reflect.construct;
    else $6a038be49179dd96$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $eq1Wd._)(instance, Class.prototype);
        return instance;
    };
    return $6a038be49179dd96$export$71511d61b312f219.apply(null, arguments);
}

});



parcelRegister("hBVyq", function(module, exports) {

$parcel$export(module.exports, "randomString", function () { return $7f99eedf73741590$export$7fa8378418b4411e; });
/**
 * genere une chaine de caractère aléatoire
 */ function $7f99eedf73741590$export$7fa8378418b4411e(length, numbers) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    if (numbers) characters += "0123456789";
    var charactersLength = characters.length;
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}

});

parcelRegister("gGX81", function(module, exports) {

$parcel$export(module.exports, "randomUUID", function () { return $47304e79c24c5dbe$export$f15387b9ab8915bf; });
/**
 * genere un identifiant UUID
 */ function $47304e79c24c5dbe$export$f15387b9ab8915bf() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});

parcelRegister("abV4P", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $53f329804ee8a0c5$export$d0a8044dce8ff2fc; });
function $53f329804ee8a0c5$export$d0a8044dce8ff2fc() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600;
}

});



parcelRegister("7su1w", function(module, exports) {

$parcel$export(module.exports, "txtSimpleLang", function () { return $85e0782b8857400d$export$9499e98ac7c1c42; });
/**
 * retourne un code unique de langue "fr-Fr" vers "fr"
 */ function $85e0782b8857400d$export$9499e98ac7c1c42(code) {
    return code.includes("-") ? code.split("-")[0] : code;
}

});

parcelRegister("5Co1u", function(module, exports) {

$parcel$export(module.exports, "generateVendor", function () { return $a2ab05ec74a3d335$export$866fc66270dcd090; });
/**
 * generer l'url vendor
 */ function $a2ab05ec74a3d335$export$866fc66270dcd090(domain) {
    return new URL("vendor/", domain).toString();
}

});

parcelRegister("9IvVr", function(module, exports) {

$parcel$export(module.exports, "ProductName", function () { return $034c0807c6a6acde$export$acdfad52bc8c6626; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $co7RM = parcelRequire("co7RM");
var $034c0807c6a6acde$export$acdfad52bc8c6626 = /*#__PURE__*/ function() {
    "use strict";
    function ProductName() {
        (0, $3CDbU._)(this, ProductName);
    }
    (0, $jyA4z._)(ProductName, null, [
        {
            key: "toString",
            value: function toString(type) {
                switch(type){
                    case (0, $co7RM.ProductType).SEDESTRAL:
                        return "sedestral";
                    case (0, $co7RM.ProductType).INBOX:
                        return "inbox";
                    case (0, $co7RM.ProductType).PUBLISHER:
                        return "publisher";
                    case (0, $co7RM.ProductType).STATISTICS:
                        return "statistics";
                    case (0, $co7RM.ProductType).CONTACTS:
                        return "contacts";
                    case (0, $co7RM.ProductType).CHANNELS:
                        return "channels";
                    case (0, $co7RM.ProductType).LIVECHAT:
                        return "livechat";
                    case (0, $co7RM.ProductType).PANEL:
                        return "panel";
                    case (0, $co7RM.ProductType).GENERAL:
                        return "general";
                    case (0, $co7RM.ProductType).CHAT_BOT:
                        return "chatBot";
                    case (0, $co7RM.ProductType).MAILS:
                        return "mails";
                    case (0, $co7RM.ProductType).SELL:
                        return "sell";
                    case (0, $co7RM.ProductType).ENGAGEMENT:
                        return "engagement";
                    case (0, $co7RM.ProductType).ADVERTISING:
                        return "advertising";
                    case (0, $co7RM.ProductType).MAILLING:
                        return "mailling";
                    case (0, $co7RM.ProductType).MEDIAS:
                        return "medias";
                    case (0, $co7RM.ProductType).CALENDAR:
                        return "calendar";
                    case (0, $co7RM.ProductType).DOCUMENTS:
                        return "documents";
                    case (0, $co7RM.ProductType).PRODUCTS:
                        return "products";
                    case (0, $co7RM.ProductType).ESTIMATE:
                        return "estimate";
                    case (0, $co7RM.ProductType).CONTACTS_GREY:
                        return "contactsGrey";
                    case (0, $co7RM.ProductType).INBOX_GREY:
                        return "inboxGrey";
                    case (0, $co7RM.ProductType).PUBLISHER_GREY:
                        return "publisherGrey";
                    case (0, $co7RM.ProductType).HELPCENTER:
                        return "helpCenter";
                    case (0, $co7RM.ProductType).WEBSITE:
                        return "website";
                    case (0, $co7RM.ProductType).CLIENT_SERVICE:
                        return "clientService";
                    case (0, $co7RM.ProductType).BLOG:
                        return "blog";
                    case (0, $co7RM.ProductType).MOBILE:
                        return "mobile";
                    case (0, $co7RM.ProductType).COMMUNITY:
                        return "community";
                    case (0, $co7RM.ProductType).ADMIN:
                        return "admin";
                }
            }
        }
    ]);
    return ProductName;
}();

});


parcelRegister("dI4pn", function(module, exports) {

$parcel$export(module.exports, "IAccountTwoFactorMethod", function () { return $ed1f84644f1403c7$export$195d311003943aa6; });
var $ed1f84644f1403c7$export$195d311003943aa6 = /*#__PURE__*/ function(IAccountTwoFactorMethod) {
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["EMAIL"] = 1] = "EMAIL";
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["TOTP"] = 2] = "TOTP";
    return IAccountTwoFactorMethod;
}({});

});

parcelRegister("aFPFV", function(module, exports) {

$parcel$export(module.exports, "NetworkSocket", function () { return $1a2b1503f1c75e30$export$af02ff68916c531; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3qZ2a = parcelRequire("3qZ2a");

var $7WDX1 = parcelRequire("7WDX1");

var $5m1WU = parcelRequire("5m1WU");

var $lThic = parcelRequire("lThic");
var $1a2b1503f1c75e30$export$af02ff68916c531 = /*#__PURE__*/ function() {
    "use strict";
    function NetworkSocket(host) {
        (0, $3CDbU._)(this, NetworkSocket);
        this.host = host;
        this.events = [];
    }
    (0, $jyA4z._)(NetworkSocket, [
        {
            key: "start",
            value: function start(options) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(/*#__PURE__*/ function() {
                                var _ref = (0, $hWZw8._)(function(started) {
                                    var success;
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.startConnectionTry(options, 0)
                                                ];
                                            case 1:
                                                success = _state.sent();
                                                if (success) _this.socket.on("disconnect", function() {
                                                    if (!_this.logout) _this.onDisconnect();
                                                });
                                                if (success) _this.events.forEach(function(value) {
                                                    return _this.on(value.event, value.func);
                                                });
                                                started(success);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(started) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                })();
            }
        },
        {
            key: "startConnection",
            value: function startConnection(options) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(function(resolve) {
                                try {
                                    _this.logout = false;
                                    _this.socket = new (0, $3qZ2a.NetworkSocketConnection)(options, _this.host);
                                    _this.socket.on("connect", function() {
                                        return resolve(true);
                                    });
                                    _this.socket.on("error", function() {
                                        return resolve(false);
                                    });
                                } catch (e) {
                                    resolve(false);
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "startConnectionTry",
            value: function startConnectionTry(options, attempts) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(/*#__PURE__*/ function() {
                                var _ref = (0, $hWZw8._)(function(resolve) {
                                    var connected;
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(attempts < 3)) return [
                                                    3,
                                                    5
                                                ];
                                                attempts++;
                                                return [
                                                    4,
                                                    _this.startConnection(options)
                                                ];
                                            case 1:
                                                connected = _state.sent();
                                                if (!connected) return [
                                                    3,
                                                    2
                                                ];
                                                _this.on((0, $7WDX1.WebSocketPanelEventName).CONNECTION_ERROR, /*#__PURE__*/ (0, $hWZw8._)(function() {
                                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    (0, $5m1WU.SedestralMachine).sleep(1000)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                resolve(_this.startConnectionTry(options, attempts));
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }));
                                                _this.on((0, $7WDX1.WebSocketPanelEventName).CONNECTION_READY, function(data) {
                                                    (0, $lThic.EntityService).activeEntity.active = data;
                                                    resolve(true);
                                                });
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    (0, $5m1WU.SedestralMachine).sleep(1000)
                                                ];
                                            case 3:
                                                _state.sent();
                                                resolve(_this.startConnectionTry(options, attempts));
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                resolve(false);
                                                _state.label = 6;
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect(logout) {
                this.socket.disconnect();
                this.socket = undefined;
                this.logout = logout;
            }
        },
        {
            key: "emit",
            value: function emit(event, value) {
                this.socket.emit(event, value);
            }
        },
        {
            key: "emitSync",
            value: function emitSync(event, value) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.socket.emitSync(event, value)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(event, func) {
                if (!this.events.find(function(value) {
                    return value.event == event;
                })) this.events.push({
                    event: event,
                    func: func
                });
                if (this.socket) this.socket.on(event, func);
            }
        },
        {
            key: "join",
            value: function join(data, route) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.emitSync(route, data)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeListener",
            value: function removeListener(event) {
                this.socket.removeListener(event);
            }
        },
        {
            /**
     * override
     */ key: "onDisconnect",
            value: function onDisconnect() {}
        }
    ]);
    return NetworkSocket;
}();

});
parcelRegister("3qZ2a", function(module, exports) {

$parcel$export(module.exports, "NetworkSocketConnection", function () { return $cc309a1f97092e23$export$a82946cdc7ec341d; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $5m1WU = parcelRequire("5m1WU");
var $cc309a1f97092e23$export$a82946cdc7ec341d = /*#__PURE__*/ function() {
    "use strict";
    function NetworkSocketConnection(options, host) {
        (0, $3CDbU._)(this, NetworkSocketConnection);
        this.events = [];
        this.disconnectEvents = [];
        this.connectEvents = [];
        this.errorEvents = [];
        var site = options.siteId ? "&site=".concat(options.siteId) : "";
        this.ws = new WebSocket("".concat(host, "/?token=").concat(options.activeToken, "&type=").concat(options.entityType, "&EIO=3&transport=websocket").concat(site));
        this.bind();
    }
    (0, $jyA4z._)(NetworkSocketConnection, [
        {
            key: "bind",
            value: function bind() {
                var _this = this;
                this.ws.onclose = function(data) {
                    _this.disconnectEvents.forEach(function(value) {
                        return value.func(data);
                    });
                    clearInterval(_this.pingInterval);
                };
                this.ws.onopen = function(data) {
                    clearInterval(_this.pingInterval);
                    _this.pingInterval = setInterval(function() {
                        _this.ws.send("2");
                    }, 14000);
                    _this.connectEvents.forEach(function(value) {
                        return value.func(data);
                    });
                };
                this.ws.onerror = function(data) {
                    _this.errorEvents.forEach(function(value) {
                        return value.func(data);
                    });
                    clearInterval(_this.pingInterval);
                };
                this.ws.onmessage = function(message) {
                    //Si on reçoit un ping, on retourne un pong
                    if (message.data == "2") _this.ws.send("3");
                    if (message.data.startsWith("42")) {
                        var decoded = JSON.parse(message.data.substring(2));
                        var events = _this.events.filter(function(value) {
                            return value.id == decoded[0];
                        });
                        events.forEach(function(event) {
                            event.func(decoded[1]);
                        });
                    }
                };
            }
        },
        {
            key: "on",
            value: /**
     * listen
     */ function on(id, func) {
                var event = {
                    id: id,
                    func: func
                };
                switch(id){
                    case "disconnect":
                        this.disconnectEvents.push(event);
                        break;
                    case "error":
                        this.errorEvents.push(event);
                        break;
                    case "connect":
                        this.connectEvents.push(event);
                        break;
                    default:
                        this.events.push(event);
                        break;
                }
                return event;
            }
        },
        {
            key: "emit",
            value: /**
     * emit
     */ function emit(event, value) {
                var array = [
                    event,
                    value
                ];
                var content = "42".concat(JSON.stringify(array));
                this.ws.send(content);
            }
        },
        {
            key: "emitSync",
            value: function emitSync(id, value) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _this.emit(id, value);
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(/*#__PURE__*/ function() {
                                var _ref = (0, $hWZw8._)(function(resolve) {
                                    var event;
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        event = _this.on(id, function(data) {
                                            _this.events.splice(_this.events.indexOf(event), 1);
                                            resolve(data);
                                        });
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(resolve) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                })();
            }
        },
        {
            key: "close",
            value: /**
     * logic
     */ function close() {
                this.ws.close();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.networkOnLogout = true;
                this.ws.close();
            }
        },
        {
            key: "removeListener",
            value: function removeListener(event) {
                this.events = this.events.filter(function(value) {
                    return value.id != event;
                });
            }
        }
    ]);
    return NetworkSocketConnection;
}();

});

parcelRegister("7WDX1", function(module, exports) {

$parcel$export(module.exports, "WebSocketPanelEventName", function () { return $046bf4940e1c2d78$export$379e1fa1a42f4e1e; });

var $3CDbU = parcelRequire("3CDbU");
var $046bf4940e1c2d78$export$379e1fa1a42f4e1e = function WebSocketPanelEventName() {
    "use strict";
    (0, $3CDbU._)(this, WebSocketPanelEventName);
};
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.CONNECTION_READY = "connection/ready";
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.CONNECTION_ERROR = "connection/error";
//collab editor room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_JOIN = "collaboration/editor/join" //compose editor
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_LEAVE = "collaboration/editor/leave" //compose editor
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_ATTACHMENTS = "collaboration/editor/attachments" //compose editor
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_METADATA = "collaboration/editor/metadata" //compose editor
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_JOIN = "collaboration/editor/viewer/join" //compose editor
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_LEAVE = "collaboration/editor/viewer/leave" //compose editor
;
//manage room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_JOIN = "site/join" // receive join
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_LEAVE = "site/leave" // receive leave
;
//site room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_UPDATE = "site/update" //compose site
;
//site and livechat room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_JOIN_ACCOUNT = "site/join/account" //compose joined account
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_LEAVE_ACCOUNT = "site/leave/account" //compose account
;
//inbox room
//no room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_RELOAD = "site/reload" //compose true
;
//site room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ROLE_UPDATE = "role/update" //compose role
;
//set to roles room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ROLE_CREATE = "role/create" //compose role
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ROLE_DELETE = "role/delete" //compose role
;
//no room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ACCOUNT_LOGOUT = "account/logout" //compose true
;
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ACCOUNT_UPDATE = "account/update" //compose account
;
//site room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ACCOUNT_KICK = "account/kick" //compose account
;
// inbox and livechat room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ENTITY_TYPING = "entity/typing" //compose entity typing
;
//site room
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.ENTITY_UPDATE = "entity/update" //compose contact or account
;
//site channel
$046bf4940e1c2d78$export$379e1fa1a42f4e1e.SITE_CHANNEL_UPDATE = "sitechannel/update";

});


parcelRegister("iRchI", function(module, exports) {

$parcel$export(module.exports, "jsonConcat", function () { return $e74d4441c908bfb1$export$18a01edb43e2b5d0; });
/**
 * Concat two json
 */ function $e74d4441c908bfb1$export$18a01edb43e2b5d0(o1, o2) {
    if (!o2) return o1;
    for(var key in o2)o1[key] = o2[key];
    return o1;
}

});

parcelRegister("bXtBT", function(module, exports) {

$parcel$export(module.exports, "randomInteger", function () { return $ad5890360ff0a474$export$3f522a9c938dfb72; });
/**
 * random
 */ /**
 * genere un nombre aléatoire
 */ function $ad5890360ff0a474$export$3f522a9c938dfb72(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

});

parcelRegister("3sBK3", function(module, exports) {

$parcel$export(module.exports, "queryString", function () { return $66aa7a4214f00697$export$ded69dcd8ce7e468; });
/**
 * Transforme du JSON en data pour les requêtes ajax
 */ function $66aa7a4214f00697$export$ded69dcd8ce7e468(object) {
    var data = "";
    var counter = 1;
    Object.keys(object).forEach(function(k) {
        if (object[k] != undefined) {
            data += k + "=" + encodeURIComponent(object[k]) + (counter >= Object.keys(object).length ? "" : "&");
            counter++;
        }
    });
    return data;
}

});


parcelRegister("fIUGb", function(module, exports) {

$parcel$export(module.exports, "AccountService", function () { return $7fa5f14e536758db$export$b662858863b75c61; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $cKMRi = parcelRequire("cKMRi");

var $jaTWB = parcelRequire("jaTWB");

var $igmb3 = parcelRequire("igmb3");

var $7WDX1 = parcelRequire("7WDX1");

var $8FuDB = parcelRequire("8FuDB");

var $lThic = parcelRequire("lThic");

var $co7RM = parcelRequire("co7RM");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $7fa5f14e536758db$export$b662858863b75c61 = /*#__PURE__*/ function() {
    "use strict";
    function AccountService() {
        (0, $3CDbU._)(this, AccountService);
    }
    (0, $jyA4z._)(AccountService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.accounts = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8GOyH.Services).beforeInit(this);
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ACCOUNT_UPDATE, function(data) {
                    _this.store(data);
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ACCOUNT_LOGOUT, function() {
                    location.reload();
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ACCOUNT_KICK, function(data) {
                    var account = _this.store(data);
                    account.siteId = undefined;
                    if (account.id == (0, $lThic.EntityService).activeEntity.id) location.reload();
                });
            }
        },
        {
            key: "create",
            value: /**
     * rest
     */ function create(data, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).TOO_MANY_REQUESTS,
                                        message: (0, $wYO7b.Resources).t("words.accountRegisterToManyRequests")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/account", data, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(name, email, work, numberPhone, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/update", {
                                        name: name,
                                        language: (0, $wYO7b.Resources).language,
                                        email: email,
                                        work: work,
                                        numberPhone: numberPhone
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerTransaction",
            value: function registerTransaction(transactionId, sessionId, component) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/register/transaction", {
                                        transactionId: transactionId,
                                        sessionId: sessionId
                                    }, component)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updatePassword",
            value: function updatePassword(oldPassword, newPassword, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).PASSWORD,
                                        message: (0, $wYO7b.Resources).t("words.account.currentPasswordUnavailable")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/update/password", {
                                        oldPassword: oldPassword,
                                        newPassword: newPassword
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "activity",
            value: function activity(active, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/activity", {
                                        active: active
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findBySiteId",
            value: function findBySiteId(siteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/site/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findRolesBySiteId",
            value: function findRolesBySiteId(siteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/roles/site/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findById",
            value: function findById(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "twoFactorVerify",
            value: function twoFactorVerify(id, token, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/2fa/verify/".concat(id, "/").concat(token), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "twoFactorDisabled",
            value: function twoFactorDisabled(component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/2fa/disable", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "twoFactorEnabled",
            value: function twoFactorEnabled(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/2fa/enable", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountAdmin",
            value: function getAccountAdmin(id, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/admin/" + id, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateEmailNotifyAccountAdmin",
            value: function updateEmailNotifyAccountAdmin(id, state, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/admin/emailNotify/" + id + '/' + state, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateDisplayPromoCodeInputAccountAdmin",
            value: function updateDisplayPromoCodeInputAccountAdmin(id, state, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/admin/displayPromoCodeInput/" + id + '/' + state, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "hasEvent",
            value: function hasEvent(id, event, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/account/event/".concat(id, "/").concat(event), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addEvent",
            value: function addEvent(id, event, component) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/event", {
                                        id: id,
                                        event: event
                                    }, component)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "hasRole",
            value: /**
     * has
     */ function hasRole(account, role) {
                if (account.rolesAccount != undefined) return account.rolesAccount.filter(function(roleAccount) {
                    return roleAccount.role.id == role.id;
                }).length > 0;
                return false;
            }
        },
        {
            key: "requestLogin",
            value: /**
     * logic
     */ function requestLogin(request) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $lThic.EntityService).headersToken(request === null || request === void 0 ? void 0 : request.headers);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).onToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $3Qm5T.Network).onLogin()
                                ];
                            case 2:
                                _state.sent();
                                (0, $3Qm5T.Network).router.onLogin();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAll",
            value: /**
     * get
     */ function getAll() {
                return this.accounts;
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(accounts) {
                for(var key in accounts)accounts[key] = this.store(accounts[key]);
                return (0, $8GOyH.Services).storeAll(accounts);
            }
        },
        {
            key: "store",
            value: function store(account) {
                if (account != undefined) {
                    var _EntityService_activeEntity, _EntityService_activeEntity1;
                    if (account.avatar != undefined) account.avatar = (0, $jaTWB.AvatarService).store(account.avatar);
                    if (account.rolesAccount != undefined) account.rolesAccount = (0, $8FuDB.RoleAccountService).storeAll(account.rolesAccount);
                    account.type = (0, $igmb3.EntityType).ACCOUNT;
                    if (account.id === ((_EntityService_activeEntity = (0, $lThic.EntityService).activeEntity) === null || _EntityService_activeEntity === void 0 ? void 0 : _EntityService_activeEntity.id) && account.email === "") account.email = (_EntityService_activeEntity1 = (0, $lThic.EntityService).activeEntity) === null || _EntityService_activeEntity1 === void 0 ? void 0 : _EntityService_activeEntity1.email;
                    return (0, $8GOyH.Services).store("id", this.accounts, account);
                }
            }
        }
    ]);
    return AccountService;
}();
$7fa5f14e536758db$export$b662858863b75c61.accounts = (0, $j2lF8.observable)([]);

});
parcelRegister("8GOyH", function(module, exports) {

$parcel$export(module.exports, "Services", function () { return $7eb1d32d3a024dcc$export$c447b0cdbd1cd184; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $3Qm5T = parcelRequire("3Qm5T");

var $04j1P = parcelRequire("04j1P");
var $7eb1d32d3a024dcc$export$c447b0cdbd1cd184 = /*#__PURE__*/ function() {
    "use strict";
    function Services() {
        (0, $3CDbU._)(this, Services);
    }
    (0, $jyA4z._)(Services, null, [
        {
            key: "storeAll",
            value: function storeAll(list) {
                if (list == undefined) return undefined;
                return (0, $j2lF8.observable)(list);
            }
        },
        {
            key: "store",
            value: function store(key, array, object) {
                // @ts-ignore
                object = (0, $j2lF8.observable)(object);
                var cache = array.filter(function(a) {
                    return a[key] == object[key];
                })[0];
                if (cache != undefined) {
                    (0, $04j1P.objectUpdate)(cache, object);
                    return cache;
                }
                array.push(object);
                return object;
            }
        },
        {
            key: "unStore",
            value: function unStore(key, array, object) {
                var cache = array.filter(function(a) {
                    return a[key] == object[key];
                })[0];
                if (cache != undefined) {
                    array.splice(array.indexOf(cache), 1);
                    return cache;
                }
                return undefined;
            }
        },
        {
            key: "get",
            value: function get(key, array, value) {
                return array.filter(function(a) {
                    return a[key] == value;
                })[0];
            }
        },
        {
            key: "on",
            value: function on(service, type, event, func) {
                if (!service.socketHandlers) service.socketHandlers = [];
                service.socketHandlers.push({
                    event: event,
                    func: func
                });
                (0, $3Qm5T.Network).on(type, event, func);
            }
        },
        {
            key: "beforeInit",
            value: function beforeInit(service) {
                if (service.socketHandlers && (0, $3Qm5T.Network).getSocket()) {
                    service.socketHandlers.forEach(function(v) {
                        return (0, $3Qm5T.Network).getSocket().removeListener(v.event);
                    });
                    service.socketHandlers = [];
                }
            }
        },
        {
            key: "handleErrors",
            value: function handleErrors(component, errors) {
                if (!component) component = {
                    networkErrorsHandler: [],
                    addNetworkErrors: function(errors) {
                        var _this = this;
                        errors.forEach(function(error) {
                            return _this.networkErrorsHandler.push(error);
                        });
                    }
                };
                if (component && component.networkErrorsHandler.length === 0) component.addNetworkErrors(errors);
            }
        }
    ]);
    return Services;
}();

});
parcelRegister("04j1P", function(module, exports) {

$parcel$export(module.exports, "objectUpdate", function () { return $1b8a58407c1e4426$export$e20c9e8e0502f2a5; });

var $3BzbZ = parcelRequire("3BzbZ");
function $1b8a58407c1e4426$export$e20c9e8e0502f2a5(objectBase, newObject) {
    if (newObject) {
        for(var property in objectBase){
            if (objectBase.hasOwnProperty(property)) {
                if (typeof newObject[property] !== "undefined") {
                    if (!Array.isArray(newObject[property])) {
                        if (objectBase[property] != newObject[property]) objectBase[property] = newObject[property];
                    } else if (!(0, $3BzbZ.arrayEquals)(objectBase[property], newObject[property])) objectBase[property] = newObject[property];
                }
            }
        }
        for(var property1 in newObject){
            if (!objectBase.hasOwnProperty(property1)) {
                if (typeof newObject[property1] !== "undefined") objectBase[property1] = newObject[property1];
            }
        }
    }
    return objectBase;
}

});
parcelRegister("3BzbZ", function(module, exports) {

$parcel$export(module.exports, "arrayEquals", function () { return $cb0a76f66a375b8a$export$22d6d01dd47e89dd; });
/**
 * array
 */ 
var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $d4tYA = parcelRequire("d4tYA");
function $cb0a76f66a375b8a$export$22d6d01dd47e89dd(arr1, arr2) {
    if (arr1 == undefined || arr2 == undefined) return false;
    if (arr1.length != arr2.length) return false;
    if (arr1.length == 0 && arr2.length == 0) return true;
    arr1 = (0, $78NO5._)(arr1);
    arr2 = (0, $78NO5._)(arr2);
    arr1 = arr1.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    arr2 = arr2.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    for(var i = 0; i < arr1.length; i++)if ((0, $7tffA._)(arr1[i]) == "object") {
        if (!(0, $d4tYA.objectEquals)(arr1[i], arr2[i])) return false;
    } else {
        if (arr1[i] != arr2[i]) return false;
    }
    return true;
}

});
parcelRegister("d4tYA", function(module, exports) {

$parcel$export(module.exports, "objectEquals", function () { return $3b98459aef490f3b$export$5b4d20f570fee173; });
/**
 * Vérifie de manière recursif si deux objets sont identique
 */ 
var $7tffA = parcelRequire("7tffA");

var $3BzbZ = parcelRequire("3BzbZ");
function $3b98459aef490f3b$export$5b4d20f570fee173(obj1, obj2) {
    if (obj1 == undefined || obj2 == undefined) return false;
    for(var property in obj1)if (obj1.hasOwnProperty(property)) {
        var value = obj1[property];
        var compareValue = obj2[property];
        if ((typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) == "object") {
            if (!$3b98459aef490f3b$export$5b4d20f570fee173(value, compareValue)) return false;
        } else if (Array.isArray(value)) {
            if (!(0, $3BzbZ.arrayEquals)(value, compareValue)) return false;
        } else {
            if (typeof value === 'string') {
                var valueNumber = Number(value);
                if (!Number.isNaN(valueNumber)) value = valueNumber;
            }
            if (typeof compareValue === 'string') {
                var valueNumber1 = Number(value);
                if (!Number.isNaN(valueNumber1)) compareValue = valueNumber1;
            }
            if (value != compareValue) return false;
        }
    }
    return true;
}

});




parcelRegister("jaTWB", function(module, exports) {

$parcel$export(module.exports, "AvatarService", function () { return $37e9fd5cc50c158d$export$c122ef7a8e25709e; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $38D2A = parcelRequire("38D2A");

var $8zF1W = parcelRequire("8zF1W");

var $lThic = parcelRequire("lThic");
var $37e9fd5cc50c158d$export$c122ef7a8e25709e = /*#__PURE__*/ function() {
    "use strict";
    function AvatarService() {
        (0, $3CDbU._)(this, AvatarService);
    }
    (0, $jyA4z._)(AvatarService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.avatars = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "storeAll",
            value: function storeAll(avatars) {
                for(var key in avatars)avatars[key] = this.store(avatars[key]);
                return (0, $8GOyH.Services).storeAll(avatars);
            }
        },
        {
            key: "store",
            value: function store(avatar) {
                var storedAvatar = (0, $8GOyH.Services).get("id", this.avatars, avatar.id);
                if (storedAvatar != undefined) {
                    if (avatar.file == undefined) storedAvatar.file = undefined;
                    if (avatar.color == undefined) storedAvatar.color = undefined;
                }
                if (avatar.file != undefined) avatar.file = (0, $38D2A.FileService).store(avatar.file);
                if (avatar.color != undefined) avatar.color = (0, $8zF1W.AvatarColorService).store(avatar.color);
                return (0, $8GOyH.Services).store("id", this.avatars, avatar);
            }
        },
        {
            key: "isActive",
            value: function isActive(activeModel) {
                return activeModel["siteId"] != undefined ? activeModel.active && activeModel["siteId"] == (0, $lThic.EntityService).activeSite.id : activeModel.active;
            }
        }
    ]);
    return AvatarService;
}();
$37e9fd5cc50c158d$export$c122ef7a8e25709e.avatars = (0, $j2lF8.observable)([]);

});
parcelRegister("38D2A", function(module, exports) {

$parcel$export(module.exports, "FileService", function () { return $1019abc6d8630f04$export$4adefade6695ab45; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");

var $gzN0P = parcelRequire("gzN0P");
var $1019abc6d8630f04$export$4adefade6695ab45 = /*#__PURE__*/ function() {
    "use strict";
    function FileService() {
        (0, $3CDbU._)(this, FileService);
    }
    (0, $jyA4z._)(FileService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.files = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "create",
            value: /**
     * rest
     */ function create(siteId, origin, files, progress, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postFormData((0, $co7RM.ProductType).PANEL, "/files", {
                                        files: files,
                                        siteId: siteId,
                                        origin: origin
                                    }, component, {
                                        onUploadProgress: function(progressEvent) {
                                            progress(progressEvent.loaded * 100 / progressEvent.total);
                                        }
                                    })
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "link",
            value: /**
     * link
     */ function link(file) {
                return (0, $gzN0P.config).httpPanelUrl + "/files/".concat(file.id, ".").concat(file.extension);
            }
        },
        {
            key: "storeAll",
            value: function storeAll(files) {
                for(var key in files)files[key] = this.store(files[key]);
                return (0, $8GOyH.Services).storeAll(files);
            }
        },
        {
            key: "store",
            value: function store(file) {
                file.link = FileService.link(file);
                return (0, $8GOyH.Services).store("id", this.files, file);
            }
        }
    ]);
    return FileService;
}();
$1019abc6d8630f04$export$4adefade6695ab45.files = (0, $j2lF8.observable)([]);

});

parcelRegister("8zF1W", function(module, exports) {

$parcel$export(module.exports, "AvatarColorService", function () { return $f694740b9ecbd7d5$export$8fd88b7de3288064; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");
var $f694740b9ecbd7d5$export$8fd88b7de3288064 = /*#__PURE__*/ function() {
    "use strict";
    function AvatarColorService() {
        (0, $3CDbU._)(this, AvatarColorService);
    }
    (0, $jyA4z._)(AvatarColorService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.colors = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "storeAll",
            value: function storeAll(colors) {
                for(var key in colors)colors[key] = this.store(colors[key]);
                return (0, $8GOyH.Services).storeAll(colors);
            }
        },
        {
            key: "store",
            value: function store(color) {
                return (0, $8GOyH.Services).store("color", this.colors, color);
            }
        }
    ]);
    return AvatarColorService;
}();
$f694740b9ecbd7d5$export$8fd88b7de3288064.colors = (0, $j2lF8.observable)([]);

});


parcelRegister("igmb3", function(module, exports) {

$parcel$export(module.exports, "EntityType", function () { return $e841b50c0c304516$export$8eda7e02f8f033b2; });
var $e841b50c0c304516$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType[EntityType["ACCOUNT"] = 1] = "ACCOUNT";
    EntityType[EntityType["CONTACT"] = 2] = "CONTACT";
    EntityType[EntityType["CHATBOT"] = 3] = "CHATBOT";
    EntityType[EntityType["EXTERNAL"] = 4] = "EXTERNAL";
    return EntityType;
}({});

});

parcelRegister("8FuDB", function(module, exports) {

$parcel$export(module.exports, "RoleAccountService", function () { return $a6747a7c68a3e304$export$776d4b659cbf7495; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $1cwwH = parcelRequire("1cwwH");

var $co7RM = parcelRequire("co7RM");
var $a6747a7c68a3e304$export$776d4b659cbf7495 = /*#__PURE__*/ function() {
    "use strict";
    function RoleAccountService() {
        (0, $3CDbU._)(this, RoleAccountService);
    }
    (0, $jyA4z._)(RoleAccountService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.accounts = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "delete",
            value: /**
     * http
     */ function _delete(id, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/roles/account/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    true
                                ];
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(accountId, roleId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/roles/account", {
                                        accountId: accountId,
                                        roleId: roleId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(rolesAccount) {
                for(var key in rolesAccount)rolesAccount[key] = this.store(rolesAccount[key]);
                return (0, $8GOyH.Services).storeAll(rolesAccount);
            }
        },
        {
            key: "store",
            value: function store(roleAccount) {
                roleAccount.role = (0, $1cwwH.RoleService).store(roleAccount.role);
                roleAccount = (0, $8GOyH.Services).store("id", this.accounts, roleAccount);
                return roleAccount;
            }
        }
    ]);
    return RoleAccountService;
}();
$a6747a7c68a3e304$export$776d4b659cbf7495.accounts = (0, $j2lF8.observable)([]);

});
parcelRegister("1cwwH", function(module, exports) {

$parcel$export(module.exports, "RoleService", function () { return $e54cc63205be3c7f$export$bb170c807acfe5f; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $7WDX1 = parcelRequire("7WDX1");

var $gpm9v = parcelRequire("gpm9v");

var $lThic = parcelRequire("lThic");

var $6VMpv = parcelRequire("6VMpv");

var $htL4C = parcelRequire("htL4C");

var $co7RM = parcelRequire("co7RM");
var $e54cc63205be3c7f$export$bb170c807acfe5f = /*#__PURE__*/ function() {
    "use strict";
    function RoleService() {
        (0, $3CDbU._)(this, RoleService);
    }
    (0, $jyA4z._)(RoleService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.roles = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8GOyH.Services).beforeInit(this);
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ROLE_UPDATE, function(data) {
                    _this.store(data);
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ROLE_CREATE, function(data) {
                    var role = _this.store(data);
                    _this.roleChange(role);
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).ROLE_DELETE, function(data) {
                    var role = _this.store(data);
                    _this.unStore(role);
                    _this.roleChange(role);
                });
            }
        },
        {
            key: "findBySite",
            value: /**
     * http
     */ function findBySite(siteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/roles/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateRanks",
            value: function updateRanks(siteId, orders, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/roles/update/ranks", {
                                        siteId: siteId,
                                        orders: orders
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updatePermissions",
            value: function updatePermissions(roleId, permissions, siteChannelsIdsInbox, siteChannelsIdsPublisher, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/roles/update/permissions", {
                                        roleId: roleId,
                                        permissions: permissions,
                                        siteChannelsIdsInbox: siteChannelsIdsInbox,
                                        siteChannelsIdsPublisher: siteChannelsIdsPublisher
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.roles;
            }
        },
        {
            key: "update",
            value: function update(roleId, name, color, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/roles/update", {
                                        roleId: roleId,
                                        name: name,
                                        color: color
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(siteId, name, color, model, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request, role;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/roles", {
                                        siteId: siteId,
                                        name: name,
                                        color: color,
                                        model: model
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    role = _this.store(request.data);
                                    _this.roleChange(role);
                                    return [
                                        2,
                                        role
                                    ];
                                }
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(roleId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var role, request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                role = _this.roles.filter(function(role) {
                                    return role.id == roleId;
                                })[0];
                                _this.unStore(role);
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/roles/".concat(roleId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    _this.roleChange(role);
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "duplicate",
            value: function duplicate(roleId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request, role;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/roles/duplicate", {
                                        roleId: roleId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    role = _this.store(request.data);
                                    _this.roleChange(role);
                                    return [
                                        2,
                                        role
                                    ];
                                }
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "maxRank",
            value: /**
     * utilities
     */ function maxRank(account) {
                var maxRank = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = account.rolesAccount.map(function(roleAccount) {
                        return roleAccount.role;
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var role = _step.value;
                        if (role.rank > maxRank) maxRank = role.rank;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return maxRank;
            }
        },
        {
            key: "greater",
            value: function greater(account) {
                var myAccount = (0, $lThic.EntityService).activeEntity;
                var mySite = (0, $lThic.EntityService).activeSite;
                if (myAccount.id == mySite.accountId) return true;
                if (account.id == mySite.accountId) return false;
                if (myAccount.rolesAccount == undefined || myAccount.rolesAccount.length == 0) return false;
                if (account.rolesAccount == undefined || account.rolesAccount.length == 0) return true;
                return this.maxRank(myAccount) > this.maxRank(account);
            }
        },
        {
            key: "can",
            value: function can() {
                for(var _len = arguments.length, permissions = new Array(_len), _key = 0; _key < _len; _key++){
                    permissions[_key] = arguments[_key];
                }
                if ((0, $lThic.EntityService).activeSite == undefined) return false;
                return this.canAccess.apply(this, [
                    (0, $lThic.EntityService).activeEntity
                ].concat((0, $78NO5._)(permissions)));
            }
        },
        {
            key: "updateRole",
            value: function updateRole(role) {
                return this.canUpdateRole((0, $lThic.EntityService).activeEntity, (0, $lThic.EntityService).activeSite, role);
            }
        },
        {
            key: "hasPermission",
            value: function hasPermission(rolesAccounts) {
                for(var _len = arguments.length, permissions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    permissions[_key - 1] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var permission = _step.value;
                        if (rolesAccounts.filter(function(roleAccount) {
                            return roleAccount.role.permissions.includes(permission);
                        }).length > 0) return {
                            v: true
                        };
                    };
                    for(var _iterator = permissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = _loop();
                        if ((0, $7tffA._)(_ret) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "canAccess",
            value: function canAccess(account) {
                for(var _len = arguments.length, permissions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    permissions[_key - 1] = arguments[_key];
                }
                if (account.rolesAccount == undefined) return false;
                if (this.hasPermission(account.rolesAccount, (0, $gpm9v.RolePermissionsType).ADMINISTRATOR)) return true;
                return this.hasPermission.apply(this, [
                    account.rolesAccount
                ].concat((0, $78NO5._)(permissions)));
            }
        },
        {
            key: "canUpdateRole",
            value: function canUpdateRole(account, site, role) {
                if (role.id == site.superRoleId) return false;
                if (account.id == site.accountId) return true;
                return this.maxRank(account) > role.rank;
            }
        },
        {
            key: "avatar",
            value: /**
     * avatar
     */ function avatar(role) {
                return {
                    type: (0, $6VMpv.AvatarType).ROLE,
                    color: {
                        color: role.color
                    }
                };
            }
        },
        {
            key: "roleChange",
            value: /**
     * events
     */ function roleChange(role) {
                this.rolesChange.forEach(function(value) {
                    return value(role);
                });
            }
        },
        {
            key: "onRoleChange",
            value: function onRoleChange(func, component) {
                var _this = this;
                this.rolesChange.push(func);
                component.onRemove(function() {
                    return _this.rolesChange.splice(_this.rolesChange.indexOf(func), 1);
                });
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(roles) {
                for(var key in roles)roles[key] = this.store(roles[key]);
                return (0, $8GOyH.Services).storeAll(roles);
            }
        },
        {
            key: "store",
            value: function store(role) {
                role.siteChannelsInbox = (0, $htL4C.SiteChannelService).storeAll(role.siteChannelsInbox);
                role.siteChannelsPublisher = (0, $htL4C.SiteChannelService).storeAll(role.siteChannelsPublisher);
                role = (0, $8GOyH.Services).store("id", this.roles, role);
                return role;
            }
        },
        {
            key: "unStore",
            value: function unStore(role) {
                (0, $8GOyH.Services).unStore("id", this.roles, role);
            }
        }
    ]);
    return RoleService;
}();
$e54cc63205be3c7f$export$bb170c807acfe5f.roles = (0, $j2lF8.observable)([]);
$e54cc63205be3c7f$export$bb170c807acfe5f.rolesChange = [];

});
parcelRegister("gpm9v", function(module, exports) {

$parcel$export(module.exports, "RolePermissionsType", function () { return $ffe741078c0ed988$export$6f6fd11394c3f5db; });

var $3CDbU = parcelRequire("3CDbU");
var $ffe741078c0ed988$export$6f6fd11394c3f5db = function RolePermissionsType() {
    "use strict";
    (0, $3CDbU._)(this, RolePermissionsType);
};
$ffe741078c0ed988$export$6f6fd11394c3f5db.ADMINISTRATOR = "a";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER_ADMINISTRATOR = "pa";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER_PUBLISH = "be";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER = "p";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER_FACEBOOK_READ = "ba";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER_INSTAGRAM_PAGE_READ = "bb";
$ffe741078c0ed988$export$6f6fd11394c3f5db.PUBLISHER_TWITTER_READ = "bc";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_ADMINISTRATOR = "m";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX = "b";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_ASSIGNMENT = "h";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_FILTERS_PUBLIC = "j";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_SHORTCUTS_PUBLIC = "q";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_FILES = "z";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_CATEGORIES_PUBLIC = "ac";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_EDIT_ALL = "af";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_LIVECHAT_READ = "f";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_MAIL_READ = "ak";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_TWITTER_READ = "bd";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_FACEBOOK_READ = "rfb";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_INSTAGRAM_PAGE_READ = "ris";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_LINKEDIN_READ = "bg";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INBOX_SHOPIFY_READ = "bo";
$ffe741078c0ed988$export$6f6fd11394c3f5db.GENERAL = "c";
$ffe741078c0ed988$export$6f6fd11394c3f5db.ACCOUNT_MANAGE = "g";
$ffe741078c0ed988$export$6f6fd11394c3f5db.INVITATIONS_MANAGE = "k";
$ffe741078c0ed988$export$6f6fd11394c3f5db.SITE_CHANNEL_MANAGE = "l";
$ffe741078c0ed988$export$6f6fd11394c3f5db.SITE_CHANNEL_LIVECHAT_MANAGE = "r";
$ffe741078c0ed988$export$6f6fd11394c3f5db.SITE_CHANNEL_MAILS_MANAGE = "ah";
$ffe741078c0ed988$export$6f6fd11394c3f5db.ROLES_MANAGE = "n";
$ffe741078c0ed988$export$6f6fd11394c3f5db.SITE_MANAGE = "ad";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_ADMINISTRATOR = "s";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_NOTES = "t";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_NOTES_MANAGE = "v";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_PRIVATE_DATA = "aa";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_ACTIVES = "ad";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_BAN = "ae";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_EDIT_DATA = "ag";
$ffe741078c0ed988$export$6f6fd11394c3f5db.CONTACT_CREATE = "bh";
$ffe741078c0ed988$export$6f6fd11394c3f5db.STATISTICS_ADMINISTRATOR = "ab";
$ffe741078c0ed988$export$6f6fd11394c3f5db.STATISTICS_INBOX = "e";
$ffe741078c0ed988$export$6f6fd11394c3f5db.STATISTICS_INBOX_CONVERSATION = "u";
$ffe741078c0ed988$export$6f6fd11394c3f5db.STATISTICS_INBOX_MESSAGES = "w";
$ffe741078c0ed988$export$6f6fd11394c3f5db.STATISTICS_INBOX_MEMBERS = "x";
$ffe741078c0ed988$export$6f6fd11394c3f5db.HELPCENTER_ADMINISTRATOR = "bn";
$ffe741078c0ed988$export$6f6fd11394c3f5db.HELPCENTER_READING = "bp";
$ffe741078c0ed988$export$6f6fd11394c3f5db.HELPCENTER_WRITING = "bq";
$ffe741078c0ed988$export$6f6fd11394c3f5db.HELPCENTER_PUBLISH = "bs";
$ffe741078c0ed988$export$6f6fd11394c3f5db.HELPCENTER_DELETE = "br";
$ffe741078c0ed988$export$6f6fd11394c3f5db.BLOG_ADMINISTRATOR = "bi";
$ffe741078c0ed988$export$6f6fd11394c3f5db.BLOG_READING = "bj";
$ffe741078c0ed988$export$6f6fd11394c3f5db.BLOG_WRITING = "bk";
$ffe741078c0ed988$export$6f6fd11394c3f5db.BLOG_PUBLISH = "bt";
$ffe741078c0ed988$export$6f6fd11394c3f5db.BLOG_DELETE = "bl";
$ffe741078c0ed988$export$6f6fd11394c3f5db.SUBSCRIPTION_ADMINISTRATOR = "bm";

});

parcelRegister("6VMpv", function(module, exports) {

$parcel$export(module.exports, "AvatarType", function () { return $1f9efadc1290022c$export$c11c93bc4a4bfefe; });
var $1f9efadc1290022c$export$c11c93bc4a4bfefe = /*#__PURE__*/ function(AvatarType) {
    AvatarType[AvatarType["ENTITY"] = 1] = "ENTITY";
    AvatarType[AvatarType["ROLE"] = 2] = "ROLE";
    AvatarType[AvatarType["SITE"] = 3] = "SITE";
    AvatarType[AvatarType["SITE_CHANNEL"] = 4] = "SITE_CHANNEL";
    AvatarType[AvatarType["BOT"] = 5] = "BOT";
    AvatarType[AvatarType["MAIL"] = 6] = "MAIL";
    AvatarType[AvatarType["HELP_CENTER"] = 7] = "HELP_CENTER";
    return AvatarType;
}({});

});

parcelRegister("htL4C", function(module, exports) {

$parcel$export(module.exports, "SiteChannelService", function () { return $a1dc042ad90a844e$export$d235de51709f9b1d; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $6m6sO = parcelRequire("6m6sO");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $jaTWB = parcelRequire("jaTWB");

var $dRmI8 = parcelRequire("dRmI8");

var $6VMpv = parcelRequire("6VMpv");

var $lThic = parcelRequire("lThic");

var $dmlE6 = parcelRequire("dmlE6");

var $fIUGb = parcelRequire("fIUGb");

var $co7RM = parcelRequire("co7RM");

var $7WDX1 = parcelRequire("7WDX1");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $a1dc042ad90a844e$export$d235de51709f9b1d = /*#__PURE__*/ function() {
    "use strict";
    function SiteChannelService() {
        (0, $3CDbU._)(this, SiteChannelService);
    }
    (0, $jyA4z._)(SiteChannelService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.siteChannels = (0, $j2lF8.observable)([]);
                this.updates = [];
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8GOyH.Services).beforeInit(this);
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_CHANNEL_UPDATE, function(data) {
                    var update = data;
                    _this.updates.forEach(function(value) {
                        return value(update);
                    });
                });
            }
        },
        {
            key: "findUrlConnectPartner",
            value: function findUrlConnectPartner(invitationId, isLogin, channelType, communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/oauth/url/".concat(channelType, "/").concat(isLogin), {
                                        invitationId: invitationId,
                                        communityId: communityId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    decodeURIComponent(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findBySiteId",
            value: function findBySiteId(siteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/site/channel/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findBySiteIdAndPerms",
            value: function findBySiteIdAndPerms(siteId, product, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/site/channel/perms/".concat(siteId, "/").concat(product), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findByType",
            value: function findByType(channelType, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/site/channel/type/".concat(channelType), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findReliedAccounts",
            value: function findReliedAccounts(siteChannelId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/site/channel/relied/accounts/".concat(siteChannelId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    (0, $fIUGb.AccountService).storeAll(request.data)
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pickedByPerms",
            value: function pickedByPerms(component, channelType) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var siteChannels, siteChannel;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.findBySiteIdAndPerms((0, $lThic.EntityService).activeSite.id, (0, $co7RM.ProductType).INBOX, component)
                                ];
                            case 1:
                                siteChannels = _state.sent();
                                siteChannels = siteChannels.filter(function(value) {
                                    return !channelType || value.channel.type == channelType;
                                });
                                siteChannel = siteChannels.find(function(value) {
                                    return value.id == (0, $dmlE6.PreferencesService).siteChannelPickerSelected;
                                });
                                return [
                                    2,
                                    siteChannel ? siteChannel : siteChannels[0]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var siteChannel, request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                siteChannel = _this.siteChannels.filter(function(value) {
                                    return value.id == id;
                                })[0];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/site/channel/delete", {
                                        id: id
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) _this.unStore(siteChannel);
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).put((0, $co7RM.ProductType).PANEL, "/site/channel/update", {
                                        id: id
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) _this.store(request.data);
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "register",
            value: function register(registerOutgoingModel, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).PARTNER_CONFING_INVALID,
                                        message: (0, $wYO7b.Resources).t("words.partnerConnectionFailed")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).PARTNER_CONFING_PERMISSIONS,
                                        message: registerOutgoingModel.channelType == (0, $dRmI8.ChannelType).SHOPIFY ? (0, $wYO7b.Resources).t("words.shopifyPermissionsMessage") : (0, $wYO7b.Resources).t("words.missingPermissions")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/site/channel/register", registerOutgoingModel, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "avatar",
            value: /**
     * avatar
     */ function avatar(siteChannel) {
                if (siteChannel.avatar) return siteChannel.avatar;
                return {
                    type: (0, $6VMpv.AvatarType).SITE_CHANNEL,
                    color: {
                        color: siteChannel.color
                    }
                };
            }
        },
        {
            key: "onUpdates",
            value: /**
     * ws
     */ function onUpdates(func, component) {
                var _this = this;
                this.updates.push(func);
                component.onRemove(function() {
                    return _this.updates.splice(_this.updates.indexOf(func), 1);
                });
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(siteChannels) {
                for(var key in siteChannels)siteChannels[key] = this.store(siteChannels[key]);
                return (0, $8GOyH.Services).storeAll(siteChannels);
            }
        },
        {
            key: "store",
            value: function store(siteChannel) {
                if (siteChannel.avatar != undefined) siteChannel.avatar = (0, $jaTWB.AvatarService).store(siteChannel.avatar);
                siteChannel.channel = (0, $6m6sO.ChannelService).findById(siteChannel.channelId);
                return siteChannel;
            }
        },
        {
            key: "unStore",
            value: function unStore(siteChannel) {
                (0, $8GOyH.Services).unStore("id", this.siteChannels, siteChannel);
            }
        }
    ]);
    return SiteChannelService;
}();
$a1dc042ad90a844e$export$d235de51709f9b1d.siteChannels = (0, $j2lF8.observable)([]);
$a1dc042ad90a844e$export$d235de51709f9b1d.updates = [];

});
parcelRegister("6m6sO", function(module, exports) {

$parcel$export(module.exports, "ChannelService", function () { return $c5c5d88d669b90d1$export$ad877c9653fa6220; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");
var $c5c5d88d669b90d1$export$ad877c9653fa6220 = /*#__PURE__*/ function() {
    "use strict";
    function ChannelService() {
        (0, $3CDbU._)(this, ChannelService);
    }
    (0, $jyA4z._)(ChannelService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.channels = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "findById",
            value: function findById(id) {
                return ChannelService.channels.find(function(channel) {
                    return channel.id === id;
                });
            }
        },
        {
            key: "findAllByFiter",
            value: function findAllByFiter() {
                return ChannelService.channels.filter(function(channel) {
                    return channel.inboxProperties;
                });
            }
        },
        {
            key: "storeAll",
            value: function storeAll(channels) {
                var _this = this;
                return channels.map(function(value) {
                    return _this.store(value);
                });
            }
        },
        {
            key: "store",
            value: function store(channel) {
                return (0, $8GOyH.Services).store("id", this.channels, channel);
            }
        }
    ]);
    return ChannelService;
}();
$c5c5d88d669b90d1$export$ad877c9653fa6220.channels = (0, $j2lF8.observable)([]);

});

parcelRegister("dRmI8", function(module, exports) {

$parcel$export(module.exports, "ChannelType", function () { return $b05a86e44b8d4fd5$export$36655de2868043ae; });
var $b05a86e44b8d4fd5$export$36655de2868043ae = /*#__PURE__*/ function(ChannelType) {
    ChannelType["LIVECHAT"] = "2e3b69b2999c4c38b45c5076f98e6946";
    ChannelType["TWITTER"] = "200cfded4cfd4bde977f174bc16bc634";
    ChannelType["FACEBOOK"] = "eebf03447dbc46068dd217fcd62e586d";
    ChannelType["LINKEDIN"] = "d7d61128f27a4af7b4bbd78394d65582";
    ChannelType["INSTAGRAM"] = "8d4446321fa7481cb71ddac1d78cd0ct";
    ChannelType["MAIL"] = "25132600ff214f18b623479258eecf38";
    ChannelType["SHOPIFY"] = "t7d61128f27a4bf7b4bbd78394d65572";
    ChannelType["WIX"] = "w7x61128f27a4b4rd4bbd78394d65512";
    ChannelType["WORDPRESS"] = "wwx61128f27a4b45d4bbd78394d65516";
    ChannelType["WEBFLOW"] = "wfx61128f27a4b45d4bbd78394d65519";
    ChannelType["PRESTASHOP"] = "ppx61128f27a4b4rd4bbd78394d65512";
    ChannelType["GOOGLE"] = "1";
    ChannelType["UNKNOWN"] = "0";
    return ChannelType;
}({});
function $b05a86e44b8d4fd5$export$c91bb9fb1b59614a(type) {
    return Object.keys($b05a86e44b8d4fd5$export$36655de2868043ae).find(function(value) {
        return $b05a86e44b8d4fd5$export$36655de2868043ae[value] == type;
    });
}

});

parcelRegister("dmlE6", function(module, exports) {

$parcel$export(module.exports, "PreferencesService", function () { return $f96f27864b823be4$export$cc55b2103fd9a32b; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $cBUb8 = parcelRequire("cBUb8");

var $yJnBa = parcelRequire("yJnBa");
var $f96f27864b823be4$export$cc55b2103fd9a32b = /*#__PURE__*/ function() {
    "use strict";
    function PreferencesService() {
        (0, $3CDbU._)(this, PreferencesService);
    }
    (0, $jyA4z._)(PreferencesService, null, [
        {
            key: "editorSpellChecker",
            get: function get() {
                return this._editorSpellChecker;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_editorSpellChecker", JSON.stringify(value));
                this._editorSpellChecker = value;
            }
        },
        {
            key: "editorLineMode",
            get: function get() {
                return this._editorLineMode;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_editorLineMode", value);
                this._editorLineMode = value;
            }
        },
        {
            key: "mediaVolume",
            get: function get() {
                return this._mediaVolume;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_mediaVolume", "" + value);
                this._mediaVolume = value;
            }
        },
        {
            key: "siteChannelPickerSelected",
            get: function get() {
                return this._siteChannelPickerSelected;
            },
            set: function set(value) {
                this._siteChannelPickerSelected = value;
                if (value == undefined) (0, $yJnBa.SedestralStorage).removeItem("_siteChannelPickerSelected");
                else (0, $yJnBa.SedestralStorage).setItem("_siteChannelPickerSelected", value);
            }
        },
        {
            key: "inboxBodyDetailsClosed",
            get: function get() {
                return this._inboxBodyDetailsClosed;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_inboxBodyDetailsClosed", JSON.stringify(value));
                this._inboxBodyDetailsClosed = value;
            }
        },
        {
            key: "inboxSearchValue",
            get: function get() {
                return this._inboxSearchValue;
            },
            set: function set(value) {
                this._inboxSearchValue = value;
                if (value == undefined) (0, $yJnBa.SedestralStorage).removeItem("_inboxSearchValue");
                else (0, $yJnBa.SedestralStorage).setItem("_inboxSearchValue", value);
            }
        },
        {
            key: "inboxSearchFilterData",
            get: function get() {
                return this._inboxSearchFilterData;
            },
            set: function set(value) {
                this._inboxSearchFilterData = value;
                if (value == undefined) (0, $yJnBa.SedestralStorage).removeItem("_inboxSearchFilterData");
                else (0, $yJnBa.SedestralStorage).setItem("_inboxSearchFilterData", value);
            }
        },
        {
            key: "inboxSearchSort",
            get: function get() {
                return this._inboxSearchSort;
            },
            set: function set(value) {
                this._inboxSearchSort = value;
                if (value == undefined) (0, $yJnBa.SedestralStorage).removeItem("_inboxSearchSort");
                else (0, $yJnBa.SedestralStorage).setItem("_inboxSearchSort", "" + value);
            }
        },
        {
            key: "inboxFilterEntryId",
            get: function get() {
                return this._inboxFilterEntryId;
            },
            set: function set(value) {
                this._inboxFilterEntryId = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterEntryId", value);
            }
        },
        {
            key: "inboxFilterEntryData",
            get: function get() {
                return this._inboxFilterEntryData;
            },
            set: function set(value) {
                this._inboxFilterEntryData = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterEntryData", value);
            }
        },
        {
            key: "inboxFilterEntryName",
            get: function get() {
                return this._inboxFilterEntryName;
            },
            set: function set(value) {
                this._inboxFilterEntryName = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterEntryName", value);
            }
        },
        {
            key: "inboxFilterId",
            get: function get() {
                return this._inboxFilterId;
            },
            set: function set(value) {
                this._inboxFilterId = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterId", value);
            }
        },
        {
            key: "inboxFilterData",
            get: function get() {
                return this._inboxFilterData;
            },
            set: function set(value) {
                this._inboxFilterData = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterData", value);
            }
        },
        {
            key: "inboxFilterName",
            get: function get() {
                return this._inboxFilterName;
            },
            set: function set(value) {
                this._inboxFilterName = value;
                (0, $yJnBa.SedestralStorage).setItem("_inboxFilterName", value);
            }
        },
        {
            key: "contactDetailsSort",
            get: function get() {
                return this._contactDetailsSort;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_contactDetailsSort", value);
                this._contactDetailsSort = value;
            }
        },
        {
            key: "statisticsInboxHomeDays",
            get: function get() {
                return this._statisticsInboxHomeDays;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxHomeDays", "" + value);
                this._statisticsInboxHomeDays = value;
            }
        },
        {
            key: "statisticsInboxConversationFilters",
            get: function get() {
                return this._statisticsInboxConversationFilters == "undefined" || this._statisticsInboxConversationFilters == "null" ? undefined : this._statisticsInboxConversationFilters;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxConversationCountFilters", value);
                this._statisticsInboxConversationFilters = value;
            }
        },
        {
            key: "statisticsInboxMessagesFilters",
            get: function get() {
                return this._statisticsInboxMessagesFilters == "undefined" || this._statisticsInboxMessagesFilters == "null" ? undefined : this._statisticsInboxMessagesFilters;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxMessagesFilters", value);
                this._statisticsInboxMessagesFilters = value;
            }
        },
        {
            key: "statisticsInboxMembersSort",
            get: function get() {
                return this._statisticsInboxMembersSort == "undefined" || this._statisticsInboxMembersSort == "null" ? undefined : this._statisticsInboxMembersSort;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxMembersSort", value);
                this._statisticsInboxMembersSort = value;
            }
        },
        {
            key: "statisticsInboxSplitType",
            get: function get() {
                return this._statisticsInboxSplitType;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxConversationCountSplitType", "" + value);
                this._statisticsInboxSplitType = value;
            }
        },
        {
            key: "statisticsInboxFirstInterval",
            get: function get() {
                return this._statisticsInboxFirstInterval;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxConversationCountFirstInterval", value);
                this._statisticsInboxFirstInterval = value;
            }
        },
        {
            key: "statisticsInboxSecondInterval",
            get: function get() {
                return this._statisticsInboxSecondInterval;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_statisticsInboxConversationCountSecondInterval", value);
                this._statisticsInboxSecondInterval = value;
            }
        },
        {
            key: "timeZoneOffset",
            get: function get() {
                return this._timeZoneOffset;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_timeZoneOffset", "" + value);
                this._timeZoneOffset = value;
            }
        },
        {
            key: "timeZoneName",
            get: function get() {
                return this._timeZoneName;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_timeZoneName", "" + value);
                this._timeZoneName = value;
            }
        },
        {
            key: "hour12",
            get: function get() {
                return this._hour12;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_hour12", JSON.stringify(value));
                this._hour12 = value;
            }
        },
        {
            key: "livechatPopupCloseTime",
            get: function get() {
                return this._livechatPopupCloseTime;
            },
            set: function set(value) {
                (0, $yJnBa.SedestralStorage).setItem("_livechatPopupCloseTime", "" + value);
                this._livechatPopupCloseTime = value;
            }
        },
        {
            key: "init",
            value: function init() {
                this._editorSpellChecker = JSON.parse((0, $yJnBa.SedestralStorage).getItem("_editorSpellChecker"));
                this._editorLineMode = (0, $yJnBa.SedestralStorage).getItem("_editorLineMode");
                this._contactDetailsSort = (0, $yJnBa.SedestralStorage).getItem("_contactDetailsSort");
                this._mediaVolume = (0, $yJnBa.SedestralStorage).getItem("_mediaVolume") == undefined ? 0.5 : parseFloat((0, $yJnBa.SedestralStorage).getItem("_mediaVolume"));
                this._livechatPopupCloseTime = (0, $yJnBa.SedestralStorage).getItem("_livechatPopupCloseTime") == undefined ? 0 : Number((0, $yJnBa.SedestralStorage).getItem("_livechatPopupCloseTime"));
                this._inboxFilterName = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterName") == undefined ? "Inbox" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterName");
                this._inboxFilterEntryName = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryName") == undefined ? "G\xe9n\xe9ral" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryName");
                this._inboxFilterEntryData = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryData") == undefined ? "inbox" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryData");
                this._inboxFilterEntryId = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryId") == undefined ? "inbox" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterEntryId");
                this._inboxSearchValue = (0, $yJnBa.SedestralStorage).getItem("_inboxSearchValue");
                this._siteChannelPickerSelected = (0, $yJnBa.SedestralStorage).getItem("_siteChannelPickerSelected");
                this._inboxSearchSort = (0, $yJnBa.SedestralStorage).getItem("_inboxSearchSort") == undefined ? (0, $cBUb8.OperatorType).ORDER_DESC : parseInt((0, $yJnBa.SedestralStorage).getItem("_inboxSearchSort"));
                this._inboxSearchFilterData = (0, $yJnBa.SedestralStorage).getItem("_inboxSearchFilterData");
                this._inboxFilterId = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterId") == undefined ? "inbox" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterId");
                this._inboxFilterData = (0, $yJnBa.SedestralStorage).getItem("_inboxFilterData") == undefined ? "inbox" : (0, $yJnBa.SedestralStorage).getItem("_inboxFilterData");
                this._inboxBodyDetailsClosed = JSON.parse((0, $yJnBa.SedestralStorage).getItem("_inboxBodyDetailsClosed"));
                this._statisticsInboxHomeDays = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxHomeDays") == undefined ? 7 : parseInt((0, $yJnBa.SedestralStorage).getItem("_statisticsInboxHomeDays"));
                this._statisticsInboxConversationFilters = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxConversationCountFilters");
                this._statisticsInboxMessagesFilters = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxMessagesFilters");
                this._statisticsInboxMembersSort = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxMembersSort");
                this._statisticsInboxSplitType = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType") == undefined ? -1 : parseInt((0, $yJnBa.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType"));
                this._statisticsInboxFirstInterval = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxConversationCountFirstInterval");
                this._statisticsInboxSecondInterval = (0, $yJnBa.SedestralStorage).getItem("_statisticsInboxConversationCountSecondInterval");
                this._timeZoneOffset = new Date().getTimezoneOffset();
                this._timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
                this._hour12 = new Intl.DateTimeFormat().resolvedOptions().hour12;
            }
        },
        {
            key: "dispose",
            value: function dispose() {}
        }
    ]);
    return PreferencesService;
}();

});
parcelRegister("cBUb8", function(module, exports) {

$parcel$export(module.exports, "OperatorType", function () { return $addf98beb4f5977d$export$c18bb9d3f9b808b3; });
var $addf98beb4f5977d$export$c18bb9d3f9b808b3 = /*#__PURE__*/ function(OperatorType) {
    OperatorType[OperatorType["IS"] = 1] = "IS";
    OperatorType[OperatorType["IS_NOT"] = 2] = "IS_NOT";
    OperatorType[OperatorType["CONTAINS_ALL"] = 12] = "CONTAINS_ALL";
    OperatorType[OperatorType["CONTAINS"] = 3] = "CONTAINS";
    OperatorType[OperatorType["NOT_CONTAINS"] = 4] = "NOT_CONTAINS";
    OperatorType[OperatorType["EXIST"] = 5] = "EXIST";
    OperatorType[OperatorType["NOT_EXIST"] = 6] = "NOT_EXIST";
    OperatorType[OperatorType["GREATER"] = 7] = "GREATER";
    OperatorType[OperatorType["AFTER"] = 10] = "AFTER";
    OperatorType[OperatorType["LESS"] = 8] = "LESS";
    OperatorType[OperatorType["BEFORE"] = 9] = "BEFORE";
    OperatorType[OperatorType["STARTS_WITH"] = 16] = "STARTS_WITH";
    OperatorType[OperatorType["ENDS_WITH"] = 17] = "ENDS_WITH";
    OperatorType[OperatorType["ORDER_DESC"] = 14] = "ORDER_DESC";
    OperatorType[OperatorType["ORDER_ASC"] = 15] = "ORDER_ASC";
    OperatorType[OperatorType["INTERVAL"] = 11] = "INTERVAL";
    return OperatorType;
}({});

});






parcelRegister("gFQjy", function(module, exports) {

$parcel$export(module.exports, "Models", function () { return $3b7a7c5a116e0372$export$6edbc060ce567afa; });

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $3b7a7c5a116e0372$export$6edbc060ce567afa = /*#__PURE__*/ function() {
    "use strict";
    function Models() {
        (0, $3CDbU._)(this, Models);
    }
    (0, $jyA4z._)(Models, null, [
        {
            key: "isPreviewModel",
            value: function isPreviewModel(objet) {
                return objet['baseUrl'] != undefined;
            }
        },
        {
            key: "isContactModel",
            value: function isContactModel(object) {
                return object['sessionsCount'] != undefined;
            }
        },
        {
            key: "isMediaModel",
            value: function isMediaModel(object) {
                return object["extension"] != undefined;
            }
        },
        {
            key: "isAccountModel",
            value: function isAccountModel(object) {
                return object['account'] != undefined;
            }
        },
        {
            key: "isEntityModel",
            value: function isEntityModel(object) {
                return this.isAccountModel(object) || this.isContactModel(object);
            }
        }
    ]);
    return Models;
}();

});

parcelRegister("3PS2c", function(module, exports) {

$parcel$export(module.exports, "PreviewService", function () { return $a54a33d932c39519$export$f1f35c887a42c378; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $33FQU = parcelRequire("33FQU");

var $gzN0P = parcelRequire("gzN0P");

var $co7RM = parcelRequire("co7RM");
var $a54a33d932c39519$export$f1f35c887a42c378 = /*#__PURE__*/ function() {
    "use strict";
    function PreviewService() {
        (0, $3CDbU._)(this, PreviewService);
    }
    (0, $jyA4z._)(PreviewService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.previews = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "findByUrl",
            value: /**
     * load
     */ function findByUrl(url, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/preview/get", {
                                        url: url
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "proxyUrl",
            value: function proxyUrl(preview) {
                switch(preview.type){
                    case (0, $33FQU.PreviewType).GIF:
                    case (0, $33FQU.PreviewType).FILE:
                    case (0, $33FQU.PreviewType).AUDIO:
                    case (0, $33FQU.PreviewType).IMAGE:
                    case (0, $33FQU.PreviewType).VIDEO:
                        if (preview.baseUrl != undefined && !this.proxyBypass(preview)) return (0, $gzN0P.config).httpPanelUrl + "/proxy?hash=".concat(preview.id, "&url=").concat(encodeURI(preview.baseUrl));
                        break;
                    case (0, $33FQU.PreviewType).WEBSITE:
                        if (preview.fileUrl != undefined) {
                            console.log(preview.fileUrl);
                            return (0, $gzN0P.config).httpPanelUrl + "/proxy?hash=".concat(preview.id, "&url=").concat(encodeURI(preview.fileUrl));
                        }
                        break;
                }
                return preview.baseUrl;
            }
        },
        {
            key: "proxyBypass",
            value: function proxyBypass(preview) {
                return preview.baseUrl.startsWith((0, $gzN0P.config).tenorMediaHost);
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(previews) {
                for(var key in previews)previews[key] = this.store(previews[key]);
                return (0, $8GOyH.Services).storeAll(previews);
            }
        },
        {
            key: "store",
            value: function store(preview) {
                preview = (0, $8GOyH.Services).store("id", this.previews, preview);
                return preview;
            }
        }
    ]);
    return PreviewService;
}();
$a54a33d932c39519$export$f1f35c887a42c378.previews = (0, $j2lF8.observable)([]);

});
parcelRegister("33FQU", function(module, exports) {

$parcel$export(module.exports, "PreviewType", function () { return $8994bd3e7b7db90f$export$ec949ba0ad63fae4; });
var $8994bd3e7b7db90f$export$ec949ba0ad63fae4 = /*#__PURE__*/ function(PreviewType) {
    PreviewType[PreviewType["WEBSITE"] = 1] = "WEBSITE";
    PreviewType[PreviewType["IMAGE"] = 2] = "IMAGE";
    PreviewType[PreviewType["VIDEO"] = 3] = "VIDEO";
    PreviewType[PreviewType["GIF"] = 4] = "GIF";
    PreviewType[PreviewType["FILE"] = 5] = "FILE";
    PreviewType[PreviewType["AUDIO"] = 6] = "AUDIO";
    return PreviewType;
}({});

});


parcelRegister("1LZ0s", function(module, exports) {

$parcel$export(module.exports, "SiteService", function () { return $57a4d542e8b91072$export$eb480a33ba4bd7a; });

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $7WDX1 = parcelRequire("7WDX1");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $jaTWB = parcelRequire("jaTWB");

var $fIUGb = parcelRequire("fIUGb");

var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");

var $lThic = parcelRequire("lThic");

var $bMhfs = parcelRequire("bMhfs");
var $57a4d542e8b91072$export$eb480a33ba4bd7a = /*#__PURE__*/ function() {
    "use strict";
    function SiteService() {
        (0, $3CDbU._)(this, SiteService);
    }
    (0, $jyA4z._)(SiteService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.sites = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8GOyH.Services).beforeInit(this);
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_JOIN_ACCOUNT, function(data) {
                    return (0, $fIUGb.AccountService).store(data);
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_LEAVE_ACCOUNT, function(data) {
                    var account = (0, $fIUGb.AccountService).store(data);
                    account.siteId = undefined;
                    account.active = false;
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_UPDATE, function(data) {
                    return _this.store(data);
                });
                (0, $8GOyH.Services).on(this, (0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_RELOAD, function() {
                    return _this.onReload();
                });
            }
        },
        {
            key: "findActiveAccounts",
            value: /**
     * http
     */ function findActiveAccounts(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/site/activeAccounts", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    request.data = (0, $fIUGb.AccountService).storeAll(request.data);
                                    return [
                                        2,
                                        request.data
                                    ];
                                }
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findMind",
            value: function findMind(component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/sites/mind", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findStatistics",
            value: function findStatistics(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/sites/statistics", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "select",
            value: function select(siteId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/sites/select", {
                                        siteId: siteId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unSelect",
            value: function unSelect(siteId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/sites/unselect", {
                                        siteId: siteId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(name, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SITE_COUNT_MAX,
                                        message: (0, $wYO7b.Resources).t("words.maxSite")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/sites", {
                                        name: name
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAvatar",
            value: function updateAvatar(files, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postFormData((0, $co7RM.ProductType).PANEL, "/sites/avatar/update", {
                                        files: files
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(name, link, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/sites/update", {
                                        name: name,
                                        link: link
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAddress",
            value: function updateAddress(address, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/sites/update/address", address, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "orderColumns",
            value: function orderColumns(columns, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/sites/column/order", columns, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createColumn",
            value: function createColumn(siteColumn, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/sites/column", siteColumn, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteColumn",
            value: function deleteColumn(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/sites/column/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTaxTypes",
            value: function getTaxTypes(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/sites/taxTypes", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "join",
            value: /**
     * websocket
     */ function join(id) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(id != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).join((0, $co7RM.ProductType).PANEL, id, (0, $7WDX1.WebSocketPanelEventName).SITE_JOIN)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "leave",
            value: function leave(id) {
                (0, $3Qm5T.Network).emit((0, $co7RM.ProductType).PANEL, (0, $7WDX1.WebSocketPanelEventName).SITE_LEAVE, id);
            }
        },
        {
            key: "onReload",
            value: /**
     * override
     */ function onReload() {}
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(conversations) {
                for(var key in conversations)conversations[key] = this.store(conversations[key]);
                return (0, $8GOyH.Services).storeAll(conversations);
            }
        },
        {
            key: "store",
            value: function store(site) {
                if (site != undefined) {
                    if ((0, $lThic.EntityService).activeSite && (0, $lThic.EntityService).activeSite.id == site.id) (0, $lThic.EntityService).activeSite = site;
                    site.avatar = (0, $jaTWB.AvatarService).store(site.avatar);
                    site.paymentProvider = (0, $bMhfs.getPaymentProviderById)(site.paymentProviderType);
                    return (0, $8GOyH.Services).store("id", this.sites, site);
                }
            }
        }
    ]);
    return SiteService;
}();
$57a4d542e8b91072$export$eb480a33ba4bd7a.sites = (0, $j2lF8.observable)([]);

});
parcelRegister("bMhfs", function(module, exports) {

$parcel$export(module.exports, "PaymentProviderType", function () { return $62ddd7de26bc327d$export$d106de282c1be6c1; });
$parcel$export(module.exports, "getPaymentProviderById", function () { return $62ddd7de26bc327d$export$b030ae93ac7cf1ce; });

var $3CDbU = parcelRequire("3CDbU");

var $fEm89 = parcelRequire("fEm89");
var $62ddd7de26bc327d$export$d106de282c1be6c1 = /*#__PURE__*/ function(PaymentProviderType) {
    PaymentProviderType[PaymentProviderType["STRIPE"] = 0] = "STRIPE";
    PaymentProviderType[PaymentProviderType["SHOPIFY"] = 1] = "SHOPIFY";
    return PaymentProviderType;
}($62ddd7de26bc327d$export$d106de282c1be6c1 || {});
var $62ddd7de26bc327d$export$202bc391a3eb96a = function PaymentProvider(id, invoice, cb, address, directDeleteDefinitiveOffer) {
    "use strict";
    (0, $3CDbU._)(this, PaymentProvider);
    this.id = id;
    this.invoice = invoice;
    this.cb = cb;
    this.address = address;
    this.directDeleteDefinitiveOffer = directDeleteDefinitiveOffer;
};
var $62ddd7de26bc327d$export$735606310a3da449 = new $62ddd7de26bc327d$export$202bc391a3eb96a(0, true, true, true, false);
var $62ddd7de26bc327d$export$6da9acb12d5139d4 = new $62ddd7de26bc327d$export$202bc391a3eb96a(1, false, false, false, true);
var $62ddd7de26bc327d$var$_obj;
var $62ddd7de26bc327d$var$paymentProvidersMap = ($62ddd7de26bc327d$var$_obj = {}, (0, $fEm89._)($62ddd7de26bc327d$var$_obj, 0, $62ddd7de26bc327d$export$735606310a3da449), (0, $fEm89._)($62ddd7de26bc327d$var$_obj, 1, $62ddd7de26bc327d$export$6da9acb12d5139d4), $62ddd7de26bc327d$var$_obj);
function $62ddd7de26bc327d$export$b030ae93ac7cf1ce(id) {
    return $62ddd7de26bc327d$var$paymentProvidersMap[id];
}

});



parcelRegister("nHskx", function(module, exports) {


module.exports = (parcelRequire("e3Pk5"))((parcelRequire("kmBYL")).resolve("4yrPJ")).then(function() {
    return parcelRequire('c9GZB');
});

});

parcelRegister("6XDMd", function(module, exports) {

$parcel$export(module.exports, "print", function () { return print; });
$parcel$export(module.exports, "warn", function () { return warn; });
$parcel$export(module.exports, "BOLD", function () { return (parcelRequire("fJDQU")).BOLD; });
$parcel$export(module.exports, "UNBOLD", function () { return (parcelRequire("fJDQU")).UNBOLD; });
$parcel$export(module.exports, "RED", function () { return (parcelRequire("fJDQU")).RED; });
$parcel$export(module.exports, "ORANGE", function () { return (parcelRequire("fJDQU")).ORANGE; });
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 
var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $fEm89 = parcelRequire("fEm89");

var $78NO5 = parcelRequire("78NO5");

var $apk8q = parcelRequire("apk8q");

var $kgvSK = parcelRequire("kgvSK");

var $8QvUL = parcelRequire("8QvUL");

var $7ZzyB = parcelRequire("7ZzyB");

var $5DD1L = parcelRequire("5DD1L");

var $89wqq = parcelRequire("89wqq");

var $lqiw7 = parcelRequire("lqiw7");

var $02E42 = parcelRequire("02E42");

var $fJDQU = parcelRequire("fJDQU");
var _obj;
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ var _browserStyleMap = (_obj = {}, (0, $fEm89._)(_obj, $fJDQU.BOLD, $8QvUL.create('font-weight', 'bold')), (0, $fEm89._)(_obj, $fJDQU.UNBOLD, $8QvUL.create('font-weight', 'normal')), (0, $fEm89._)(_obj, $fJDQU.BLUE, $8QvUL.create('color', 'blue')), (0, $fEm89._)(_obj, $fJDQU.GREEN, $8QvUL.create('color', 'green')), (0, $fEm89._)(_obj, $fJDQU.GREY, $8QvUL.create('color', 'grey')), (0, $fEm89._)(_obj, $fJDQU.RED, $8QvUL.create('color', 'red')), (0, $fEm89._)(_obj, $fJDQU.PURPLE, $8QvUL.create('color', 'purple')), (0, $fEm89._)(_obj, $fJDQU.ORANGE, $8QvUL.create('color', 'orange')), (0, $fEm89._)(_obj, $fJDQU.UNCOLOR, $8QvUL.create('color', 'black')), _obj);
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ var computeBrowserLoggingArgs = function(args) {
    var _args_;
    if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    var strBuilder = [];
    var styles = [];
    var currentStyle = $89wqq.create();
    /**
   * @type {Array<string|Object|number>}
   */ var logArgs = [];
    // try with formatting until we find something unsupported
    var i = 0;
    for(; i < args.length; i++){
        var arg = args[i];
        // @ts-ignore
        var style = _browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                var style1 = $7ZzyB.mapToStyleString(currentStyle);
                if (i > 0 || style1.length > 0) {
                    strBuilder.push('%c' + arg);
                    styles.push(style1);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(''));
    }
    // append the rest
    for(; i < args.length; i++){
        var arg1 = args[i];
        if (!(arg1 instanceof Symbol)) logArgs.push(arg1);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ var computeLoggingArgs = $apk8q.supportsColor ? computeBrowserLoggingArgs : $fJDQU.computeNoColorLoggingArgs;
var print = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).log.apply(_console, (0, $78NO5._)(computeLoggingArgs(args)));
    /* c8 ignore next */ vconsoles.forEach(function(vc) {
        return vc.print(args);
    });
};
var warn = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, (0, $78NO5._)(computeLoggingArgs(args)));
    args.unshift($fJDQU.ORANGE);
    vconsoles.forEach(function(vc) {
        return vc.print(args);
    });
};
var printError = function(err) {
    console.error(err);
    vconsoles.forEach(function(vc) {
        return vc.printError(err);
    });
};
var printImg = function(url, height) {
    if ($apk8q.isBrowser) console.log('%c                      ', "font-size: ".concat(height, "px; background-size: contain; background-repeat: no-repeat; background-image: url(").concat(url, ")"));
    vconsoles.forEach(function(vc) {
        return vc.printImg(url, height);
    });
};
var printImgBase64 = function(base64, height) {
    return printImg("data:image/gif;base64,".concat(base64), height);
};
var group = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).group.apply(_console, (0, $78NO5._)(computeLoggingArgs(args)));
    /* c8 ignore next */ vconsoles.forEach(function(vc) {
        return vc.group(args);
    });
};
var groupCollapsed = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).groupCollapsed.apply(_console, (0, $78NO5._)(computeLoggingArgs(args)));
    /* c8 ignore next */ vconsoles.forEach(function(vc) {
        return vc.groupCollapsed(args);
    });
};
var groupEnd = function() {
    console.groupEnd();
    /* c8 ignore next */ vconsoles.forEach(function(vc) {
        return vc.groupEnd();
    });
};
var printDom = function(createNode) {
    return vconsoles.forEach(function(vc) {
        return vc.printDom(createNode());
    });
};
var printCanvas = function(canvas, height) {
    return printImg(canvas.toDataURL(), height);
};
var vconsoles = $kgvSK.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ var _computeLineSpans = function(args) {
    var spans = [];
    var currentStyle = new Map();
    // try with formatting until we find something unsupported
    var i = 0;
    for(; i < args.length; i++){
        var arg = args[i];
        // @ts-ignore
        var style = _browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = 'undefined ';
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                var span = $7ZzyB.element('span', [
                    $8QvUL.create('style', $7ZzyB.mapToStyleString(currentStyle))
                ], [
                    $7ZzyB.text(arg.toString())
                ]);
                if (span.innerHTML === '') span.innerHTML = '&nbsp;';
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        var content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = ' ' + $5DD1L.stringify(content) + ' ';
            spans.push($7ZzyB.element('span', [], [
                $7ZzyB.text(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ var lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';
var VConsole = /*#__PURE__*/ function() {
    "use strict";
    function VConsole(dom) {
        (0, $3CDbU._)(this, VConsole);
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        vconsoles.add(this);
    }
    (0, $jyA4z._)(VConsole, [
        {
            /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ key: "group",
            value: function group(args) {
                var _this = this;
                var collapsed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                $lqiw7.enqueue(function() {
                    var triangleDown = $7ZzyB.element('span', [
                        $8QvUL.create('hidden', collapsed),
                        $8QvUL.create('style', 'color:grey;font-size:120%;')
                    ], [
                        $7ZzyB.text("\u25BC")
                    ]);
                    var triangleRight = $7ZzyB.element('span', [
                        $8QvUL.create('hidden', !collapsed),
                        $8QvUL.create('style', 'color:grey;font-size:125%;')
                    ], [
                        $7ZzyB.text("\u25B6")
                    ]);
                    var content = $7ZzyB.element('div', [
                        $8QvUL.create('style', "".concat(lineStyle, ";padding-left:").concat(_this.depth * 10, "px"))
                    ], [
                        triangleDown,
                        triangleRight,
                        $7ZzyB.text(' ')
                    ].concat(_computeLineSpans(args)));
                    var nextContainer = $7ZzyB.element('div', [
                        $8QvUL.create('hidden', collapsed)
                    ]);
                    var nextLine = $7ZzyB.element('div', [], [
                        content,
                        nextContainer
                    ]);
                    $7ZzyB.append(_this.ccontainer, [
                        nextLine
                    ]);
                    _this.ccontainer = nextContainer;
                    _this.depth++;
                    // when header is clicked, collapse/uncollapse container
                    $7ZzyB.addEventListener(content, 'click', function(_event) {
                        nextContainer.toggleAttribute('hidden');
                        triangleDown.toggleAttribute('hidden');
                        triangleRight.toggleAttribute('hidden');
                    });
                });
            }
        },
        {
            /**
   * @param {Array<string|Symbol|Object|number>} args
   */ key: "groupCollapsed",
            value: function groupCollapsed(args) {
                this.group(args, true);
            }
        },
        {
            key: "groupEnd",
            value: function groupEnd() {
                var _this = this;
                $lqiw7.enqueue(function() {
                    if (_this.depth > 0) {
                        _this.depth--;
                        // @ts-ignore
                        _this.ccontainer = _this.ccontainer.parentElement.parentElement;
                    }
                });
            }
        },
        {
            /**
   * @param {Array<string|Symbol|Object|number>} args
   */ key: "print",
            value: function print(args) {
                var _this = this;
                $lqiw7.enqueue(function() {
                    $7ZzyB.append(_this.ccontainer, [
                        $7ZzyB.element('div', [
                            $8QvUL.create('style', "".concat(lineStyle, ";padding-left:").concat(_this.depth * 10, "px"))
                        ], _computeLineSpans(args))
                    ]);
                });
            }
        },
        {
            /**
   * @param {Error} err
   */ key: "printError",
            value: function printError(err) {
                this.print([
                    $fJDQU.RED,
                    $fJDQU.BOLD,
                    err.toString()
                ]);
            }
        },
        {
            /**
   * @param {string} url
   * @param {number} height
   */ key: "printImg",
            value: function printImg(url, height) {
                var _this = this;
                $lqiw7.enqueue(function() {
                    $7ZzyB.append(_this.ccontainer, [
                        $7ZzyB.element('img', [
                            $8QvUL.create('src', url),
                            $8QvUL.create('height', "".concat($02E42.round(height * 1.5), "px"))
                        ])
                    ]);
                });
            }
        },
        {
            /**
   * @param {Node} node
   */ key: "printDom",
            value: function printDom(node) {
                var _this = this;
                $lqiw7.enqueue(function() {
                    $7ZzyB.append(_this.ccontainer, [
                        node
                    ]);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                $lqiw7.enqueue(function() {
                    vconsoles["delete"](_this);
                });
            }
        }
    ]);
    return VConsole;
}();
var createVConsole = function(dom) {
    return new VConsole(dom);
};
var createModuleLogger = function(moduleName) {
    return $fJDQU.createModuleLogger(print, moduleName);
};

});
parcelRegister("apk8q", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $793bdb87aa900f97$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getVariable", function () { return $793bdb87aa900f97$export$39fb32ac18db3f88; });
$parcel$export(module.exports, "supportsColor", function () { return $793bdb87aa900f97$export$fcbe44f5d6fcebd; });
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module environment
 */ 
var $bN2zx = parcelRequire("bN2zx");

var $7tffA = parcelRequire("7tffA");

var $89wqq = parcelRequire("89wqq");

var $80Ijr = parcelRequire("80Ijr");

var $WUQnk = parcelRequire("WUQnk");

var $1JGI6 = parcelRequire("1JGI6");

var $1PYZG = parcelRequire("1PYZG");

var $cDSXo = parcelRequire("cDSXo");
var $793bdb87aa900f97$export$8ee0fc9ee280b4ee = typeof $cDSXo !== 'undefined' && $cDSXo.release && /node|io\.js/.test($cDSXo.release.name) && Object.prototype.toString.call(typeof $cDSXo !== 'undefined' ? $cDSXo : 0) === '[object process]';
var $793bdb87aa900f97$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof document !== 'undefined' && !$793bdb87aa900f97$export$8ee0fc9ee280b4ee;
var $793bdb87aa900f97$export$9ac100e40613ea10 = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ var $793bdb87aa900f97$var$params;
var $793bdb87aa900f97$var$args = [];
/* c8 ignore start */ var $793bdb87aa900f97$var$computeParams = function() {
    if ($793bdb87aa900f97$var$params === undefined) {
        if ($793bdb87aa900f97$export$8ee0fc9ee280b4ee) {
            $793bdb87aa900f97$var$params = $89wqq.create();
            var pargs = $cDSXo.argv;
            var currParamName = null;
            for(var i = 0; i < pargs.length; i++){
                var parg = pargs[i];
                if (parg[0] === '-') {
                    if (currParamName !== null) $793bdb87aa900f97$var$params.set(currParamName, '');
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $793bdb87aa900f97$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $793bdb87aa900f97$var$args.push(parg);
            }
            if (currParamName !== null) $793bdb87aa900f97$var$params.set(currParamName, '');
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if ((typeof location === "undefined" ? "undefined" : (0, $7tffA._)(location)) === 'object') {
            $793bdb87aa900f97$var$params = $89wqq.create(); // eslint-disable-next-line no-undef
            (location.search || '?').slice(1).split('&').forEach(function(kv) {
                if (kv.length !== 0) {
                    var _kv_split = (0, $bN2zx._)(kv.split('='), 2), key = _kv_split[0], value = _kv_split[1];
                    $793bdb87aa900f97$var$params.set("--".concat($80Ijr.fromCamelCase(key, '-')), value);
                    $793bdb87aa900f97$var$params.set("-".concat($80Ijr.fromCamelCase(key, '-')), value);
                }
            });
        } else $793bdb87aa900f97$var$params = $89wqq.create();
    }
    return $793bdb87aa900f97$var$params;
};
var $793bdb87aa900f97$export$3ad523d4e4ddff75 = function(name) {
    return $793bdb87aa900f97$var$computeParams().has(name);
};
var $793bdb87aa900f97$export$ecf541e09a511845 = function(name, defaultVal) {
    return $793bdb87aa900f97$var$computeParams().get(name) || defaultVal;
};
var $793bdb87aa900f97$export$39fb32ac18db3f88 = function(name) {
    return $793bdb87aa900f97$export$8ee0fc9ee280b4ee ? $WUQnk.undefinedToNull($cDSXo.env[name.toUpperCase().replaceAll('-', '_')]) : $WUQnk.undefinedToNull($1JGI6.varStorage.getItem(name));
};
var $793bdb87aa900f97$export$137940a4fd07b923 = function(name) {
    return $793bdb87aa900f97$var$computeParams().get('--' + name) || $793bdb87aa900f97$export$39fb32ac18db3f88(name);
};
var $793bdb87aa900f97$export$e336c1d2b3b2390d = function(name) {
    var c = $793bdb87aa900f97$export$137940a4fd07b923(name);
    if (c == null) throw new Error('Expected configuration "'.concat(name.toUpperCase().replaceAll('-', '_'), '"'));
    return c;
};
var $793bdb87aa900f97$export$41f29dc169f5b0eb = function(name) {
    return $793bdb87aa900f97$export$3ad523d4e4ddff75('--' + name) || $793bdb87aa900f97$export$39fb32ac18db3f88(name) !== null;
};
var $793bdb87aa900f97$export$d71d1489bc353e92 = $793bdb87aa900f97$export$41f29dc169f5b0eb('production');
/* c8 ignore next 2 */ var $793bdb87aa900f97$var$forceColor = $793bdb87aa900f97$export$8ee0fc9ee280b4ee && $1PYZG.isOneOf(undefined, [
    'true',
    '1',
    '2'
]);
var $793bdb87aa900f97$export$fcbe44f5d6fcebd = $793bdb87aa900f97$var$forceColor || !$793bdb87aa900f97$export$3ad523d4e4ddff75('--no-colors') && // @todo deprecate --no-colors
!$793bdb87aa900f97$export$41f29dc169f5b0eb('no-color') && (!$793bdb87aa900f97$export$8ee0fc9ee280b4ee || $cDSXo.stdout.isTTY) && (!$793bdb87aa900f97$export$8ee0fc9ee280b4ee || $793bdb87aa900f97$export$3ad523d4e4ddff75('--color') || $793bdb87aa900f97$export$39fb32ac18db3f88('COLORTERM') !== null || ($793bdb87aa900f97$export$39fb32ac18db3f88('TERM') || '').includes('color')) /* c8 ignore stop */ ;

});
parcelRegister("89wqq", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $5ef850fa89867f11$export$185802fd694ee1f5; });
$parcel$export(module.exports, "copy", function () { return $5ef850fa89867f11$export$784d13d8ee351f07; });
$parcel$export(module.exports, "setIfUndefined", function () { return $5ef850fa89867f11$export$dccd489362a8619; });
$parcel$export(module.exports, "map", function () { return $5ef850fa89867f11$export$871de8747c9eaa88; });
$parcel$export(module.exports, "any", function () { return $5ef850fa89867f11$export$4154a199d7d90455; });
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ 
var $bN2zx = parcelRequire("bN2zx");
var $5ef850fa89867f11$export$185802fd694ee1f5 = function() {
    return new Map();
};
var $5ef850fa89867f11$export$784d13d8ee351f07 = function(m) {
    var r = $5ef850fa89867f11$export$185802fd694ee1f5();
    m.forEach(function(v, k) {
        r.set(k, v);
    });
    return r;
};
var $5ef850fa89867f11$export$dccd489362a8619 = function(map, key, createT) {
    var set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
var $5ef850fa89867f11$export$871de8747c9eaa88 = function(m, f) {
    var res = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            res.push(f(value, key));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
};
var $5ef850fa89867f11$export$4154a199d7d90455 = function(m, f) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (f(value, key)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
var $5ef850fa89867f11$export$84bf76cd7afc7469 = function(m, f) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (!f(value, key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};

});

parcelRegister("80Ijr", function(module, exports) {

$parcel$export(module.exports, "fromCharCode", function () { return $5d50b25ae8f480ff$export$30216c0101da0ee0; });
$parcel$export(module.exports, "fromCamelCase", function () { return $5d50b25ae8f480ff$export$87429743646c3257; });
$parcel$export(module.exports, "utf8TextEncoder", function () { return $5d50b25ae8f480ff$export$f3ce4806f2484eb; });
$parcel$export(module.exports, "encodeUtf8", function () { return $5d50b25ae8f480ff$export$8f647c2204da8484; });
$parcel$export(module.exports, "utf8TextDecoder", function () { return $5d50b25ae8f480ff$export$f477633695bbbcd; });
$parcel$export(module.exports, "decodeUtf8", function () { return $5d50b25ae8f480ff$export$72118b85b055afd; });
$parcel$export(module.exports, "repeat", function () { return $5d50b25ae8f480ff$export$76d90c956114f2c2; });

var $397ju = parcelRequire("397ju");
var $5d50b25ae8f480ff$export$30216c0101da0ee0 = String.fromCharCode;
var $5d50b25ae8f480ff$export$73bfc63873071f74 = String.fromCodePoint;
var $5d50b25ae8f480ff$export$e3a9a653b2a11ac1 = $5d50b25ae8f480ff$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ var $5d50b25ae8f480ff$var$toLowerCase = function(s) {
    return s.toLowerCase();
};
var $5d50b25ae8f480ff$var$trimLeftRegex = /^\s*/g;
var $5d50b25ae8f480ff$export$c5557f40488c48ec = function(s) {
    return s.replace($5d50b25ae8f480ff$var$trimLeftRegex, '');
};
var $5d50b25ae8f480ff$var$fromCamelCaseRegex = /([A-Z])/g;
var $5d50b25ae8f480ff$export$87429743646c3257 = function(s, separator) {
    return $5d50b25ae8f480ff$export$c5557f40488c48ec(s.replace($5d50b25ae8f480ff$var$fromCamelCaseRegex, function(match) {
        return "".concat(separator).concat($5d50b25ae8f480ff$var$toLowerCase(match));
    }));
};
var $5d50b25ae8f480ff$export$ba35f6b806a3dbd4 = function(str) {
    return unescape(encodeURIComponent(str)).length;
};
var $5d50b25ae8f480ff$export$83d8cea287b4dfcd = function(str) {
    var encodedString = unescape(encodeURIComponent(str));
    var len = encodedString.length;
    var buf = new Uint8Array(len);
    for(var i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
var $5d50b25ae8f480ff$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
var $5d50b25ae8f480ff$export$9a0a70804ee285dd = function(str) {
    return $5d50b25ae8f480ff$export$f3ce4806f2484eb.encode(str);
};
var $5d50b25ae8f480ff$export$8f647c2204da8484 = $5d50b25ae8f480ff$export$f3ce4806f2484eb ? $5d50b25ae8f480ff$export$9a0a70804ee285dd : $5d50b25ae8f480ff$export$83d8cea287b4dfcd;
var $5d50b25ae8f480ff$export$154b750182ae32cf = function(buf) {
    var remainingLen = buf.length;
    var encodedString = '';
    var bufPos = 0;
    while(remainingLen > 0){
        var nextLen = remainingLen < 10000 ? remainingLen : 10000;
        var bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
var $5d50b25ae8f480ff$export$f477633695bbbcd = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($5d50b25ae8f480ff$export$f477633695bbbcd && $5d50b25ae8f480ff$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $5d50b25ae8f480ff$export$f477633695bbbcd = null;
var $5d50b25ae8f480ff$export$23d5f1ce72f56168 = function(buf) {
    return /** @type {TextDecoder} */ $5d50b25ae8f480ff$export$f477633695bbbcd.decode(buf);
};
var $5d50b25ae8f480ff$export$72118b85b055afd = $5d50b25ae8f480ff$export$f477633695bbbcd ? $5d50b25ae8f480ff$export$23d5f1ce72f56168 : $5d50b25ae8f480ff$export$154b750182ae32cf;
var $5d50b25ae8f480ff$export$869882364835d202 = function(str, index, remove) {
    var insert = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    return str.slice(0, index) + insert + str.slice(index + remove);
};
var $5d50b25ae8f480ff$export$76d90c956114f2c2 = function(source, n) {
    return $397ju.unfold(n, function() {
        return source;
    }).join('');
};

});
parcelRegister("397ju", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $24a7e2a9da500ce5$export$4c7897fafd92b108; });
$parcel$export(module.exports, "appendTo", function () { return $24a7e2a9da500ce5$export$9ceefe31f12a3778; });
$parcel$export(module.exports, "from", function () { return $24a7e2a9da500ce5$export$6788812c4e6611e6; });
$parcel$export(module.exports, "some", function () { return $24a7e2a9da500ce5$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "equalFlat", function () { return $24a7e2a9da500ce5$export$4f1c34abb2bb4c8; });
$parcel$export(module.exports, "unfold", function () { return $24a7e2a9da500ce5$export$c48e357c1a89b78d; });
$parcel$export(module.exports, "isArray", function () { return $24a7e2a9da500ce5$export$43bee75e5e14138e; });
$parcel$export(module.exports, "map", function () { return $24a7e2a9da500ce5$export$871de8747c9eaa88; });
/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
var $kgvSK = parcelRequire("kgvSK");
var $24a7e2a9da500ce5$export$4c7897fafd92b108 = function(arr) {
    return arr[arr.length - 1];
};
var $24a7e2a9da500ce5$export$185802fd694ee1f5 = function() {
    return /** @type {Array<C>} */ [];
};
var $24a7e2a9da500ce5$export$784d13d8ee351f07 = function(a) {
    return /** @type {Array<D>} */ a.slice();
};
var $24a7e2a9da500ce5$export$9ceefe31f12a3778 = function(dest, src) {
    for(var i = 0; i < src.length; i++)dest.push(src[i]);
};
var $24a7e2a9da500ce5$export$6788812c4e6611e6 = Array.from;
var $24a7e2a9da500ce5$export$7ecc1a3b11b57dab = function(arr, f) {
    for(var i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
var $24a7e2a9da500ce5$export$ad14ef4001db2bcd = function(arr, f) {
    for(var i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
var $24a7e2a9da500ce5$export$4f1c34abb2bb4c8 = function(a, b) {
    return a.length === b.length && $24a7e2a9da500ce5$export$7ecc1a3b11b57dab(a, function(item, index) {
        return item === b[index];
    });
};
var $24a7e2a9da500ce5$export$bffa455ba8c619a6 = function(arr) {
    return $24a7e2a9da500ce5$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], function(acc, val) {
        return acc.concat(val);
    });
};
var $24a7e2a9da500ce5$export$c48e357c1a89b78d = function(len, f) {
    var array = new Array(len);
    for(var i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
var $24a7e2a9da500ce5$export$93e2b83da34ff82a = function(arr, seed, folder) {
    return arr.reduce(folder, seed);
};
var $24a7e2a9da500ce5$export$43bee75e5e14138e = Array.isArray;
var $24a7e2a9da500ce5$export$7a5d5c156e7dc406 = function(arr) {
    return $24a7e2a9da500ce5$export$6788812c4e6611e6($kgvSK.from(arr));
};
var $24a7e2a9da500ce5$export$abf0e2545164275f = function(arr, mapper) {
    /**
   * @type {Set<M>}
   */ var happened = $kgvSK.create();
    /**
   * @type {Array<T>}
   */ var result = [];
    for(var i = 0; i < arr.length; i++){
        var el = arr[i];
        var mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
var $24a7e2a9da500ce5$export$871de8747c9eaa88 = function(arr, mapper) {
    /**
   * @type {Array<any>}
   */ var res = Array(arr.length);
    for(var i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};

});
parcelRegister("kgvSK", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $ec0e085a9c6f5165$export$185802fd694ee1f5; });
$parcel$export(module.exports, "from", function () { return $ec0e085a9c6f5165$export$6788812c4e6611e6; });
/**
 * Utility module to work with sets.
 *
 * @module set
 */ var $ec0e085a9c6f5165$export$185802fd694ee1f5 = function() {
    return new Set();
};
var $ec0e085a9c6f5165$export$45b10814cc054894 = function(set) {
    return Array.from(set);
};
var $ec0e085a9c6f5165$export$43128fadae87b74a = function(set) {
    var _set_values_next_value;
    return (_set_values_next_value = set.values().next().value) !== null && _set_values_next_value !== void 0 ? _set_values_next_value : undefined;
};
var $ec0e085a9c6f5165$export$6788812c4e6611e6 = function(entries) {
    return new Set(entries);
};

});



parcelRegister("WUQnk", function(module, exports) {

$parcel$export(module.exports, "undefinedToNull", function () { return $0b1182e19900ca96$export$43874719a1af321f; });
/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ var $0b1182e19900ca96$export$43874719a1af321f = function(v) {
    return v === undefined ? null : v;
};

});

parcelRegister("1JGI6", function(module, exports) {

$parcel$export(module.exports, "varStorage", function () { return $143b1fc62a22b749$export$86b84a8d42aa2c65; });
$parcel$export(module.exports, "onChange", function () { return $143b1fc62a22b749$export$bd913411069e59d3; });
$parcel$export(module.exports, "offChange", function () { return $143b1fc62a22b749$export$ff6a13ad336aa064; });
/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ 
var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $143b1fc62a22b749$var$VarStoragePolyfill = /*#__PURE__*/ function() {
    "use strict";
    function VarStoragePolyfill() {
        (0, $3CDbU._)(this, VarStoragePolyfill);
        this.map = new Map();
    }
    (0, $jyA4z._)(VarStoragePolyfill, [
        {
            /**
   * @param {string} key
   * @param {any} newValue
   */ key: "setItem",
            value: function setItem(key, newValue) {
                this.map.set(key, newValue);
            }
        },
        {
            /**
   * @param {string} key
   */ key: "getItem",
            value: function getItem(key) {
                return this.map.get(key);
            }
        }
    ]);
    return VarStoragePolyfill;
}();
/* c8 ignore stop */ /**
 * @type {any}
 */ var $143b1fc62a22b749$var$_localStorage = new $143b1fc62a22b749$var$VarStoragePolyfill();
var $143b1fc62a22b749$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== 'undefined' && localStorage) {
        $143b1fc62a22b749$var$_localStorage = localStorage;
        $143b1fc62a22b749$var$usePolyfill = false;
    }
} catch (e) {}
var $143b1fc62a22b749$export$86b84a8d42aa2c65 = $143b1fc62a22b749$var$_localStorage;
var $143b1fc62a22b749$export$bd913411069e59d3 = function(eventHandler) {
    return $143b1fc62a22b749$var$usePolyfill || addEventListener('storage', /** @type {any} */ eventHandler);
};
var $143b1fc62a22b749$export$ff6a13ad336aa064 = function(eventHandler) {
    return $143b1fc62a22b749$var$usePolyfill || removeEventListener('storage', /** @type {any} */ eventHandler);
};

});

parcelRegister("1PYZG", function(module, exports) {

$parcel$export(module.exports, "callAll", function () { return $1569ddfdb974f9fb$export$9dd9a52f2dd5b9ce; });
$parcel$export(module.exports, "nop", function () { return $1569ddfdb974f9fb$export$b5f1cfe7b08e6ed5; });
$parcel$export(module.exports, "id", function () { return $1569ddfdb974f9fb$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "equalityDeep", function () { return $1569ddfdb974f9fb$export$2ca9a723affd5d11; });
$parcel$export(module.exports, "isOneOf", function () { return $1569ddfdb974f9fb$export$532a90c0e5e8e48c; });
/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $397ju = parcelRequire("397ju");

var $eCHRC = parcelRequire("eCHRC");
var $1569ddfdb974f9fb$export$9dd9a52f2dd5b9ce = function(fs, args) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    try {
        var _fs;
        for(; i < fs.length; i++)(_fs = fs)[i].apply(_fs, (0, $78NO5._)(args));
    } finally{
        if (i < fs.length) $1569ddfdb974f9fb$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
var $1569ddfdb974f9fb$export$b5f1cfe7b08e6ed5 = function() {};
var $1569ddfdb974f9fb$export$5635d7ef4b8fee1c = function(f) {
    return f();
};
var $1569ddfdb974f9fb$export$d560c7e4a29451c2 = function(a) {
    return a;
};
var $1569ddfdb974f9fb$export$bbb1dcf8c6c6bac1 = function(a, b) {
    return a === b;
};
var $1569ddfdb974f9fb$export$6ca82605a98f2278 = function(a, b) {
    return a === b || a != null && b != null && a.constructor === b.constructor && ($397ju.isArray(a) && $397ju.equalFlat(a, /** @type {Array<T>} */ b) || (typeof a === "undefined" ? "undefined" : (0, $7tffA._)(a)) === 'object' && $eCHRC.equalFlat(a, b));
};
var $1569ddfdb974f9fb$export$2ca9a723affd5d11 = function(a, b) {
    if (a == null || b == null) return $1569ddfdb974f9fb$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(var i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var value = _step.value;
                    if (!b.has(value)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = a.keys()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    if (!b.has(key) || !$1569ddfdb974f9fb$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            break;
        case Object:
            if ($eCHRC.length(a) !== $eCHRC.length(b)) return false;
            for(var key1 in a){
                if (!$eCHRC.hasProperty(a, key1) || !$1569ddfdb974f9fb$export$2ca9a723affd5d11(a[key1], b[key1])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(var i1 = 0; i1 < a.length; i1++){
                if (!$1569ddfdb974f9fb$export$2ca9a723affd5d11(a[i1], b[i1])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
var $1569ddfdb974f9fb$export$532a90c0e5e8e48c = function(value, options) {
    return options.includes(value);
};
var $1569ddfdb974f9fb$export$43bee75e5e14138e = $397ju.isArray;
var $1569ddfdb974f9fb$export$844ec244b1367d54 = function(s) {
    return s && s.constructor === String;
};
var $1569ddfdb974f9fb$export$7e4aa119212bc614 = function(n) {
    return n != null && n.constructor === Number;
};
var $1569ddfdb974f9fb$export$226b3eccf92c9ed9 = function(n, T) {
    return n && n.constructor === T;
};
var $1569ddfdb974f9fb$export$6306e0d85c68df69 = function(T) {
    return(/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ function(n) {
        return n && n.constructor === T;
    });
};

});
parcelRegister("eCHRC", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $aa56a3b9875adb1e$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "forEach", function () { return $aa56a3b9875adb1e$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "map", function () { return $aa56a3b9875adb1e$export$871de8747c9eaa88; });
$parcel$export(module.exports, "length", function () { return $aa56a3b9875adb1e$export$f24224f1c91d8156; });
$parcel$export(module.exports, "isEmpty", function () { return $aa56a3b9875adb1e$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "hasProperty", function () { return $aa56a3b9875adb1e$export$bf9617eaf5d2451; });
$parcel$export(module.exports, "equalFlat", function () { return $aa56a3b9875adb1e$export$4f1c34abb2bb4c8; });
$parcel$export(module.exports, "deepFreeze", function () { return $aa56a3b9875adb1e$export$7e32b29e1cb162e1; });
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ 
var $7tffA = parcelRequire("7tffA");
var $aa56a3b9875adb1e$export$185802fd694ee1f5 = function() {
    return Object.create(null);
};
var $aa56a3b9875adb1e$export$e6e34fd1f2686227 = Object.assign;
var $aa56a3b9875adb1e$export$ed97f33186d4b816 = Object.keys;
var $aa56a3b9875adb1e$export$4b80e395e36b5a56 = function(obj, f) {
    for(var key in obj)f(obj[key], key);
};
var $aa56a3b9875adb1e$export$871de8747c9eaa88 = function(obj, f) {
    var results = [];
    for(var key in obj)results.push(f(obj[key], key));
    return results;
};
var $aa56a3b9875adb1e$export$f24224f1c91d8156 = function(obj) {
    return $aa56a3b9875adb1e$export$ed97f33186d4b816(obj).length;
};
var $aa56a3b9875adb1e$export$346677f925de839c = function(obj) {
    return $aa56a3b9875adb1e$export$ed97f33186d4b816(obj).length;
};
var $aa56a3b9875adb1e$export$ad14ef4001db2bcd = function(obj, f) {
    for(var key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
var $aa56a3b9875adb1e$export$dd1bc94b04021eeb = function(obj) {
    // eslint-disable-next-line
    for(var _k in obj)return false;
    return true;
};
var $aa56a3b9875adb1e$export$7ecc1a3b11b57dab = function(obj, f) {
    for(var key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
var $aa56a3b9875adb1e$export$bf9617eaf5d2451 = function(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $aa56a3b9875adb1e$export$4f1c34abb2bb4c8 = function(a, b) {
    return a === b || $aa56a3b9875adb1e$export$346677f925de839c(a) === $aa56a3b9875adb1e$export$346677f925de839c(b) && $aa56a3b9875adb1e$export$7ecc1a3b11b57dab(a, function(val, key) {
        return (val !== undefined || $aa56a3b9875adb1e$export$bf9617eaf5d2451(b, key)) && b[key] === val;
    });
};
var $aa56a3b9875adb1e$export$792f3d81ea979f55 = Object.freeze;
var $aa56a3b9875adb1e$export$7e32b29e1cb162e1 = function(o) {
    for(var key in o){
        var c = o[key];
        if ((typeof c === "undefined" ? "undefined" : (0, $7tffA._)(c)) === 'object' || typeof c === 'function') $aa56a3b9875adb1e$export$7e32b29e1cb162e1(o[key]);
    }
    return $aa56a3b9875adb1e$export$792f3d81ea979f55(o);
};

});



parcelRegister("8QvUL", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $670befa0bdd0f6b5$export$185802fd694ee1f5; });
$parcel$export(module.exports, "forEach", function () { return $670befa0bdd0f6b5$export$4b80e395e36b5a56; });
/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ 
var $3CDbU = parcelRequire("3CDbU");
var $670befa0bdd0f6b5$export$d63d7cff08fe4dc9 = function Pair(left, right) {
    "use strict";
    (0, $3CDbU._)(this, Pair);
    this.left = left;
    this.right = right;
};
var $670befa0bdd0f6b5$export$185802fd694ee1f5 = function(left, right) {
    return new $670befa0bdd0f6b5$export$d63d7cff08fe4dc9(left, right);
};
var $670befa0bdd0f6b5$export$ca0ea131672c5a9b = function(right, left) {
    return new $670befa0bdd0f6b5$export$d63d7cff08fe4dc9(left, right);
};
var $670befa0bdd0f6b5$export$4b80e395e36b5a56 = function(arr, f) {
    return arr.forEach(function(p) {
        return f(p.left, p.right);
    });
};
var $670befa0bdd0f6b5$export$871de8747c9eaa88 = function(arr, f) {
    return arr.map(function(p) {
        return f(p.left, p.right);
    });
};

});

parcelRegister("7ZzyB", function(module, exports) {

$parcel$export(module.exports, "append", function () { return $5d19cfcb1d937503$export$10d8903dec122b9d; });
$parcel$export(module.exports, "addEventListener", function () { return $5d19cfcb1d937503$export$3f65cefe8380dbea; });
$parcel$export(module.exports, "element", function () { return $5d19cfcb1d937503$export$8454457683f90105; });
$parcel$export(module.exports, "text", function () { return $5d19cfcb1d937503$export$6f093cfa640b7166; });
$parcel$export(module.exports, "mapToStyleString", function () { return $5d19cfcb1d937503$export$7d9cafe158c3b49; });
/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 
var $8QvUL = parcelRequire("8QvUL");

var $89wqq = parcelRequire("89wqq");
var $5d19cfcb1d937503$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== 'undefined' ? document : {};
var $5d19cfcb1d937503$export$c8a8987d4410bf2d = function(name) {
    return $5d19cfcb1d937503$export$2a111da947c407d2.createElement(name);
};
var $5d19cfcb1d937503$export$fb51152cd5328759 = function() {
    return $5d19cfcb1d937503$export$2a111da947c407d2.createDocumentFragment();
};
var $5d19cfcb1d937503$export$b2ce9ad90858ed7a = function(text) {
    return $5d19cfcb1d937503$export$2a111da947c407d2.createTextNode(text);
};
var $5d19cfcb1d937503$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== 'undefined' ? new DOMParser() : null;
var $5d19cfcb1d937503$export$77c9ee5a14f9d7cf = function(el, name, opts) {
    return el.dispatchEvent(new CustomEvent(name, opts));
};
var $5d19cfcb1d937503$export$74da2cba014bdc09 = function(el, attrs) {
    $8QvUL.forEach(attrs, function(key, value) {
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, '');
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
var $5d19cfcb1d937503$export$ba744f7d152abea1 = function(el, attrs) {
    attrs.forEach(function(value, key) {
        el.setAttribute(key, value);
    });
    return el;
};
var $5d19cfcb1d937503$export$f00aeb236b6f05af = function(children) {
    var fragment = $5d19cfcb1d937503$export$fb51152cd5328759();
    for(var i = 0; i < children.length; i++)$5d19cfcb1d937503$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
var $5d19cfcb1d937503$export$10d8903dec122b9d = function(parent, nodes) {
    $5d19cfcb1d937503$export$1b8e57c9ea42f1d2(parent, $5d19cfcb1d937503$export$f00aeb236b6f05af(nodes));
    return parent;
};
var $5d19cfcb1d937503$export$cd7f480d6b8286c3 = function(el) {
    return el.remove();
};
var $5d19cfcb1d937503$export$3f65cefe8380dbea = function(el, name, f) {
    return el.addEventListener(name, f);
};
var $5d19cfcb1d937503$export$8ff9f68337b520c0 = function(el, name, f) {
    return el.removeEventListener(name, f);
};
var $5d19cfcb1d937503$export$40a4ed63e5cb7043 = function(node, listeners) {
    $8QvUL.forEach(listeners, function(name, f) {
        return $5d19cfcb1d937503$export$3f65cefe8380dbea(node, name, f);
    });
    return node;
};
var $5d19cfcb1d937503$export$8c7b13b21690651d = function(node, listeners) {
    $8QvUL.forEach(listeners, function(name, f) {
        return $5d19cfcb1d937503$export$8ff9f68337b520c0(node, name, f);
    });
    return node;
};
var $5d19cfcb1d937503$export$8454457683f90105 = function(name) {
    var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return $5d19cfcb1d937503$export$10d8903dec122b9d($5d19cfcb1d937503$export$74da2cba014bdc09($5d19cfcb1d937503$export$c8a8987d4410bf2d(name), attrs), children);
};
var $5d19cfcb1d937503$export$67ea982130081db = function(width, height) {
    var c = /** @type {HTMLCanvasElement} */ $5d19cfcb1d937503$export$c8a8987d4410bf2d('canvas');
    c.height = height;
    c.width = width;
    return c;
};
var $5d19cfcb1d937503$export$6f093cfa640b7166 = $5d19cfcb1d937503$export$b2ce9ad90858ed7a;
var $5d19cfcb1d937503$export$7f60f118cd3e6292 = function(pair) {
    return "".concat(pair.left, ":").concat(pair.right, ";");
};
var $5d19cfcb1d937503$export$3d24a00500154f45 = function(pairs) {
    return pairs.map($5d19cfcb1d937503$export$7f60f118cd3e6292).join('');
};
var $5d19cfcb1d937503$export$7d9cafe158c3b49 = function(m) {
    return $89wqq.map(m, function(value, key) {
        return "".concat(key, ":").concat(value, ";");
    }).join('');
};
var $5d19cfcb1d937503$export$78fb49a702cc1f2 = function(el, query) {
    return el.querySelector(query);
};
var $5d19cfcb1d937503$export$2e83b5c43fb7af7b = function(el, query) {
    return el.querySelectorAll(query);
};
var $5d19cfcb1d937503$export$83595b84fc78b9b4 = function(id) {
    return /** @type {HTMLElement} */ $5d19cfcb1d937503$export$2a111da947c407d2.getElementById(id);
};
/**
 * @param {string} html
 * @return {HTMLElement}
 */ var $5d19cfcb1d937503$var$_parse = function(html) {
    return $5d19cfcb1d937503$export$fb621bb527230cda.parseFromString("<html><body>".concat(html, "</body></html>"), 'text/html').body;
};
var $5d19cfcb1d937503$export$e1152f5efcc82ad = function(html) {
    return $5d19cfcb1d937503$export$f00aeb236b6f05af(/** @type {any} */ $5d19cfcb1d937503$var$_parse(html).childNodes);
};
var $5d19cfcb1d937503$export$b23064c2dcaf2b63 = function(html) {
    return /** @type HTMLElement */ $5d19cfcb1d937503$var$_parse(html).firstElementChild;
};
var $5d19cfcb1d937503$export$e6a6680780233a77 = function(oldEl, newEl) {
    return oldEl.replaceWith(newEl);
};
var $5d19cfcb1d937503$export$86b68c7dbeb53c22 = function(parent, el, ref) {
    return parent.insertBefore(el, ref);
};
var $5d19cfcb1d937503$export$1b8e57c9ea42f1d2 = function(parent, child) {
    return parent.appendChild(child);
};
var $5d19cfcb1d937503$export$51c8a276ee4b8f51 = $5d19cfcb1d937503$export$2a111da947c407d2.ELEMENT_NODE;
var $5d19cfcb1d937503$export$5bcc40203615fc2e = $5d19cfcb1d937503$export$2a111da947c407d2.TEXT_NODE;
var $5d19cfcb1d937503$export$e5fc6332c1c8eb8e = $5d19cfcb1d937503$export$2a111da947c407d2.CDATA_SECTION_NODE;
var $5d19cfcb1d937503$export$3d597a6ef0f08b0a = $5d19cfcb1d937503$export$2a111da947c407d2.COMMENT_NODE;
var $5d19cfcb1d937503$export$4139dcda4f7f83db = $5d19cfcb1d937503$export$2a111da947c407d2.DOCUMENT_NODE;
var $5d19cfcb1d937503$export$e9e7ddfdb004b848 = $5d19cfcb1d937503$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
var $5d19cfcb1d937503$export$b86725031ae151ee = $5d19cfcb1d937503$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
var $5d19cfcb1d937503$export$1aa65d86db59b879 = function(node, type) {
    return node.nodeType === type;
};
var $5d19cfcb1d937503$export$3c81af374b054d6a = function(parent, child) {
    var p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;

});

parcelRegister("5DD1L", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $41aede4a7b4efd47$export$fac44ee5b035f737; });
/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ var $41aede4a7b4efd47$export$fac44ee5b035f737 = JSON.stringify;
var $41aede4a7b4efd47$export$98e6a39c04603d36 = JSON.parse;

});

parcelRegister("lqiw7", function(module, exports) {

$parcel$export(module.exports, "enqueue", function () { return $f98a63c1bea3b0c4$export$513072ba72100d9c; });
/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ 
var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $f98a63c1bea3b0c4$var$queue = [];
var $f98a63c1bea3b0c4$var$_runQueue = function() {
    for(var i = 0; i < $f98a63c1bea3b0c4$var$queue.length; i++)$f98a63c1bea3b0c4$var$queue[i]();
    $f98a63c1bea3b0c4$var$queue = [];
};
var $f98a63c1bea3b0c4$export$513072ba72100d9c = function(f) {
    $f98a63c1bea3b0c4$var$queue.push(f);
    if ($f98a63c1bea3b0c4$var$queue.length === 1) setTimeout($f98a63c1bea3b0c4$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ var $f98a63c1bea3b0c4$var$createTimeoutClass = function(clearFunction) {
    var TT = /*#__PURE__*/ function() {
        "use strict";
        function TT(timeoutId) {
            (0, $3CDbU._)(this, TT);
            this._ = timeoutId;
        }
        (0, $jyA4z._)(TT, [
            {
                key: "destroy",
                value: function destroy() {
                    clearFunction(this._);
                }
            }
        ]);
        return TT;
    }();
    return TT;
};
var $f98a63c1bea3b0c4$var$Timeout = $f98a63c1bea3b0c4$var$createTimeoutClass(clearTimeout);
var $f98a63c1bea3b0c4$export$83e74882c5df8fe1 = function(timeout, callback) {
    return new $f98a63c1bea3b0c4$var$Timeout(setTimeout(callback, timeout));
};
var $f98a63c1bea3b0c4$var$Interval = $f98a63c1bea3b0c4$var$createTimeoutClass(clearInterval);
var $f98a63c1bea3b0c4$export$3174cdbf0a0cbc84 = function(timeout, callback) {
    return new $f98a63c1bea3b0c4$var$Interval(setInterval(callback, timeout));
};
var $f98a63c1bea3b0c4$export$c35d437ae5945fcd = $f98a63c1bea3b0c4$var$createTimeoutClass(function(arg) {
    return typeof requestAnimationFrame !== 'undefined' && cancelAnimationFrame(arg);
});
var $f98a63c1bea3b0c4$export$1402cba6a733f33a = function(cb) {
    return typeof requestAnimationFrame === 'undefined' ? $f98a63c1bea3b0c4$export$83e74882c5df8fe1(0, cb) : new $f98a63c1bea3b0c4$export$c35d437ae5945fcd(requestAnimationFrame(cb));
};
/* c8 ignore next */ // @ts-ignore
var $f98a63c1bea3b0c4$var$Idle = $f98a63c1bea3b0c4$var$createTimeoutClass(function(arg) {
    return typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(arg);
});
var $f98a63c1bea3b0c4$export$9f62c65f1b707875 = function(cb) {
    return typeof requestIdleCallback !== 'undefined' ? new $f98a63c1bea3b0c4$var$Idle(requestIdleCallback(cb)) : $f98a63c1bea3b0c4$export$83e74882c5df8fe1(1000, cb);
};
var $f98a63c1bea3b0c4$export$21cd608c50c2ba31 = function(timeout) {
    var timer = -1;
    return function(f) {
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};

});

parcelRegister("02E42", function(module, exports) {

$parcel$export(module.exports, "floor", function () { return $007f43ea145650b5$export$a3fe094919f356fd; });
$parcel$export(module.exports, "ceil", function () { return $007f43ea145650b5$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "abs", function () { return $007f43ea145650b5$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "round", function () { return $007f43ea145650b5$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "log10", function () { return $007f43ea145650b5$export$75e08744a3ff8516; });
$parcel$export(module.exports, "min", function () { return $007f43ea145650b5$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $007f43ea145650b5$export$8960430cfd85939f; });
$parcel$export(module.exports, "pow", function () { return $007f43ea145650b5$export$9c297f60e22e3389; });
$parcel$export(module.exports, "exp10", function () { return $007f43ea145650b5$export$1bb2a14208c790f7; });
$parcel$export(module.exports, "isNegativeZero", function () { return $007f43ea145650b5$export$dc0a61f4a9121f92; });
/**
 * Common Math expressions.
 *
 * @module math
 */ var $007f43ea145650b5$export$a3fe094919f356fd = Math.floor;
var $007f43ea145650b5$export$803ce6b71a0a94b2 = Math.ceil;
var $007f43ea145650b5$export$2335f513bbd82c6d = Math.abs;
var $007f43ea145650b5$export$46de3d998ca9a030 = Math.imul;
var $007f43ea145650b5$export$2077e0241d6afd3c = Math.round;
var $007f43ea145650b5$export$75e08744a3ff8516 = Math.log10;
var $007f43ea145650b5$export$b9fae0bba9d9094d = Math.log2;
var $007f43ea145650b5$export$bef1f36f5486a6a3 = Math.log;
var $007f43ea145650b5$export$eba8049fb5020b81 = Math.sqrt;
var $007f43ea145650b5$export$e16d8520af44a096 = function(a, b) {
    return a + b;
};
var $007f43ea145650b5$export$96ec731ed4dcb222 = function(a, b) {
    return a < b ? a : b;
};
var $007f43ea145650b5$export$8960430cfd85939f = function(a, b) {
    return a > b ? a : b;
};
var $007f43ea145650b5$export$c9f5652083b8129d = Number.isNaN;
var $007f43ea145650b5$export$9c297f60e22e3389 = Math.pow;
var $007f43ea145650b5$export$1bb2a14208c790f7 = function(exp) {
    return Math.pow(10, exp);
};
var $007f43ea145650b5$export$c5552dfdbc7cec71 = Math.sign;
var $007f43ea145650b5$export$dc0a61f4a9121f92 = function(n) {
    return n !== 0 ? n < 0 : 1 / n < 0;
};

});

parcelRegister("fJDQU", function(module, exports) {

$parcel$export(module.exports, "BOLD", function () { return $b749f8da835bea24$export$c1286c4c2a7c066; });
$parcel$export(module.exports, "UNBOLD", function () { return $b749f8da835bea24$export$f0ce1666bb40789b; });
$parcel$export(module.exports, "BLUE", function () { return $b749f8da835bea24$export$738c3b9a44c87ecc; });
$parcel$export(module.exports, "GREY", function () { return $b749f8da835bea24$export$7d278ca694634874; });
$parcel$export(module.exports, "GREEN", function () { return $b749f8da835bea24$export$48d4b2cd5bc0e88b; });
$parcel$export(module.exports, "RED", function () { return $b749f8da835bea24$export$aa201224bb439d47; });
$parcel$export(module.exports, "PURPLE", function () { return $b749f8da835bea24$export$7ffdeca4b2f927a2; });
$parcel$export(module.exports, "ORANGE", function () { return $b749f8da835bea24$export$3de5e29ed1757f9b; });
$parcel$export(module.exports, "UNCOLOR", function () { return $b749f8da835bea24$export$b586f81201748dd0; });
$parcel$export(module.exports, "computeNoColorLoggingArgs", function () { return $b749f8da835bea24$export$3454091cc3c6c473; });
$parcel$export(module.exports, "createModuleLogger", function () { return $b749f8da835bea24$export$c2977e725d59a2fd; });

var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $dIPPI = parcelRequire("dIPPI");

var $gL882 = parcelRequire("gL882");

var $apk8q = parcelRequire("apk8q");

var $1PYZG = parcelRequire("1PYZG");

var $5DD1L = parcelRequire("5DD1L");
var $b749f8da835bea24$export$c1286c4c2a7c066 = $dIPPI.create();
var $b749f8da835bea24$export$f0ce1666bb40789b = $dIPPI.create();
var $b749f8da835bea24$export$738c3b9a44c87ecc = $dIPPI.create();
var $b749f8da835bea24$export$7d278ca694634874 = $dIPPI.create();
var $b749f8da835bea24$export$48d4b2cd5bc0e88b = $dIPPI.create();
var $b749f8da835bea24$export$aa201224bb439d47 = $dIPPI.create();
var $b749f8da835bea24$export$7ffdeca4b2f927a2 = $dIPPI.create();
var $b749f8da835bea24$export$3de5e29ed1757f9b = $dIPPI.create();
var $b749f8da835bea24$export$b586f81201748dd0 = $dIPPI.create();
var $b749f8da835bea24$export$3454091cc3c6c473 = function(args) {
    var _args_;
    if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    var strBuilder = [];
    var logArgs = [];
    // try with formatting until we find something unsupported
    var i = 0;
    for(; i < args.length; i++){
        var arg = args[i];
        if (arg === undefined) break;
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) break;
    }
    if (i > 0) // create logArgs with what we have so far
    logArgs.push(strBuilder.join(''));
    // append the rest
    for(; i < args.length; i++){
        var arg1 = args[i];
        if (!(arg1 instanceof Symbol)) logArgs.push(arg1);
    }
    return logArgs;
};
/* c8 ignore stop */ var $b749f8da835bea24$var$loggingColors = [
    $b749f8da835bea24$export$48d4b2cd5bc0e88b,
    $b749f8da835bea24$export$7ffdeca4b2f927a2,
    $b749f8da835bea24$export$3de5e29ed1757f9b,
    $b749f8da835bea24$export$738c3b9a44c87ecc
];
var $b749f8da835bea24$var$nextColor = 0;
var $b749f8da835bea24$var$lastLoggingTime = $gL882.getUnixTime();
var $b749f8da835bea24$export$c2977e725d59a2fd = function(_print, moduleName) {
    var color = $b749f8da835bea24$var$loggingColors[$b749f8da835bea24$var$nextColor];
    var debugRegexVar = $apk8q.getVariable('log');
    var doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
    $b749f8da835bea24$var$nextColor = ($b749f8da835bea24$var$nextColor + 1) % $b749f8da835bea24$var$loggingColors.length;
    moduleName += ': ';
    return !doLogging ? $1PYZG.nop : function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args_;
        if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = args[0]();
        var timeNow = $gL882.getUnixTime();
        var timeDiff = timeNow - $b749f8da835bea24$var$lastLoggingTime;
        $b749f8da835bea24$var$lastLoggingTime = timeNow;
        _print.apply(void 0, [
            color,
            moduleName,
            $b749f8da835bea24$export$b586f81201748dd0
        ].concat((0, $78NO5._)(args.map(function(arg) {
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            var t = typeof arg === "undefined" ? "undefined" : (0, $7tffA._)(arg);
            switch(t){
                case 'string':
                case 'symbol':
                    return arg;
                default:
                    return $5DD1L.stringify(arg);
            }
        })), [
            color,
            ' +' + timeDiff + 'ms'
        ]));
    };
} /* c8 ignore stop */ ;

});
parcelRegister("dIPPI", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $9fd797624ef62126$export$185802fd694ee1f5; });
/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ 
var $7tffA = parcelRequire("7tffA");
var $9fd797624ef62126$export$185802fd694ee1f5 = Symbol;
var $9fd797624ef62126$export$a244864fd9645c7f = function(s) {
    return (typeof s === "undefined" ? "undefined" : (0, $7tffA._)(s)) === 'symbol';
};

});

parcelRegister("gL882", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $03260dcb9a8786c7$export$1f77c0008d16313; });
/**
 * Utility module to work with time.
 *
 * @module time
 */ 
var $aHiYU = parcelRequire("aHiYU");

var $02E42 = parcelRequire("02E42");
var $03260dcb9a8786c7$export$aa350b96d91cd94 = function() {
    return new Date();
};
var $03260dcb9a8786c7$export$1f77c0008d16313 = Date.now;
var $03260dcb9a8786c7$export$70cb903099cabea3 = function(d) {
    if (d < 60000) {
        var p = $aHiYU.prefix(d, -1);
        return $02E42.round(p.n * 100) / 100 + p.prefix + 's';
    }
    d = $02E42.floor(d / 1000);
    var seconds = d % 60;
    var minutes = $02E42.floor(d / 60) % 60;
    var hours = $02E42.floor(d / 3600) % 24;
    var days = $02E42.floor(d / 86400);
    if (days > 0) return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
    if (hours > 0) /* c8 ignore next */ return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
    return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};

});
parcelRegister("aHiYU", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $7c9ca4d34905fa8a$export$82e9f45cca5ba907; });
/**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
var $02E42 = parcelRequire("02E42");
var $7c9ca4d34905fa8a$export$3c3f39195836e927 = 1e24;
var $7c9ca4d34905fa8a$export$bc1fc8bc8e1895cf = 1e21;
var $7c9ca4d34905fa8a$export$91377b751fc464a0 = 1e18;
var $7c9ca4d34905fa8a$export$fc10d2598c9417a5 = 1e15;
var $7c9ca4d34905fa8a$export$ce366dc9d5abf7ac = 1e12;
var $7c9ca4d34905fa8a$export$197e40aa3a484017 = 1e9;
var $7c9ca4d34905fa8a$export$580f1e8cf64f2815 = 1e6;
var $7c9ca4d34905fa8a$export$a3ed9693cfbf67fa = 1e3;
var $7c9ca4d34905fa8a$export$6ec17edd70114a88 = 1e2;
var $7c9ca4d34905fa8a$export$6ffbaf3528ca9f3f = 10;
var $7c9ca4d34905fa8a$export$ec5800edbd9f0b69 = 0.1;
var $7c9ca4d34905fa8a$export$9faf718fe58aaa35 = 0.01;
var $7c9ca4d34905fa8a$export$fab274f99578ceb6 = 1e-3;
var $7c9ca4d34905fa8a$export$77bd0ce503b87b26 = 1e-6;
var $7c9ca4d34905fa8a$export$ddef5c050164e23e = 1e-9;
var $7c9ca4d34905fa8a$export$e10c52a2ab594201 = 1e-12;
var $7c9ca4d34905fa8a$export$c49f04803481822 = 1e-15;
var $7c9ca4d34905fa8a$export$5510a0bcf77f39 = 1e-18;
var $7c9ca4d34905fa8a$export$2b85cc24af20b7fe = 1e-21;
var $7c9ca4d34905fa8a$export$a2878e23774b59ce = 1e-24;
var $7c9ca4d34905fa8a$var$prefixUp = [
    '',
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
var $7c9ca4d34905fa8a$var$prefixDown = [
    '',
    'm',
    "\u03BC",
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
var $7c9ca4d34905fa8a$export$82e9f45cca5ba907 = function(n) {
    var baseMultiplier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var nPow = n === 0 ? 0 : $02E42.log10(n);
    var mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    var prefix = baseMultiplier < 0 ? $7c9ca4d34905fa8a$var$prefixDown[-baseMultiplier] : $7c9ca4d34905fa8a$var$prefixUp[baseMultiplier];
    return {
        n: $02E42.round((mult > 0 ? n / $02E42.exp10(mult * 3) : n * $02E42.exp10(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};

});




var $a7723a0c25d67c02$exports = {};


(parcelRequire("kmBYL")).register((parcelRequire("acCeR")).getBundleURL('9J6sR'), JSON.parse("[\"9J6sR\",\"website.9c1d486a.js\",\"2MyrY\",\"SedestralRum.b2b01e3a.js\",\"4yrPJ\",\"stripe-js.847281c2.js\",\"acP7Y\",\"website.4b28fdab.css\"]"));


var $hWZw8 = parcelRequire("hWZw8");

var $eJDpD = parcelRequire("eJDpD");
var $e86e1590a7783511$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7tffA = parcelRequire("7tffA");
var $e86e1590a7783511$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $7tffA._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $7tffA._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $e86e1590a7783511$exports));
try {
    regeneratorRuntime = $e86e1590a7783511$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $7tffA._)(globalThis)) === "object") globalThis.regeneratorRuntime = $e86e1590a7783511$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e86e1590a7783511$var$runtime);
}



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $5m1WU = parcelRequire("5m1WU");

var $eQCFs = parcelRequire("eQCFs");

var $62tsD = parcelRequire("62tsD");

var $12UO1 = parcelRequire("12UO1");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $5m1WU = parcelRequire("5m1WU");

var $wYO7b = parcelRequire("wYO7b");

var $gzN0P = parcelRequire("gzN0P");

var $9IvVr = parcelRequire("9IvVr");

var $co7RM = parcelRequire("co7RM");
var $17004beb65fc22e9$export$f650c34b939fcf30 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralSsr() {
        (0, $3CDbU._)(this, SedestralSsr);
    }
    (0, $jyA4z._)(SedestralSsr, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _window_location_pathname;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if ((0, $gzN0P.config).product != (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).LIVECHAT)) window["ssr"] = _this;
                        _this.ssrPath = (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.endsWith("sedestral.ssr");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "hasSsr",
            value: function hasSsr() {
                return this.ssrPath;
            }
        },
        {
            key: "awaitProcessing",
            value: function awaitProcessing() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var promises;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.awaitRequests()
                                ];
                            case 1:
                                _state.sent();
                                promises = (0, $5m1WU.SedestralMachine).promises.filter(function(promise) {
                                    return promise.displayRequired;
                                });
                                if (!(promises.length > 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    Promise.all(promises.map(function(promise) {
                                        return promise.promise;
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "awaitRequests",
            value: function awaitRequests() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.awaitRequest()
                                ];
                            case 1:
                                request = _state.sent();
                                if (!request) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.awaitRequests()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "awaitRequest",
            value: function awaitRequest() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $5m1WU.SedestralMachine).promise(function(resolve) {
                                var origOpen = XMLHttpRequest.prototype.open;
                                var timeOut = setTimeout(function() {
                                    resolve(false);
                                });
                                XMLHttpRequest.prototype.open = function() {
                                    this.addEventListener('load', function() {
                                        resolve(true);
                                    });
                                    clearTimeout(timeOut);
                                    origOpen.apply(this, arguments);
                                    XMLHttpRequest.prototype.open = origOpen;
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "renderPageSsr",
            value: /**
     * SSR
     */ function renderPageSsr(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                document.body.className = "";
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.reload(path)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.awaitProcessing()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (0, $5m1WU.SedestralMachine).sleep(1)
                                ];
                            case 3:
                                _state.sent();
                                if ((0, $3Qm5T.Network).router["static"].components.loader) (0, $3Qm5T.Network).router["static"].components.loader.displayShow();
                                document.body.className += "ssrPageReady";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRoutesSsr",
            value: function getRoutesSsr() {
                if ((0, $3Qm5T.Network).productName == (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).BLOG) || (0, $3Qm5T.Network).productName === (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).HELPCENTER)) return (0, $wYO7b.Resources).languages.flatMap(function(language) {
                    return [
                        "/" + language + "/home"
                    ];
                }).join(",");
                return (0, $wYO7b.Resources).languages.flatMap(function(language) {
                    return Object.keys((0, $3Qm5T.Network).router.pages.pages).map(function(route) {
                        return "/" + language + route;
                    });
                }).join(",");
            }
        }
    ]);
    return SedestralSsr;
}();



var $yJnBa = parcelRequire("yJnBa");
var $446e07ea1e729403$export$d1af847c14d84dee = /*#__PURE__*/ function() {
    "use strict";
    function SedestralLogic() {
        (0, $3CDbU._)(this, SedestralLogic);
    }
    (0, $jyA4z._)(SedestralLogic, null, [
        {
            key: "init",
            value: function init() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        (0, $12UO1.SedestralDebugger).init(),
                                        (0, $5m1WU.SedestralMachine).init(),
                                        (0, $eQCFs.SedestralInterface).init(),
                                        (0, $62tsD.SedestralMemory).init(),
                                        (0, $yJnBa.SedestralStorage).init(),
                                        (0, $17004beb65fc22e9$export$f650c34b939fcf30).init()
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "ready",
            value: function ready(callback) {
                if (document.readyState !== 'loading') callback();
                else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
                else // @ts-ignore
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState == 'complete') callback();
                });
            }
        }
    ]);
    return SedestralLogic;
}();



var $gzN0P = parcelRequire("gzN0P");

var $3Qm5T = parcelRequire("3Qm5T");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");


var $711530aa5a175801$export$f32d71d2735e0373;
$711530aa5a175801$export$f32d71d2735e0373 = "_7x5qp";



var $wYO7b = parcelRequire("wYO7b");

var $3Qm5T = parcelRequire("3Qm5T");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $5q8bQ = parcelRequire("5q8bQ");
function $de922cf553e47f3b$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $5q8bQ._)(object);
        if (object === null) break;
    }
    return object;
}


function $2a50ed38ddeef305$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $2a50ed38ddeef305$export$71511d61b312f219 = Reflect.get;
    else $2a50ed38ddeef305$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $de922cf553e47f3b$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $2a50ed38ddeef305$export$71511d61b312f219(target, property, receiver || target);
}



var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $eQCFs = parcelRequire("eQCFs");

var $5m1WU = parcelRequire("5m1WU");


var $wYO7b = parcelRequire("wYO7b");

var $gzN0P = parcelRequire("gzN0P");

var $3Qm5T = parcelRequire("3Qm5T");

var $9IvVr = parcelRequire("9IvVr");

var $co7RM = parcelRequire("co7RM");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $yJnBa = parcelRequire("yJnBa");

var $5m1WU = parcelRequire("5m1WU");

var $eQCFs = parcelRequire("eQCFs");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $5a499bc32e76b662$export$6125f896890f3b30 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralPageStatsActivity() {
        (0, $3CDbU._)(this, SedestralPageStatsActivity);
        this.currentPageDuration = 0;
        this.intervalId = null;
        this.setupActivityTracking();
    }
    (0, $jyA4z._)(SedestralPageStatsActivity, [
        {
            key: "init",
            value: function init() {
                this.currentPageDuration = 0;
            }
        },
        {
            key: "setupActivityTracking",
            value: function setupActivityTracking() {
                var _this = this;
                document.addEventListener('visibilitychange', function() {
                    if (document.visibilityState === 'visible') _this.startTracking();
                    else _this.stopTracking();
                });
                if (document.visibilityState === 'visible') this.startTracking();
            }
        },
        {
            key: "startTracking",
            value: function startTracking() {
                var _this = this;
                if (this.intervalId !== null) return;
                this.intervalId = setInterval(function() {
                    _this.currentPageDuration++;
                }, 1000);
            }
        },
        {
            key: "stopTracking",
            value: function stopTracking() {
                if (this.intervalId !== null) {
                    clearInterval(this.intervalId);
                    this.intervalId = null;
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.stopTracking();
                this.currentPageDuration = 0;
            }
        }
    ]);
    return SedestralPageStatsActivity;
}();



var $gGX81 = parcelRequire("gGX81");
var $9da2deafe4e31137$export$cffcd64a3cd48b50 = /*#__PURE__*/ function() {
    "use strict";
    function SedestralPageStats(pages) {
        var _this = this;
        (0, $3CDbU._)(this, SedestralPageStats);
        this.newPageFunc = [];
        this.closePageFunc = [];
        this.pages = pages;
        var frontId = (0, $yJnBa.SedestralStorage).getItem("fid");
        if (frontId == null) {
            frontId = (0, $gGX81.randomUUID)().replaceAll("-", "");
            (0, $yJnBa.SedestralStorage).setItem("fid", frontId);
        }
        this.frontId = frontId;
        this.baseUrl = window.location.origin;
        this.referrer = document.referrer.startsWith(this.baseUrl) ? undefined : document.referrer;
        this.activity = new (0, $5a499bc32e76b662$export$6125f896890f3b30)();
        this.pages.onPopState(undefined, function() {
            _this.endPage();
            _this.startPage();
        });
        (0, $5m1WU.SedestralMachine).addListener(window, "beforeunload", function() {
            return _this.close();
        });
    }
    (0, $jyA4z._)(SedestralPageStats, [
        {
            key: "startPage",
            value: function startPage() {
                var _this = this;
                this.currentPage = {
                    duration: 0,
                    endTime: 0,
                    startTime: Date.now(),
                    route: this.pages.getPath(),
                    viewedPercentage: 0,
                    actions: []
                };
                //duration
                this.activity.init();
                //scroll
                this.currentPageScroll = (0, $eQCFs.SedestralInterface).main.onScroll(function() {
                    var percentage = (0, $eQCFs.SedestralInterface).main.getScrollPercent();
                    if (percentage > _this.currentPage.viewedPercentage) _this.currentPage.viewedPercentage = percentage;
                });
                //link
                this.currentPageLink = (0, $eQCFs.SedestralInterface).main.putListener(window, "click", function(e) {
                    var target = e.target;
                    while(target != null && target.nodeName !== 'A')target = target.parentNode;
                    if (target && target.nodeName === 'A') {
                        if (!target.href.startsWith(_this.baseUrl)) {
                            if (_this.currentPage) _this.currentPage.actions.push({
                                name: target.innerText,
                                value: target.href,
                                time: Date.now(),
                                type: "link"
                            });
                        }
                    }
                });
            }
        },
        {
            key: "endPage",
            value: function endPage() {
                var _this = this;
                if (this.currentPage) {
                    this.currentPage.endTime = Date.now();
                    this.currentPage.duration = this.activity.currentPageDuration;
                    this.activity.dispose();
                    (0, $5m1WU.SedestralMachine).removeListener(this.currentPageScroll);
                    (0, $5m1WU.SedestralMachine).removeListener(this.currentPageLink);
                    this.newPageFunc.forEach(function(value) {
                        return value(_this, _this.currentPage);
                    });
                }
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                this.endPage();
                this.closePageFunc.forEach(function(value) {
                    return value(_this);
                });
            }
        },
        {
            key: "onNewPage",
            value: function onNewPage(func) {
                this.newPageFunc.push(func);
            }
        },
        {
            key: "onClosePage",
            value: function onClosePage(func) {
                this.closePageFunc.push(func);
            }
        }
    ]);
    return SedestralPageStats;
}();



var $12UO1 = parcelRequire("12UO1");

var $doRa2 = parcelRequire("doRa2");

var $abV4P = parcelRequire("abV4P");
var $04b461310bd6119d$export$cd5a914b394b4ddc = /*#__PURE__*/ function() {
    "use strict";
    function SedestralPageRouter(router, languages, defaultLanguage) {
        (0, $3CDbU._)(this, SedestralPageRouter);
        this.router = router;
        this.languages = languages !== null && languages !== void 0 ? languages : [
            (0, $wYO7b.Resources).getDefaultLanguage()
        ];
        this.defaultLanguage = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $wYO7b.Resources).getDefaultLanguage();
        this.main = (0, $eQCFs.SedestralInterface).main;
        this.pages = {};
        this.pagesInitialized = {};
        this.page = undefined;
        this.change = false;
        this.popStateFunctions = [];
        this.popStateHashFunctions = [];
        this.stats = new (0, $9da2deafe4e31137$export$cffcd64a3cd48b50)(this);
    }
    (0, $jyA4z._)(SedestralPageRouter, [
        {
            key: "init",
            value: /**
     * init
     */ function init() {
                this.main.clear();
                this.intAHref();
                this.initPopState();
            }
        },
        {
            key: "intAHref",
            value: function intAHref() {
                var _this = this;
                var globalFunc = function(e) {
                    var parents = (0, $doRa2.elementParents)(e.target);
                    var elementA = e.target.tagName == "A" ? e.target : parents.find(function(value) {
                        return value.tagName == "A";
                    });
                    if (elementA) {
                        var href = elementA.getAttribute("href");
                        var target = elementA.getAttribute("target");
                        var download = elementA.getAttribute("download");
                        if (target == "_blank") e.stopPropagation();
                        if (target !== "_blank" && download == undefined) {
                            try {
                                var url = new URL(href);
                                var x;
                                if (url.origin != "https://sedestral.com") window.open(url);
                                href = href.replace(url.origin, "");
                                if (href == "") href = _this.pathLogin;
                            } catch (ignored) {}
                            e.preventDefault();
                            if (elementA.getAttribute("click") == undefined && elementA.getAttribute("data-click") == undefined) _this.setPath(href);
                        }
                    }
                };
                (0, $5m1WU.SedestralMachine).addListener(document, 'click', globalFunc, true);
            }
        },
        {
            key: "initPopState",
            value: function initPopState() {
                var _this = this;
                window.onpopstate = /*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isOnPopState = true;
                                return [
                                    4,
                                    _this.execute(_this.getPath())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                this.setPath(this.getPath());
            }
        },
        {
            key: "getPage",
            value: /**
     * pages
     */ function getPage(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var segments, page, i, partialPath;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                path = path.startsWith("/") ? path.substring(1) : path;
                                segments = path.split("/");
                                i = segments.length;
                                _state.label = 1;
                            case 1:
                                if (!(i > 0)) return [
                                    3,
                                    5
                                ];
                                partialPath = "/" + segments.slice(0, i).join("/");
                                if (!(_this.pages[partialPath] !== undefined)) return [
                                    3,
                                    4
                                ];
                                page = _this.pagesInitialized[partialPath];
                                if (!(page == undefined)) return [
                                    3,
                                    3
                                ];
                                _this.pagePath = partialPath;
                                return [
                                    4,
                                    _this.pages[partialPath](partialPath)
                                ];
                            case 2:
                                page = _state.sent();
                                _this.pagesInitialized[partialPath] = page;
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                i--;
                                return [
                                    3,
                                    1
                                ];
                            case 5:
                                return [
                                    2,
                                    page
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerPage",
            value: function registerPage(name, component, componentMobile) {
                this.pages[name] = (0, $abV4P.isMobile)() && componentMobile ? componentMobile : component;
            }
        },
        {
            key: "getDynamicPage",
            value: // @ts-ignore
            function getDynamicPage(path) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "pathIsLanguage",
            value: /**
     * language
     */ function pathIsLanguage(path) {
                return this.languages.includes(path);
            }
        },
        {
            key: "pathHasLanguage",
            value: function pathHasLanguage(path) {
                var firstPath = path.split("/").filter(function(value) {
                    return value != "";
                })[0];
                return this.pathIsLanguage(firstPath);
            }
        },
        {
            key: "removeLanguageFromPath",
            value: function removeLanguageFromPath(path) {
                if (this.pathHasLanguage(path)) {
                    var language = this.getLanguageFromPath(path);
                    if (language) path = path.replace("/".concat(language), "");
                }
                return path;
            }
        },
        {
            key: "getLanguageFromPath",
            value: function getLanguageFromPath(path) {
                var firstPath = path.split("/").filter(function(value) {
                    return value != "";
                })[0];
                return this.pathIsLanguage(firstPath) ? firstPath : undefined;
            }
        },
        {
            key: "addLanguageToPath",
            value: function addLanguageToPath(language, path) {
                return "/".concat(language) + path;
            }
        },
        {
            key: "getLanguage",
            value: function getLanguage() {
                var language = this.getLanguageFromPath(this.getPath());
                if (language && this.pathIsLanguage(language)) return language;
                return this.defaultLanguage;
            }
        },
        {
            key: "setLanguage",
            value: function setLanguage(language) {
                this.setPath("/".concat(language).concat(this.getPathWithoutLanguage()));
                window.location.reload();
            }
        },
        {
            key: "getPath",
            value: /**
     * hash
     */ /**
     * Récupérer le hash actuel, sinon le hash de login si vide
     */ function getPath() {
                var path = window.location.pathname;
                if (path == "/" || this.pathIsLanguage(path.replace("/", ""))) path = this.pathHome;
                return path;
            }
        },
        {
            key: "getPathWithoutLanguage",
            value: function getPathWithoutLanguage() {
                return this.removeLanguageFromPath(this.getPath());
            }
        },
        {
            key: "setPath",
            value: function setPath(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.pathHasLanguage(path)) path = _this.addLanguageToPath(_this.getLanguage(), path);
                                if (path != _this.getPath()) {
                                    if (!_this.isOnPopState) {
                                        if (!_this.bufferHistoryPath) _this.bufferHistoryPath = _this.getPath();
                                        clearTimeout(_this.bufferHistory);
                                        history.replaceState({}, '', path);
                                        _this.bufferHistory = setTimeout(function() {
                                            history.replaceState({}, '', _this.bufferHistoryPath);
                                            history.pushState({}, '', path);
                                            _this.bufferHistoryPath = undefined;
                                        }, 500);
                                    }
                                    clearTimeout(_this.bufferPopState);
                                    _this.bufferPopState = setTimeout(function() {
                                        _this.isOnPopState = false;
                                    }, 500);
                                }
                                return [
                                    4,
                                    _this.execute(path)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "changePath",
            value: function changePath(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var p, page;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                p = _this.removeLanguageFromPath(path).substring(1);
                                p = "/" + p.split("/")[0];
                                page = _this.pagesInitialized[p];
                                if (!page) page = _this.page;
                                if (!(page.constructor.name == _this.page.constructor.name)) return [
                                    3,
                                    2
                                ];
                                _this.change = true;
                                return [
                                    4,
                                    _this.setPath(path)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.setPath(path)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "redirect",
            value: /**
     * redirection
     */ function redirect(path, newTab) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!newTab) return [
                                    3,
                                    1
                                ];
                                window.open(path);
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                path = path == "" || path == "/" ? _this.pathHome : path;
                                return [
                                    4,
                                    _this.setPath(path)
                                ];
                            case 2:
                                _state.sent();
                                window.scroll(0, 0);
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reload",
            value: function reload(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.onReload = true;
                                return [
                                    4,
                                    _this.redirect(path !== null && path !== void 0 ? path : _this.getPath())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParams",
            value: /**
     * params
     */ function getParams() {
                return (this.dynamicPath ? this.dynamicPath : this.getPath()).split("/");
            }
        },
        {
            key: "getParam",
            value: function getParam(name) {
                var hashes = this.getParams();
                for(var i = 0; i < hashes.length; i++)if (hashes[i] == name) {
                    if (typeof hashes[i + 1] !== "undefined") return hashes[i + 1];
                }
                return undefined;
            }
        },
        {
            key: "getParamAtIndex",
            value: function getParamAtIndex(index) {
                return this.getParams()[index];
            }
        },
        {
            key: "hasParam",
            value: function hasParam(name) {
                var hashes = this.getPath().split("/");
                for(var i = 0; i < hashes.length; i++){
                    if (hashes[i] == name) return true;
                }
                return false;
            }
        },
        {
            key: "removeParams",
            value: function removeParams(names, noHash) {
                var _this = this;
                names.forEach(function(value) {
                    return _this.removeParam(value, noHash);
                });
            }
        },
        {
            key: "removeParam",
            value: function removeParam(name, noHash, forceBase) {
                if (this.hasParam(name)) {
                    this.noOnHash = noHash;
                    var currentParam = this.getParam(name);
                    var hash = this.getPath().replace("/" + name + "/" + currentParam, "");
                    if (forceBase) hash = hash.replace("/" + name, "");
                    this.changePath(hash);
                }
            }
        },
        {
            key: "removeParamAfter",
            value: function removeParamAfter(paramName) {
                var params = (0, $3Qm5T.Network).router.pages.getParams();
                for(var i = 0; i < params.length; i++){
                    var baseIndex = params.indexOf(paramName);
                    if (baseIndex >= 0) {
                        if (i > baseIndex) {
                            if (params[i].length > 0) (0, $3Qm5T.Network).router.pages.removeParam(params[i], true);
                        }
                    }
                }
            }
        },
        {
            key: "setParams",
            value: function setParams(params, noHash) {
                var _this = this;
                var hash = this.getPath();
                if (noHash) this.noOnHash = true;
                params.forEach(function(param) {
                    if (param.value) hash = _this.setParamUrl(hash, param.name, param.value, true);
                    else hash = _this.removeParamStr(hash, param.name);
                });
                this.changePath(hash);
            }
        },
        {
            key: "setParam",
            value: function setParam(name, value, preserve, noHash) {
                if (noHash) this.noOnHash = true;
                this.changePath(this.setParamUrl(this.getPath(), name, value, preserve));
            }
        },
        {
            key: "setParamStr",
            value: function setParamStr(path, name, value) {
                var regex = new RegExp("/".concat(name, "/[^/]+"));
                if (path.match(regex)) return path.replace(regex, "/".concat(name, "/").concat(value));
                else return "".concat(path, "/").concat(name, "/").concat(value);
            }
        },
        {
            key: "removeParamStr",
            value: function removeParamStr(path, name) {
                var regex = new RegExp("/".concat(name, "/[^/]+"));
                return path.replace(regex, '');
            }
        },
        {
            key: "hasParamStr",
            value: function hasParamStr(path, name) {
                var regex = new RegExp("/".concat(name, "/[^/]+"));
                return regex.test(path);
            }
        },
        {
            key: "onPopState",
            value: /**
     * funcs
     */ function onPopState(component, func, hash) {
                var _this = this;
                if (hash) {
                    this.popStateHashFunctions.push(func);
                    if (component) component.onRemove(function() {
                        return _this.popStateHashFunctions.splice(_this.popStateHashFunctions.indexOf(func), 1);
                    });
                } else {
                    this.popStateFunctions.push(func);
                    if (component) component.onRemove(function() {
                        return _this.popStateFunctions.splice(_this.popStateFunctions.indexOf(func), 1);
                    });
                }
            }
        },
        {
            key: "execute",
            value: /**
     * run
     */ function execute(path) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var page;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.dynamicPath = undefined;
                                if (!!_this.noOnHash) return [
                                    3,
                                    4
                                ];
                                path = _this.removeLanguageFromPath(path);
                                return [
                                    4,
                                    _this.getPage(path)
                                ];
                            case 1:
                                page = _state.sent();
                                if (!(page == undefined)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getDynamicPage(path)
                                ];
                            case 2:
                                page = _state.sent();
                                if (page == undefined) return [
                                    2,
                                    _this.redirect(_this.path404)
                                ];
                                _state.label = 3;
                            case 3:
                                if (!page.status.open) {
                                    if (page.status.open != undefined && page.status.online == true && !_this.isOnline()) return [
                                        2,
                                        _this.redirect(_this.pathLogin)
                                    ];
                                    if (path != _this.path404 && page.status.online != undefined && page.status.online == false && _this.isOnline()) return [
                                        2,
                                        _this.redirect(_this.pathHome)
                                    ];
                                }
                                if (!_this.change) {
                                    if (!_this.onReload && page == _this.page) {
                                        page.onHash();
                                        _this.router["static"].onHash();
                                    } else {
                                        if (_this.page !== undefined) {
                                            _this.page.remove();
                                            (0, $eQCFs.SedestralInterface).main.clear();
                                        }
                                        _this.page = page;
                                        _this.renderPage(page);
                                        page.onHash();
                                        _this.router["static"].onHash();
                                        _this.updatePageMeta(page);
                                    }
                                } else {
                                    if (_this.onReload || page != _this.page) {
                                        if (_this.page != undefined) {
                                            _this.page.remove();
                                            (0, $eQCFs.SedestralInterface).main.clear();
                                        }
                                        _this.page = page;
                                        _this.renderPage(page);
                                        _this.updatePageMeta(page);
                                    }
                                    page.onHash();
                                    _this.router["static"].onHash();
                                }
                                _state.label = 4;
                            case 4:
                                if (!_this.noOnHash) _this.popStateFunctions.forEach(function(value) {
                                    return value();
                                });
                                else _this.popStateHashFunctions.forEach(function(value) {
                                    return value();
                                });
                                _this.onReload = false;
                                _this.change = false;
                                _this.noOnHash = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renderPage",
            value: function renderPage(page) {
                var _SedestralDebugger_rum;
                var rum = (_SedestralDebugger_rum = (0, $12UO1.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.pageLoad();
                (0, $eQCFs.SedestralInterface).main.render(page);
                (0, $17004beb65fc22e9$export$f650c34b939fcf30).awaitProcessing().then(function() {
                    rum === null || rum === void 0 ? void 0 : rum.end();
                });
                window.scroll(0, 0);
            }
        },
        {
            key: "updatePageMeta",
            value: /**
     * logic
     */ function updatePageMeta(page) {
                document.documentElement.lang = (0, $wYO7b.Resources).language;
                document.title = page.title;
                this.updateMeta("robots", this.getRobots(page));
                this.updateMeta("og:locale", (0, $wYO7b.Resources).language);
                this.updateMeta("og:title", page.title);
                this.updateMeta("twitter:title", page.title);
                this.updateMeta("name", page.title);
                this.updateMeta("description", page.description);
                this.updateMeta("og:description", page.description);
                this.updateMeta("twitter:description", page.description);
                this.updateMeta("keywords", page.keywords);
                this.updateMeta("image", page.image);
                this.updateMeta("og:image", page.image);
                this.updateMeta("twitter:image", page.image);
                this.updateMeta("og:url", page.ogUrl);
                this.updateMeta("og:site_name", page.ogSiteName);
                this.updateMeta("og:type", page.ogType);
                this.updateAlternateLinks(page.alternateLang);
                this.updateFavIcon(page.favicon);
            }
        },
        {
            key: "updateMetasCommunity",
            value: function updateMetasCommunity(community, isArticle, title, description, keywords, image, alternateLang) {
                var _this = this;
                var _community_logoFile, _community_faviconFile;
                var _community_text_metaTitle;
                this.page.title = title ? title : (_community_text_metaTitle = community.text.metaTitle) !== null && _community_text_metaTitle !== void 0 ? _community_text_metaTitle : (0, $wYO7b.Resources).t("words.metas.title");
                var _community_text_metaTitle1;
                this.page.ogSiteName = (_community_text_metaTitle1 = community.text.metaTitle) !== null && _community_text_metaTitle1 !== void 0 ? _community_text_metaTitle1 : (0, $wYO7b.Resources).t("words.metas.title");
                this.page.description = description ? description : community.text.metaDescription;
                this.page.keywords = keywords ? keywords.join(", ") : community.text.metaKeywords.join(", ");
                var _community_logoFile_link;
                this.page.image = image ? image.link : (_community_logoFile_link = (_community_logoFile = community.logoFile) === null || _community_logoFile === void 0 ? void 0 : _community_logoFile.link) !== null && _community_logoFile_link !== void 0 ? _community_logoFile_link : undefined;
                this.page.ogUrl = this.getCurrentUrlWithLang();
                this.page.favicon = community === null || community === void 0 ? void 0 : (_community_faviconFile = community.faviconFile) === null || _community_faviconFile === void 0 ? void 0 : _community_faviconFile.link;
                this.page.ogType = isArticle ? "article" : "website";
                if (!alternateLang) {
                    alternateLang = new Map();
                    community.languages.forEach(function(lang) {
                        alternateLang.set(lang, _this.getCurrentUrlWithLang(lang));
                    });
                }
                this.page.alternateLang = alternateLang;
                this.updatePageMeta(this.page);
            }
        },
        {
            key: "updateMeta",
            value: function updateMeta(name, value) {
                var metas = document.querySelectorAll('head meta[name="'.concat(name, '"], head meta[itemprop="').concat(name, '"], head meta[property="').concat(name, '"]'));
                metas.forEach(function(meta) {
                    meta.setAttribute('content', value !== null && value !== void 0 ? value : "");
                });
            }
        },
        {
            key: "updateFavIcon",
            value: function updateFavIcon() {
                var icon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $3Qm5T.Network).vendor + "images/favicon.png";
                var link = document.querySelector('link[rel="icon"]');
                if (link) link.setAttribute('href', icon);
            }
        },
        {
            key: "getUrlWithLang",
            value: function getUrlWithLang(lang) {
                return (0, $gzN0P.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $wYO7b.Resources).language) + (0, $3Qm5T.Network).router.pages.pagePath;
            }
        },
        {
            key: "getCurrentUrlWithLang",
            value: function getCurrentUrlWithLang(lang) {
                return (0, $gzN0P.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $wYO7b.Resources).language) + location.pathname.replace(/^\/[a-z]{2}/i, '');
            }
        },
        {
            key: "getUrlWithPath",
            value: function getUrlWithPath(path) {
                return (0, $gzN0P.config).domain + "/" + (0, $wYO7b.Resources).language + "/" + path;
            }
        },
        {
            key: "getPanelUrl",
            value: function getPanelUrl(path) {
                return this.generateUrl("https://panel.sedestral.com", path);
            }
        },
        {
            key: "getWebsiteUrl",
            value: function getWebsiteUrl(path) {
                return this.generateUrl(undefined, path);
            }
        },
        {
            key: "updateAlternateLinks",
            value: function updateAlternateLinks(alternateLanguages) {
                var _this = this;
                // Supprimer tous les liens alternatifs existants
                document.querySelectorAll('link[rel="alternate"]').forEach(function(link) {
                    var _link_parentNode;
                    (_link_parentNode = link.parentNode) === null || _link_parentNode === void 0 ? void 0 : _link_parentNode.removeChild(link);
                });
                // Ajouter les nouveaux liens alternatifs
                alternateLanguages.forEach(function(url, lang) {
                    _this.updateAlternateLink(lang, url);
                });
                //Si aucun lien alternate, alors on place quand même l'url actuelle
                if (alternateLanguages.size == 0) this.updateAlternateLink((0, $wYO7b.Resources).language, window.location.pathname);
            }
        },
        {
            key: "isOnline",
            value: /**
     * override
     */ function isOnline() {
                return false;
            }
        },
        {
            key: "isNoneSite",
            value: function isNoneSite() {
                return false;
            }
        },
        {
            key: "setParamUrl",
            value: function setParamUrl(hash, name, value, preserve) {
                var finalHash;
                if (this.hasParam(name)) {
                    var currentParam = this.getParam(name);
                    var toReplace = name + (currentParam == undefined ? "" : "/" + currentParam);
                    var replacement = name + "/" + value;
                    finalHash = hash.replace(toReplace, replacement);
                    var afters = finalHash.split(replacement);
                    if (afters.length > 0) {
                        if (!preserve) finalHash = finalHash.replace(afters[1], "");
                    }
                } else finalHash = hash + "/" + name + "/" + value;
                return finalHash;
            }
        },
        {
            key: "getRobots",
            value: function getRobots(page) {
                var noIndex = [
                    "/helpcenter",
                    "/service-client",
                    "/inbox",
                    "/mail",
                    "/publisher",
                    "/statistics",
                    "/livechat"
                ];
                if (noIndex.includes(location.pathname.replace(/^\/[a-z]{2}/i, ''))) return "noindex";
                if (!(0, $gzN0P.config).isProd) return "noindex";
                if ((0, $3Qm5T.Network).productName == (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).WEBSITE)) return "index";
                else return (0, $17004beb65fc22e9$export$f650c34b939fcf30).hasSsr() || this.hasPathIndex() ? "index" : "noindex";
            }
        },
        {
            key: "hasPathIndex",
            value: function hasPathIndex() {
                var pathsToCheck = [
                    "login",
                    "signup",
                    "password"
                ];
                return pathsToCheck.some(function(path) {
                    var _window_location_pathname;
                    return (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.includes(path);
                });
            }
        },
        {
            key: "updateAlternateLink",
            value: function updateAlternateLink(lang, url) {
                if (!url.startsWith('http')) url = (0, $gzN0P.config).domain + url;
                var link = document.createElement('link');
                link.rel = 'alternate';
                link.hreflang = lang;
                link.href = url;
                document.head.appendChild(link);
            }
        },
        {
            key: "generateUrl",
            value: function generateUrl(url, path) {
                if (path) return url + "/" + (0, $wYO7b.Resources).language + "/" + path;
                else return url + "/" + (0, $wYO7b.Resources).language;
            }
        }
    ]);
    return SedestralPageRouter;
}();



var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $cbafd15d2cddb0e1$export$81033b5937b7c31e = /*#__PURE__*/ function() {
    "use strict";
    function SedestralStaticRouter(router) {
        (0, $3CDbU._)(this, SedestralStaticRouter);
        this._components = {};
    }
    (0, $jyA4z._)(SedestralStaticRouter, [
        {
            key: "components",
            get: /**
     * get and set
     */ function get() {
                return this._components;
            },
            set: function set(value) {
                this._components = value;
            }
        },
        {
            key: "register",
            value: function register(name, component) {
                this._components[name] = component;
            }
        },
        {
            key: "onHash",
            value: function onHash() {
                for(var key in this._components)if (this._components.hasOwnProperty(key)) {
                    var component = this._components[key];
                    component.onHash();
                }
            }
        }
    ]);
    return SedestralStaticRouter;
}();



var $3Qm5T = parcelRequire("3Qm5T");

var $lThic = parcelRequire("lThic");

var $eQCFs = parcelRequire("eQCFs");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $dbf890e3ace2bc3c$export$1a9aa230c91bad4e = /*#__PURE__*/ function() {
    "use strict";
    function PageStatus() {
        (0, $3CDbU._)(this, PageStatus);
        this._online = false;
        this._open = false;
    }
    (0, $jyA4z._)(PageStatus, [
        {
            key: "online",
            get: function get() {
                return this._online;
            },
            set: function set(value) {
                this._online = value;
            }
        },
        {
            key: "open",
            get: function get() {
                return this._open;
            },
            set: function set(value) {
                this._open = value;
            }
        }
    ]);
    return PageStatus;
}();



var $9gCL8 = parcelRequire("9gCL8");

var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $cfc75e76a9120279$export$c4dc9eeb28e63095 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(PageComponent, Component);
    function PageComponent() {
        (0, $3CDbU._)(this, PageComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, PageComponent);
        _this.image = (0, $3Qm5T.Network).vendor + "images/capture-blog.webp";
        _this.ogUrl = (0, $3Qm5T.Network).router.pages.getUrlWithLang();
        _this.ogSiteName = "Sedestral";
        _this.ogType = "website";
        _this.container = undefined;
        _this.template = "<div>page</div>";
        _this.status = new (0, $dbf890e3ace2bc3c$export$1a9aa230c91bad4e)();
        var alternateLanguages = new Map();
        (0, $wYO7b.Resources).languages.forEach(function(lang) {
            alternateLanguages.set(lang, (0, $3Qm5T.Network).router.pages.getUrlWithLang(lang));
        });
        _this.alternateLang = alternateLanguages;
        return _this;
    }
    (0, $jyA4z._)(PageComponent, [
        {
            key: "updateMetas",
            value: function updateMetas(pageName) {
                var _this_getPageData = this.getPageData(pageName), title = _this_getPageData.title, description = _this_getPageData.description, keywords = _this_getPageData.keywords;
                this.title = title;
                this.description = description;
                this.keywords = keywords;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                this.init();
                return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(PageComponent.prototype), "getTemplate", this).call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.nullify();
                this.committed = false;
            }
        },
        {
            key: "renderNoneSite",
            value: function renderNoneSite() {}
        },
        {
            key: "renderNoneRole",
            value: function renderNoneRole() {}
        },
        {
            key: "getPageData",
            value: function getPageData(pageName) {
                var keyPrefix = "pagesDatas.".concat(pageName, ".");
                return {
                    title: (0, $wYO7b.Resources).t("words.".concat(keyPrefix, "title")),
                    description: (0, $wYO7b.Resources).t("words.".concat(keyPrefix, "description")),
                    keywords: (0, $wYO7b.Resources).exist("words.".concat(keyPrefix, "keywords")) ? (0, $wYO7b.Resources).t("words.".concat(keyPrefix, "keywords")) : undefined
                };
            }
        }
    ]);
    return PageComponent;
}((0, $9gCL8.Component));


var $1b7e8548af9e27ca$export$7f99477635901bdd = /*#__PURE__*/ function(PageComponent) {
    "use strict";
    (0, $jCmGC._)(SedestralSsrPage, PageComponent);
    function SedestralSsrPage() {
        (0, $3CDbU._)(this, SedestralSsrPage);
        var _this;
        _this = (0, $ep9cZ._)(this, SedestralSsrPage);
        _this.title = "Sedestral SSR";
        _this.status.online = false;
        return _this;
    }
    (0, $jyA4z._)(SedestralSsrPage, [
        {
            key: "init",
            value: function init() {
                //language=HTML
                console.log('finish');
                this.template = '\n            <div class="ssrPageLoadReady"></div>';
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return SedestralSsrPage;
}((0, $cfc75e76a9120279$export$c4dc9eeb28e63095));



var $yJnBa = parcelRequire("yJnBa");

var $wYO7b = parcelRequire("wYO7b");
var $2b52f0ec3a5ceed6$export$d35034d02907e61a = /*#__PURE__*/ function() {
    "use strict";
    function SedestralRouter(languages) {
        (0, $3CDbU._)(this, SedestralRouter);
        this.languages = languages;
    }
    (0, $jyA4z._)(SedestralRouter, [
        {
            key: "init",
            value: /**
     * init
     */ function init(config) {
                this.config = config;
            }
        },
        {
            key: "initStarted",
            value: function initStarted() {
                var _this_config, _this_config1;
                this.pages = new (0, $04b461310bd6119d$export$cd5a914b394b4ddc)(this, (_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.languages, (_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.defaultLanguage);
                this["static"] = new (0, $cbafd15d2cddb0e1$export$81033b5937b7c31e)(this);
                this.pages.isOnline = function() {
                    return (0, $3Qm5T.Network).logged;
                };
                this.pages.isNoneSite = function() {
                    return (0, $lThic.EntityService).activeSite == null;
                };
                this.registerStatic();
                this.registerPages();
                this.registerSsr();
                this["static"].components.loader.displayHide();
                this.pages.init();
                this.onStarted();
            }
        },
        {
            key: "initNotStarted",
            value: function initNotStarted(errorComponent) {
                this.pages = new (0, $04b461310bd6119d$export$cd5a914b394b4ddc)(this);
                this["static"] = new (0, $cbafd15d2cddb0e1$export$81033b5937b7c31e)(this);
                this.registerStatic();
                this["static"].components.loader.displayHide();
                (0, $eQCFs.SedestralInterface).body.render(errorComponent);
            }
        },
        {
            key: "registerStatic",
            value: /**
     * register
     */ function registerStatic() {}
        },
        {
            key: "registerPages",
            value: function registerPages() {}
        },
        {
            key: "registerSsr",
            value: function registerSsr() {
                this.pages.registerPage("/sedestral.ssr", function() {
                    return new (0, $1b7e8548af9e27ca$export$7f99477635901bdd)();
                });
            }
        },
        {
            key: "importPage",
            value: /**
     * import
     */ function importPage(func, product) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var key, module;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                key = "panelRouter" + product; //+ Date.now();
                                if (Date.now() - 3600000 < new Date(parseInt((0, $yJnBa.SedestralStorage).getItem(key))).getTime()) product = undefined;
                                else (0, $yJnBa.SedestralStorage).setItem(key, "" + Date.now());
                                _this["static"].components.pageLoader.remove();
                                clearTimeout(_this.pageLoaderTimeout);
                                _this["static"].components.pageLoader.product = product;
                                _this["static"].components.pageLoader.init();
                                return [
                                    4,
                                    func()
                                ];
                            case 1:
                                module = _state.sent();
                                if (product != undefined) _this.pageLoaderTimeout = setTimeout(function() {
                                    _this["static"].components.pageLoader.animateRemove();
                                }, 2500);
                                else _this["static"].components.pageLoader.remove();
                                return [
                                    2,
                                    module
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "language",
            value: /**
     * language
     */ function language(defaultLanguage) {
                var firstPath = window.location.pathname.split("/").filter(function(value) {
                    return value != "";
                })[0];
                if (this.languages.includes(firstPath)) return firstPath;
                if (this.pages && this.pages.defaultLanguage) return this.pages.defaultLanguage;
                var _ref;
                return (_ref = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $wYO7b.Resources).getBestLanguageCandidate(this.languages)) !== null && _ref !== void 0 ? _ref : (0, $wYO7b.Resources).getDefaultLanguage();
            }
        },
        {
            /**
     * override
     */ key: "onLogin",
            value: function onLogin() {}
        },
        {
            key: "onLogout",
            value: function onLogout() {}
        },
        {
            key: "onStarted",
            value: function onStarted() {}
        }
    ]);
    return SedestralRouter;
}();



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");
var $f5b52fec49df89c4$export$d160ab07b491fe06;
var $f5b52fec49df89c4$export$e9396702b45dbab1;
var $f5b52fec49df89c4$export$6f093cfa640b7166;
var $f5b52fec49df89c4$export$bd0dc469391eee2c;
var $f5b52fec49df89c4$export$fb184b623420d9be;
var $f5b52fec49df89c4$export$6d59db4903f20f7d;
var $f5b52fec49df89c4$export$14439f5cc10d722f;
var $f5b52fec49df89c4$export$1ca1ec8b29a4ce27;
$f5b52fec49df89c4$export$d160ab07b491fe06 = "d9hJK";
$f5b52fec49df89c4$export$e9396702b45dbab1 = "Aoupu";
$f5b52fec49df89c4$export$6f093cfa640b7166 = "GkPC8";
$f5b52fec49df89c4$export$bd0dc469391eee2c = "_6TdY7";
$f5b52fec49df89c4$export$fb184b623420d9be = "OdVCJ";
$f5b52fec49df89c4$export$6d59db4903f20f7d = "E7EQ0";
$f5b52fec49df89c4$export$14439f5cc10d722f = "hpI31";
$f5b52fec49df89c4$export$1ca1ec8b29a4ce27 = "Emzq9";



var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $49ceb9ae0d43d56d$export$4e3eb2b5df8a6b94;
var $49ceb9ae0d43d56d$export$5fd5031fecdacec3;
var $49ceb9ae0d43d56d$export$6f093cfa640b7166;
var $49ceb9ae0d43d56d$export$a7db06668cad9adb;
var $49ceb9ae0d43d56d$export$34e0f9847d4c02dd;
var $49ceb9ae0d43d56d$export$14439f5cc10d722f;
var $49ceb9ae0d43d56d$export$fb184b623420d9be;
var $49ceb9ae0d43d56d$export$6d59db4903f20f7d;
var $49ceb9ae0d43d56d$export$827f4ee28efc37;
var $49ceb9ae0d43d56d$export$5afc6c8569fc1bd;
var $49ceb9ae0d43d56d$export$4ea799498ef4a755;
var $49ceb9ae0d43d56d$export$a8ff84c12d48cfa6;
var $49ceb9ae0d43d56d$export$f2120bbfa5450bd2;
var $49ceb9ae0d43d56d$export$3e523c77c1f23f8c;
var $49ceb9ae0d43d56d$export$185802fd694ee1f5;
var $49ceb9ae0d43d56d$export$a0973bcfe11b05c9;
var $49ceb9ae0d43d56d$export$4487c9d305171aae;
$49ceb9ae0d43d56d$export$4e3eb2b5df8a6b94 = "MdSsb";
$49ceb9ae0d43d56d$export$5fd5031fecdacec3 = "MpSeh";
$49ceb9ae0d43d56d$export$6f093cfa640b7166 = "bL0rY";
$49ceb9ae0d43d56d$export$a7db06668cad9adb = "tQc9T";
$49ceb9ae0d43d56d$export$34e0f9847d4c02dd = "joeNi";
$49ceb9ae0d43d56d$export$14439f5cc10d722f = "oIqL9";
$49ceb9ae0d43d56d$export$fb184b623420d9be = "_9DgBb";
$49ceb9ae0d43d56d$export$6d59db4903f20f7d = "_1XD06";
$49ceb9ae0d43d56d$export$827f4ee28efc37 = "D1aLr";
$49ceb9ae0d43d56d$export$5afc6c8569fc1bd = "MSWwh";
$49ceb9ae0d43d56d$export$4ea799498ef4a755 = "_7HNrv";
$49ceb9ae0d43d56d$export$a8ff84c12d48cfa6 = "_5kw27";
$49ceb9ae0d43d56d$export$f2120bbfa5450bd2 = "P1TmC";
$49ceb9ae0d43d56d$export$3e523c77c1f23f8c = "CcwDt";
$49ceb9ae0d43d56d$export$185802fd694ee1f5 = "sp6xN";
$49ceb9ae0d43d56d$export$a0973bcfe11b05c9 = "_4yS0g";
$49ceb9ae0d43d56d$export$4487c9d305171aae = "_7st3p";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $8413d3dca949234b$export$f4055a8322d74206;
var $8413d3dca949234b$export$2235f094b8d7361f;
var $8413d3dca949234b$export$bb628a54ab399bc9;
var $8413d3dca949234b$export$bb654e07daaf8c3a;
var $8413d3dca949234b$export$eb03490a10c3abc9;
$8413d3dca949234b$export$f4055a8322d74206 = "lN1gY";
$8413d3dca949234b$export$2235f094b8d7361f = "y48H6";
$8413d3dca949234b$export$bb628a54ab399bc9 = "ZeMux";
$8413d3dca949234b$export$bb654e07daaf8c3a = "-Yh7x";
$8413d3dca949234b$export$eb03490a10c3abc9 = "_8TQdO";


var $13657ca4b0c85698$export$8ed40a6e8d9e757d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(LoaderLightComponent, Component);
    function LoaderLightComponent(p) {
        (0, $3CDbU._)(this, LoaderLightComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, LoaderLightComponent);
        _this.template = '\n            <div loaderLight class="'.concat($8413d3dca949234b$export$f4055a8322d74206, '">\n                <div class="').concat($8413d3dca949234b$export$2235f094b8d7361f, '">\n                    <svg style="').concat(p && p.width ? "width:".concat(p.width, "px;height:").concat(p.width, "px;") : "", '" viewBox="0 0 50 50">\n                        <circle style="').concat(p && p.strokeWidth ? "stroke-width:".concat(p.strokeWidth, "px;") : "").concat(p && p.strokeColor ? "stroke:".concat(p.strokeColor, ";") : "", '" class="').concat($8413d3dca949234b$export$bb654e07daaf8c3a, '" cx="25" cy="25" r="20" fill="none" stroke-width="2"/>\n                    </svg>\n                </div>\n            </div>\n        ');
        return _this;
    }
    return LoaderLightComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $31e0712f0507b238$export$30c9ebb4c11a4f0e;
var $31e0712f0507b238$export$827f4ee28efc37;
var $31e0712f0507b238$export$22275bc6362b2804;
var $31e0712f0507b238$export$a8ff84c12d48cfa6;
var $31e0712f0507b238$export$2077e0241d6afd3c;
var $31e0712f0507b238$export$1ca1ec8b29a4ce27;
var $31e0712f0507b238$export$1fb296bfdbc45c30;
var $31e0712f0507b238$export$de65de8213222d10;
var $31e0712f0507b238$export$add244bda2f9423c;
$31e0712f0507b238$export$30c9ebb4c11a4f0e = "M-u8I";
$31e0712f0507b238$export$827f4ee28efc37 = "_91Na6";
$31e0712f0507b238$export$22275bc6362b2804 = "RR1Lv";
$31e0712f0507b238$export$a8ff84c12d48cfa6 = "_2gJrE";
$31e0712f0507b238$export$2077e0241d6afd3c = "mKbbs";
$31e0712f0507b238$export$1ca1ec8b29a4ce27 = "-coP-";
$31e0712f0507b238$export$1fb296bfdbc45c30 = "j-rId";
$31e0712f0507b238$export$de65de8213222d10 = "_4t882";
$31e0712f0507b238$export$add244bda2f9423c = "wUbdo";



var $eQCFs = parcelRequire("eQCFs");

var $3Qm5T = parcelRequire("3Qm5T");

var $abV4P = parcelRequire("abV4P");

var $5m1WU = parcelRequire("5m1WU");
var $4c1003e9348fedb7$export$2a517e1cac1c1f85 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(VisualModalComponent, Component);
    function VisualModalComponent() {
        (0, $3CDbU._)(this, VisualModalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualModalComponent);
        _this.modalTemplate = "<div>template</div>";
        _this.modalStyle = "width:360px;";
        _this.name = "name";
        _this.template = '\n            <div class="'.concat($31e0712f0507b238$export$30c9ebb4c11a4f0e, '">\n                <div class="').concat($31e0712f0507b238$export$827f4ee28efc37, '">\n                    <div class="').concat($31e0712f0507b238$export$1fb296bfdbc45c30, '">\n                        <div class="').concat($31e0712f0507b238$export$a8ff84c12d48cfa6, '"></div>\n                        <div class="').concat($31e0712f0507b238$export$de65de8213222d10, " ").concat($31e0712f0507b238$export$2077e0241d6afd3c, '">\n                            <div class="').concat($31e0712f0507b238$export$1ca1ec8b29a4ce27, '"></div>\n                        </div>\n                    </div>\n                    <div class="').concat($31e0712f0507b238$export$add244bda2f9423c, '"></div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(VisualModalComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.visualModal = this.el($31e0712f0507b238$export$30c9ebb4c11a4f0e);
                this.headContainer = this.el($31e0712f0507b238$export$1fb296bfdbc45c30);
                this.boxContainer = this.el($31e0712f0507b238$export$827f4ee28efc37);
                this.nameContainer = this.el($31e0712f0507b238$export$a8ff84c12d48cfa6);
                this.contentContainer = this.el($31e0712f0507b238$export$add244bda2f9423c);
                this.closeButton = this.el($31e0712f0507b238$export$de65de8213222d10);
                this.nameContainer.setHtml(this.name);
                this.modalContainer = this.contentContainer.append(this.modalTemplate);
                this.boxContainer.onOutsideClick(function() {
                    if (!_this.fixed && !_this.fixedWithTitle) _this.close();
                });
                this.closeButton.onClick(function() {
                    _this.close();
                });
                if (this.modalStyle) this.boxContainer.setStyle(this.modalStyle);
                if (this.headMargin) this.headContainer.setStyle("margin-bottom:15px;");
                if (this.fixed) this.headContainer.remove();
                if (this.fixedWithTitle) {
                    if (!(0, $abV4P.isMobile)()) this.setStyle("background: white;");
                    this.closeButton.remove();
                    (0, $3Qm5T.Network).router.pages.onPopState(this, function() {
                        return _this.close();
                    });
                }
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    return _this.resize();
                });
                if (this.autoResize) this.onResize(function() {
                    return _this.timeOut(function() {
                        return _this.resize();
                    }, 50);
                });
                this.animateOpen();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualModalComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "resize",
            value: function resize() {
                var fullHeight = this.modalContainer.getHeightCalculated();
                if (this.modalHeight != fullHeight) {
                    this.modalHeight = fullHeight;
                    if (fullHeight + 60 > window.innerHeight) this.boxContainer.setStyle("height: ".concat(window.innerHeight - 80, "px;"));
                    else this.boxContainer.setStyle("height:".concat(fullHeight + 36, "px"));
                }
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.animateClose()
                                ];
                            case 1:
                                _state.sent();
                                _this.onClose();
                                if (!_this.isNull()) _this.remove();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "screenRender",
            value: function screenRender() {
                (0, $eQCFs.SedestralInterface).body.render(this);
            }
        },
        {
            key: "screenPreRender",
            value: function screenPreRender() {
                (0, $eQCFs.SedestralInterface).body.prerender(this);
            }
        },
        {
            key: "excludeOutsideClickComponent",
            value: function excludeOutsideClickComponent(component) {
                this.boxContainer.excludeOutsideClickComponent(component);
            }
        },
        {
            key: "animateOpen",
            value: /**
     * animate
     */ function animateOpen() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $abV4P.isMobile)()) return [
                                    3,
                                    2
                                ];
                                _this.displayShow();
                                _this.boxContainer.setStyle("transform:translateY(100%) scale(1);opacity:1;");
                                return [
                                    4,
                                    _this.boxContainer.translate({
                                        translateY: 0,
                                        delay: 250
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.boxContainer.scale(0.8, 1, 80)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this.boxContainer.fade("in", 100)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _this.boxContainer.timeOut(function() {
                                    _this.boxContainer.setStyle("transform:unset;");
                                }, 150);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "animateClose",
            value: function animateClose() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $abV4P.isMobile)()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.boxContainer.wait([
                                        _this.boxContainer.translate({
                                            translateY: 150,
                                            delay: 80
                                        }),
                                        _this.boxContainer.fade("out", 80),
                                        _this.fade("out", 80)
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.boxContainer.wait([
                                        _this.boxContainer.scale(1, 0.9, 50),
                                        _this.boxContainer.fade("out", 80),
                                        _this.fade("out", 80)
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onClose",
            value: /**
     * override
     */ function onClose() {}
        }
    ]);
    return VisualModalComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");
var $35bbe210def3b092$export$cb46c5951159e3af;
var $35bbe210def3b092$export$fb184b623420d9be;
var $35bbe210def3b092$export$3931a0da49df8dc0;
$35bbe210def3b092$export$cb46c5951159e3af = "seOEH";
$35bbe210def3b092$export$fb184b623420d9be = "skqkt";
$35bbe210def3b092$export$3931a0da49df8dc0 = "SK6Wl";



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $4697d434807f39fa$export$9973266709ea69b1;
var $4697d434807f39fa$export$5fd5031fecdacec3;
var $4697d434807f39fa$export$f2120bbfa5450bd2;
var $4697d434807f39fa$export$1ca1ec8b29a4ce27;
var $4697d434807f39fa$export$a8ff84c12d48cfa6;
$4697d434807f39fa$export$9973266709ea69b1 = "P1Qa3";
$4697d434807f39fa$export$5fd5031fecdacec3 = "vEpPs";
$4697d434807f39fa$export$f2120bbfa5450bd2 = "IGeX9";
$4697d434807f39fa$export$1ca1ec8b29a4ce27 = "vOA3l";
$4697d434807f39fa$export$a8ff84c12d48cfa6 = "_89DM9";


var $92398a0ca828f77d$export$6e0ba5664525d2a0 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(StepsComponent, Component);
    function StepsComponent() {
        (0, $3CDbU._)(this, StepsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, StepsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($4697d434807f39fa$export$9973266709ea69b1, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(StepsComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.initBase();
                this.initButtons();
                this.onCommit(function() {
                    _this.height = _this.getFullHeight();
                    _this.setStyle("height:".concat(_this.height, "px;"));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(StepsComponent.prototype), "commit", this).call(this);
            }
        },
        {
            /**
     * logic
     */ key: "initHead",
            value: function initHead(name) {
                var _this = this;
                //language=HTML
                this.headContainer = this.append('\n            <div class="'.concat($4697d434807f39fa$export$5fd5031fecdacec3, '">\n                <div class="').concat($4697d434807f39fa$export$f2120bbfa5450bd2, '">\n                    <div class="').concat($4697d434807f39fa$export$1ca1ec8b29a4ce27, '"></div>\n                </div>\n                <div class="').concat($4697d434807f39fa$export$a8ff84c12d48cfa6, '">\n                    ').concat(name, "\n                </div>\n            </div>\n        "));
                this.headContainer.el($4697d434807f39fa$export$f2120bbfa5450bd2).onClick(function() {
                    return _this.resetBase();
                });
            }
        },
        {
            key: "initButton",
            value: function initButton(btnClass, func, name) {
                var _this = this;
                this.el(btnClass).onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    var component;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.translate({
                                        translateX: -(_this.getWidth() / 2),
                                        opacity: 0,
                                        delay: 150
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.setStyle("transform:translateX(".concat(_this.getWidth() / 2, "px);transition-duration: 0s;"));
                                _this.clearAll();
                                _this.initHead(name);
                                component = func();
                                _this.render(component);
                                _this.translate({
                                    translateX: 0,
                                    height: component.getHeight() + _this.headContainer.getHeight() + 30,
                                    opacity: 1,
                                    delay: 150
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }), true);
            }
        },
        {
            /**
     * override
     */ key: "initBase",
            value: function initBase() {}
        },
        {
            key: "initButtons",
            value: function initButtons() {}
        },
        {
            key: "resetBase",
            value: /**
     * reset
     */ function resetBase() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.translate({
                                        translateX: _this.getWidth() / 2,
                                        height: _this.height,
                                        opacity: 0,
                                        delay: 150
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.setStyle("transform:translateX(".concat(-(_this.getWidth() / 2), "px);transition-duration: 0s;"));
                                _this.clearAll();
                                _this.initBase();
                                _this.translate({
                                    translateX: 0,
                                    opacity: 1,
                                    delay: 150
                                });
                                _this.initButtons();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StepsComponent;
}((0, $9gCL8.Component));



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");
var $c79a9e1d30c24dc9$export$8efcc86333d6e64f;
var $c79a9e1d30c24dc9$export$a8ff84c12d48cfa6;
var $c79a9e1d30c24dc9$export$9c30223ca0a664fb;
var $c79a9e1d30c24dc9$export$bbea856fdb3e3c5f;
$c79a9e1d30c24dc9$export$8efcc86333d6e64f = "_3ZoNJ";
$c79a9e1d30c24dc9$export$a8ff84c12d48cfa6 = "_0DLIZ";
$c79a9e1d30c24dc9$export$9c30223ca0a664fb = "Yg6XI";
$c79a9e1d30c24dc9$export$bbea856fdb3e3c5f = "_16y-3";




var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $85468dbb09df7a8d$export$b53266dac128743c;
var $85468dbb09df7a8d$export$c073df10e766abfa;
var $85468dbb09df7a8d$export$3a57bbc0fbe4b744;
var $85468dbb09df7a8d$export$4ededb8e5b56a6fb;
var $85468dbb09df7a8d$export$3cd3724d2f91e9d3;
$85468dbb09df7a8d$export$b53266dac128743c = "Lh6iX";
$85468dbb09df7a8d$export$c073df10e766abfa = "OdoUB";
$85468dbb09df7a8d$export$3a57bbc0fbe4b744 = "_8NIB-";
$85468dbb09df7a8d$export$4ededb8e5b56a6fb = "XlN05";
$85468dbb09df7a8d$export$3cd3724d2f91e9d3 = "uYb7g";



var $wYO7b = parcelRequire("wYO7b");
var $2d4c13491eee0660$export$f0c6024316437792 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(ButtonsSaveComponent, Component);
    function ButtonsSaveComponent(settings) {
        (0, $3CDbU._)(this, ButtonsSaveComponent);
        var _this;
        var _this_settings, _this_settings1;
        _this = (0, $ep9cZ._)(this, ButtonsSaveComponent);
        _this.settings = settings;
        //language=HTML
        _this.template = '\n            <div btnSave class="'.concat($85468dbb09df7a8d$export$b53266dac128743c, " ").concat((settings === null || settings === void 0 ? void 0 : settings.themeBlack) ? $85468dbb09df7a8d$export$c073df10e766abfa : "", '">\n                <div btnS class="').concat($85468dbb09df7a8d$export$3a57bbc0fbe4b744, '">\n                    ').concat(((_this_settings = _this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.saveText) ? _this.settings.saveText : (0, $wYO7b.Resources).t("words.save"), '\n                </div>\n                <div btnC class="').concat($85468dbb09df7a8d$export$4ededb8e5b56a6fb, '">\n                    ').concat(((_this_settings1 = _this.settings) === null || _this_settings1 === void 0 ? void 0 : _this_settings1.cancelText) ? _this.settings.cancelText : (0, $wYO7b.Resources).t("words.cancel"), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(ButtonsSaveComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.saveButton = this.el($85468dbb09df7a8d$export$3a57bbc0fbe4b744);
                this.cancelButton = this.el($85468dbb09df7a8d$export$4ededb8e5b56a6fb);
                this.saveButton.onClick(function() {
                    if (!_this.saveButton.hasClass($85468dbb09df7a8d$export$3cd3724d2f91e9d3)) _this.onSave();
                }, true);
                this.cancelButton.onClick(function() {
                    if (!_this.cancelLoading) _this.onCancel();
                }, true);
                if (this.settings) {
                    if (this.settings.hideSaveButton) this.saveButton.remove();
                    if (this.settings.hideCancelButton) this.cancelButton.remove();
                }
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(ButtonsSaveComponent.prototype), "commit", this).call(this);
            }
        },
        {
            /**
     * events
     */ key: "onSave",
            value: function onSave() {}
        },
        {
            key: "onCancel",
            value: function onCancel() {}
        },
        {
            key: "setCancelLoading",
            value: function setCancelLoading() {
                this.cancelButton.save();
                this.cancelButton.setStyle("padding:0;height:".concat(this.cancelButton.getHeight(), "px;width:").concat(this.cancelButton.getWidth(), "px;"));
                this.cancelButton.clear();
                this.cancelButton.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                this.cancelLoading = true;
            }
        },
        {
            key: "remCancelLoading",
            value: function remCancelLoading() {
                if (this.cancelLoading) {
                    this.cancelButton.restore();
                    this.cancelLoading = true;
                }
            }
        },
        {
            key: "setLoadingAndInactive",
            value: function setLoadingAndInactive() {
                this.setLoading();
                this.setInactive();
            }
        },
        {
            key: "remLoadingAndInactive",
            value: function remLoadingAndInactive() {
                this.remLoading();
                this.removeInactive();
            }
        },
        {
            key: "setLoading",
            value: function setLoading() {
                this.saveButton.save();
                this.saveButton.setStyle("padding:0;height:".concat(this.saveButton.getHeight(), "px;width:").concat(this.saveButton.getWidth(), "px;"));
                this.saveButton.clear();
                this.saveButton.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                this.saveLoading = true;
            }
        },
        {
            key: "remLoading",
            value: function remLoading() {
                if (this.saveLoading) {
                    this.saveButton.restore();
                    this.saveLoading = false;
                }
            }
        },
        {
            key: "setInactive",
            value: function setInactive() {
                this.saveButton.addClass($85468dbb09df7a8d$export$3cd3724d2f91e9d3);
            }
        },
        {
            key: "removeInactive",
            value: function removeInactive() {
                this.saveButton.removeClass($85468dbb09df7a8d$export$3cd3724d2f91e9d3);
            }
        },
        {
            key: "isInactive",
            value: function isInactive() {
                return this.saveButton.hasClass($85468dbb09df7a8d$export$3cd3724d2f91e9d3);
            }
        }
    ]);
    return ButtonsSaveComponent;
}((0, $9gCL8.Component));



var $1LZ0s = parcelRequire("1LZ0s");

var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $b9e58924d151f12e$export$64d4c812f849ef19 = /*#__PURE__*/ function(StepsComponent) {
    "use strict";
    (0, $jCmGC._)(SiteCreatorCreateComponent, StepsComponent);
    function SiteCreatorCreateComponent() {
        (0, $3CDbU._)(this, SiteCreatorCreateComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteCreatorCreateComponent);
        _this.buttons = new (0, $2d4c13491eee0660$export$f0c6024316437792)();
        //language=HTML
        _this.template = '\n            <div class="'.concat($c79a9e1d30c24dc9$export$8efcc86333d6e64f, '">\n                <input class="').concat($c79a9e1d30c24dc9$export$a8ff84c12d48cfa6, '" placeholder="').concat((0, $wYO7b.Resources).t("words.workspaceName"), '"/>\n                <div class="').concat($c79a9e1d30c24dc9$export$bbea856fdb3e3c5f, '">\n                    ').concat(_this.draw(_this.buttons), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(SiteCreatorCreateComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.buttons.onSave = /*#__PURE__*/ (0, $hWZw8._)(function() {
                    var name, site;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.buttons.saveLoading) return [
                                    3,
                                    4
                                ];
                                _this.buttons.setLoading();
                                name = _this.el($c79a9e1d30c24dc9$export$a8ff84c12d48cfa6).getValue();
                                if (name.length < 3) return [
                                    2,
                                    _this.error((0, $wYO7b.Resources).t("words.workspaceNameTooShort"))
                                ];
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).create(name, _this)
                                ];
                            case 1:
                                site = _state.sent();
                                if (!site) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).select(site.id, _this)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.buttons.remLoading();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SiteCreatorCreateComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "error",
            value: function error(description) {
                (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.unableToContinue"), description, 8000);
                this.buttons.remLoading();
            }
        }
    ]);
    return SiteCreatorCreateComponent;
}((0, $92398a0ca828f77d$export$6e0ba5664525d2a0));



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");
var $2e70c8cccfe01227$export$48edaaeba8b27219;
var $2e70c8cccfe01227$export$fb184b623420d9be;
var $2e70c8cccfe01227$export$b7e3ae3d7c15e42e;
var $2e70c8cccfe01227$export$bbea856fdb3e3c5f;
$2e70c8cccfe01227$export$48edaaeba8b27219 = "fVBBq";
$2e70c8cccfe01227$export$fb184b623420d9be = "ekyEZ";
$2e70c8cccfe01227$export$b7e3ae3d7c15e42e = "llCoa";
$2e70c8cccfe01227$export$bbea856fdb3e3c5f = "Jemon";





var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $1LZ0s = parcelRequire("1LZ0s");

var $1cwwH = parcelRequire("1cwwH");

var $co7RM = parcelRequire("co7RM");
var $bb21924d01b29d74$export$dcb66d9e8650d51c = /*#__PURE__*/ function() {
    "use strict";
    function InvitationService() {
        (0, $3CDbU._)(this, InvitationService);
    }
    (0, $jyA4z._)(InvitationService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.invitations = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "findById",
            value: /**
     * http
     */ function findById(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/invitation/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findBySite",
            value: function findBySite(siteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/invitation/site/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "use",
            value: function use(id, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/invitation/use/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(hours, maxUses, rolesIds, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/invitation", {
                                        hours: hours,
                                        maxUses: maxUses,
                                        rolesIds: rolesIds
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(invitation, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/invitation/".concat(invitation.id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    _this.unStore(invitation);
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(invitations) {
                for(var key in invitations)invitations[key] = this.store(invitations[key]);
                return (0, $8GOyH.Services).storeAll(invitations);
            }
        },
        {
            key: "store",
            value: function store(invitation) {
                invitation.site = (0, $1LZ0s.SiteService).store(invitation.site);
                invitation.roles = (0, $1cwwH.RoleService).storeAll(invitation.roles);
                return (0, $8GOyH.Services).store("id", this.invitations, invitation);
            }
        },
        {
            key: "unStore",
            value: function unStore(invitation) {
                (0, $8GOyH.Services).unStore("id", this.invitations, invitation);
            }
        }
    ]);
    return InvitationService;
}();
$bb21924d01b29d74$export$dcb66d9e8650d51c.invitations = (0, $j2lF8.observable)([]);



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $4eadde613c2376bd$export$bb3ce8ec10e1a90a = /*#__PURE__*/ function(StepsComponent) {
    "use strict";
    (0, $jCmGC._)(SiteCreatorJoinComponent, StepsComponent);
    function SiteCreatorJoinComponent() {
        (0, $3CDbU._)(this, SiteCreatorJoinComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteCreatorJoinComponent);
        _this.buttons = new (0, $2d4c13491eee0660$export$f0c6024316437792)();
        //language=HTML
        _this.template = '\n            <div class="'.concat($2e70c8cccfe01227$export$48edaaeba8b27219, '">\n                <input class="').concat($2e70c8cccfe01227$export$b7e3ae3d7c15e42e, '" placeholder="').concat((0, $wYO7b.Resources).t("words.invitationLink"), '"/>\n                <div class="').concat($2e70c8cccfe01227$export$bbea856fdb3e3c5f, '">\n                    ').concat(_this.draw(_this.buttons), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(SiteCreatorJoinComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.buttons.onSave = /*#__PURE__*/ (0, $hWZw8._)(function() {
                    var link, invitationId, invitation;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                link = _this.el($2e70c8cccfe01227$export$b7e3ae3d7c15e42e).getValue();
                                if (!link.includes("invitation/i/")) return [
                                    2,
                                    _this.error()
                                ];
                                //http://localhost:1111/#/invitation/i/691a0513bc194cd2945e9716f24a44a9a21881e43a3b4916b50c47e6fa0c91e53893801b8b5a49f4a5bc7be953d5b8cx
                                invitationId = link.split("invitation/i/")[1];
                                if (invitationId.length < 1) return [
                                    2,
                                    _this.error()
                                ];
                                _this.buttons.setLoading();
                                return [
                                    4,
                                    (0, $bb21924d01b29d74$export$dcb66d9e8650d51c).findById(invitationId, _this)
                                ];
                            case 1:
                                invitation = _state.sent();
                                if (invitation == undefined) return [
                                    2,
                                    _this.error()
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.redirect("/invitation/i/" + invitationId)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SiteCreatorJoinComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "error",
            value: function error() {
                (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.unableToContinue"), (0, $wYO7b.Resources).t("words.invalidInvitationLink"), 8000);
                this.buttons.remLoading();
            }
        }
    ]);
    return SiteCreatorJoinComponent;
}((0, $92398a0ca828f77d$export$6e0ba5664525d2a0));



var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");
var $72f29e707327555a$exports = {};

$parcel$export($72f29e707327555a$exports, "globalCase", function () { return $72f29e707327555a$export$343854cb8c07b515; }, function (v) { return $72f29e707327555a$export$343854cb8c07b515 = v; });
$parcel$export($72f29e707327555a$exports, "case", function () { return $72f29e707327555a$export$e850e66917a23e0f; }, function (v) { return $72f29e707327555a$export$e850e66917a23e0f = v; });
$parcel$export($72f29e707327555a$exports, "invitation", function () { return $72f29e707327555a$export$fba01e68c459a9dd; }, function (v) { return $72f29e707327555a$export$fba01e68c459a9dd = v; });
$parcel$export($72f29e707327555a$exports, "icon", function () { return $72f29e707327555a$export$1ca1ec8b29a4ce27; }, function (v) { return $72f29e707327555a$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($72f29e707327555a$exports, "create", function () { return $72f29e707327555a$export$185802fd694ee1f5; }, function (v) { return $72f29e707327555a$export$185802fd694ee1f5 = v; });
$parcel$export($72f29e707327555a$exports, "articleBlank", function () { return $72f29e707327555a$export$91888c26f50efce2; }, function (v) { return $72f29e707327555a$export$91888c26f50efce2 = v; });
$parcel$export($72f29e707327555a$exports, "articleAi", function () { return $72f29e707327555a$export$60c7b865d28898e9; }, function (v) { return $72f29e707327555a$export$60c7b865d28898e9 = v; });
$parcel$export($72f29e707327555a$exports, "mini", function () { return $72f29e707327555a$export$3cde769702d1be3a; }, function (v) { return $72f29e707327555a$export$3cde769702d1be3a = v; });
$parcel$export($72f29e707327555a$exports, "text", function () { return $72f29e707327555a$export$6f093cfa640b7166; }, function (v) { return $72f29e707327555a$export$6f093cfa640b7166 = v; });
$parcel$export($72f29e707327555a$exports, "description", function () { return $72f29e707327555a$export$6d59db4903f20f7d; }, function (v) { return $72f29e707327555a$export$6d59db4903f20f7d = v; });
var $72f29e707327555a$export$343854cb8c07b515;
var $72f29e707327555a$export$e850e66917a23e0f;
var $72f29e707327555a$export$fba01e68c459a9dd;
var $72f29e707327555a$export$1ca1ec8b29a4ce27;
var $72f29e707327555a$export$185802fd694ee1f5;
var $72f29e707327555a$export$91888c26f50efce2;
var $72f29e707327555a$export$60c7b865d28898e9;
var $72f29e707327555a$export$3cde769702d1be3a;
var $72f29e707327555a$export$6f093cfa640b7166;
var $72f29e707327555a$export$6d59db4903f20f7d;
$72f29e707327555a$export$343854cb8c07b515 = "gmTu0";
$72f29e707327555a$export$e850e66917a23e0f = "rs-Ya";
$72f29e707327555a$export$fba01e68c459a9dd = "zDvEK";
$72f29e707327555a$export$1ca1ec8b29a4ce27 = "n-YCY";
$72f29e707327555a$export$185802fd694ee1f5 = "cVNN-";
$72f29e707327555a$export$91888c26f50efce2 = "wWdjm";
$72f29e707327555a$export$60c7b865d28898e9 = "iKfs0";
$72f29e707327555a$export$3cde769702d1be3a = "-UkJ-";
$72f29e707327555a$export$6f093cfa640b7166 = "_8xlDx";
$72f29e707327555a$export$6d59db4903f20f7d = "DHL-w";



var $9gCL8 = parcelRequire("9gCL8");

var $37bde28bc6863353$export$487f8b75dbe0c048 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CasesComponent, Component);
    function CasesComponent(entries) {
        (0, $3CDbU._)(this, CasesComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CasesComponent);
        _this.entries = entries;
        //language=HTML
        _this.template = '\n            <div class="'.concat($72f29e707327555a$exports.globalCase, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(CasesComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.entries.forEach(function(entry) {
                    //language=HTML
                    var caseComponent = _this.append('\n                <div class="'.concat($72f29e707327555a$exports["case"], " ").concat(entry.mini ? $72f29e707327555a$exports.mini : "", " ").concat($72f29e707327555a$exports[entry.id], " ").concat(entry.id, '">\n                    <div class="').concat($72f29e707327555a$exports.icon, '"></div>\n                    <div class="').concat($72f29e707327555a$exports.text, '">\n                        ').concat(entry.name, "\n                    </div>\n                </div>\n            "));
                    if (entry.description) //language=HTML
                    caseComponent.append('\n                    <div class="'.concat($72f29e707327555a$exports.description, '">\n                        ').concat(entry.description, "\n                    </div>\n                "));
                    if (entry.click) caseComponent.onClick(function() {
                        caseComponent.clearAll();
                        caseComponent.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                        entry.click();
                    });
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CasesComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return CasesComponent;
}((0, $9gCL8.Component));


var $5d91f6ab91d5dc50$export$f0dd3d3d1b613563 = /*#__PURE__*/ function(StepsComponent) {
    "use strict";
    (0, $jCmGC._)(SiteCreatorComponent, StepsComponent);
    function SiteCreatorComponent() {
        (0, $3CDbU._)(this, SiteCreatorComponent);
        return (0, $ep9cZ._)(this, SiteCreatorComponent);
    }
    (0, $jyA4z._)(SiteCreatorComponent, [
        {
            key: "initButtons",
            value: function initButtons() {
                this.initButton("create", function() {
                    return new (0, $b9e58924d151f12e$export$64d4c812f849ef19)();
                }, (0, $wYO7b.Resources).t("words.createSite"));
                this.initButton("invitation", function() {
                    return new (0, $4eadde613c2376bd$export$bb3ce8ec10e1a90a)();
                }, (0, $wYO7b.Resources).t("words.joinSite"));
            }
        },
        {
            key: "initBase",
            value: function initBase() {
                //language=HTML
                this.append('\n            <div class="'.concat($35bbe210def3b092$export$cb46c5951159e3af, '">\n                <div class="').concat($35bbe210def3b092$export$fb184b623420d9be, '">\n                    \uD83C\uDFDB ').concat((0, $wYO7b.Resources).t("words.addWorkspace"), '\n                </div>\n                <div class="').concat($35bbe210def3b092$export$3931a0da49df8dc0, '">\n                    ').concat(this.draw(new (0, $37bde28bc6863353$export$487f8b75dbe0c048)([
                    {
                        name: (0, $wYO7b.Resources).t("words.new"),
                        id: "create"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.invitation"),
                        id: "invitation"
                    }
                ])), "\n                </div>\n            </div>\n        "));
            }
        }
    ]);
    return SiteCreatorComponent;
}((0, $92398a0ca828f77d$export$6e0ba5664525d2a0));


var $40a7433bd3bf9431$export$f59adc86f55bf373 = /*#__PURE__*/ function(VisualModalComponent) {
    "use strict";
    (0, $jCmGC._)(SiteCreatorModalComponent, VisualModalComponent);
    function SiteCreatorModalComponent() {
        (0, $3CDbU._)(this, SiteCreatorModalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteCreatorModalComponent);
        _this.name = "";
        _this.autoResize = true;
        _this.modalTemplate = _this.draw(new (0, $5d91f6ab91d5dc50$export$f0dd3d3d1b613563)());
        return _this;
    }
    (0, $jyA4z._)(SiteCreatorModalComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SiteCreatorModalComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return SiteCreatorModalComponent;
}((0, $4c1003e9348fedb7$export$2a517e1cac1c1f85));



var $1LZ0s = parcelRequire("1LZ0s");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $fb1eaf8ff3529aea$export$8079ad1b16c50b33;
var $fb1eaf8ff3529aea$export$4ea799498ef4a755;
var $fb1eaf8ff3529aea$export$f3c22307ab7b1568;
var $fb1eaf8ff3529aea$export$a7db06668cad9adb;
var $fb1eaf8ff3529aea$export$a8ff84c12d48cfa6;
var $fb1eaf8ff3529aea$export$6f093cfa640b7166;
var $fb1eaf8ff3529aea$export$b96bb35bc88d6fa;
$fb1eaf8ff3529aea$export$8079ad1b16c50b33 = "xqnPq";
$fb1eaf8ff3529aea$export$4ea799498ef4a755 = "Inaak";
$fb1eaf8ff3529aea$export$f3c22307ab7b1568 = "iEuXb";
$fb1eaf8ff3529aea$export$a7db06668cad9adb = "mvy1a";
$fb1eaf8ff3529aea$export$a8ff84c12d48cfa6 = "Nnb6i";
$fb1eaf8ff3529aea$export$6f093cfa640b7166 = "SZXCH";
$fb1eaf8ff3529aea$export$b96bb35bc88d6fa = "_1iX3r";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $2974d12d9e70f97c$export$82e7c8e479f92dd4;
var $2974d12d9e70f97c$export$63e82393dc8977bf;
var $2974d12d9e70f97c$export$345c5736c8054f22;
var $2974d12d9e70f97c$export$1ca1ec8b29a4ce27;
var $2974d12d9e70f97c$export$4b5127edceda427d;
var $2974d12d9e70f97c$export$3100efae45e879;
var $2974d12d9e70f97c$export$6c0ec2aaaedda558;
var $2974d12d9e70f97c$export$e5e25fbcc1f7affe;
var $2974d12d9e70f97c$export$6193722c8094ee5f;
var $2974d12d9e70f97c$export$7d4dd925a096c195;
var $2974d12d9e70f97c$export$e0fa3e8e7ca66abf;
var $2974d12d9e70f97c$export$564e4a74ab2e0db0;
var $2974d12d9e70f97c$export$89da14300d534261;
var $2974d12d9e70f97c$export$3cd3724d2f91e9d3;
var $2974d12d9e70f97c$export$759d1803c860a44e;
var $2974d12d9e70f97c$export$14073983b879be0b;
var $2974d12d9e70f97c$export$df8a68e89d215ac9;
$2974d12d9e70f97c$export$82e7c8e479f92dd4 = "VRZUP";
$2974d12d9e70f97c$export$63e82393dc8977bf = "bHs6q";
$2974d12d9e70f97c$export$345c5736c8054f22 = "aU1Zc";
$2974d12d9e70f97c$export$1ca1ec8b29a4ce27 = "qIxIz";
$2974d12d9e70f97c$export$4b5127edceda427d = "Zjhxj";
$2974d12d9e70f97c$export$3100efae45e879 = "jMLMa";
$2974d12d9e70f97c$export$6c0ec2aaaedda558 = "e6g5f";
$2974d12d9e70f97c$export$e5e25fbcc1f7affe = "xEPse";
$2974d12d9e70f97c$export$6193722c8094ee5f = "MTUPx";
$2974d12d9e70f97c$export$7d4dd925a096c195 = "b9Y0T";
$2974d12d9e70f97c$export$e0fa3e8e7ca66abf = "oqhiS";
$2974d12d9e70f97c$export$564e4a74ab2e0db0 = "-n8LO";
$2974d12d9e70f97c$export$89da14300d534261 = "fcekX";
$2974d12d9e70f97c$export$3cd3724d2f91e9d3 = "BqQa-";
$2974d12d9e70f97c$export$759d1803c860a44e = "Blnge";
$2974d12d9e70f97c$export$14073983b879be0b = "bLqoW";
$2974d12d9e70f97c$export$df8a68e89d215ac9 = "eOgwf";



var $jaTWB = parcelRequire("jaTWB");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $38D2A = parcelRequire("38D2A");

var $6VMpv = parcelRequire("6VMpv");
var $8ea395b141053537$export$adff159d7a56dcf = /*#__PURE__*/ function() {
    "use strict";
    function AvatarTemplate() {
        (0, $3CDbU._)(this, AvatarTemplate);
    }
    (0, $jyA4z._)(AvatarTemplate, null, [
        {
            key: "staticTemplate",
            value: function staticTemplate(avatar) {
                //language=HTML
                return "\n            <div ".concat(avatar.color != undefined ? 'style="background-image:'.concat(avatar.color.color, '"') : "", '\n                 class="').concat($2974d12d9e70f97c$export$82e7c8e479f92dd4, '">\n                ').concat(this.imageTemplate(avatar), "\n            </div>\n        ");
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate(avatar) {
                if (avatar.url != undefined) return this.urlTemplate(avatar);
                var _avatar_file_link;
                //language=HTML
                return '\n            <div class="'.concat($2974d12d9e70f97c$export$63e82393dc8977bf, '">\n                ').concat(avatar.file != undefined ? '<img class="'.concat($2974d12d9e70f97c$export$345c5736c8054f22, '" src="').concat((_avatar_file_link = avatar.file.link) !== null && _avatar_file_link !== void 0 ? _avatar_file_link : (0, $38D2A.FileService).link(avatar.file), '" alt="avatar"/>') : this.iconDivTemplate(avatar), "\n            </div>\n        ");
            }
        },
        {
            key: "iconDivTemplate",
            value: function iconDivTemplate(avatar) {
                return '<div class="'.concat($2974d12d9e70f97c$export$1ca1ec8b29a4ce27, " ").concat(this.iconTemplate(avatar), '"></div>');
            }
        },
        {
            key: "urlTemplate",
            value: function urlTemplate(avatar) {
                //language=HTML
                return '\n            <div class="'.concat($2974d12d9e70f97c$export$63e82393dc8977bf, '">\n                <img width="100%" height="unset" class="').concat($2974d12d9e70f97c$export$345c5736c8054f22, '" src="').concat(avatar.url, '" alt="avatar"/>\n            </div>\n        ');
            }
        },
        {
            key: "iconTemplate",
            value: function iconTemplate(avatar) {
                switch(avatar.type){
                    case (0, $6VMpv.AvatarType).ENTITY:
                        return $2974d12d9e70f97c$export$4b5127edceda427d;
                    case (0, $6VMpv.AvatarType).ROLE:
                        return $2974d12d9e70f97c$export$3100efae45e879;
                    case (0, $6VMpv.AvatarType).SITE:
                        return $2974d12d9e70f97c$export$6193722c8094ee5f;
                    case (0, $6VMpv.AvatarType).SITE_CHANNEL:
                        return $2974d12d9e70f97c$export$7d4dd925a096c195;
                    case (0, $6VMpv.AvatarType).BOT:
                        return $2974d12d9e70f97c$export$e0fa3e8e7ca66abf;
                    case (0, $6VMpv.AvatarType).MAIL:
                        return $2974d12d9e70f97c$export$e5e25fbcc1f7affe;
                    case (0, $6VMpv.AvatarType).HELP_CENTER:
                        return $2974d12d9e70f97c$export$6c0ec2aaaedda558;
                }
                return $2974d12d9e70f97c$export$4b5127edceda427d;
            }
        }
    ]);
    return AvatarTemplate;
}();


var $d4e4ed6ae4640ad0$export$544ac6dc05ac737e = /*#__PURE__*/ function(AssignableType) {
    AssignableType[AssignableType["ACCOUNT"] = 1] = "ACCOUNT";
    AssignableType[AssignableType["ROLE"] = 2] = "ROLE";
    AssignableType[AssignableType["CONTACT"] = 3] = "CONTACT";
    AssignableType[AssignableType["MAIL"] = 4] = "MAIL";
    return AssignableType;
}({});



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $co7RM = parcelRequire("co7RM");

var $9IvVr = parcelRequire("9IvVr");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $9IvVr = parcelRequire("9IvVr");
var $65d9b7fb0b8fe8b5$exports = {};

$parcel$export($65d9b7fb0b8fe8b5$exports, "componentCapsuleIcon", function () { return $65d9b7fb0b8fe8b5$export$64da90efda5e2a8f; }, function (v) { return $65d9b7fb0b8fe8b5$export$64da90efda5e2a8f = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "inbox", function () { return $65d9b7fb0b8fe8b5$export$9c1acc30f900961c; }, function (v) { return $65d9b7fb0b8fe8b5$export$9c1acc30f900961c = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "inboxGrey", function () { return $65d9b7fb0b8fe8b5$export$6008f82f189447c4; }, function (v) { return $65d9b7fb0b8fe8b5$export$6008f82f189447c4 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "admin", function () { return $65d9b7fb0b8fe8b5$export$7d0f136b730edfdf; }, function (v) { return $65d9b7fb0b8fe8b5$export$7d0f136b730edfdf = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "sell", function () { return $65d9b7fb0b8fe8b5$export$e761f9e0703de895; }, function (v) { return $65d9b7fb0b8fe8b5$export$e761f9e0703de895 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "blog", function () { return $65d9b7fb0b8fe8b5$export$300b2c23f49a49cb; }, function (v) { return $65d9b7fb0b8fe8b5$export$300b2c23f49a49cb = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "statistics", function () { return $65d9b7fb0b8fe8b5$export$9ebee87b1eb4e24e; }, function (v) { return $65d9b7fb0b8fe8b5$export$9ebee87b1eb4e24e = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "channels", function () { return $65d9b7fb0b8fe8b5$export$9659c395d9de169e; }, function (v) { return $65d9b7fb0b8fe8b5$export$9659c395d9de169e = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "clientService", function () { return $65d9b7fb0b8fe8b5$export$dd6fd28d4b3e1cb5; }, function (v) { return $65d9b7fb0b8fe8b5$export$dd6fd28d4b3e1cb5 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "publisher", function () { return $65d9b7fb0b8fe8b5$export$eb39f87c5509319c; }, function (v) { return $65d9b7fb0b8fe8b5$export$eb39f87c5509319c = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "publisherGrey", function () { return $65d9b7fb0b8fe8b5$export$8924b6f929971904; }, function (v) { return $65d9b7fb0b8fe8b5$export$8924b6f929971904 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "contacts", function () { return $65d9b7fb0b8fe8b5$export$7f1a29bc3be2296e; }, function (v) { return $65d9b7fb0b8fe8b5$export$7f1a29bc3be2296e = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "contactsGrey", function () { return $65d9b7fb0b8fe8b5$export$b85d51bb3a50ac09; }, function (v) { return $65d9b7fb0b8fe8b5$export$b85d51bb3a50ac09 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "chatBot", function () { return $65d9b7fb0b8fe8b5$export$c84166c64dfbd7ab; }, function (v) { return $65d9b7fb0b8fe8b5$export$c84166c64dfbd7ab = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "mails", function () { return $65d9b7fb0b8fe8b5$export$de7df53586297632; }, function (v) { return $65d9b7fb0b8fe8b5$export$de7df53586297632 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "livechat", function () { return $65d9b7fb0b8fe8b5$export$17a8a1cb950cf89a; }, function (v) { return $65d9b7fb0b8fe8b5$export$17a8a1cb950cf89a = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "engagement", function () { return $65d9b7fb0b8fe8b5$export$e1c03b54a682a141; }, function (v) { return $65d9b7fb0b8fe8b5$export$e1c03b54a682a141 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "advertising", function () { return $65d9b7fb0b8fe8b5$export$b195d7ba5a0a4b33; }, function (v) { return $65d9b7fb0b8fe8b5$export$b195d7ba5a0a4b33 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "mailling", function () { return $65d9b7fb0b8fe8b5$export$13055afe968066cb; }, function (v) { return $65d9b7fb0b8fe8b5$export$13055afe968066cb = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "medias", function () { return $65d9b7fb0b8fe8b5$export$ccc39835abb5f24f; }, function (v) { return $65d9b7fb0b8fe8b5$export$ccc39835abb5f24f = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "calendar", function () { return $65d9b7fb0b8fe8b5$export$56bbcdb8aca31149; }, function (v) { return $65d9b7fb0b8fe8b5$export$56bbcdb8aca31149 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "documents", function () { return $65d9b7fb0b8fe8b5$export$3260cc9ddc8b12d; }, function (v) { return $65d9b7fb0b8fe8b5$export$3260cc9ddc8b12d = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "products", function () { return $65d9b7fb0b8fe8b5$export$b6aad051bad07f12; }, function (v) { return $65d9b7fb0b8fe8b5$export$b6aad051bad07f12 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "estimate", function () { return $65d9b7fb0b8fe8b5$export$9f3a0795ca2cc944; }, function (v) { return $65d9b7fb0b8fe8b5$export$9f3a0795ca2cc944 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "sedestral", function () { return $65d9b7fb0b8fe8b5$export$5218b6b8649290d3; }, function (v) { return $65d9b7fb0b8fe8b5$export$5218b6b8649290d3 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "general", function () { return $65d9b7fb0b8fe8b5$export$78b80bc2f5d4953a; }, function (v) { return $65d9b7fb0b8fe8b5$export$78b80bc2f5d4953a = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "helpCenter", function () { return $65d9b7fb0b8fe8b5$export$6c0ec2aaaedda558; }, function (v) { return $65d9b7fb0b8fe8b5$export$6c0ec2aaaedda558 = v; });
$parcel$export($65d9b7fb0b8fe8b5$exports, "document", function () { return $65d9b7fb0b8fe8b5$export$5a7bfc01df82fcd1; }, function (v) { return $65d9b7fb0b8fe8b5$export$5a7bfc01df82fcd1 = v; });
var $65d9b7fb0b8fe8b5$export$64da90efda5e2a8f;
var $65d9b7fb0b8fe8b5$export$9c1acc30f900961c;
var $65d9b7fb0b8fe8b5$export$6008f82f189447c4;
var $65d9b7fb0b8fe8b5$export$7d0f136b730edfdf;
var $65d9b7fb0b8fe8b5$export$e761f9e0703de895;
var $65d9b7fb0b8fe8b5$export$300b2c23f49a49cb;
var $65d9b7fb0b8fe8b5$export$9ebee87b1eb4e24e;
var $65d9b7fb0b8fe8b5$export$9659c395d9de169e;
var $65d9b7fb0b8fe8b5$export$dd6fd28d4b3e1cb5;
var $65d9b7fb0b8fe8b5$export$eb39f87c5509319c;
var $65d9b7fb0b8fe8b5$export$8924b6f929971904;
var $65d9b7fb0b8fe8b5$export$7f1a29bc3be2296e;
var $65d9b7fb0b8fe8b5$export$b85d51bb3a50ac09;
var $65d9b7fb0b8fe8b5$export$c84166c64dfbd7ab;
var $65d9b7fb0b8fe8b5$export$de7df53586297632;
var $65d9b7fb0b8fe8b5$export$17a8a1cb950cf89a;
var $65d9b7fb0b8fe8b5$export$e1c03b54a682a141;
var $65d9b7fb0b8fe8b5$export$b195d7ba5a0a4b33;
var $65d9b7fb0b8fe8b5$export$13055afe968066cb;
var $65d9b7fb0b8fe8b5$export$ccc39835abb5f24f;
var $65d9b7fb0b8fe8b5$export$56bbcdb8aca31149;
var $65d9b7fb0b8fe8b5$export$3260cc9ddc8b12d;
var $65d9b7fb0b8fe8b5$export$b6aad051bad07f12;
var $65d9b7fb0b8fe8b5$export$9f3a0795ca2cc944;
var $65d9b7fb0b8fe8b5$export$5218b6b8649290d3;
var $65d9b7fb0b8fe8b5$export$78b80bc2f5d4953a;
var $65d9b7fb0b8fe8b5$export$6c0ec2aaaedda558;
var $65d9b7fb0b8fe8b5$export$5a7bfc01df82fcd1;
$65d9b7fb0b8fe8b5$export$64da90efda5e2a8f = "_8wXnX";
$65d9b7fb0b8fe8b5$export$9c1acc30f900961c = "_3666q";
$65d9b7fb0b8fe8b5$export$6008f82f189447c4 = "w9-CC";
$65d9b7fb0b8fe8b5$export$7d0f136b730edfdf = "C5aOO";
$65d9b7fb0b8fe8b5$export$e761f9e0703de895 = "IT55P";
$65d9b7fb0b8fe8b5$export$300b2c23f49a49cb = "PIrpP";
$65d9b7fb0b8fe8b5$export$9ebee87b1eb4e24e = "iUHNS";
$65d9b7fb0b8fe8b5$export$9659c395d9de169e = "VEt1c";
$65d9b7fb0b8fe8b5$export$dd6fd28d4b3e1cb5 = "_6V-hK";
$65d9b7fb0b8fe8b5$export$eb39f87c5509319c = "X2WtW";
$65d9b7fb0b8fe8b5$export$8924b6f929971904 = "N8plC";
$65d9b7fb0b8fe8b5$export$7f1a29bc3be2296e = "cw9eh";
$65d9b7fb0b8fe8b5$export$b85d51bb3a50ac09 = "JpkLN";
$65d9b7fb0b8fe8b5$export$c84166c64dfbd7ab = "Yw9YY";
$65d9b7fb0b8fe8b5$export$de7df53586297632 = "BVFrS";
$65d9b7fb0b8fe8b5$export$17a8a1cb950cf89a = "j-yl6";
$65d9b7fb0b8fe8b5$export$e1c03b54a682a141 = "kMETM";
$65d9b7fb0b8fe8b5$export$b195d7ba5a0a4b33 = "_2DevX";
$65d9b7fb0b8fe8b5$export$13055afe968066cb = "G8G4P";
$65d9b7fb0b8fe8b5$export$ccc39835abb5f24f = "-Hrqj";
$65d9b7fb0b8fe8b5$export$56bbcdb8aca31149 = "LdtAG";
$65d9b7fb0b8fe8b5$export$3260cc9ddc8b12d = "-ri-N";
$65d9b7fb0b8fe8b5$export$b6aad051bad07f12 = "_748by";
$65d9b7fb0b8fe8b5$export$9f3a0795ca2cc944 = "cHAKr";
$65d9b7fb0b8fe8b5$export$5218b6b8649290d3 = "RxvUN";
$65d9b7fb0b8fe8b5$export$78b80bc2f5d4953a = "mkZ4G";
$65d9b7fb0b8fe8b5$export$6c0ec2aaaedda558 = "lz-5-";
$65d9b7fb0b8fe8b5$export$5a7bfc01df82fcd1 = "vUyaI";


var $a6f9a22f279d34f9$export$eff4b1de68e1c259 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CapsuleIconComponent, Component);
    function CapsuleIconComponent(product) {
        (0, $3CDbU._)(this, CapsuleIconComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CapsuleIconComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($65d9b7fb0b8fe8b5$exports.componentCapsuleIcon, " ").concat($65d9b7fb0b8fe8b5$exports[(0, $9IvVr.ProductName).toString(product)], '"></div>\n        ');
        return _this;
    }
    return CapsuleIconComponent;
}((0, $9gCL8.Component));


var $b6f2657c55e3744e$exports = {};

$parcel$export($b6f2657c55e3744e$exports, "componentCapsule", function () { return $b6f2657c55e3744e$export$3d5bac00ab4da99c; }, function (v) { return $b6f2657c55e3744e$export$3d5bac00ab4da99c = v; });
$parcel$export($b6f2657c55e3744e$exports, "icon", function () { return $b6f2657c55e3744e$export$1ca1ec8b29a4ce27; }, function (v) { return $b6f2657c55e3744e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($b6f2657c55e3744e$exports, "soon", function () { return $b6f2657c55e3744e$export$7bfacca66fdbc2e1; }, function (v) { return $b6f2657c55e3744e$export$7bfacca66fdbc2e1 = v; });
$parcel$export($b6f2657c55e3744e$exports, "position", function () { return $b6f2657c55e3744e$export$5880b8b5730aff45; }, function (v) { return $b6f2657c55e3744e$export$5880b8b5730aff45 = v; });
$parcel$export($b6f2657c55e3744e$exports, "chatBot", function () { return $b6f2657c55e3744e$export$c84166c64dfbd7ab; }, function (v) { return $b6f2657c55e3744e$export$c84166c64dfbd7ab = v; });
$parcel$export($b6f2657c55e3744e$exports, "admin", function () { return $b6f2657c55e3744e$export$7d0f136b730edfdf; }, function (v) { return $b6f2657c55e3744e$export$7d0f136b730edfdf = v; });
$parcel$export($b6f2657c55e3744e$exports, "mails", function () { return $b6f2657c55e3744e$export$de7df53586297632; }, function (v) { return $b6f2657c55e3744e$export$de7df53586297632 = v; });
$parcel$export($b6f2657c55e3744e$exports, "clientService", function () { return $b6f2657c55e3744e$export$dd6fd28d4b3e1cb5; }, function (v) { return $b6f2657c55e3744e$export$dd6fd28d4b3e1cb5 = v; });
$parcel$export($b6f2657c55e3744e$exports, "livechat", function () { return $b6f2657c55e3744e$export$17a8a1cb950cf89a; }, function (v) { return $b6f2657c55e3744e$export$17a8a1cb950cf89a = v; });
$parcel$export($b6f2657c55e3744e$exports, "medias", function () { return $b6f2657c55e3744e$export$ccc39835abb5f24f; }, function (v) { return $b6f2657c55e3744e$export$ccc39835abb5f24f = v; });
$parcel$export($b6f2657c55e3744e$exports, "engagement", function () { return $b6f2657c55e3744e$export$e1c03b54a682a141; }, function (v) { return $b6f2657c55e3744e$export$e1c03b54a682a141 = v; });
$parcel$export($b6f2657c55e3744e$exports, "advertising", function () { return $b6f2657c55e3744e$export$b195d7ba5a0a4b33; }, function (v) { return $b6f2657c55e3744e$export$b195d7ba5a0a4b33 = v; });
$parcel$export($b6f2657c55e3744e$exports, "mailling", function () { return $b6f2657c55e3744e$export$13055afe968066cb; }, function (v) { return $b6f2657c55e3744e$export$13055afe968066cb = v; });
$parcel$export($b6f2657c55e3744e$exports, "calendar", function () { return $b6f2657c55e3744e$export$56bbcdb8aca31149; }, function (v) { return $b6f2657c55e3744e$export$56bbcdb8aca31149 = v; });
$parcel$export($b6f2657c55e3744e$exports, "documents", function () { return $b6f2657c55e3744e$export$3260cc9ddc8b12d; }, function (v) { return $b6f2657c55e3744e$export$3260cc9ddc8b12d = v; });
$parcel$export($b6f2657c55e3744e$exports, "products", function () { return $b6f2657c55e3744e$export$b6aad051bad07f12; }, function (v) { return $b6f2657c55e3744e$export$b6aad051bad07f12 = v; });
$parcel$export($b6f2657c55e3744e$exports, "estimate", function () { return $b6f2657c55e3744e$export$9f3a0795ca2cc944; }, function (v) { return $b6f2657c55e3744e$export$9f3a0795ca2cc944 = v; });
$parcel$export($b6f2657c55e3744e$exports, "contactsGrey", function () { return $b6f2657c55e3744e$export$b85d51bb3a50ac09; }, function (v) { return $b6f2657c55e3744e$export$b85d51bb3a50ac09 = v; });
$parcel$export($b6f2657c55e3744e$exports, "inboxGrey", function () { return $b6f2657c55e3744e$export$6008f82f189447c4; }, function (v) { return $b6f2657c55e3744e$export$6008f82f189447c4 = v; });
$parcel$export($b6f2657c55e3744e$exports, "publisherGrey", function () { return $b6f2657c55e3744e$export$8924b6f929971904; }, function (v) { return $b6f2657c55e3744e$export$8924b6f929971904 = v; });
$parcel$export($b6f2657c55e3744e$exports, "document", function () { return $b6f2657c55e3744e$export$5a7bfc01df82fcd1; }, function (v) { return $b6f2657c55e3744e$export$5a7bfc01df82fcd1 = v; });
$parcel$export($b6f2657c55e3744e$exports, "inbox", function () { return $b6f2657c55e3744e$export$9c1acc30f900961c; }, function (v) { return $b6f2657c55e3744e$export$9c1acc30f900961c = v; });
$parcel$export($b6f2657c55e3744e$exports, "statistics", function () { return $b6f2657c55e3744e$export$9ebee87b1eb4e24e; }, function (v) { return $b6f2657c55e3744e$export$9ebee87b1eb4e24e = v; });
$parcel$export($b6f2657c55e3744e$exports, "blog", function () { return $b6f2657c55e3744e$export$300b2c23f49a49cb; }, function (v) { return $b6f2657c55e3744e$export$300b2c23f49a49cb = v; });
$parcel$export($b6f2657c55e3744e$exports, "helpCenter", function () { return $b6f2657c55e3744e$export$6c0ec2aaaedda558; }, function (v) { return $b6f2657c55e3744e$export$6c0ec2aaaedda558 = v; });
$parcel$export($b6f2657c55e3744e$exports, "sell", function () { return $b6f2657c55e3744e$export$e761f9e0703de895; }, function (v) { return $b6f2657c55e3744e$export$e761f9e0703de895 = v; });
$parcel$export($b6f2657c55e3744e$exports, "publisher", function () { return $b6f2657c55e3744e$export$eb39f87c5509319c; }, function (v) { return $b6f2657c55e3744e$export$eb39f87c5509319c = v; });
$parcel$export($b6f2657c55e3744e$exports, "contacts", function () { return $b6f2657c55e3744e$export$7f1a29bc3be2296e; }, function (v) { return $b6f2657c55e3744e$export$7f1a29bc3be2296e = v; });
$parcel$export($b6f2657c55e3744e$exports, "sedestral", function () { return $b6f2657c55e3744e$export$5218b6b8649290d3; }, function (v) { return $b6f2657c55e3744e$export$5218b6b8649290d3 = v; });
$parcel$export($b6f2657c55e3744e$exports, "general", function () { return $b6f2657c55e3744e$export$78b80bc2f5d4953a; }, function (v) { return $b6f2657c55e3744e$export$78b80bc2f5d4953a = v; });
var $b6f2657c55e3744e$export$3d5bac00ab4da99c;
var $b6f2657c55e3744e$export$1ca1ec8b29a4ce27;
var $b6f2657c55e3744e$export$7bfacca66fdbc2e1;
var $b6f2657c55e3744e$export$5880b8b5730aff45;
var $b6f2657c55e3744e$export$c84166c64dfbd7ab;
var $b6f2657c55e3744e$export$7d0f136b730edfdf;
var $b6f2657c55e3744e$export$de7df53586297632;
var $b6f2657c55e3744e$export$dd6fd28d4b3e1cb5;
var $b6f2657c55e3744e$export$17a8a1cb950cf89a;
var $b6f2657c55e3744e$export$ccc39835abb5f24f;
var $b6f2657c55e3744e$export$e1c03b54a682a141;
var $b6f2657c55e3744e$export$b195d7ba5a0a4b33;
var $b6f2657c55e3744e$export$13055afe968066cb;
var $b6f2657c55e3744e$export$56bbcdb8aca31149;
var $b6f2657c55e3744e$export$3260cc9ddc8b12d;
var $b6f2657c55e3744e$export$b6aad051bad07f12;
var $b6f2657c55e3744e$export$9f3a0795ca2cc944;
var $b6f2657c55e3744e$export$b85d51bb3a50ac09;
var $b6f2657c55e3744e$export$6008f82f189447c4;
var $b6f2657c55e3744e$export$8924b6f929971904;
var $b6f2657c55e3744e$export$5a7bfc01df82fcd1;
var $b6f2657c55e3744e$export$9c1acc30f900961c;
var $b6f2657c55e3744e$export$9ebee87b1eb4e24e;
var $b6f2657c55e3744e$export$300b2c23f49a49cb;
var $b6f2657c55e3744e$export$6c0ec2aaaedda558;
var $b6f2657c55e3744e$export$e761f9e0703de895;
var $b6f2657c55e3744e$export$eb39f87c5509319c;
var $b6f2657c55e3744e$export$7f1a29bc3be2296e;
var $b6f2657c55e3744e$export$5218b6b8649290d3;
var $b6f2657c55e3744e$export$78b80bc2f5d4953a;
$b6f2657c55e3744e$export$3d5bac00ab4da99c = "Tt0wR";
$b6f2657c55e3744e$export$1ca1ec8b29a4ce27 = "HoMZO";
$b6f2657c55e3744e$export$7bfacca66fdbc2e1 = "Cbv0h";
$b6f2657c55e3744e$export$5880b8b5730aff45 = "Pw8r6";
$b6f2657c55e3744e$export$c84166c64dfbd7ab = "nKAd9";
$b6f2657c55e3744e$export$7d0f136b730edfdf = "tqGEO";
$b6f2657c55e3744e$export$de7df53586297632 = "R71fv";
$b6f2657c55e3744e$export$dd6fd28d4b3e1cb5 = "_9REBJ";
$b6f2657c55e3744e$export$17a8a1cb950cf89a = "_3S-uD";
$b6f2657c55e3744e$export$ccc39835abb5f24f = "d0uDN";
$b6f2657c55e3744e$export$e1c03b54a682a141 = "K3bc5";
$b6f2657c55e3744e$export$b195d7ba5a0a4b33 = "S8omn";
$b6f2657c55e3744e$export$13055afe968066cb = "Fw9WT";
$b6f2657c55e3744e$export$56bbcdb8aca31149 = "wZ-cV";
$b6f2657c55e3744e$export$3260cc9ddc8b12d = "eZksr";
$b6f2657c55e3744e$export$b6aad051bad07f12 = "_1l-33";
$b6f2657c55e3744e$export$9f3a0795ca2cc944 = "Hin-K";
$b6f2657c55e3744e$export$b85d51bb3a50ac09 = "Bbqm8";
$b6f2657c55e3744e$export$6008f82f189447c4 = "_144aY";
$b6f2657c55e3744e$export$8924b6f929971904 = "wUQcP";
$b6f2657c55e3744e$export$5a7bfc01df82fcd1 = "_-2It8";
$b6f2657c55e3744e$export$9c1acc30f900961c = "XWipe";
$b6f2657c55e3744e$export$9ebee87b1eb4e24e = "ifwk-";
$b6f2657c55e3744e$export$300b2c23f49a49cb = "bNX2C";
$b6f2657c55e3744e$export$6c0ec2aaaedda558 = "_5KAfU";
$b6f2657c55e3744e$export$e761f9e0703de895 = "vM-fJ";
$b6f2657c55e3744e$export$eb39f87c5509319c = "eaoid";
$b6f2657c55e3744e$export$7f1a29bc3be2296e = "_0hqmv";
$b6f2657c55e3744e$export$5218b6b8649290d3 = "s3pKw";
$b6f2657c55e3744e$export$78b80bc2f5d4953a = "-rKLq";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $ce22bf2b2a3dd672$export$a01e695ac355f334;
$ce22bf2b2a3dd672$export$a01e695ac355f334 = "_0D8ml";


var $95216e797ff7157f$export$8049d12bcdeca35f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(TextResizeableComponent, Component);
    function TextResizeableComponent(text, fill) {
        (0, $3CDbU._)(this, TextResizeableComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, TextResizeableComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($ce22bf2b2a3dd672$export$a01e695ac355f334, '" style="color:').concat(fill, ';">\n                ').concat(text, "\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(TextResizeableComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.onVisible(function() {
                    return _this.setStyle("font-size: ".concat(_this.getWidth() / 2.5, "px;"));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(TextResizeableComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return TextResizeableComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $c388cbcac7991775$export$5c3f85cf9710806e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CapsuleComponent, Component);
    function CapsuleComponent(type, soon) {
        (0, $3CDbU._)(this, CapsuleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CapsuleComponent);
        _this.productType = type;
        _this.soon = soon ? soon : false;
        var style = "";
        switch(type){
            case (0, $co7RM.ProductType).SEDESTRAL:
            case (0, $co7RM.ProductType).GENERAL:
                style = "width:50%;height:50%;";
                break;
            case (0, $co7RM.ProductType).MAILS:
            case (0, $co7RM.ProductType).CHAT_BOT:
            case (0, $co7RM.ProductType).MAILLING:
            case (0, $co7RM.ProductType).ENGAGEMENT:
                style = "width:46%;height:46%;";
                break;
            case (0, $co7RM.ProductType).ADVERTISING:
            case (0, $co7RM.ProductType).INBOX:
            case (0, $co7RM.ProductType).MEDIAS:
                style = "width:42%;height:42%;";
                break;
        }
        //language=HTML
        _this.template = '\n            <div class="'.concat($b6f2657c55e3744e$exports.componentCapsule, " ").concat($b6f2657c55e3744e$exports[(0, $9IvVr.ProductName).toString(type)], '">\n                <div style="').concat(style, '" class="').concat($b6f2657c55e3744e$exports.icon, '">\n                    ').concat(_this.draw(new (0, $a6f9a22f279d34f9$export$eff4b1de68e1c259)(type)), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(CapsuleComponent, [
        {
            key: "commit",
            value: function commit() {
                switch(this.productType){
                    case (0, $co7RM.ProductType).CALENDAR:
                    case (0, $co7RM.ProductType).ADVERTISING:
                    case (0, $co7RM.ProductType).CHAT_BOT:
                    case (0, $co7RM.ProductType).SELL:
                    case (0, $co7RM.ProductType).MAILLING:
                    case (0, $co7RM.ProductType).MEDIAS:
                    case (0, $co7RM.ProductType).ENGAGEMENT:
                    case (0, $co7RM.ProductType).ESTIMATE:
                    case (0, $co7RM.ProductType).DOCUMENTS:
                    case (0, $co7RM.ProductType).PRODUCTS:
                        this.renderSoon();
                        break;
                }
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CapsuleComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderSoon",
            value: function renderSoon() {
                if (this.soon !== true) //language=HTML
                this.append('\n                <div class="'.concat($b6f2657c55e3744e$exports.soon, '">\n                    <div class="').concat($b6f2657c55e3744e$exports.position, '">\n                        ').concat(this.draw(new (0, $95216e797ff7157f$export$8049d12bcdeca35f)((0, $wYO7b.Resources).t("words.soon"), "white")), "\n                    </div>\n                </div>\n            "));
            }
        }
    ]);
    return CapsuleComponent;
}((0, $9gCL8.Component));



var $co7RM = parcelRequire("co7RM");

var $abV4P = parcelRequire("abV4P");
var $df14df5036d9d44f$export$d9b0d60bf0a19302 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(AvatarComponent, Component);
    function AvatarComponent(avatar, tooltipSettings) {
        (0, $3CDbU._)(this, AvatarComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, AvatarComponent);
        _this.tooltipSettings = tooltipSettings;
        _this.avatar = avatar;
        //language=HTML
        _this.template = '\n            <div class="'.concat($2974d12d9e70f97c$export$82e7c8e479f92dd4, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(AvatarComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(AvatarComponent.prototype), "commit", this).call(this);
                if (this.tooltipSettings != undefined) {
                    var exec = function() {
                        if (_this.tooltipComponent == undefined) {
                            if (_this.tooltipSettings.contentId != "virtualId") {
                                _this.tooltipComponent = new _this.tooltipSettings.componentClass(_this, _this.tooltipSettings.contentId);
                                _this.tooltipComponent.create();
                                _this.tooltipComponent.onDispose = function() {
                                    return _this.tooltipComponent = undefined;
                                };
                            }
                        }
                    };
                    if ((0, $abV4P.isMobile)()) this.onClick(function() {
                        return exec();
                    });
                    else this.onHover(function() {
                        return exec();
                    }, 300);
                }
                this.onReactiveObserve(function() {
                    return _this.init();
                });
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.removeAttribute("style");
                if (this.avatar) {
                    if (this.avatar && this.avatar.color != undefined) this.setStyle("background-image:".concat(this.avatar.color.color, ";background:").concat(this.avatar.color.color));
                    var template = (0, $8ea395b141053537$export$adff159d7a56dcf).imageTemplate(this.avatar);
                    if (this.nameActiveModel) !this.avatar.file && this.avatar.color && this.nameActiveModel.name;
                    if (this.activeModel) template += this.activeModel.active != undefined ? '<div class="'.concat($2974d12d9e70f97c$export$564e4a74ab2e0db0, " ").concat((0, $jaTWB.AvatarService).isActive(this.activeModel) ? $2974d12d9e70f97c$export$89da14300d534261 : $2974d12d9e70f97c$export$3cd3724d2f91e9d3, '"></div>') : "";
                    this.setHtml(template);
                    var avatarContainer = this.el($2974d12d9e70f97c$export$345c5736c8054f22);
                    if (!avatarContainer.isNull()) avatarContainer.addListener("error", function() {
                        var template = (0, $8ea395b141053537$export$adff159d7a56dcf).iconDivTemplate(_this.avatar);
                        _this.setHtml(template);
                    });
                }
            }
        },
        {
            /**
     * active
     */ key: "setActive",
            value: function setActive(activeModel) {
                if (activeModel != undefined) {
                    this.activeModel = activeModel;
                    this.nameActiveModel = activeModel;
                }
                return this;
            }
        },
        {
            /**
     * name
     */ key: "setName",
            value: function setName(activeModel) {
                this.nameActiveModel = activeModel;
                return this;
            }
        },
        {
            /**
     * type
     */ key: "setType",
            value: function setType(assignableType) {
                //language=HTML
                var typeContainer = this.append('\n            <div class="'.concat($2974d12d9e70f97c$export$14073983b879be0b, '"></div>'));
                if (assignableType == (0, $d4e4ed6ae4640ad0$export$544ac6dc05ac737e).CONTACT) typeContainer.render(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).CONTACTS));
                else if (assignableType == (0, $d4e4ed6ae4640ad0$export$544ac6dc05ac737e).MAIL) typeContainer.render(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).MAILS));
                else if (assignableType == (0, $d4e4ed6ae4640ad0$export$544ac6dc05ac737e).ACCOUNT) typeContainer.append('<div class="'.concat($2974d12d9e70f97c$export$df8a68e89d215ac9, '">A</div>'));
            }
        }
    ]);
    return AvatarComponent;
}((0, $9gCL8.Component));


var $5df97fdd5ebc12b4$export$bf256e9408857fc3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(SiteComponent, Component);
    function SiteComponent(site, checked) {
        (0, $3CDbU._)(this, SiteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteComponent);
        //language=HTML
        _this.template = '\n            <div site class="'.concat($fb1eaf8ff3529aea$export$8079ad1b16c50b33, '">\n                <div class="').concat($fb1eaf8ff3529aea$export$4ea799498ef4a755, '">\n                    ').concat(_this.draw(new (0, $df14df5036d9d44f$export$d9b0d60bf0a19302)(site.avatar)), "\n                    ").concat(site.notificationsCount > 0 ? '<div class="'.concat($fb1eaf8ff3529aea$export$f3c22307ab7b1568, '">').concat(site.notificationsCount, "</div>") : "", '\n                </div>\n                <div class="').concat($fb1eaf8ff3529aea$export$a7db06668cad9adb, '">\n                    <div class="').concat($fb1eaf8ff3529aea$export$a8ff84c12d48cfa6, '">\n                        <div class="').concat($fb1eaf8ff3529aea$export$6f093cfa640b7166, '">\n                            ').concat(_this.reactive(function() {
            return site.name;
        }), "\n                        </div>\n                    </div>\n                </div>\n                ").concat(checked ? '<div class="'.concat($fb1eaf8ff3529aea$export$b96bb35bc88d6fa, '"></div>') : "", "\n            </div>\n        ");
        return _this;
    }
    return SiteComponent;
}((0, $9gCL8.Component));


var $ec4c5c715c3ca882$export$7935c8964bef1c2f;
$ec4c5c715c3ca882$export$7935c8964bef1c2f = "CyXTF";



var $1LZ0s = parcelRequire("1LZ0s");

var $f5729a47552dc22d$export$9cde866c69654769 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(SitesComponent, Component);
    function SitesComponent(sites, checkedIds) {
        (0, $3CDbU._)(this, SitesComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SitesComponent);
        _this.sites = sites;
        _this.checkedIds = checkedIds;
        //language=HTML
        _this.template = '\n            <div class="'.concat($ec4c5c715c3ca882$export$7935c8964bef1c2f, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(SitesComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                var _this1 = this, _superprop_get_commit = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SitesComponent.prototype), "commit", _this);
                };
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this1.sites == undefined)) return [
                                    3,
                                    2
                                ];
                                _this1.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).findMind(_this1)
                                ];
                            case 1:
                                _this1.sites = _state.sent();
                                _this1.clearAll();
                                _state.label = 2;
                            case 2:
                                _this1.sites.forEach(function(site) {
                                    var component = new (0, $5df97fdd5ebc12b4$export$bf256e9408857fc3)(site, _this1.checkedIds != undefined && _this1.checkedIds.includes(site.id));
                                    _this1.render(component);
                                    component.onClick(function() {
                                        return _this1.onPick(site);
                                    });
                                });
                                _this1.scrollable();
                                _superprop_get_commit().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * override
     */ key: "onPick",
            value: function onPick(site) {}
        }
    ]);
    return SitesComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $84911afd575356aa$export$e80bff15bbf26afe = /*#__PURE__*/ function(VisualModalComponent) {
    "use strict";
    (0, $jCmGC._)(SitesModalComponent, VisualModalComponent);
    function SitesModalComponent(sites, checkedIds) {
        (0, $3CDbU._)(this, SitesModalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SitesModalComponent);
        _this.sites = sites;
        _this.checkedIds = checkedIds;
        _this.sitesComponent = new (0, $f5729a47552dc22d$export$9cde866c69654769)(_this.sites, _this.checkedIds);
        _this.name = (0, $wYO7b.Resources).t("words.selectWorkspace");
        _this.modalTemplate = _this.draw(_this.sitesComponent);
        _this.autoResize = true;
        return _this;
    }
    return SitesModalComponent;
}((0, $4c1003e9348fedb7$export$2a517e1cac1c1f85));



var $wYO7b = parcelRequire("wYO7b");


var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $1LZ0s = parcelRequire("1LZ0s");

var $fIUGb = parcelRequire("fIUGb");

var $wYO7b = parcelRequire("wYO7b");

var $lThic = parcelRequire("lThic");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $8GOyH = parcelRequire("8GOyH");

var $co7RM = parcelRequire("co7RM");
var $25a36d1d7e7edd70$export$1ad9ba1937b657a1 = /*#__PURE__*/ function() {
    "use strict";
    function AccountPreferencesService() {
        (0, $3CDbU._)(this, AccountPreferencesService);
    }
    (0, $jyA4z._)(AccountPreferencesService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.preferences = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "update",
            value: /**
     * rest
     */ function update(accountId, language, hourClock, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/preferences/update", {
                                        accountId: accountId,
                                        language: language,
                                        hourClock: hourClock
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    AccountPreferencesService.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateNotifications",
            value: function updateNotifications(accountId, data, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).putJson((0, $co7RM.ProductType).PANEL, "/account/preferences/notifications/".concat(accountId), data, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    AccountPreferencesService.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(preferences) {
                for(var key in preferences)preferences[key] = this.store(preferences[key]);
                return (0, $8GOyH.Services).storeAll(preferences);
            }
        },
        {
            key: "store",
            value: function store(preference) {
                if (preference != undefined) return (0, $8GOyH.Services).store("accountId", this.preferences, preference);
            }
        }
    ]);
    return AccountPreferencesService;
}();
$25a36d1d7e7edd70$export$1ad9ba1937b657a1.preferences = (0, $j2lF8.observable)([]);



var $8FuDB = parcelRequire("8FuDB");

var $co7RM = parcelRequire("co7RM");

var $8GOyH = parcelRequire("8GOyH");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");
var $83aff06fdc6f0546$export$cd69738ed1a42348 = /*#__PURE__*/ function() {
    "use strict";
    function OfferProductService() {
        (0, $3CDbU._)(this, OfferProductService);
    }
    (0, $jyA4z._)(OfferProductService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.products = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "storeAllObject",
            value: /**
     * store
     */ function storeAllObject(products) {
                var _this = this;
                if (products) {
                    Object.keys(products).forEach(function(key) {
                        products[key] = _this.store(products[key]);
                    });
                    return products;
                }
            }
        },
        {
            key: "storeAll",
            value: function storeAll(products) {
                for(var key in products)products[key] = this.store(products[key]);
                return (0, $8GOyH.Services).storeAll(products);
            }
        },
        {
            key: "store",
            value: function store(product) {
                product = (0, $8GOyH.Services).store("id", this.products, product);
                return product;
            }
        }
    ]);
    return OfferProductService;
}();
$83aff06fdc6f0546$export$cd69738ed1a42348.products = (0, $j2lF8.observable)([]);


function $f3be6645a7879260$export$cd10aaa149c5324c(url) {
    try {
        // Ajouter le préfixe 'http://' si l'URL ne commence pas par 'http://' ou 'https://'
        if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
        var parsedUrl = new URL(url);
        return parsedUrl.host;
    } catch (e) {
        console.error("Invalid URL:", e);
        return null;
    }
}
function $f3be6645a7879260$export$e870aa252b9361ba(url) {
    try {
        // Décoder et extraire la dernière partie du chemin
        var lastRoute = decodeURIComponent(new URL(url).pathname).split('/').filter(Boolean).pop();
        if (!lastRoute) return '';
        var withoutExtension = lastRoute.replace(/\.[^/.]+$/, '');
        if (withoutExtension.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)) return '';
        if (!/[a-zA-Z]/.test(withoutExtension)) return '';
        return withoutExtension.replace(/[-_0-9]/g, ' ').trim().toLowerCase().replace(/\s+/g, ' ').substring(0, 200);
    } catch (error) {
        return '';
    }
}
function $f3be6645a7879260$export$ecf541e09a511845(param) {
    try {
        var url = window.location.href;
        var regex = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
        var result = regex.exec(url);
        return result ? decodeURIComponent(result[1]) : null;
    } catch (error) {
        return null;
    }
}
function $f3be6645a7879260$export$f1ee45924ce04785(param) {
    try {
        var url = window.location.href;
        var regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)', 'i');
        // Si le paramètre n'existe pas dans l'URL, ne rien faire
        if (!regex.test(url)) return;
        var newUrl = url.replace(regex, function(match, p1, p2, offset, string) {
            return string.charAt(offset - 1) === '?' ? '?' : '';
        });
        // Nettoyer les '&' ou '?' en double générés
        newUrl = newUrl.replace(/[?&]+$/, '');
        newUrl = newUrl.replace(/[?&]+(?=[#])/g, '');
        // Remplacer l'URL dans la barre d'adresse sans recharger la page
        window.history.replaceState(null, '', newUrl);
    } catch (error) {
        console.error('Error removing parameter:', error);
    }
}



var $6m6sO = parcelRequire("6m6sO");
var $e25d7635d2d87041$export$8b2d45e406ebb5ab = /*#__PURE__*/ function() {
    "use strict";
    function AccountSessionService() {
        (0, $3CDbU._)(this, AccountSessionService);
    }
    (0, $jyA4z._)(AccountSessionService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "token",
            value: /**
     * rest
     */ function token() {
                return (0, $hWZw8._)(function() {
                    var tokenRequest, e;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                if ((0, $f3be6645a7879260$export$ecf541e09a511845)("transaction") != null) {
                                    if ((0, $lThic.EntityService).activeToken) {
                                        (0, $lThic.EntityService).saveActiveToken = (0, $lThic.EntityService).activeToken;
                                        (0, $lThic.EntityService).clearActiveToken();
                                    }
                                }
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/session/token")
                                ];
                            case 1:
                                tokenRequest = _state.sent();
                                if (tokenRequest.status != (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    false
                                ];
                                (0, $3Qm5T.Network).logged = tokenRequest.data.online;
                                (0, $lThic.EntityService).headersToken(tokenRequest.headers);
                                //SiteColumnsContactService.storeStandard(tokenRequest.data.standardColumnsContacts);
                                if ((0, $3Qm5T.Network).logged) {
                                    (0, $6m6sO.ChannelService).storeAll(tokenRequest.data.channels);
                                    (0, $lThic.EntityService).activeOfferIsFailureToPay = tokenRequest.data.activeOfferIsFailureToPay;
                                    (0, $lThic.EntityService).activeOfferProducts = (0, $83aff06fdc6f0546$export$cd69738ed1a42348).storeAllObject(tokenRequest.data.products);
                                    (0, $lThic.EntityService).activeEntity = (0, $fIUGb.AccountService).store(tokenRequest.data.account);
                                    (0, $lThic.EntityService).activeEntity['preferences'] = (0, $25a36d1d7e7edd70$export$1ad9ba1937b657a1).store(tokenRequest.data.preferences);
                                    (0, $lThic.EntityService).activeEntity['rolesAccount'] = (0, $8FuDB.RoleAccountService).storeAll(tokenRequest.data.rolesAccount);
                                    (0, $lThic.EntityService).activeSite = (0, $1LZ0s.SiteService).store(tokenRequest.data.site);
                                }
                                return [
                                    2,
                                    true
                                ];
                            case 2:
                                e = _state.sent();
                                console.log(e);
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "login",
            value: function login(mail, password, invitation, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).UNAUTHORIZED,
                                        message: (0, $wYO7b.Resources).t("words.wrongIdentifiers")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/session/login", {
                                        email: mail,
                                        password: password,
                                        invitationId: invitation == undefined ? undefined : invitation.id
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: function logout(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/session/logout", "", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (!(request.status == (0, $cKMRi.HttpStatus).OK)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    AccountSessionService.createLogout()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connectionAccountAdmin",
            value: function connectionAccountAdmin(accountId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/account/session/admin/remplaceSession", {
                                        accountId: accountId,
                                        sessionId: (0, $lThic.EntityService).activeToken
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    (0, $cKMRi.HttpStatus).OK == request.status
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onLogin",
            value: /**
     * on events
     */ function onLogin() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).join((0, $lThic.EntityService).activeEntity.siteId)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onLogout",
            value: function onLogout() {
                (0, $1LZ0s.SiteService).leave((0, $lThic.EntityService).activeEntity.siteId);
            }
        },
        {
            key: "createLogout",
            value: function createLogout() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $3Qm5T.Network).router.onLogout();
                                return [
                                    4,
                                    (0, $3Qm5T.Network).onLogout()
                                ];
                            case 1:
                                _state.sent();
                                (0, $lThic.EntityService).clearActiveToken();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AccountSessionService;
}();


var $cb12b50ec3c8ac26$export$9635fd1ed971cc0d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(SiteNoneComponent, Component);
    function SiteNoneComponent(permissions) {
        (0, $3CDbU._)(this, SiteNoneComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteNoneComponent);
        //language=HTML
        _this.template = '\n            <div siteNone class="'.concat($49ceb9ae0d43d56d$export$4e3eb2b5df8a6b94, '">\n                <div siteNoneHead class="').concat($49ceb9ae0d43d56d$export$5fd5031fecdacec3, '">\n                    <div class="').concat($49ceb9ae0d43d56d$export$6f093cfa640b7166, '">\n                        ').concat((0, $wYO7b.Resources).t("words.sedestral"), '\n                    </div>\n                </div>\n                <div class="').concat($49ceb9ae0d43d56d$export$a7db06668cad9adb, '">\n                    <div class="').concat($49ceb9ae0d43d56d$export$34e0f9847d4c02dd, '">\n                        <div class="').concat($49ceb9ae0d43d56d$export$14439f5cc10d722f, '"></div>\n                        <div class="').concat($49ceb9ae0d43d56d$export$fb184b623420d9be, '">\n                            ').concat(permissions ? (0, $wYO7b.Resources).t("words.noPermission") : (0, $wYO7b.Resources).t("words.noActiveWorkspace"), '\n                        </div>\n                        <div class="').concat($49ceb9ae0d43d56d$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.mustHaveWorkspace"), '\n                        </div>\n                        <div class="').concat($49ceb9ae0d43d56d$export$827f4ee28efc37, '">\n                            <div class="').concat($49ceb9ae0d43d56d$export$5afc6c8569fc1bd, '">\n                                ').concat(_this.draw(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)()), '\n                            </div>\n                            <div class="').concat($49ceb9ae0d43d56d$export$3e523c77c1f23f8c, '"></div>\n                            <div class="').concat($49ceb9ae0d43d56d$export$185802fd694ee1f5, '">\n                                ').concat((0, $wYO7b.Resources).t("words.addWorkspace"), '\n                            </div>\n                            <div class="').concat($49ceb9ae0d43d56d$export$a0973bcfe11b05c9, '">\n                                ').concat((0, $wYO7b.Resources).t("words.deconnexion"), '\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($49ceb9ae0d43d56d$export$4487c9d305171aae, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(SiteNoneComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.sitePickerContainer = this.el($49ceb9ae0d43d56d$export$5afc6c8569fc1bd);
                this.createContainer = this.el($49ceb9ae0d43d56d$export$185802fd694ee1f5);
                this.createContainer.onClick(function() {
                    var creator = new (0, $40a7433bd3bf9431$export$f59adc86f55bf373)();
                    _this.render(creator);
                });
                var logoutButton = this.el($49ceb9ae0d43d56d$export$a0973bcfe11b05c9);
                var onLogout = false;
                var _this1 = this;
                logoutButton.onClick(/*#__PURE__*/ function() {
                    var _ref = (0, $hWZw8._)(function(e) {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    if (!!onLogout) return [
                                        3,
                                        2
                                    ];
                                    onLogout = true;
                                    logoutButton.save();
                                    logoutButton.clear();
                                    logoutButton.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                                    return [
                                        4,
                                        (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).logout(_this1)
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(), true);
                this.renderSitePicker();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SiteNoneComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderSitePicker",
            value: function renderSitePicker() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var sites;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).findMind(_this)
                                ];
                            case 1:
                                sites = _state.sent();
                                _this.sitePickerContainer.clearAll();
                                if (!sites || sites.length == 0) _this.sitePickerContainer.setHtml("<span>".concat((0, $wYO7b.Resources).t("words.noAffiliatedWorkspace"), "</span>"));
                                else {
                                    //language=HTML
                                    _this.sitePickerContainer.append('\n                <div class="'.concat($49ceb9ae0d43d56d$export$4ea799498ef4a755, '">\n                    ').concat(_this.sitePickerContainer.draw(new (0, $df14df5036d9d44f$export$d9b0d60bf0a19302)(sites[0].avatar)), '\n                </div>\n                <div class="').concat($49ceb9ae0d43d56d$export$a8ff84c12d48cfa6, '">\n                    ').concat(_this.sitePickerContainer.reactive(function() {
                                        return sites[0].name;
                                    }), '\n                </div>\n                <div class="').concat($49ceb9ae0d43d56d$export$f2120bbfa5450bd2, '"></div>\n            '));
                                    _this.sitePickerContainer.onClick(function() {
                                        var modal = new (0, $84911afd575356aa$export$e80bff15bbf26afe)(sites);
                                        modal.sitesComponent.onPick = function(site) {
                                            modal.close();
                                            _this.sitePickerContainer.clearAll();
                                            _this.sitePickerContainer.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                                            (0, $1LZ0s.SiteService).select(site.id, _this);
                                        };
                                        _this.render(modal);
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SiteNoneComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $58b809b575fc7b0a$export$221bcb11230b996e;
var $58b809b575fc7b0a$export$34e0f9847d4c02dd;
var $58b809b575fc7b0a$export$1ca1ec8b29a4ce27;
var $58b809b575fc7b0a$export$6f093cfa640b7166;
var $58b809b575fc7b0a$export$8f45430ccf837300;
var $58b809b575fc7b0a$export$1e95b668f3b82d;
var $58b809b575fc7b0a$export$35e9368ef982300f;
var $58b809b575fc7b0a$export$101619b11a34a0bd;
var $58b809b575fc7b0a$export$60e660859c376841;
var $58b809b575fc7b0a$export$df838d0240c938cf;
var $58b809b575fc7b0a$export$4f33f238a5c1ad77;
var $58b809b575fc7b0a$export$7fe88b5920ffddd2;
var $58b809b575fc7b0a$export$df7c425476ed4f2;
$58b809b575fc7b0a$export$221bcb11230b996e = "_7zFcP";
$58b809b575fc7b0a$export$34e0f9847d4c02dd = "TsvOz";
$58b809b575fc7b0a$export$1ca1ec8b29a4ce27 = "uECWc";
$58b809b575fc7b0a$export$6f093cfa640b7166 = "Wd5Gn";
$58b809b575fc7b0a$export$8f45430ccf837300 = "pyth-";
$58b809b575fc7b0a$export$1e95b668f3b82d = "_86Vex";
$58b809b575fc7b0a$export$35e9368ef982300f = "_3dCRr";
$58b809b575fc7b0a$export$101619b11a34a0bd = "-YW3H";
$58b809b575fc7b0a$export$60e660859c376841 = "jsAhO";
$58b809b575fc7b0a$export$df838d0240c938cf = "jmoai";
$58b809b575fc7b0a$export$4f33f238a5c1ad77 = "iw0Py";
$58b809b575fc7b0a$export$7fe88b5920ffddd2 = "xkme7";
$58b809b575fc7b0a$export$df7c425476ed4f2 = "Ks-xm";



var $wYO7b = parcelRequire("wYO7b");
var $c88925025e665ec6$export$a6f6f1cb6d6f034e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(RoleNoneComponent, Component);
    function RoleNoneComponent(text) {
        (0, $3CDbU._)(this, RoleNoneComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, RoleNoneComponent);
        //language=HTML
        _this.template = '\n            <div roleNone class="'.concat($58b809b575fc7b0a$export$221bcb11230b996e, '">\n                <div class="').concat($58b809b575fc7b0a$export$8f45430ccf837300, " ").concat($58b809b575fc7b0a$export$1e95b668f3b82d, '">\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$101619b11a34a0bd, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$60e660859c376841, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$df838d0240c938cf, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$4f33f238a5c1ad77, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$7fe88b5920ffddd2, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$df7c425476ed4f2, '"></div>\n                </div>\n\n                <div class="').concat($58b809b575fc7b0a$export$34e0f9847d4c02dd, '">\n                    <div class="').concat($58b809b575fc7b0a$export$1ca1ec8b29a4ce27, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$6f093cfa640b7166, '">\n                        ').concat(text == undefined ? (0, $wYO7b.Resources).t("words.noPermission") : text, '\n                    </div>\n                </div>\n                <div class="').concat($58b809b575fc7b0a$export$8f45430ccf837300, '">\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$101619b11a34a0bd, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$60e660859c376841, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$df838d0240c938cf, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$4f33f238a5c1ad77, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$7fe88b5920ffddd2, '"></div>\n                    <div class="').concat($58b809b575fc7b0a$export$35e9368ef982300f, " ").concat($58b809b575fc7b0a$export$df7c425476ed4f2, '"></div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    return RoleNoneComponent;
}((0, $9gCL8.Component));


var $5f100fba5d069eaa$export$523fb3936f49e028;
var $5f100fba5d069eaa$export$4caf129a4f120781;
var $5f100fba5d069eaa$export$eabcd2c8791e7bf4;
var $5f100fba5d069eaa$export$acf4eaf431084f78;
var $5f100fba5d069eaa$export$a8ff84c12d48cfa6;
var $5f100fba5d069eaa$export$321c0b1a406de31f;
var $5f100fba5d069eaa$export$79ffe56a765070d2;
var $5f100fba5d069eaa$export$6f093cfa640b7166;
var $5f100fba5d069eaa$export$2ba01fb71ed41cb6;
var $5f100fba5d069eaa$export$a7db06668cad9adb;
var $5f100fba5d069eaa$export$13e2de3c33d99539;
var $5f100fba5d069eaa$export$5fd5031fecdacec3;
var $5f100fba5d069eaa$export$351f93dff0fc1e76;
var $5f100fba5d069eaa$export$5f68ff167dfc5831;
var $5f100fba5d069eaa$export$75a30c72c46d1150;
var $5f100fba5d069eaa$export$3280a108d7f81d56;
var $5f100fba5d069eaa$export$7191e3a7048e77a9;
var $5f100fba5d069eaa$export$aaf8edec33967047;
var $5f100fba5d069eaa$export$e16d8520af44a096;
var $5f100fba5d069eaa$export$564e4a74ab2e0db0;
var $5f100fba5d069eaa$export$f25d54de1f4102d2;
$5f100fba5d069eaa$export$523fb3936f49e028 = "e-HHS";
$5f100fba5d069eaa$export$4caf129a4f120781 = "D8Wan";
$5f100fba5d069eaa$export$eabcd2c8791e7bf4 = "_7g7Ks";
$5f100fba5d069eaa$export$acf4eaf431084f78 = "_5nqUv";
$5f100fba5d069eaa$export$a8ff84c12d48cfa6 = "oFaJ7";
$5f100fba5d069eaa$export$321c0b1a406de31f = "WYl4r";
$5f100fba5d069eaa$export$79ffe56a765070d2 = "_0L2Nh";
$5f100fba5d069eaa$export$6f093cfa640b7166 = "IKCyP";
$5f100fba5d069eaa$export$2ba01fb71ed41cb6 = "l7uch";
$5f100fba5d069eaa$export$a7db06668cad9adb = "_0WZXB";
$5f100fba5d069eaa$export$13e2de3c33d99539 = "m73Xi";
$5f100fba5d069eaa$export$5fd5031fecdacec3 = "Zl448";
$5f100fba5d069eaa$export$351f93dff0fc1e76 = "PFN-E";
$5f100fba5d069eaa$export$5f68ff167dfc5831 = "Tn1fN";
$5f100fba5d069eaa$export$75a30c72c46d1150 = "t2VMc";
$5f100fba5d069eaa$export$3280a108d7f81d56 = "_8tyun";
$5f100fba5d069eaa$export$7191e3a7048e77a9 = "LET9l";
$5f100fba5d069eaa$export$aaf8edec33967047 = "XvKY6";
$5f100fba5d069eaa$export$e16d8520af44a096 = "-al70";
$5f100fba5d069eaa$export$564e4a74ab2e0db0 = "JpQtF";
$5f100fba5d069eaa$export$f25d54de1f4102d2 = "Xq6l6";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a9bc217c90a7f55b$export$c6d08212a1d61bc2;
var $a9bc217c90a7f55b$export$884c4fb92a8b1ea6;
var $a9bc217c90a7f55b$export$649ecc744817b5c7;
var $a9bc217c90a7f55b$export$eff34822f84c3a88;
$a9bc217c90a7f55b$export$c6d08212a1d61bc2 = "_4kuzS";
$a9bc217c90a7f55b$export$884c4fb92a8b1ea6 = "U-yIa";
$a9bc217c90a7f55b$export$649ecc744817b5c7 = "-LTPy";
$a9bc217c90a7f55b$export$eff34822f84c3a88 = "ikg9-";


var $8d25e8b1405345f3$export$6516733363c4513e = /*#__PURE__*/ function(OfferProductTemplateType) {
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_FREE"] = 1] = "HELP_CENTER_FREE";
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_BASIC"] = 2] = "HELP_CENTER_BASIC";
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_AGENCY"] = 3] = "HELP_CENTER_AGENCY";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_FREE"] = 4] = "BLOG_FREE";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_BASIC"] = 5] = "BLOG_BASIC";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_PRO"] = 6] = "BLOG_PRO";
    OfferProductTemplateType[OfferProductTemplateType["INBOX"] = 7] = "INBOX";
    OfferProductTemplateType[OfferProductTemplateType["PUBLISHER"] = 8] = "PUBLISHER";
    OfferProductTemplateType[OfferProductTemplateType["CONTACTS"] = 9] = "CONTACTS";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_ENTERPRISE"] = 10] = "BLOG_ENTERPRISE";
    return OfferProductTemplateType;
}({});


var $7fa5fdd391950487$export$e11200deb10216e7 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferTemplateIconComponent, Component);
    function OfferTemplateIconComponent(type) {
        (0, $3CDbU._)(this, OfferTemplateIconComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferTemplateIconComponent);
        var cl = $a9bc217c90a7f55b$export$884c4fb92a8b1ea6;
        switch(type){
            case (0, $8d25e8b1405345f3$export$6516733363c4513e).BLOG_BASIC:
                cl = $a9bc217c90a7f55b$export$884c4fb92a8b1ea6;
                break;
            case (0, $8d25e8b1405345f3$export$6516733363c4513e).BLOG_PRO:
                cl = $a9bc217c90a7f55b$export$649ecc744817b5c7;
                break;
            case (0, $8d25e8b1405345f3$export$6516733363c4513e).BLOG_ENTERPRISE:
                cl = $a9bc217c90a7f55b$export$eff34822f84c3a88;
                break;
        }
        //language=HTML
        _this.template = '\n            <div class="'.concat($a9bc217c90a7f55b$export$c6d08212a1d61bc2, " ").concat(cl, '"></div>\n        ');
        return _this;
    }
    return OfferTemplateIconComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");


var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $c2bd1b702a3d9ea1$export$77181601c038f22b;
var $c2bd1b702a3d9ea1$export$61f6990d5944375a;
var $c2bd1b702a3d9ea1$export$96ff94e0adb1d772;
var $c2bd1b702a3d9ea1$export$96e4b36520c26a2c;
var $c2bd1b702a3d9ea1$export$a7db06668cad9adb;
var $c2bd1b702a3d9ea1$export$321c0b1a406de31f;
var $c2bd1b702a3d9ea1$export$f4c5de44377d2946;
var $c2bd1b702a3d9ea1$export$1e95b668f3b82d;
var $c2bd1b702a3d9ea1$export$da0c8716dc13cd97;
var $c2bd1b702a3d9ea1$export$40e52e4cb633d77a;
var $c2bd1b702a3d9ea1$export$a8fc3402335b0b04;
var $c2bd1b702a3d9ea1$export$34e0f9847d4c02dd;
var $c2bd1b702a3d9ea1$export$d90250155de6d7e7;
var $c2bd1b702a3d9ea1$export$e29b1f3b2b6a7669;
var $c2bd1b702a3d9ea1$export$c99df9cf5e6bee9b;
var $c2bd1b702a3d9ea1$export$fb184b623420d9be;
var $c2bd1b702a3d9ea1$export$6b8103ff35a0f6fe;
var $c2bd1b702a3d9ea1$export$333eed13d25bd57;
$c2bd1b702a3d9ea1$export$77181601c038f22b = "XlFv1";
$c2bd1b702a3d9ea1$export$61f6990d5944375a = "cCXA8";
$c2bd1b702a3d9ea1$export$96ff94e0adb1d772 = "U1m8K";
$c2bd1b702a3d9ea1$export$96e4b36520c26a2c = "Oy7Bn";
$c2bd1b702a3d9ea1$export$a7db06668cad9adb = "_0MZGS";
$c2bd1b702a3d9ea1$export$321c0b1a406de31f = "uR2dm";
$c2bd1b702a3d9ea1$export$f4c5de44377d2946 = "Q9D5i";
$c2bd1b702a3d9ea1$export$1e95b668f3b82d = "sk6Ee";
$c2bd1b702a3d9ea1$export$da0c8716dc13cd97 = "V8CB3";
$c2bd1b702a3d9ea1$export$40e52e4cb633d77a = "JJztT";
$c2bd1b702a3d9ea1$export$a8fc3402335b0b04 = "pCHxs";
$c2bd1b702a3d9ea1$export$34e0f9847d4c02dd = "sUbOC";
$c2bd1b702a3d9ea1$export$d90250155de6d7e7 = "gP8z9";
$c2bd1b702a3d9ea1$export$e29b1f3b2b6a7669 = "UA1jT";
$c2bd1b702a3d9ea1$export$c99df9cf5e6bee9b = "qddhs";
$c2bd1b702a3d9ea1$export$fb184b623420d9be = "b9Ca-";
$c2bd1b702a3d9ea1$export$6b8103ff35a0f6fe = "SsI6m";
$c2bd1b702a3d9ea1$export$333eed13d25bd57 = "kj4UB";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $7912c60f03a9e48c$export$fe72765e3e76693f;
var $7912c60f03a9e48c$export$fb184b623420d9be;
var $7912c60f03a9e48c$export$6e9570de354791bd;
var $7912c60f03a9e48c$export$6788812c4e6611e6;
$7912c60f03a9e48c$export$fe72765e3e76693f = "qc9Zu";
$7912c60f03a9e48c$export$fb184b623420d9be = "IL033";
$7912c60f03a9e48c$export$6e9570de354791bd = "CQODP";
$7912c60f03a9e48c$export$6788812c4e6611e6 = "_5GN64";


var $5e3ee4c72bc0588f$export$48a3aac3632ef8 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferContentComponent, Component);
    function OfferContentComponent(contents, text) {
        (0, $3CDbU._)(this, OfferContentComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferContentComponent);
        _this.contents = contents;
        //language=HTML
        _this.template = '\n            <div class="'.concat($7912c60f03a9e48c$export$fe72765e3e76693f, '">\n                ').concat(text ? '<div class="'.concat($7912c60f03a9e48c$export$fb184b623420d9be, '">').concat(text, "</div>") : "", '\n                <ul class="').concat($7912c60f03a9e48c$export$6e9570de354791bd, '"></ul>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(OfferContentComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.offersContainer = this.el($7912c60f03a9e48c$export$6e9570de354791bd);
                this.contents.forEach(function(value) {
                    _this.offersContainer.append("<li>".concat(value, "</li>"));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferContentComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return OfferContentComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $9a3853b62ccb4707$export$32f66f1b48c85b65;
var $9a3853b62ccb4707$export$a8ff84c12d48cfa6;
var $9a3853b62ccb4707$export$58734539bbfa41a2;
var $9a3853b62ccb4707$export$2077e0241d6afd3c;
var $9a3853b62ccb4707$export$bb1a638da8ad190f;
var $9a3853b62ccb4707$export$1ca1ec8b29a4ce27;
var $9a3853b62ccb4707$export$f25d54de1f4102d2;
var $9a3853b62ccb4707$export$b7e3ae3d7c15e42e;
$9a3853b62ccb4707$export$32f66f1b48c85b65 = "EUyoY";
$9a3853b62ccb4707$export$a8ff84c12d48cfa6 = "mVkxk";
$9a3853b62ccb4707$export$58734539bbfa41a2 = "lvn7g";
$9a3853b62ccb4707$export$2077e0241d6afd3c = "_1tERG";
$9a3853b62ccb4707$export$bb1a638da8ad190f = "P5YuJ";
$9a3853b62ccb4707$export$1ca1ec8b29a4ce27 = "BXKYA";
$9a3853b62ccb4707$export$f25d54de1f4102d2 = "GWDS3";
$9a3853b62ccb4707$export$b7e3ae3d7c15e42e = "_4f7rU";



var $wYO7b = parcelRequire("wYO7b");

var $3Qm5T = parcelRequire("3Qm5T");
var $0a2a8b1178ca7d67$export$3629cf1b14c0cc2b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferSolutionComponent, Component);
    function OfferSolutionComponent(bundle, solution) {
        (0, $3CDbU._)(this, OfferSolutionComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferSolutionComponent);
        _this.solution = solution;
        _this.bundle = bundle;
        _this.value = solution.quantityInitial;
        //language=HTML
        _this.template = '\n            <div class="'.concat($9a3853b62ccb4707$export$32f66f1b48c85b65, '">\n                <div class="').concat($9a3853b62ccb4707$export$a8ff84c12d48cfa6, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerSolutionDescription".concat(solution.type)), '\n                </div>\n                <div class="').concat($9a3853b62ccb4707$export$58734539bbfa41a2, '">\n                    <div class="').concat($9a3853b62ccb4707$export$2077e0241d6afd3c, " ").concat($9a3853b62ccb4707$export$bb1a638da8ad190f, '">\n                        <div class="').concat($9a3853b62ccb4707$export$1ca1ec8b29a4ce27, '"></div>\n                    </div>\n                    <div class="').concat($9a3853b62ccb4707$export$b7e3ae3d7c15e42e, '">').concat(solution.quantityInitial, '</div>\n                    <div class="').concat($9a3853b62ccb4707$export$2077e0241d6afd3c, " ").concat($9a3853b62ccb4707$export$f25d54de1f4102d2, '">\n                        <div class="').concat($9a3853b62ccb4707$export$1ca1ec8b29a4ce27, '"></div>\n                    </div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(OfferSolutionComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.inputContainer = this.el($9a3853b62ccb4707$export$b7e3ae3d7c15e42e);
                this.lessButton = this.el($9a3853b62ccb4707$export$bb1a638da8ad190f);
                this.plusButton = this.el($9a3853b62ccb4707$export$f25d54de1f4102d2);
                this.lessButton.onClick(function() {
                    return _this.lessGranularity();
                });
                this.plusButton.onClick(function() {
                    return _this.plusGranularity();
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferSolutionComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "plusGranularity",
            value: function plusGranularity() {
                if (this.bundle.maxOption == undefined || this.solutionCount() < this.bundle.maxOption) {
                    this.value += this.solution.granularity;
                    this.inputContainer.setText(this.value + "");
                    this.onSolutionChange(this.solutionCount());
                } else (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.offerSolutionLimit"), undefined, 3000);
            }
        },
        {
            key: "lessGranularity",
            value: function lessGranularity() {
                var value = this.value - this.solution.granularity;
                if (value >= this.solution.quantityInitial) {
                    this.value = value;
                    this.inputContainer.setText(this.value + "");
                    this.onSolutionChange(this.solutionCount());
                }
            }
        },
        {
            key: "setGranularity",
            value: function setGranularity(count) {
                var _this_inputContainer;
                this.value = this.solution.quantityInitial + this.solution.granularity * count;
                (_this_inputContainer = this.inputContainer) === null || _this_inputContainer === void 0 ? void 0 : _this_inputContainer.setText(this.value + "");
            }
        },
        {
            key: "solutionCount",
            value: function solutionCount() {
                return this.solution.granularity > 0 ? Math.round((this.value - this.solution.quantityInitial) / this.solution.granularity) : Math.round(this.value - this.solution.quantityInitial);
            }
        },
        {
            key: "onSolutionChange",
            value: function onSolutionChange(count) {}
        }
    ]);
    return OfferSolutionComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $6f50ed8e07d458f7$export$915c6aaf55728df8;
var $6f50ed8e07d458f7$export$e4b2ac9215619f8d;
var $6f50ed8e07d458f7$export$fb184b623420d9be;
var $6f50ed8e07d458f7$export$ee3212a4833dc722;
var $6f50ed8e07d458f7$export$321c0b1a406de31f;
var $6f50ed8e07d458f7$export$da0c8716dc13cd97;
var $6f50ed8e07d458f7$export$2ba01fb71ed41cb6;
var $6f50ed8e07d458f7$export$46c1c92549715335;
$6f50ed8e07d458f7$export$915c6aaf55728df8 = "yzXs-";
$6f50ed8e07d458f7$export$e4b2ac9215619f8d = "uMQLz";
$6f50ed8e07d458f7$export$fb184b623420d9be = "OWv0j";
$6f50ed8e07d458f7$export$ee3212a4833dc722 = "kb75t";
$6f50ed8e07d458f7$export$321c0b1a406de31f = "h4AwQ";
$6f50ed8e07d458f7$export$da0c8716dc13cd97 = "D-iwl";
$6f50ed8e07d458f7$export$2ba01fb71ed41cb6 = "tKSgY";
$6f50ed8e07d458f7$export$46c1c92549715335 = "_6MlXq";


var $e4a056b6b54a25c6$export$b7ac94010691eccd = /*#__PURE__*/ function(OfferPeriodType) {
    OfferPeriodType[OfferPeriodType["MONTHLY"] = 0] = "MONTHLY";
    OfferPeriodType[OfferPeriodType["ANNUAL"] = 1] = "ANNUAL";
    return OfferPeriodType;
}({});



var $wYO7b = parcelRequire("wYO7b");


var $wYO7b = parcelRequire("wYO7b");
function $93e45b16057b7b5b$export$6349d151e019902e(priceCentimes, includedTax) {
    var priceEuros = priceCentimes / 100;
    var formattedPrice = priceEuros.toFixed(2);
    var tax = includedTax == undefined ? "" : includedTax == true ? " " + (0, $wYO7b.Resources).t("words.offerIncludeTax") : " " + (0, $wYO7b.Resources).t("words.offerExcludeTax");
    if (formattedPrice.endsWith("00")) return formattedPrice.substring(0, formattedPrice.length - 3) + "\u20AC" + tax;
    return formattedPrice + "\u20AC" + tax;
}


var $bf3d11141e19674b$export$19746147d1b55543 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferPriceComponent, Component);
    function OfferPriceComponent(p) {
        (0, $3CDbU._)(this, OfferPriceComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferPriceComponent);
        _this.period = p.period;
        _this.price = p.price;
        if (!p.noCalculateYear && p.period.periodType == (0, $e4a056b6b54a25c6$export$b7ac94010691eccd).ANNUAL) _this.price = (p.price - p.price * p.period.advantagePercentage) * 12;
        //language=HTML
        _this.template = '\n            <div class="'.concat($6f50ed8e07d458f7$export$915c6aaf55728df8, '">\n                <div class="').concat($6f50ed8e07d458f7$export$e4b2ac9215619f8d, '">\n                    <div class="').concat($6f50ed8e07d458f7$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.offerTotalPrice"), '\n                    </div>\n                    <div class="').concat($6f50ed8e07d458f7$export$ee3212a4833dc722, '">\n                        <span class="').concat($6f50ed8e07d458f7$export$321c0b1a406de31f, '">').concat((0, $93e45b16057b7b5b$export$6349d151e019902e)(_this.price), "\n                            ").concat(!p.totalPrice ? (0, $wYO7b.Resources).t("words.offerExcludeTax") : (0, $wYO7b.Resources).t("words.offerIncludeTax"), "</span>\n\n                        ").concat(p.totalPrice ? "" : '/<span\n                            class="'.concat($6f50ed8e07d458f7$export$da0c8716dc13cd97, '">').concat((0, $wYO7b.Resources).t("words.offerPeriodTitle".concat(_this.period.periodType)), "</span>"), '\n                    </div>\n                </div>\n                <div class="').concat($6f50ed8e07d458f7$export$2ba01fb71ed41cb6, '">\n                    ').concat(p.text, "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(OfferPriceComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.button = this.el($6f50ed8e07d458f7$export$2ba01fb71ed41cb6);
                this.button.onClick(function() {
                    if (!_this.button.hasClass($6f50ed8e07d458f7$export$46c1c92549715335)) _this.onGetStarted();
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferPriceComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "setLoading",
            value: function setLoading() {
                this.remLoading();
                this.loader = new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)({
                    strokeColor: "white"
                });
                this.button.addClass($6f50ed8e07d458f7$export$46c1c92549715335);
                this.button.render(this.loader);
            }
        },
        {
            key: "remLoading",
            value: function remLoading() {
                if (this.loader) {
                    this.loader.remove();
                    this.loader = undefined;
                }
                this.button.removeClass($6f50ed8e07d458f7$export$46c1c92549715335);
            }
        },
        {
            key: "onGetStarted",
            value: function onGetStarted() {
                this.setLoading();
            }
        }
    ]);
    return OfferPriceComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $5eeed82ae3c58431$export$d3861ffa4af1796e;
var $5eeed82ae3c58431$export$1e95b668f3b82d;
var $5eeed82ae3c58431$export$40e543e69a8b3fbb;
$5eeed82ae3c58431$export$d3861ffa4af1796e = "OEmeL";
$5eeed82ae3c58431$export$1e95b668f3b82d = "Pc1iI";
$5eeed82ae3c58431$export$40e543e69a8b3fbb = "StgcT";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $7c386589bc35cfa3$export$5533f3fa6fce9810;
var $7c386589bc35cfa3$export$8a5e915bd1d05fe0;
var $7c386589bc35cfa3$export$1158a42d67788fdd;
$7c386589bc35cfa3$export$5533f3fa6fce9810 = "FMZE3";
$7c386589bc35cfa3$export$8a5e915bd1d05fe0 = "lcPDH";
$7c386589bc35cfa3$export$1158a42d67788fdd = "e1j1C";


var $43d66d57869901bf$export$225d33e6c7e4852d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(LoaderObjectBlockComponent, Component);
    function LoaderObjectBlockComponent(shine) {
        (0, $3CDbU._)(this, LoaderObjectBlockComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, LoaderObjectBlockComponent);
        //language=HTML
        _this.template = '\n            <div loaderBlock class="'.concat($7c386589bc35cfa3$export$5533f3fa6fce9810, " ").concat(shine ? $7c386589bc35cfa3$export$8a5e915bd1d05fe0 : "", '">\n            </div>\n        ');
        return _this;
    }
    return LoaderObjectBlockComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $0ff859850435b9dd$export$8cb904089a919076;
var $0ff859850435b9dd$export$8a5e915bd1d05fe0;
var $0ff859850435b9dd$export$1158a42d67788fdd;
var $0ff859850435b9dd$export$be5493f9613cbbe;
$0ff859850435b9dd$export$8cb904089a919076 = "FWezv";
$0ff859850435b9dd$export$8a5e915bd1d05fe0 = "FJOsh";
$0ff859850435b9dd$export$1158a42d67788fdd = "MkV2y";
$0ff859850435b9dd$export$be5493f9613cbbe = "Hs9sf";



var $bXtBT = parcelRequire("bXtBT");
var $88c583ee1c5e45fe$export$766a040f1f31f2a9 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(LoaderObjectListComponent, Component);
    function LoaderObjectListComponent(shine, size, minHeight, maxHeight) {
        (0, $3CDbU._)(this, LoaderObjectListComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, LoaderObjectListComponent);
        _this.minHeight = minHeight;
        _this.maxHeight = maxHeight;
        if (typeof size == "undefined") size = 16;
        var objects = _this.object();
        for(var i = 0; i < size; i++)objects += _this.object();
        _this.template = '\n            <div loaderObjectList class="'.concat($0ff859850435b9dd$export$8cb904089a919076, " ").concat(shine ? $0ff859850435b9dd$export$8a5e915bd1d05fe0 : "", '">\n                ').concat(objects, "\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(LoaderObjectListComponent, [
        {
            key: "object",
            value: function object() {
                var height = (0, $bXtBT.randomInteger)(this.minHeight == undefined ? 60 : this.minHeight, this.maxHeight ? this.maxHeight : 120);
                return '<div style="height: '.concat(height, 'px;" class="').concat($0ff859850435b9dd$export$be5493f9613cbbe, '"></div>');
            }
        }
    ]);
    return LoaderObjectListComponent;
}((0, $9gCL8.Component));


var $918e9676245a49d6$export$71a85bce14e8f1c5 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(LoaderObjectOfferComponent, Component);
    function LoaderObjectOfferComponent(shine) {
        (0, $3CDbU._)(this, LoaderObjectOfferComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, LoaderObjectOfferComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($5eeed82ae3c58431$export$d3861ffa4af1796e, '">\n                <div class="').concat($5eeed82ae3c58431$export$1e95b668f3b82d, '">\n                    ').concat(_this.draw(new (0, $88c583ee1c5e45fe$export$766a040f1f31f2a9)(shine, 1, 40, 40)), '\n                </div>\n                <div class="').concat($5eeed82ae3c58431$export$40e543e69a8b3fbb, '">\n                    ').concat(_this.draw(new (0, $43d66d57869901bf$export$225d33e6c7e4852d)(shine)), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    return LoaderObjectOfferComponent;
}((0, $9gCL8.Component));



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");
var $d67df95cfdefdde4$export$9b114977314e08a5 = /*#__PURE__*/ function() {
    "use strict";
    function OfferProductTemplateService() {
        (0, $3CDbU._)(this, OfferProductTemplateService);
    }
    (0, $jyA4z._)(OfferProductTemplateService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.templates = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(templates) {
                for(var key in templates)templates[key] = this.store(templates[key]);
                return (0, $8GOyH.Services).storeAll(templates);
            }
        },
        {
            key: "store",
            value: function store(template) {
                template = (0, $8GOyH.Services).store("id", this.templates, template);
                return template;
            }
        }
    ]);
    return OfferProductTemplateService;
}();
$d67df95cfdefdde4$export$9b114977314e08a5.templates = (0, $j2lF8.observable)([]);



var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $c0453c00fb30c134$export$d4c083ce95fb2409 = /*#__PURE__*/ function(OfferState) {
    OfferState[OfferState["CONFIRMED"] = 0] = "CONFIRMED";
    OfferState[OfferState["PAYMENT"] = 1] = "PAYMENT";
    OfferState[OfferState["SUSPENDED"] = 2] = "SUSPENDED";
    OfferState[OfferState["CLOSED"] = 3] = "CLOSED";
    OfferState[OfferState["SCHEDULED"] = 4] = "SCHEDULED";
    OfferState[OfferState["IN_PROGRESS"] = 5] = "IN_PROGRESS";
    OfferState[OfferState["FAILURE_TO_PAY"] = 6] = "FAILURE_TO_PAY";
    return OfferState;
}({});



var $lThic = parcelRequire("lThic");
var $2105f4e2b30e22f8$export$361763241a2a268d = /*#__PURE__*/ function(OfferProductLevel) {
    OfferProductLevel[OfferProductLevel["PREMIUM"] = 0] = "PREMIUM";
    OfferProductLevel[OfferProductLevel["FREE"] = 1] = "FREE";
    return OfferProductLevel;
}({});


var $58c1bfefd78b8329$export$a047eb6606b2561b = /*#__PURE__*/ function() {
    "use strict";
    function OfferService() {
        (0, $3CDbU._)(this, OfferService);
    }
    (0, $jyA4z._)(OfferService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.offers = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "findAll",
            value: function findAll(component) {
                return (0, $hWZw8._)(function() {
                    var request, templates;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/templates", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    templates = request.data;
                                    Object.keys(templates.templates).forEach(function(value) {
                                        templates.templates[value] = (0, $d67df95cfdefdde4$export$9b114977314e08a5).store(templates.templates[value]);
                                    });
                                    return [
                                        2,
                                        templates
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "active",
            value: function active(displayPayment, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/active/".concat(displayPayment), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduled",
            value: function scheduled(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/schedule", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancel",
            value: function cancel(offerId, isCancel, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).TASK_IN_PROGRESS,
                                        message: (0, $wYO7b.Resources).t("words.taskInProgressOnCurrentOffer")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).OFFER_CANCELLED_EXPIRED,
                                        message: (0, $wYO7b.Resources).t("words.offerCancelledExpired")
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/offer/cancel/".concat(offerId, "/").concat(isCancel), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDateCancel",
            value: function getDateCancel(offerId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/cancel/estimateDate/".concat(offerId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "quote",
            value: //Récupérer le devis en cours quand tu actualises la page
            function quote(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/quote", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "quoteSubscription",
            value: //Créer un devis
            function quoteSubscription(offerSubscription, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).PROMOTION_CODE_INVALID,
                                        message: (0, $wYO7b.Resources).t("words.promoCodeInvalid")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).OFFER_ALREADY_EXISTS,
                                        message: (0, $wYO7b.Resources).t("words.youAlreadyHaveAnOngoingQuote")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).ACTIVE_OFFER_IS_FAILURE_TO_PAY,
                                        message: (0, $wYO7b.Resources).t("words.currentOfferPaymentDefault")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).OFFER_SAME_OFFER_ACTIVE,
                                        message: (0, $wYO7b.Resources).t("words.sameOfferConfiguration")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/offer/quote/subscription", offerSubscription, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "quoteCancel",
            value: function quoteCancel(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).TASK_IN_PROGRESS,
                                        message: (0, $wYO7b.Resources).t("words.taskInProgressOnCurrentOffer")
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/offer/quote/cancel", component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "quoteConfirmed",
            value: function quoteConfirmed(data, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).PROMOTION_CODE_INVALID,
                                        message: (0, $wYO7b.Resources).t("words.promoCodeInvalid")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).ACTIVE_OFFER_IS_FAILURE_TO_PAY,
                                        message: (0, $wYO7b.Resources).t("words.currentOfferPaymentDefault")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).TASK_IN_PROGRESS,
                                        message: (0, $wYO7b.Resources).t("words.taskInProgressOnCurrentOffer")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/offer/quote/confirmed", data, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteCb",
            value: function deleteCb(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).OFFER_ACTIVE_EXISTS,
                                        message: (0, $wYO7b.Resources).t("words.cannotDeleteCardDueToActiveOffer")
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: (0, $wYO7b.Resources).t("words.noCarError")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).PANEL, "/offer/cb", component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOfferPaymentSecrets",
            value: function getOfferPaymentSecrets(component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).BAD_REQUEST,
                                        message: (0, $wYO7b.Resources).t("words.cannotRetrievePaymentInfo")
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: (0, $wYO7b.Resources).t("words.noBankCardRegistered")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).PANEL, "/offer/cb/paymentSecret", component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "offerIsFree",
            value: //permissions
            function offerIsFree(type) {
                var _EntityService_activeOfferProducts_type;
                return ((_EntityService_activeOfferProducts_type = (0, $lThic.EntityService).activeOfferProducts[type]) === null || _EntityService_activeOfferProducts_type === void 0 ? void 0 : _EntityService_activeOfferProducts_type.level) == (0, $2105f4e2b30e22f8$export$361763241a2a268d).FREE;
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(offers) {
                for(var key in offers)offers[key] = this.store(offers[key]);
                return (0, $8GOyH.Services).storeAll(offers);
            }
        },
        {
            key: "store",
            value: function store(offer) {
                offer = (0, $8GOyH.Services).store("id", this.offers, offer);
                return offer;
            }
        },
        {
            key: "isPaymentFailed",
            value: function isPaymentFailed(offerDetails) {
                return (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offer.state) == (0, $c0453c00fb30c134$export$d4c083ce95fb2409).FAILURE_TO_PAY || (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offer.state) == (0, $c0453c00fb30c134$export$d4c083ce95fb2409).SUSPENDED;
            }
        }
    ]);
    return OfferService;
}();
$58c1bfefd78b8329$export$a047eb6606b2561b.offers = (0, $j2lF8.observable)([]);



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $d3630fe2a96be0b1$export$f3270842e3266d55;
var $d3630fe2a96be0b1$export$df8deae090c7c8ce;
var $d3630fe2a96be0b1$export$aea217a45095ce11;
var $d3630fe2a96be0b1$export$1ca1ec8b29a4ce27;
$d3630fe2a96be0b1$export$f3270842e3266d55 = "Ple9y";
$d3630fe2a96be0b1$export$df8deae090c7c8ce = "-BMvC";
$d3630fe2a96be0b1$export$aea217a45095ce11 = "vMVi1";
$d3630fe2a96be0b1$export$1ca1ec8b29a4ce27 = "NaNLE";



var $5m1WU = parcelRequire("5m1WU");
var $965bd87bb23aafee$export$60ff82c3e26d6c1f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CheckboxSlidingComponent, Component);
    function CheckboxSlidingComponent(entries, selected) {
        (0, $3CDbU._)(this, CheckboxSlidingComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CheckboxSlidingComponent);
        _this.entries = entries;
        _this.selected = selected;
        //language=HTML
        _this.template = '\n            <div chSliding class="'.concat($d3630fe2a96be0b1$export$f3270842e3266d55, '">\n                <div chEntry class="').concat($d3630fe2a96be0b1$export$df8deae090c7c8ce, " ").concat($d3630fe2a96be0b1$export$aea217a45095ce11, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(CheckboxSlidingComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.selectorComponent = this.el($d3630fe2a96be0b1$export$aea217a45095ce11);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var entry = _step.value;
                        var entryComponent = _this1.append("\n                <div chEntry ".concat(entry.title == undefined ? "" : 'data-tooltip="'.concat(entry.title, '"'), ' class="').concat($d3630fe2a96be0b1$export$df8deae090c7c8ce, '">\n                    ').concat(entry.html, "\n                </div>\n            "));
                        entryComponent.onClick(function() {
                            _this.select(entry.value);
                        });
                        entry.component = entryComponent;
                    };
                    for(var _iterator = this.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.currentValue = this.entries[0].value;
                if (this.selected != undefined) (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    return _this.select(_this.selected);
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CheckboxSlidingComponent.prototype), "commitTooltips", this).call(this);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CheckboxSlidingComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "onSelect",
            value: function onSelect(value) {}
        },
        {
            key: "select",
            value: function select(value, noAnimation) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (entry.value == value) {
                            var speed = noAnimation != undefined ? 10 : 200;
                            this.selectorComponent.translate({
                                moveLeft: entry.component.getParentOffsets().left,
                                delay: speed
                            });
                            this.currentComponent = entry.component;
                            this.currentValue = entry.value;
                            this.onSelect(value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return CheckboxSlidingComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $3accc8c4adbafd86$export$8f6adf886c3e91d5 = /*#__PURE__*/ function(CheckboxSlidingComponent) {
    "use strict";
    (0, $jCmGC._)(OfferPeriodComponent, CheckboxSlidingComponent);
    function OfferPeriodComponent(periods) {
        (0, $3CDbU._)(this, OfferPeriodComponent);
        return (0, $ep9cZ._)(this, OfferPeriodComponent, [
            periods.map(function(period) {
                return {
                    html: (0, $wYO7b.Resources).t("words.offerPeriod".concat(period.periodType)),
                    value: period.periodType + ""
                };
            })
        ]);
    }
    return OfferPeriodComponent;
}((0, $965bd87bb23aafee$export$60ff82c3e26d6c1f));




var $wYO7b = parcelRequire("wYO7b");



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $6ec9744be80cbcc3$export$1c80ec59d1789323;
var $6ec9744be80cbcc3$export$7c341cb16fc91138;
var $6ec9744be80cbcc3$export$1ca1ec8b29a4ce27;
var $6ec9744be80cbcc3$export$8f981dffec84ba52;
var $6ec9744be80cbcc3$export$ce69bd05624d0c48;
var $6ec9744be80cbcc3$export$acf4eaf431084f78;
var $6ec9744be80cbcc3$export$a8ff84c12d48cfa6;
var $6ec9744be80cbcc3$export$18f552c4c727aeb5;
var $6ec9744be80cbcc3$export$72108e4fb43880e3;
var $6ec9744be80cbcc3$export$7b388ca536128c6d;
var $6ec9744be80cbcc3$export$1237798dc640739a;
var $6ec9744be80cbcc3$export$66fec733742690b6;
var $6ec9744be80cbcc3$export$fb184b623420d9be;
var $6ec9744be80cbcc3$export$6d59db4903f20f7d;
var $6ec9744be80cbcc3$export$337d1885ef6f1e24;
var $6ec9744be80cbcc3$export$56030be9156ae856;
var $6ec9744be80cbcc3$export$321c0b1a406de31f;
var $6ec9744be80cbcc3$export$40e0ca2dfa95ba9e;
var $6ec9744be80cbcc3$export$735606310a3da449;
var $6ec9744be80cbcc3$export$a3bc9b8ed74fc;
var $6ec9744be80cbcc3$export$49c44dfc2bb21d70;
var $6ec9744be80cbcc3$export$98ea8a8009e37bf1;
var $6ec9744be80cbcc3$export$70b61ad426ddbe54;
var $6ec9744be80cbcc3$export$74d6ad014ec5fd29;
$6ec9744be80cbcc3$export$1c80ec59d1789323 = "_5F2IX";
$6ec9744be80cbcc3$export$7c341cb16fc91138 = "q3klv";
$6ec9744be80cbcc3$export$1ca1ec8b29a4ce27 = "pmorz";
$6ec9744be80cbcc3$export$8f981dffec84ba52 = "PjWcP";
$6ec9744be80cbcc3$export$ce69bd05624d0c48 = "amZSr";
$6ec9744be80cbcc3$export$acf4eaf431084f78 = "M5Ge7";
$6ec9744be80cbcc3$export$a8ff84c12d48cfa6 = "zKT09";
$6ec9744be80cbcc3$export$18f552c4c727aeb5 = "_7XTTr";
$6ec9744be80cbcc3$export$72108e4fb43880e3 = "Dmndu";
$6ec9744be80cbcc3$export$7b388ca536128c6d = "_6-jQd";
$6ec9744be80cbcc3$export$1237798dc640739a = "_03LXX";
$6ec9744be80cbcc3$export$66fec733742690b6 = "bLieP";
$6ec9744be80cbcc3$export$fb184b623420d9be = "VKtj9";
$6ec9744be80cbcc3$export$6d59db4903f20f7d = "QVU1G";
$6ec9744be80cbcc3$export$337d1885ef6f1e24 = "uawxm";
$6ec9744be80cbcc3$export$56030be9156ae856 = "_2ODnS";
$6ec9744be80cbcc3$export$321c0b1a406de31f = "p23dZ";
$6ec9744be80cbcc3$export$40e0ca2dfa95ba9e = "_2lpps";
$6ec9744be80cbcc3$export$735606310a3da449 = "cRi-p";
$6ec9744be80cbcc3$export$a3bc9b8ed74fc = "UyISm";
$6ec9744be80cbcc3$export$49c44dfc2bb21d70 = "UcQJZ";
$6ec9744be80cbcc3$export$98ea8a8009e37bf1 = "H73mJ";
$6ec9744be80cbcc3$export$70b61ad426ddbe54 = "_9iP2Y";
$6ec9744be80cbcc3$export$74d6ad014ec5fd29 = "X3f6l";






var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");
var $ec51238552ef069f$export$2ab62eda9e453014;
var $ec51238552ef069f$export$4c2b230493b2b322;
var $ec51238552ef069f$export$fb184b623420d9be;
var $ec51238552ef069f$export$a3bc9b8ed74fc;
var $ec51238552ef069f$export$b7e3ae3d7c15e42e;
var $ec51238552ef069f$export$73ba5813cda80a49;
var $ec51238552ef069f$export$7e39b47ba949ea16;
var $ec51238552ef069f$export$f9258c55612cbed7;
var $ec51238552ef069f$export$1fb2911de90ed83f;
var $ec51238552ef069f$export$2e6c959c16ff56b8;
var $ec51238552ef069f$export$1f96961348e52fad;
$ec51238552ef069f$export$2ab62eda9e453014 = "aqsVz";
$ec51238552ef069f$export$4c2b230493b2b322 = "_2-8xc";
$ec51238552ef069f$export$fb184b623420d9be = "HZ1gj";
$ec51238552ef069f$export$a3bc9b8ed74fc = "vogRx";
$ec51238552ef069f$export$b7e3ae3d7c15e42e = "_88EKk";
$ec51238552ef069f$export$73ba5813cda80a49 = "_9dWOo";
$ec51238552ef069f$export$7e39b47ba949ea16 = "_3ype4";
$ec51238552ef069f$export$f9258c55612cbed7 = "b2gKv";
$ec51238552ef069f$export$1fb2911de90ed83f = "-CEZY";
$ec51238552ef069f$export$2e6c959c16ff56b8 = "N5bLS";
$ec51238552ef069f$export$1f96961348e52fad = "ek2RZ";



var $9gCL8 = parcelRequire("9gCL8");

var $5m1WU = parcelRequire("5m1WU");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $f2dd29cd3e9b307e$export$2e2bcd8739ae039 = {
    version: 4,
    country_calling_codes: {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    countries: {
        AC: [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        AD: [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        AE: [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AF: [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AG: [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        AI: [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        AL: [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AM: [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AO: [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        AR: [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        AS: [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        AT: [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AU: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        AW: [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        AX: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        AZ: [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BA: [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BB: [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        BD: [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BE: [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BF: [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        BG: [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BH: [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        BI: [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        BJ: [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        BL: [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        BM: [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        BN: [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        BO: [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        BQ: [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        BR: [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        BS: [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        BT: [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        BW: [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        BY: [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        BZ: [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CA: [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        CC: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CD: [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CF: [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        CG: [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        CH: [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CI: [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CK: [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        CL: [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        CM: [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        CN: [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        CO: [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        CR: [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        CU: [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CV: [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        CW: [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        CX: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CY: [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        CZ: [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        DE: [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        DJ: [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        DK: [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        DM: [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        DO: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        DZ: [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EC: [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        EE: [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        EG: [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EH: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        ER: [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ES: [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        ET: [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        FI: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        FJ: [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        FK: [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        FM: [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        FO: [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        FR: [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GA: [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        GB: [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        GD: [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        GE: [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GF: [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GG: [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        GH: [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GI: [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        GL: [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        GM: [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        GN: [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        GP: [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        GQ: [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        GR: [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        GT: [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        GU: [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        GW: [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        GY: [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        HK: [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        HN: [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        HR: [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        HT: [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        HU: [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        ID: [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IE: [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IL: [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        IM: [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        IN: [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        IO: [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        IQ: [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IR: [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IS: [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        IT: [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        JE: [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        JM: [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        JO: [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        JP: [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        KE: [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KG: [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KH: [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        KI: [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        KM: [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        KN: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        KP: [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KR: [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        KW: [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        KY: [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        KZ: [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        LA: [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LB: [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        LC: [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        LI: [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        LK: [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LR: [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LS: [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        LT: [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        LU: [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        LV: [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        LY: [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MA: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        MC: [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MD: [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ME: [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MF: [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        MG: [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        MH: [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        MK: [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ML: [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        MM: [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MN: [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MO: [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        MP: [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        MQ: [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MR: [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        MS: [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        MT: [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        MU: [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        MV: [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        MW: [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MX: [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        MY: [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MZ: [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NA: [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NC: [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        NE: [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        NF: [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        NG: [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NI: [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        NL: [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NO: [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        NP: [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        NR: [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        NU: [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NZ: [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        OM: [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        PA: [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PE: [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        PF: [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PG: [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        PH: [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PK: [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        PL: [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PM: [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        PR: [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        PS: [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PT: [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        PW: [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        PY: [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        QA: [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        RE: [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        RO: [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        RS: [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        RU: [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        RW: [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SA: [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        SB: [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        SC: [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SD: [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SE: [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        SG: [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        SH: [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        SI: [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SJ: [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        SK: [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SL: [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        SM: [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        SN: [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        SO: [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        SR: [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        SS: [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ST: [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        SV: [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        SX: [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        SY: [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        SZ: [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        TA: [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        TC: [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        TD: [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        TG: [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        TH: [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        TJ: [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TK: [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        TL: [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TM: [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TN: [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        TO: [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        TR: [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        TT: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        TV: [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TW: [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        TZ: [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        UA: [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        UG: [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        US: [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        UY: [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        UZ: [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        VA: [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        VC: [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        VE: [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        VG: [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        VI: [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        VN: [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        VU: [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        WF: [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        WS: [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        XK: [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YE: [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YT: [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        ZA: [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZM: [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZW: [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    nonGeographic: {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $9e51943c093be60a$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


var $206cb48cfb06a52c$var$objectConstructor = {}.constructor;
function $206cb48cfb06a52c$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $206cb48cfb06a52c$var$objectConstructor;
}


function $4760ad3c0b393a66$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4760ad3c0b393a66$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4760ad3c0b393a66$var$_typeof(obj);
}
function $4760ad3c0b393a66$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4760ad3c0b393a66$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4760ad3c0b393a66$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4760ad3c0b393a66$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4760ad3c0b393a66$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $4760ad3c0b393a66$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $4760ad3c0b393a66$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $4760ad3c0b393a66$var$V4 = '1.7.35';
var $4760ad3c0b393a66$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $4760ad3c0b393a66$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $4760ad3c0b393a66$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $4760ad3c0b393a66$var$_classCallCheck(this, Metadata);
        $4760ad3c0b393a66$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $4760ad3c0b393a66$var$setVersion.call(this, metadata);
    }
    $4760ad3c0b393a66$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $4760ad3c0b393a66$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $4760ad3c0b393a66$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $4760ad3c0b393a66$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $4760ad3c0b393a66$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $4760ad3c0b393a66$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $4760ad3c0b393a66$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $4760ad3c0b393a66$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $4760ad3c0b393a66$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $4760ad3c0b393a66$var$getType(this.types(), _type2)) return new $4760ad3c0b393a66$var$Type($4760ad3c0b393a66$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $4760ad3c0b393a66$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $4760ad3c0b393a66$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $4760ad3c0b393a66$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $4760ad3c0b393a66$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $4760ad3c0b393a66$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$4760ad3c0b393a66$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $4760ad3c0b393a66$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $4760ad3c0b393a66$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $4760ad3c0b393a66$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $4760ad3c0b393a66$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $4760ad3c0b393a66$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $4760ad3c0b393a66$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(metadata) || !(0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $4760ad3c0b393a66$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $4760ad3c0b393a66$var$typeOf = function typeOf(_) {
    return $4760ad3c0b393a66$var$_typeof(_);
};
function $4760ad3c0b393a66$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $4760ad3c0b393a66$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $4760ad3c0b393a66$var$DEFAULT_EXT_PREFIX;
}
function $4760ad3c0b393a66$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $4760ad3c0b393a66$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $4760ad3c0b393a66$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $4760ad3c0b393a66$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $9e51943c093be60a$export$2e2bcd8739ae039)(version, $4760ad3c0b393a66$var$V3) === -1) this.v2 = true;
        else if ((0, $9e51943c093be60a$export$2e2bcd8739ae039)(version, $4760ad3c0b393a66$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




function $185461418284654d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $185461418284654d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $185461418284654d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $185461418284654d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $185461418284654d$var$_arrayLikeToArray(o, minLen);
}
function $185461418284654d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $185461418284654d$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $185461418284654d$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $e125dadd88ab7a6e$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $e125dadd88ab7a6e$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $e125dadd88ab7a6e$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $e125dadd88ab7a6e$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $185461418284654d$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $31bca4ad9fa433f3$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $31bca4ad9fa433f3$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $31bca4ad9fa433f3$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $e125dadd88ab7a6e$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}



/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $10fb07b4a57c315a$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $da30a7f37d393039$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $da30a7f37d393039$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $da30a7f37d393039$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $da30a7f37d393039$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $da30a7f37d393039$var$_arrayLikeToArray(o, minLen);
}
function $da30a7f37d393039$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $da30a7f37d393039$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $da30a7f37d393039$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($da30a7f37d393039$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($da30a7f37d393039$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $da30a7f37d393039$var$_createForOfIteratorHelperLoose($da30a7f37d393039$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($da30a7f37d393039$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $da30a7f37d393039$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $435e6e1a4bbf190b$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $da30a7f37d393039$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $816e601bc3f639ee$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $816e601bc3f639ee$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $816e601bc3f639ee$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}



// The minimum length of the national significant number.
var $24e4d3b872b2066b$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $24e4d3b872b2066b$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $24e4d3b872b2066b$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $24e4d3b872b2066b$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $24e4d3b872b2066b$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $24e4d3b872b2066b$var$SLASHES = "\uFF0F/";
var $24e4d3b872b2066b$var$DOTS = "\uFF0E.";
var $24e4d3b872b2066b$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $24e4d3b872b2066b$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $24e4d3b872b2066b$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $24e4d3b872b2066b$export$7f01587e28f9194 = "".concat($24e4d3b872b2066b$var$DASHES).concat($24e4d3b872b2066b$var$SLASHES).concat($24e4d3b872b2066b$var$DOTS).concat($24e4d3b872b2066b$export$20542845033f576e).concat($24e4d3b872b2066b$var$BRACKETS).concat($24e4d3b872b2066b$var$TILDES);
var $24e4d3b872b2066b$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


var $cd59c7b5b78cb6c2$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + '])');
function $cd59c7b5b78cb6c2$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($cd59c7b5b78cb6c2$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $300e54464323b382$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $267bfdd757e8049b$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $300e54464323b382$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$267bfdd757e8049b$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$267bfdd757e8049b$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $267bfdd757e8049b$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $267bfdd757e8049b$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $e125dadd88ab7a6e$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $619c797d88584aa7$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $4760ad3c0b393a66$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $267bfdd757e8049b$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $267bfdd757e8049b$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $e125dadd88ab7a6e$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $d762ce87c559e3c5$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $cd59c7b5b78cb6c2$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $619c797d88584aa7$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $24e4d3b872b2066b$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $46cf187fe9c00ceb$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $24e4d3b872b2066b$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $873e61dccabe7ce5$export$4f32ad1c51a7a6be = /(\$\d)/;
function $873e61dccabe7ce5$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($873e61dccabe7ce5$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $46cf187fe9c00ceb$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $bde376cac38a007b$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $bde376cac38a007b$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($bde376cac38a007b$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}




var $578fe4d8a07e3d2c$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $578fe4d8a07e3d2c$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $24e4d3b872b2066b$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $578fe4d8a07e3d2c$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $578fe4d8a07e3d2c$var$RFC3966_EXTN_PREFIX + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $578fe4d8a07e3d2c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $17296e6445a3bb26$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']{' + (0, $24e4d3b872b2066b$export$cd8355bcbe13154) + '}'; //
var $17296e6445a3bb26$export$a77dd7471651eee = '[' + (0, $24e4d3b872b2066b$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + ']*' + '[' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $17296e6445a3bb26$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $24e4d3b872b2066b$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + ']*' + '[' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $17296e6445a3bb26$export$a2d12a04749c087d = $17296e6445a3bb26$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $578fe4d8a07e3d2c$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $17296e6445a3bb26$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $17296e6445a3bb26$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $17296e6445a3bb26$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $17296e6445a3bb26$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $24e4d3b872b2066b$export$cd8355bcbe13154) && $17296e6445a3bb26$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $17296e6445a3bb26$export$4c3f76c95c05197c(number) {
    return $17296e6445a3bb26$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}


function $fab8e27f9e5faadc$var$_slicedToArray(arr, i) {
    return $fab8e27f9e5faadc$var$_arrayWithHoles(arr) || $fab8e27f9e5faadc$var$_iterableToArrayLimit(arr, i) || $fab8e27f9e5faadc$var$_unsupportedIterableToArray(arr, i) || $fab8e27f9e5faadc$var$_nonIterableRest();
}
function $fab8e27f9e5faadc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fab8e27f9e5faadc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fab8e27f9e5faadc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fab8e27f9e5faadc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fab8e27f9e5faadc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fab8e27f9e5faadc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fab8e27f9e5faadc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fab8e27f9e5faadc$var$_arrayLikeToArray(o, minLen);
}
function $fab8e27f9e5faadc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fab8e27f9e5faadc$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $fab8e27f9e5faadc$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $fab8e27f9e5faadc$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $17296e6445a3bb26$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $fab8e27f9e5faadc$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $11d4c4cb2027075e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $11d4c4cb2027075e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $11d4c4cb2027075e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $11d4c4cb2027075e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $11d4c4cb2027075e$var$_arrayLikeToArray(o, minLen);
}
function $11d4c4cb2027075e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $11d4c4cb2027075e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $11d4c4cb2027075e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $11d4c4cb2027075e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $11d4c4cb2027075e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $11d4c4cb2027075e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $11d4c4cb2027075e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $11d4c4cb2027075e$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $11d4c4cb2027075e$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $11d4c4cb2027075e$var$_objectSpread($11d4c4cb2027075e$var$_objectSpread({}, $11d4c4cb2027075e$var$DEFAULT_OPTIONS), options);
    else options = $11d4c4cb2027075e$var$DEFAULT_OPTIONS;
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $11d4c4cb2027075e$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $11d4c4cb2027075e$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $11d4c4cb2027075e$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $11d4c4cb2027075e$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $fab8e27f9e5faadc$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $11d4c4cb2027075e$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $11d4c4cb2027075e$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $11d4c4cb2027075e$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $11d4c4cb2027075e$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $873e61dccabe7ce5$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $11d4c4cb2027075e$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $11d4c4cb2027075e$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $11d4c4cb2027075e$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $11d4c4cb2027075e$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $4760ad3c0b393a66$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $11d4c4cb2027075e$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $bde376cac38a007b$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($11d4c4cb2027075e$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $11b39e33a2c97248$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $11b39e33a2c97248$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $11b39e33a2c97248$var$ownKeys(Object(source), !0).forEach(function(key) {
            $11b39e33a2c97248$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $11b39e33a2c97248$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $11b39e33a2c97248$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11b39e33a2c97248$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11b39e33a2c97248$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b39e33a2c97248$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $11b39e33a2c97248$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b39e33a2c97248$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $11b39e33a2c97248$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $11b39e33a2c97248$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $11b39e33a2c97248$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === 'string') {
            if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
            if ((0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(nationalNumber) && (0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$11b39e33a2c97248$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $d762ce87c559e3c5$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
         // Validate `metadata` argument.
        (0, $4760ad3c0b393a66$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $11b39e33a2c97248$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $11b39e33a2c97248$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $816e601bc3f639ee$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $31bca4ad9fa433f3$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $435e6e1a4bbf190b$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $da30a7f37d393039$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $11d4c4cb2027075e$export$2e2bcd8739ae039)(this, _format, options ? $11b39e33a2c97248$var$_objectSpread($11b39e33a2c97248$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $11b39e33a2c97248$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $11b39e33a2c97248$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($11b39e33a2c97248$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($11b39e33a2c97248$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $11b39e33a2c97248$var$E164_NUMBER_REGEXP = /^\+\d+$/;


function $3a0aefe1ab4c3a85$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a0aefe1ab4c3a85$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3a0aefe1ab4c3a85$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a0aefe1ab4c3a85$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a0aefe1ab4c3a85$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var $3a0aefe1ab4c3a85$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $3a0aefe1ab4c3a85$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $3a0aefe1ab4c3a85$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(_ref2) {
                var country = _ref2.country, callingCode = _ref2.callingCode;
                this.international = false;
                this.missingPlus = false;
                this.IDDPrefix = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();


function $767f183790c019a6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $767f183790c019a6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $767f183790c019a6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $767f183790c019a6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $767f183790c019a6$var$_arrayLikeToArray(o, minLen);
}
function $767f183790c019a6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $767f183790c019a6$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $767f183790c019a6$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($767f183790c019a6$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $767f183790c019a6$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $767f183790c019a6$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $767f183790c019a6$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $767f183790c019a6$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $767f183790c019a6$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $767f183790c019a6$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $767f183790c019a6$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $767f183790c019a6$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $767f183790c019a6$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $767f183790c019a6$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $767f183790c019a6$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($767f183790c019a6$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($767f183790c019a6$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($767f183790c019a6$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}



function $8e562bcdaf9a8d29$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8e562bcdaf9a8d29$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e562bcdaf9a8d29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8e562bcdaf9a8d29$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8e562bcdaf9a8d29$var$_arrayLikeToArray(o, minLen);
}
function $8e562bcdaf9a8d29$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $8e562bcdaf9a8d29$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $8e562bcdaf9a8d29$export$1d16fddea1437169(character) {
    return $8e562bcdaf9a8d29$export$2848f3d68c08fe69[character];
}
function $8e562bcdaf9a8d29$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $8e562bcdaf9a8d29$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $8e562bcdaf9a8d29$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}



function $f40f8097b974ebfe$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $f40f8097b974ebfe$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $f40f8097b974ebfe$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $e125dadd88ab7a6e$export$2e2bcd8739ae039)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $f40f8097b974ebfe$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $f40f8097b974ebfe$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $f40f8097b974ebfe$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $f40f8097b974ebfe$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $873e61dccabe7ce5$export$2e2bcd8739ae039)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($f40f8097b974ebfe$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $f40f8097b974ebfe$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $8e562bcdaf9a8d29$export$2e2bcd8739ae039)(formattedNationalNumber) === state.getNationalDigits();
}


function $25004c3270da24be$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $25004c3270da24be$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $25004c3270da24be$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $25004c3270da24be$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $25004c3270da24be$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $25004c3270da24be$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $25004c3270da24be$var$_classCallCheck(this, PatternParser);
    }
    $25004c3270da24be$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $25004c3270da24be$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($25004c3270da24be$var$OPERATOR);
                if (!match) {
                    if ($25004c3270da24be$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($25004c3270da24be$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($25004c3270da24be$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $25004c3270da24be$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $25004c3270da24be$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $25004c3270da24be$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $25004c3270da24be$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $25004c3270da24be$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}


function $e111c03aec625530$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e111c03aec625530$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e111c03aec625530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e111c03aec625530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e111c03aec625530$var$_arrayLikeToArray(o, minLen);
}
function $e111c03aec625530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e111c03aec625530$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e111c03aec625530$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e111c03aec625530$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e111c03aec625530$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e111c03aec625530$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $e111c03aec625530$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $e111c03aec625530$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $25004c3270da24be$export$2e2bcd8739ae039)().parse(pattern);
    }
    $e111c03aec625530$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $e111c03aec625530$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $e111c03aec625530$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $e111c03aec625530$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $e111c03aec625530$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $e111c03aec625530$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $e111c03aec625530$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}






function $eda15ec656ea899b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $eda15ec656ea899b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eda15ec656ea899b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eda15ec656ea899b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eda15ec656ea899b$var$_arrayLikeToArray(o, minLen);
}
function $eda15ec656ea899b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eda15ec656ea899b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eda15ec656ea899b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eda15ec656ea899b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eda15ec656ea899b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eda15ec656ea899b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $eda15ec656ea899b$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $eda15ec656ea899b$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $eda15ec656ea899b$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $767f183790c019a6$export$76d90c956114f2c2)($eda15ec656ea899b$var$DUMMY_DIGIT, $eda15ec656ea899b$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $eda15ec656ea899b$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $eda15ec656ea899b$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $eda15ec656ea899b$var$CREATE_CHARACTER_CLASS_PATTERN = $eda15ec656ea899b$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $eda15ec656ea899b$var$CREATE_STANDALONE_DIGIT_PATTERN = $eda15ec656ea899b$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $eda15ec656ea899b$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + ']*' + '(\\$\\d[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $eda15ec656ea899b$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $eda15ec656ea899b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $eda15ec656ea899b$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $eda15ec656ea899b$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $f40f8097b974ebfe$export$9e33d25ea5d3e526)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $eda15ec656ea899b$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $f40f8097b974ebfe$export$2e2bcd8739ae039)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $767f183790c019a6$export$2a0174a7c311f338)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $767f183790c019a6$export$2a0174a7c311f338));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $eda15ec656ea899b$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $eda15ec656ea899b$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $e111c03aec625530$export$2e2bcd8739ae039)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$eda15ec656ea899b$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $eda15ec656ea899b$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($eda15ec656ea899b$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $eda15ec656ea899b$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $767f183790c019a6$export$2a0174a7c311f338), index + 1);
                    i++;
                }
                return (0, $767f183790c019a6$export$ac095dcff0205861)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $767f183790c019a6$export$2a0174a7c311f338)) + (0, $767f183790c019a6$export$76d90c956114f2c2)((0, $767f183790c019a6$export$2a0174a7c311f338), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($eda15ec656ea899b$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($eda15ec656ea899b$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($eda15ec656ea899b$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $eda15ec656ea899b$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $eda15ec656ea899b$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $873e61dccabe7ce5$export$4f32ad1c51a7a6be), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $8e562bcdaf9a8d29$export$2e2bcd8739ae039)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $8e562bcdaf9a8d29$export$2e2bcd8739ae039)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $767f183790c019a6$export$2a0174a7c311f338));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($eda15ec656ea899b$var$DUMMY_DIGIT, 'g'), (0, $767f183790c019a6$export$2a0174a7c311f338)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $767f183790c019a6$export$76d90c956114f2c2)((0, $767f183790c019a6$export$2a0174a7c311f338), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $767f183790c019a6$export$76d90c956114f2c2)((0, $767f183790c019a6$export$2a0174a7c311f338), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $46cf187fe9c00ceb$export$2e2bcd8739ae039)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $767f183790c019a6$export$a15547494b55ca4e)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $767f183790c019a6$export$ac095dcff0205861)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();








function $2932a5207260597a$var$_slicedToArray(arr, i) {
    return $2932a5207260597a$var$_arrayWithHoles(arr) || $2932a5207260597a$var$_iterableToArrayLimit(arr, i) || $2932a5207260597a$var$_unsupportedIterableToArray(arr, i) || $2932a5207260597a$var$_nonIterableRest();
}
function $2932a5207260597a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2932a5207260597a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2932a5207260597a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2932a5207260597a$var$_arrayLikeToArray(o, minLen);
}
function $2932a5207260597a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2932a5207260597a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2932a5207260597a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2932a5207260597a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2932a5207260597a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2932a5207260597a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2932a5207260597a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2932a5207260597a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']+';
var $2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $24e4d3b872b2066b$export$207c99ccf3902df8) + ']' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']*' + '|' + '[' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']+' + ')';
var $2932a5207260597a$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $24e4d3b872b2066b$export$7f01587e28f9194) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $2932a5207260597a$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $2932a5207260597a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $2932a5207260597a$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $2932a5207260597a$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $2932a5207260597a$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $2932a5207260597a$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $8e562bcdaf9a8d29$export$2e2bcd8739ae039)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $d762ce87c559e3c5$export$2e2bcd8739ae039)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $2932a5207260597a$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $300e54464323b382$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $300e54464323b382$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $cd59c7b5b78cb6c2$export$2e2bcd8739ae039)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $619c797d88584aa7$export$2e2bcd8739ae039)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $2932a5207260597a$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($2932a5207260597a$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $2932a5207260597a$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $2932a5207260597a$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $2932a5207260597a$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $2932a5207260597a$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $2932a5207260597a$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$2932a5207260597a$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}




function $4a47e9f7a3997e89$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4a47e9f7a3997e89$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4a47e9f7a3997e89$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4a47e9f7a3997e89$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4a47e9f7a3997e89$var$_arrayLikeToArray(o, minLen);
}
function $4a47e9f7a3997e89$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4a47e9f7a3997e89$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $4a47e9f7a3997e89$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $da30a7f37d393039$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $1cc6a41c9e22596e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $1cc6a41c9e22596e$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($1cc6a41c9e22596e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $4a47e9f7a3997e89$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}




function $3515ecc9b5a8d362$var$_slicedToArray(arr, i) {
    return $3515ecc9b5a8d362$var$_arrayWithHoles(arr) || $3515ecc9b5a8d362$var$_iterableToArrayLimit(arr, i) || $3515ecc9b5a8d362$var$_unsupportedIterableToArray(arr, i) || $3515ecc9b5a8d362$var$_nonIterableRest();
}
function $3515ecc9b5a8d362$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3515ecc9b5a8d362$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3515ecc9b5a8d362$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3515ecc9b5a8d362$var$_arrayLikeToArray(o, minLen);
}
function $3515ecc9b5a8d362$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3515ecc9b5a8d362$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3515ecc9b5a8d362$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3515ecc9b5a8d362$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3515ecc9b5a8d362$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3515ecc9b5a8d362$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3515ecc9b5a8d362$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3515ecc9b5a8d362$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $3515ecc9b5a8d362$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $3515ecc9b5a8d362$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $3515ecc9b5a8d362$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $3515ecc9b5a8d362$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
        // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
        // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $3515ecc9b5a8d362$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ((0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(optionsOrDefaultCountry)) {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($3515ecc9b5a8d362$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $3a0aefe1ab4c3a85$export$2e2bcd8739ae039)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $eda15ec656ea899b$export$2e2bcd8739ae039)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $2932a5207260597a$export$2e2bcd8739ae039)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                });
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($3515ecc9b5a8d362$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $767f183790c019a6$export$2a0174a7c311f338));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $1cc6a41c9e22596e$export$2e2bcd8739ae039)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                 // `state.country` and `state.callingCode` aren't required to be in sync.
                // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
                // So `country` and `callingCode` are totally independent.
                if (!country && !callingCode) return;
                 // By default, if `defaultCountry` parameter was passed when
                // creating `AsYouType` instance, `state.country` is gonna be
                // that `defaultCountry`, which doesn't entirely conform with
                // `parsePhoneNumber()`'s behavior where it attempts to determine
                // the country more precisely in cases when multiple countries
                // could correspond to the same `countryCallingCode`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
                //
                // Because `AsYouType.getNumber()` method is supposed to be a 1:1
                // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
                // then it should also behave accordingly in cases of `country` ambiguity.
                // That's how users of this library would expect it to behave anyway.
                //
                if (country) {
                    if (country === this.defaultCountry) {
                        // `state.country` and `state.callingCode` aren't required to be in sync.
                        // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
                        // So `state.country` and `state.callingCode` are totally independent.
                        var metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(this.metadata.metadata);
                        metadata.selectNumberingPlan(country);
                        var _callingCode = metadata.numberingPlan.callingCode();
                        var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
                        if (ambiguousCountries.length > 1) {
                            var exactCountry = (0, $4a47e9f7a3997e89$export$2e2bcd8739ae039)(nationalSignificantNumber, {
                                countries: ambiguousCountries,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            if (exactCountry) country = exactCountry;
                        }
                    }
                }
                var phoneNumber = new (0, $11b39e33a2c97248$export$2e2bcd8739ae039)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();


function $e40bfda488419a26$export$80d8c6912928a4eb(country) {
    return (0, $3515ecc9b5a8d362$export$2e2bcd8739ae039).call(this, country, (0, $f2dd29cd3e9b307e$export$2e2bcd8739ae039));
}
$e40bfda488419a26$export$80d8c6912928a4eb.prototype = Object.create((0, $3515ecc9b5a8d362$export$2e2bcd8739ae039).prototype, {});
$e40bfda488419a26$export$80d8c6912928a4eb.prototype.constructor = $e40bfda488419a26$export$80d8c6912928a4eb;

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

function $951e0331af33368c$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $f2dd29cd3e9b307e$export$2e2bcd8739ae039));
    return func.apply(this, args);
}



function $a98b3966922c44e4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a98b3966922c44e4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a98b3966922c44e4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a98b3966922c44e4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a98b3966922c44e4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a98b3966922c44e4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a98b3966922c44e4$var$_slicedToArray(arr, i) {
    return $a98b3966922c44e4$var$_arrayWithHoles(arr) || $a98b3966922c44e4$var$_iterableToArrayLimit(arr, i) || $a98b3966922c44e4$var$_unsupportedIterableToArray(arr, i) || $a98b3966922c44e4$var$_nonIterableRest();
}
function $a98b3966922c44e4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a98b3966922c44e4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a98b3966922c44e4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a98b3966922c44e4$var$_arrayLikeToArray(o, minLen);
}
function $a98b3966922c44e4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a98b3966922c44e4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a98b3966922c44e4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a98b3966922c44e4$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $a98b3966922c44e4$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $a98b3966922c44e4$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $206cb48cfb06a52c$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

function $9c54a162030e4c57$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9c54a162030e4c57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9c54a162030e4c57$var$_typeof(obj);
}
function $9c54a162030e4c57$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9c54a162030e4c57$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9c54a162030e4c57$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9c54a162030e4c57$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9c54a162030e4c57$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9c54a162030e4c57$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9c54a162030e4c57$var$_setPrototypeOf(subClass, superClass);
}
function $9c54a162030e4c57$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9c54a162030e4c57$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9c54a162030e4c57$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9c54a162030e4c57$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9c54a162030e4c57$var$_possibleConstructorReturn(this, result);
    };
}
function $9c54a162030e4c57$var$_possibleConstructorReturn(self, call) {
    if (call && ($9c54a162030e4c57$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9c54a162030e4c57$var$_assertThisInitialized(self);
}
function $9c54a162030e4c57$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9c54a162030e4c57$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9c54a162030e4c57$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$9c54a162030e4c57$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $9c54a162030e4c57$var$_construct(Class, arguments, $9c54a162030e4c57$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $9c54a162030e4c57$var$_setPrototypeOf(Wrapper, Class);
    };
    return $9c54a162030e4c57$var$_wrapNativeSuper(Class);
}
function $9c54a162030e4c57$var$_construct(Parent, args, Class) {
    if ($9c54a162030e4c57$var$_isNativeReflectConstruct()) $9c54a162030e4c57$var$_construct = Reflect.construct;
    else $9c54a162030e4c57$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $9c54a162030e4c57$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $9c54a162030e4c57$var$_construct.apply(null, arguments);
}
function $9c54a162030e4c57$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9c54a162030e4c57$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $9c54a162030e4c57$var$_setPrototypeOf(o, p) {
    $9c54a162030e4c57$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9c54a162030e4c57$var$_setPrototypeOf(o, p);
}
function $9c54a162030e4c57$var$_getPrototypeOf(o) {
    $9c54a162030e4c57$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9c54a162030e4c57$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $9c54a162030e4c57$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $9c54a162030e4c57$var$_inherits(ParseError, _Error);
    var _super = $9c54a162030e4c57$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $9c54a162030e4c57$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($9c54a162030e4c57$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $9c54a162030e4c57$var$_createClass(ParseError);
}(/*#__PURE__*/ $9c54a162030e4c57$var$_wrapNativeSuper(Error));





// 1 or more valid digits, for use when parsing.
var $e2aa57459c109023$var$EXTN_PATTERN = new RegExp('(?:' + (0, $578fe4d8a07e3d2c$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $e2aa57459c109023$export$2e2bcd8739ae039(number) {
    var start = number.search($e2aa57459c109023$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($e2aa57459c109023$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}



function $4be77465f80d1ad6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4be77465f80d1ad6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4be77465f80d1ad6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4be77465f80d1ad6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4be77465f80d1ad6$var$_arrayLikeToArray(o, minLen);
}
function $4be77465f80d1ad6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4be77465f80d1ad6$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $4be77465f80d1ad6$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $4be77465f80d1ad6$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $4be77465f80d1ad6$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $8e562bcdaf9a8d29$export$1d16fddea1437169)(character);
}










// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $715e43ac2e09f367$export$1ddc7eed78155f68 = '+';
var $715e43ac2e09f367$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $715e43ac2e09f367$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']' + '|' + $715e43ac2e09f367$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $715e43ac2e09f367$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $715e43ac2e09f367$export$1ddc7eed78155f68 + $715e43ac2e09f367$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']' + $715e43ac2e09f367$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $715e43ac2e09f367$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($715e43ac2e09f367$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $715e43ac2e09f367$var$ALPHANUM_ = (0, $24e4d3b872b2066b$export$852d1d4a47329634);
var $715e43ac2e09f367$var$RFC3966_DOMAINLABEL_ = '[' + $715e43ac2e09f367$var$ALPHANUM_ + ']+((\\-)*[' + $715e43ac2e09f367$var$ALPHANUM_ + '])*';
var $715e43ac2e09f367$var$VALID_ALPHA_ = 'a-zA-Z';
var $715e43ac2e09f367$var$RFC3966_TOPLABEL_ = '[' + $715e43ac2e09f367$var$VALID_ALPHA_ + ']+((\\-)*[' + $715e43ac2e09f367$var$ALPHANUM_ + '])*';
var $715e43ac2e09f367$var$RFC3966_DOMAINNAME_ = '^(' + $715e43ac2e09f367$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $715e43ac2e09f367$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $715e43ac2e09f367$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($715e43ac2e09f367$var$RFC3966_DOMAINNAME_, 'g');
var $715e43ac2e09f367$export$70d485ce3f6de783 = 'tel:';
var $715e43ac2e09f367$export$f6d5879d582c3a27 = ';phone-context=';
var $715e43ac2e09f367$export$9e356e12edb00a81 = ';isub=';
function $715e43ac2e09f367$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($715e43ac2e09f367$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $715e43ac2e09f367$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $715e43ac2e09f367$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $715e43ac2e09f367$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $715e43ac2e09f367$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $cf1bddc4fc0feeb0$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $715e43ac2e09f367$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $715e43ac2e09f367$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $715e43ac2e09f367$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $715e43ac2e09f367$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $715e43ac2e09f367$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $715e43ac2e09f367$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $715e43ac2e09f367$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $152b0dabc8a5982f$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $152b0dabc8a5982f$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $24e4d3b872b2066b$export$207c99ccf3902df8) + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $152b0dabc8a5982f$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $24e4d3b872b2066b$export$852d1d4a47329634) + '#' + ']+$');
var $152b0dabc8a5982f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $152b0dabc8a5982f$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $4760ad3c0b393a66$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $152b0dabc8a5982f$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $152b0dabc8a5982f$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $24e4d3b872b2066b$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $24e4d3b872b2066b$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $11b39e33a2c97248$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $10fb07b4a57c315a$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $152b0dabc8a5982f$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $31bca4ad9fa433f3$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $152b0dabc8a5982f$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $152b0dabc8a5982f$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $9c54a162030e4c57$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($152b0dabc8a5982f$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($152b0dabc8a5982f$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $152b0dabc8a5982f$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $cf1bddc4fc0feeb0$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $152b0dabc8a5982f$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $17296e6445a3bb26$export$2e2bcd8739ae039)(number)) {
        if ((0, $17296e6445a3bb26$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $e2aa57459c109023$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $152b0dabc8a5982f$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $152b0dabc8a5982f$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $d762ce87c559e3c5$export$2e2bcd8739ae039)((0, $4be77465f80d1ad6$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($152b0dabc8a5982f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $4760ad3c0b393a66$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $267bfdd757e8049b$export$2e2bcd8739ae039)((0, $4be77465f80d1ad6$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $1cc6a41c9e22596e$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $1bd1eb3df9f8e551$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1bd1eb3df9f8e551$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1bd1eb3df9f8e551$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1bd1eb3df9f8e551$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1bd1eb3df9f8e551$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1bd1eb3df9f8e551$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1bd1eb3df9f8e551$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $152b0dabc8a5982f$export$2e2bcd8739ae039)(text, $1bd1eb3df9f8e551$var$_objectSpread($1bd1eb3df9f8e551$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $aeaec9908e7ed798$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aeaec9908e7ed798$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aeaec9908e7ed798$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aeaec9908e7ed798$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aeaec9908e7ed798$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aeaec9908e7ed798$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aeaec9908e7ed798$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $4760ad3c0b393a66$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $aeaec9908e7ed798$var$_objectSpread($aeaec9908e7ed798$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $1bd1eb3df9f8e551$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $9c54a162030e4c57$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $b33f0cc6aac2b930$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $a98b3966922c44e4$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $aeaec9908e7ed798$export$2e2bcd8739ae039)(text, options, metadata);
}


function $3a9c72d2dc84e6a6$export$da44e4eaa54bc82e() {
    return (0, $951e0331af33368c$export$2e2bcd8739ae039)((0, $b33f0cc6aac2b930$export$2e2bcd8739ae039), arguments);
}



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $e2f4664227dfbd40$export$b605972fbb5a633b;
var $e2f4664227dfbd40$export$683472f6198a076e;
var $e2f4664227dfbd40$export$aa5fcd1d589f5ce8;
var $e2f4664227dfbd40$export$542cf336a574a3f8;
$e2f4664227dfbd40$export$b605972fbb5a633b = "WgQ0f";
$e2f4664227dfbd40$export$683472f6198a076e = "svHEm";
$e2f4664227dfbd40$export$aa5fcd1d589f5ce8 = "JBpGF";
$e2f4664227dfbd40$export$542cf336a574a3f8 = "vhYdc";



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $eQCFs = parcelRequire("eQCFs");

var $5m1WU = parcelRequire("5m1WU");

var $7ewsz = parcelRequire("7ewsz");
var $fea835aeb232ab32$export$ec7a7f40ea27f7a7 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(VisualFloatingComponent, Component);
    function VisualFloatingComponent(component) {
        (0, $3CDbU._)(this, VisualFloatingComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualFloatingComponent);
        _this._component = component;
        _this.time = performance.now();
        _this.firstPlace = true;
        _this.putListener(window, "resize", function() {
            return _this.replace();
        });
        return _this;
    }
    (0, $jyA4z._)(VisualFloatingComponent, [
        {
            key: "component",
            get: /**
     * get and set
     */ function get() {
                return this._component;
            },
            set: function set(value) {
                this._component = value;
            }
        },
        {
            /**
     * place and position
     */ key: "place",
            value: function place() {
                var _this = this;
                if (this.component.getOffsets().top > window.innerHeight / 2) this.setStyle("transition-duration:0;left:".concat(this.calcMiddle(), "px;top:unset;bottom:").concat(this.calcOutsideBottom(), "px;"));
                else this.setStyle("transition-duration:0;left:".concat(this.calcMiddle(), "px;top:").concat(this.calcTop(), "px;"));
                if (this.outsideBottom()) this.setStyle("top:unset;bottom:".concat(this.calcOutsideBottom(), "px"));
                if (this.outsideRight()) this.setStyle("left:unset;right:".concat(this.calcOutsideRight(), "px;"));
                if (this.outsideLeft()) this.setStyle("right:unset;left:".concat(this.calcOutsideLeft(), "px;"));
                if (this.firstPlace) {
                    this.firstPlace = false;
                    (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                        if (_this.outsideBottom() || _this.outsideRight() || _this.outsideLeft()) _this.place();
                    });
                }
            }
        },
        {
            key: "placeTop",
            value: function placeTop() {
                this.setStyle("top:unset;bottom:".concat(this.calcOutsideBottom(), "px"));
                if (this.outsideTop()) this.setStyle("bottom:unset;top:".concat(this.calcTop(), "px;"));
            }
        },
        {
            key: "placeRight",
            value: function placeRight() {
                this.setStyle("left:unset;right:".concat(this.calcOutsideRight(), "px;"));
                if (this.outsideLeft()) this.setStyle("right:unset;left:".concat(this.calcOutsideLeft(), "px;"));
            }
        },
        {
            key: "placeOnRight",
            value: function placeOnRight() {
                this.setStyle("left:".concat(this.calcLeft() + this._component.getWidth() + 15, ";right: unset;"));
                this.setStyle("top:".concat(this.calcMiddleTop(), "px;"));
                if (this.outsideLeft()) this.setStyle("right:unset;left:".concat(this.calcOutsideLeft(), "px;"));
                if (this.outsideRight()) this.setStyle("left:unset;right:".concat(this.calcOutsideRight(), "px;"));
                if (this.outsideTop()) this.setStyle("bottom:unset;top:".concat(this.calcOutsideTop(), "px;"));
                if (this.outsideBottom()) this.setStyle("bottom: 10px;top: unset;");
            }
        },
        {
            key: "replace",
            value: function replace() {
                var timeNow = performance.now();
                if (timeNow - 10 > this.time) {
                    this.time = timeNow;
                    this.setStyle("transition-duration: 0s;");
                    this.place();
                }
            }
        },
        {
            /**
     * calc position
     */ //place element to middle
            key: "calcMiddle",
            value: function calcMiddle() {
                return this._component.getOffsets().left + this._component.getWidth() / 2 - this.getWidth() / 2;
            }
        },
        {
            key: "calcMiddleTop",
            value: function calcMiddleTop() {
                return this._component.getOffsets().top + this._component.getHeight() / 2 - this.getHeight() / 2;
            }
        },
        {
            // place to left element
            key: "calcLeft",
            value: function calcLeft() {
                return this._component.getOffsets().left;
            }
        },
        {
            // place if limit left
            key: "calcOutsideLeft",
            value: function calcOutsideLeft() {
                return 10;
            }
        },
        {
            key: "calcOutsideTop",
            value: function calcOutsideTop() {
                return 10;
            }
        },
        {
            //place on bottom of element
            key: "calcTop",
            value: function calcTop() {
                return this._component.getOffsets().top + this._component.getHeight() + 5;
            }
        },
        {
            //place on top of element if bottom is limit
            key: "calcOutsideBottom",
            value: function calcOutsideBottom() {
                return this.component.getOffsets().bottom + this._component.getHeight() + 4;
            }
        },
        {
            // place if limit right
            key: "calcOutsideRight",
            value: function calcOutsideRight() {
                return 10;
            }
        },
        {
            /**
     * calc if element is outside screen
     */ key: "outsideLeft",
            value: function outsideLeft() {
                return (0, $7ewsz.elementOffsets)(this.getHTMLElement()).left < 10;
            }
        },
        {
            key: "outsideBottom",
            value: function outsideBottom() {
                return this.getHTMLElement().getBoundingClientRect().height + this.getOffsets().top > window.innerHeight;
            }
        },
        {
            key: "outsideTop",
            value: function outsideTop() {
                return this.getOffsets().top < 0;
            }
        },
        {
            key: "outsideRight",
            value: function outsideRight() {
                return this.getWidth() + this.getOffsets().left > window.innerWidth;
            }
        },
        {
            /**
     * append and remove
     */ key: "dispose",
            value: function dispose() {
                if (!this.isNull()) this.remove();
                this.onDispose();
            }
        },
        {
            key: "create",
            value: function create() {
                (0, $eQCFs.SedestralInterface).main.render(this);
                (0, $eQCFs.SedestralInterface).main.removeChildren(this);
            }
        },
        {
            /**
     *override
     */ key: "onDispose",
            value: function onDispose() {}
        },
        {
            key: "beforeDispose",
            value: function beforeDispose() {}
        }
    ]);
    return VisualFloatingComponent;
}((0, $9gCL8.Component));


var $8badb76e7ea54892$export$ea5c36236b0b24c6;
var $8badb76e7ea54892$export$1114d5e9985e6d2a;
$8badb76e7ea54892$export$ea5c36236b0b24c6 = "ELPJA";
$8badb76e7ea54892$export$1114d5e9985e6d2a = "_50N--";



var $5m1WU = parcelRequire("5m1WU");

var $eQCFs = parcelRequire("eQCFs");

var $abV4P = parcelRequire("abV4P");
var $f115b792dc63239f$export$2b42b674fe95a29 = /*#__PURE__*/ function(VisualFloatingComponent) {
    "use strict";
    (0, $jCmGC._)(VisualHoverTooltipWhiteComponent, VisualFloatingComponent);
    function VisualHoverTooltipWhiteComponent(component, minHeight, width) {
        (0, $3CDbU._)(this, VisualHoverTooltipWhiteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualHoverTooltipWhiteComponent, [
            component
        ]);
        _this._hovered = false;
        _this._minHeight = minHeight;
        _this._width = width;
        _this._animation = true;
        _this._keyId = "tooltip-" + _this.constructor.name;
        return _this;
    }
    (0, $jyA4z._)(VisualHoverTooltipWhiteComponent, [
        {
            key: "hovered",
            get: function get() {
                return this._hovered;
            }
        },
        {
            key: "minHeight",
            get: function get() {
                return this._minHeight;
            },
            set: function set(value) {
                this._minHeight = value;
            }
        },
        {
            key: "width",
            get: function get() {
                return this._width;
            },
            set: function set(value) {
                this._width = value;
            }
        },
        {
            key: "hoverDelay",
            get: function get() {
                return this._hoverDelay;
            },
            set: function set(value) {
                this._hoverDelay = value;
            }
        },
        {
            key: "leaveDelay",
            get: function get() {
                return this._leaveDelay;
            },
            set: function set(value) {
                this._leaveDelay = value;
            }
        },
        {
            key: "isAnimation",
            get: /**
     * get set
     */ function get() {
                return this._animation;
            }
        },
        {
            key: "animationDelay",
            get: function get() {
                return this._delay;
            },
            set: function set(value) {
                this._delay = value;
            }
        },
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                if (this._autoMaxHeight) {
                    this.calcMaxHeight();
                    (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                        _this.calcMaxHeight();
                        _this.onChange(function() {
                            _this.calcMaxHeight();
                        });
                    });
                }
                this.bind();
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    _this.place();
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "commit", this).call(this);
            }
        },
        {
            /**
     * bind
     */ key: "bind",
            value: function bind() {
                var _this = this;
                if (!(0, $abV4P.isMobile)() && !this._disableLeave) {
                    var _this1 = this;
                    this.onLeave(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this1.dispose()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    var _this2 = this;
                    var listener = this.component.onLeave(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!_this2._hovered) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this2.dispose()
                                    ];
                                case 1:
                                    _state.sent();
                                    _this2.component.deleteListener(listener);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), this._leaveDelay == undefined ? 200 : this._leaveDelay);
                    this.onHover(function() {
                        if (!_this._hovered) {
                            _this._hovered = true;
                            _this.component.deleteListener(listener);
                        }
                    }, this._hoverDelay == undefined ? 0 : this._hoverDelay);
                } else this.onOutsideClick(function() {
                    return _this.dispose();
                });
            }
        },
        {
            key: "dispose",
            value: /**
     * init and dispose
     */ function dispose() {
                var _this = this;
                var _this1 = this, _superprop_get_dispose = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "dispose", _this);
                };
                return (0, $hWZw8._)(function() {
                    var _tmp;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this1.beforeDispose();
                                if (!_this1._animation) return [
                                    3,
                                    5
                                ];
                                if (!_this1._mobileStyle) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.closeDown(_this1._delay)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this1.scaleHide(_this1._delay)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this1.displayHide();
                                _this1.clearAll();
                                _state.label = 6;
                            case 6:
                                if (_this1._disableLeave) _this1.component[_this1._keyId] = undefined;
                                _superprop_get_dispose().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create() {
                if (this._disableLeave) {
                    if (this.component[this._keyId]) {
                        (0, $eQCFs.SedestralInterface).unStore(this);
                        this.clearAll();
                        return;
                    }
                    this.component[this._keyId] = true;
                }
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "create", this).call(this);
                if (this._animation) this._mobileStyle ? this.openUp(this._delay) : this.scaleShow(this._delay);
                else this.displayShow();
            }
        },
        {
            key: "place",
            value: function place() {
                if (this._mobileStyle && (0, $abV4P.isMobile)()) {
                    var paddingLeft = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue('padding-left');
                    var paddingRight = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue('padding-right');
                    this.setStyle("width:calc(100% - ".concat(parseInt(paddingLeft) + parseInt(paddingRight), "px);left:unset !important;right:0 !important;top:unset !important;bottom:0;border-radius: 15px 15px 0px 0px;"));
                    this.getHTMLElement().lastElementChild['style'].cssText += "padding-bottom: 20px !important;";
                } else (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "place", this).call(this);
            }
        },
        {
            /**
     * template
     */ key: "getTemplate",
            value: function getTemplate() {
                if (this._width !== 0) return this.template = '\n                <div style="min-height: '.concat(this._minHeight, "px;width:").concat(this._width, 'px;" class="').concat($8badb76e7ea54892$export$ea5c36236b0b24c6, '">\n                     ').concat((0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "getTemplate", this).call(this), "\n                </div>\n            ");
                else return this.template = '\n                <div style="min-height: '.concat(this._minHeight, 'px;width: calc(100% - 60px); left: 15px !important; top: 15px !important" class="').concat($8badb76e7ea54892$export$ea5c36236b0b24c6, '">\n                     ').concat((0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualHoverTooltipWhiteComponent.prototype), "getTemplate", this).call(this), "\n                </div>\n            ");
            }
        },
        {
            /**
     * settings
     */ key: "animation",
            value: function animation(value) {
                this._animation = value;
                return this;
            }
        },
        {
            key: "mobileStyle",
            value: function mobileStyle(value) {
                this._mobileStyle = value;
                return this;
            }
        },
        {
            key: "autoMaxHeight",
            value: function autoMaxHeight(value) {
                this._autoMaxHeight = value;
                return this;
            }
        },
        {
            /**
     * height
     */ key: "calcMaxHeight",
            value: function calcMaxHeight() {
                if (!this.component.isNull() && !this.isNull()) {
                    var firstElement = this.getFirstChildElement();
                    if (firstElement != undefined) {
                        var maxHeight;
                        if (this.component.getOffsets().top > window.innerHeight / 2) {
                            var bottom = this.component.getHeight() + this.component.getOffsets().bottom + 30;
                            maxHeight = window.innerHeight - bottom;
                        } else {
                            var top = this.component.getHeight() + this.component.getOffsets().top + 30;
                            maxHeight = window.innerHeight - top;
                        }
                        var child = firstElement;
                        for(var i = 0; i < child.children.length; i++)child.children[i]['_scrollTop'] = child.children[i].scrollTop;
                        child.style.cssText += "height:fit-content !important;";
                        var childHeight = child.scrollHeight;
                        if (childHeight > maxHeight - 10) {
                            child.style.cssText += "height:".concat(maxHeight - ((0, $abV4P.isMobile)() ? 40 : 0), "px !important;");
                            this.setStyle("height:".concat(maxHeight, "px;transition:0s;"));
                        } else {
                            child.style.cssText += "height:".concat(childHeight + 1, "px !important;");
                            this.setStyle("height:fit-content;transition:0s;");
                        }
                        for(var i1 = 0; i1 < child.children.length; i1++)child.children[i1]['scrollTop'] = child.children[i1]['_scrollTop'];
                        this.place();
                    }
                }
            }
        },
        {
            key: "getFirstChildElement",
            value: function getFirstChildElement() {
                var firstElement = this.getHTMLElement().firstElementChild;
                if (firstElement && firstElement.hasAttribute("swapBar")) return firstElement.nextElementSibling;
                return firstElement;
            }
        }
    ]);
    return VisualHoverTooltipWhiteComponent;
}((0, $fea835aeb232ab32$export$ec7a7f40ea27f7a7));



var $eQCFs = parcelRequire("eQCFs");


var $5m1WU = parcelRequire("5m1WU");
var $b0ea949471a5ed6e$export$dea594182f495d9c = /*#__PURE__*/ function(VisualHoverTooltipWhiteComponent) {
    "use strict";
    (0, $jCmGC._)(VisualClickTooltipWhiteComponent, VisualHoverTooltipWhiteComponent);
    function VisualClickTooltipWhiteComponent(component, minHeight, width) {
        (0, $3CDbU._)(this, VisualClickTooltipWhiteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualClickTooltipWhiteComponent, [
            component,
            minHeight,
            width
        ]);
        _this._screen = true;
        _this._unClickable = true;
        _this._isReady = false;
        return _this;
    }
    (0, $jyA4z._)(VisualClickTooltipWhiteComponent, [
        {
            key: "screenContainer",
            get: /**
     * get and set
     */ function get() {
                return this._screenContainer;
            }
        },
        {
            key: "isReady",
            get: function get() {
                return this._isReady;
            }
        },
        {
            key: "bind",
            value: function bind() {
                this.addListener("contextmenu", function(e) {
                    return e.stopPropagation();
                });
                var _this = this;
                this.onOutsideClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.dispose()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }));
                var _this1 = this;
                this.onOutsideRightClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.dispose()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }));
                var _this2 = this;
                this.component.onRemove(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this2.disposeScreen();
                                return [
                                    4,
                                    _this2.dispose()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "create",
            value: function create(hidden) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _tmp;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.component[_this._keyId]) {
                                    (0, $eQCFs.SedestralInterface).unStore(_this);
                                    _this.clearAll();
                                    return [
                                        2
                                    ];
                                }
                                _this.component[_this._keyId] = true;
                                (0, $eQCFs.SedestralInterface).main.render(_this);
                                if (_this._screen) {
                                    _this._screenContainer = (0, $eQCFs.SedestralInterface).body.append('<div class="'.concat($8badb76e7ea54892$export$1114d5e9985e6d2a, '"></div>'));
                                    (0, $eQCFs.SedestralInterface).body.removeChildren(_this._screenContainer);
                                }
                                if (_this._unClickable) _this.unClickable();
                                if (!!hidden) return [
                                    3,
                                    7
                                ];
                                if (!_this.isAnimation) return [
                                    3,
                                    5
                                ];
                                if (!_this._mobileStyle) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.openUp(_this.animationDelay)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.scaleShow(_this.animationDelay)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.displayShow();
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _this.displayHide();
                                _state.label = 8;
                            case 8:
                                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                                    _this._isReady = true;
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this = this;
                var _this1 = this, _superprop_get_dispose = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualClickTooltipWhiteComponent.prototype), "dispose", _this);
                };
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this1.disposeScreen();
                                return [
                                    4,
                                    _superprop_get_dispose().call(_this1)
                                ];
                            case 1:
                                _state.sent();
                                _this1._isReady = false;
                                _this1.component[_this1._keyId] = undefined;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disposeScreen",
            value: function disposeScreen() {
                if (this._screen && this._screenContainer != undefined) {
                    this._screenContainer.remove();
                    this._screenContainer = undefined;
                }
            }
        },
        {
            /**
     * settings
     */ key: "screen",
            value: function screen(value) {
                this._screen = value;
                return this;
            }
        },
        {
            key: "setUnClickable",
            value: function setUnClickable(value) {
                this._unClickable = value;
                return this;
            }
        },
        {
            key: "setComponentUnClickable",
            value: function setComponentUnClickable(classValue) {
                if (!this.isNull()) this.onClick(function(e) {
                    (0, $5m1WU.SedestralMachine).outsideClickListeners.forEach(function(value) {
                        if (!(value['component'] instanceof classValue)) value.callback(e);
                    });
                }, true);
            }
        }
    ]);
    return VisualClickTooltipWhiteComponent;
}((0, $f115b792dc63239f$export$2b42b674fe95a29));


var $4d76d4aa9899cd57$export$d1d55afab036cac2;
var $4d76d4aa9899cd57$export$100aa851bad32d9d;
var $4d76d4aa9899cd57$export$1ca1ec8b29a4ce27;
var $4d76d4aa9899cd57$export$b7e3ae3d7c15e42e;
var $4d76d4aa9899cd57$export$c6d40e657c4cb32e;
var $4d76d4aa9899cd57$export$e850e66917a23e0f;
var $4d76d4aa9899cd57$export$151a98b9b0a52b4e;
var $4d76d4aa9899cd57$export$d90250155de6d7e7;
var $4d76d4aa9899cd57$export$51987bb50e1f6752;
var $4d76d4aa9899cd57$export$6d59db4903f20f7d;
$4d76d4aa9899cd57$export$d1d55afab036cac2 = "_9PF-j";
$4d76d4aa9899cd57$export$100aa851bad32d9d = "T-B3N";
$4d76d4aa9899cd57$export$1ca1ec8b29a4ce27 = "f-EUc";
$4d76d4aa9899cd57$export$b7e3ae3d7c15e42e = "cFmpY";
$4d76d4aa9899cd57$export$c6d40e657c4cb32e = "hHIr0";
$4d76d4aa9899cd57$export$e850e66917a23e0f = "BFocA";
$4d76d4aa9899cd57$export$151a98b9b0a52b4e = "_-8Nbr";
$4d76d4aa9899cd57$export$d90250155de6d7e7 = "_9LzAM";
$4d76d4aa9899cd57$export$51987bb50e1f6752 = "bLGZA";
$4d76d4aa9899cd57$export$6d59db4903f20f7d = "hFpcJ";



var $wYO7b = parcelRequire("wYO7b");
function $116f33fc5fa98918$export$bd9d5a37ac9dc911(txt) {
    txt = txt.trim().toLowerCase();
    txt = txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    txt = txt.replace("s", "").replace("x", "").replace("\u2019", "'").replace("\u2018", "'").replace("\xb4", "'").replace("`", "'");
    return txt;
}


/**
 * Transforme le HTML en plain text
 */ function $bc1c6123f9858434$export$20bf31df4b15cdec(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\n/g, '');
}


var $f22f5e3cca7605c1$export$76cac35af4870249 = /*#__PURE__*/ function(VisualClickTooltipWhiteComponent) {
    "use strict";
    (0, $jCmGC._)(VisualSelectBoxTooltipComponent, VisualClickTooltipWhiteComponent);
    function VisualSelectBoxTooltipComponent(component, settings, selectedValue) {
        (0, $3CDbU._)(this, VisualSelectBoxTooltipComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualSelectBoxTooltipComponent, [
            component,
            0,
            settings.width ? settings.width : component.getWidth()
        ]);
        _this.settings = settings;
        _this.buttonsComponents = [];
        _this.typedWord = "";
        if (_this.settings.entries.length > 0) _this.selectedValue = selectedValue;
        //language=HTML
        _this.template = '\n            <div class="'.concat($4d76d4aa9899cd57$export$d1d55afab036cac2, '">\n                <div class="').concat($4d76d4aa9899cd57$export$c6d40e657c4cb32e, '">\n                    <div class="').concat($4d76d4aa9899cd57$export$151a98b9b0a52b4e, '"></div>\n                </div>\n            </div>\n        ');
        _this.mobileStyle(true);
        _this.autoMaxHeight(true);
        return _this;
    }
    (0, $jyA4z._)(VisualSelectBoxTooltipComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.casesContainer = this.el($4d76d4aa9899cd57$export$151a98b9b0a52b4e);
                this.casesScrollable = this.el($4d76d4aa9899cd57$export$c6d40e657c4cb32e);
                if (this.settings.search) this.casesScrollable.setStyle("height:calc(100% - 32px);");
                this.casesScrollable.scrollable();
                this.init();
                this.swapable(function() {
                    return _this.dispose();
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualSelectBoxTooltipComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.setStyle("padding:5px;");
                if (this.settings.search) {
                    //language=HTML
                    this.el($4d76d4aa9899cd57$export$d1d55afab036cac2).prepend('\n                <div class="'.concat($4d76d4aa9899cd57$export$100aa851bad32d9d, '">\n                    <div class="').concat($4d76d4aa9899cd57$export$1ca1ec8b29a4ce27, '"></div>\n                    <input placeholder="').concat((0, $wYO7b.Resources).t("words.search"), '" class="').concat($4d76d4aa9899cd57$export$b7e3ae3d7c15e42e, '"/>\n                </div>\n            '));
                    var input = this.el($4d76d4aa9899cd57$export$b7e3ae3d7c15e42e);
                    input.onKeyUp(function() {
                        return _this.renderButtons(input.getValue());
                    });
                    input.focus();
                }
                this.renderButtons();
            }
        },
        {
            key: "renderButtons",
            value: function renderButtons(search) {
                var _this = this;
                this.casesContainer.clearAll();
                this.settings.entries.filter(function(value) {
                    var searchValue = _this.settings.searchDescription ? value.description : value.label;
                    return search == undefined || (_this.settings.searchInclude ? (0, $bc1c6123f9858434$export$20bf31df4b15cdec)((0, $116f33fc5fa98918$export$bd9d5a37ac9dc911)(searchValue)).includes((0, $116f33fc5fa98918$export$bd9d5a37ac9dc911)(search)) : (0, $bc1c6123f9858434$export$20bf31df4b15cdec)((0, $116f33fc5fa98918$export$bd9d5a37ac9dc911)(searchValue)).startsWith((0, $116f33fc5fa98918$export$bd9d5a37ac9dc911)(search)));
                }).forEach(function(entry) {
                    //language=HTML
                    var button = _this.casesContainer.append('\n                <div class="'.concat($4d76d4aa9899cd57$export$e850e66917a23e0f, " ").concat((_this.settings.multiple ? _this.selectedValue.includes("" + entry.value) : _this.selectedValue == entry.value) ? $4d76d4aa9899cd57$export$d90250155de6d7e7 : "", '">\n                    ').concat(entry.label ? entry.label : "", "\n                </div>\n            "));
                    button['entry'] = entry;
                    var _this1 = _this;
                    button.onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this1.selectedValue = entry.value;
                                    if (!!_this1.settings.multiple) return [
                                        3,
                                        7
                                    ];
                                    if (!_this1.settings.selectedValueNullable) return [
                                        3,
                                        4
                                    ];
                                    if (_this1.selectedButton && _this1.selectedButton != button) _this1.selectedButton.removeClass($4d76d4aa9899cd57$export$d90250155de6d7e7);
                                    if (!button.hasClass($4d76d4aa9899cd57$export$d90250155de6d7e7)) return [
                                        3,
                                        1
                                    ];
                                    _this1.selectedButton = undefined;
                                    button.removeClass($4d76d4aa9899cd57$export$d90250155de6d7e7);
                                    return [
                                        3,
                                        3
                                    ];
                                case 1:
                                    _this1.selectedButton = button;
                                    button.addClass($4d76d4aa9899cd57$export$d90250155de6d7e7);
                                    return [
                                        4,
                                        _this1.dispose()
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        _this1.dispose()
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    return [
                                        3,
                                        8
                                    ];
                                case 7:
                                    if (button.hasClass($4d76d4aa9899cd57$export$d90250155de6d7e7)) button.removeClass($4d76d4aa9899cd57$export$d90250155de6d7e7);
                                    else button.addClass($4d76d4aa9899cd57$export$d90250155de6d7e7);
                                    _state.label = 8;
                                case 8:
                                    _this1.onSelect(entry);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), true);
                    if (entry.description) {
                        button.addClass($4d76d4aa9899cd57$export$51987bb50e1f6752);
                        //language=HTML
                        button.append('\n                    <div class="'.concat($4d76d4aa9899cd57$export$6d59db4903f20f7d, '">\n                        ').concat(entry.description, "\n                    </div>\n                "));
                    }
                    _this.buttonsComponents.push(button);
                });
            }
        },
        {
            key: "calcMiddle",
            value: function calcMiddle() {
                return this.component.getOffsets().left;
            }
        },
        {
            /**
     * override
     */ key: "onSelect",
            value: function onSelect(entry) {}
        }
    ]);
    return VisualSelectBoxTooltipComponent;
}((0, $b0ea949471a5ed6e$export$dea594182f495d9c));



var $wYO7b = parcelRequire("wYO7b");
var $a54861d990819f07$export$32ca16bda187b168 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(VisualSelectBoxComponent, Component);
    function VisualSelectBoxComponent(settings) {
        (0, $3CDbU._)(this, VisualSelectBoxComponent);
        var _this;
        var _this_settings;
        _this = (0, $ep9cZ._)(this, VisualSelectBoxComponent);
        _this.settings = settings;
        _this.selectedValue = !_this.settings.selectedValue && _this.settings.multiple ? [] : _this.settings.selectedValue;
        //language=HTML
        _this.template = "\n            <div ".concat(_this.settings.maxHeight ? 'style="height: calc(100% - 8px);"' : "", ' data-selectbox="true"\n                 class="').concat($e2f4664227dfbd40$export$b605972fbb5a633b, '">\n                <div style="font-size: ').concat((_this_settings = _this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.fontSize, 'px;" class="').concat($e2f4664227dfbd40$export$542cf336a574a3f8, '"></div>\n                <div data-selectIcon class="').concat($e2f4664227dfbd40$export$aa5fcd1d589f5ce8, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(VisualSelectBoxComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.selectIcon = this.el($e2f4664227dfbd40$export$aa5fcd1d589f5ce8);
                this.selectedContainer = this.el($e2f4664227dfbd40$export$542cf336a574a3f8);
                this.onClick(function() {
                    return _this.renderPicker();
                });
                this.onRemove(function() {
                    if (_this.pickerComponent != undefined && !_this.pickerComponent.isNull()) _this.pickerComponent.remove();
                });
                this.renderSelection();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualSelectBoxComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "select",
            value: function select(value) {
                if (this.settings.entries.length > 0) {
                    var entry = this.settings.entries.filter(function(entry) {
                        return entry.value == value;
                    })[0];
                    if (entry != undefined) {
                        if (!this.settings.multiple) {
                            if (this.settings.selectedValueNullable && this.selectedValue == entry.value) this.selectedValue = undefined;
                            else this.selectedValue = entry.value;
                        } else {
                            var values = this.selectedValue;
                            var v = entry.value;
                            if (values.indexOf(v) >= 0) values.splice(values.indexOf(v), 1);
                            else this.selectedValue.push("" + entry.value);
                        }
                        this.renderSelection();
                    }
                }
            }
        },
        {
            key: "renderSelection",
            value: function renderSelection() {
                if (!this.settings.multiple) this.selectedContainer.setHtml(this.settings.previewIsValue ? this.getSelection().value : this.getSelection().label);
                else if (this.getSelections().length > 0) this.selectedContainer.setHtml(this.getSelections().map(function(value) {
                    return value.label;
                }).join(", "));
                else this.selectedContainer.setHtml(this.settings.noneText ? this.settings.noneText : (0, $wYO7b.Resources).t("words.none"));
            }
        },
        {
            key: "renderPicker",
            value: function renderPicker() {
                var _this = this;
                if (this.pickerComponent != undefined && !this.pickerComponent.isNull()) this.pickerComponent.dispose();
                else {
                    this.pickerComponent = new (0, $f22f5e3cca7605c1$export$76cac35af4870249)(this.selectedContainer, this.settings, this.selectedValue);
                    this.pickerComponent.screen(false);
                    this.pickerComponent.onOutsideClick(function() {
                        return _this.pickerComponent.dispose();
                    });
                    this.pickerComponent.create();
                    this.pickerComponent.onSelect = function(entry) {
                        if (_this.beforeSelect(entry)) {
                            _this.select("" + entry.value);
                            _this.onSelect(entry);
                        }
                    };
                }
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                var _this = this;
                if (this.settings.multiple) {
                    var selectedValues = this.selectedValue;
                    if (this.settings.entries.length == 0 || (!selectedValues || selectedValues.length == 0) && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) // @ts-ignore
                    return [
                        {
                            value: undefined,
                            label: this.settings.noneText ? this.settings.noneText : (0, $wYO7b.Resources).t("words.none")
                        }
                    ];
                    else {
                        if (!selectedValues) return [
                            this.settings.entries[0]
                        ];
                        else // @ts-ignore
                        return selectedValues.map(function(value) {
                            return _this.settings.entries.find(function(entry) {
                                return entry.value == value;
                            });
                        });
                    }
                } else {
                    var selectedValue = this.selectedValue;
                    if (this.settings.entries.length == 0 || !selectedValue && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) return {
                        value: undefined,
                        label: this.settings.noneText ? this.settings.noneText : (0, $wYO7b.Resources).t("words.none")
                    };
                    else {
                        var _this_settings_entries_find;
                        if (!selectedValue) return this.settings.entries[0];
                        else return (_this_settings_entries_find = this.settings.entries.find(function(value) {
                            return value.value == selectedValue;
                        })) !== null && _this_settings_entries_find !== void 0 ? _this_settings_entries_find : this.settings.entries[0];
                    }
                }
            }
        },
        {
            key: "getSelections",
            value: function getSelections() {
                return this.getSelection();
            }
        },
        {
            key: "classDisable",
            value: function classDisable() {
                this.addClass($e2f4664227dfbd40$export$683472f6198a076e);
            }
        },
        {
            /**
     * override
     *
     */ key: "beforeSelect",
            value: function beforeSelect(entry) {
                return true;
            }
        },
        {
            key: "onSelect",
            value: function onSelect(entry) {}
        }
    ]);
    return VisualSelectBoxComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");

var $3D7wv = parcelRequire("3D7wv");
/**
 * Permet d'escaper tous les < > etc
 */ function $576ca3e5023a7117$export$96b5765c47169ce9(text) {
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}


var $8d8057af24883f1e$export$a6f05ece7dba1e5c = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(VisualInputStatesComponent, Component);
    function VisualInputStatesComponent(p) {
        (0, $3CDbU._)(this, VisualInputStatesComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, VisualInputStatesComponent);
        _this.p = p;
        if (_this.p.type == "tel") {
            var parser = (0, $3a9c72d2dc84e6a6$export$da44e4eaa54bc82e)(p.value ? p.value : "");
            _this.telCountry = parser ? parser.country : (0, $wYO7b.Resources).getCountryCode().toUpperCase();
        }
        //language=HTML
        _this.template = '\n            <div class="'.concat($ec51238552ef069f$export$2ab62eda9e453014, " ").concat(p.noBorder ? $ec51238552ef069f$export$1fb2911de90ed83f : "", " ").concat(p.bold ? $ec51238552ef069f$export$73ba5813cda80a49 : "", " ").concat(p.semiBold ? $ec51238552ef069f$export$7e39b47ba949ea16 : "", " ").concat(p.outline ? $ec51238552ef069f$export$f9258c55612cbed7 : "", '">\n                <div style="font-size: ').concat(p.fontSize ? p.fontSize : 15, "px;left: ").concat(p.paddingLeft != undefined ? p.paddingLeft : p.type === "tel" ? 80 : 15, 'px;"\n                     class="').concat($ec51238552ef069f$export$fb184b623420d9be, " ").concat(p.noLabel ? $ec51238552ef069f$export$1f96961348e52fad : "", '">\n                    ').concat(p.placeholder).concat(p.required ? "*" : "", '\n                </div>\n\n                <input style="').concat(p.maxWidth ? "max-width: ".concat(p.maxWidth, "px;") : "").concat(p.borderRadius ? "border-radius: ".concat(p.borderRadius, "px;") : "", "cursor: text;").concat(p.maxHeight ? 'height: calc(100% - 4px) !important;' : '', "font-size: ").concat(p.fontSize ? p.fontSize : 15, "px;padding-left: ").concat(p.paddingLeft != undefined ? p.paddingLeft : 15, "px; ").concat(p.padding != undefined ? "padding:" + p.padding + "px" : "", '"\n                       class="').concat($ec51238552ef069f$export$b7e3ae3d7c15e42e, '"\n                       ').concat(p.required ? "required" : "", "\n                       ").concat(p.disabled ? "disabled" : "", "\n                       ").concat(p.minNumber ? 'min="'.concat(p.minNumber, '"') : "", "\n                       ").concat(p.maxNumber ? 'max="'.concat(p.maxNumber, '"') : "", "\n                       ").concat(p.value ? 'value="'.concat((0, $576ca3e5023a7117$export$96b5765c47169ce9)(_this.formatValue(p.value)), '"') : "", "\n                       ").concat(p.noLabel && p.placeholder ? 'placeholder="'.concat(p.placeholder, '"') : "", "\n                       ").concat(p.type ? 'type="'.concat(p.type, '"') : "", '\n                       spellcheck="false"/>\n            </div>\n        ');
        (0, $5m1WU.SedestralMachine).inputs.push(_this);
        _this.onRemove(function() {
            return (0, $5m1WU.SedestralMachine).inputs.splice((0, $5m1WU.SedestralMachine).inputs.indexOf(_this));
        });
        return _this;
    }
    (0, $jyA4z._)(VisualInputStatesComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this_p;
                this.input = this.el($ec51238552ef069f$export$b7e3ae3d7c15e42e);
                if ((_this_p = this.p) === null || _this_p === void 0 ? void 0 : _this_p.focus) {
                    this.input.focusAtEnd();
                    this.addClass($ec51238552ef069f$export$4c2b230493b2b322);
                }
                if (this.input.getValue().length > 0) this.addClass($ec51238552ef069f$export$4c2b230493b2b322);
                this.initEvents();
                if (this.p.type == "tel") this.initTel();
                if (this.p.autoWidth) this.initAutoWidth();
                if (this.p.saveMode) this.initSave();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(VisualInputStatesComponent.prototype), "commit", this).call(this);
            }
        },
        {
            /**
     * init
     */ key: "initEvents",
            value: function initEvents() {
                var _this = this;
                this.checker = function() {
                    var inputValueLength = _this.input.getValue().length;
                    if (_this.p.required && inputValueLength == 0) return false;
                    if (_this.p.minLength && inputValueLength < _this.p.minLength) return false;
                    if (_this.p.minLength > 0 && _this.input.getValue().replaceAll(" ", "").length == 0) return false;
                    return !(_this.p.maxLength && inputValueLength > _this.p.maxLength);
                };
                this.input.onFocus(function() {
                    return _this.addClass($ec51238552ef069f$export$4c2b230493b2b322);
                });
                this.input.onBlur(function() {
                    if (_this.input.getValue().length <= 0) _this.removeClass($ec51238552ef069f$export$4c2b230493b2b322);
                    else _this.addClass($ec51238552ef069f$export$4c2b230493b2b322);
                });
                this.onKeyUp(function(key) {
                    _this.input.setValue(_this.formatValue(_this.input.getValue()));
                    if (key.key != "Enter") _this.check();
                });
            }
        },
        {
            key: "initTel",
            value: function initTel() {
                var _this = this;
                var selectBox = new (0, $a54861d990819f07$export$32ca16bda187b168)({
                    entries: (0, $wYO7b.Resources).countries.map(function(value) {
                        return {
                            value: value['a2'].toUpperCase(),
                            label: "".concat(value['n'], " (").concat(value['a2'].toUpperCase(), ")")
                        };
                    }),
                    selectedValue: this.telCountry,
                    search: true,
                    width: 220,
                    previewIsValue: true
                });
                //language=HTML
                this.prepend('\n            <div class="'.concat($ec51238552ef069f$export$2e6c959c16ff56b8, '">\n                ').concat(this.draw(selectBox), "\n            </div>\n        "));
                selectBox.onSelect = function(entry) {
                    _this.telCountry = entry.value;
                    _this.input.setValue(_this.formatValue(_this.input.getValue()));
                    _this.check();
                };
            }
        },
        {
            key: "initAutoWidth",
            value: function initAutoWidth() {
                var _this = this;
                this.setStyle("width: auto;");
                this.addListener("input", function() {
                    _this.input.setStyle("width: ".concat(_this.contentWidth(), "px"));
                });
                this.input.setStyle("width: ".concat(this.contentWidth(), "px"));
            }
        },
        {
            key: "initSave",
            value: function initSave() {
                var _this = this;
                var edited = false;
                var focused = false;
                this.input.onClick(function() {
                    return focused = true;
                });
                this.input.onKeyUp(function() {
                    return edited = true;
                });
                this.input.onHotKey("Enter", function() {
                    _this.input.getHTMLElement().blur();
                    _this.onSave();
                });
                this.input.onOutsideClick(function() {
                    if (focused && edited) _this.onSave(true);
                    edited = false;
                    focused = false;
                });
            }
        },
        {
            /**
     * value
     */ key: "getValue",
            value: function getValue() {
                if (this.p.type == "tel") {
                    var _formatter_getNumber;
                    var formatter = new (0, $e40bfda488419a26$export$80d8c6912928a4eb)(this.telCountry);
                    formatter.input(this.input.getValue());
                    return (_formatter_getNumber = formatter.getNumber()) === null || _formatter_getNumber === void 0 ? void 0 : _formatter_getNumber.number;
                }
                return this.input.getValue();
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                if (value.length > 0) this.addClass($ec51238552ef069f$export$4c2b230493b2b322);
                else this.removeClass($ec51238552ef069f$export$4c2b230493b2b322);
                this.input.setValue(value);
                if (this.p.autoWidth) this.input.setStyle("width: ".concat(this.contentWidth(), "px"));
                return (0, $3D7wv.filterXSS)(value);
            }
        },
        {
            key: "formatValue",
            value: function formatValue(value) {
                if (this.p.type == "tel") {
                    var formatter = new (0, $e40bfda488419a26$export$80d8c6912928a4eb)(this.telCountry);
                    var parser = (0, $3a9c72d2dc84e6a6$export$da44e4eaa54bc82e)(value);
                    return parser ? parser.formatNational() : formatter.input(value);
                }
                return value;
            }
        },
        {
            /**
     * width
     */ key: "contentWidth",
            value: function contentWidth(placeholder) {
                var temp = document.createElement('span');
                temp.style.font = window.getComputedStyle(this.input.getHTMLElement()).font;
                temp.style.visibility = 'hidden';
                temp.innerHTML = (placeholder ? placeholder : this.input.getValue()).replace(/ /g, '&nbsp;');
                document.body.appendChild(temp);
                var width = temp.offsetWidth + (this.p.paddingLeft ? this.p.paddingLeft * 2 : this.getPaddingWidth() * 10) + 2;
                document.body.removeChild(temp);
                var placeholderWidth = 0;
                if (!placeholder && this.p.placeholder) placeholderWidth = this.contentWidth(this.p.placeholder);
                return (this.input.getValue().length == 0 && width < placeholderWidth && placeholderWidth != 0 ? placeholderWidth : width) + 15;
            }
        },
        {
            /**
     * state
     */ key: "setStateError",
            value: function setStateError() {
                this.addClass($ec51238552ef069f$export$a3bc9b8ed74fc);
            }
        },
        {
            key: "removeState",
            value: function removeState() {
                this.removeClass($ec51238552ef069f$export$a3bc9b8ed74fc);
            }
        },
        {
            /**
     * check
     */ key: "check",
            value: function check() {
                if (this.checker() && this.checkerLocal()) this.removeState();
                else this.setStateError();
                return this.isValid();
            }
        },
        {
            key: "checkerLocal",
            value: function checkerLocal() {
                if (this.p.type == "tel") {
                    var type = new (0, $e40bfda488419a26$export$80d8c6912928a4eb)(this.telCountry);
                    type.input(this.input.getValue());
                    return type.isValid();
                }
                return true;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return !this.hasClass($ec51238552ef069f$export$a3bc9b8ed74fc);
            }
        },
        {
            /**
     * focus
     */ key: "isFocus",
            value: function isFocus() {
                return document.activeElement == this.input.getHTMLElement();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focusAtEnd();
            }
        },
        {
            key: "showShadowTooltip",
            value: /**
     * other
     */ function showShadowTooltip(template, color) {
                this.input.showShadowTooltip(template, color);
            }
        },
        {
            /**
     * keys
     */ key: "onKeyUp",
            value: function onKeyUp(func, delay) {
                return this.input.onKeyUp(func, delay);
            }
        },
        {
            key: "onKey",
            value: function onKey(func, delay) {
                return this.input.onKey(func, delay);
            }
        },
        {
            /**
     * override
     */ key: "onSave",
            value: function onSave(outsideClick) {}
        }
    ]);
    return VisualInputStatesComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");
var $a522163d05fa3c01$export$a7617739149c6d10;
var $a522163d05fa3c01$export$86201b36d8e19735;
var $a522163d05fa3c01$export$e88cb2efb12ae807;
$a522163d05fa3c01$export$a7617739149c6d10 = "WM8X6";
$a522163d05fa3c01$export$86201b36d8e19735 = "Ylxmj";
$a522163d05fa3c01$export$e88cb2efb12ae807 = "eudQO";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $ad2699554357d8bb$export$405ce769029154bc = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(ButtonCheckComponent, Component);
    function ButtonCheckComponent(checked) {
        (0, $3CDbU._)(this, ButtonCheckComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, ButtonCheckComponent);
        _this.checked = checked;
        return _this;
    }
    (0, $jyA4z._)(ButtonCheckComponent, [
        {
            key: "commit",
            value: function commit() {
                this.bind();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(ButtonCheckComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "bind",
            value: function bind() {
                var _this = this;
                this.onClick(function() {
                    _this.stateChange(!_this.checked);
                }, true);
            }
        },
        {
            /**
     * state
     */ key: "stateChange",
            value: function stateChange(checked, noCallback) {
                this.checked = checked;
                this.stateChangeClass();
                if (!noCallback) {
                    if (checked) this.onCheck();
                    else this.onUnCheck();
                    this.onStateChange(checked);
                }
            }
        },
        {
            key: "stateAuto",
            value: function stateAuto() {
                this.stateChange(!this.checked);
            }
        },
        {
            key: "stateChangeClass",
            value: function stateChangeClass() {
                this.removeAttribute("checked");
                this.removeAttribute("unchecked");
                this.setAttribute(this.state(), "");
            }
        },
        {
            key: "state",
            value: function state() {
                return this.checked ? "checked" : "unchecked";
            }
        },
        {
            /**
     * override
     */ key: "onCheck",
            value: function onCheck() {}
        },
        {
            key: "onUnCheck",
            value: function onUnCheck() {}
        },
        {
            key: "onStateChange",
            value: function onStateChange(checked) {}
        }
    ]);
    return ButtonCheckComponent;
}((0, $9gCL8.Component));


var $2bebc11730903676$export$667c5478f6e1eafe = /*#__PURE__*/ function(ButtonCheckComponent) {
    "use strict";
    (0, $jCmGC._)(ButtonCheckBoxComponent, ButtonCheckComponent);
    function ButtonCheckBoxComponent(checked, checker) {
        (0, $3CDbU._)(this, ButtonCheckBoxComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, ButtonCheckBoxComponent, [
            checked
        ]);
        //language=HTML
        _this.template = '\n            <div btnCheckBox class="'.concat($a522163d05fa3c01$export$a7617739149c6d10, " ").concat(checker ? $a522163d05fa3c01$export$86201b36d8e19735 : "", '" ').concat(_this.state(), '>\n                <div btnCheckBoxCaret class="').concat($a522163d05fa3c01$export$e88cb2efb12ae807, '"></div>\n            </div>\n        ');
        return _this;
    }
    return ButtonCheckBoxComponent;
}((0, $ad2699554357d8bb$export$405ce769029154bc));



var $3Qm5T = parcelRequire("3Qm5T");


var $wYO7b = parcelRequire("wYO7b");

var $dmlE6 = parcelRequire("dmlE6");
function $c9c1c4776943ab22$export$4e4cb19dd88cd821(date, hour) {
    var options = {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    };
    if (hour) {
        options['hour'] = "2-digit";
        options['minute'] = "2-digit";
        options['hour12'] = (0, $dmlE6.PreferencesService).hour12;
    }
    return new Intl.DateTimeFormat((0, $wYO7b.Resources).language, options).format(date);
}
function $c9c1c4776943ab22$export$1aac387c4ed0273c(date) {
    var options = {};
    options['hour'] = "2-digit";
    options['minute'] = "2-digit";
    options['hour12'] = (0, $dmlE6.PreferencesService).hour12;
    return new Intl.DateTimeFormat((0, $wYO7b.Resources).language, options).format(date);
}


var $8957314797dd1ba9$export$50ba419e547989b9 = /*#__PURE__*/ function(OfferPaymentActionType) {
    OfferPaymentActionType[OfferPaymentActionType["PAYMENT"] = 0] = "PAYMENT";
    OfferPaymentActionType[OfferPaymentActionType["INTENT"] = 1] = "INTENT";
    OfferPaymentActionType[OfferPaymentActionType["NONE"] = 2] = "NONE";
    return OfferPaymentActionType;
}({});




var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $5ad1f851e2531abd$export$aaa2fdfbe3211bee;
var $5ad1f851e2531abd$export$1237798dc640739a;
var $5ad1f851e2531abd$export$6170c7625ed1f3cc;
var $5ad1f851e2531abd$export$72108e4fb43880e3;
$5ad1f851e2531abd$export$aaa2fdfbe3211bee = "zOxDG";
$5ad1f851e2531abd$export$1237798dc640739a = "_8ZWTx";
$5ad1f851e2531abd$export$6170c7625ed1f3cc = "kXdyw";
$5ad1f851e2531abd$export$72108e4fb43880e3 = "dcUax";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");
var $2ca825f1cf615c43$export$cb01125cc4e845f0;
var $2ca825f1cf615c43$export$a4510362933968c8;
$2ca825f1cf615c43$export$cb01125cc4e845f0 = "osy8p";
$2ca825f1cf615c43$export$a4510362933968c8 = "ER-w7";



var $9gCL8 = parcelRequire("9gCL8");


var $04j1P = parcelRequire("04j1P");

var $wYO7b = parcelRequire("wYO7b");
var $78b704a2554e9522$export$143c167d2a04bd23 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CountryPickerComponent, Component);
    function CountryPickerComponent(value, settings, filters) {
        (0, $3CDbU._)(this, CountryPickerComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CountryPickerComponent);
        _this.value = value;
        _this.settings = settings;
        _this.filters = filters;
        //language=HTML
        _this.template = '\n            <div class="'.concat($2ca825f1cf615c43$export$cb01125cc4e845f0, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(CountryPickerComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                var _this_settings;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CountryPickerComponent.prototype), "commit", this).call(this);
                this.selectBox = new (0, $a54861d990819f07$export$32ca16bda187b168)((0, $04j1P.objectUpdate)(this.settings ? this.settings : {}, {
                    entries: (0, $wYO7b.Resources).countries.filter(function(l) {
                        return !_this.filters || _this.filters.includes(l.a2);
                    }).map(function(v) {
                        return {
                            label: v.n,
                            value: v.a2
                        };
                    }),
                    selectedValue: this.value,
                    search: ((_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.search) != undefined ? this.settings.search : true
                }));
                this.selectBox.onSelect = function(entry) {
                    return _this.onSelect(entry.value);
                };
                this.clearAll();
                this.render(this.selectBox);
            }
        },
        {
            key: "onSelect",
            value: function onSelect(language) {}
        }
    ]);
    return CountryPickerComponent;
}((0, $9gCL8.Component));



var $lThic = parcelRequire("lThic");


var $wYO7b = parcelRequire("wYO7b");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");


var $1LZ0s = parcelRequire("1LZ0s");


var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a3e5f9a5e672db12$export$e6f751ba8af48c04;
var $a3e5f9a5e672db12$export$6e22c362a0406a2c;
$a3e5f9a5e672db12$export$e6f751ba8af48c04 = "jNb2G";
$a3e5f9a5e672db12$export$6e22c362a0406a2c = "LRXto";



var $3Qm5T = parcelRequire("3Qm5T");
var $0cc7e3e04e0ee248$export$3a3ab308824b90fa = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CountryIconComponent, Component);
    function CountryIconComponent(code) {
        (0, $3CDbU._)(this, CountryIconComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CountryIconComponent);
        if (code) {
            code = code.toUpperCase();
            //language=HTML
            _this.template = "\n                <div style=\"background: url('".concat((0, $3Qm5T.Network).vendor + "countries/flags/" + code + ".svg", '\'); background-size: contain;"\n                     class="').concat($a3e5f9a5e672db12$export$e6f751ba8af48c04, '">\n                </div>\n            ');
        } else //language=HTML
        _this.template = '\n                <div class="'.concat($a3e5f9a5e672db12$export$e6f751ba8af48c04, '">\n                    <div class="').concat($a3e5f9a5e672db12$export$6e22c362a0406a2c, '"></div>\n                </div>\n            ');
        return _this;
    }
    return CountryIconComponent;
}((0, $9gCL8.Component));


var $69ff473a57156731$export$7323b7ababca8042;
var $69ff473a57156731$export$edc875d7f22c9a5b;
$69ff473a57156731$export$7323b7ababca8042 = "uGsry";
$69ff473a57156731$export$edc875d7f22c9a5b = "E-t4F";



var $lThic = parcelRequire("lThic");
var $ea76e649c6458191$export$d347b2ed4a8490cf = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(SiteTaxComponent, Component);
    function SiteTaxComponent() {
        (0, $3CDbU._)(this, SiteTaxComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, SiteTaxComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($69ff473a57156731$export$7323b7ababca8042, '">\n                ').concat(_this.draw(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)()), "\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(SiteTaxComponent, [
        {
            key: "commit",
            value: function commit() {
                this.init();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(SiteTaxComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var entries, selectedValue;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1LZ0s.SiteService).getTaxTypes(_this)
                                ];
                            case 1:
                                _this.taxes = _state.sent();
                                entries = [];
                                _this.taxes.forEach(function(value) {
                                    var _EntityService_activeSite_address_tax, _EntityService_activeSite_address, _EntityService_activeSite_address_tax1, _EntityService_activeSite_address1, _EntityService_activeSite_address2;
                                    var country = (0, $wYO7b.Resources).country(value.country);
                                    var _country_n;
                                    entries.push({
                                        value: value.id,
                                        label: (country ? '<div class="'.concat($69ff473a57156731$export$edc875d7f22c9a5b, '">').concat(_this.draw(new (0, $0cc7e3e04e0ee248$export$3a3ab308824b90fa)(country.a3)), "</div> ") : "") + value.label,
                                        description: (_country_n = country === null || country === void 0 ? void 0 : country.n) !== null && _country_n !== void 0 ? _country_n : value.country
                                    });
                                    var _EntityService_activeSite_address_country;
                                    if ((_EntityService_activeSite_address = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address === void 0 ? void 0 : (_EntityService_activeSite_address_tax = _EntityService_activeSite_address.tax) === null || _EntityService_activeSite_address_tax === void 0 ? void 0 : _EntityService_activeSite_address_tax.type) selectedValue = (_EntityService_activeSite_address1 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address1 === void 0 ? void 0 : (_EntityService_activeSite_address_tax1 = _EntityService_activeSite_address1.tax) === null || _EntityService_activeSite_address_tax1 === void 0 ? void 0 : _EntityService_activeSite_address_tax1.type;
                                    else if ((country === null || country === void 0 ? void 0 : country.a2) == ((_EntityService_activeSite_address_country = (_EntityService_activeSite_address2 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address2 === void 0 ? void 0 : _EntityService_activeSite_address2.country) !== null && _EntityService_activeSite_address_country !== void 0 ? _EntityService_activeSite_address_country : (0, $wYO7b.Resources).getCountryCode())) selectedValue = value.id;
                                });
                                _this.clearAll();
                                _this.selectBox = new (0, $a54861d990819f07$export$32ca16bda187b168)({
                                    search: true,
                                    searchDescription: true,
                                    entries: entries,
                                    selectedValue: selectedValue
                                });
                                _this.render(_this.selectBox);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSelectedTax",
            value: function getSelectedTax() {
                var _this = this;
                return this.taxes.find(function(value) {
                    return value.id == _this.selectBox.getSelection().value;
                });
            }
        }
    ]);
    return SiteTaxComponent;
}((0, $9gCL8.Component));


var $1806b2d216a8842a$export$ec80a8c98df77cb5 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(SiteAddressComponent, Component);
    function SiteAddressComponent() {
        (0, $3CDbU._)(this, SiteAddressComponent);
        var _this;
        var _EntityService_activeSite_address, _EntityService_activeSite_address1, _EntityService_activeSite_address2, _EntityService_activeSite_address3, _EntityService_activeSite_address4, _EntityService_activeSite_address5, _EntityService_activeSite_address6, _EntityService_activeSite_address7, _EntityService_activeSite_address_tax, _EntityService_activeSite_address8;
        _this = (0, $ep9cZ._)(this, SiteAddressComponent);
        _this.countryPicker = new (0, $78b704a2554e9522$export$143c167d2a04bd23)(((_EntityService_activeSite_address = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address === void 0 ? void 0 : _EntityService_activeSite_address.country) ? (_EntityService_activeSite_address1 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address1 === void 0 ? void 0 : _EntityService_activeSite_address1.country : (0, $wYO7b.Resources).getCountryCode());
        _this.nameInput = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $wYO7b.Resources).t("words.name"),
            value: (_EntityService_activeSite_address2 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address2 === void 0 ? void 0 : _EntityService_activeSite_address2.name
        });
        _this.line1Input = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $wYO7b.Resources).t("words.address"),
            value: (_EntityService_activeSite_address3 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address3 === void 0 ? void 0 : _EntityService_activeSite_address3.line1
        });
        _this.line2Input = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            placeholder: (0, $wYO7b.Resources).t("words.addressDetails"),
            value: (_EntityService_activeSite_address4 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address4 === void 0 ? void 0 : _EntityService_activeSite_address4.line2
        });
        _this.postalCodeInput = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $wYO7b.Resources).t("words.zipCode"),
            value: (_EntityService_activeSite_address5 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address5 === void 0 ? void 0 : _EntityService_activeSite_address5.postalCode
        });
        _this.cityInput = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $wYO7b.Resources).t("words.city"),
            value: (_EntityService_activeSite_address6 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address6 === void 0 ? void 0 : _EntityService_activeSite_address6.city
        });
        _this.stateInput = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            placeholder: (0, $wYO7b.Resources).t("words.addressState"),
            value: (_EntityService_activeSite_address7 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address7 === void 0 ? void 0 : _EntityService_activeSite_address7.state
        });
        _this.taxInput = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
            placeholder: (0, $wYO7b.Resources).t("words.number"),
            value: (_EntityService_activeSite_address8 = (0, $lThic.EntityService).activeSite.address) === null || _EntityService_activeSite_address8 === void 0 ? void 0 : (_EntityService_activeSite_address_tax = _EntityService_activeSite_address8.tax) === null || _EntityService_activeSite_address_tax === void 0 ? void 0 : _EntityService_activeSite_address_tax.code
        });
        _this.taxPicker = new (0, $ea76e649c6458191$export$d347b2ed4a8490cf)();
        //language=HTML
        _this.template = '\n            <div class="'.concat($5ad1f851e2531abd$export$aaa2fdfbe3211bee, '">\n                <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                    ').concat(_this.draw(_this.nameInput), '\n                </div>\n                <div>\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.line1Input), '\n                    </div>\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.line2Input), '\n                    </div>\n                </div>\n                <div class="').concat($5ad1f851e2531abd$export$6170c7625ed1f3cc, '">\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.postalCodeInput), '\n                    </div>\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.cityInput), '\n                    </div>\n                </div>\n                <div class="').concat($5ad1f851e2531abd$export$6170c7625ed1f3cc, '">\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.stateInput), '\n                    </div>\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.countryPicker), '\n                    </div>\n                </div>\n                <div class="').concat($5ad1f851e2531abd$export$1237798dc640739a, '">\n                    ').concat((0, $wYO7b.Resources).t("words.optionalTaxNumber"), '\n                </div>\n                <div class="').concat($5ad1f851e2531abd$export$6170c7625ed1f3cc, '">\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.taxPicker), '\n                    </div>\n                    <div class="').concat($5ad1f851e2531abd$export$72108e4fb43880e3, '">\n                        ').concat(_this.draw(_this.taxInput), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(SiteAddressComponent, [
        {
            key: "getAddress",
            value: function getAddress() {
                return {
                    city: this.cityInput.getValue(),
                    country: this.countryPicker.selectBox.getSelection().value,
                    line1: this.line1Input.getValue(),
                    line2: this.line2Input.getValue(),
                    name: this.nameInput.getValue(),
                    postalCode: this.postalCodeInput.getValue(),
                    state: this.stateInput.getValue(),
                    tax: this.taxInput.getValueTrim().length > 0 ? {
                        code: this.taxInput.getValue(),
                        type: this.taxPicker.getSelectedTax().id
                    } : undefined
                };
            }
        }
    ]);
    return SiteAddressComponent;
}((0, $9gCL8.Component));




var $lThic = parcelRequire("lThic");

var $bMhfs = parcelRequire("bMhfs");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $wYO7b = parcelRequire("wYO7b");
var $ea7a5885ca834dd8$export$6fdb7f490b0acb5b = /*#__PURE__*/ function(OfferProductSolutionType) {
    OfferProductSolutionType[OfferProductSolutionType["ACCOUNT"] = 0] = "ACCOUNT";
    OfferProductSolutionType[OfferProductSolutionType["LIVECHAT"] = 1] = "LIVECHAT";
    OfferProductSolutionType[OfferProductSolutionType["MAILS"] = 2] = "MAILS";
    OfferProductSolutionType[OfferProductSolutionType["IA"] = 3] = "IA";
    OfferProductSolutionType[OfferProductSolutionType["SITE_CHANNEL"] = 4] = "SITE_CHANNEL";
    OfferProductSolutionType[OfferProductSolutionType["COMMUNITY"] = 5] = "COMMUNITY";
    OfferProductSolutionType[OfferProductSolutionType["AI_CONTENT"] = 6] = "AI_CONTENT";
    OfferProductSolutionType[OfferProductSolutionType["AUTOPILOT"] = 7] = "AUTOPILOT";
    OfferProductSolutionType[OfferProductSolutionType["WRITING_STYLE"] = 8] = "WRITING_STYLE";
    OfferProductSolutionType[OfferProductSolutionType["SEO_RANKING"] = 9] = "SEO_RANKING";
    OfferProductSolutionType[OfferProductSolutionType["SEO_CLUSTER"] = 10] = "SEO_CLUSTER";
    OfferProductSolutionType[OfferProductSolutionType["SEO_AUDIT"] = 11] = "SEO_AUDIT";
    OfferProductSolutionType[OfferProductSolutionType["OPTIMIZATION_CONTENT"] = 12] = "OPTIMIZATION_CONTENT";
    OfferProductSolutionType[OfferProductSolutionType["BRIEF_CONTENT"] = 13] = "BRIEF_CONTENT";
    return OfferProductSolutionType;
}({});


var $daa657d6ac7ca23b$export$6913bb0f068db6f0 = /*#__PURE__*/ function(IOfferContentsTableIcon) {
    IOfferContentsTableIcon[IOfferContentsTableIcon["WORDPRESS"] = 0] = "WORDPRESS";
    IOfferContentsTableIcon[IOfferContentsTableIcon["SHOPIFY"] = 1] = "SHOPIFY";
    IOfferContentsTableIcon[IOfferContentsTableIcon["WIX"] = 2] = "WIX";
    IOfferContentsTableIcon[IOfferContentsTableIcon["PRESTASHOP"] = 3] = "PRESTASHOP";
    IOfferContentsTableIcon[IOfferContentsTableIcon["WEBFLOW"] = 4] = "WEBFLOW";
    return IOfferContentsTableIcon;
}({});


var $befcde66434320e0$export$b6ed60a23ae88524 = /*#__PURE__*/ function() {
    "use strict";
    function OfferContents() {
        (0, $3CDbU._)(this, OfferContents);
    }
    (0, $jyA4z._)(OfferContents, null, [
        {
            key: "table",
            value: function table(templates) {
                var table = [
                    {
                        name: (0, $wYO7b.Resources).t("words.briefContentSeoWriting"),
                        entries: [],
                        description: (0, $wYO7b.Resources).t("words.briefContentSeoWritingDescription"),
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).BRIEF_CONTENT,
                        type: "text"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.automaticOptimization"),
                        entries: [],
                        description: (0, $wYO7b.Resources).t("words.automaticOptimizationDescription"),
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).OPTIMIZATION_CONTENT,
                        type: "text"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.seoOptimizedBlogContents"),
                        entries: [],
                        description: (0, $wYO7b.Resources).t("words.generateContentDescription"),
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).AI_CONTENT,
                        type: "text"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.topicsAndClusters"),
                        entries: [],
                        description: (0, $wYO7b.Resources).t("words.topicsAndClustersDescription"),
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).SEO_CLUSTER,
                        type: "text"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.teamMembers"),
                        entries: [
                            {
                                value: "<span>1</span> ".concat((0, $wYO7b.Resources).t("words.singleMember"))
                            },
                            {
                                value: "<span>3</span> ".concat((0, $wYO7b.Resources).t("words.multipleMembers"))
                            },
                            {
                                value: "<span>10</span> ".concat((0, $wYO7b.Resources).t("words.multipleMembers"))
                            }
                        ],
                        entriesCustom: true,
                        description: (0, $wYO7b.Resources).t("words.teamMembersDescription"),
                        solutionType: undefined,
                        addToContents: true,
                        type: "text"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.competitorAnalysis"),
                        description: (0, $wYO7b.Resources).t("words.analyzeCompetitorsDescription"),
                        addToContents: true,
                        entries: [],
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).SEO_RANKING,
                        type: "bool",
                        boolMin: 1
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.multiLanguageSites"),
                        description: (0, $wYO7b.Resources).t("words.generateMultiLangContentDescription"),
                        entries: [],
                        addToContents: true,
                        solutionType: (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).COMMUNITY,
                        type: "textBool",
                        boolMin: 1
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.integrationWithYourSite"),
                        description: (0, $wYO7b.Resources).t("words.connectYourSiteDescription"),
                        addToContents: true,
                        entries: [],
                        solutionType: undefined,
                        type: "bool",
                        icons: [
                            (0, $daa657d6ac7ca23b$export$6913bb0f068db6f0).PRESTASHOP,
                            (0, $daa657d6ac7ca23b$export$6913bb0f068db6f0).SHOPIFY,
                            (0, $daa657d6ac7ca23b$export$6913bb0f068db6f0).WORDPRESS,
                            (0, $daa657d6ac7ca23b$export$6913bb0f068db6f0).WIX,
                            (0, $daa657d6ac7ca23b$export$6913bb0f068db6f0).WEBFLOW
                        ]
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.seoPositionTracking"),
                        description: (0, $wYO7b.Resources).t("words.seoPositionTrackingDescription"),
                        addToContents: true,
                        entries: [],
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.textHumanization"),
                        description: (0, $wYO7b.Resources).t("words.textHumanizationDescription"),
                        entries: [],
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.autopilot"),
                        description: (0, $wYO7b.Resources).t("words.automaticPilotDescription"),
                        addToContents: true,
                        entries: [],
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.keywordResearch"),
                        description: (0, $wYO7b.Resources).t("words.keywordResearchDescription"),
                        entries: [],
                        addToContents: true,
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.internalLinks"),
                        description: (0, $wYO7b.Resources).t("words.internalLinksDescription"),
                        entries: [],
                        addToContents: true,
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.googleSearchConsole"),
                        description: (0, $wYO7b.Resources).t("words.googleSearchConsoleDescription"),
                        entries: [],
                        solutionType: undefined,
                        type: "bool"
                    },
                    {
                        name: (0, $wYO7b.Resources).t("words.onboardingHelp"),
                        description: (0, $wYO7b.Resources).t("words.contactUsForAssistanceDescription"),
                        addToContents: true,
                        entries: [],
                        solutionType: undefined,
                        type: "bool"
                    }
                ];
                templates.forEach(function(product) {
                    var bundle = product.bundles[0];
                    table.forEach(function(tableLine) {
                        var solution = bundle.solutions.find(function(value) {
                            return value.type == tableLine.solutionType;
                        });
                        var entry = {
                            templateId: product.id
                        };
                        switch(tableLine.type){
                            case "text":
                                if (solution) entry.value = "<span>".concat(solution.quantityInitial, "</span> ").concat((0, $wYO7b.Resources).t("words.offerSolution".concat(product.type).concat(product.productType).concat(solution.type)));
                                break;
                            case "textBool":
                                if (solution && solution.quantityInitial > tableLine.boolMin) entry.value = "<span>".concat(solution.quantityInitial, "</span> ").concat((0, $wYO7b.Resources).t("words.offerSolution".concat(product.type).concat(product.productType).concat(solution.type)));
                                break;
                            case "bool":
                                if (solution) {
                                    if (solution.quantityInitial > tableLine.boolMin) entry.value = true;
                                } else entry.value = true;
                                break;
                        }
                        if (!tableLine.entriesCustom) tableLine.entries.push(entry);
                    });
                });
                return table;
            }
        },
        {
            key: "hiddenTypes",
            value: function hiddenTypes() {
                return [
                    (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).SEO_RANKING,
                    (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).WRITING_STYLE,
                    (0, $ea7a5885ca834dd8$export$6fdb7f490b0acb5b).SEO_AUDIT
                ];
            }
        },
        {
            key: "popularTemplates",
            value: function popularTemplates() {
                return [
                    "17778c6ca54349a69a4999ca218aced9"
                ];
            }
        },
        {
            key: "contents",
            value: function contents(baseContents, template) {
                var table = this.table([
                    template
                ]);
                table.forEach(function(tableLine) {
                    if (tableLine.addToContents) {
                        var _tableLine_entries_find;
                        var value = (_tableLine_entries_find = tableLine.entries.find(function(value) {
                            return value.templateId == template.id;
                        })) === null || _tableLine_entries_find === void 0 ? void 0 : _tableLine_entries_find.value;
                        if (value !== undefined) {
                            if (!value || tableLine.type == "bool") value = tableLine.name;
                            baseContents.push(value);
                        }
                    }
                });
                return baseContents;
            }
        }
    ]);
    return OfferContents;
}();


var $06b56c5a6cff27f5$export$958f4fee317b0b7c = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferQuoteComponent, Component);
    function OfferQuoteComponent(productType, quote) {
        (0, $3CDbU._)(this, OfferQuoteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferQuoteComponent);
        _this.productType = productType;
        _this.quote = quote;
        _this.paymentProvider = (0, $lThic.EntityService).activeSite.paymentProvider;
        var _EntityService_activeEntity_displayPromoCodeInput;
        _this.displayPromoCodeInput = (_EntityService_activeEntity_displayPromoCodeInput = (0, $lThic.EntityService).activeEntity.displayPromoCodeInput) !== null && _EntityService_activeEntity_displayPromoCodeInput !== void 0 ? _EntityService_activeEntity_displayPromoCodeInput : false;
        _this.product = _this.quote.offer.products[_this.productType];
        _this.bundle = _this.quote.offer.products[_this.productType].bundles[0];
        _this.bundleTemplate = _this.quote.offer.products[_this.productType].template[0];
        //language=HTML
        _this.template = '\n            <div class="'.concat($6ec9744be80cbcc3$export$1c80ec59d1789323, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(OfferQuoteComponent, [
        {
            key: "commit",
            value: function commit() {
                this.renderAll();
                this.scrollable();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferQuoteComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderAll",
            value: function renderAll() {
                this.renderBack((0, $wYO7b.Resources).t("words.offerBack"));
                this.renderOfferContent();
                this.renderAddress();
                this.renderAdvantageCode();
                if (this.quote.offer.startDate > Date.now()) this.renderScheduled();
                this.renderPrice();
            }
        },
        {
            key: "renderBack",
            value: function renderBack(text) {
                if (!this.quote.offer.active) {
                    //language=HTML
                    this.backButton = this.append('\n                <div class="'.concat($6ec9744be80cbcc3$export$7c341cb16fc91138, '">\n                    <div class="').concat($6ec9744be80cbcc3$export$1ca1ec8b29a4ce27, '"></div>\n                    ').concat(text, "\n                </div>\n            "));
                    var _this = this;
                    this.backButton.onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            return [
                                2,
                                _this.back()
                            ];
                        });
                    }));
                } else this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$7c341cb16fc91138, '"></div>\n        '));
            }
        },
        {
            key: "renderOfferContent",
            value: function renderOfferContent() {
                var _this = this;
                var contents = this.bundle.solutions.filter(function(solution) {
                    return !(0, $befcde66434320e0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type);
                }).map(function(solution) {
                    return "".concat(solution.quantity, " ").concat((0, $wYO7b.Resources).t("words.offerSolution".concat(_this.product.template.type).concat(_this.product.template.productType).concat(solution.type)));
                });
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$8f981dffec84ba52, '">\n                <div class="').concat($6ec9744be80cbcc3$export$ce69bd05624d0c48, '">\n                    <div class="').concat($6ec9744be80cbcc3$export$acf4eaf431084f78, '">\n                        ').concat(this.draw(new (0, $7fa5fdd391950487$export$e11200deb10216e7)(this.product.template.type)), '\n                    </div>\n                    <div class="').concat($6ec9744be80cbcc3$export$a8ff84c12d48cfa6, '">\n                        ').concat((0, $wYO7b.Resources).t("words.offer"), " ").concat((0, $wYO7b.Resources).t("words.offerName".concat(this.product.template.type)), "\n                    </div>\n                </div>\n                ").concat(this.draw(new (0, $5e3ee4c72bc0588f$export$48a3aac3632ef8)((0, $befcde66434320e0$export$b6ed60a23ae88524).contents(contents, this.product.template), (0, $wYO7b.Resources).t("words.offerContentRecap"))), "\n            </div>\n        "));
            }
        },
        {
            key: "renderAddress",
            value: function renderAddress() {
                this.cgvButton = new (0, $2bebc11730903676$export$667c5478f6e1eafe)(false);
                this.addressComponent = new (0, $1806b2d216a8842a$export$ec80a8c98df77cb5)();
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$7b388ca536128c6d, '">\n                ').concat(this.paymentProvider.address ? '\n                <div class="'.concat($6ec9744be80cbcc3$export$1237798dc640739a, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerWriteAddress"), "\n                </div>\n                ").concat(this.draw(this.addressComponent), "\n            ") : '', '\n\n                <div class="').concat($6ec9744be80cbcc3$export$1237798dc640739a, '">\n                    <a href="').concat((0, $3Qm5T.Network).router.pages.getWebsiteUrl('cgv'), '" target="_blank">\n                        ').concat((0, $wYO7b.Resources).t("words.offerCgv"), "\n                    </a>\n                    <span>").concat(this.draw(this.cgvButton), "</span>\n                </div>\n            </div>\n        "));
            }
        },
        {
            key: "renderAdvantageCode",
            value: function renderAdvantageCode() {
                this.advantageCode = new (0, $8d8057af24883f1e$export$a6f05ece7dba1e5c)({
                    placeholder: (0, $wYO7b.Resources).t("words.offerApplyAdvantageCodeInput")
                });
                //language=HTML
                this.append('<div class="'.concat($6ec9744be80cbcc3$export$18f552c4c727aeb5, '">\n                ').concat(this.displayPromoCodeInput ? "\n                    <div>".concat((0, $wYO7b.Resources).t("words.offerApplyAdvantageCode"), '</div>\n                    <div class="').concat($6ec9744be80cbcc3$export$72108e4fb43880e3, '">\n                        ').concat(this.draw(this.advantageCode), "\n                    </div> ") : '', "\n            </div>"));
            }
        },
        {
            key: "renderScheduled",
            value: function renderScheduled() {
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$49c44dfc2bb21d70, '">\n                ').concat((0, $wYO7b.Resources).t("words.offerTakeEffectAt"), " ").concat((0, $c9c1c4776943ab22$export$4e4cb19dd88cd821)(new Date(this.quote.offer.startDate)), "\n            </div>\n        "));
            }
        },
        {
            key: "renderPrice",
            value: function renderPrice(fixedPrice, text) {
                this.priceComponent = new (0, $bf3d11141e19674b$export$19746147d1b55543)({
                    period: {
                        periodType: this.quote.offer.periodType,
                        advantagePercentage: this.quote.offer.advantagePercentage
                    },
                    price: fixedPrice ? fixedPrice : this.quote.offer.totalPrice,
                    noCalculateYear: true,
                    text: text ? text : (0, $wYO7b.Resources).t("words.continue"),
                    totalPrice: fixedPrice != undefined
                });
                var _this = this;
                this.priceComponent.onGetStarted = /*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getStarted()
                        ];
                    });
                });
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$74d6ad014ec5fd29, '">\n                ').concat(this.draw(this.priceComponent), "\n            </div>\n        "));
            }
        },
        {
            key: "back",
            value: function back() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.clearAll();
                                _this.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                                return [
                                    4,
                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).quoteCancel(_this)
                                ];
                            case 1:
                                _state.sent();
                                _this.onStep();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStarted",
            value: function getStarted() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var quote, _quote_payment;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.cgvButton.checked) return [
                                    3,
                                    1
                                ];
                                (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.offerAcceptCgv"), undefined, 3000);
                                return [
                                    3,
                                    8
                                ];
                            case 1:
                                _this.priceComponent.setLoading();
                                return [
                                    4,
                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).quoteConfirmed({
                                        offerId: _this.quote.offer.id,
                                        address: _this.paymentProvider.address ? _this.addressComponent.getAddress() : undefined,
                                        advantageCode: _this.displayPromoCodeInput && _this.advantageCode.getValue().length > 0 ? _this.advantageCode.getValue() : undefined
                                    }, _this)
                                ];
                            case 2:
                                quote = _state.sent();
                                if (!quote) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).token()
                                ];
                            case 3:
                                _state.sent();
                                if (!(_this.paymentProvider.id == (0, $bMhfs.PaymentProviderType).STRIPE && ((_quote_payment = quote.payment) === null || _quote_payment === void 0 ? void 0 : _quote_payment.actionType) == (0, $8957314797dd1ba9$export$50ba419e547989b9).NONE)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.startStripePayCheck(quote.offer)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.onStep(quote);
                                _this.priceComponent.remLoading();
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _this.priceComponent.remLoading();
                                _state.label = 8;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleExpiredQuote",
            value: function scheduleExpiredQuote() {
                var _this = this;
                if (this.quote.offer.expiredTime > 0) {
                    var time = this.quote.offer.expiredTime - Date.now();
                    this.timeOut(function() {
                        return _this.back();
                    }, time);
                }
            }
        },
        {
            key: "startStripePayCheck",
            value: function startStripePayCheck(offerQuote) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var intervalCount, interval;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(offerQuote.state === (0, $c0453c00fb30c134$export$d4c083ce95fb2409).SCHEDULED)) return [
                                    3,
                                    2
                                ];
                                _this.onCloseModal();
                                (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.offerNowScheduled"), undefined, 3000, "success");
                                return [
                                    4,
                                    _this.reloadOrRedirect()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                intervalCount = 0;
                                interval = _this.interval(/*#__PURE__*/ (0, $hWZw8._)(function() {
                                    var offerDetails;
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (intervalCount >= 3) {
                                                    (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.account.error"), undefined, 3000);
                                                    clearInterval(interval);
                                                    _this.priceComponent.remLoading();
                                                    return [
                                                        2
                                                    ];
                                                }
                                                intervalCount++;
                                                return [
                                                    4,
                                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).active(false, _this)
                                                ];
                                            case 1:
                                                offerDetails = _state.sent();
                                                if (!(offerDetails && offerDetails.offer.id == offerQuote.id)) return [
                                                    3,
                                                    3
                                                ];
                                                clearInterval(interval);
                                                _this.onCloseModal();
                                                (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.offerNowActive"), undefined, 3000, "success");
                                                return [
                                                    4,
                                                    _this.reloadOrRedirect()
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), 7000);
                                _this.priceComponent.setLoading();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onStep",
            value: function onStep(details) {}
        },
        {
            key: "onCloseModal",
            value: function onCloseModal() {}
        },
        {
            key: "reloadOrRedirect",
            value: function reloadOrRedirect() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $3Qm5T.Network).router.pages.getPath().includes("/b/home/content/subscriptions/home")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.reload()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.redirect("/b/home/content/subscriptions/home")
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OfferQuoteComponent;
}((0, $9gCL8.Component));



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");




var $wYO7b = parcelRequire("wYO7b");



/**
 * Retourne les codes de mois entre deux dates
 */ function $426f757abc13fbfd$export$14d4a9b10446dd73(timestamp1, timestamp2) {
    // Création des objets Date à partir des timestamps
    var date1 = new Date(timestamp1);
    var date2 = new Date(timestamp2);
    // Calcul des composants année et mois
    var year1 = date1.getFullYear();
    var month1 = date1.getMonth();
    var year2 = date2.getFullYear();
    var month2 = date2.getMonth();
    // Calcul de la différence en mois
    return (year2 - year1) * 12 + (month2 - month1);
}



var $wYO7b = parcelRequire("wYO7b");

function $12f22d88e5c88f36$export$afa05e915c2edbb5(details, product) {
    if (details.payment) {
        var _details_payment_nextAdvantages;
        var advantages = (_details_payment_nextAdvantages = details.payment.nextAdvantages) === null || _details_payment_nextAdvantages === void 0 ? void 0 : _details_payment_nextAdvantages.filter(function(value) {
            return value.productTemplateId == product.template.id;
        });
        var advantagePercentage = 0;
        var advantageMonths = 0;
        if (advantages && advantages.length > 0) {
            advantagePercentage = advantages[0].advantagePercentage * 100;
            advantageMonths = (0, $426f757abc13fbfd$export$14d4a9b10446dd73)(advantages[0].startDate, advantages[0].endDate) - 1;
        }
        var advantageText = advantagePercentage > 0 ? "".concat(advantagePercentage, "% ").concat((0, $wYO7b.Resources).t("words.offerAdvantageNow")) : "";
        if (details.offer.advantageCode && details.offer.periodType == (0, $e4a056b6b54a25c6$export$b7ac94010691eccd).ANNUAL) advantageText = (0, $wYO7b.Resources).t("words.offerAdvantageYearApplied");
        return {
            advantageMonths: advantageMonths,
            advantagePercentage: advantagePercentage,
            advantageText: advantageText
        };
    }
}



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");


var $wYO7b = parcelRequire("wYO7b");

var $bXtBT = parcelRequire("bXtBT");

var $57e1fc777c8669fa$export$ff62fe619d647b4e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferStripeComponent, Component);
    function OfferStripeComponent(secrets, actionType) {
        (0, $3CDbU._)(this, OfferStripeComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferStripeComponent);
        _this.id = "offer-stripe-component" + (0, $bXtBT.randomInteger)(0, 1000000);
        _this.secrets = secrets;
        _this.actionType = actionType;
        //language=HTML
        _this.template = '\n            <div id="'.concat(_this.id, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(OfferStripeComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferStripeComponent.prototype), "commit", this).call(this);
                this.init();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var stripeJs, customerOptions, paymentElement;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (parcelRequire("nHskx"))
                                ];
                            case 1:
                                stripeJs = _state.sent();
                                return [
                                    4,
                                    stripeJs.loadStripe(undefined, {
                                        betas: [
                                            "elements_customers_beta_1"
                                        ],
                                        apiVersion: "2024-04-10"
                                    })
                                ];
                            case 2:
                                _this.stripe = _state.sent();
                                if (_this.secrets.ephemeralKey) customerOptions = {
                                    ephemeralKey: _this.secrets.ephemeralKey,
                                    customer: _this.secrets.customer
                                };
                                _this.stripeElements = _this.stripe.elements({
                                    clientSecret: _this.secrets.clientSecret,
                                    customerOptions: customerOptions
                                });
                                paymentElement = _this.stripeElements.create('payment');
                                paymentElement.mount("#" + _this.id);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "payment",
            value: function payment() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var errorStripe, successStripe, paymentIntentResult, setupIntentResult, _errorStripe_message;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                errorStripe = undefined;
                                successStripe = undefined;
                                if (!(_this.actionType === (0, $8957314797dd1ba9$export$50ba419e547989b9).PAYMENT)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.stripe.confirmPayment({
                                        elements: _this.stripeElements,
                                        redirect: "if_required"
                                    })
                                ];
                            case 1:
                                paymentIntentResult = _state.sent();
                                errorStripe = paymentIntentResult.error;
                                successStripe = paymentIntentResult.paymentIntent;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(_this.actionType === (0, $8957314797dd1ba9$export$50ba419e547989b9).INTENT)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.stripe.confirmSetup({
                                        elements: _this.stripeElements,
                                        redirect: "if_required"
                                    })
                                ];
                            case 3:
                                setupIntentResult = _state.sent();
                                errorStripe = setupIntentResult.error;
                                successStripe = setupIntentResult.setupIntent;
                                _state.label = 4;
                            case 4:
                                if (errorStripe) {
                                    ;
                                    if (errorStripe.code == "payment_intent_unexpected_state") _this.onPaid();
                                    else _this.onError(errorStripe.code != "incomplete_number" ? (_errorStripe_message = errorStripe.message) !== null && _errorStripe_message !== void 0 ? _errorStripe_message : (0, $wYO7b.Resources).t("words.errorgenericErrorMessage") : undefined);
                                } else if (successStripe) _this.onPaid();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onPaid",
            value: function onPaid() {}
        },
        {
            key: "onError",
            value: function onError(error) {}
        }
    ]);
    return OfferStripeComponent;
}((0, $9gCL8.Component));


var $d84b946eb25fa51a$export$97cdf95035444dd8 = /*#__PURE__*/ function(OfferQuoteComponent) {
    "use strict";
    (0, $jCmGC._)(OfferQuoteConfirmedComponent, OfferQuoteComponent);
    function OfferQuoteConfirmedComponent(productType, quote) {
        (0, $3CDbU._)(this, OfferQuoteConfirmedComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferQuoteConfirmedComponent, [
            productType,
            quote
        ]);
        //language=HTML
        _this.template = '\n            <div class="'.concat($6ec9744be80cbcc3$export$1c80ec59d1789323, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(OfferQuoteConfirmedComponent, [
        {
            key: "renderAll",
            value: function renderAll() {
                this.renderBack((0, $wYO7b.Resources).t("words.offerBackContent"));
                this.renderOfferContent();
                this.renderPriceDetailsCurrent();
                this.renderPriceDetailsNext();
                if (this.quote.payment.actionType !== (0, $8957314797dd1ba9$export$50ba419e547989b9).NONE) this.renderStripe(this.quote.payment.secrets, this.quote.payment.actionType);
                this.renderPrice(this.quote.payment.currentPriceTotal, (0, $wYO7b.Resources).t("words.offerPay"));
                this.scheduleExpiredQuote();
            }
        },
        {
            key: "renderPriceDetailsNext",
            value: function renderPriceDetailsNext() {
                if (!this.quote.offer.active) {
                    var advantages = (0, $12f22d88e5c88f36$export$afa05e915c2edbb5)(this.quote, this.product);
                    this.renderPriceDetails("".concat((0, $wYO7b.Resources).t("words.offerSince"), " ").concat((0, $c9c1c4776943ab22$export$4e4cb19dd88cd821)(new Date(this.quote.offer.nextBilling))), (0, $wYO7b.Resources).t(this.quote.offer.periodType == (0, $e4a056b6b54a25c6$export$b7ac94010691eccd).MONTHLY ? "words.offerPaidMonth" : "words.offerPaidYear"), this.quote.payment.nextPriceExcludingTaxEstimate, this.quote.payment.nextPriceIncludingTaxEstimate, (advantages === null || advantages === void 0 ? void 0 : advantages.advantagePercentage) > 0 ? "".concat(advantages.advantagePercentage, "% ").concat((0, $wYO7b.Resources).r("words.offerAdvantageMonth", {
                        advantageMonths: advantages.advantageMonths
                    })) : "", (advantages === null || advantages === void 0 ? void 0 : advantages.advantageMonths) > 0 ? this.quote.payment.nextAdvantageEndPriceIncludingTax : undefined, (advantages === null || advantages === void 0 ? void 0 : advantages.advantageMonths) > 0 ? this.quote.payment.nextAdvantageEndPriceExcludingTax : undefined);
                }
            }
        },
        {
            key: "renderPriceDetailsCurrent",
            value: function renderPriceDetailsCurrent() {
                var advantages = (0, $12f22d88e5c88f36$export$afa05e915c2edbb5)(this.quote, this.product);
                var _advantages_advantageText;
                this.renderPriceDetails("".concat((0, $wYO7b.Resources).t("words.offerCurrentPeriod"), " <span>(").concat((0, $wYO7b.Resources).t("words.from"), " ").concat((0, $c9c1c4776943ab22$export$4e4cb19dd88cd821)(new Date(this.quote.payment.currentPeriodStartDate)), " ").concat((0, $wYO7b.Resources).t("words.to"), " ").concat((0, $c9c1c4776943ab22$export$4e4cb19dd88cd821)(new Date(this.quote.payment.currentPeriodEndDate)), ")</span>"), (0, $wYO7b.Resources).t("words.offerCurrentPeriodPaid"), this.quote.payment.currentPriceExcludingTax, this.quote.payment.currentPriceTotal, (_advantages_advantageText = advantages === null || advantages === void 0 ? void 0 : advantages.advantageText) !== null && _advantages_advantageText !== void 0 ? _advantages_advantageText : "", undefined, undefined, this.quote.payment.currentInvoiceUrl);
            }
        },
        {
            key: "renderPriceDetails",
            value: function renderPriceDetails(title, description, priceVAT, price, advantageText, advantageEndVATPrice, advantageEndTotalPrice, invoiceUrl) {
                //language=HTML
                var details = this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$66fec733742690b6, '">\n                <div class="').concat($6ec9744be80cbcc3$export$fb184b623420d9be, '">\n                    ').concat(title, '\n                    <div class="').concat($6ec9744be80cbcc3$export$6d59db4903f20f7d, '">\n                        ').concat(description, "\n                    </div>\n                </div>\n                ").concat(advantageText ? '<div class="'.concat($6ec9744be80cbcc3$export$337d1885ef6f1e24, " ").concat($6ec9744be80cbcc3$export$56030be9156ae856, '">').concat(advantageText, "</div>") : "", "\n                ").concat(price ? '<div class="'.concat($6ec9744be80cbcc3$export$337d1885ef6f1e24, '">').concat((0, $93e45b16057b7b5b$export$6349d151e019902e)(priceVAT, false), "</div>") : '', '\n                <div class="').concat($6ec9744be80cbcc3$export$321c0b1a406de31f, '">\n                    ').concat((0, $93e45b16057b7b5b$export$6349d151e019902e)(price !== null && price !== void 0 ? price : priceVAT, Boolean(price)), "\n                </div>\n            </div>\n        "));
                if (advantageEndVATPrice) //language=HTML
                details.append('\n                <div style="margin-top: 15px;">\n                    <div class="'.concat($6ec9744be80cbcc3$export$337d1885ef6f1e24, " ").concat($6ec9744be80cbcc3$export$56030be9156ae856, '">').concat((0, $wYO7b.Resources).t("words.offerAtAdvantageEnd"), '</div>\n                    <div class="').concat($6ec9744be80cbcc3$export$337d1885ef6f1e24, '">\n                        ').concat((0, $93e45b16057b7b5b$export$6349d151e019902e)(advantageEndVATPrice, false), '\n                    </div>\n                    <div class="').concat($6ec9744be80cbcc3$export$321c0b1a406de31f, '">\n                        ').concat((0, $93e45b16057b7b5b$export$6349d151e019902e)(advantageEndTotalPrice, true), "\n                    </div>\n                </div>\n            "));
                if (invoiceUrl) //language=HTML
                details.append('\n                <a href="'.concat(invoiceUrl, '" class="').concat($6ec9744be80cbcc3$export$40e0ca2dfa95ba9e, '" download>\n                    ').concat((0, $wYO7b.Resources).t("words.offerDownloadInvoice"), '\n                    <div class="').concat($6ec9744be80cbcc3$export$1ca1ec8b29a4ce27, '"></div>\n                </a>\n            '));
            }
        },
        {
            key: "renderStripe",
            value: function renderStripe(secrets, actionType) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var stripeComponent, stripeContainer, errorContainer;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if (secrets) {
                            stripeComponent = new (0, $57e1fc777c8669fa$export$ff62fe619d647b4e)(secrets, actionType);
                            stripeComponent.onPaid = function() {
                                return _this.startStripePayCheck(_this.quote.offer);
                            };
                            stripeComponent.onError = function(error) {
                                if (error) {
                                    if (errorContainer) errorContainer.remove();
                                    errorContainer = stripeContainer.prepend('<div class="'.concat($6ec9744be80cbcc3$export$a3bc9b8ed74fc, '">').concat(error, "</div>"));
                                }
                                _this.priceComponent.remLoading();
                            };
                            //language=HTML
                            stripeContainer = _this.append('\n                <div class="'.concat($6ec9744be80cbcc3$export$735606310a3da449, '"></div>'));
                            stripeContainer.render(stripeComponent);
                            ;
                            _this.getStarted = /*#__PURE__*/ (0, $hWZw8._)(function() {
                                return (0, $eJDpD.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _this.priceComponent.setLoading();
                                            return [
                                                4,
                                                stripeComponent.payment()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        } else {
                            _this.getStarted = /*#__PURE__*/ (0, $hWZw8._)(function() {
                                return (0, $eJDpD.__generator)(this, function(_state) {
                                    return [
                                        2
                                    ];
                                });
                            });
                            _this.priceComponent.clear();
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return OfferQuoteConfirmedComponent;
}((0, $06b56c5a6cff27f5$export$958f4fee317b0b7c));



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");


var $wYO7b = parcelRequire("wYO7b");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $2b1685d63ad60b29$export$56715c470bdac314;
var $2b1685d63ad60b29$export$f1e544e8e1c4eecb;
var $2b1685d63ad60b29$export$f4c5de44377d2946;
var $2b1685d63ad60b29$export$a19185d1233fc4b2;
var $2b1685d63ad60b29$export$6f093cfa640b7166;
var $2b1685d63ad60b29$export$dc57ddd528b7443f;
var $2b1685d63ad60b29$export$2ba01fb71ed41cb6;
var $2b1685d63ad60b29$export$46c1c92549715335;
$2b1685d63ad60b29$export$56715c470bdac314 = "POGiS";
$2b1685d63ad60b29$export$f1e544e8e1c4eecb = "qmkTN";
$2b1685d63ad60b29$export$f4c5de44377d2946 = "_3pXQU";
$2b1685d63ad60b29$export$a19185d1233fc4b2 = "_1xGyO";
$2b1685d63ad60b29$export$6f093cfa640b7166 = "Oia-2";
$2b1685d63ad60b29$export$dc57ddd528b7443f = "Nf2mf";
$2b1685d63ad60b29$export$2ba01fb71ed41cb6 = "OaL6X";
$2b1685d63ad60b29$export$46c1c92549715335 = "sQqtO";



var $3Qm5T = parcelRequire("3Qm5T");

var $e159f7468ee1e5d4$export$8f93841fb2480ea2 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(EmptyBasicComponent, Component);
    function EmptyBasicComponent(emoji, text, buttonText, loader) {
        (0, $3CDbU._)(this, EmptyBasicComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, EmptyBasicComponent);
        //language=HTML
        _this.template = '\n            <div emptyBasic class="'.concat($2b1685d63ad60b29$export$56715c470bdac314, '">\n                <div class="').concat($2b1685d63ad60b29$export$f1e544e8e1c4eecb, '">\n                    <div emptyemoji class="').concat($2b1685d63ad60b29$export$a19185d1233fc4b2, '">').concat(emoji, "</div>\n                    ").concat(text == undefined ? "" : '<div emptyText class="'.concat($2b1685d63ad60b29$export$6f093cfa640b7166, '">').concat(text, "</div>"), "\n                    ").concat(buttonText == undefined ? "" : '<div class="'.concat($2b1685d63ad60b29$export$dc57ddd528b7443f, '"><div emptyButton class="').concat($2b1685d63ad60b29$export$2ba01fb71ed41cb6, '">').concat(buttonText, "</div></div>"), "\n                    ").concat(loader == undefined ? "" : '<div class="'.concat($2b1685d63ad60b29$export$f4c5de44377d2946, '">').concat(_this.draw(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)({
            width: 50,
            strokeWidth: 3
        })), "</div>"), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(EmptyBasicComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.buttonContainer = this.el($2b1685d63ad60b29$export$dc57ddd528b7443f);
                this.button = this.el($2b1685d63ad60b29$export$2ba01fb71ed41cb6);
                this.textContainer = this.el($2b1685d63ad60b29$export$6f093cfa640b7166);
                if (this.buttonContainer && !this.buttonContainer.isNull()) this.buttonContainer.onClick(function() {
                    if (!_this.button.hasClass($2b1685d63ad60b29$export$46c1c92549715335)) _this.onButtonClick();
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(EmptyBasicComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "onButtonClick",
            value: function onButtonClick() {
                (0, $3Qm5T.Network).router.pages.redirect("/general/categories");
            }
        },
        {
            key: "setButtonLoading",
            value: function setButtonLoading() {
                if (!this.buttonContainer.isNull()) {
                    this.loading = this.button.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
                    this.button.addClass($2b1685d63ad60b29$export$46c1c92549715335);
                }
            }
        },
        {
            key: "remButtonLoading",
            value: function remButtonLoading() {
                if (!this.buttonContainer.isNull() && this.loading) {
                    this.button.removeClass($2b1685d63ad60b29$export$46c1c92549715335);
                    this.loading.remove();
                    this.loading = undefined;
                }
            }
        }
    ]);
    return EmptyBasicComponent;
}((0, $9gCL8.Component));






var $3Qm5T = parcelRequire("3Qm5T");

var $lThic = parcelRequire("lThic");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $bc90777c321ec919$export$e69bd631d8b8dbd7;
var $bc90777c321ec919$export$6d59db4903f20f7d;
var $bc90777c321ec919$export$bbea856fdb3e3c5f;
var $bc90777c321ec919$export$2ba01fb71ed41cb6;
var $bc90777c321ec919$export$70b61ad426ddbe54;
var $bc90777c321ec919$export$c4c4198845d8b888;
$bc90777c321ec919$export$e69bd631d8b8dbd7 = "-eIPc";
$bc90777c321ec919$export$6d59db4903f20f7d = "Z6d2k";
$bc90777c321ec919$export$bbea856fdb3e3c5f = "yLDdq";
$bc90777c321ec919$export$2ba01fb71ed41cb6 = "_2bOXJ";
$bc90777c321ec919$export$70b61ad426ddbe54 = "fXoRb";
$bc90777c321ec919$export$c4c4198845d8b888 = "qd6Jo";




var $wYO7b = parcelRequire("wYO7b");
var $dee593dd6e35be1c$export$f09a8aef9d6f86e4 = /*#__PURE__*/ function(VisualModalComponent) {
    "use strict";
    (0, $jCmGC._)(PromptConfirmationComponent, VisualModalComponent);
    function PromptConfirmationComponent(description, name, okButton) {
        (0, $3CDbU._)(this, PromptConfirmationComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, PromptConfirmationComponent);
        _this.name = name !== null && name !== void 0 ? name : (0, $wYO7b.Resources).t("words.confirmation");
        _this.okButton = okButton;
        //language=HTML
        _this.modalTemplate = '\n            <div class="'.concat($bc90777c321ec919$export$e69bd631d8b8dbd7, '">\n                <div class="').concat($bc90777c321ec919$export$6d59db4903f20f7d, '">\n                    ').concat(description, '\n                </div>\n                <div class="').concat($bc90777c321ec919$export$bbea856fdb3e3c5f, '">\n                    ').concat(_this.okButton ? '' : '<div class="'.concat($bc90777c321ec919$export$2ba01fb71ed41cb6, " ").concat($bc90777c321ec919$export$70b61ad426ddbe54, '">\n                        ').concat((0, $wYO7b.Resources).t("words.cancel"), "\n                    </div>"), '\n                    <div class="').concat($bc90777c321ec919$export$2ba01fb71ed41cb6, " ").concat($bc90777c321ec919$export$c4c4198845d8b888, '">\n                        ').concat(_this.okButton ? (0, $wYO7b.Resources).t("words.ok") : (0, $wYO7b.Resources).t("words.continue"), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(PromptConfirmationComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(PromptConfirmationComponent.prototype), "commit", this).call(this);
                this.visualModal.setStyle("z-index:99999999;");
                this.boxContainer.setStyle("width:250px;");
                this.cancelButton = this.el($bc90777c321ec919$export$70b61ad426ddbe54);
                this.continueButton = this.el($bc90777c321ec919$export$c4c4198845d8b888);
                var _this1 = this;
                if (!this.okButton) {
                    var _this2 = this;
                    this.cancelButton.onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this2.close()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    this.continueButton.onClick(function() {
                        _this.onContinue();
                    });
                } else this.continueButton.onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.close()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "setLoading",
            value: function setLoading() {
                this.continueButton.save();
                this.continueButton.clearAll();
                this.continueButton.render(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)());
            }
        },
        {
            /**
     * override
     */ key: "onContinue",
            value: function onContinue() {}
        }
    ]);
    return PromptConfirmationComponent;
}((0, $4c1003e9348fedb7$export$2a517e1cac1c1f85));


var $5b7b12c130e99677$export$18390818359c51b8 = /*#__PURE__*/ function(OfferQuoteConfirmedComponent) {
    "use strict";
    (0, $jCmGC._)(OfferQuoteScheduledComponent, OfferQuoteConfirmedComponent);
    function OfferQuoteScheduledComponent(productType, quote) {
        (0, $3CDbU._)(this, OfferQuoteScheduledComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferQuoteScheduledComponent, [
            productType,
            quote
        ]);
        _this.paymentProvider = (0, $lThic.EntityService).activeSite.paymentProvider;
        //language=HTML
        _this.template = '\n            <div class="'.concat($6ec9744be80cbcc3$export$1c80ec59d1789323, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(OfferQuoteScheduledComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferQuoteScheduledComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderAll",
            value: function renderAll() {
                this.renderEmpty();
                this.renderOfferContent();
                this.renderPriceDetailsNext();
                if (!this.paymentProvider.directDeleteDefinitiveOffer) this.renderCancel();
            }
        },
        {
            key: "renderEmpty",
            value: function renderEmpty() {
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$98ea8a8009e37bf1, '">\n                ').concat(this.draw(new (0, $e159f7468ee1e5d4$export$8f93841fb2480ea2)('<div class="'.concat($6ec9744be80cbcc3$export$1ca1ec8b29a4ce27, '"></div>'), "".concat((0, $wYO7b.Resources).t("words.offerTakeEffectAt"), " ").concat((0, $c9c1c4776943ab22$export$4e4cb19dd88cd821)(new Date(this.quote.offer.startDate))))), "\n            </div>\n        "));
            }
        },
        {
            key: "renderCancel",
            value: function renderCancel() {
                var buttons = new (0, $2d4c13491eee0660$export$f0c6024316437792)({
                    hideCancelButton: true,
                    saveText: (0, $wYO7b.Resources).t("words.offerCancelSchedule")
                });
                var _this = this;
                buttons.onSave = /*#__PURE__*/ (0, $hWZw8._)(function() {
                    var confirmation;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        confirmation = new (0, $dee593dd6e35be1c$export$f09a8aef9d6f86e4)((0, $wYO7b.Resources).t("words.offerCancelScheduleConfirmation"));
                        confirmation.screenRender();
                        confirmation.onContinue = /*#__PURE__*/ (0, $hWZw8._)(function() {
                            var e;
                            return (0, $eJDpD.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        buttons.setLoading();
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            (0, $58c1bfefd78b8329$export$a047eb6606b2561b).cancel(_this.quote.offer.id, true, _this)
                                        ];
                                    case 2:
                                        if (_state.sent()) (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.actionSuccess"), undefined, 3000, "success");
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        console.error(e);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        _this.onCloseModal();
                                        return [
                                            4,
                                            (0, $3Qm5T.Network).router.pages.reload()
                                        ];
                                    case 5:
                                        _state.sent();
                                        return [
                                            4,
                                            confirmation.close()
                                        ];
                                    case 6:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return [
                            2
                        ];
                    });
                });
                //language=HTML
                this.append('\n            <div class="'.concat($6ec9744be80cbcc3$export$70b61ad426ddbe54, '">\n                ').concat(this.draw(buttons), "\n            </div>\n        "));
            }
        }
    ]);
    return OfferQuoteScheduledComponent;
}((0, $d84b946eb25fa51a$export$97cdf95035444dd8));



var $3Qm5T = parcelRequire("3Qm5T");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $c0be1573cc790493$exports = {};

$parcel$export($c0be1573cc790493$exports, "componentOfferGrid", function () { return $c0be1573cc790493$export$6fab4431c6d3110c; }, function (v) { return $c0be1573cc790493$export$6fab4431c6d3110c = v; });
$parcel$export($c0be1573cc790493$exports, "line", function () { return $c0be1573cc790493$export$53f1d5ea8de3d7c; }, function (v) { return $c0be1573cc790493$export$53f1d5ea8de3d7c = v; });
$parcel$export($c0be1573cc790493$exports, "entry", function () { return $c0be1573cc790493$export$c407db72103fecfa; }, function (v) { return $c0be1573cc790493$export$c407db72103fecfa = v; });
$parcel$export($c0be1573cc790493$exports, "title", function () { return $c0be1573cc790493$export$fb184b623420d9be; }, function (v) { return $c0be1573cc790493$export$fb184b623420d9be = v; });
$parcel$export($c0be1573cc790493$exports, "description", function () { return $c0be1573cc790493$export$6d59db4903f20f7d; }, function (v) { return $c0be1573cc790493$export$6d59db4903f20f7d = v; });
$parcel$export($c0be1573cc790493$exports, "icons", function () { return $c0be1573cc790493$export$df03f54e09e486fa; }, function (v) { return $c0be1573cc790493$export$df03f54e09e486fa = v; });
$parcel$export($c0be1573cc790493$exports, "descIcon", function () { return $c0be1573cc790493$export$674d17a43c1246d4; }, function (v) { return $c0be1573cc790493$export$674d17a43c1246d4 = v; });
$parcel$export($c0be1573cc790493$exports, "shopify", function () { return $c0be1573cc790493$export$6da9acb12d5139d4; }, function (v) { return $c0be1573cc790493$export$6da9acb12d5139d4 = v; });
$parcel$export($c0be1573cc790493$exports, "webflow", function () { return $c0be1573cc790493$export$7902342170a40c7a; }, function (v) { return $c0be1573cc790493$export$7902342170a40c7a = v; });
$parcel$export($c0be1573cc790493$exports, "wordpress", function () { return $c0be1573cc790493$export$97971ff30d8c30d2; }, function (v) { return $c0be1573cc790493$export$97971ff30d8c30d2 = v; });
$parcel$export($c0be1573cc790493$exports, "wix", function () { return $c0be1573cc790493$export$ad6718c788124d32; }, function (v) { return $c0be1573cc790493$export$ad6718c788124d32 = v; });
$parcel$export($c0be1573cc790493$exports, "prestashop", function () { return $c0be1573cc790493$export$7c5480d2d52b096a; }, function (v) { return $c0be1573cc790493$export$7c5480d2d52b096a = v; });
$parcel$export($c0be1573cc790493$exports, "value", function () { return $c0be1573cc790493$export$2ab9a8f9f1186f14; }, function (v) { return $c0be1573cc790493$export$2ab9a8f9f1186f14 = v; });
$parcel$export($c0be1573cc790493$exports, "boolTrue", function () { return $c0be1573cc790493$export$428ef1f8ddd66578; }, function (v) { return $c0be1573cc790493$export$428ef1f8ddd66578 = v; });
$parcel$export($c0be1573cc790493$exports, "icon", function () { return $c0be1573cc790493$export$1ca1ec8b29a4ce27; }, function (v) { return $c0be1573cc790493$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($c0be1573cc790493$exports, "boolFalse", function () { return $c0be1573cc790493$export$d4a36b86e0c64e34; }, function (v) { return $c0be1573cc790493$export$d4a36b86e0c64e34 = v; });
var $c0be1573cc790493$export$6fab4431c6d3110c;
var $c0be1573cc790493$export$53f1d5ea8de3d7c;
var $c0be1573cc790493$export$c407db72103fecfa;
var $c0be1573cc790493$export$fb184b623420d9be;
var $c0be1573cc790493$export$6d59db4903f20f7d;
var $c0be1573cc790493$export$df03f54e09e486fa;
var $c0be1573cc790493$export$674d17a43c1246d4;
var $c0be1573cc790493$export$6da9acb12d5139d4;
var $c0be1573cc790493$export$7902342170a40c7a;
var $c0be1573cc790493$export$97971ff30d8c30d2;
var $c0be1573cc790493$export$ad6718c788124d32;
var $c0be1573cc790493$export$7c5480d2d52b096a;
var $c0be1573cc790493$export$2ab9a8f9f1186f14;
var $c0be1573cc790493$export$428ef1f8ddd66578;
var $c0be1573cc790493$export$1ca1ec8b29a4ce27;
var $c0be1573cc790493$export$d4a36b86e0c64e34;
$c0be1573cc790493$export$6fab4431c6d3110c = "_9XhK6";
$c0be1573cc790493$export$53f1d5ea8de3d7c = "XPv7g";
$c0be1573cc790493$export$c407db72103fecfa = "riHOJ";
$c0be1573cc790493$export$fb184b623420d9be = "MUJJR";
$c0be1573cc790493$export$6d59db4903f20f7d = "uGTfi";
$c0be1573cc790493$export$df03f54e09e486fa = "CQK23";
$c0be1573cc790493$export$674d17a43c1246d4 = "jwaPT";
$c0be1573cc790493$export$6da9acb12d5139d4 = "zb4TS";
$c0be1573cc790493$export$7902342170a40c7a = "KYMQg";
$c0be1573cc790493$export$97971ff30d8c30d2 = "-s90n";
$c0be1573cc790493$export$ad6718c788124d32 = "btfWH";
$c0be1573cc790493$export$7c5480d2d52b096a = "RJsSQ";
$c0be1573cc790493$export$2ab9a8f9f1186f14 = "ASwW5";
$c0be1573cc790493$export$428ef1f8ddd66578 = "XIDxA";
$c0be1573cc790493$export$1ca1ec8b29a4ce27 = "-qoDq";
$c0be1573cc790493$export$d4a36b86e0c64e34 = "V-MC8";





var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a5c713cacfe9e4cd$exports = {};

$parcel$export($a5c713cacfe9e4cd$exports, "componentOfferTemplate", function () { return $a5c713cacfe9e4cd$export$f88754492213681b; }, function (v) { return $a5c713cacfe9e4cd$export$f88754492213681b = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "selected", function () { return $a5c713cacfe9e4cd$export$d90250155de6d7e7; }, function (v) { return $a5c713cacfe9e4cd$export$d90250155de6d7e7 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "selectedCheck", function () { return $a5c713cacfe9e4cd$export$a6ab2d8c92cb3c5d; }, function (v) { return $a5c713cacfe9e4cd$export$a6ab2d8c92cb3c5d = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "button", function () { return $a5c713cacfe9e4cd$export$2ba01fb71ed41cb6; }, function (v) { return $a5c713cacfe9e4cd$export$2ba01fb71ed41cb6 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "popular", function () { return $a5c713cacfe9e4cd$export$cfb079464428d8c8; }, function (v) { return $a5c713cacfe9e4cd$export$cfb079464428d8c8 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "name", function () { return $a5c713cacfe9e4cd$export$a8ff84c12d48cfa6; }, function (v) { return $a5c713cacfe9e4cd$export$a8ff84c12d48cfa6 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "icon", function () { return $a5c713cacfe9e4cd$export$1ca1ec8b29a4ce27; }, function (v) { return $a5c713cacfe9e4cd$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "price", function () { return $a5c713cacfe9e4cd$export$321c0b1a406de31f; }, function (v) { return $a5c713cacfe9e4cd$export$321c0b1a406de31f = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "description", function () { return $a5c713cacfe9e4cd$export$6d59db4903f20f7d; }, function (v) { return $a5c713cacfe9e4cd$export$6d59db4903f20f7d = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "content", function () { return $a5c713cacfe9e4cd$export$a7db06668cad9adb; }, function (v) { return $a5c713cacfe9e4cd$export$a7db06668cad9adb = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "entry", function () { return $a5c713cacfe9e4cd$export$c407db72103fecfa; }, function (v) { return $a5c713cacfe9e4cd$export$c407db72103fecfa = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "title", function () { return $a5c713cacfe9e4cd$export$fb184b623420d9be; }, function (v) { return $a5c713cacfe9e4cd$export$fb184b623420d9be = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "boolTrue", function () { return $a5c713cacfe9e4cd$export$428ef1f8ddd66578; }, function (v) { return $a5c713cacfe9e4cd$export$428ef1f8ddd66578 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "boolFalse", function () { return $a5c713cacfe9e4cd$export$d4a36b86e0c64e34; }, function (v) { return $a5c713cacfe9e4cd$export$d4a36b86e0c64e34 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "icons", function () { return $a5c713cacfe9e4cd$export$df03f54e09e486fa; }, function (v) { return $a5c713cacfe9e4cd$export$df03f54e09e486fa = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "descIcon", function () { return $a5c713cacfe9e4cd$export$674d17a43c1246d4; }, function (v) { return $a5c713cacfe9e4cd$export$674d17a43c1246d4 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "shopify", function () { return $a5c713cacfe9e4cd$export$6da9acb12d5139d4; }, function (v) { return $a5c713cacfe9e4cd$export$6da9acb12d5139d4 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "wordpress", function () { return $a5c713cacfe9e4cd$export$97971ff30d8c30d2; }, function (v) { return $a5c713cacfe9e4cd$export$97971ff30d8c30d2 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "wix", function () { return $a5c713cacfe9e4cd$export$ad6718c788124d32; }, function (v) { return $a5c713cacfe9e4cd$export$ad6718c788124d32 = v; });
$parcel$export($a5c713cacfe9e4cd$exports, "prestashop", function () { return $a5c713cacfe9e4cd$export$7c5480d2d52b096a; }, function (v) { return $a5c713cacfe9e4cd$export$7c5480d2d52b096a = v; });
var $a5c713cacfe9e4cd$export$f88754492213681b;
var $a5c713cacfe9e4cd$export$d90250155de6d7e7;
var $a5c713cacfe9e4cd$export$a6ab2d8c92cb3c5d;
var $a5c713cacfe9e4cd$export$2ba01fb71ed41cb6;
var $a5c713cacfe9e4cd$export$cfb079464428d8c8;
var $a5c713cacfe9e4cd$export$a8ff84c12d48cfa6;
var $a5c713cacfe9e4cd$export$1ca1ec8b29a4ce27;
var $a5c713cacfe9e4cd$export$321c0b1a406de31f;
var $a5c713cacfe9e4cd$export$6d59db4903f20f7d;
var $a5c713cacfe9e4cd$export$a7db06668cad9adb;
var $a5c713cacfe9e4cd$export$c407db72103fecfa;
var $a5c713cacfe9e4cd$export$fb184b623420d9be;
var $a5c713cacfe9e4cd$export$428ef1f8ddd66578;
var $a5c713cacfe9e4cd$export$d4a36b86e0c64e34;
var $a5c713cacfe9e4cd$export$df03f54e09e486fa;
var $a5c713cacfe9e4cd$export$674d17a43c1246d4;
var $a5c713cacfe9e4cd$export$6da9acb12d5139d4;
var $a5c713cacfe9e4cd$export$97971ff30d8c30d2;
var $a5c713cacfe9e4cd$export$ad6718c788124d32;
var $a5c713cacfe9e4cd$export$7c5480d2d52b096a;
$a5c713cacfe9e4cd$export$f88754492213681b = "BPLDf";
$a5c713cacfe9e4cd$export$d90250155de6d7e7 = "zIpIj";
$a5c713cacfe9e4cd$export$a6ab2d8c92cb3c5d = "F3cWF";
$a5c713cacfe9e4cd$export$2ba01fb71ed41cb6 = "e-cZr";
$a5c713cacfe9e4cd$export$cfb079464428d8c8 = "Im-wb";
$a5c713cacfe9e4cd$export$a8ff84c12d48cfa6 = "b9DRx";
$a5c713cacfe9e4cd$export$1ca1ec8b29a4ce27 = "_4Civj";
$a5c713cacfe9e4cd$export$321c0b1a406de31f = "SGE-o";
$a5c713cacfe9e4cd$export$6d59db4903f20f7d = "_8Y2ih";
$a5c713cacfe9e4cd$export$a7db06668cad9adb = "xnqsg";
$a5c713cacfe9e4cd$export$c407db72103fecfa = "MJAmK";
$a5c713cacfe9e4cd$export$fb184b623420d9be = "wL7iu";
$a5c713cacfe9e4cd$export$428ef1f8ddd66578 = "_5X3ec";
$a5c713cacfe9e4cd$export$d4a36b86e0c64e34 = "uSbdC";
$a5c713cacfe9e4cd$export$df03f54e09e486fa = "DfTVs";
$a5c713cacfe9e4cd$export$674d17a43c1246d4 = "v7kgz";
$a5c713cacfe9e4cd$export$6da9acb12d5139d4 = "Pdld2";
$a5c713cacfe9e4cd$export$97971ff30d8c30d2 = "lCju1";
$a5c713cacfe9e4cd$export$ad6718c788124d32 = "X-IRC";
$a5c713cacfe9e4cd$export$7c5480d2d52b096a = "pcQvc";



var $wYO7b = parcelRequire("wYO7b");






var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $3a065ddb85a6837e$export$3b6d265609194a23;
$3a065ddb85a6837e$export$3b6d265609194a23 = "kVHSJ";


var $0cd76519469f43b0$export$e18e2f8e82cdc428 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(TooltipComponent, Component);
    function TooltipComponent(description, position) {
        (0, $3CDbU._)(this, TooltipComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, TooltipComponent);
        _this.type = "SPAN";
        _this.description = description;
        _this.position = position;
        //language=HTML
        _this.template = '\n            <span class="'.concat($3a065ddb85a6837e$export$3b6d265609194a23, '"><span>?</span></span>\n        ');
        return _this;
    }
    (0, $jyA4z._)(TooltipComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(TooltipComponent.prototype), "commit", this).call(this);
                if (!this.isNull()) //language=HTML
                this.setTooltip('\n                <div style="max-width: 300px;text-align: center;">\n                    '.concat(this.description, "\n                </div>\n            "), this.position);
            }
        }
    ]);
    return TooltipComponent;
}((0, $9gCL8.Component));


var $f14f816e6af75dce$export$abaa7eeb39abc6ba = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferTemplateComponent, Component);
    function OfferTemplateComponent(template, period, table) {
        (0, $3CDbU._)(this, OfferTemplateComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferTemplateComponent);
        _this.productTemplate = template;
        _this.period = period;
        _this.table = table;
        _this.bundle = template.bundles[0];
        //language=HTML
        _this.template = '\n            <div class="'.concat($a5c713cacfe9e4cd$exports.componentOfferTemplate, '">\n                ').concat((0, $befcde66434320e0$export$b6ed60a23ae88524).popularTemplates().includes(template.id) ? '<div class="'.concat($a5c713cacfe9e4cd$exports.popular, '">').concat((0, $wYO7b.Resources).t("words.popular"), "</div>") : "", '\n                <div class="').concat($a5c713cacfe9e4cd$exports.selectedCheck, '"></div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.name, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerName".concat(template.type)), '\n                </div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.icon, '">\n                    ').concat(_this.draw(new (0, $7fa5fdd391950487$export$e11200deb10216e7)(template.type)), '\n                </div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.price, '"></div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.description, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerDescription".concat(template.type)), '\n                </div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.button, '">\n                    ').concat((0, $wYO7b.Resources).t("words.choose"), " ").concat((0, $wYO7b.Resources).t("words.offerName".concat(template.type)), '\n                </div>\n                <div class="').concat($a5c713cacfe9e4cd$exports.content, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(OfferTemplateComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.priceContainer = this.el($a5c713cacfe9e4cd$exports.price);
                this.contentContainer = this.el($a5c713cacfe9e4cd$exports.content);
                this.button = this.el($a5c713cacfe9e4cd$exports.button);
                this.button.onClick(function() {
                    return _this.onPick();
                });
                this.table.forEach(function(tableLine) {
                    var entry = tableLine.entries.find(function(value) {
                        return value.templateId == _this.productTemplate.id;
                    });
                    var entryCase;
                    if (entry) {
                        switch(tableLine.type){
                            case "text":
                                //language=HTML
                                entryCase = _this.contentContainer.append('\n                            <div class="'.concat($a5c713cacfe9e4cd$exports.entry, '">\n                                <div class="').concat($a5c713cacfe9e4cd$exports.title, '">').concat(tableLine.name, "\n                                    ").concat(_this.contentContainer.draw(new (0, $0cd76519469f43b0$export$e18e2f8e82cdc428)(tableLine.description)), '\n                                </div>\n                                <div class="').concat($a5c713cacfe9e4cd$exports.description, '">').concat(entry.value, "</div>\n                            </div>\n                        "));
                                break;
                            case "bool":
                            case "textBool":
                                //language=HTML
                                entryCase = _this.contentContainer.append('\n                            <div class="'.concat($a5c713cacfe9e4cd$exports.entry, '">\n                                <div class="').concat($a5c713cacfe9e4cd$exports.title, '">\n                                    ').concat(entry.value ? '<div class="'.concat($a5c713cacfe9e4cd$exports.boolTrue, '"><div class="').concat($a5c713cacfe9e4cd$exports.icon, '"></div></div>') : '<div class="'.concat($a5c713cacfe9e4cd$exports.boolFalse, '"></div>'), "\n                                    ").concat(tableLine.name, "\n                                    ").concat(_this.contentContainer.draw(new (0, $0cd76519469f43b0$export$e18e2f8e82cdc428)(tableLine.description)), "\n                                </div>\n                            </div>\n                        "));
                                if (tableLine.type == "textBool" && entry.value) entryCase.append('<div class="'.concat($a5c713cacfe9e4cd$exports.description, '">').concat(entry.value, "</div>"));
                                break;
                        }
                        if (tableLine.icons) //language=HTML
                        entryCase.append('\n                        <div class="'.concat($a5c713cacfe9e4cd$exports.icons, '">\n                            ').concat(tableLine.icons.map(function(value) {
                            return '<div class="'.concat($a5c713cacfe9e4cd$exports.descIcon, " ").concat($a5c713cacfe9e4cd$exports[(0, $daa657d6ac7ca23b$export$6913bb0f068db6f0)[value].toLowerCase()], '"></div>');
                        }).join(""), "\n                        </div>\n                    "));
                    }
                });
                this.renderPrice();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferTemplateComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderPrice",
            value: function renderPrice() {
                var price = this.bundle.priceInitial / 100;
                if (this.period.periodType == (0, $e4a056b6b54a25c6$export$b7ac94010691eccd).ANNUAL) {
                    price = price * 12;
                    price = price - price * this.period.advantagePercentage;
                }
                this.priceContainer.clearAll();
                this.priceContainer.setHtml(this.productTemplate.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).FREE ? (0, $wYO7b.Resources).t("words.free") : "".concat(Math.round(price), "\u20AC <span>/").concat((0, $wYO7b.Resources).t("words.offerPeriodTitle".concat(this.period.periodType)), "</span>"));
            }
        },
        {
            key: "setPeriod",
            value: function setPeriod(period) {
                this.period = period;
                this.renderPrice();
            }
        },
        {
            key: "setSelected",
            value: function setSelected() {
                this.addClass($a5c713cacfe9e4cd$exports.selected);
            }
        },
        {
            key: "remSelected",
            value: function remSelected() {
                this.removeClass($a5c713cacfe9e4cd$exports.selected);
            }
        },
        {
            key: "onPick",
            value: function onPick() {}
        }
    ]);
    return OfferTemplateComponent;
}((0, $9gCL8.Component));


var $95faea5abea2326b$export$a0759ffb3acba2ce = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferGridComponent, Component);
    function OfferGridComponent(templates, period, selectedTemplateId) {
        (0, $3CDbU._)(this, OfferGridComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferGridComponent);
        _this.templates = templates;
        _this.period = period;
        _this.selectedTemplateId = selectedTemplateId;
        _this.table = (0, $befcde66434320e0$export$b6ed60a23ae88524).table(templates);
        _this.templatesComponents = [];
        //language=HTML
        _this.template = '\n            <div class="'.concat($c0be1573cc790493$exports.componentOfferGrid, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(OfferGridComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.renderTemplates();
                this.table.forEach(function(tableLine) {
                    return _this.renderLine(tableLine);
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferGridComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderTemplates",
            value: function renderTemplates() {
                var _this = this;
                //language=HTML
                var line = this.append('\n            <div class="'.concat($c0be1573cc790493$exports.line, '">\n                <div class="').concat($c0be1573cc790493$exports.entry, '"></div>\n            </div>'));
                this.templates.forEach(function(template) {
                    var templateComponent = new (0, $f14f816e6af75dce$export$abaa7eeb39abc6ba)(template, _this.period, _this.table);
                    templateComponent.onPick = function() {
                        _this.templatesComponents.forEach(function(value) {
                            return value.remSelected();
                        });
                        templateComponent.setSelected();
                        _this.onPick(template);
                    };
                    //language=HTML
                    line.append('\n                <div class="'.concat($c0be1573cc790493$exports.entry, '">\n                    ').concat(line.draw(templateComponent), "\n                </div>\n            "));
                    _this.templatesComponents.push(templateComponent);
                    if (template.id == _this.selectedTemplateId) templateComponent.setSelected();
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine(tableLine) {
                //language=HTML
                var line = this.append('\n            <div class="'.concat($c0be1573cc790493$exports.line, '"></div>'));
                //language=HTML
                var entryDescription = line.append('\n            <div class="'.concat($c0be1573cc790493$exports.entry, '">\n                <div class="').concat($c0be1573cc790493$exports.title, '">\n                    ').concat(tableLine.name, '\n                </div>\n                <div class="').concat($c0be1573cc790493$exports.description, '">\n                    ').concat(tableLine.description, "\n                </div>\n            </div>\n        "));
                if (tableLine.icons) //language=HTML
                entryDescription.append('\n                <div class="'.concat($c0be1573cc790493$exports.icons, '">\n                    ').concat(tableLine.icons.map(function(value) {
                    return '<div class="'.concat($c0be1573cc790493$exports.descIcon, " ").concat($c0be1573cc790493$exports[(0, $daa657d6ac7ca23b$export$6913bb0f068db6f0)[value].toLowerCase()], '"></div>');
                }).join(""), "\n                </div>\n            "));
                tableLine.entries.forEach(function(tableLineEntry) {
                    switch(tableLine.type){
                        case "text":
                            //language=HTML
                            line.append('\n                        <div class="'.concat($c0be1573cc790493$exports.entry, '">\n                            <div class="').concat($c0be1573cc790493$exports.value, '">\n                                ').concat(tableLineEntry.value, "\n                            </div>\n                        </div>\n                    "));
                            break;
                        case "bool":
                            //language=HTML
                            line.append('\n                        <div class="'.concat($c0be1573cc790493$exports.entry, '">\n                            ').concat(tableLineEntry.value ? '<div class="'.concat($c0be1573cc790493$exports.boolTrue, '"><div class="').concat($c0be1573cc790493$exports.icon, '"></div></div>') : '<div class="'.concat($c0be1573cc790493$exports.boolFalse, '"></div>'), "\n                        </div>\n                    "));
                            break;
                        case "textBool":
                            //language=HTML
                            line.append('\n                        <div class="'.concat($c0be1573cc790493$exports.entry, '">\n                            ').concat(tableLineEntry.value ? '<div class="'.concat($c0be1573cc790493$exports.boolTrue, '"><div class="').concat($c0be1573cc790493$exports.icon, '"></div></div>') : '<div class="'.concat($c0be1573cc790493$exports.boolFalse, '"></div>'), "\n                            ").concat(tableLineEntry.value ? '<div class="'.concat($c0be1573cc790493$exports.description, '">').concat(tableLineEntry.value, "</div>") : "", "\n                        </div>\n                    "));
                            break;
                    }
                });
            }
        },
        {
            key: "setPeriod",
            value: function setPeriod(period) {
                this.templatesComponents.forEach(function(value) {
                    return value.setPeriod(period);
                });
            }
        },
        {
            key: "onPick",
            value: function onPick(template) {}
        }
    ]);
    return OfferGridComponent;
}((0, $9gCL8.Component));



var $eQCFs = parcelRequire("eQCFs");
var $a587bf5cffbf7150$export$b39970eebb991951 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferComponent, Component);
    function OfferComponent(productType, details, website) {
        (0, $3CDbU._)(this, OfferComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferComponent), _this.solutionsComponents = [];
        _this.details = details;
        _this.productType = productType;
        _this.website = website;
        //language=HTML
        _this.template = '\n            <div class="'.concat($c2bd1b702a3d9ea1$export$77181601c038f22b, " ").concat(_this.website ? $c2bd1b702a3d9ea1$export$61f6990d5944375a : $c2bd1b702a3d9ea1$export$96e4b36520c26a2c, '">\n                <div class="').concat($c2bd1b702a3d9ea1$export$f4c5de44377d2946, '">\n                    ').concat(_this.draw(new (0, $918e9676245a49d6$export$71a85bce14e8f1c5)(true)), "\n                </div>\n            </div>");
        return _this;
    }
    (0, $jyA4z._)(OfferComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferComponent.prototype), "commit", this).call(this);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferComponent.prototype), "scrollable", this).call(this);
                this.renderAll(this.details);
            }
        },
        {
            key: "renderAll",
            value: function renderAll(details) {
                var _this = this;
                var _this1 = this, _superprop_get_scrollable = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferComponent.prototype), "scrollable", _this);
                };
                return (0, $hWZw8._)(function() {
                    var _this_activeOffer;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this1.website) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.renderAllTemplates()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 2:
                                if (!details) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this1.renderQuote(details)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 4:
                                return [
                                    4,
                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).quote(_this1)
                                ];
                            case 5:
                                details = _state.sent();
                                if (!details) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this1.renderQuote(details)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 7:
                                return [
                                    4,
                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).active(false, _this1)
                                ];
                            case 8:
                                _this1.activeOffer = _state.sent();
                                _this1.activeOfferProduct = (_this_activeOffer = _this1.activeOffer) === null || _this_activeOffer === void 0 ? void 0 : _this_activeOffer.offer.products[_this1.productType];
                                return [
                                    4,
                                    _this1.renderAllTemplates()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                _superprop_get_scrollable().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renderAllTemplates",
            value: function renderAllTemplates() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $58c1bfefd78b8329$export$a047eb6606b2561b).findAll(_this)
                                ];
                            case 1:
                                _this.templates = _state.sent();
                                _this.clearAll();
                                _this.renderTop();
                                _this.renderTopPeriod();
                                _this.renderTemplatesContainer();
                                _this.renderSolutionsContainer();
                                _this.renderContentContainer();
                                _this.renderPriceContainer();
                                _this.renderBottomAll();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renderBottomAll",
            value: function renderBottomAll() {
                this.solutionsContainer.clearAll();
                var solutions = this.el($c2bd1b702a3d9ea1$export$e29b1f3b2b6a7669);
                solutions.displayHide();
                if (this.selectedTemplate.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).PREMIUM) {
                    solutions.displayShow();
                    this.renderSolutions();
                }
                this.renderContent();
                this.renderPrice();
            }
        },
        {
            key: "renderTop",
            value: function renderTop() {
                this.clearAll();
                //language=HTML
                this.append('\n            <div class="'.concat($c2bd1b702a3d9ea1$export$1e95b668f3b82d, '">\n                <div class="').concat($c2bd1b702a3d9ea1$export$96ff94e0adb1d772, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerDescription".concat(this.productType)), '\n                </div>\n                <div class="').concat($c2bd1b702a3d9ea1$export$da0c8716dc13cd97, '"></div>\n                <div class="').concat($c2bd1b702a3d9ea1$export$40e52e4cb633d77a, '">\n                </div>\n            </div>\n        '));
                this.periodContainer = this.el($c2bd1b702a3d9ea1$export$da0c8716dc13cd97);
                this.advantageContainer = this.el($c2bd1b702a3d9ea1$export$40e52e4cb633d77a);
            }
        },
        {
            key: "renderTopPeriod",
            value: function renderTopPeriod() {
                var _this = this;
                this.period = this.templates.periods[0];
                if (this.activeOffer) this.period = this.templates.periods.find(function(value) {
                    return value.periodType == _this.activeOffer.offer.periodType;
                });
                this.periodContainer.clearAll();
                var periodPicker = new (0, $3accc8c4adbafd86$export$8f6adf886c3e91d5)(this.templates.periods);
                this.periodContainer.render(periodPicker);
                periodPicker.select(this.period.periodType + "", true);
                periodPicker.onSelect = function(value) {
                    _this.period = _this.templates.periods.find(function(period) {
                        return period.periodType == value;
                    });
                    _this.renderTopPeriodAdvantage(_this.period.periodType);
                    _this.setPeriod(_this.period);
                    _this.renderPrice();
                };
                this.renderTopPeriodAdvantage(this.period.periodType);
            }
        },
        {
            key: "renderTopPeriodAdvantage",
            value: function renderTopPeriodAdvantage(periodType) {
                var period = this.templates.periods.find(function(value) {
                    return value.periodType == periodType;
                });
                this.advantageContainer.setText((0, $wYO7b.Resources).r("words.offerAdvantage", {
                    advantage: period.advantagePercentage * 100
                }));
                if (periodType != (0, $e4a056b6b54a25c6$export$b7ac94010691eccd).MONTHLY) this.advantageContainer.show();
                else this.advantageContainer.hide();
            }
        },
        {
            key: "renderTemplatesContainer",
            value: function renderTemplatesContainer() {
                var _this = this;
                //language=HTML
                this.templatesContainer = this.append('\n            <div class="'.concat($c2bd1b702a3d9ea1$export$a8fc3402335b0b04, '"></div>'));
                var templates = this.templates.templates[this.productType].filter(function(value) {
                    return value.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).PREMIUM;
                }).sort(function(a, b) {
                    return a.order < b.order ? 1 : -1;
                }).reverse();
                this.selectedTemplate = templates.find(function(value) {
                    return value.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).PREMIUM;
                });
                if (this.activeOffer) this.selectedTemplate = this.activeOfferProduct.template;
                this.gridComponent = new (0, $95faea5abea2326b$export$a0759ffb3acba2ce)(templates, this.period, this.selectedTemplate.id);
                this.gridComponent.onPick = function(template) {
                    _this.selectedTemplate = template;
                    _this.renderBottomAll();
                    _this.contentContainer.scrollTo((0, $eQCFs.SedestralInterface).html, -250);
                };
                this.templatesContainer.render(this.gridComponent);
            }
        },
        {
            key: "renderSolutionsContainer",
            value: function renderSolutionsContainer() {
                //language=HTML
                this.solutionsSection = this.append('\n            <div class="'.concat($c2bd1b702a3d9ea1$export$e29b1f3b2b6a7669, '">\n                <div class="').concat($c2bd1b702a3d9ea1$export$fb184b623420d9be, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerSolutions"), '\n                </div>\n                <div class="').concat($c2bd1b702a3d9ea1$export$6b8103ff35a0f6fe, '"></div>\n            </div>\n        '));
                this.solutionsContainer = this.el($c2bd1b702a3d9ea1$export$6b8103ff35a0f6fe);
            }
        },
        {
            key: "renderSolutions",
            value: function renderSolutions() {
                var _this = this;
                var bundle = this.selectedTemplate.bundles[0];
                var totalGranularity = bundle.solutions.reduce(function(sum, value) {
                    return sum + value.granularity;
                }, 0);
                if (totalGranularity > 0) {
                    this.solutionsComponents = [];
                    bundle.solutions.forEach(function(solution) {
                        if (solution.granularity > 0) {
                            var solutionComponent = new (0, $0a2a8b1178ca7d67$export$3629cf1b14c0cc2b)(bundle, solution);
                            solutionComponent.onSolutionChange = function(count) {
                                _this.solutionsComponents.forEach(function(value) {
                                    return value.setGranularity(count);
                                });
                                _this.renderContent();
                                _this.renderPrice();
                            };
                            //language=HTML
                            if (!(0, $befcde66434320e0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type)) _this.solutionsContainer.append('\n                                <div class="'.concat($c2bd1b702a3d9ea1$export$333eed13d25bd57, '">\n                                    ').concat(_this.solutionsContainer.draw(solutionComponent), "\n                                </div>\n                            "));
                            _this.solutionsComponents.push(solutionComponent);
                            if (_this.activeOfferProduct) {
                                var activeBundle = _this.activeOfferProduct.bundles.find(function(value) {
                                    return value.solutions.find(function(value1) {
                                        return value1.type == solution.type;
                                    }) != undefined;
                                });
                                if (activeBundle && (!bundle.maxOption || activeBundle.quantityOption <= bundle.maxOption)) {
                                    if (_this.activeOfferProduct.template.type == _this.selectedTemplate.type) solutionComponent.setGranularity(activeBundle.quantityOption);
                                }
                            }
                        }
                    });
                    this.solutionsSection.removeClass($c2bd1b702a3d9ea1$export$c99df9cf5e6bee9b);
                } else this.solutionsSection.addClass($c2bd1b702a3d9ea1$export$c99df9cf5e6bee9b);
            }
        },
        {
            key: "renderContentContainer",
            value: function renderContentContainer() {
                this.contentContainer = this.append('<div class="'.concat($c2bd1b702a3d9ea1$export$a7db06668cad9adb, '"></div>'));
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var _this = this;
                var bundle = this.selectedTemplate.bundles[0];
                var contents = bundle.solutions.filter(function(solution) {
                    return !(0, $befcde66434320e0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type);
                }).map(function(solution) {
                    var solutionComponent = _this.solutionsComponents.find(function(value) {
                        return value.solution == solution;
                    });
                    var quantity = solution.quantityInitial;
                    if (solutionComponent) quantity += solutionComponent.solutionCount() * solution.granularity;
                    return "".concat(quantity, " ").concat((0, $wYO7b.Resources).t("words.offerSolution".concat(_this.selectedTemplate.type).concat(_this.selectedTemplate.productType).concat(solution.type)));
                });
                this.contentContainer.clearAll();
                this.contentContainer.render(new (0, $5e3ee4c72bc0588f$export$48a3aac3632ef8)((0, $befcde66434320e0$export$b6ed60a23ae88524).contents(contents, this.selectedTemplate), (0, $wYO7b.Resources).t("words.offerContentRecap")));
            }
        },
        {
            key: "renderPriceContainer",
            value: function renderPriceContainer() {
                this.priceContainer = this.append('<div class="'.concat($c2bd1b702a3d9ea1$export$321c0b1a406de31f, '"></div>'));
            }
        },
        {
            key: "renderPrice",
            value: function renderPrice() {
                if (this.selectedTemplate.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).FREE) this.priceContainer.hide();
                else {
                    this.priceContainer.show();
                    var bundle = this.selectedTemplate.bundles[0];
                    var price = bundle.priceInitial;
                    if (this.solutionsComponents.length > 0) price += this.solutionsComponents[0].solutionCount() * bundle.priceOption;
                    this.priceContainer.clearAll();
                    var priceComponent = new (0, $bf3d11141e19674b$export$19746147d1b55543)({
                        period: this.period,
                        price: price,
                        text: this.activeOffer ? (0, $wYO7b.Resources).t("words.offerEdit") : (0, $wYO7b.Resources).t("words.getStarted")
                    });
                    var _this = this;
                    priceComponent.onGetStarted = /*#__PURE__*/ (0, $hWZw8._)(function() {
                        var product, quote;
                        return (0, $eJDpD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!_this.website) return [
                                        3,
                                        1
                                    ];
                                    (0, $3Qm5T.Network).router.pages.redirect((0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), true);
                                    return [
                                        3,
                                        5
                                    ];
                                case 1:
                                    priceComponent.setLoading();
                                    product = {
                                        templateId: _this.selectedTemplate.id,
                                        bundlesQuantity: [
                                            _this.solutionsComponents.length > 0 ? _this.solutionsComponents[0].solutionCount() : 0
                                        ]
                                    };
                                    return [
                                        4,
                                        (0, $58c1bfefd78b8329$export$a047eb6606b2561b).quoteSubscription({
                                            paymentPeriod: _this.period.periodType,
                                            products: [
                                                product
                                            ]
                                        }, priceComponent)
                                    ];
                                case 2:
                                    quote = _state.sent();
                                    if (!quote) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        _this.renderQuote(quote)
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    priceComponent.remLoading();
                                    _state.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    this.priceContainer.render(priceComponent);
                }
            }
        },
        {
            key: "renderQuote",
            value: function renderQuote(quote) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var quoteComponent;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        if (quote.offer.state == (0, $c0453c00fb30c134$export$d4c083ce95fb2409).PAYMENT && quote.url) {
                            location.href = quote.url;
                            return [
                                2
                            ];
                        }
                        if (quote.error) (0, $3Qm5T.Network).router["static"].components.notifications.notify((0, $wYO7b.Resources).t("words.errorMessage"), undefined, 3000, "error");
                        _this.clearAll();
                        switch(quote.offer.state){
                            case (0, $c0453c00fb30c134$export$d4c083ce95fb2409).CONFIRMED:
                                quoteComponent = new (0, $06b56c5a6cff27f5$export$958f4fee317b0b7c)(_this.productType, quote);
                                break;
                            case (0, $c0453c00fb30c134$export$d4c083ce95fb2409).PAYMENT:
                            case (0, $c0453c00fb30c134$export$d4c083ce95fb2409).FAILURE_TO_PAY:
                            case (0, $c0453c00fb30c134$export$d4c083ce95fb2409).SUSPENDED:
                                quoteComponent = new (0, $06b56c5a6cff27f5$export$958f4fee317b0b7c)(_this.productType, quote);
                                quoteComponent = new (0, $d84b946eb25fa51a$export$97cdf95035444dd8)(_this.productType, quote);
                                break;
                            case (0, $c0453c00fb30c134$export$d4c083ce95fb2409).SCHEDULED:
                                quoteComponent = new (0, $5b7b12c130e99677$export$18390818359c51b8)(_this.productType, quote);
                                break;
                        }
                        quoteComponent.onStep = function(details) {
                            return _this.renderAll(details);
                        };
                        quoteComponent.onCloseModal = function() {
                            return _this.onCloseModal();
                        };
                        _this.render(quoteComponent);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setPeriod",
            value: function setPeriod(period) {
                this.gridComponent.setPeriod(period);
            }
        },
        {
            key: "onCloseModal",
            value: function onCloseModal() {}
        }
    ]);
    return OfferComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $fd89a7af4beb2b9e$export$6191bb88e92acd1c = /*#__PURE__*/ function(VisualModalComponent) {
    "use strict";
    (0, $jCmGC._)(OfferModalComponent, VisualModalComponent);
    function OfferModalComponent(productType, details) {
        (0, $3CDbU._)(this, OfferModalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferModalComponent);
        _this.productType = productType;
        _this.modalStyle = "width:1160px;height: 93%;";
        //language=HTML
        _this.name = (0, $wYO7b.Resources).t("words.offerPricing");
        var component = new (0, $a587bf5cffbf7150$export$b39970eebb991951)(_this.productType, details);
        component.onCloseModal = function() {
            return _this.close();
        };
        _this.modalTemplate = _this.draw(component);
        return _this;
    }
    (0, $jyA4z._)(OfferModalComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferModalComponent.prototype), "commit", this).call(this);
                this.headContainer.setStyle("border-bottom: 1px solid var(--grey-sur);height: 44px;");
                this.contentContainer.setStyle("height: calc(100% - 25px);");
            }
        }
    ]);
    return OfferModalComponent;
}((0, $4c1003e9348fedb7$export$2a517e1cac1c1f85));



var $lThic = parcelRequire("lThic");


var $wYO7b = parcelRequire("wYO7b");
var $ad3130453e2e37df$export$6d0692ff2663f9ce = /*#__PURE__*/ function(PageComponent) {
    "use strict";
    (0, $jCmGC._)(PanelPageComponent, PageComponent);
    function PanelPageComponent() {
        (0, $3CDbU._)(this, PanelPageComponent);
        return (0, $ep9cZ._)(this, PanelPageComponent, arguments);
    }
    (0, $jyA4z._)(PanelPageComponent, [
        {
            key: "renderNoneSite",
            value: function renderNoneSite(permissions) {
                this.template = this.draw(new (0, $cb12b50ec3c8ac26$export$9635fd1ed971cc0d)(permissions));
            }
        },
        {
            key: "renderNoneRole",
            value: function renderNoneRole() {
                this.template = this.draw(new (0, $c88925025e665ec6$export$a6f6f1cb6d6f034e)());
            }
        },
        {
            key: "renderOffer",
            value: function renderOffer(productType) {
                var offerProduct = (0, $lThic.EntityService).activeOfferProducts[productType];
                if (!offerProduct || offerProduct.level == (0, $2105f4e2b30e22f8$export$361763241a2a268d).FREE) {
                    //language=HTML
                    var offerContainer = this.prepend('\n                <div class="'.concat($5f100fba5d069eaa$export$4caf129a4f120781, '">\n                    <div class="').concat($5f100fba5d069eaa$export$eabcd2c8791e7bf4, '">\n                        <div class="').concat($5f100fba5d069eaa$export$acf4eaf431084f78, '">\n                            ').concat(this.draw(new (0, $7fa5fdd391950487$export$e11200deb10216e7)(offerProduct.template.type)), '\n                        </div>\n                        <div class="').concat($5f100fba5d069eaa$export$a8ff84c12d48cfa6, '">\n                            ').concat((0, $wYO7b.Resources).t("words.offerFree"), '\n                        </div>\n                        <div class="').concat($5f100fba5d069eaa$export$321c0b1a406de31f, '">\n                            ').concat((0, $wYO7b.Resources).t("words.free"), '\n                        </div>\n                    </div>\n                    <div class="').concat($5f100fba5d069eaa$export$79ffe56a765070d2, '">\n                        <div class="').concat($5f100fba5d069eaa$export$6f093cfa640b7166, '">\n                            ').concat((0, $wYO7b.Resources).t("words.offerSubText"), '\n                        </div>\n                        <div class="').concat($5f100fba5d069eaa$export$2ba01fb71ed41cb6, '">\n                            ').concat((0, $wYO7b.Resources).t("words.offerViewOffers"), "\n                        </div>\n                    </div>\n                </div>\n            "));
                    offerContainer.onClick(function() {
                        var modal = new (0, $fd89a7af4beb2b9e$export$6191bb88e92acd1c)(productType);
                        modal.screenRender();
                    });
                    this.el($5f100fba5d069eaa$export$a7db06668cad9adb).addClass($5f100fba5d069eaa$export$13e2de3c33d99539);
                }
            }
        }
    ]);
    return PanelPageComponent;
}((0, $cfc75e76a9120279$export$c4dc9eeb28e63095));


var $e52e2ad4a7d03c16$export$31641b61980e511f = /*#__PURE__*/ function(PanelPageComponent) {
    "use strict";
    (0, $jCmGC._)(NotFoundPage, PanelPageComponent);
    function NotFoundPage() {
        (0, $3CDbU._)(this, NotFoundPage);
        var _this;
        _this = (0, $ep9cZ._)(this, NotFoundPage);
        _this.title = (0, $wYO7b.Resources).t("words.notFound");
        _this.status.online = false;
        return _this;
    }
    (0, $jyA4z._)(NotFoundPage, [
        {
            key: "init",
            value: function init() {
                //language=HTML
                this.template = '\n            <div class="'.concat($f5b52fec49df89c4$export$d160ab07b491fe06, '">\n                <div class="').concat($f5b52fec49df89c4$export$e9396702b45dbab1, '">\n                    <div class="').concat($f5b52fec49df89c4$export$6f093cfa640b7166, '">\n                        <div class="').concat($f5b52fec49df89c4$export$bd0dc469391eee2c, '">\n                            404\n                        </div>\n                        <div class="').concat($f5b52fec49df89c4$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.youLandedInTheWrongPlace"), '\n                        </div>\n                        <div class="').concat($f5b52fec49df89c4$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.theRequestedPageDoesNotExistOrHasBeenRemoved"), '\n                        </div>\n                    </div>\n                </div>\n\n                <div class="').concat($f5b52fec49df89c4$export$14439f5cc10d722f, '">\n                    <div class="').concat($f5b52fec49df89c4$export$1ca1ec8b29a4ce27, '"></div>\n                </div>\n            </div>\n        ');
            }
        },
        {
            key: "onHash",
            value: function onHash() {
                console.log("on hash");
            }
        },
        {
            key: "remove",
            value: function remove() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(NotFoundPage.prototype), "remove", this).call(this);
            }
        }
    ]);
    return NotFoundPage;
}((0, $ad3130453e2e37df$export$6d0692ff2663f9ce));



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $9ca8b79bf300b415$export$383cb4a7b52cc636 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(StaticComponent, Component);
    function StaticComponent() {
        (0, $3CDbU._)(this, StaticComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, StaticComponent);
        _this.template = "<div>static</div>";
        return _this;
    }
    (0, $jyA4z._)(StaticComponent, [
        {
            // @ts-ignore
            key: "init",
            value: function init() {
                this.commit();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return StaticComponent;
}((0, $9gCL8.Component));


var $08238b120245f836$export$854fe5f7a33d16c2 = /*#__PURE__*/ function(StaticComponent) {
    "use strict";
    (0, $jCmGC._)(LoaderStatic, StaticComponent);
    function LoaderStatic() {
        (0, $3CDbU._)(this, LoaderStatic);
        var _this;
        _this = (0, $ep9cZ._)(this, LoaderStatic);
        _this.element = document.querySelector('.globalLoaderBackground:not([globalBg])');
        return _this;
    }
    (0, $jyA4z._)(LoaderStatic, [
        {
            key: "displayShow",
            value: function displayShow() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(LoaderStatic.prototype), "displayShow", this).call(this);
                this.setStyle("display:flex;opacity:1;");
            }
        },
        {
            key: "displayHide",
            value: function displayHide() {
                var _this = this;
                var _this1 = this, _superprop_get_fade = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(LoaderStatic.prototype), "fade", _this);
                }, _superprop_get_displayHide = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(LoaderStatic.prototype), "displayHide", _this);
                };
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_fade().call(_this1, "out", 200)
                                ];
                            case 1:
                                _state.sent();
                                _superprop_get_displayHide().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return LoaderStatic;
}((0, $9ca8b79bf300b415$export$383cb4a7b52cc636));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");
var $329be264cf508f4d$export$2cb412c852497e7f;
var $329be264cf508f4d$export$5fd5031fecdacec3;
var $329be264cf508f4d$export$a7db06668cad9adb;
var $329be264cf508f4d$export$fd59df041b888442;
var $329be264cf508f4d$export$34e0f9847d4c02dd;
var $329be264cf508f4d$export$ac96a2a951168044;
$329be264cf508f4d$export$2cb412c852497e7f = "kqQNp";
$329be264cf508f4d$export$5fd5031fecdacec3 = "_4sSGO";
$329be264cf508f4d$export$a7db06668cad9adb = "FiFOA";
$329be264cf508f4d$export$fd59df041b888442 = "TmGHb";
$329be264cf508f4d$export$34e0f9847d4c02dd = "i-x9E";
$329be264cf508f4d$export$ac96a2a951168044 = "N27Hn";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $1bdb3dfba03d3af1$export$9914389b95e1a1e8;
var $1bdb3dfba03d3af1$export$5ae74841c1c22479;
var $1bdb3dfba03d3af1$export$300b2c23f49a49cb;
var $1bdb3dfba03d3af1$export$60974f670aa8d75e;
var $1bdb3dfba03d3af1$export$364bb6944bd5af75;
var $1bdb3dfba03d3af1$export$a1fe6a2d7788354f;
var $1bdb3dfba03d3af1$export$db3c28d99448dcff;
var $1bdb3dfba03d3af1$export$fb184b623420d9be;
var $1bdb3dfba03d3af1$export$3931a0da49df8dc0;
var $1bdb3dfba03d3af1$export$e850e66917a23e0f;
var $1bdb3dfba03d3af1$export$b6aad051bad07f12;
var $1bdb3dfba03d3af1$export$1f96ae73734a86cc;
var $1bdb3dfba03d3af1$export$ee3212a4833dc722;
var $1bdb3dfba03d3af1$export$6b501c78a3684162;
var $1bdb3dfba03d3af1$export$7200a869094fec36;
var $1bdb3dfba03d3af1$export$1ca1ec8b29a4ce27;
var $1bdb3dfba03d3af1$export$6e0e6ce39e5a0361;
var $1bdb3dfba03d3af1$export$3e523c77c1f23f8c;
var $1bdb3dfba03d3af1$export$698bf39bb1e7111e;
var $1bdb3dfba03d3af1$export$ee1491bbb87d4653;
var $1bdb3dfba03d3af1$export$3ce6949f20cea765;
var $1bdb3dfba03d3af1$export$60912654947077e3;
var $1bdb3dfba03d3af1$export$1c4e7a9c31a6c071;
var $1bdb3dfba03d3af1$export$84eb487870768d99;
$1bdb3dfba03d3af1$export$9914389b95e1a1e8 = "TLoVY";
$1bdb3dfba03d3af1$export$5ae74841c1c22479 = "uqQxU";
$1bdb3dfba03d3af1$export$300b2c23f49a49cb = "wSkkj";
$1bdb3dfba03d3af1$export$60974f670aa8d75e = "_2xlwj";
$1bdb3dfba03d3af1$export$364bb6944bd5af75 = "Sy5qQ";
$1bdb3dfba03d3af1$export$a1fe6a2d7788354f = "aOE6F";
$1bdb3dfba03d3af1$export$db3c28d99448dcff = "Uwz-A";
$1bdb3dfba03d3af1$export$fb184b623420d9be = "rjiEX";
$1bdb3dfba03d3af1$export$3931a0da49df8dc0 = "Nqs87";
$1bdb3dfba03d3af1$export$e850e66917a23e0f = "klTSr";
$1bdb3dfba03d3af1$export$b6aad051bad07f12 = "Wo25U";
$1bdb3dfba03d3af1$export$1f96ae73734a86cc = "inlHz";
$1bdb3dfba03d3af1$export$ee3212a4833dc722 = "J5FLr";
$1bdb3dfba03d3af1$export$6b501c78a3684162 = "pnoj8";
$1bdb3dfba03d3af1$export$7200a869094fec36 = "qMXh2";
$1bdb3dfba03d3af1$export$1ca1ec8b29a4ce27 = "K6Unu";
$1bdb3dfba03d3af1$export$6e0e6ce39e5a0361 = "DjTdk";
$1bdb3dfba03d3af1$export$3e523c77c1f23f8c = "rKzrE";
$1bdb3dfba03d3af1$export$698bf39bb1e7111e = "qMxK1";
$1bdb3dfba03d3af1$export$ee1491bbb87d4653 = "s32-s";
$1bdb3dfba03d3af1$export$3ce6949f20cea765 = "_64JCz";
$1bdb3dfba03d3af1$export$60912654947077e3 = "mY5-A";
$1bdb3dfba03d3af1$export$1c4e7a9c31a6c071 = "g-zA1";
$1bdb3dfba03d3af1$export$84eb487870768d99 = "itSsE";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");
var $b973c1c4b9e07ee9$export$ebcd94e5d6026061;
var $b973c1c4b9e07ee9$export$bbea856fdb3e3c5f;
var $b973c1c4b9e07ee9$export$b3571188c770cc5a;
var $b973c1c4b9e07ee9$export$596d806903d1f59e;
var $b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27;
var $b973c1c4b9e07ee9$export$a7db06668cad9adb;
var $b973c1c4b9e07ee9$export$4e0c71f277ca26b3;
var $b973c1c4b9e07ee9$export$3ce6949f20cea765;
var $b973c1c4b9e07ee9$export$f2120bbfa5450bd2;
var $b973c1c4b9e07ee9$export$fb184b623420d9be;
var $b973c1c4b9e07ee9$export$3931a0da49df8dc0;
var $b973c1c4b9e07ee9$export$e850e66917a23e0f;
var $b973c1c4b9e07ee9$export$9c1acc30f900961c;
var $b973c1c4b9e07ee9$export$17a8a1cb950cf89a;
var $b973c1c4b9e07ee9$export$b602b78110e4ab1e;
var $b973c1c4b9e07ee9$export$9ebee87b1eb4e24e;
var $b973c1c4b9e07ee9$export$b4925ff091c7f556;
var $b973c1c4b9e07ee9$export$7f1a29bc3be2296e;
var $b973c1c4b9e07ee9$export$ac5985f28ad46107;
var $b973c1c4b9e07ee9$export$351f93dff0fc1e76;
var $b973c1c4b9e07ee9$export$e4c89085febbc618;
var $b973c1c4b9e07ee9$export$f38c853ae54ed474;
var $b973c1c4b9e07ee9$export$7dc4b9367473a505;
var $b973c1c4b9e07ee9$export$5d910be2177c3c87;
var $b973c1c4b9e07ee9$export$ad6718c788124d32;
var $b973c1c4b9e07ee9$export$7c5480d2d52b096a;
var $b973c1c4b9e07ee9$export$97971ff30d8c30d2;
var $b973c1c4b9e07ee9$export$6da9acb12d5139d4;
var $b973c1c4b9e07ee9$export$29f9f81de5c56283;
var $b973c1c4b9e07ee9$export$959d3058f2a8f3e9;
var $b973c1c4b9e07ee9$export$6d59db4903f20f7d;
$b973c1c4b9e07ee9$export$ebcd94e5d6026061 = "-Vlt9";
$b973c1c4b9e07ee9$export$bbea856fdb3e3c5f = "dDQun";
$b973c1c4b9e07ee9$export$b3571188c770cc5a = "_0yX-y";
$b973c1c4b9e07ee9$export$596d806903d1f59e = "a-IcG";
$b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27 = "ayL-M";
$b973c1c4b9e07ee9$export$a7db06668cad9adb = "vMrem";
$b973c1c4b9e07ee9$export$4e0c71f277ca26b3 = "LGn2t";
$b973c1c4b9e07ee9$export$3ce6949f20cea765 = "_03B5h";
$b973c1c4b9e07ee9$export$f2120bbfa5450bd2 = "v-2x3";
$b973c1c4b9e07ee9$export$fb184b623420d9be = "qZxXS";
$b973c1c4b9e07ee9$export$3931a0da49df8dc0 = "duq5w";
$b973c1c4b9e07ee9$export$e850e66917a23e0f = "etszA";
$b973c1c4b9e07ee9$export$9c1acc30f900961c = "Pt3yQ";
$b973c1c4b9e07ee9$export$17a8a1cb950cf89a = "_8G-OD";
$b973c1c4b9e07ee9$export$b602b78110e4ab1e = "Zmwiz";
$b973c1c4b9e07ee9$export$9ebee87b1eb4e24e = "VnbOJ";
$b973c1c4b9e07ee9$export$b4925ff091c7f556 = "mdOXG";
$b973c1c4b9e07ee9$export$7f1a29bc3be2296e = "VjRw1";
$b973c1c4b9e07ee9$export$ac5985f28ad46107 = "UhgYq";
$b973c1c4b9e07ee9$export$351f93dff0fc1e76 = "A-gTE";
$b973c1c4b9e07ee9$export$e4c89085febbc618 = "q9ze4";
$b973c1c4b9e07ee9$export$f38c853ae54ed474 = "VawEX";
$b973c1c4b9e07ee9$export$7dc4b9367473a505 = "ZPA1J";
$b973c1c4b9e07ee9$export$5d910be2177c3c87 = "OzNbr";
$b973c1c4b9e07ee9$export$ad6718c788124d32 = "_9PHzi";
$b973c1c4b9e07ee9$export$7c5480d2d52b096a = "J1akp";
$b973c1c4b9e07ee9$export$97971ff30d8c30d2 = "Vpy-G";
$b973c1c4b9e07ee9$export$6da9acb12d5139d4 = "DNoVU";
$b973c1c4b9e07ee9$export$29f9f81de5c56283 = "N5Eu3";
$b973c1c4b9e07ee9$export$959d3058f2a8f3e9 = "y4A12";
$b973c1c4b9e07ee9$export$6d59db4903f20f7d = "_7ztef";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $011f72d0b4b8452c$export$b02585722e8afc63 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentComponent, Component);
    function WebsiteHeadSubmenuContentComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentComponent);
        return (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentComponent, arguments);
    }
    (0, $jyA4z._)(WebsiteHeadSubmenuContentComponent, [
        {
            key: "openColumn",
            value: function openColumn(column) {
                column.el($b973c1c4b9e07ee9$export$3931a0da49df8dc0).displayFlex();
                column.addClass($b973c1c4b9e07ee9$export$3ce6949f20cea765);
            }
        },
        {
            key: "closeColumn",
            value: function closeColumn(column) {
                column.el($b973c1c4b9e07ee9$export$3931a0da49df8dc0).displayHide();
                column.removeClass($b973c1c4b9e07ee9$export$3ce6949f20cea765);
            }
        }
    ]);
    return WebsiteHeadSubmenuContentComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");

var $3Qm5T = parcelRequire("3Qm5T");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");


var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");


var $abV4P = parcelRequire("abV4P");
var $9c59cd6979ae2748$export$a51cf35744924ee2 = /*#__PURE__*/ function(WebsiteHeadSubmenuContentComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentProductsComponent, WebsiteHeadSubmenuContentComponent);
    function WebsiteHeadSubmenuContentProductsComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentProductsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentProductsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($b973c1c4b9e07ee9$export$ebcd94e5d6026061, '">\n                <div class="').concat($b973c1c4b9e07ee9$export$4e0c71f277ca26b3, " ").concat($b973c1c4b9e07ee9$export$3ce6949f20cea765, '">\n                    <div class="').concat($b973c1c4b9e07ee9$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.tools"), '\n                        <div class="').concat($b973c1c4b9e07ee9$export$f2120bbfa5450bd2, '"></div>\n                    </div>\n                    <div class="').concat($b973c1c4b9e07ee9$export$3931a0da49df8dc0, '">\n                        <a style="display: none;" itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('ai'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$7dc4b9367473a505, '"></div>\n                                </div>\n                               <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.contentStrategy"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.contentStrategyDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('ai'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$f38c853ae54ed474, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.sedestralAI"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.sedestralAIDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('analysis'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$9ebee87b1eb4e24e, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.seoAnalytics"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.seoAnalyticsDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('autopilot'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$5d910be2177c3c87, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.autopilot"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.autopilotDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                    </div>\n                </div>\n                <div class="').concat($b973c1c4b9e07ee9$export$4e0c71f277ca26b3, '">\n                    <div class="').concat($b973c1c4b9e07ee9$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.integrations"), '\n                        <div class="').concat($b973c1c4b9e07ee9$export$f2120bbfa5450bd2, '"></div>\n                    </div>\n                    <div class="').concat($b973c1c4b9e07ee9$export$3931a0da49df8dc0, '">\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('prestashop'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$7c5480d2d52b096a, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.prestaShop"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.prestaShopDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('shopify'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$6da9acb12d5139d4, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.shopify"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.shopifyDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('wordpress'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$97971ff30d8c30d2, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wordpress"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wordpressDescription"), '\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('wix'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$9c1acc30f900961c, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, " ").concat($b973c1c4b9e07ee9$export$e4c89085febbc618, '">\n                                    <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, " ").concat($b973c1c4b9e07ee9$export$ad6718c788124d32, '"></div>\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wix"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wixDescription"), "\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteHeadSubmenuContentProductsComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                if ((0, $abV4P.isMobile)()) this.els($b973c1c4b9e07ee9$export$4e0c71f277ca26b3).forEach(function(value) {
                    value.onClick(function() {
                        _this.els($b973c1c4b9e07ee9$export$4e0c71f277ca26b3).forEach(function(value) {
                            return _this.closeColumn(value);
                        });
                        _this.openColumn(value);
                    });
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteHeadSubmenuContentProductsComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteHeadSubmenuContentProductsComponent;
}((0, $011f72d0b4b8452c$export$b02585722e8afc63));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");

var $453c5ba63c9e83f6$export$aae1be5c386a10f3 = /*#__PURE__*/ function(WebsiteHeadSubmenuContentComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentPricingComponent, WebsiteHeadSubmenuContentComponent);
    function WebsiteHeadSubmenuContentPricingComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentPricingComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentPricingComponent);
        //language=HTML
        _this.template = '\n            <a href="'.concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('pricing'), '" class="').concat($b973c1c4b9e07ee9$export$ebcd94e5d6026061, '">\n                <div class="').concat($b973c1c4b9e07ee9$export$4e0c71f277ca26b3, '">\n                    <h6 class="').concat($b973c1c4b9e07ee9$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.pricing"), '\n                        <span class="').concat($b973c1c4b9e07ee9$export$f2120bbfa5450bd2, '"></span>\n                    </h6>\n                </div>\n            </a>\n        ');
        return _this;
    }
    return WebsiteHeadSubmenuContentPricingComponent;
}((0, $011f72d0b4b8452c$export$b02585722e8afc63));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");

var $c3e8d8235f11a1d2$export$f4312c6b981e35a = /*#__PURE__*/ function(WebsiteHeadSubmenuContentComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentScheduleComponent, WebsiteHeadSubmenuContentComponent);
    function WebsiteHeadSubmenuContentScheduleComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentScheduleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentScheduleComponent);
        //language=HTML
        _this.template = '\n            <a href="'.concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('schedule'), '" class="').concat($b973c1c4b9e07ee9$export$ebcd94e5d6026061, '">\n                <div class="').concat($b973c1c4b9e07ee9$export$4e0c71f277ca26b3, '">\n                    <h6 class="').concat($b973c1c4b9e07ee9$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.scheduleTitle"), '\n                        <span class="').concat($b973c1c4b9e07ee9$export$f2120bbfa5450bd2, '"></span>\n                    </h6>\n                </div>\n            </a>\n        ');
        return _this;
    }
    return WebsiteHeadSubmenuContentScheduleComponent;
}((0, $011f72d0b4b8452c$export$b02585722e8afc63));


var $1825181cd1a878a6$export$310360aa7761db45 = /*#__PURE__*/ function(WebsiteHeadSubmenuContentComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentMobileComponent, WebsiteHeadSubmenuContentComponent);
    function WebsiteHeadSubmenuContentMobileComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentMobileComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentMobileComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($b973c1c4b9e07ee9$export$ebcd94e5d6026061, '">\n                ').concat(_this.draw(new (0, $9c59cd6979ae2748$export$a51cf35744924ee2)()), "\n                ").concat(_this.draw(new (0, $453c5ba63c9e83f6$export$aae1be5c386a10f3)()), "\n                ").concat(_this.draw(new (0, $c3e8d8235f11a1d2$export$f4312c6b981e35a)()), '\n\n                <div class="').concat($b973c1c4b9e07ee9$export$bbea856fdb3e3c5f, '">\n                    <a href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), '" target="_blank">\n                        <div class="').concat($b973c1c4b9e07ee9$export$596d806903d1f59e, '">\n                            ').concat((0, $wYO7b.Resources).t("words.beginFree"), '\n                        </div>\n                    </a>\n                    <a class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, '" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('login'), '"\n                       target="_blank">\n                        <div class="').concat($b973c1c4b9e07ee9$export$b3571188c770cc5a, " ").concat($b973c1c4b9e07ee9$export$596d806903d1f59e, '">\n                            <div></div>\n                            <div class="').concat($b973c1c4b9e07ee9$export$a7db06668cad9adb, '">\n                                ').concat((0, $wYO7b.Resources).t("words.login"), '\n                            </div>\n                        </div>\n                    </a>\n                    <a class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, '" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), '"\n                       target="_blank">\n                        <div class="').concat($b973c1c4b9e07ee9$export$b3571188c770cc5a, '">\n                            <div></div>\n                            <div class="').concat($b973c1c4b9e07ee9$export$a7db06668cad9adb, '">\n                                ').concat((0, $wYO7b.Resources).t("words.beginFree"), '\n                                <div class="').concat($b973c1c4b9e07ee9$export$1ca1ec8b29a4ce27, '"></div>\n                            </div>\n                        </div>\n                    </a>\n                </div>\n            </div>');
        return _this;
    }
    (0, $jyA4z._)(WebsiteHeadSubmenuContentMobileComponent, [
        {
            key: "onOpen",
            value: function onOpen() {
                var _this = this;
                var columns = this.els($b973c1c4b9e07ee9$export$4e0c71f277ca26b3);
                var openedColumn;
                columns.forEach(function(column) {
                    _this.closeColumn(column);
                    var casesContainer = column.el($b973c1c4b9e07ee9$export$3931a0da49df8dc0);
                    var cases = casesContainer.els($b973c1c4b9e07ee9$export$e850e66917a23e0f);
                    cases === null || cases === void 0 ? void 0 : cases.forEach(function(caseElem) {
                        if (caseElem.getHTMLElement().parentElement && caseElem.getHTMLElement().parentElement['href'] == window.location.href) {
                            openedColumn = column;
                            _this.openColumn(column);
                        }
                    });
                });
                if (!openedColumn) this.openColumn(columns[0]);
            }
        }
    ]);
    return WebsiteHeadSubmenuContentMobileComponent;
}((0, $011f72d0b4b8452c$export$b02585722e8afc63));




var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");


var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");


var $738989d701f3462a$export$68f03a9fb148d796 = /*#__PURE__*/ function(WebsiteHeadSubmenuContentComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadSubmenuContentUseCaseComponent, WebsiteHeadSubmenuContentComponent);
    function WebsiteHeadSubmenuContentUseCaseComponent() {
        (0, $3CDbU._)(this, WebsiteHeadSubmenuContentUseCaseComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadSubmenuContentUseCaseComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($b973c1c4b9e07ee9$export$ebcd94e5d6026061, '">\n                <div class="').concat($b973c1c4b9e07ee9$export$4e0c71f277ca26b3, '">\n                    <h6 class="').concat($b973c1c4b9e07ee9$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.useCases"), '\n                        <span class="').concat($b973c1c4b9e07ee9$export$f2120bbfa5450bd2, '"></span>\n                    </h6>\n                    <div class="').concat($b973c1c4b9e07ee9$export$3931a0da49df8dc0, '">\n                        <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('service-client'), '">\n                            <div class="').concat($b973c1c4b9e07ee9$export$e850e66917a23e0f, " ").concat($b973c1c4b9e07ee9$export$ac5985f28ad46107, '">\n                                <div class="').concat($b973c1c4b9e07ee9$export$351f93dff0fc1e76, '">\n                                    ').concat(_this.draw(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).CLIENT_SERVICE)), '\n                                </div>\n                                <div class="').concat($b973c1c4b9e07ee9$export$29f9f81de5c56283, '">\n                                    <p itemprop="name" class="').concat($b973c1c4b9e07ee9$export$959d3058f2a8f3e9, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.customerService"), '\n                                    </p>\n                                    <p class="').concat($b973c1c4b9e07ee9$export$6d59db4903f20f7d, '">\n                                        ').concat((0, $wYO7b.Resources).t("words.supportCustomers"), "\n                                    </p>\n                                </div>\n                            </div>\n                        </a>\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteHeadSubmenuContentUseCaseComponent, [
        {
            key: "commit",
            value: function commit() {
                this.el($b973c1c4b9e07ee9$export$ac5985f28ad46107).onClick(function() {
                    (0, $3Qm5T.Network).router.pages.redirect("/service-client");
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteHeadSubmenuContentUseCaseComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteHeadSubmenuContentUseCaseComponent;
}((0, $011f72d0b4b8452c$export$b02585722e8afc63));


var $2785cb9973b34d21$export$749158e506049de5 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteHeadComponent, Component);
    function WebsiteHeadComponent() {
        (0, $3CDbU._)(this, WebsiteHeadComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHeadComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($1bdb3dfba03d3af1$export$9914389b95e1a1e8, '">\n                <div style="z-index: 4;" itemscope itemtype="https://schema.org/Organization">\n                    <a itemprop="url" href="').concat("https://sedestral.com/" + (0, $wYO7b.Resources).language + "/home", '">\n                        <meta itemprop="brand" content="Sedestral">\n                        <div class="').concat($1bdb3dfba03d3af1$export$364bb6944bd5af75, '">\n                            <div itemprop="logo" class="').concat($1bdb3dfba03d3af1$export$a1fe6a2d7788354f, '">\n                                <img itemprop="logo" class="').concat($1bdb3dfba03d3af1$export$db3c28d99448dcff, '"\n                                     src="').concat((0, $3Qm5T.Network).vendor, 'images/logo-sedestral.svg"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.logo"), '">\n                            </div>\n                            <h2 itemprop="name" class="').concat($1bdb3dfba03d3af1$export$fb184b623420d9be, '">\n                                Sedestral\n                            </h2>\n                        </div>\n                    </a>\n                </div>\n                <div itemscope itemtype="https://schema.org/SiteNavigationElement" class="').concat($1bdb3dfba03d3af1$export$3931a0da49df8dc0, '">\n                    <div class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$b6aad051bad07f12, '">\n                        ').concat((0, $wYO7b.Resources).t("words.solutions"), '\n                        <i class="').concat($1bdb3dfba03d3af1$export$1ca1ec8b29a4ce27, '"></i>\n\n                        <div class="').concat($1bdb3dfba03d3af1$export$6e0e6ce39e5a0361, '">\n                            <div class="').concat($1bdb3dfba03d3af1$export$3e523c77c1f23f8c, '"></div>\n                            ').concat(_this.draw(new (0, $9c59cd6979ae2748$export$a51cf35744924ee2)()), '\n                        </div>\n                    </div>\n                    <div style="display: none;" class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$1f96ae73734a86cc, '">\n                        ').concat((0, $wYO7b.Resources).t("words.useCases"), '\n                        <i class="').concat($1bdb3dfba03d3af1$export$1ca1ec8b29a4ce27, '"></i>\n\n                        <div class="').concat($1bdb3dfba03d3af1$export$6e0e6ce39e5a0361, '">\n                            <div class="').concat($1bdb3dfba03d3af1$export$3e523c77c1f23f8c, '"></div>\n                            ').concat(_this.draw(new (0, $738989d701f3462a$export$68f03a9fb148d796)()), '\n                        </div>\n                    </div>\n                    <div class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$ee3212a4833dc722, '">\n                        <a href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('pricing'), '">').concat((0, $wYO7b.Resources).t("words.pricing"), '</a>\n                    </div>\n                    <div class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$60974f670aa8d75e, '">\n                        <a href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('schedule'), '">').concat((0, $wYO7b.Resources).t("words.scheduleTitle"), '</a>\n                    </div>\n                        <!--<div class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$300b2c23f49a49cb, '">\n                        <a target="_blank" href="', "https://blog.sedestral.com", '">Blog</a>\n                    </div>-->\n                    <a class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$6b501c78a3684162, '" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('login'), '"\n                       target="_blank">\n                        ').concat((0, $wYO7b.Resources).t("words.login"), '\n                    </a>\n                    <a class="').concat($1bdb3dfba03d3af1$export$e850e66917a23e0f, " ").concat($1bdb3dfba03d3af1$export$6b501c78a3684162, " ").concat($1bdb3dfba03d3af1$export$7200a869094fec36, '" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), '"\n                       target="_blank">\n                        ').concat((0, $wYO7b.Resources).t("words.beginFree"), '\n                    </a>\n                </div>\n                <div class="').concat($1bdb3dfba03d3af1$export$698bf39bb1e7111e, '">\n                    <div class="').concat($1bdb3dfba03d3af1$export$ee1491bbb87d4653, " ").concat($1bdb3dfba03d3af1$export$60912654947077e3, '">\n                        <span class="').concat($1bdb3dfba03d3af1$export$1ca1ec8b29a4ce27, '"></span>\n                    </div>\n                </div>\n                <div class="').concat($1bdb3dfba03d3af1$export$1c4e7a9c31a6c071, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteHeadComponent, [
        {
            key: "commit",
            value: function commit() {
                this.registerSubMenu(this.el($1bdb3dfba03d3af1$export$b6aad051bad07f12));
                this.registerSubMenu(this.el($1bdb3dfba03d3af1$export$1f96ae73734a86cc));
                this.registerMobile();
                //this.el(s.blog).onClick(() => window.open(process.env.BLOG_URL));
                this.el($1bdb3dfba03d3af1$export$ee3212a4833dc722).onClick(function() {
                    return (0, $3Qm5T.Network).router.pages.redirect("/pricing");
                });
                this.el($1bdb3dfba03d3af1$export$60974f670aa8d75e).onClick(function() {
                    return (0, $3Qm5T.Network).router.pages.redirect("/schedule");
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteHeadComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "registerSubMenu",
            value: function registerSubMenu(caseButton) {
                var subMenu = caseButton.el($1bdb3dfba03d3af1$export$6e0e6ce39e5a0361);
                caseButton.onHover(function() {
                    return subMenu.scaleShow();
                });
                caseButton.onLeave(function() {
                    return subMenu.scaleHide(80, 0.9, false);
                });
                (0, $3Qm5T.Network).router.pages.onPopState(this, function() {
                    return subMenu.scaleHide(80, 0.9, false);
                });
            }
        },
        {
            key: "registerMobile",
            value: function registerMobile() {
                var _this = this;
                var mobileCase = this.el($1bdb3dfba03d3af1$export$60912654947077e3);
                var mobileContainer = this.el($1bdb3dfba03d3af1$export$1c4e7a9c31a6c071);
                var hideMenu = function() {
                    mobileContainer.displayHide();
                    mobileContainer.clear();
                    mobileCase.removeClass($1bdb3dfba03d3af1$export$3ce6949f20cea765);
                    _this.removeClass($1bdb3dfba03d3af1$export$5ae74841c1c22479);
                    _this.timeOut(function() {
                        mobileContainer.setStyle("max-height: 0%;");
                    }, 1);
                };
                var showMenu = function() {
                    var mobileMenuComponent = new (0, $1825181cd1a878a6$export$310360aa7761db45)();
                    mobileContainer.render(mobileMenuComponent);
                    mobileContainer.displayShow();
                    mobileMenuComponent.onOpen();
                    mobileCase.addClass($1bdb3dfba03d3af1$export$3ce6949f20cea765);
                    _this.addClass($1bdb3dfba03d3af1$export$5ae74841c1c22479);
                    _this.timeOut(function() {
                        mobileContainer.setStyle("max-height: 100%;");
                    }, 1);
                };
                mobileContainer.onOutsideClick(function() {
                    return hideMenu();
                });
                mobileCase.onClick(function() {
                    if (mobileContainer.isDisplayNone()) showMenu();
                    else hideMenu();
                }, true);
                (0, $3Qm5T.Network).router.pages.onPopState(this, function() {
                    return hideMenu();
                });
            }
        }
    ]);
    return WebsiteHeadComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $d7755a80dac68d9e$export$70e3371ee669ebd3;
var $d7755a80dac68d9e$export$96ff94e0adb1d772;
var $d7755a80dac68d9e$export$364bb6944bd5af75;
var $d7755a80dac68d9e$export$a1fe6a2d7788354f;
var $d7755a80dac68d9e$export$db3c28d99448dcff;
var $d7755a80dac68d9e$export$fb184b623420d9be;
var $d7755a80dac68d9e$export$53b3c91859018cd4;
var $d7755a80dac68d9e$export$4e0c71f277ca26b3;
var $d7755a80dac68d9e$export$3e9f948b41964866;
var $d7755a80dac68d9e$export$c407db72103fecfa;
var $d7755a80dac68d9e$export$789c912f57fe164c;
var $d7755a80dac68d9e$export$666c3ad173ff70db;
$d7755a80dac68d9e$export$70e3371ee669ebd3 = "sWQBN";
$d7755a80dac68d9e$export$96ff94e0adb1d772 = "n2TOE";
$d7755a80dac68d9e$export$364bb6944bd5af75 = "_6indg";
$d7755a80dac68d9e$export$a1fe6a2d7788354f = "QzMt4";
$d7755a80dac68d9e$export$db3c28d99448dcff = "_3vKT0";
$d7755a80dac68d9e$export$fb184b623420d9be = "wCw69";
$d7755a80dac68d9e$export$53b3c91859018cd4 = "KAdqr";
$d7755a80dac68d9e$export$4e0c71f277ca26b3 = "eIrgo";
$d7755a80dac68d9e$export$3e9f948b41964866 = "kyTyE";
$d7755a80dac68d9e$export$c407db72103fecfa = "XePa5";
$d7755a80dac68d9e$export$789c912f57fe164c = "VPgA6";
$d7755a80dac68d9e$export$666c3ad173ff70db = "Vy4h7";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");


var $wYO7b = parcelRequire("wYO7b");
var $3d5d09d6f531d15b$export$1bc61b600880820c;
var $3d5d09d6f531d15b$export$a4510362933968c8;
$3d5d09d6f531d15b$export$1bc61b600880820c = "PrJU2";
$3d5d09d6f531d15b$export$a4510362933968c8 = "g8H2t";



var $04j1P = parcelRequire("04j1P");
var $4955d47245a4d37e$export$afc0a508cbf81cd2 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(LanguageAllComponent, Component);
    function LanguageAllComponent(value, settings, filters) {
        (0, $3CDbU._)(this, LanguageAllComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, LanguageAllComponent);
        _this.value = value;
        _this.settings = settings;
        _this.filters = filters;
        //language=HTML
        _this.template = '\n            <div class="'.concat($3d5d09d6f531d15b$export$1bc61b600880820c, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(LanguageAllComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                var _this_settings;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(LanguageAllComponent.prototype), "commit", this).call(this);
                this.selectBox = new (0, $a54861d990819f07$export$32ca16bda187b168)((0, $04j1P.objectUpdate)(this.settings ? this.settings : {}, {
                    entries: (0, $wYO7b.Resources).worldLanguages.filter(function(l) {
                        return !_this.filters || _this.filters.includes(l.code);
                    }).map(function(v) {
                        return {
                            label: v.name,
                            value: v.code
                        };
                    }),
                    selectedValue: this.value,
                    search: ((_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.search) != undefined ? this.settings.search : true
                }));
                this.selectBox.onSelect = function(entry) {
                    return _this.onSelect(entry.value);
                };
                this.clearAll();
                this.render(this.selectBox);
            }
        },
        {
            key: "onSelect",
            value: function onSelect(language) {}
        }
    ]);
    return LanguageAllComponent;
}((0, $9gCL8.Component));



var $3CDbU = parcelRequire("3CDbU");
var $790bb746928a4e16$export$b25f5cc1eb7681bd = function ProductsLanguages() {
    "use strict";
    (0, $3CDbU._)(this, ProductsLanguages);
};
$790bb746928a4e16$export$b25f5cc1eb7681bd.panel = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$790bb746928a4e16$export$b25f5cc1eb7681bd.blog = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$790bb746928a4e16$export$b25f5cc1eb7681bd.helpCenter = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$790bb746928a4e16$export$b25f5cc1eb7681bd.livechat = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$790bb746928a4e16$export$b25f5cc1eb7681bd.website = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];


var $3bd953e975ec1672$export$ec10209cef18e52a = /*#__PURE__*/ function(LanguageAllComponent) {
    "use strict";
    (0, $jCmGC._)(LanguageWebsitePickerComponent, LanguageAllComponent);
    function LanguageWebsitePickerComponent(value) {
        (0, $3CDbU._)(this, LanguageWebsitePickerComponent);
        return (0, $ep9cZ._)(this, LanguageWebsitePickerComponent, [
            value,
            {
                search: false
            },
            (0, $790bb746928a4e16$export$b25f5cc1eb7681bd).website
        ]);
    }
    return LanguageWebsitePickerComponent;
}((0, $4955d47245a4d37e$export$afc0a508cbf81cd2));


var $b83205bb21d0997a$export$f7cee7a23320c3c3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteFooterComponent, Component);
    function WebsiteFooterComponent() {
        (0, $3CDbU._)(this, WebsiteFooterComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteFooterComponent);
        _this.languagePicker = new (0, $3bd953e975ec1672$export$ec10209cef18e52a)((0, $wYO7b.Resources).language);
        //language=HTML
        _this.template = '\n            <div class="'.concat($d7755a80dac68d9e$export$70e3371ee669ebd3, '">\n                <div class="').concat($d7755a80dac68d9e$export$96ff94e0adb1d772, '">\n                    <div style="z-index: 4;" itemscope itemtype="https://schema.org/Organization">\n                    <a itemprop="url" href="').concat("https://sedestral.com/" + (0, $wYO7b.Resources).language + "/home", '">\n                        <meta itemprop="brand" content="Sedestral">\n                        <div class="').concat($d7755a80dac68d9e$export$364bb6944bd5af75, '">\n                            <div itemprop="logo" class="').concat($d7755a80dac68d9e$export$a1fe6a2d7788354f, '">\n                                <img itemprop="logo" class="').concat($d7755a80dac68d9e$export$db3c28d99448dcff, '"\n                                     src="').concat((0, $3Qm5T.Network).vendor, 'images/logo-sedestral.svg"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.logo"), '">\n                            </div>\n                            <h2 itemprop="name" class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                                Sedestral\n                            </h2>\n                        </div>\n                    </a>\n                </div>\n                </div>\n                <div itemscope itemtype="https://schema.org/SiteNavigationElement" class="').concat($d7755a80dac68d9e$export$53b3c91859018cd4, '">\n                    <div class="').concat($d7755a80dac68d9e$export$4e0c71f277ca26b3, '">\n                        <nav class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.tools"), '\n                            <ul class="').concat($d7755a80dac68d9e$export$3e9f948b41964866, '">\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('ai'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.sedestralAI"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('analysis'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.seoAnalytics"), '\n                                    </a> \n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('autopilot'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.autopilot"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('style'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.styleCloningTitle"), '\n                                    </a>\n                                </li>\n                            </ul>\n                        </nav>\n                    </div>\n                     <div class="').concat($d7755a80dac68d9e$export$4e0c71f277ca26b3, '">\n                        <nav class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.integrations"), '\n                            <ul class="').concat($d7755a80dac68d9e$export$3e9f948b41964866, '">\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('prestashop'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.prestaShop"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('shopify'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.shopify"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('wordpress'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wordpress"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('wix'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.wix"), '\n                                    </a>\n                                </li>\n                            </ul>\n                        </nav>\n                    </div>\n                    <div class="').concat($d7755a80dac68d9e$export$4e0c71f277ca26b3, '">\n                        <nav class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.resources"), '\n                            <ul class="').concat($d7755a80dac68d9e$export$3e9f948b41964866, '">\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('pricing'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.pricing"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('schedule'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.scheduleTitle"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('cgu'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.conditionsOfUse"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('cgv'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.generalSalesConditions"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getUrlWithPath('policy'), '">\n                                        ').concat((0, $wYO7b.Resources).t("words.privacyPolicyName"), '\n                                    </a>\n                                </li>\n                            </ul>\n                        </nav>\n                    </div>\n                    <div class="').concat($d7755a80dac68d9e$export$4e0c71f277ca26b3, '">\n                        <nav class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.account"), '\n                            <ul class="').concat($d7755a80dac68d9e$export$3e9f948b41964866, '">\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('login'), '" target="_blank">\n                                        ').concat((0, $wYO7b.Resources).t("words.myAccount"), '\n                                    </a>\n                                </li>\n                                <li itemprop="name" class="').concat($d7755a80dac68d9e$export$c407db72103fecfa, '">\n                                    <a itemprop="url" href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl("signup"), '" target="_blank">\n                                        ').concat((0, $wYO7b.Resources).t("words.signUp"), '\n                                    </a>\n                                </li>\n                            </ul>\n                        </nav>\n                        <nav class="').concat($d7755a80dac68d9e$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.language"), '\n                            <div class="').concat($d7755a80dac68d9e$export$789c912f57fe164c, '">\n                                ').concat(_this.draw(_this.languagePicker), '\n                            </div>\n                        </nav>\n                    </div>\n                </div>\n                <p class="').concat($d7755a80dac68d9e$export$666c3ad173ff70db, '">\n                    Copyright \xa9 ').concat(new Date().getFullYear(), " Sedestral. ").concat((0, $wYO7b.Resources).t("words.allRightsReserved"), "\n                </p>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteFooterComponent, [
        {
            key: "commit",
            value: function commit() {
                this.languagePicker.onSelect = function(language) {
                    return (0, $3Qm5T.Network).router.pages.setLanguage(language);
                };
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteFooterComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteFooterComponent;
}((0, $9gCL8.Component));





var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $ab266916f6c4ba80$export$8a4b034b88ce89d2;
var $ab266916f6c4ba80$export$e4b2ac9215619f8d;
var $ab266916f6c4ba80$export$fb184b623420d9be;
var $ab266916f6c4ba80$export$6d59db4903f20f7d;
var $ab266916f6c4ba80$export$b3571188c770cc5a;
var $ab266916f6c4ba80$export$1ca1ec8b29a4ce27;
var $ab266916f6c4ba80$export$5ff12484cc89d9be;
var $ab266916f6c4ba80$export$a7db06668cad9adb;
var $ab266916f6c4ba80$export$acf4eaf431084f78;
var $ab266916f6c4ba80$export$b8972b998723d602;
$ab266916f6c4ba80$export$8a4b034b88ce89d2 = "ncrla";
$ab266916f6c4ba80$export$e4b2ac9215619f8d = "KxwNl";
$ab266916f6c4ba80$export$fb184b623420d9be = "Av5iz";
$ab266916f6c4ba80$export$6d59db4903f20f7d = "SP8FW";
$ab266916f6c4ba80$export$b3571188c770cc5a = "GQy6k";
$ab266916f6c4ba80$export$1ca1ec8b29a4ce27 = "OXijq";
$ab266916f6c4ba80$export$5ff12484cc89d9be = "xDwRm";
$ab266916f6c4ba80$export$a7db06668cad9adb = "Qq00-";
$ab266916f6c4ba80$export$acf4eaf431084f78 = "qoRcZ";
$ab266916f6c4ba80$export$b8972b998723d602 = "dxpy-";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $0e7c8fdeef4d0a03$export$ecbe10969f9e521f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackJoinComponent, Component);
    function WebsiteBlackJoinComponent() {
        (0, $3CDbU._)(this, WebsiteBlackJoinComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackJoinComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($ab266916f6c4ba80$export$8a4b034b88ce89d2, '">\n                <div class="').concat($ab266916f6c4ba80$export$e4b2ac9215619f8d, '">\n                    <div class="').concat($ab266916f6c4ba80$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.organicTrafficWithinReach"), '\n                    </div>\n                    <div class="').concat($ab266916f6c4ba80$export$6d59db4903f20f7d, '">\n                        ').concat((0, $wYO7b.Resources).t("words.sedestralDescription"), '\n                    </div>\n                    <a href="').concat((0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), '" target="_blank" class="').concat($ab266916f6c4ba80$export$b3571188c770cc5a, '">\n                        <div class="').concat($ab266916f6c4ba80$export$5ff12484cc89d9be, '"></div>\n                        <div class="').concat($ab266916f6c4ba80$export$a7db06668cad9adb, '">\n                            ').concat((0, $wYO7b.Resources).t("words.beginFree"), '\n                            <div class="').concat($ab266916f6c4ba80$export$1ca1ec8b29a4ce27, '"></div>\n                        </div>\n                    </a>\n                </div>\n                <div class="').concat($ab266916f6c4ba80$export$acf4eaf431084f78, '">\n                    <div class="').concat($ab266916f6c4ba80$export$1ca1ec8b29a4ce27, '"></div>\n                </div>\n                <div class="').concat($ab266916f6c4ba80$export$b8972b998723d602, '"></div>\n            </div>\n        ');
        return _this;
    }
    return WebsiteBlackJoinComponent;
}((0, $9gCL8.Component));


var $f8a487b4e0321a84$export$f58f12b264b5aeb7 = /*#__PURE__*/ function(PageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsitePageComponent, PageComponent);
    function WebsitePageComponent() {
        (0, $3CDbU._)(this, WebsitePageComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePageComponent);
        //language=HTML
        _this.template = "\n        ";
        return _this;
    }
    (0, $jyA4z._)(WebsitePageComponent, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return undefined;
            }
        },
        {
            key: "init",
            value: function init() {
                //language=HTML
                this.template = '\n            <div class="'.concat($5f100fba5d069eaa$export$523fb3936f49e028, '">\n                <div class="').concat($329be264cf508f4d$export$2cb412c852497e7f, '">\n                    <div class="').concat($329be264cf508f4d$export$5fd5031fecdacec3, '">\n                        ').concat(this.draw(new (0, $2785cb9973b34d21$export$749158e506049de5)()), "\n                    </div>\n                    ").concat(this.draw(this.contentComponent()), '\n                    <div class="').concat($329be264cf508f4d$export$a7db06668cad9adb, '">\n                        <div class="').concat($329be264cf508f4d$export$fd59df041b888442, '">\n                            <div class="').concat($329be264cf508f4d$export$34e0f9847d4c02dd, '">\n                                ').concat(this.draw(new (0, $0e7c8fdeef4d0a03$export$ecbe10969f9e521f)()), '\n                            </div>\n                        </div>\n                    </div>\n                    <div class="').concat($329be264cf508f4d$export$ac96a2a951168044, '">\n                        ').concat(this.draw(new (0, $b83205bb21d0997a$export$f7cee7a23320c3c3)()), "\n                    </div>\n                </div>\n            </div>\n        ");
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsitePageComponent;
}((0, $cfc75e76a9120279$export$c4dc9eeb28e63095));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $95cb205eff9a45f3$export$f997558458ede46c;
var $95cb205eff9a45f3$export$8fa4e5556fd77a60;
var $95cb205eff9a45f3$export$a7db06668cad9adb;
var $95cb205eff9a45f3$export$34e0f9847d4c02dd;
$95cb205eff9a45f3$export$f997558458ede46c = "_1xZ4z";
$95cb205eff9a45f3$export$8fa4e5556fd77a60 = "_0u-sQ";
$95cb205eff9a45f3$export$a7db06668cad9adb = "M6c0H";
$95cb205eff9a45f3$export$34e0f9847d4c02dd = "OKAGF";


var $dfb6afb0b8149071$export$5016101a142bf96a;
var $dfb6afb0b8149071$export$3bf720ece7bc7b2e;
var $dfb6afb0b8149071$export$1f6feda8aa226b71;
var $dfb6afb0b8149071$export$34e0f9847d4c02dd;
$dfb6afb0b8149071$export$5016101a142bf96a = "Toz-F";
$dfb6afb0b8149071$export$3bf720ece7bc7b2e = "-gDaK";
$dfb6afb0b8149071$export$1f6feda8aa226b71 = "k0Z8m";
$dfb6afb0b8149071$export$34e0f9847d4c02dd = "_5OUdl";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $d0a2af7ac8d11bc1$exports = {};

$parcel$export($d0a2af7ac8d11bc1$exports, "componentWebsiteProduct", function () { return $d0a2af7ac8d11bc1$export$50bc9fb5708a76a9; }, function (v) { return $d0a2af7ac8d11bc1$export$50bc9fb5708a76a9 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "brandContainer", function () { return $d0a2af7ac8d11bc1$export$b700ae2838043bbf; }, function (v) { return $d0a2af7ac8d11bc1$export$b700ae2838043bbf = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "imageContainer", function () { return $d0a2af7ac8d11bc1$export$63e82393dc8977bf; }, function (v) { return $d0a2af7ac8d11bc1$export$63e82393dc8977bf = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "cardTexts", function () { return $d0a2af7ac8d11bc1$export$48c304f518b09d1e; }, function (v) { return $d0a2af7ac8d11bc1$export$48c304f518b09d1e = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "title", function () { return $d0a2af7ac8d11bc1$export$fb184b623420d9be; }, function (v) { return $d0a2af7ac8d11bc1$export$fb184b623420d9be = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "inbox", function () { return $d0a2af7ac8d11bc1$export$9c1acc30f900961c; }, function (v) { return $d0a2af7ac8d11bc1$export$9c1acc30f900961c = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "statistics", function () { return $d0a2af7ac8d11bc1$export$9ebee87b1eb4e24e; }, function (v) { return $d0a2af7ac8d11bc1$export$9ebee87b1eb4e24e = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "livechat", function () { return $d0a2af7ac8d11bc1$export$17a8a1cb950cf89a; }, function (v) { return $d0a2af7ac8d11bc1$export$17a8a1cb950cf89a = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "mail", function () { return $d0a2af7ac8d11bc1$export$b602b78110e4ab1e; }, function (v) { return $d0a2af7ac8d11bc1$export$b602b78110e4ab1e = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "serviceclient", function () { return $d0a2af7ac8d11bc1$export$cbb43b43d319c590; }, function (v) { return $d0a2af7ac8d11bc1$export$cbb43b43d319c590 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "text", function () { return $d0a2af7ac8d11bc1$export$6f093cfa640b7166; }, function (v) { return $d0a2af7ac8d11bc1$export$6f093cfa640b7166 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "round", function () { return $d0a2af7ac8d11bc1$export$2077e0241d6afd3c; }, function (v) { return $d0a2af7ac8d11bc1$export$2077e0241d6afd3c = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "prestashop", function () { return $d0a2af7ac8d11bc1$export$7c5480d2d52b096a; }, function (v) { return $d0a2af7ac8d11bc1$export$7c5480d2d52b096a = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "icon", function () { return $d0a2af7ac8d11bc1$export$1ca1ec8b29a4ce27; }, function (v) { return $d0a2af7ac8d11bc1$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "wix", function () { return $d0a2af7ac8d11bc1$export$ad6718c788124d32; }, function (v) { return $d0a2af7ac8d11bc1$export$ad6718c788124d32 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "wordpress", function () { return $d0a2af7ac8d11bc1$export$97971ff30d8c30d2; }, function (v) { return $d0a2af7ac8d11bc1$export$97971ff30d8c30d2 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "shopify", function () { return $d0a2af7ac8d11bc1$export$6da9acb12d5139d4; }, function (v) { return $d0a2af7ac8d11bc1$export$6da9acb12d5139d4 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "promo", function () { return $d0a2af7ac8d11bc1$export$40e52e4cb633d77a; }, function (v) { return $d0a2af7ac8d11bc1$export$40e52e4cb633d77a = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "button", function () { return $d0a2af7ac8d11bc1$export$2ba01fb71ed41cb6; }, function (v) { return $d0a2af7ac8d11bc1$export$2ba01fb71ed41cb6 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "shadow", function () { return $d0a2af7ac8d11bc1$export$b8972b998723d602; }, function (v) { return $d0a2af7ac8d11bc1$export$b8972b998723d602 = v; });
$parcel$export($d0a2af7ac8d11bc1$exports, "content", function () { return $d0a2af7ac8d11bc1$export$a7db06668cad9adb; }, function (v) { return $d0a2af7ac8d11bc1$export$a7db06668cad9adb = v; });
var $d0a2af7ac8d11bc1$export$50bc9fb5708a76a9;
var $d0a2af7ac8d11bc1$export$b700ae2838043bbf;
var $d0a2af7ac8d11bc1$export$63e82393dc8977bf;
var $d0a2af7ac8d11bc1$export$48c304f518b09d1e;
var $d0a2af7ac8d11bc1$export$fb184b623420d9be;
var $d0a2af7ac8d11bc1$export$9c1acc30f900961c;
var $d0a2af7ac8d11bc1$export$9ebee87b1eb4e24e;
var $d0a2af7ac8d11bc1$export$17a8a1cb950cf89a;
var $d0a2af7ac8d11bc1$export$b602b78110e4ab1e;
var $d0a2af7ac8d11bc1$export$cbb43b43d319c590;
var $d0a2af7ac8d11bc1$export$6f093cfa640b7166;
var $d0a2af7ac8d11bc1$export$2077e0241d6afd3c;
var $d0a2af7ac8d11bc1$export$7c5480d2d52b096a;
var $d0a2af7ac8d11bc1$export$1ca1ec8b29a4ce27;
var $d0a2af7ac8d11bc1$export$ad6718c788124d32;
var $d0a2af7ac8d11bc1$export$97971ff30d8c30d2;
var $d0a2af7ac8d11bc1$export$6da9acb12d5139d4;
var $d0a2af7ac8d11bc1$export$40e52e4cb633d77a;
var $d0a2af7ac8d11bc1$export$2ba01fb71ed41cb6;
var $d0a2af7ac8d11bc1$export$b8972b998723d602;
var $d0a2af7ac8d11bc1$export$a7db06668cad9adb;
$d0a2af7ac8d11bc1$export$50bc9fb5708a76a9 = "A6P3b";
$d0a2af7ac8d11bc1$export$b700ae2838043bbf = "_2lx1n";
$d0a2af7ac8d11bc1$export$63e82393dc8977bf = "aHiz1";
$d0a2af7ac8d11bc1$export$48c304f518b09d1e = "wxWNP";
$d0a2af7ac8d11bc1$export$fb184b623420d9be = "Lnmyj";
$d0a2af7ac8d11bc1$export$9c1acc30f900961c = "Tz7ie";
$d0a2af7ac8d11bc1$export$9ebee87b1eb4e24e = "k-pem";
$d0a2af7ac8d11bc1$export$17a8a1cb950cf89a = "eHNQ9";
$d0a2af7ac8d11bc1$export$b602b78110e4ab1e = "Fm-kD";
$d0a2af7ac8d11bc1$export$cbb43b43d319c590 = "LdonG";
$d0a2af7ac8d11bc1$export$6f093cfa640b7166 = "DM1Jo";
$d0a2af7ac8d11bc1$export$2077e0241d6afd3c = "nvn8h";
$d0a2af7ac8d11bc1$export$7c5480d2d52b096a = "wH2ys";
$d0a2af7ac8d11bc1$export$1ca1ec8b29a4ce27 = "xJC3p";
$d0a2af7ac8d11bc1$export$ad6718c788124d32 = "qODv7";
$d0a2af7ac8d11bc1$export$97971ff30d8c30d2 = "h3WXc";
$d0a2af7ac8d11bc1$export$6da9acb12d5139d4 = "MK1oF";
$d0a2af7ac8d11bc1$export$40e52e4cb633d77a = "hLzZO";
$d0a2af7ac8d11bc1$export$2ba01fb71ed41cb6 = "_529Da";
$d0a2af7ac8d11bc1$export$b8972b998723d602 = "_856Tg";
$d0a2af7ac8d11bc1$export$a7db06668cad9adb = "Xqh-B";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a4e23956ca1e8775$export$bd28379bbedb5475;
var $a4e23956ca1e8775$export$351f93dff0fc1e76;
var $a4e23956ca1e8775$export$75a30c72c46d1150;
$a4e23956ca1e8775$export$bd28379bbedb5475 = "chBpD";
$a4e23956ca1e8775$export$351f93dff0fc1e76 = "bgk4Z";
$a4e23956ca1e8775$export$75a30c72c46d1150 = "iDRe2";




var $co7RM = parcelRequire("co7RM");

var $9IvVr = parcelRequire("9IvVr");

var $wYO7b = parcelRequire("wYO7b");
var $ee30fdceafcc6047$export$fc7ae33fafef4f1d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBrandComponent, Component);
    function WebsiteBrandComponent(productType, productName) {
        (0, $3CDbU._)(this, WebsiteBrandComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBrandComponent);
        _this.productType = productType;
        _this.productName = productName;
        var style = "";
        switch(productType){
            case (0, $co7RM.ProductType).CLIENT_SERVICE:
                style = "display:none";
                break;
        }
        //language=HTML
        _this.template = '\n            <div class="'.concat($a4e23956ca1e8775$export$bd28379bbedb5475, '">\n                <div class="').concat($a4e23956ca1e8775$export$351f93dff0fc1e76, '" style="').concat(style, '"></div>\n                <h1 class="').concat($a4e23956ca1e8775$export$75a30c72c46d1150, '">\n                    ').concat(_this.productName ? _this.productName : _this.productType == (0, $co7RM.ProductType).CLIENT_SERVICE ? (0, $wYO7b.Resources).t("words.customerService") : (0, $wYO7b.Resources).t("words.products." + (0, $9IvVr.ProductName).toString(_this.productType)), "\n                </h1>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteBrandComponent, [
        {
            key: "commit",
            value: function commit() {
                this.capsuleContainer = this.el($a4e23956ca1e8775$export$351f93dff0fc1e76);
                if (!this.productType) this.capsuleContainer.remove();
                else this.capsuleContainer.render(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)(this.productType));
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBrandComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteBrandComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $b1da3e1cee142e14$exports = {};

$parcel$export($b1da3e1cee142e14$exports, "componentWebsiteImageSkewed", function () { return $b1da3e1cee142e14$export$120e66516e7c1a2; }, function (v) { return $b1da3e1cee142e14$export$120e66516e7c1a2 = v; });
$parcel$export($b1da3e1cee142e14$exports, "intermediate", function () { return $b1da3e1cee142e14$export$28824b7d7b72532c; }, function (v) { return $b1da3e1cee142e14$export$28824b7d7b72532c = v; });
$parcel$export($b1da3e1cee142e14$exports, "discreet", function () { return $b1da3e1cee142e14$export$b888741373b3dda2; }, function (v) { return $b1da3e1cee142e14$export$b888741373b3dda2 = v; });
$parcel$export($b1da3e1cee142e14$exports, "important", function () { return $b1da3e1cee142e14$export$929888ab0c9f043c; }, function (v) { return $b1da3e1cee142e14$export$929888ab0c9f043c = v; });
var $b1da3e1cee142e14$export$120e66516e7c1a2;
var $b1da3e1cee142e14$export$28824b7d7b72532c;
var $b1da3e1cee142e14$export$b888741373b3dda2;
var $b1da3e1cee142e14$export$929888ab0c9f043c;
$b1da3e1cee142e14$export$120e66516e7c1a2 = "ugMaD";
$b1da3e1cee142e14$export$28824b7d7b72532c = "arVTJ";
$b1da3e1cee142e14$export$b888741373b3dda2 = "VUubG";
$b1da3e1cee142e14$export$929888ab0c9f043c = "HUKHM";



var $wYO7b = parcelRequire("wYO7b");
var $7223b14368987219$export$1850aae07b2215a1 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteImageSkewedComponent, Component);
    function WebsiteImageSkewedComponent(p) {
        (0, $3CDbU._)(this, WebsiteImageSkewedComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteImageSkewedComponent);
        _this.shadow = p.shadow;
        _this.type = "IMG";
        //language=HTML
        _this.template = '\n            <img class="'.concat($b1da3e1cee142e14$exports.componentWebsiteImageSkewed, " ").concat($b1da3e1cee142e14$exports[_this.shadow], '"\n                 src="').concat(p.link, '"\n                 alt="').concat((0, $wYO7b.Resources).t("words.presentationImage"), '"\n                 width="').concat(p.width, '"\n                 height="').concat(p.height, '"\n            />\n        ');
        return _this;
    }
    return WebsiteImageSkewedComponent;
}((0, $9gCL8.Component));



var $9IvVr = parcelRequire("9IvVr");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $34133874689146b4$export$860f11a0f47b60ac = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteVideoComponent, Component);
    function WebsiteVideoComponent(url) {
        (0, $3CDbU._)(this, WebsiteVideoComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteVideoComponent);
        //language=HTML
        _this.template = '\n            <div style="width: 100%; overflow: hidden;box-shadow: 0 0 73.91px var(--black-alpha-middle);border-radius: 18px;position: relative;">\n                <div style="height: 6px;width: 100%;background: #ffffff;position: absolute;bottom: 0;"></div>\n                <video class="video" autoplay loop muted playsinline\n                       style=" height: auto;width: 0;margin-top: -1px;">\n                    <source src="'.concat(url, '" type="video/mp4">\n                    Votre navigateur ne supporte pas les vid\xe9os HTML5.\n                </video>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteVideoComponent, [
        {
            key: "commit",
            value: function commit() {
                var video = this.el("video").getHTMLElement();
                video.addEventListener('canplay', function() {
                    video.style.width = 'calc(100% + 1px)';
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteVideoComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteVideoComponent;
}((0, $9gCL8.Component));


var $c94a38a55d85de37$export$dd68357b72560132 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteProductComponent, Component);
    function WebsiteProductComponent(p) {
        (0, $3CDbU._)(this, WebsiteProductComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteProductComponent);
        _this.productType = p.productType;
        _this.pUrl = p.url;
        //language=HTML
        _this.template = '\n            <div class="'.concat($d0a2af7ac8d11bc1$exports.componentWebsiteProduct, '">\n                <div class="').concat($d0a2af7ac8d11bc1$exports.brandContainer, '">\n                    ').concat(_this.draw(new (0, $ee30fdceafcc6047$export$fc7ae33fafef4f1d)(p.productType, p.productName)), '\n                </div>\n                <div class="').concat($d0a2af7ac8d11bc1$exports.imageContainer, '"></div>\n                <div class="').concat($d0a2af7ac8d11bc1$exports.cardTexts, '">\n                    ').concat(p.roundIcon ? '<div class="'.concat($d0a2af7ac8d11bc1$exports.round, " ").concat($d0a2af7ac8d11bc1$exports[p.roundIcon], '"><div class="').concat($d0a2af7ac8d11bc1$exports.icon, '"></div></div>') : "", '\n                    <h2 class="').concat($d0a2af7ac8d11bc1$exports.title, " ").concat($d0a2af7ac8d11bc1$exports[p.titleClass ? p.titleClass : (0, $9IvVr.ProductName).toString(_this.productType)], '">\n                        ').concat(p.title, '\n                    </h2>\n                    <p class="').concat($d0a2af7ac8d11bc1$exports.text, '">\n                        ').concat(p.text, "\n                    </p>\n                    ").concat(p.promo ? '<div class="'.concat($d0a2af7ac8d11bc1$exports.promo, '">').concat(p.promo, "</div>") : "", "\n                    ").concat(p.buttonText ? '<a target="_blank" href="'.concat(p.buttonUrl, '">\n                                <div class="').concat($d0a2af7ac8d11bc1$exports.button, '">\n                                    <div class="').concat($d0a2af7ac8d11bc1$exports.shadow, '"></div>\n                                    <div class="').concat($d0a2af7ac8d11bc1$exports.content, '">\n                                        ').concat(p.buttonText, "\n                                        ").concat(p.buttonIcon ? '<div class="'.concat($d0a2af7ac8d11bc1$exports.icon, " ").concat($d0a2af7ac8d11bc1$exports[p.buttonIcon], '"></div>') : '<div class="'.concat($d0a2af7ac8d11bc1$exports.icon, '"></div>'), "\n                                    </div>\n                                </div>\n                            </a>") : "", "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteProductComponent, [
        {
            key: "commit",
            value: function commit() {
                this.imageContainer = this.el($d0a2af7ac8d11bc1$exports.imageContainer);
                if (this.pUrl.endsWith(".mp4")) //language=HTML
                this.imageContainer.render(new (0, $34133874689146b4$export$860f11a0f47b60ac)(this.pUrl));
                else this.imageContainer.render(new (0, $7223b14368987219$export$1850aae07b2215a1)({
                    link: this.pUrl,
                    shadow: "important",
                    width: "920",
                    height: "517.5"
                }));
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteProductComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteProductComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $380f84df3893372a$exports = {};

$parcel$export($380f84df3893372a$exports, "componentWebsitePresentationLight", function () { return $380f84df3893372a$export$984c3bc21b1a54fc; }, function (v) { return $380f84df3893372a$export$984c3bc21b1a54fc = v; });
$parcel$export($380f84df3893372a$exports, "left", function () { return $380f84df3893372a$export$eabcd2c8791e7bf4; }, function (v) { return $380f84df3893372a$export$eabcd2c8791e7bf4 = v; });
$parcel$export($380f84df3893372a$exports, "tall", function () { return $380f84df3893372a$export$d06da4f97bb01f71; }, function (v) { return $380f84df3893372a$export$d06da4f97bb01f71 = v; });
$parcel$export($380f84df3893372a$exports, "medium", function () { return $380f84df3893372a$export$649ecc744817b5c7; }, function (v) { return $380f84df3893372a$export$649ecc744817b5c7 = v; });
$parcel$export($380f84df3893372a$exports, "article", function () { return $380f84df3893372a$export$bba2aacf8566461b; }, function (v) { return $380f84df3893372a$export$bba2aacf8566461b = v; });
$parcel$export($380f84df3893372a$exports, "title", function () { return $380f84df3893372a$export$fb184b623420d9be; }, function (v) { return $380f84df3893372a$export$fb184b623420d9be = v; });
$parcel$export($380f84df3893372a$exports, "subtitle", function () { return $380f84df3893372a$export$c96745152eb2740f; }, function (v) { return $380f84df3893372a$export$c96745152eb2740f = v; });
$parcel$export($380f84df3893372a$exports, "more", function () { return $380f84df3893372a$export$a627d162e8aad100; }, function (v) { return $380f84df3893372a$export$a627d162e8aad100 = v; });
$parcel$export($380f84df3893372a$exports, "arrow", function () { return $380f84df3893372a$export$f2120bbfa5450bd2; }, function (v) { return $380f84df3893372a$export$f2120bbfa5450bd2 = v; });
$parcel$export($380f84df3893372a$exports, "right", function () { return $380f84df3893372a$export$79ffe56a765070d2; }, function (v) { return $380f84df3893372a$export$79ffe56a765070d2 = v; });
$parcel$export($380f84df3893372a$exports, "visual", function () { return $380f84df3893372a$export$496f218b657bbde0; }, function (v) { return $380f84df3893372a$export$496f218b657bbde0 = v; });
$parcel$export($380f84df3893372a$exports, "image", function () { return $380f84df3893372a$export$5c452ff88e35e47d; }, function (v) { return $380f84df3893372a$export$5c452ff88e35e47d = v; });
$parcel$export($380f84df3893372a$exports, "illus-mails-advanced", function () { return $380f84df3893372a$export$5613b0a28e68c9f8; }, function (v) { return $380f84df3893372a$export$5613b0a28e68c9f8 = v; });
$parcel$export($380f84df3893372a$exports, "illus-seo", function () { return $380f84df3893372a$export$74a1f66030468d3b; }, function (v) { return $380f84df3893372a$export$74a1f66030468d3b = v; });
$parcel$export($380f84df3893372a$exports, "illus-perms", function () { return $380f84df3893372a$export$b439ac323795b8de; }, function (v) { return $380f84df3893372a$export$b439ac323795b8de = v; });
$parcel$export($380f84df3893372a$exports, "illus-funnel", function () { return $380f84df3893372a$export$7c04b2d1cdbc98a7; }, function (v) { return $380f84df3893372a$export$7c04b2d1cdbc98a7 = v; });
var $380f84df3893372a$export$984c3bc21b1a54fc;
var $380f84df3893372a$export$eabcd2c8791e7bf4;
var $380f84df3893372a$export$d06da4f97bb01f71;
var $380f84df3893372a$export$649ecc744817b5c7;
var $380f84df3893372a$export$bba2aacf8566461b;
var $380f84df3893372a$export$fb184b623420d9be;
var $380f84df3893372a$export$c96745152eb2740f;
var $380f84df3893372a$export$a627d162e8aad100;
var $380f84df3893372a$export$f2120bbfa5450bd2;
var $380f84df3893372a$export$79ffe56a765070d2;
var $380f84df3893372a$export$496f218b657bbde0;
var $380f84df3893372a$export$5c452ff88e35e47d;
var $380f84df3893372a$export$5613b0a28e68c9f8;
var $380f84df3893372a$export$74a1f66030468d3b;
var $380f84df3893372a$export$b439ac323795b8de;
var $380f84df3893372a$export$7c04b2d1cdbc98a7;
$380f84df3893372a$export$984c3bc21b1a54fc = "_0Z1Fo";
$380f84df3893372a$export$eabcd2c8791e7bf4 = "G-U-e";
$380f84df3893372a$export$d06da4f97bb01f71 = "s64OX";
$380f84df3893372a$export$649ecc744817b5c7 = "Fgvjw";
$380f84df3893372a$export$bba2aacf8566461b = "_8OJXc";
$380f84df3893372a$export$fb184b623420d9be = "JdsXP";
$380f84df3893372a$export$c96745152eb2740f = "WNZNH";
$380f84df3893372a$export$a627d162e8aad100 = "CcbG-";
$380f84df3893372a$export$f2120bbfa5450bd2 = "QvmBK";
$380f84df3893372a$export$79ffe56a765070d2 = "vZHsd";
$380f84df3893372a$export$496f218b657bbde0 = "_9LfWb";
$380f84df3893372a$export$5c452ff88e35e47d = "-rK3F";
$380f84df3893372a$export$5613b0a28e68c9f8 = "lIcF7";
$380f84df3893372a$export$74a1f66030468d3b = "wWDjF";
$380f84df3893372a$export$b439ac323795b8de = "D0OHZ";
$380f84df3893372a$export$7c04b2d1cdbc98a7 = "dALtA";



var $wYO7b = parcelRequire("wYO7b");
var $951a12393fe71ff0$export$e4b6d83931e2a971 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsitePresentationLightComponent, Component);
    function WebsitePresentationLightComponent(p) {
        (0, $3CDbU._)(this, WebsitePresentationLightComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePresentationLightComponent);
        _this.illus = p.illus;
        _this.size = p.size;
        _this.url = p.url;
        if (p.direction == true) _this.direction = ' style="flex-direction: row-reverse;"';
        else _this.direction = "";
        //language=HTML
        _this.template = '\n            <div class="'.concat($380f84df3893372a$exports.componentWebsitePresentationLight, '" ').concat(_this.direction, '>\n                <div class="').concat($380f84df3893372a$exports.left, " ").concat($380f84df3893372a$exports[_this.size], '">\n                    <div class="').concat($380f84df3893372a$exports.article, '">\n                        <h3 class="').concat($380f84df3893372a$exports.title, '">\n                            ').concat(p.title, '\n                        </h3>\n                        <p class="').concat($380f84df3893372a$exports.subtitle, '">\n                            ').concat(p.subtitle, "\n                        </p>\n                        ").concat(p.url ? '                   \n                          <a class="'.concat($380f84df3893372a$exports.more, '" href="').concat(p.url, '">\n                           ').concat((0, $wYO7b.Resources).t("words.more"), '\n                            <i class="').concat($380f84df3893372a$exports.arrow, '"></i>\n                        </a>') : '', '\n                    </div>\n                </div>\n                <div class="').concat($380f84df3893372a$exports.right, " ").concat($380f84df3893372a$exports[_this.size], '">\n                    <div class="').concat($380f84df3893372a$exports.visual, '">\n                        <div class="').concat($380f84df3893372a$exports.image, " ").concat($380f84df3893372a$exports[_this.illus], '"></div>\n                    </div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    return WebsitePresentationLightComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $8b76a15172595c2c$exports = {};

$parcel$export($8b76a15172595c2c$exports, "componentWebsitePresentationVertical", function () { return $8b76a15172595c2c$export$eb8beb82df6ed103; }, function (v) { return $8b76a15172595c2c$export$eb8beb82df6ed103 = v; });
$parcel$export($8b76a15172595c2c$exports, "head", function () { return $8b76a15172595c2c$export$5fd5031fecdacec3; }, function (v) { return $8b76a15172595c2c$export$5fd5031fecdacec3 = v; });
$parcel$export($8b76a15172595c2c$exports, "title", function () { return $8b76a15172595c2c$export$fb184b623420d9be; }, function (v) { return $8b76a15172595c2c$export$fb184b623420d9be = v; });
$parcel$export($8b76a15172595c2c$exports, "blue", function () { return $8b76a15172595c2c$export$2aa0182783e7e9de; }, function (v) { return $8b76a15172595c2c$export$2aa0182783e7e9de = v; });
$parcel$export($8b76a15172595c2c$exports, "red", function () { return $8b76a15172595c2c$export$a90204d1394caf30; }, function (v) { return $8b76a15172595c2c$export$a90204d1394caf30 = v; });
$parcel$export($8b76a15172595c2c$exports, "black", function () { return $8b76a15172595c2c$export$c073df10e766abfa; }, function (v) { return $8b76a15172595c2c$export$c073df10e766abfa = v; });
$parcel$export($8b76a15172595c2c$exports, "multi", function () { return $8b76a15172595c2c$export$13e2537ceeaf8a3a; }, function (v) { return $8b76a15172595c2c$export$13e2537ceeaf8a3a = v; });
$parcel$export($8b76a15172595c2c$exports, "purple", function () { return $8b76a15172595c2c$export$e13cce2a2d16a9d4; }, function (v) { return $8b76a15172595c2c$export$e13cce2a2d16a9d4 = v; });
$parcel$export($8b76a15172595c2c$exports, "green", function () { return $8b76a15172595c2c$export$955a2ebd2fb142ae; }, function (v) { return $8b76a15172595c2c$export$955a2ebd2fb142ae = v; });
$parcel$export($8b76a15172595c2c$exports, "white", function () { return $8b76a15172595c2c$export$8fa4e5556fd77a60; }, function (v) { return $8b76a15172595c2c$export$8fa4e5556fd77a60 = v; });
$parcel$export($8b76a15172595c2c$exports, "description", function () { return $8b76a15172595c2c$export$6d59db4903f20f7d; }, function (v) { return $8b76a15172595c2c$export$6d59db4903f20f7d = v; });
$parcel$export($8b76a15172595c2c$exports, "imageContainer", function () { return $8b76a15172595c2c$export$63e82393dc8977bf; }, function (v) { return $8b76a15172595c2c$export$63e82393dc8977bf = v; });
$parcel$export($8b76a15172595c2c$exports, "image", function () { return $8b76a15172595c2c$export$5c452ff88e35e47d; }, function (v) { return $8b76a15172595c2c$export$5c452ff88e35e47d = v; });
$parcel$export($8b76a15172595c2c$exports, "tall", function () { return $8b76a15172595c2c$export$d06da4f97bb01f71; }, function (v) { return $8b76a15172595c2c$export$d06da4f97bb01f71 = v; });
$parcel$export($8b76a15172595c2c$exports, "medium", function () { return $8b76a15172595c2c$export$649ecc744817b5c7; }, function (v) { return $8b76a15172595c2c$export$649ecc744817b5c7 = v; });
$parcel$export($8b76a15172595c2c$exports, "intermediate", function () { return $8b76a15172595c2c$export$28824b7d7b72532c; }, function (v) { return $8b76a15172595c2c$export$28824b7d7b72532c = v; });
$parcel$export($8b76a15172595c2c$exports, "shadow", function () { return $8b76a15172595c2c$export$b8972b998723d602; }, function (v) { return $8b76a15172595c2c$export$b8972b998723d602 = v; });
$parcel$export($8b76a15172595c2c$exports, "border", function () { return $8b76a15172595c2c$export$1edee58a52776cd9; }, function (v) { return $8b76a15172595c2c$export$1edee58a52776cd9 = v; });
var $8b76a15172595c2c$export$eb8beb82df6ed103;
var $8b76a15172595c2c$export$5fd5031fecdacec3;
var $8b76a15172595c2c$export$fb184b623420d9be;
var $8b76a15172595c2c$export$2aa0182783e7e9de;
var $8b76a15172595c2c$export$a90204d1394caf30;
var $8b76a15172595c2c$export$c073df10e766abfa;
var $8b76a15172595c2c$export$13e2537ceeaf8a3a;
var $8b76a15172595c2c$export$e13cce2a2d16a9d4;
var $8b76a15172595c2c$export$955a2ebd2fb142ae;
var $8b76a15172595c2c$export$8fa4e5556fd77a60;
var $8b76a15172595c2c$export$6d59db4903f20f7d;
var $8b76a15172595c2c$export$63e82393dc8977bf;
var $8b76a15172595c2c$export$5c452ff88e35e47d;
var $8b76a15172595c2c$export$d06da4f97bb01f71;
var $8b76a15172595c2c$export$649ecc744817b5c7;
var $8b76a15172595c2c$export$28824b7d7b72532c;
var $8b76a15172595c2c$export$b8972b998723d602;
var $8b76a15172595c2c$export$1edee58a52776cd9;
$8b76a15172595c2c$export$eb8beb82df6ed103 = "ygavk";
$8b76a15172595c2c$export$5fd5031fecdacec3 = "r4yEW";
$8b76a15172595c2c$export$fb184b623420d9be = "wUGOp";
$8b76a15172595c2c$export$2aa0182783e7e9de = "sGXHA";
$8b76a15172595c2c$export$a90204d1394caf30 = "B3jpP";
$8b76a15172595c2c$export$c073df10e766abfa = "G-DXY";
$8b76a15172595c2c$export$13e2537ceeaf8a3a = "_60-BV";
$8b76a15172595c2c$export$e13cce2a2d16a9d4 = "gxllE";
$8b76a15172595c2c$export$955a2ebd2fb142ae = "zsO-A";
$8b76a15172595c2c$export$8fa4e5556fd77a60 = "YjMYk";
$8b76a15172595c2c$export$6d59db4903f20f7d = "UIyoX";
$8b76a15172595c2c$export$63e82393dc8977bf = "t9VEZ";
$8b76a15172595c2c$export$5c452ff88e35e47d = "VdJMY";
$8b76a15172595c2c$export$d06da4f97bb01f71 = "b-gKn";
$8b76a15172595c2c$export$649ecc744817b5c7 = "_3uO1H";
$8b76a15172595c2c$export$28824b7d7b72532c = "_37I23";
$8b76a15172595c2c$export$b8972b998723d602 = "a-Cfj";
$8b76a15172595c2c$export$1edee58a52776cd9 = "yOgS2";



var $wYO7b = parcelRequire("wYO7b");

var $a065dfaf6e33fc91$export$366de2f3346a7a26 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsitePresentationVerticalComponent, Component);
    function WebsitePresentationVerticalComponent(p) {
        (0, $3CDbU._)(this, WebsitePresentationVerticalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePresentationVerticalComponent);
        _this.imageComponent = p.imageComponent;
        _this.title = p.title;
        _this.image = p.image;
        _this.color = p.color;
        _this.size = p.size;
        _this.shadow = p.shadow;
        _this.border = p.border;
        //language=HTML
        _this.template = '\n            <div class="'.concat($8b76a15172595c2c$exports.componentWebsitePresentationVertical, '">\n                <div class="').concat($8b76a15172595c2c$exports.head, '">\n                    <h2 class="').concat($8b76a15172595c2c$exports.title, " ").concat($8b76a15172595c2c$exports[_this.color], '">\n                        ').concat(p.title, "\n                    </h2>\n                    ").concat(p.description ? '<p class="'.concat($8b76a15172595c2c$exports.description, '">').concat(p.description, "</p>") : "", "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsitePresentationVerticalComponent, [
        {
            key: "commit",
            value: function commit() {
                if (this.image || this.imageComponent) {
                    this.imageContainer = this.append('<div class="'.concat($8b76a15172595c2c$exports.imageContainer, '"></div>'));
                    if (this.imageComponent) this.imageContainer.render(this.imageComponent);
                    if (this.image) {
                        if (this.image.endsWith(".mp4")) this.imageContainer.render(new (0, $34133874689146b4$export$860f11a0f47b60ac)(this.image));
                        else //language=HTM
                        this.imageContainer.append('\n                        <img class="'.concat($8b76a15172595c2c$exports.image, " ").concat($8b76a15172595c2c$exports[this.size], " ").concat($8b76a15172595c2c$exports[this.shadow], " ").concat($8b76a15172595c2c$exports[this.border], '"\n                             src="').concat(this.image, '"\n                             alt="').concat((0, $wYO7b.Resources).t("words.sedestralInterfacePageRepresenting"), " : ").concat(this.title, '."/>'));
                    }
                }
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsitePresentationVerticalComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsitePresentationVerticalComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $b12866477c0049de$export$b81e1430fb6fcb09;
var $b12866477c0049de$export$6d59db4903f20f7d;
var $b12866477c0049de$export$53b3c91859018cd4;
var $b12866477c0049de$export$4e0c71f277ca26b3;
var $b12866477c0049de$export$1ca1ec8b29a4ce27;
var $b12866477c0049de$export$83aa05add7fe0e17;
var $b12866477c0049de$export$6f093cfa640b7166;
$b12866477c0049de$export$b81e1430fb6fcb09 = "zLXxD";
$b12866477c0049de$export$6d59db4903f20f7d = "pY2EZ";
$b12866477c0049de$export$53b3c91859018cd4 = "iEBgs";
$b12866477c0049de$export$4e0c71f277ca26b3 = "YigGP";
$b12866477c0049de$export$1ca1ec8b29a4ce27 = "h9h5Y";
$b12866477c0049de$export$83aa05add7fe0e17 = "oPrII";
$b12866477c0049de$export$6f093cfa640b7166 = "ES7VN";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $0b3776658751a630$export$68bb1055da0209bf = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteColumnsThreeWhiteComponent, Component);
    function WebsiteColumnsThreeWhiteComponent(p) {
        (0, $3CDbU._)(this, WebsiteColumnsThreeWhiteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteColumnsThreeWhiteComponent);
        _this.columns = p.columns;
        //language=HTML
        _this.template = '\n            <div class="'.concat($b12866477c0049de$export$b81e1430fb6fcb09, '">\n                <h2 class="').concat($b12866477c0049de$export$6d59db4903f20f7d, '">\n                    ').concat(p.title, '\n                </h2>\n                <div class="').concat($b12866477c0049de$export$53b3c91859018cd4, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteColumnsThreeWhiteComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.columnsContainer = this.el($b12866477c0049de$export$53b3c91859018cd4);
                this.columns.forEach(function(column) {
                    //language=HTML
                    if (column.state == 'normal') _this.columnsContainer.append('\n                    <div class="'.concat($b12866477c0049de$export$4e0c71f277ca26b3, '">\n                        <div class="').concat($b12866477c0049de$export$6f093cfa640b7166, '">\n                            ').concat(column.name, '\n                        </div>\n                        <div class="').concat($b12866477c0049de$export$1ca1ec8b29a4ce27, '">\n                            <img src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(column.picture, '" alt="').concat((0, $wYO7b.Resources).t("words.sedestralInterfacePageRepresenting"), " ").concat(column.name, '." height="" width="272.66" height="347.53" />\n                        </div>\n                    </div>\n                '));
                    else _this.columnsContainer.append('\n                    <div class="'.concat($b12866477c0049de$export$4e0c71f277ca26b3, '">\n                        <div class="').concat($b12866477c0049de$export$6f093cfa640b7166, '">\n                            ').concat(column.name, '\n                        </div>\n                        <div class="').concat($b12866477c0049de$export$1ca1ec8b29a4ce27, '">\n                            <img class="').concat($b12866477c0049de$export$83aa05add7fe0e17, '" src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(column.picture, '" alt="').concat((0, $wYO7b.Resources).t("words.sedestralInterfacePageRepresenting"), " ").concat(column.name, '." width="122.7" height="122.7"/>\n                        </div>\n                    </div>\n                '));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteColumnsThreeWhiteComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteColumnsThreeWhiteComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $e0d4f42efd7e7eab$export$4e81deb572f16c75;
var $e0d4f42efd7e7eab$export$6d59db4903f20f7d;
var $e0d4f42efd7e7eab$export$1ca1ec8b29a4ce27;
var $e0d4f42efd7e7eab$export$53b3c91859018cd4;
var $e0d4f42efd7e7eab$export$4e0c71f277ca26b3;
var $e0d4f42efd7e7eab$export$5c452ff88e35e47d;
$e0d4f42efd7e7eab$export$4e81deb572f16c75 = "k42bb";
$e0d4f42efd7e7eab$export$6d59db4903f20f7d = "uk1aS";
$e0d4f42efd7e7eab$export$1ca1ec8b29a4ce27 = "eD55P";
$e0d4f42efd7e7eab$export$53b3c91859018cd4 = "Zi-vH";
$e0d4f42efd7e7eab$export$4e0c71f277ca26b3 = "f9D4V";
$e0d4f42efd7e7eab$export$5c452ff88e35e47d = "fGNP5";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");


var $co7RM = parcelRequire("co7RM");
var $6632da5645e80027$export$7e355f9f7e662f9b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsitePresentationCapsuleComponent, Component);
    function WebsitePresentationCapsuleComponent() {
        (0, $3CDbU._)(this, WebsitePresentationCapsuleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePresentationCapsuleComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($e0d4f42efd7e7eab$export$4e81deb572f16c75, '">\n                <h2 class="').concat($e0d4f42efd7e7eab$export$6d59db4903f20f7d, '">\n                    ').concat((0, $wYO7b.Resources).t("words.customizeInbox"), '\n                </h2>\n                <div class="').concat($e0d4f42efd7e7eab$export$1ca1ec8b29a4ce27, '">\n                    ').concat(_this.draw(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).STATISTICS)), '\n                </div>\n                <div class="').concat($e0d4f42efd7e7eab$export$53b3c91859018cd4, '">\n                    <div class="').concat($e0d4f42efd7e7eab$export$4e0c71f277ca26b3, '">\n                        <img src="').concat((0, $3Qm5T.Network).vendor, 'images/illus-number-conversation.webp"\n                             alt="').concat((0, $wYO7b.Resources).t("words.statisticsNumberConversations"), '"\n                             height="248.54"\n                             width="354.66"\n                        />\n                    </div>\n                    <div class="').concat($e0d4f42efd7e7eab$export$4e0c71f277ca26b3, '">\n                        <img src="').concat((0, $3Qm5T.Network).vendor, 'images/illus-delay-answer.webp"\n                             alt="').concat((0, $wYO7b.Resources).t("words.statisticsResponseTime"), '"\n                             height="248.54"\n                             width="354.66"\n                        />\n                    </div>\n                    <div class="').concat($e0d4f42efd7e7eab$export$4e0c71f277ca26b3, '">\n                        <img src="').concat((0, $3Qm5T.Network).vendor, 'images/illus-conversation-hours.webp"\n                             alt="').concat((0, $wYO7b.Resources).t("words.statisticsHours"), '"\n                             height="248.54"\n                             width="354.66"\n                        />\n                    </div>\n                </div>\n                <div class="').concat($e0d4f42efd7e7eab$export$5c452ff88e35e47d, '">\n                    <img src="').concat((0, $3Qm5T.Network).vendor, 'images/capture-collaboraters.webp"\n                         alt="').concat((0, $wYO7b.Resources).t("words.classificationEmployees"), '"\n                         height="582.19"\n                         width="1035"\n                    />\n                </div>\n            </div>\n        ');
        return _this;
    }
    return WebsitePresentationCapsuleComponent;
}((0, $9gCL8.Component));



var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $43d7da80c7c470a8$exports = {};

$parcel$export($43d7da80c7c470a8$exports, "componentWebsiteIssues", function () { return $43d7da80c7c470a8$export$cc4c34968a089886; }, function (v) { return $43d7da80c7c470a8$export$cc4c34968a089886 = v; });
$parcel$export($43d7da80c7c470a8$exports, "black", function () { return $43d7da80c7c470a8$export$c073df10e766abfa; }, function (v) { return $43d7da80c7c470a8$export$c073df10e766abfa = v; });
$parcel$export($43d7da80c7c470a8$exports, "issue", function () { return $43d7da80c7c470a8$export$69ad3503f98be476; }, function (v) { return $43d7da80c7c470a8$export$69ad3503f98be476 = v; });
$parcel$export($43d7da80c7c470a8$exports, "icon", function () { return $43d7da80c7c470a8$export$1ca1ec8b29a4ce27; }, function (v) { return $43d7da80c7c470a8$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($43d7da80c7c470a8$exports, "title", function () { return $43d7da80c7c470a8$export$fb184b623420d9be; }, function (v) { return $43d7da80c7c470a8$export$fb184b623420d9be = v; });
$parcel$export($43d7da80c7c470a8$exports, "issues", function () { return $43d7da80c7c470a8$export$564c0735c817a25e; }, function (v) { return $43d7da80c7c470a8$export$564c0735c817a25e = v; });
$parcel$export($43d7da80c7c470a8$exports, "top", function () { return $43d7da80c7c470a8$export$1e95b668f3b82d; }, function (v) { return $43d7da80c7c470a8$export$1e95b668f3b82d = v; });
$parcel$export($43d7da80c7c470a8$exports, "more", function () { return $43d7da80c7c470a8$export$a627d162e8aad100; }, function (v) { return $43d7da80c7c470a8$export$a627d162e8aad100 = v; });
$parcel$export($43d7da80c7c470a8$exports, "name", function () { return $43d7da80c7c470a8$export$a8ff84c12d48cfa6; }, function (v) { return $43d7da80c7c470a8$export$a8ff84c12d48cfa6 = v; });
$parcel$export($43d7da80c7c470a8$exports, "open", function () { return $43d7da80c7c470a8$export$3ce6949f20cea765; }, function (v) { return $43d7da80c7c470a8$export$3ce6949f20cea765 = v; });
$parcel$export($43d7da80c7c470a8$exports, "rotationLeft", function () { return $43d7da80c7c470a8$export$831e6269d94587a; }, function (v) { return $43d7da80c7c470a8$export$831e6269d94587a = v; });
$parcel$export($43d7da80c7c470a8$exports, "close", function () { return $43d7da80c7c470a8$export$8360e631d277ea4d; }, function (v) { return $43d7da80c7c470a8$export$8360e631d277ea4d = v; });
$parcel$export($43d7da80c7c470a8$exports, "rotationRight", function () { return $43d7da80c7c470a8$export$f73ada0996849266; }, function (v) { return $43d7da80c7c470a8$export$f73ada0996849266 = v; });
$parcel$export($43d7da80c7c470a8$exports, "bottom", function () { return $43d7da80c7c470a8$export$40e543e69a8b3fbb; }, function (v) { return $43d7da80c7c470a8$export$40e543e69a8b3fbb = v; });
$parcel$export($43d7da80c7c470a8$exports, "description", function () { return $43d7da80c7c470a8$export$6d59db4903f20f7d; }, function (v) { return $43d7da80c7c470a8$export$6d59db4903f20f7d = v; });
$parcel$export($43d7da80c7c470a8$exports, "hidden", function () { return $43d7da80c7c470a8$export$73920f18ca706874; }, function (v) { return $43d7da80c7c470a8$export$73920f18ca706874 = v; });
var $43d7da80c7c470a8$export$cc4c34968a089886;
var $43d7da80c7c470a8$export$c073df10e766abfa;
var $43d7da80c7c470a8$export$69ad3503f98be476;
var $43d7da80c7c470a8$export$1ca1ec8b29a4ce27;
var $43d7da80c7c470a8$export$fb184b623420d9be;
var $43d7da80c7c470a8$export$564c0735c817a25e;
var $43d7da80c7c470a8$export$1e95b668f3b82d;
var $43d7da80c7c470a8$export$a627d162e8aad100;
var $43d7da80c7c470a8$export$a8ff84c12d48cfa6;
var $43d7da80c7c470a8$export$3ce6949f20cea765;
var $43d7da80c7c470a8$export$831e6269d94587a;
var $43d7da80c7c470a8$export$8360e631d277ea4d;
var $43d7da80c7c470a8$export$f73ada0996849266;
var $43d7da80c7c470a8$export$40e543e69a8b3fbb;
var $43d7da80c7c470a8$export$6d59db4903f20f7d;
var $43d7da80c7c470a8$export$73920f18ca706874;
$43d7da80c7c470a8$export$cc4c34968a089886 = "WXVPM";
$43d7da80c7c470a8$export$c073df10e766abfa = "_75msI";
$43d7da80c7c470a8$export$69ad3503f98be476 = "b4WII";
$43d7da80c7c470a8$export$1ca1ec8b29a4ce27 = "_-4sl-";
$43d7da80c7c470a8$export$fb184b623420d9be = "_9pqef";
$43d7da80c7c470a8$export$564c0735c817a25e = "_9XQAG";
$43d7da80c7c470a8$export$1e95b668f3b82d = "uxuJv";
$43d7da80c7c470a8$export$a627d162e8aad100 = "aouCN";
$43d7da80c7c470a8$export$a8ff84c12d48cfa6 = "lhJ--";
$43d7da80c7c470a8$export$3ce6949f20cea765 = "bipT9";
$43d7da80c7c470a8$export$831e6269d94587a = "NqxeD";
$43d7da80c7c470a8$export$8360e631d277ea4d = "UzkRX";
$43d7da80c7c470a8$export$f73ada0996849266 = "Myd3e";
$43d7da80c7c470a8$export$40e543e69a8b3fbb = "CDFtg";
$43d7da80c7c470a8$export$6d59db4903f20f7d = "-wtOZ";
$43d7da80c7c470a8$export$73920f18ca706874 = "n-yOA";



var $wYO7b = parcelRequire("wYO7b");
var $e208639b04565fea$export$f6f77077605a705e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteIssuesComponent, Component);
    function WebsiteIssuesComponent(p) {
        (0, $3CDbU._)(this, WebsiteIssuesComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteIssuesComponent);
        _this.questions = p.questions;
        if (_this.questions) //language=HTML
        _this.template = '\n                <div itemscope itemtype="https://schema.org/FAQPage"\n                     class="'.concat($43d7da80c7c470a8$exports.componentWebsiteIssues, " ").concat(p.theme ? $43d7da80c7c470a8$exports[p.theme] : "", '">\n                    <h2 itemprop="name" class="').concat($43d7da80c7c470a8$exports.title, '">\n                        ').concat((0, $wYO7b.Resources).t("words.faq"), '\n                    </h2>\n                    <div class="').concat($43d7da80c7c470a8$exports.issues, '">\n\n                    </div>\n                </div>\n            ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteIssuesComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                if (this.questions) {
                    this.questionsContainer = this.el($43d7da80c7c470a8$exports.issues);
                    this.questions.forEach(function(questions) {
                        //language=HTML
                        var questionComponent = _this.questionsContainer.append('\n                    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" class="'.concat($43d7da80c7c470a8$exports.issue, '">\n                        <div class="').concat($43d7da80c7c470a8$exports.top, '">\n                            <h3 itemprop="name" class="').concat($43d7da80c7c470a8$exports.name, '">\n                                ').concat(questions.question, '\n                            </h3>\n                            <div class="').concat($43d7da80c7c470a8$exports.more, '">\n                                <div class="').concat($43d7da80c7c470a8$exports.icon, " ").concat($43d7da80c7c470a8$exports.close, '"></div>\n                            </div>\n                        </div>\n                        <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer"\n                             class="').concat($43d7da80c7c470a8$exports.bottom, " ").concat($43d7da80c7c470a8$exports.hidden, '">\n                            <p itemprop="text" class="').concat($43d7da80c7c470a8$exports.description, '">\n                                ').concat(questions.response, "\n                            </p>\n                        </div>\n                    </div>\n                "));
                        questionComponent.el($43d7da80c7c470a8$exports.top).onClick(function() {
                            _this.hideResponse(questionComponent.el($43d7da80c7c470a8$exports.bottom), questionComponent.el($43d7da80c7c470a8$exports.icon));
                        });
                    });
                }
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteIssuesComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "hideResponse",
            value: function hideResponse(questions, icon) {
                if (questions.hasClass($43d7da80c7c470a8$exports.hidden)) {
                    questions.removeClass($43d7da80c7c470a8$exports.hidden);
                    icon.removeClass($43d7da80c7c470a8$exports.close);
                    icon.addClass($43d7da80c7c470a8$exports.open);
                } else {
                    questions.addClass($43d7da80c7c470a8$exports.hidden);
                    icon.removeClass($43d7da80c7c470a8$exports.open);
                    icon.addClass($43d7da80c7c470a8$exports.close);
                }
            }
        }
    ]);
    return WebsiteIssuesComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $e534db2eba311d2e$export$cc5daa14ab636235 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentInboxComponent, Component);
    function WebsiteContentInboxComponent() {
        (0, $3CDbU._)(this, WebsiteContentInboxComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentInboxComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($dfb6afb0b8149071$export$5016101a142bf96a, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.optimize"),
            text: (0, $wYO7b.Resources).t("words.completeSolution"),
            productType: (0, $co7RM.ProductType).INBOX,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-inbox.webp")
        })), '\n                    </div>\n                    <div class="').concat($dfb6afb0b8149071$export$3bf720ece7bc7b2e, '"></div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $951a12393fe71ff0$export$e4b6d83931e2a971)({
            title: (0, $wYO7b.Resources).t("words.sendAndReceive"),
            subtitle: (0, $wYO7b.Resources).t("words.createMails"),
            illus: "illus-mails-advanced",
            size: "medium",
            url: "https://sedestral.com/mail"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.liveChat"),
            description: (0, $wYO7b.Resources).t("words.customizeAndInstall"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-livechat-website.webp",
            color: "blue",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.replyTo"),
            description: (0, $wYO7b.Resources).t("words.connectNetworks"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-social.svg",
            color: "red",
            size: "medium"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.summarize"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-funnel.svg",
            color: "black",
            size: "medium"
        })), '\n                    </div>\n                    <div class="').concat($dfb6afb0b8149071$export$1f6feda8aa226b71, '">\n                        <div class="').concat($dfb6afb0b8149071$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $951a12393fe71ff0$export$e4b6d83931e2a971)({
            title: (0, $wYO7b.Resources).t("words.defined"),
            subtitle: (0, $wYO7b.Resources).t("words.limited"),
            illus: "illus-perms",
            size: "tall"
        })), '\n                        </div>\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.workTeam"),
            description: (0, $wYO7b.Resources).t("words.invitedCollaborator"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-content.webp",
            color: "blue",
            size: "tall"
        })), '\n                        </div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $0b3776658751a630$export$68bb1055da0209bf)({
            title: (0, $wYO7b.Resources).t("words.personalizeInbox"),
            columns: [
                {
                    name: (0, $wYO7b.Resources).t("words.createdInbox"),
                    picture: "illus-inbox.webp",
                    state: "normal"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.organizeCategroies"),
                    picture: "illus-categories.webp",
                    state: "normal"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.filtersTalks"),
                    picture: "illus-conversation.webp",
                    state: "normal"
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $6632da5645e80027$export$7e355f9f7e662f9b)()), '\n                    </div>\n                        <!--<div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        $ {this.draw(new WebsiteMobileComponent())}\n                    </div>-->\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.inbox")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentInboxComponent;
}((0, $9gCL8.Component));


var $de8535061b5d4d06$export$fdf70f43a3a81415 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteInboxPage, WebsitePageComponent);
    function WebsiteInboxPage() {
        (0, $3CDbU._)(this, WebsiteInboxPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteInboxPage);
        _this.updateMetas("inbox");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteInboxPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $e534db2eba311d2e$export$cc5daa14ab636235)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteInboxPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $0ecd471943016011$export$e434ce7de9258df4;
var $0ecd471943016011$export$fb184b623420d9be;
var $0ecd471943016011$export$4caf129a4f120781;
$0ecd471943016011$export$e434ce7de9258df4 = "FvVUi";
$0ecd471943016011$export$fb184b623420d9be = "PlotT";
$0ecd471943016011$export$4caf129a4f120781 = "t2Z1k";




var $wYO7b = parcelRequire("wYO7b");


var $co7RM = parcelRequire("co7RM");
var $386e957982502a0f$export$d1e51e80a9e142de = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentPricingComponent, Component);
    function WebsiteContentPricingComponent() {
        (0, $3CDbU._)(this, WebsiteContentPricingComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentPricingComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($0ecd471943016011$export$e434ce7de9258df4, '">\n                <div style="gap:20px;" class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <h2 class="').concat($0ecd471943016011$export$fb184b623420d9be, '">\n                        ').concat((0, $wYO7b.Resources).t("words.sedestralRates"), '\n                    </h2>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            <div class="').concat($0ecd471943016011$export$4caf129a4f120781, '">\n                                ').concat(_this.draw(new (0, $a587bf5cffbf7150$export$b39970eebb991951)((0, $co7RM.ProductType).BLOG, undefined, true)), '\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div style="gap:20px;" class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: (0, $wYO7b.Resources).t("words.questions.pricing")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentPricingComponent;
}((0, $9gCL8.Component));


var $78c597d9d50d6293$export$36d652602e27a852 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsitePricingPage, WebsitePageComponent);
    function WebsitePricingPage() {
        (0, $3CDbU._)(this, WebsitePricingPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePricingPage);
        _this.updateMetas("pricing");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsitePricingPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $386e957982502a0f$export$d1e51e80a9e142de)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsitePricingPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $c4d18c363f69c643$export$1d90f4fd07c087ab;
var $c4d18c363f69c643$export$fb184b623420d9be;
var $c4d18c363f69c643$export$53b3c91859018cd4;
var $c4d18c363f69c643$export$4e0c71f277ca26b3;
var $c4d18c363f69c643$export$41ee12f6f6f05843;
var $c4d18c363f69c643$export$1ca1ec8b29a4ce27;
var $c4d18c363f69c643$export$be246276456a52e7;
var $c4d18c363f69c643$export$b714fa498b091246;
var $c4d18c363f69c643$export$1f6feda8aa226b71;
var $c4d18c363f69c643$export$30780d0b6b610af8;
var $c4d18c363f69c643$export$a8ff84c12d48cfa6;
var $c4d18c363f69c643$export$6d59db4903f20f7d;
var $c4d18c363f69c643$export$bb5ee47d9ea2348e;
var $c4d18c363f69c643$export$98e628dec113755e;
var $c4d18c363f69c643$export$2f151dcf7eae7881;
$c4d18c363f69c643$export$1d90f4fd07c087ab = "EJBeL";
$c4d18c363f69c643$export$fb184b623420d9be = "MI3-z";
$c4d18c363f69c643$export$53b3c91859018cd4 = "ayTYF";
$c4d18c363f69c643$export$4e0c71f277ca26b3 = "J2-sU";
$c4d18c363f69c643$export$41ee12f6f6f05843 = "Hw6UG";
$c4d18c363f69c643$export$1ca1ec8b29a4ce27 = "wxJra";
$c4d18c363f69c643$export$be246276456a52e7 = "kLb-5";
$c4d18c363f69c643$export$b714fa498b091246 = "_63sdn";
$c4d18c363f69c643$export$1f6feda8aa226b71 = "_7TnQ3";
$c4d18c363f69c643$export$30780d0b6b610af8 = "-WFi7";
$c4d18c363f69c643$export$a8ff84c12d48cfa6 = "_3y1At";
$c4d18c363f69c643$export$6d59db4903f20f7d = "_9LxgU";
$c4d18c363f69c643$export$bb5ee47d9ea2348e = "HmgLg";
$c4d18c363f69c643$export$98e628dec113755e = "nv92A";
$c4d18c363f69c643$export$2f151dcf7eae7881 = "_4EZm0";





var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $ed8a693e6fc268c3$exports = {};

$parcel$export($ed8a693e6fc268c3$exports, "componentWebsiteColumnsDouble", function () { return $ed8a693e6fc268c3$export$562aeeb04ebda242; }, function (v) { return $ed8a693e6fc268c3$export$562aeeb04ebda242 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "head", function () { return $ed8a693e6fc268c3$export$5fd5031fecdacec3; }, function (v) { return $ed8a693e6fc268c3$export$5fd5031fecdacec3 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "title", function () { return $ed8a693e6fc268c3$export$fb184b623420d9be; }, function (v) { return $ed8a693e6fc268c3$export$fb184b623420d9be = v; });
$parcel$export($ed8a693e6fc268c3$exports, "black", function () { return $ed8a693e6fc268c3$export$c073df10e766abfa; }, function (v) { return $ed8a693e6fc268c3$export$c073df10e766abfa = v; });
$parcel$export($ed8a693e6fc268c3$exports, "red", function () { return $ed8a693e6fc268c3$export$a90204d1394caf30; }, function (v) { return $ed8a693e6fc268c3$export$a90204d1394caf30 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "multi", function () { return $ed8a693e6fc268c3$export$13e2537ceeaf8a3a; }, function (v) { return $ed8a693e6fc268c3$export$13e2537ceeaf8a3a = v; });
$parcel$export($ed8a693e6fc268c3$exports, "columns", function () { return $ed8a693e6fc268c3$export$53b3c91859018cd4; }, function (v) { return $ed8a693e6fc268c3$export$53b3c91859018cd4 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "column", function () { return $ed8a693e6fc268c3$export$4e0c71f277ca26b3; }, function (v) { return $ed8a693e6fc268c3$export$4e0c71f277ca26b3 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "icon", function () { return $ed8a693e6fc268c3$export$1ca1ec8b29a4ce27; }, function (v) { return $ed8a693e6fc268c3$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "seo", function () { return $ed8a693e6fc268c3$export$7dc4b9367473a505; }, function (v) { return $ed8a693e6fc268c3$export$7dc4b9367473a505 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "handshake", function () { return $ed8a693e6fc268c3$export$3b7178ef4b094956; }, function (v) { return $ed8a693e6fc268c3$export$3b7178ef4b094956 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "customerService", function () { return $ed8a693e6fc268c3$export$8a83870103bcf376; }, function (v) { return $ed8a693e6fc268c3$export$8a83870103bcf376 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "transaction", function () { return $ed8a693e6fc268c3$export$2d62d2646dd2fb3c; }, function (v) { return $ed8a693e6fc268c3$export$2d62d2646dd2fb3c = v; });
$parcel$export($ed8a693e6fc268c3$exports, "error", function () { return $ed8a693e6fc268c3$export$a3bc9b8ed74fc; }, function (v) { return $ed8a693e6fc268c3$export$a3bc9b8ed74fc = v; });
$parcel$export($ed8a693e6fc268c3$exports, "mailSpam", function () { return $ed8a693e6fc268c3$export$19f83829f98e3e86; }, function (v) { return $ed8a693e6fc268c3$export$19f83829f98e3e86 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "letter", function () { return $ed8a693e6fc268c3$export$30780d0b6b610af8; }, function (v) { return $ed8a693e6fc268c3$export$30780d0b6b610af8 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "articleAi", function () { return $ed8a693e6fc268c3$export$60c7b865d28898e9; }, function (v) { return $ed8a693e6fc268c3$export$60c7b865d28898e9 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "name", function () { return $ed8a693e6fc268c3$export$a8ff84c12d48cfa6; }, function (v) { return $ed8a693e6fc268c3$export$a8ff84c12d48cfa6 = v; });
$parcel$export($ed8a693e6fc268c3$exports, "text", function () { return $ed8a693e6fc268c3$export$6f093cfa640b7166; }, function (v) { return $ed8a693e6fc268c3$export$6f093cfa640b7166 = v; });
var $ed8a693e6fc268c3$export$562aeeb04ebda242;
var $ed8a693e6fc268c3$export$5fd5031fecdacec3;
var $ed8a693e6fc268c3$export$fb184b623420d9be;
var $ed8a693e6fc268c3$export$c073df10e766abfa;
var $ed8a693e6fc268c3$export$a90204d1394caf30;
var $ed8a693e6fc268c3$export$13e2537ceeaf8a3a;
var $ed8a693e6fc268c3$export$53b3c91859018cd4;
var $ed8a693e6fc268c3$export$4e0c71f277ca26b3;
var $ed8a693e6fc268c3$export$1ca1ec8b29a4ce27;
var $ed8a693e6fc268c3$export$7dc4b9367473a505;
var $ed8a693e6fc268c3$export$3b7178ef4b094956;
var $ed8a693e6fc268c3$export$8a83870103bcf376;
var $ed8a693e6fc268c3$export$2d62d2646dd2fb3c;
var $ed8a693e6fc268c3$export$a3bc9b8ed74fc;
var $ed8a693e6fc268c3$export$19f83829f98e3e86;
var $ed8a693e6fc268c3$export$30780d0b6b610af8;
var $ed8a693e6fc268c3$export$60c7b865d28898e9;
var $ed8a693e6fc268c3$export$a8ff84c12d48cfa6;
var $ed8a693e6fc268c3$export$6f093cfa640b7166;
$ed8a693e6fc268c3$export$562aeeb04ebda242 = "l5Zya";
$ed8a693e6fc268c3$export$5fd5031fecdacec3 = "FMAOs";
$ed8a693e6fc268c3$export$fb184b623420d9be = "HsUnm";
$ed8a693e6fc268c3$export$c073df10e766abfa = "Vy0CW";
$ed8a693e6fc268c3$export$a90204d1394caf30 = "lsnCj";
$ed8a693e6fc268c3$export$13e2537ceeaf8a3a = "PZ0UG";
$ed8a693e6fc268c3$export$53b3c91859018cd4 = "ett64";
$ed8a693e6fc268c3$export$4e0c71f277ca26b3 = "fRL0f";
$ed8a693e6fc268c3$export$1ca1ec8b29a4ce27 = "octwo";
$ed8a693e6fc268c3$export$7dc4b9367473a505 = "FXwLh";
$ed8a693e6fc268c3$export$3b7178ef4b094956 = "d1sAN";
$ed8a693e6fc268c3$export$8a83870103bcf376 = "OQ5TK";
$ed8a693e6fc268c3$export$2d62d2646dd2fb3c = "zVly8";
$ed8a693e6fc268c3$export$a3bc9b8ed74fc = "_9LXQs";
$ed8a693e6fc268c3$export$19f83829f98e3e86 = "Yz97v";
$ed8a693e6fc268c3$export$30780d0b6b610af8 = "_2J2d9";
$ed8a693e6fc268c3$export$60c7b865d28898e9 = "ZoKpH";
$ed8a693e6fc268c3$export$a8ff84c12d48cfa6 = "lt4HJ";
$ed8a693e6fc268c3$export$6f093cfa640b7166 = "zArqQ";


var $63f6c7e7bfe0384f$export$d8eb6fbe0ee5dec2 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteColumnsDoubleComponent, Component);
    function WebsiteColumnsDoubleComponent(p) {
        (0, $3CDbU._)(this, WebsiteColumnsDoubleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteColumnsDoubleComponent);
        _this.color = p.color;
        _this.columns = p.columns;
        //language=HTML
        _this.template = '\n            <div class="'.concat($ed8a693e6fc268c3$exports.componentWebsiteColumnsDouble, '">\n                <div class="').concat($ed8a693e6fc268c3$exports.head, '">\n                    <h3 class="').concat($ed8a693e6fc268c3$exports.title, " ").concat(_this.color ? $ed8a693e6fc268c3$exports[_this.color] : "", '">\n                        ').concat(p.title, '\n                    </h3>\n                </div>\n                <div class="').concat($ed8a693e6fc268c3$exports.columns, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteColumnsDoubleComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.columnsContainer = this.el($ed8a693e6fc268c3$exports.columns);
                this.columns.forEach(function(column) {
                    //language=HTML
                    _this.columnsContainer.append('\n                <div class="'.concat($ed8a693e6fc268c3$exports.column, '">\n                    <div class="').concat($ed8a693e6fc268c3$exports.icon, " ").concat($ed8a693e6fc268c3$exports[column.icon], '"></div>\n                    <h4 class="').concat($ed8a693e6fc268c3$exports.name, '">\n                        ').concat(column.name, '\n                    </h4>\n                    <p class="').concat($ed8a693e6fc268c3$exports.text, '">\n                        ').concat(column.text, "\n                    </p>\n                </div>\n            "));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteColumnsDoubleComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteColumnsDoubleComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");


var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $db62148f7de3d193$export$f03a647dc37f632a = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteColumnsStepsComponent, Component);
    function WebsiteColumnsStepsComponent(p) {
        (0, $3CDbU._)(this, WebsiteColumnsStepsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteColumnsStepsComponent);
        _this.entries = p.grid;
        //language=HTML
        _this.template = '\n            <div class="'.concat($c4d18c363f69c643$export$1d90f4fd07c087ab, '">\n                <h3 class="').concat($c4d18c363f69c643$export$fb184b623420d9be, '">\n                    ').concat(p.title, '\n                </h3>\n                <div class="').concat($c4d18c363f69c643$export$53b3c91859018cd4, '">\n                    \n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteColumnsStepsComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.contentContainer = this.el($c4d18c363f69c643$export$53b3c91859018cd4);
                var lineUrl = "".concat((0, $3Qm5T.Network).vendor, "images/separator-wave.webp");
                var number = 1;
                this.entries.forEach(function(value) {
                    //language=HTML
                    var entry = _this.contentContainer.append('\n                <div class="'.concat($c4d18c363f69c643$export$4e0c71f277ca26b3, '">\n                    <div class="').concat($c4d18c363f69c643$export$41ee12f6f6f05843, '">\n                        <div class="').concat($c4d18c363f69c643$export$1ca1ec8b29a4ce27, " ").concat(value.icon, '"></div>\n                        <h4 class="').concat($c4d18c363f69c643$export$a8ff84c12d48cfa6, '">\n                            ').concat(value.name, '\n                        </h4>\n                        <p class="').concat($c4d18c363f69c643$export$6d59db4903f20f7d, '">\n                            ').concat(value.description, '\n                        </p>\n                    </div>\n                    <img src="').concat(lineUrl, '" class="').concat($c4d18c363f69c643$export$bb5ee47d9ea2348e, '" alt="').concat((0, $wYO7b.Resources).t("words.presentationLine"), '"\n                         onmousedown="return false" onmousemove="return false"/>\n                    <div class="').concat($c4d18c363f69c643$export$98e628dec113755e, '">\n                        <p class="').concat($c4d18c363f69c643$export$2f151dcf7eae7881, '">').concat(number, "</p>\n                    </div>\n                </div>\n            "));
                    number++;
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteColumnsStepsComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteColumnsStepsComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $d1a89f682012501f$exports = {};

$parcel$export($d1a89f682012501f$exports, "componentWebsiteSliderLeft", function () { return $d1a89f682012501f$export$bfc36268175233c; }, function (v) { return $d1a89f682012501f$export$bfc36268175233c = v; });
$parcel$export($d1a89f682012501f$exports, "title", function () { return $d1a89f682012501f$export$fb184b623420d9be; }, function (v) { return $d1a89f682012501f$export$fb184b623420d9be = v; });
$parcel$export($d1a89f682012501f$exports, "slider", function () { return $d1a89f682012501f$export$b38bf4f33e9e4c25; }, function (v) { return $d1a89f682012501f$export$b38bf4f33e9e4c25 = v; });
$parcel$export($d1a89f682012501f$exports, "left", function () { return $d1a89f682012501f$export$eabcd2c8791e7bf4; }, function (v) { return $d1a89f682012501f$export$eabcd2c8791e7bf4 = v; });
$parcel$export($d1a89f682012501f$exports, "entry", function () { return $d1a89f682012501f$export$c407db72103fecfa; }, function (v) { return $d1a89f682012501f$export$c407db72103fecfa = v; });
$parcel$export($d1a89f682012501f$exports, "selected", function () { return $d1a89f682012501f$export$d90250155de6d7e7; }, function (v) { return $d1a89f682012501f$export$d90250155de6d7e7 = v; });
$parcel$export($d1a89f682012501f$exports, "titles", function () { return $d1a89f682012501f$export$1cbbc5990c2ee230; }, function (v) { return $d1a89f682012501f$export$1cbbc5990c2ee230 = v; });
$parcel$export($d1a89f682012501f$exports, "icon", function () { return $d1a89f682012501f$export$1ca1ec8b29a4ce27; }, function (v) { return $d1a89f682012501f$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($d1a89f682012501f$exports, "draft", function () { return $d1a89f682012501f$export$3776927205fb6aff; }, function (v) { return $d1a89f682012501f$export$3776927205fb6aff = v; });
$parcel$export($d1a89f682012501f$exports, "section", function () { return $d1a89f682012501f$export$fe2e36411d703b3d; }, function (v) { return $d1a89f682012501f$export$fe2e36411d703b3d = v; });
$parcel$export($d1a89f682012501f$exports, "paragraph", function () { return $d1a89f682012501f$export$9c206ddddb32a9b; }, function (v) { return $d1a89f682012501f$export$9c206ddddb32a9b = v; });
$parcel$export($d1a89f682012501f$exports, "trombone", function () { return $d1a89f682012501f$export$d1d7a8444e6e2c0e; }, function (v) { return $d1a89f682012501f$export$d1d7a8444e6e2c0e = v; });
$parcel$export($d1a89f682012501f$exports, "writePaper", function () { return $d1a89f682012501f$export$8f2886ebc4b1fa1a; }, function (v) { return $d1a89f682012501f$export$8f2886ebc4b1fa1a = v; });
$parcel$export($d1a89f682012501f$exports, "pensil", function () { return $d1a89f682012501f$export$b714fa498b091246; }, function (v) { return $d1a89f682012501f$export$b714fa498b091246 = v; });
$parcel$export($d1a89f682012501f$exports, "clock", function () { return $d1a89f682012501f$export$8c9e255416017e56; }, function (v) { return $d1a89f682012501f$export$8c9e255416017e56 = v; });
$parcel$export($d1a89f682012501f$exports, "home", function () { return $d1a89f682012501f$export$d12a05a2da93ee73; }, function (v) { return $d1a89f682012501f$export$d12a05a2da93ee73 = v; });
$parcel$export($d1a89f682012501f$exports, "mail", function () { return $d1a89f682012501f$export$b602b78110e4ab1e; }, function (v) { return $d1a89f682012501f$export$b602b78110e4ab1e = v; });
$parcel$export($d1a89f682012501f$exports, "mailAlias", function () { return $d1a89f682012501f$export$d1bf21c0c67a443b; }, function (v) { return $d1a89f682012501f$export$d1bf21c0c67a443b = v; });
$parcel$export($d1a89f682012501f$exports, "domains", function () { return $d1a89f682012501f$export$5d15c6f5dc2166f9; }, function (v) { return $d1a89f682012501f$export$5d15c6f5dc2166f9 = v; });
$parcel$export($d1a89f682012501f$exports, "description", function () { return $d1a89f682012501f$export$6d59db4903f20f7d; }, function (v) { return $d1a89f682012501f$export$6d59db4903f20f7d = v; });
$parcel$export($d1a89f682012501f$exports, "content", function () { return $d1a89f682012501f$export$a7db06668cad9adb; }, function (v) { return $d1a89f682012501f$export$a7db06668cad9adb = v; });
$parcel$export($d1a89f682012501f$exports, "picture", function () { return $d1a89f682012501f$export$1188214e9d38144e; }, function (v) { return $d1a89f682012501f$export$1188214e9d38144e = v; });
$parcel$export($d1a89f682012501f$exports, "hidden", function () { return $d1a89f682012501f$export$73920f18ca706874; }, function (v) { return $d1a89f682012501f$export$73920f18ca706874 = v; });
var $d1a89f682012501f$export$bfc36268175233c;
var $d1a89f682012501f$export$fb184b623420d9be;
var $d1a89f682012501f$export$b38bf4f33e9e4c25;
var $d1a89f682012501f$export$eabcd2c8791e7bf4;
var $d1a89f682012501f$export$c407db72103fecfa;
var $d1a89f682012501f$export$d90250155de6d7e7;
var $d1a89f682012501f$export$1cbbc5990c2ee230;
var $d1a89f682012501f$export$1ca1ec8b29a4ce27;
var $d1a89f682012501f$export$3776927205fb6aff;
var $d1a89f682012501f$export$fe2e36411d703b3d;
var $d1a89f682012501f$export$9c206ddddb32a9b;
var $d1a89f682012501f$export$d1d7a8444e6e2c0e;
var $d1a89f682012501f$export$8f2886ebc4b1fa1a;
var $d1a89f682012501f$export$b714fa498b091246;
var $d1a89f682012501f$export$8c9e255416017e56;
var $d1a89f682012501f$export$d12a05a2da93ee73;
var $d1a89f682012501f$export$b602b78110e4ab1e;
var $d1a89f682012501f$export$d1bf21c0c67a443b;
var $d1a89f682012501f$export$5d15c6f5dc2166f9;
var $d1a89f682012501f$export$6d59db4903f20f7d;
var $d1a89f682012501f$export$a7db06668cad9adb;
var $d1a89f682012501f$export$1188214e9d38144e;
var $d1a89f682012501f$export$73920f18ca706874;
$d1a89f682012501f$export$bfc36268175233c = "YUUlr";
$d1a89f682012501f$export$fb184b623420d9be = "lSnh6";
$d1a89f682012501f$export$b38bf4f33e9e4c25 = "fXBXT";
$d1a89f682012501f$export$eabcd2c8791e7bf4 = "grb3R";
$d1a89f682012501f$export$c407db72103fecfa = "K5cGb";
$d1a89f682012501f$export$d90250155de6d7e7 = "Y7GTC";
$d1a89f682012501f$export$1cbbc5990c2ee230 = "Qv4F5";
$d1a89f682012501f$export$1ca1ec8b29a4ce27 = "Ukb7J";
$d1a89f682012501f$export$3776927205fb6aff = "qOyeS";
$d1a89f682012501f$export$fe2e36411d703b3d = "TKD4b";
$d1a89f682012501f$export$9c206ddddb32a9b = "eMtn6";
$d1a89f682012501f$export$d1d7a8444e6e2c0e = "dEJ1d";
$d1a89f682012501f$export$8f2886ebc4b1fa1a = "uxSRm";
$d1a89f682012501f$export$b714fa498b091246 = "YVX28";
$d1a89f682012501f$export$8c9e255416017e56 = "xMOQY";
$d1a89f682012501f$export$d12a05a2da93ee73 = "OaGwx";
$d1a89f682012501f$export$b602b78110e4ab1e = "exXmA";
$d1a89f682012501f$export$d1bf21c0c67a443b = "zCXRG";
$d1a89f682012501f$export$5d15c6f5dc2166f9 = "X52gr";
$d1a89f682012501f$export$6d59db4903f20f7d = "pofdZ";
$d1a89f682012501f$export$a7db06668cad9adb = "-zrsP";
$d1a89f682012501f$export$1188214e9d38144e = "wGI6i";
$d1a89f682012501f$export$73920f18ca706874 = "yvUa4";


var $11905550a94e3587$export$21cf7e1029971b9d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteSliderLeftComponent, Component);
    function WebsiteSliderLeftComponent(title, entries) {
        (0, $3CDbU._)(this, WebsiteSliderLeftComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteSliderLeftComponent);
        _this.entries = entries;
        _this.entriesComponents = [];
        //language=HTML
        _this.template = '\n            <div class="'.concat($d1a89f682012501f$exports.componentWebsiteSliderLeft, '">\n                <h3 class="').concat($d1a89f682012501f$exports.title, '">\n                    ').concat(title, '\n                </h3>\n                <div class="').concat($d1a89f682012501f$exports.slider, '">\n                    <div class="').concat($d1a89f682012501f$exports.left, '"></div>\n                    <div class="').concat($d1a89f682012501f$exports.content, '"></div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteSliderLeftComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.leftContainer = this.el($d1a89f682012501f$exports.left);
                this.contentContainer = this.el($d1a89f682012501f$exports.content);
                this.entries.forEach(function(value) {
                    //language=HTML
                    var entry = _this.leftContainer.append('\n                <div class="'.concat($d1a89f682012501f$exports.entry, " ").concat($d1a89f682012501f$exports.selected, '">\n                    <div class="').concat($d1a89f682012501f$exports.titles, '">\n                        <div class="').concat($d1a89f682012501f$exports.icon, " ").concat($d1a89f682012501f$exports[value.icon], '"></div>\n                        <h4 class="').concat($d1a89f682012501f$exports.title, '">\n                            ').concat(value.title, '\n                        </h4>\n                    </div>\n                    <p class="').concat($d1a89f682012501f$exports.description, '">\n                        ').concat(value.desc, "\n                    </p>\n                </div>\n            "));
                    entry.onClick(function() {
                        return _this.select(_this.entries.indexOf(value));
                    });
                    _this.entriesComponents.push(entry);
                });
                this.select(0);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteSliderLeftComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "select",
            value: function select(index) {
                this.contentContainer.clearAll();
                this.entriesComponents.forEach(function(value) {
                    return value.removeClass($d1a89f682012501f$exports.selected);
                });
                var value = this.entries[index];
                var entry = this.entriesComponents[index];
                entry.addClass($d1a89f682012501f$exports.selected);
                this.contentContainer.append('<img src="'.concat(value.image, '" class="').concat($d1a89f682012501f$exports.picture, '" alt="').concat(value.title, '" height="').concat(value.height, '" width="').concat(value.width, '"/>'));
            }
        }
    ]);
    return WebsiteSliderLeftComponent;
}((0, $9gCL8.Component));



var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");


var $wYO7b = parcelRequire("wYO7b");
var $2941544806245097$export$1b5d99909ed4e8af = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentLivechatComponent, Component);
    function WebsiteContentLivechatComponent() {
        (0, $3CDbU._)(this, WebsiteContentLivechatComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentLivechatComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.websiteLivechat"),
            text: (0, $wYO7b.Resources).t("words.installSolution"),
            productType: (0, $co7RM.ProductType).LIVECHAT,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-livechat.webp")
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $63f6c7e7bfe0384f$export$d8eb6fbe0ee5dec2)({
            color: "black",
            title: (0, $wYO7b.Resources).t("words.relationship"),
            columns: [
                {
                    icon: "customerService",
                    name: "Support",
                    text: (0, $wYO7b.Resources).t("words.helpCustomer")
                },
                {
                    icon: "transaction",
                    name: "Ventes",
                    text: (0, $wYO7b.Resources).t("words.quickContact")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $db62148f7de3d193$export$f03a647dc37f632a)({
            title: (0, $wYO7b.Resources).t("words.startNow"),
            grid: [
                {
                    name: (0, $wYO7b.Resources).t("words.download"),
                    description: (0, $wYO7b.Resources).t("words.codeCopy"),
                    icon: $c4d18c363f69c643$export$be246276456a52e7
                },
                {
                    name: (0, $wYO7b.Resources).t("words.customize"),
                    description: (0, $wYO7b.Resources).t("words.colorCustomize"),
                    icon: $c4d18c363f69c643$export$b714fa498b091246
                },
                {
                    name: (0, $wYO7b.Resources).t("words.start"),
                    description: (0, $wYO7b.Resources).t("words.startReply"),
                    icon: $c4d18c363f69c643$export$30780d0b6b610af8
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.customerChatbox"),
            description: (0, $wYO7b.Resources).t("words.fullyCustomizableLivechat"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-livechats.webp",
            color: "multi",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $11905550a94e3587$export$21cf7e1029971b9d)((0, $wYO7b.Resources).t("words.features"), [
            {
                icon: "trombone",
                title: (0, $wYO7b.Resources).t("words.files"),
                desc: (0, $wYO7b.Resources).t("words.shareFiles"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "content-files.webp",
                width: "223.81",
                height: "399.98"
            },
            {
                icon: "writePaper",
                title: (0, $wYO7b.Resources).t("words.answerQuickly"),
                desc: (0, $wYO7b.Resources).t("words.predefinedTexts"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "content-answerQuickly.webp",
                width: "547.11",
                height: "399.99"
            },
            {
                icon: "pensil",
                title: (0, $wYO7b.Resources).t("words.collectInformations"),
                desc: (0, $wYO7b.Resources).t("words.customersForm"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "content-form.webp",
                width: "223.2",
                height: "399.98"
            },
            {
                icon: "clock",
                title: (0, $wYO7b.Resources).t("words.activity"),
                desc: (0, $wYO7b.Resources).t("words.activityHours"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "content-informationGathering.webp",
                width: "311.04",
                height: "399.99"
            }
        ])), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.analyzeYourPerformance"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-poll.webp",
            color: "purple",
            size: "tall",
            shadow: "shadow",
            border: "border"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.livechatMore"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-mail-connected.webp",
            color: "black",
            size: "tall"
        })), '\n                    </div>\n                        <!--<div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        $ {this.draw(new WebsiteMobileComponent())}\n                    </div>-->\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.livechat")
        })), "\n                    </div>\n                </div>\n        ");
        return _this;
    }
    return WebsiteContentLivechatComponent;
}((0, $9gCL8.Component));


var $a51cb86f8dc1fa90$export$3cbb6273c610a30 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteLivechatPage, WebsitePageComponent);
    function WebsiteLivechatPage() {
        (0, $3CDbU._)(this, WebsiteLivechatPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteLivechatPage);
        _this.updateMetas("livechat");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteLivechatPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $2941544806245097$export$1b5d99909ed4e8af)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteLivechatPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");





var $3Qm5T = parcelRequire("3Qm5T");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $93651d42d4db39b7$exports = {};

$parcel$export($93651d42d4db39b7$exports, "componentWebsitePresentationDegraded", function () { return $93651d42d4db39b7$export$d4cd5e862c20dc56; }, function (v) { return $93651d42d4db39b7$export$d4cd5e862c20dc56 = v; });
$parcel$export($93651d42d4db39b7$exports, "head", function () { return $93651d42d4db39b7$export$5fd5031fecdacec3; }, function (v) { return $93651d42d4db39b7$export$5fd5031fecdacec3 = v; });
$parcel$export($93651d42d4db39b7$exports, "title", function () { return $93651d42d4db39b7$export$fb184b623420d9be; }, function (v) { return $93651d42d4db39b7$export$fb184b623420d9be = v; });
$parcel$export($93651d42d4db39b7$exports, "medium", function () { return $93651d42d4db39b7$export$649ecc744817b5c7; }, function (v) { return $93651d42d4db39b7$export$649ecc744817b5c7 = v; });
$parcel$export($93651d42d4db39b7$exports, "small", function () { return $93651d42d4db39b7$export$3c17b0e969a90510; }, function (v) { return $93651d42d4db39b7$export$3c17b0e969a90510 = v; });
$parcel$export($93651d42d4db39b7$exports, "blue", function () { return $93651d42d4db39b7$export$2aa0182783e7e9de; }, function (v) { return $93651d42d4db39b7$export$2aa0182783e7e9de = v; });
$parcel$export($93651d42d4db39b7$exports, "red", function () { return $93651d42d4db39b7$export$a90204d1394caf30; }, function (v) { return $93651d42d4db39b7$export$a90204d1394caf30 = v; });
$parcel$export($93651d42d4db39b7$exports, "black", function () { return $93651d42d4db39b7$export$c073df10e766abfa; }, function (v) { return $93651d42d4db39b7$export$c073df10e766abfa = v; });
$parcel$export($93651d42d4db39b7$exports, "multi", function () { return $93651d42d4db39b7$export$13e2537ceeaf8a3a; }, function (v) { return $93651d42d4db39b7$export$13e2537ceeaf8a3a = v; });
$parcel$export($93651d42d4db39b7$exports, "purple", function () { return $93651d42d4db39b7$export$e13cce2a2d16a9d4; }, function (v) { return $93651d42d4db39b7$export$e13cce2a2d16a9d4 = v; });
$parcel$export($93651d42d4db39b7$exports, "imageContainer", function () { return $93651d42d4db39b7$export$63e82393dc8977bf; }, function (v) { return $93651d42d4db39b7$export$63e82393dc8977bf = v; });
$parcel$export($93651d42d4db39b7$exports, "image", function () { return $93651d42d4db39b7$export$5c452ff88e35e47d; }, function (v) { return $93651d42d4db39b7$export$5c452ff88e35e47d = v; });
$parcel$export($93651d42d4db39b7$exports, "tall", function () { return $93651d42d4db39b7$export$d06da4f97bb01f71; }, function (v) { return $93651d42d4db39b7$export$d06da4f97bb01f71 = v; });
var $93651d42d4db39b7$export$d4cd5e862c20dc56;
var $93651d42d4db39b7$export$5fd5031fecdacec3;
var $93651d42d4db39b7$export$fb184b623420d9be;
var $93651d42d4db39b7$export$649ecc744817b5c7;
var $93651d42d4db39b7$export$3c17b0e969a90510;
var $93651d42d4db39b7$export$2aa0182783e7e9de;
var $93651d42d4db39b7$export$a90204d1394caf30;
var $93651d42d4db39b7$export$c073df10e766abfa;
var $93651d42d4db39b7$export$13e2537ceeaf8a3a;
var $93651d42d4db39b7$export$e13cce2a2d16a9d4;
var $93651d42d4db39b7$export$63e82393dc8977bf;
var $93651d42d4db39b7$export$5c452ff88e35e47d;
var $93651d42d4db39b7$export$d06da4f97bb01f71;
$93651d42d4db39b7$export$d4cd5e862c20dc56 = "s8jKV";
$93651d42d4db39b7$export$5fd5031fecdacec3 = "G-nsn";
$93651d42d4db39b7$export$fb184b623420d9be = "MA3hF";
$93651d42d4db39b7$export$649ecc744817b5c7 = "_6nbKi";
$93651d42d4db39b7$export$3c17b0e969a90510 = "-B4ob";
$93651d42d4db39b7$export$2aa0182783e7e9de = "HeQjH";
$93651d42d4db39b7$export$a90204d1394caf30 = "_3Gko9";
$93651d42d4db39b7$export$c073df10e766abfa = "ne6Gn";
$93651d42d4db39b7$export$13e2537ceeaf8a3a = "XKRi3";
$93651d42d4db39b7$export$e13cce2a2d16a9d4 = "_88gPl";
$93651d42d4db39b7$export$63e82393dc8977bf = "p6aWt";
$93651d42d4db39b7$export$5c452ff88e35e47d = "benqp";
$93651d42d4db39b7$export$d06da4f97bb01f71 = "y52n-";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $ebfdeea4f9f1bcab$export$26ebd0be71b24829 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsitePresentationDegradedComponent, Component);
    function WebsitePresentationDegradedComponent(p) {
        (0, $3CDbU._)(this, WebsitePresentationDegradedComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePresentationDegradedComponent);
        _this.color = p.color;
        _this.size = p.size;
        _this.titles = p.titles;
        //language=HTML
        _this.template = '\n            <div class="'.concat($93651d42d4db39b7$exports.componentWebsitePresentationDegraded, '">\n                <div class="').concat($93651d42d4db39b7$exports.head, " ").concat($93651d42d4db39b7$exports[_this.color], '">\n                    <h2 class="').concat($93651d42d4db39b7$exports.title, " ").concat($93651d42d4db39b7$exports.small, '"></h2>\n                    <h2 class="').concat($93651d42d4db39b7$exports.title, " ").concat($93651d42d4db39b7$exports.medium, '"></h2>\n                    <h2 class="').concat($93651d42d4db39b7$exports.title, " ").concat($93651d42d4db39b7$exports.big, '"></h2>\n                </div>\n                <div class="').concat($93651d42d4db39b7$exports.imageContainer, '">\n                    <img class="').concat($93651d42d4db39b7$exports.image, " ").concat($93651d42d4db39b7$exports[_this.size], '" src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(p.image, '"\n                         alt="').concat((0, $wYO7b.Resources).t("words.extractSedestralInterface"), '"/>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsitePresentationDegradedComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.smallContainer = this.el($93651d42d4db39b7$exports.small);
                this.mediumContainer = this.el($93651d42d4db39b7$exports.medium);
                this.bigContainer = this.el($93651d42d4db39b7$exports.big);
                this.index = 0;
                this.titles.forEach(function(title) {
                    //language=HTML
                    if (_this.index == 0) _this.smallContainer.append("\n                    ".concat(title.title, "\n                "));
                    else if (_this.index == 1) _this.mediumContainer.append("\n                    ".concat(title.title, "\n                "));
                    else if (_this.index == 2) _this.bigContainer.append("\n                    ".concat(title.title, "\n                "));
                    _this.index += 1;
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsitePresentationDegradedComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsitePresentationDegradedComponent;
}((0, $9gCL8.Component));





var $co7RM = parcelRequire("co7RM");


var $wYO7b = parcelRequire("wYO7b");
var $c4f68c88c3349831$export$70f619274ccd91c3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentMailComponent, Component);
    function WebsiteContentMailComponent() {
        (0, $3CDbU._)(this, WebsiteContentMailComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentMailComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.businessMails"),
            text: (0, $wYO7b.Resources).t("words.manageAndCreateMails"),
            productType: (0, $co7RM.ProductType).MAILS,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-mail-ask.webp")
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $ebfdeea4f9f1bcab$export$26ebd0be71b24829)({
            titles: [
                {
                    title: (0, $wYO7b.Resources).t("words.yourMails")
                },
                {
                    title: (0, $wYO7b.Resources).t("words.yourCompany")
                },
                {
                    title: (0, $wYO7b.Resources).t("words.yourDomainName")
                }
            ],
            image: "illus-domain.svg",
            color: "multi",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $0b3776658751a630$export$68bb1055da0209bf)({
            title: (0, $wYO7b.Resources).t("words.bigTeams"),
            columns: [
                {
                    name: (0, $wYO7b.Resources).t("words.createGroupMails"),
                    picture: "illus-members.svg",
                    state: "special"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.supportMails"),
                    picture: "illus-domains.svg",
                    state: "normal"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.collaborate"),
                    picture: "illus-editor.webp",
                    state: "normal"
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $11905550a94e3587$export$21cf7e1029971b9d)((0, $wYO7b.Resources).t("words.fullControlMails"), [
            {
                icon: "home",
                title: (0, $wYO7b.Resources).t("words.overview"),
                desc: (0, $wYO7b.Resources).t("words.spaceManagement"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-overview.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "mail",
                title: (0, $wYO7b.Resources).t("words.manageMails"),
                desc: (0, $wYO7b.Resources).t("words.allocateMails"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-emailAttribution.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "mailAlias",
                title: (0, $wYO7b.Resources).t("words.aliasesRedirections"),
                desc: (0, $wYO7b.Resources).t("words.setUpAliases"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-aliasAttribution.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "domains",
                title: (0, $wYO7b.Resources).t("words.domains"),
                desc: (0, $wYO7b.Resources).t("words.addDomainName"),
                image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-domainValidation.webp",
                width: "561.6",
                height: "315.9"
            }
        ])), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $63f6c7e7bfe0384f$export$d8eb6fbe0ee5dec2)({
            color: "red",
            title: (0, $wYO7b.Resources).t("words.reliableMailsAddresses"),
            columns: [
                {
                    icon: "error",
                    name: (0, $wYO7b.Resources).t("words.antiSpam"),
                    text: (0, $wYO7b.Resources).t("words.blockSpam")
                },
                {
                    icon: "mailSpam",
                    name: (0, $wYO7b.Resources).t("words.antiVirus"),
                    text: (0, $wYO7b.Resources).t("words.securitySolution")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.connectSocialNetworks"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-mail-connected.webp",
            color: "black",
            size: "tall"
        })), '\n                    </div>\n                        <!--<div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        $ {this.draw(new WebsiteMobileComponent())}\n                    </div>-->\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.mails")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentMailComponent;
}((0, $9gCL8.Component));


var $83c6fbe919b812f9$export$98018fbb31b537b8 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteMailPage, WebsitePageComponent);
    function WebsiteMailPage() {
        (0, $3CDbU._)(this, WebsiteMailPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteMailPage);
        _this.updateMetas("mails");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteMailPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $c4f68c88c3349831$export$70f619274ccd91c3)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteMailPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $f9a511d67c6b89bc$export$31666aeebab1a81b;
var $f9a511d67c6b89bc$export$c6575b6ed1dea316;
var $f9a511d67c6b89bc$export$c96745152eb2740f;
var $f9a511d67c6b89bc$export$fb184b623420d9be;
$f9a511d67c6b89bc$export$31666aeebab1a81b = "YR8RE";
$f9a511d67c6b89bc$export$c6575b6ed1dea316 = "BrAUn";
$f9a511d67c6b89bc$export$c96745152eb2740f = "SrIN7";
$f9a511d67c6b89bc$export$fb184b623420d9be = "B863R";




var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $58f4baccb39826fa$export$552a907c2569cb26;
var $58f4baccb39826fa$export$d8556a2a8f973135;
var $58f4baccb39826fa$export$1e95b668f3b82d;
var $58f4baccb39826fa$export$1ca1ec8b29a4ce27;
var $58f4baccb39826fa$export$fb184b623420d9be;
var $58f4baccb39826fa$export$40e543e69a8b3fbb;
var $58f4baccb39826fa$export$eabcd2c8791e7bf4;
var $58f4baccb39826fa$export$29f9f81de5c56283;
var $58f4baccb39826fa$export$6f093cfa640b7166;
var $58f4baccb39826fa$export$2ba01fb71ed41cb6;
var $58f4baccb39826fa$export$9254cd51d610f2d2;
var $58f4baccb39826fa$export$60bb6c1f29b8a8cc;
var $58f4baccb39826fa$export$79ffe56a765070d2;
$58f4baccb39826fa$export$552a907c2569cb26 = "_8obg6";
$58f4baccb39826fa$export$d8556a2a8f973135 = "_5iUED";
$58f4baccb39826fa$export$1e95b668f3b82d = "_23fJh";
$58f4baccb39826fa$export$1ca1ec8b29a4ce27 = "JyyuX";
$58f4baccb39826fa$export$fb184b623420d9be = "ZwOXq";
$58f4baccb39826fa$export$40e543e69a8b3fbb = "onvxY";
$58f4baccb39826fa$export$eabcd2c8791e7bf4 = "-V1ky";
$58f4baccb39826fa$export$29f9f81de5c56283 = "TVnje";
$58f4baccb39826fa$export$6f093cfa640b7166 = "-UMv5";
$58f4baccb39826fa$export$2ba01fb71ed41cb6 = "GM9Wg";
$58f4baccb39826fa$export$9254cd51d610f2d2 = "pIF8L";
$58f4baccb39826fa$export$60bb6c1f29b8a8cc = "ahMLk";
$58f4baccb39826fa$export$79ffe56a765070d2 = "rvzAK";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $2484e1eec9a3cb35$export$d95034cd4cf3650d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteProductGridComponent, Component);
    function WebsiteProductGridComponent(p) {
        (0, $3CDbU._)(this, WebsiteProductGridComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteProductGridComponent);
        _this.components = p.components;
        //language=HTML
        _this.template = '\n            <div class="'.concat($58f4baccb39826fa$export$552a907c2569cb26, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteProductGridComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.componentContainer = this.el($58f4baccb39826fa$export$552a907c2569cb26);
                this.components.forEach(function(components) {
                    if (components.url && components.url !== "" && components.textButton !== "" && components.textButton) //language=HTML
                    _this.componentContainer.append('\n                    <div class="'.concat($58f4baccb39826fa$export$d8556a2a8f973135, '">\n                        <div class="').concat($58f4baccb39826fa$export$1e95b668f3b82d, '">\n                            <div class="').concat($58f4baccb39826fa$export$1ca1ec8b29a4ce27, '"></div>\n                            <h3 class="').concat($58f4baccb39826fa$export$fb184b623420d9be, '">\n                                ').concat(components.title, '\n                            </h3>\n                        </div>\n                        <div class="').concat($58f4baccb39826fa$export$40e543e69a8b3fbb, '">\n                            <div class="').concat($58f4baccb39826fa$export$eabcd2c8791e7bf4, '">\n                                <div class="').concat($58f4baccb39826fa$export$29f9f81de5c56283, '">\n                                    <p class="').concat($58f4baccb39826fa$export$6f093cfa640b7166, '">').concat(components.text, '</p>\n                                    <a href="/').concat(components.url, '">\n                                        <div class="').concat($58f4baccb39826fa$export$2ba01fb71ed41cb6, '">\n                                            <p class="').concat($58f4baccb39826fa$export$9254cd51d610f2d2, '">').concat(components.textButton, '</p>\n                                            <i class="').concat($58f4baccb39826fa$export$60bb6c1f29b8a8cc, '"></i>\n                                        </div>\n                                    </a>\n                                </div>\n                            </div>\n                            <div class="').concat($58f4baccb39826fa$export$79ffe56a765070d2, '">\n                                <img src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(components.image, '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.illustrationCategory"), " ").concat(components.title, '."/>\n                            </div>\n                        </div>\n                    </div>\n                '));
                    else //language=HTML
                    _this.componentContainer.append('\n                    <div class="'.concat($58f4baccb39826fa$export$d8556a2a8f973135, '">\n                        <div class="').concat($58f4baccb39826fa$export$1e95b668f3b82d, '">\n                            <div class="').concat($58f4baccb39826fa$export$1ca1ec8b29a4ce27, '"></div>\n                            <h3 class="').concat($58f4baccb39826fa$export$fb184b623420d9be, '">\n                                ').concat(components.title, '\n                            </h3>\n                        </div>\n                        <div class="').concat($58f4baccb39826fa$export$40e543e69a8b3fbb, '">\n                            <div class="').concat($58f4baccb39826fa$export$eabcd2c8791e7bf4, '">\n                                <div class="').concat($58f4baccb39826fa$export$29f9f81de5c56283, '">\n                                    <p class="').concat($58f4baccb39826fa$export$6f093cfa640b7166, '">').concat(components.text, '</p>\n                                </div>\n                            </div>\n                            <div class="').concat($58f4baccb39826fa$export$79ffe56a765070d2, '">\n                                <img src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(components.image, '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.illustrationCategory"), " ").concat(components.title, '."/>\n                            </div>\n                        </div>\n                    </div>\n                '));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteProductGridComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteProductGridComponent;
}((0, $9gCL8.Component));




var $wYO7b = parcelRequire("wYO7b");
var $4945800f37af7748$export$a63ef9c175deac98 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentCustomerServiceComponent, Component);
    function WebsiteContentCustomerServiceComponent() {
        (0, $3CDbU._)(this, WebsiteContentCustomerServiceComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentCustomerServiceComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($f9a511d67c6b89bc$export$31666aeebab1a81b, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.allInOne"),
            text: (0, $wYO7b.Resources).t("words.fastSupport"),
            productType: (0, $co7RM.ProductType).CLIENT_SERVICE,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-inbox.webp")
        })), '\n                    </div>\n                    <div class="').concat($f9a511d67c6b89bc$export$c6575b6ed1dea316, '">\n                        <h3 class="').concat($f9a511d67c6b89bc$export$c96745152eb2740f, '">\n                            ').concat((0, $wYO7b.Resources).t("words.multiChannel"), '\n                        </h3>\n                        <h4 class="').concat($f9a511d67c6b89bc$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.letSee"), '\n\n                        </h4>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2484e1eec9a3cb35$export$d95034cd4cf3650d)({
            components: [
                {
                    title: (0, $wYO7b.Resources).t("words.products.frLivechat"),
                    text: (0, $wYO7b.Resources).t("words.livechatCustomize"),
                    textButton: (0, $wYO7b.Resources).t("words.desktop"),
                    image: "livechat-a.webp",
                    url: "livechat"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.mails"),
                    text: "<span>1.</span> ".concat((0, $wYO7b.Resources).t("words.mailsConnect"), "<br/><br/><span>2.</span> ").concat((0, $wYO7b.Resources).t("words.mailsCreate"), "<br/><br/><span>3.</span> ").concat((0, $wYO7b.Resources).t("words.mailsAssigned"), "<br/><br/><span>4.</span> ").concat((0, $wYO7b.Resources).t("words.mailsWork")),
                    textButton: (0, $wYO7b.Resources).t("words.mailsServe"),
                    image: "illus-sc-mails.webp",
                    url: "mail"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.socialNetworks"),
                    text: (0, $wYO7b.Resources).t("words.linkToSN"),
                    textButton: (0, $wYO7b.Resources).t("words.SNServe"),
                    image: "illus-sc-social.svg",
                    url: "inbox"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.helpCenter"),
                    text: (0, $wYO7b.Resources).t("words.helpcenterCustomize"),
                    image: "illus-sc-support.svg"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.chatBot"),
                    text: (0, $wYO7b.Resources).t("words.trainIA"),
                    image: "illus-sc-bots.svg"
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($f9a511d67c6b89bc$export$c6575b6ed1dea316, '">\n                        <h3 class="').concat($f9a511d67c6b89bc$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.customerService"), '\n                        </h3>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.customerService")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentCustomerServiceComponent;
}((0, $9gCL8.Component));


var $b608fbce79f44631$export$ea798b7c680ee0d5 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteClientServicePage, WebsitePageComponent);
    function WebsiteClientServicePage() {
        (0, $3CDbU._)(this, WebsiteClientServicePage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteClientServicePage);
        _this.updateMetas("clientService");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteClientServicePage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $4945800f37af7748$export$a63ef9c175deac98)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteClientServicePage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $e90ba9dd4a4f2e91$export$8fa521ed3b789f84;
var $e90ba9dd4a4f2e91$export$2217aca24454a969;
var $e90ba9dd4a4f2e91$export$f7c42a96c638d4dc;
var $e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4;
var $e90ba9dd4a4f2e91$export$fb184b623420d9be;
var $e90ba9dd4a4f2e91$export$c96745152eb2740f;
var $e90ba9dd4a4f2e91$export$79ffe56a765070d2;
var $e90ba9dd4a4f2e91$export$5c452ff88e35e47d;
var $e90ba9dd4a4f2e91$export$34e0f9847d4c02dd;
var $e90ba9dd4a4f2e91$export$53f1d5ea8de3d7c;
$e90ba9dd4a4f2e91$export$8fa521ed3b789f84 = "NLmOl";
$e90ba9dd4a4f2e91$export$2217aca24454a969 = "tC470";
$e90ba9dd4a4f2e91$export$f7c42a96c638d4dc = "_5962h";
$e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4 = "g4Yqu";
$e90ba9dd4a4f2e91$export$fb184b623420d9be = "VBPaj";
$e90ba9dd4a4f2e91$export$c96745152eb2740f = "V2-ox";
$e90ba9dd4a4f2e91$export$79ffe56a765070d2 = "pIWc1";
$e90ba9dd4a4f2e91$export$5c452ff88e35e47d = "ydErr";
$e90ba9dd4a4f2e91$export$34e0f9847d4c02dd = "jyv06";
$e90ba9dd4a4f2e91$export$53f1d5ea8de3d7c = "gWBxP";




var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $e0bcff324d37c688$exports = {};

$parcel$export($e0bcff324d37c688$exports, "componentWebsiteColumnsGridWhite", function () { return $e0bcff324d37c688$export$5b4fd01d942d3c49; }, function (v) { return $e0bcff324d37c688$export$5b4fd01d942d3c49 = v; });
$parcel$export($e0bcff324d37c688$exports, "head", function () { return $e0bcff324d37c688$export$5fd5031fecdacec3; }, function (v) { return $e0bcff324d37c688$export$5fd5031fecdacec3 = v; });
$parcel$export($e0bcff324d37c688$exports, "title", function () { return $e0bcff324d37c688$export$fb184b623420d9be; }, function (v) { return $e0bcff324d37c688$export$fb184b623420d9be = v; });
$parcel$export($e0bcff324d37c688$exports, "blue", function () { return $e0bcff324d37c688$export$2aa0182783e7e9de; }, function (v) { return $e0bcff324d37c688$export$2aa0182783e7e9de = v; });
$parcel$export($e0bcff324d37c688$exports, "details", function () { return $e0bcff324d37c688$export$41ee12f6f6f05843; }, function (v) { return $e0bcff324d37c688$export$41ee12f6f6f05843 = v; });
$parcel$export($e0bcff324d37c688$exports, "detail", function () { return $e0bcff324d37c688$export$13a2d28b88853ef2; }, function (v) { return $e0bcff324d37c688$export$13a2d28b88853ef2 = v; });
$parcel$export($e0bcff324d37c688$exports, "icon", function () { return $e0bcff324d37c688$export$1ca1ec8b29a4ce27; }, function (v) { return $e0bcff324d37c688$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-chart", function () { return $e0bcff324d37c688$export$b5c6e04a29996f44; }, function (v) { return $e0bcff324d37c688$export$b5c6e04a29996f44 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-time", function () { return $e0bcff324d37c688$export$ac5ad22284b5687f; }, function (v) { return $e0bcff324d37c688$export$ac5ad22284b5687f = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-good", function () { return $e0bcff324d37c688$export$9a9f95c5a2d62fc5; }, function (v) { return $e0bcff324d37c688$export$9a9f95c5a2d62fc5 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-export", function () { return $e0bcff324d37c688$export$b2c3039516e2b8e1; }, function (v) { return $e0bcff324d37c688$export$b2c3039516e2b8e1 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-voice", function () { return $e0bcff324d37c688$export$b861bd9c9b84a44d; }, function (v) { return $e0bcff324d37c688$export$b861bd9c9b84a44d = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-words", function () { return $e0bcff324d37c688$export$3452ba47e78af6e3; }, function (v) { return $e0bcff324d37c688$export$3452ba47e78af6e3 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-seo", function () { return $e0bcff324d37c688$export$18d1c96072158b62; }, function (v) { return $e0bcff324d37c688$export$18d1c96072158b62 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-code", function () { return $e0bcff324d37c688$export$f210b805fe669b2f; }, function (v) { return $e0bcff324d37c688$export$f210b805fe669b2f = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-read", function () { return $e0bcff324d37c688$export$c37b689a2403b457; }, function (v) { return $e0bcff324d37c688$export$c37b689a2403b457 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-keywords", function () { return $e0bcff324d37c688$export$24555e9708195adb; }, function (v) { return $e0bcff324d37c688$export$24555e9708195adb = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-domains", function () { return $e0bcff324d37c688$export$5881ae397af7f4cf; }, function (v) { return $e0bcff324d37c688$export$5881ae397af7f4cf = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-conversations", function () { return $e0bcff324d37c688$export$7fb52a7446f340fe; }, function (v) { return $e0bcff324d37c688$export$7fb52a7446f340fe = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-planning", function () { return $e0bcff324d37c688$export$f1f6f288bdcd89e1; }, function (v) { return $e0bcff324d37c688$export$f1f6f288bdcd89e1 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-delay", function () { return $e0bcff324d37c688$export$56795306f1762ee9; }, function (v) { return $e0bcff324d37c688$export$56795306f1762ee9 = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-rating", function () { return $e0bcff324d37c688$export$fd1585561896434d; }, function (v) { return $e0bcff324d37c688$export$fd1585561896434d = v; });
$parcel$export($e0bcff324d37c688$exports, "black-lineal-team", function () { return $e0bcff324d37c688$export$5aedd97a193be748; }, function (v) { return $e0bcff324d37c688$export$5aedd97a193be748 = v; });
$parcel$export($e0bcff324d37c688$exports, "subtitle", function () { return $e0bcff324d37c688$export$c96745152eb2740f; }, function (v) { return $e0bcff324d37c688$export$c96745152eb2740f = v; });
var $e0bcff324d37c688$export$5b4fd01d942d3c49;
var $e0bcff324d37c688$export$5fd5031fecdacec3;
var $e0bcff324d37c688$export$fb184b623420d9be;
var $e0bcff324d37c688$export$2aa0182783e7e9de;
var $e0bcff324d37c688$export$41ee12f6f6f05843;
var $e0bcff324d37c688$export$13a2d28b88853ef2;
var $e0bcff324d37c688$export$1ca1ec8b29a4ce27;
var $e0bcff324d37c688$export$b5c6e04a29996f44;
var $e0bcff324d37c688$export$ac5ad22284b5687f;
var $e0bcff324d37c688$export$9a9f95c5a2d62fc5;
var $e0bcff324d37c688$export$b2c3039516e2b8e1;
var $e0bcff324d37c688$export$b861bd9c9b84a44d;
var $e0bcff324d37c688$export$3452ba47e78af6e3;
var $e0bcff324d37c688$export$18d1c96072158b62;
var $e0bcff324d37c688$export$f210b805fe669b2f;
var $e0bcff324d37c688$export$c37b689a2403b457;
var $e0bcff324d37c688$export$24555e9708195adb;
var $e0bcff324d37c688$export$5881ae397af7f4cf;
var $e0bcff324d37c688$export$7fb52a7446f340fe;
var $e0bcff324d37c688$export$f1f6f288bdcd89e1;
var $e0bcff324d37c688$export$56795306f1762ee9;
var $e0bcff324d37c688$export$fd1585561896434d;
var $e0bcff324d37c688$export$5aedd97a193be748;
var $e0bcff324d37c688$export$c96745152eb2740f;
$e0bcff324d37c688$export$5b4fd01d942d3c49 = "ea3Uf";
$e0bcff324d37c688$export$5fd5031fecdacec3 = "D8KYI";
$e0bcff324d37c688$export$fb184b623420d9be = "pKtD4";
$e0bcff324d37c688$export$2aa0182783e7e9de = "_8-INO";
$e0bcff324d37c688$export$41ee12f6f6f05843 = "bsKOx";
$e0bcff324d37c688$export$13a2d28b88853ef2 = "fdgHA";
$e0bcff324d37c688$export$1ca1ec8b29a4ce27 = "HvutW";
$e0bcff324d37c688$export$b5c6e04a29996f44 = "fseJ9";
$e0bcff324d37c688$export$ac5ad22284b5687f = "bK8ii";
$e0bcff324d37c688$export$9a9f95c5a2d62fc5 = "_7Elhc";
$e0bcff324d37c688$export$b2c3039516e2b8e1 = "e8gfv";
$e0bcff324d37c688$export$b861bd9c9b84a44d = "mrdpH";
$e0bcff324d37c688$export$3452ba47e78af6e3 = "_-4NrD";
$e0bcff324d37c688$export$18d1c96072158b62 = "P-UZS";
$e0bcff324d37c688$export$f210b805fe669b2f = "sVvPK";
$e0bcff324d37c688$export$c37b689a2403b457 = "q3A4x";
$e0bcff324d37c688$export$24555e9708195adb = "z29iQ";
$e0bcff324d37c688$export$5881ae397af7f4cf = "aGIoO";
$e0bcff324d37c688$export$7fb52a7446f340fe = "LWfxr";
$e0bcff324d37c688$export$f1f6f288bdcd89e1 = "M6L97";
$e0bcff324d37c688$export$56795306f1762ee9 = "odq--";
$e0bcff324d37c688$export$fd1585561896434d = "u9Rae";
$e0bcff324d37c688$export$5aedd97a193be748 = "_78rux";
$e0bcff324d37c688$export$c96745152eb2740f = "_1aumv";


var $22bbd5ff065cc08a$export$1965e7302a1f5007 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteColumnsGridWhiteComponent, Component);
    function WebsiteColumnsGridWhiteComponent(p) {
        (0, $3CDbU._)(this, WebsiteColumnsGridWhiteComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteColumnsGridWhiteComponent);
        _this.color = p.color;
        _this.details = p.details;
        //language=HTML
        _this.template = '\n            <div class="'.concat($e0bcff324d37c688$exports.componentWebsiteColumnsGridWhite, '">\n                <div class="').concat($e0bcff324d37c688$exports.head, '">\n                    <h3 class="').concat($e0bcff324d37c688$exports.title, " ").concat($e0bcff324d37c688$exports[_this.color], '">\n                        ').concat(p.title, '\n                    </h3>\n                </div>\n                <div class="').concat($e0bcff324d37c688$exports.details, '">\n                    \n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteColumnsGridWhiteComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.detailsContainer = this.el($e0bcff324d37c688$exports.details);
                this.details.forEach(function(detail) {
                    //language=HTML
                    _this.detailsContainer.append('\n                <div class="'.concat($e0bcff324d37c688$exports.detail, '">\n                    <div class="').concat($e0bcff324d37c688$exports.icon, " ").concat($e0bcff324d37c688$exports[detail.icon], '"></div>\n                    <h4 class="').concat($e0bcff324d37c688$exports.title, '">\n                        ').concat(detail.title, '\n                    </h4>\n                    <p class="').concat($e0bcff324d37c688$exports.subtitle, '">\n                        ').concat(detail.subtitle, "\n                    </p>\n                </div>\n            "));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteColumnsGridWhiteComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteColumnsGridWhiteComponent;
}((0, $9gCL8.Component));




var $wYO7b = parcelRequire("wYO7b");
var $e3adfda71db90272$export$1277ab3aa9d165b3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentStatisticsComponent, Component);
    function WebsiteContentStatisticsComponent() {
        (0, $3CDbU._)(this, WebsiteContentStatisticsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentStatisticsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.yourPerformanceImpact"),
            text: (0, $wYO7b.Resources).t("words.evaluatingYourImpact"),
            productType: (0, $co7RM.ProductType).STATISTICS,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-statistics.webp")
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.centralizeStatistics"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-applications.svg",
            color: "black",
            size: "intermediate"
        })), '\n                    </div>\n                    <div class="').concat($e90ba9dd4a4f2e91$export$2217aca24454a969, '">\n                        <div class="').concat($e90ba9dd4a4f2e91$export$f7c42a96c638d4dc, '">\n                            <div class="').concat($e90ba9dd4a4f2e91$export$79ffe56a765070d2, '">\n                                <img class="').concat($e90ba9dd4a4f2e91$export$5c452ff88e35e47d, '" src="').concat((0, $3Qm5T.Network).vendor, 'images/illus-filter.webp"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.creationPresentationReports"), '" draggable="false"\n                                     width="380" height="347.51"\n                                />\n                            </div>\n                            <div class="').concat($e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4, '">\n                                <h2 class="').concat($e90ba9dd4a4f2e91$export$fb184b623420d9be, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.createReports"), '\n                                </h2>\n                                <p class="').concat($e90ba9dd4a4f2e91$export$c96745152eb2740f, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.filtersStatistics"), '\n                                </p>\n                                <img class="').concat($e90ba9dd4a4f2e91$export$53f1d5ea8de3d7c, '" src="').concat((0, $3Qm5T.Network).vendor, 'images/separator-line.svg"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.separationLine"), '" draggable="false"/>\n                            </div>\n                        </div>\n                        <div class="').concat($e90ba9dd4a4f2e91$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.evaluatedCollaborator"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-collaboraters.webp",
            color: "black",
            size: "tall",
            border: "border"
        })), '\n                        </div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $22bbd5ff065cc08a$export$1965e7302a1f5007)({
            title: (0, $wYO7b.Resources).t("words.mainReports"),
            color: "blue",
            details: [
                {
                    icon: "black-lineal-conversations",
                    title: (0, $wYO7b.Resources).t("words.numberConversations"),
                    subtitle: (0, $wYO7b.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-planning",
                    title: (0, $wYO7b.Resources).t("words.conversationsHours"),
                    subtitle: (0, $wYO7b.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-delay",
                    title: (0, $wYO7b.Resources).t("words.responseTime"),
                    subtitle: (0, $wYO7b.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-rating",
                    title: (0, $wYO7b.Resources).t("words.ratings"),
                    subtitle: (0, $wYO7b.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-team",
                    title: (0, $wYO7b.Resources).t("words.employees"),
                    subtitle: (0, $wYO7b.Resources).t("words.contactHours")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.statistics")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentStatisticsComponent;
}((0, $9gCL8.Component));


var $134535f50b7b8404$export$4f14dbe3a32e74d3 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteStatisticsPage, WebsitePageComponent);
    function WebsiteStatisticsPage() {
        (0, $3CDbU._)(this, WebsiteStatisticsPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteStatisticsPage);
        _this.updateMetas("statistics");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteStatisticsPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $e3adfda71db90272$export$1277ab3aa9d165b3)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteStatisticsPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");


var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $f192a237db744f08$export$eb2fa5f3de7c69e3;
var $f192a237db744f08$export$fb184b623420d9be;
var $f192a237db744f08$export$c96745152eb2740f;
var $f192a237db744f08$export$40513806f2b08545;
var $f192a237db744f08$export$d92138c69f1228fc;
var $f192a237db744f08$export$61910e92ff177e73;
var $f192a237db744f08$export$db269b07546483b0;
$f192a237db744f08$export$eb2fa5f3de7c69e3 = "AQxmE";
$f192a237db744f08$export$fb184b623420d9be = "IERJg";
$f192a237db744f08$export$c96745152eb2740f = "gwW2L";
$f192a237db744f08$export$40513806f2b08545 = "eyuEU";
$f192a237db744f08$export$d92138c69f1228fc = "c-Mca";
$f192a237db744f08$export$61910e92ff177e73 = "Cj8oB";
$f192a237db744f08$export$db269b07546483b0 = "VK2zh";


var $0cd7ccfe36d74fa4$export$b6320866fd1832d9 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteTableComponent, Component);
    function WebsiteTableComponent(p) {
        (0, $3CDbU._)(this, WebsiteTableComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteTableComponent);
        _this.clauses = p.clauses;
        //language=HTML
        _this.template = '\n            <div class="'.concat($f192a237db744f08$export$eb2fa5f3de7c69e3, '">\n                <h2 class="').concat($f192a237db744f08$export$fb184b623420d9be, '">\n                    ').concat(p.title, '\n                </h2>\n                <h4 class="').concat($f192a237db744f08$export$c96745152eb2740f, '">\n                    ').concat(p.subtitle, '\n                </h4>\n                <div class="').concat($f192a237db744f08$export$db269b07546483b0, '">\n\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteTableComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.clausesContainer = this.el($f192a237db744f08$export$db269b07546483b0);
                this.clauses.forEach(function(clause) {
                    if (clause.explain != "") //language=HTML
                    _this.clausesContainer.append('\n                    <div class="'.concat($f192a237db744f08$export$40513806f2b08545, '">\n                        <h3 class="').concat($f192a237db744f08$export$d92138c69f1228fc, '">\n                            ').concat(clause.header, '\n                        </h3>\n                        <p class="').concat($f192a237db744f08$export$61910e92ff177e73, '">\n                            ').concat(clause.explain, "\n                        </p>\n                    </div>\n                "));
                    else //language=HTML
                    _this.clausesContainer.append('\n                    <div class="'.concat($f192a237db744f08$export$40513806f2b08545, '">\n                        <h3 class="').concat($f192a237db744f08$export$d92138c69f1228fc, '">\n                            ').concat(clause.header, "\n                        </h3>\n                    </div>\n                "));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteTableComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteTableComponent;
}((0, $9gCL8.Component));


var $6ca17b4aea4401a9$export$edff894759dc337f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentCgvComponent, Component);
    function WebsiteContentCgvComponent() {
        (0, $3CDbU._)(this, WebsiteContentCgvComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentCgvComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $0cd7ccfe36d74fa4$export$b6320866fd1832d9)({
            clauses: (0, $wYO7b.Resources).t("words.generalConditionsSale.clauses"),
            title: (0, $wYO7b.Resources).t("words.generalConditionsSale.conditions"),
            subtitle: (0, $wYO7b.Resources).t("words.generalConditionsSale.date")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentCgvComponent;
}((0, $9gCL8.Component));



var $fe54d12263e975be$export$fb06d92033ba4bca = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteCgvPage, WebsitePageComponent);
    function WebsiteCgvPage() {
        (0, $3CDbU._)(this, WebsiteCgvPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteCgvPage);
        _this.updateMetas("cgv");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteCgvPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $6ca17b4aea4401a9$export$edff894759dc337f)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteCgvPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");


var $wYO7b = parcelRequire("wYO7b");

var $4f237ec1071c042a$export$fc98eca6edd0a214 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentCguComponent, Component);
    function WebsiteContentCguComponent() {
        (0, $3CDbU._)(this, WebsiteContentCguComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentCguComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $0cd7ccfe36d74fa4$export$b6320866fd1832d9)({
            clauses: (0, $wYO7b.Resources).t("words.generalConditionsUse.clauses"),
            title: (0, $wYO7b.Resources).t("words.generalConditionsUse.conditions"),
            subtitle: (0, $wYO7b.Resources).t("words.generalConditionsUse.date")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentCguComponent;
}((0, $9gCL8.Component));


var $89ba3010f6bc10c8$export$2422684a229ca95d = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteCguPage, WebsitePageComponent);
    function WebsiteCguPage() {
        (0, $3CDbU._)(this, WebsiteCguPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteCguPage);
        _this.updateMetas("cgu");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteCguPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $4f237ec1071c042a$export$fc98eca6edd0a214)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteCguPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");


var $wYO7b = parcelRequire("wYO7b");

var $7aaea079a9665ad0$export$82018ff1307c221f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentPolicyComponent, Component);
    function WebsiteContentPolicyComponent() {
        (0, $3CDbU._)(this, WebsiteContentPolicyComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentPolicyComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $0cd7ccfe36d74fa4$export$b6320866fd1832d9)({
            clauses: (0, $wYO7b.Resources).t("words.privacyPolicy.clauses"),
            title: (0, $wYO7b.Resources).t("words.privacyPolicy.conditions"),
            subtitle: (0, $wYO7b.Resources).t("words.privacyPolicy.date")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentPolicyComponent;
}((0, $9gCL8.Component));


var $9e7e16e1bfaa898c$export$8c2ad8bee15c420d = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsitePolicyPage, WebsitePageComponent);
    function WebsitePolicyPage() {
        (0, $3CDbU._)(this, WebsitePolicyPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePolicyPage);
        _this.updateMetas("policy");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsitePolicyPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $7aaea079a9665ad0$export$82018ff1307c221f)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsitePolicyPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $c774c69794b7e406$export$fcbb65595819f6f6;
var $c774c69794b7e406$export$3bf720ece7bc7b2e;
var $c774c69794b7e406$export$34e0f9847d4c02dd;
$c774c69794b7e406$export$fcbb65595819f6f6 = "e1dKy";
$c774c69794b7e406$export$3bf720ece7bc7b2e = "lzoUU";
$c774c69794b7e406$export$34e0f9847d4c02dd = "tGGse";







var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");


var $wYO7b = parcelRequire("wYO7b");

var $35b59ad2aaf2f2da$export$a91c64c48ed79244 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentPublisherComponent, Component);
    function WebsiteContentPublisherComponent() {
        (0, $3CDbU._)(this, WebsiteContentPublisherComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentPublisherComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.communicationContinuous"),
            text: (0, $wYO7b.Resources).t("words.publisherDescription"),
            productType: (0, $co7RM.ProductType).PUBLISHER,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-publisher-agenda.webp")
        })), '\n                    </div>\n                    <div class="').concat($c774c69794b7e406$export$3bf720ece7bc7b2e, '"></div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $db62148f7de3d193$export$f03a647dc37f632a)({
            title: (0, $wYO7b.Resources).t("words.whatDo"),
            grid: [
                {
                    name: (0, $wYO7b.Resources).t("words.create"),
                    description: (0, $wYO7b.Resources).t("words.createPublication"),
                    icon: $c4d18c363f69c643$export$b714fa498b091246
                },
                {
                    name: (0, $wYO7b.Resources).t("words.collaborate"),
                    description: (0, $wYO7b.Resources).t("words.collaboratePublish"),
                    icon: $c4d18c363f69c643$export$1f6feda8aa226b71
                },
                {
                    name: (0, $wYO7b.Resources).t("words.publish"),
                    description: (0, $wYO7b.Resources).t("words.publishEverywhere"),
                    icon: $c4d18c363f69c643$export$30780d0b6b610af8
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.resumePublish"),
            description: "",
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-content-publisher.svg",
            color: "black",
            size: "medium"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.schedulePublications"),
            description: (0, $wYO7b.Resources).t("words.schedulePublicationsDetails"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "capture-publisher.webp",
            shadow: "shadow",
            border: "border",
            color: "green",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.disponibleEverywhere"),
            description: (0, $wYO7b.Resources).t("words.socialEngagement"),
            image: "".concat((0, $3Qm5T.Network).vendor, "images/") + "illus-social.svg",
            color: "red",
            size: "medium"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $951a12393fe71ff0$export$e4b6d83931e2a971)({
            title: (0, $wYO7b.Resources).t("words.personalizePosts"),
            subtitle: (0, $wYO7b.Resources).t("words.customizeEveryPost"),
            illus: "capture-publisher-creator",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $951a12393fe71ff0$export$e4b6d83931e2a971)({
            title: (0, $wYO7b.Resources).t("words.receiveMessage"),
            subtitle: (0, $wYO7b.Resources).t("words.descriptionReceiveMessage"),
            illus: "illus-funnel",
            size: "tall",
            url: (0, $3Qm5T.Network).router.pages.getUrlWithPath('inbox'),
            direction: true
        })), '\n                    </div>\n                        <!--<div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        $ {this.draw(new WebsiteMobileComponent())}\n                    </div>-->\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.publisher")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentPublisherComponent;
}((0, $9gCL8.Component));


var $db8c0d2f48b2ae25$export$574699e312ffd9fc = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsitePublisherPage, WebsitePageComponent);
    function WebsitePublisherPage() {
        (0, $3CDbU._)(this, WebsitePublisherPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsitePublisherPage);
        _this.updateMetas("publisher");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsitePublisherPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $35b59ad2aaf2f2da$export$a91c64c48ed79244)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsitePublisherPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");




var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");


var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $f963012a6460e356$export$552a907c2569cb26;
var $f963012a6460e356$export$d8556a2a8f973135;
var $f963012a6460e356$export$1e95b668f3b82d;
var $f963012a6460e356$export$1ca1ec8b29a4ce27;
var $f963012a6460e356$export$fb184b623420d9be;
var $f963012a6460e356$export$40e543e69a8b3fbb;
var $f963012a6460e356$export$eabcd2c8791e7bf4;
var $f963012a6460e356$export$29f9f81de5c56283;
var $f963012a6460e356$export$6f093cfa640b7166;
var $f963012a6460e356$export$2ba01fb71ed41cb6;
var $f963012a6460e356$export$9254cd51d610f2d2;
var $f963012a6460e356$export$60bb6c1f29b8a8cc;
var $f963012a6460e356$export$79ffe56a765070d2;
$f963012a6460e356$export$552a907c2569cb26 = "LdoR-";
$f963012a6460e356$export$d8556a2a8f973135 = "OvGB-";
$f963012a6460e356$export$1e95b668f3b82d = "_1J-Of";
$f963012a6460e356$export$1ca1ec8b29a4ce27 = "crt1m";
$f963012a6460e356$export$fb184b623420d9be = "XkFbv";
$f963012a6460e356$export$40e543e69a8b3fbb = "_5uF3l";
$f963012a6460e356$export$eabcd2c8791e7bf4 = "BFSYr";
$f963012a6460e356$export$29f9f81de5c56283 = "aXGDu";
$f963012a6460e356$export$6f093cfa640b7166 = "FTAVd";
$f963012a6460e356$export$2ba01fb71ed41cb6 = "j68oj";
$f963012a6460e356$export$9254cd51d610f2d2 = "FbUQf";
$f963012a6460e356$export$60bb6c1f29b8a8cc = "rr0bA";
$f963012a6460e356$export$79ffe56a765070d2 = "My2zJ";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $4e2e4ead88ccbab2$export$ae690cddcd3d91e1 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteProductGridRightComponent, Component);
    function WebsiteProductGridRightComponent(p) {
        (0, $3CDbU._)(this, WebsiteProductGridRightComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteProductGridRightComponent);
        _this.components = p.components;
        //language=HTML
        _this.template = '\n            <div class="'.concat($f963012a6460e356$export$552a907c2569cb26, '"></div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteProductGridRightComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.componentContainer = this.el($f963012a6460e356$export$552a907c2569cb26);
                this.components.forEach(function(components) {
                    if (components.url && components.url !== "" && components.textButton !== "" && components.textButton) //language=HTML
                    _this.componentContainer.append('\n                    <div class="'.concat($f963012a6460e356$export$d8556a2a8f973135, '">\n                        <div class="').concat($f963012a6460e356$export$1e95b668f3b82d, '">\n                            <div class="').concat($f963012a6460e356$export$1ca1ec8b29a4ce27, '"></div>\n                            <h3 class="').concat($f963012a6460e356$export$fb184b623420d9be, '">\n                                ').concat(components.title, '\n                            </h3>\n                        </div>\n                        <div class="').concat($f963012a6460e356$export$40e543e69a8b3fbb, '">\n                            <div class="').concat($f963012a6460e356$export$eabcd2c8791e7bf4, '">\n                                <div class="').concat($f963012a6460e356$export$29f9f81de5c56283, '">\n                                    <p class="').concat($f963012a6460e356$export$6f093cfa640b7166, '">').concat(components.text, '</p>\n                                    <a href="/').concat(components.url, '">\n                                        <div class="').concat($f963012a6460e356$export$2ba01fb71ed41cb6, '">\n                                            <p class="').concat($f963012a6460e356$export$9254cd51d610f2d2, '">').concat(components.textButton, '</p>\n                                            <i class="').concat($f963012a6460e356$export$60bb6c1f29b8a8cc, '"></i>\n                                        </div>\n                                    </a>\n                                </div>\n                            </div>\n                            <div class="').concat($f963012a6460e356$export$79ffe56a765070d2, '">\n                                <img src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(components.image, '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.illustrationCategory"), " ").concat(components.title, '."/>\n                            </div>\n                        </div>\n                    </div>\n                '));
                    else //language=HTML
                    _this.componentContainer.append('\n                    <div class="'.concat($f963012a6460e356$export$d8556a2a8f973135, '">\n                        <div class="').concat($f963012a6460e356$export$1e95b668f3b82d, '">\n                            <div class="').concat($f963012a6460e356$export$1ca1ec8b29a4ce27, '"></div>\n                            <h3 class="').concat($f963012a6460e356$export$fb184b623420d9be, '">\n                                ').concat(components.title, '\n                            </h3>\n                        </div>\n                        <div class="').concat($f963012a6460e356$export$40e543e69a8b3fbb, '">\n                            <div class="').concat($f963012a6460e356$export$eabcd2c8791e7bf4, '">\n                                <div class="').concat($f963012a6460e356$export$29f9f81de5c56283, '">\n                                    <p class="').concat($f963012a6460e356$export$6f093cfa640b7166, '">').concat(components.text, '</p>\n                                </div>\n                            </div>\n                            <div class="').concat($f963012a6460e356$export$79ffe56a765070d2, '">\n                                <img src="').concat((0, $3Qm5T.Network).vendor, "images/").concat(components.image, '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.illustrationCategory"), " ").concat(components.title, '."/>\n                            </div>\n                        </div>\n                    </div>\n                '));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteProductGridRightComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteProductGridRightComponent;
}((0, $9gCL8.Component));


var $3663bc955a8d4089$export$700149dde71fa4 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentHelpCenterComponent, Component);
    function WebsiteContentHelpCenterComponent() {
        (0, $3CDbU._)(this, WebsiteContentHelpCenterComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentHelpCenterComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($f9a511d67c6b89bc$export$31666aeebab1a81b, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.helpcenterBusiness"),
            text: (0, $wYO7b.Resources).t("words.fastSupport"),
            productType: (0, $co7RM.ProductType).CLIENT_SERVICE,
            url: "".concat((0, $3Qm5T.Network).vendor, "images/capture-inbox.webp")
        })), '\n                    </div>\n                    <div class="').concat($f9a511d67c6b89bc$export$c6575b6ed1dea316, '">\n                        <h3 class="').concat($f9a511d67c6b89bc$export$c96745152eb2740f, '">\n                            ').concat((0, $wYO7b.Resources).t("words.multiChannel"), '\n                        </h3>\n                        <h4 class="').concat($f9a511d67c6b89bc$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.letSee"), '\n\n                        </h4>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $4e2e4ead88ccbab2$export$ae690cddcd3d91e1)({
            components: [
                {
                    title: (0, $wYO7b.Resources).t("words.products.frLivechat"),
                    text: (0, $wYO7b.Resources).t("words.livechatCustomize"),
                    textButton: (0, $wYO7b.Resources).t("words.desktop"),
                    image: "livechat-a.webp",
                    url: "livechat"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.mails"),
                    text: "<span>1.</span> ".concat((0, $wYO7b.Resources).t("words.mailsConnect"), "<br/><br/><span>2.</span> ").concat((0, $wYO7b.Resources).t("words.mailsCreate"), "<br/><br/><span>3.</span> ").concat((0, $wYO7b.Resources).t("words.mailsAssigned"), "<br/><br/><span>4.</span> ").concat((0, $wYO7b.Resources).t("words.mailsWork")),
                    textButton: (0, $wYO7b.Resources).t("words.mailsServe"),
                    image: "illus-sc-mails.webp",
                    url: "mail"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.socialNetworks"),
                    text: (0, $wYO7b.Resources).t("words.linkToSN"),
                    textButton: (0, $wYO7b.Resources).t("words.SNServe"),
                    image: "illus-sc-social.svg",
                    url: "inbox"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.frHelpcenter"),
                    text: (0, $wYO7b.Resources).t("words.helpcenterCustomize"),
                    image: "illus-sc-support.svg"
                },
                {
                    title: (0, $wYO7b.Resources).t("words.products.chatBot"),
                    text: (0, $wYO7b.Resources).t("words.trainIA"),
                    image: "illus-sc-bots.svg"
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($f9a511d67c6b89bc$export$c6575b6ed1dea316, '">\n                        <h3 class="').concat($f9a511d67c6b89bc$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.customerService"), '\n                        </h3>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: (0, $wYO7b.Resources).t("words.questions.customerService")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentHelpCenterComponent;
}((0, $9gCL8.Component));


var $b01c73757609a7d8$export$17f3ea6ee3033913 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHelpcenterPage, WebsitePageComponent);
    function WebsiteHelpcenterPage() {
        (0, $3CDbU._)(this, WebsiteHelpcenterPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHelpcenterPage);
        _this.updateMetas("helpcenter");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteHelpcenterPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $3663bc955a8d4089$export$700149dde71fa4)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteHelpcenterPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $78NO5 = parcelRequire("78NO5");

var $9gCL8 = parcelRequire("9gCL8");







var $co7RM = parcelRequire("co7RM");

var $3Qm5T = parcelRequire("3Qm5T");


var $wYO7b = parcelRequire("wYO7b");



var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $wYO7b = parcelRequire("wYO7b");

var $3Qm5T = parcelRequire("3Qm5T");
var $3e10e981c2995cb0$export$a27e371a094e4e50 = /*#__PURE__*/ function() {
    "use strict";
    function NetworkVendor() {
        (0, $3CDbU._)(this, NetworkVendor);
    }
    (0, $jyA4z._)(NetworkVendor, null, [
        {
            key: "image",
            value: function image(name) {
                var lang = (0, $wYO7b.Resources).language;
                if (this.images.find(function(value) {
                    return value.lang == lang && value.name == name;
                })) return "".concat((0, $3Qm5T.Network).vendor, "images/").concat(lang, "/").concat(name);
                else return "".concat((0, $3Qm5T.Network).vendor, "images/en/").concat(name);
            }
        },
        {
            key: "illus",
            value: function illus(name) {
                return "".concat((0, $3Qm5T.Network).vendor, "images/").concat(name);
            }
        },
        {
            key: "customer",
            value: function customer(name) {
                return "".concat((0, $3Qm5T.Network).vendor, "images/customers/").concat(name);
            }
        },
        {
            key: "reviews",
            value: function reviews(type) {
                return [
                    {
                        platform: "Shopify App Store",
                        platformIcon: "shopify",
                        content: (0, $wYO7b.Resources).t("words.shopifyReview1"),
                        avatarUrl: NetworkVendor.customer("blog-gourmet.svg"),
                        avatarName: "Le Coq Gourmet",
                        avatarDescription: (0, $wYO7b.Resources).t("words.ecommerceSite"),
                        stars: 5,
                        datePublished: "2024-09-03",
                        productName: "SmartBlog"
                    },
                    {
                        platform: "Google",
                        platformIcon: "google",
                        content: (0, $wYO7b.Resources).t("words.googleReview1"),
                        avatarUrl: NetworkVendor.customer("blog-dylan.jpg"),
                        avatarName: "Dylan DELIQUE",
                        avatarDescription: (0, $wYO7b.Resources).t("words.realEstateAdvisor"),
                        stars: 5,
                        datePublished: "2024-06-17",
                        productName: "SmartBlog"
                    }
                ];
            }
        }
    ]);
    return NetworkVendor;
}();
$3e10e981c2995cb0$export$a27e371a094e4e50.images = [];



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $03daba7b93f0f9d1$exports = {};

$parcel$export($03daba7b93f0f9d1$exports, "componentWebsiteReview", function () { return $03daba7b93f0f9d1$export$79bad0724c35cf21; }, function (v) { return $03daba7b93f0f9d1$export$79bad0724c35cf21 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "stars", function () { return $03daba7b93f0f9d1$export$cccfc0e200cdf418; }, function (v) { return $03daba7b93f0f9d1$export$cccfc0e200cdf418 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "star", function () { return $03daba7b93f0f9d1$export$c869496b69afe520; }, function (v) { return $03daba7b93f0f9d1$export$c869496b69afe520 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "provider", function () { return $03daba7b93f0f9d1$export$ca328f169d304df4; }, function (v) { return $03daba7b93f0f9d1$export$ca328f169d304df4 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "by", function () { return $03daba7b93f0f9d1$export$766bf7dcfb630b6c; }, function (v) { return $03daba7b93f0f9d1$export$766bf7dcfb630b6c = v; });
$parcel$export($03daba7b93f0f9d1$exports, "shopify", function () { return $03daba7b93f0f9d1$export$6da9acb12d5139d4; }, function (v) { return $03daba7b93f0f9d1$export$6da9acb12d5139d4 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "icon", function () { return $03daba7b93f0f9d1$export$1ca1ec8b29a4ce27; }, function (v) { return $03daba7b93f0f9d1$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "google", function () { return $03daba7b93f0f9d1$export$2d1fdedcfa4b711e; }, function (v) { return $03daba7b93f0f9d1$export$2d1fdedcfa4b711e = v; });
$parcel$export($03daba7b93f0f9d1$exports, "content", function () { return $03daba7b93f0f9d1$export$a7db06668cad9adb; }, function (v) { return $03daba7b93f0f9d1$export$a7db06668cad9adb = v; });
$parcel$export($03daba7b93f0f9d1$exports, "author", function () { return $03daba7b93f0f9d1$export$571b02044ddb2ab3; }, function (v) { return $03daba7b93f0f9d1$export$571b02044ddb2ab3 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "image", function () { return $03daba7b93f0f9d1$export$5c452ff88e35e47d; }, function (v) { return $03daba7b93f0f9d1$export$5c452ff88e35e47d = v; });
$parcel$export($03daba7b93f0f9d1$exports, "name", function () { return $03daba7b93f0f9d1$export$a8ff84c12d48cfa6; }, function (v) { return $03daba7b93f0f9d1$export$a8ff84c12d48cfa6 = v; });
$parcel$export($03daba7b93f0f9d1$exports, "description", function () { return $03daba7b93f0f9d1$export$6d59db4903f20f7d; }, function (v) { return $03daba7b93f0f9d1$export$6d59db4903f20f7d = v; });
var $03daba7b93f0f9d1$export$79bad0724c35cf21;
var $03daba7b93f0f9d1$export$cccfc0e200cdf418;
var $03daba7b93f0f9d1$export$c869496b69afe520;
var $03daba7b93f0f9d1$export$ca328f169d304df4;
var $03daba7b93f0f9d1$export$766bf7dcfb630b6c;
var $03daba7b93f0f9d1$export$6da9acb12d5139d4;
var $03daba7b93f0f9d1$export$1ca1ec8b29a4ce27;
var $03daba7b93f0f9d1$export$2d1fdedcfa4b711e;
var $03daba7b93f0f9d1$export$a7db06668cad9adb;
var $03daba7b93f0f9d1$export$571b02044ddb2ab3;
var $03daba7b93f0f9d1$export$5c452ff88e35e47d;
var $03daba7b93f0f9d1$export$a8ff84c12d48cfa6;
var $03daba7b93f0f9d1$export$6d59db4903f20f7d;
$03daba7b93f0f9d1$export$79bad0724c35cf21 = "XFZ-n";
$03daba7b93f0f9d1$export$cccfc0e200cdf418 = "_9Uo3c";
$03daba7b93f0f9d1$export$c869496b69afe520 = "uidhD";
$03daba7b93f0f9d1$export$ca328f169d304df4 = "hd61J";
$03daba7b93f0f9d1$export$766bf7dcfb630b6c = "AAaF1";
$03daba7b93f0f9d1$export$6da9acb12d5139d4 = "_9X34Z";
$03daba7b93f0f9d1$export$1ca1ec8b29a4ce27 = "OBEL0";
$03daba7b93f0f9d1$export$2d1fdedcfa4b711e = "_41OXe";
$03daba7b93f0f9d1$export$a7db06668cad9adb = "SCGSn";
$03daba7b93f0f9d1$export$571b02044ddb2ab3 = "_8casC";
$03daba7b93f0f9d1$export$5c452ff88e35e47d = "lnQ2D";
$03daba7b93f0f9d1$export$a8ff84c12d48cfa6 = "GYBvd";
$03daba7b93f0f9d1$export$6d59db4903f20f7d = "lt-8w";



var $wYO7b = parcelRequire("wYO7b");
var $92cd82a004503f89$export$8ead506451ba0d9d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteReviewComponent, Component);
    function WebsiteReviewComponent(reviewsCount, review) {
        (0, $3CDbU._)(this, WebsiteReviewComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteReviewComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($03daba7b93f0f9d1$exports.componentWebsiteReview, '" itemscope itemtype="https://schema.org/Review">\n                <div class="').concat($03daba7b93f0f9d1$exports.stars, '" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">\n                    <meta itemprop="ratingValue" content="').concat(review.stars, '"/>\n                    <meta itemprop="bestRating" content="5"/>\n                    <meta itemprop="worstRating" content="1"/>\n                    <div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.star, '"></div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.star, '"></div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.star, '"></div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.star, '"></div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.star, '"></div>\n                    </div>\n                    <div class="').concat($03daba7b93f0f9d1$exports.provider, " ").concat($03daba7b93f0f9d1$exports[review.platformIcon], '">\n                        <span class="').concat($03daba7b93f0f9d1$exports.by, '">').concat((0, $wYO7b.Resources).t("words.publishedOn"), '</span>\n                        <span itemprop="publisher">').concat(review.platform, '</span>\n                        <div class="').concat($03daba7b93f0f9d1$exports.icon, '"></div>\n                    </div>\n                    <div class="').concat($03daba7b93f0f9d1$exports.content, '" itemprop="reviewBody">\n                        ').concat(review.content, '\n                    </div>\n                </div>\n                <div class="').concat($03daba7b93f0f9d1$exports.author, '" itemprop="author" itemscope itemtype="https://schema.org/Person">\n                    <div class="').concat($03daba7b93f0f9d1$exports.image, '">\n                        <img src="').concat(review.avatarUrl, '" alt="').concat(review.avatarName, '" itemprop="image"/>\n                    </div>\n                    <div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.name, '" itemprop="name">').concat(review.avatarName, '</div>\n                        <div class="').concat($03daba7b93f0f9d1$exports.description, '">\n                            ').concat(review.avatarDescription, '\n                        </div>\n                    </div>\n                </div>\n                <meta itemprop="datePublished" content="').concat(review.datePublished, '"/>\n                <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/Product">\n                    <meta itemprop="name" content="').concat(review.productName, '"/>\n                    <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">\n                        <meta itemprop="ratingValue" content="').concat(review.stars, '"/>\n                        <meta itemprop="reviewCount" content="').concat(reviewsCount, '"/>\n                        <meta itemprop="bestRating" content="5"/>\n                        <meta itemprop="worstRating" content="1">\n                    </div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    return WebsiteReviewComponent;
}((0, $9gCL8.Component));


var $deb84410ba101283$export$c32be3e6c06658c8;
var $deb84410ba101283$export$fb184b623420d9be;
var $deb84410ba101283$export$a5cc789282b6873;
$deb84410ba101283$export$c32be3e6c06658c8 = "P5o2F";
$deb84410ba101283$export$fb184b623420d9be = "rY15Z";
$deb84410ba101283$export$a5cc789282b6873 = "_1-Wsg";


var $2ad9de2cc8e904c9$export$e9f2082bf3648ed6 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteReviewsComponent, Component);
    function WebsiteReviewsComponent(title, reviews) {
        (0, $3CDbU._)(this, WebsiteReviewsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteReviewsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($deb84410ba101283$export$c32be3e6c06658c8, '">\n                <div class="').concat($deb84410ba101283$export$fb184b623420d9be, '">').concat(title, '</div>\n                <div class="').concat($deb84410ba101283$export$a5cc789282b6873, '">\n                    ').concat(reviews.map(function(value) {
            return _this.draw(new (0, $92cd82a004503f89$export$8ead506451ba0d9d)(reviews.length, value));
        }).join(""), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteReviewsComponent;
}((0, $9gCL8.Component));



var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eQCFs = parcelRequire("eQCFs");

var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");
var $dbb2de9a4483d550$exports = {};

$parcel$export($dbb2de9a4483d550$exports, "componentCustomerPopup", function () { return $dbb2de9a4483d550$export$e0ce3e6c6a4477a8; }, function (v) { return $dbb2de9a4483d550$export$e0ce3e6c6a4477a8 = v; });
$parcel$export($dbb2de9a4483d550$exports, "box", function () { return $dbb2de9a4483d550$export$827f4ee28efc37; }, function (v) { return $dbb2de9a4483d550$export$827f4ee28efc37 = v; });
$parcel$export($dbb2de9a4483d550$exports, "head", function () { return $dbb2de9a4483d550$export$5fd5031fecdacec3; }, function (v) { return $dbb2de9a4483d550$export$5fd5031fecdacec3 = v; });
$parcel$export($dbb2de9a4483d550$exports, "title", function () { return $dbb2de9a4483d550$export$fb184b623420d9be; }, function (v) { return $dbb2de9a4483d550$export$fb184b623420d9be = v; });
$parcel$export($dbb2de9a4483d550$exports, "close", function () { return $dbb2de9a4483d550$export$8360e631d277ea4d; }, function (v) { return $dbb2de9a4483d550$export$8360e631d277ea4d = v; });
$parcel$export($dbb2de9a4483d550$exports, "icon", function () { return $dbb2de9a4483d550$export$1ca1ec8b29a4ce27; }, function (v) { return $dbb2de9a4483d550$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($dbb2de9a4483d550$exports, "content", function () { return $dbb2de9a4483d550$export$a7db06668cad9adb; }, function (v) { return $dbb2de9a4483d550$export$a7db06668cad9adb = v; });
$parcel$export($dbb2de9a4483d550$exports, "text", function () { return $dbb2de9a4483d550$export$6f093cfa640b7166; }, function (v) { return $dbb2de9a4483d550$export$6f093cfa640b7166 = v; });
$parcel$export($dbb2de9a4483d550$exports, "cases", function () { return $dbb2de9a4483d550$export$3931a0da49df8dc0; }, function (v) { return $dbb2de9a4483d550$export$3931a0da49df8dc0 = v; });
$parcel$export($dbb2de9a4483d550$exports, "case", function () { return $dbb2de9a4483d550$export$e850e66917a23e0f; }, function (v) { return $dbb2de9a4483d550$export$e850e66917a23e0f = v; });
$parcel$export($dbb2de9a4483d550$exports, "context", function () { return $dbb2de9a4483d550$export$a078c61943f9dbbe; }, function (v) { return $dbb2de9a4483d550$export$a078c61943f9dbbe = v; });
$parcel$export($dbb2de9a4483d550$exports, "style", function () { return $dbb2de9a4483d550$export$1d567c320f4763bc; }, function (v) { return $dbb2de9a4483d550$export$1d567c320f4763bc = v; });
$parcel$export($dbb2de9a4483d550$exports, "ai", function () { return $dbb2de9a4483d550$export$f38c853ae54ed474; }, function (v) { return $dbb2de9a4483d550$export$f38c853ae54ed474 = v; });
$parcel$export($dbb2de9a4483d550$exports, "round", function () { return $dbb2de9a4483d550$export$2077e0241d6afd3c; }, function (v) { return $dbb2de9a4483d550$export$2077e0241d6afd3c = v; });
$parcel$export($dbb2de9a4483d550$exports, "button", function () { return $dbb2de9a4483d550$export$2ba01fb71ed41cb6; }, function (v) { return $dbb2de9a4483d550$export$2ba01fb71ed41cb6 = v; });
var $dbb2de9a4483d550$export$e0ce3e6c6a4477a8;
var $dbb2de9a4483d550$export$827f4ee28efc37;
var $dbb2de9a4483d550$export$5fd5031fecdacec3;
var $dbb2de9a4483d550$export$fb184b623420d9be;
var $dbb2de9a4483d550$export$8360e631d277ea4d;
var $dbb2de9a4483d550$export$1ca1ec8b29a4ce27;
var $dbb2de9a4483d550$export$a7db06668cad9adb;
var $dbb2de9a4483d550$export$6f093cfa640b7166;
var $dbb2de9a4483d550$export$3931a0da49df8dc0;
var $dbb2de9a4483d550$export$e850e66917a23e0f;
var $dbb2de9a4483d550$export$a078c61943f9dbbe;
var $dbb2de9a4483d550$export$1d567c320f4763bc;
var $dbb2de9a4483d550$export$f38c853ae54ed474;
var $dbb2de9a4483d550$export$2077e0241d6afd3c;
var $dbb2de9a4483d550$export$2ba01fb71ed41cb6;
$dbb2de9a4483d550$export$e0ce3e6c6a4477a8 = "TBvlc";
$dbb2de9a4483d550$export$827f4ee28efc37 = "-KmyV";
$dbb2de9a4483d550$export$5fd5031fecdacec3 = "WGM9H";
$dbb2de9a4483d550$export$fb184b623420d9be = "X6Gwb";
$dbb2de9a4483d550$export$8360e631d277ea4d = "gSjsg";
$dbb2de9a4483d550$export$1ca1ec8b29a4ce27 = "MN3oY";
$dbb2de9a4483d550$export$a7db06668cad9adb = "-csry";
$dbb2de9a4483d550$export$6f093cfa640b7166 = "P-cL4";
$dbb2de9a4483d550$export$3931a0da49df8dc0 = "_3CPqo";
$dbb2de9a4483d550$export$e850e66917a23e0f = "BFE7C";
$dbb2de9a4483d550$export$a078c61943f9dbbe = "_1ICUF";
$dbb2de9a4483d550$export$1d567c320f4763bc = "nJEw-";
$dbb2de9a4483d550$export$f38c853ae54ed474 = "_7-e8R";
$dbb2de9a4483d550$export$2077e0241d6afd3c = "_0Gh5d";
$dbb2de9a4483d550$export$2ba01fb71ed41cb6 = "njImB";


var $f03f5eca0427a383$export$a0872ea153981ca8 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(CustomerPopupComponent, Component);
    function CustomerPopupComponent(p) {
        (0, $3CDbU._)(this, CustomerPopupComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, CustomerPopupComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($dbb2de9a4483d550$exports.componentCustomerPopup, '">\n                <div class="').concat($dbb2de9a4483d550$exports.box, '">\n                    <div class="').concat($dbb2de9a4483d550$exports.head, '">\n                        <div class="').concat($dbb2de9a4483d550$exports.title, '">').concat(p.title, '</div>\n                        <div class="').concat($dbb2de9a4483d550$exports.close, '">\n                            <div class="').concat($dbb2de9a4483d550$exports.icon, '"></div>\n                        </div>\n                    </div>\n                    <div class="').concat($dbb2de9a4483d550$exports.content, '">\n                        <div class="').concat($dbb2de9a4483d550$exports.icon, '"></div>\n                        <div class="').concat($dbb2de9a4483d550$exports.text, '">\n                            ').concat(p.content, '\n                        </div>\n                    </div>\n                    <div class="').concat($dbb2de9a4483d550$exports.cases, '">\n                        ').concat(p.cases ? p.cases.map(function(value) {
            //language=HTML
            return '\n                            <div class="'.concat($dbb2de9a4483d550$exports["case"], " ").concat($dbb2de9a4483d550$exports[value.icon], '">\n                                <div class="').concat($dbb2de9a4483d550$exports.head, '">\n                                    <div class="').concat($dbb2de9a4483d550$exports.round, '">\n                                        <div class="').concat($dbb2de9a4483d550$exports.icon, '"></div>\n                                    </div>\n                                    ').concat(value.title, '\n                                </div>\n                                <div class="').concat($dbb2de9a4483d550$exports.text, '">\n                                    ').concat(value.text, "\n                                </div>\n                            </div>\n                            ");
        }).join("") : "", '\n                    </div>\n                    <a href="').concat(p.buttonUrl, '" target="_blank" class="').concat($dbb2de9a4483d550$exports.button, '">\n                        ').concat(p.buttonText, '\n                        <div class="').concat($dbb2de9a4483d550$exports.icon, '"></div>\n                    </a>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(CustomerPopupComponent, [
        {
            key: "commit",
            value: function commit() {
                this.boxContainer = this.el($dbb2de9a4483d550$exports.box);
                this.actionButton = this.el($dbb2de9a4483d550$exports.button);
                this.closeButton = this.el($dbb2de9a4483d550$exports.close);
                this.boxContainer.translate({
                    translateY: 0,
                    scale: 1,
                    delay: 300
                });
                var _this = this;
                this.closeButton.onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.boxContainer.translate({
                                        translateY: 500,
                                        opacity: 0,
                                        delay: 300
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.remove();
                                _this.onClose();
                                return [
                                    2
                                ];
                        }
                    });
                }));
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(CustomerPopupComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "onClose",
            value: function onClose() {}
        }
    ]);
    return CustomerPopupComponent;
}((0, $9gCL8.Component));



var $yJnBa = parcelRequire("yJnBa");

var $5m1WU = parcelRequire("5m1WU");

var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");

var $8f67b912ef2ce121$export$4718cc74f3daff00 = /*#__PURE__*/ function() {
    "use strict";
    function CustomerPopup() {
        (0, $3CDbU._)(this, CustomerPopup);
    }
    (0, $jyA4z._)(CustomerPopup, null, [
        {
            key: "blog",
            value: function blog() {
                var _this = this;
                (0, $5m1WU.SedestralMachine).setTimeout(function() {
                    //if (SedestralStorage.getItem("CblogClosed") == undefined) {
                    if (!_this.blogRendered) {
                        if (!(0, $17004beb65fc22e9$export$f650c34b939fcf30).hasSsr()) {
                            var popup = new (0, $f03f5eca0427a383$export$a0872ea153981ca8)({
                                title: (0, $wYO7b.Resources).t("words.threeFreeContents"),
                                content: (0, $wYO7b.Resources).t("words.createAccountSeoContent"),
                                buttonText: (0, $wYO7b.Resources).t("words.beginFree"),
                                buttonUrl: (0, $3Qm5T.Network).router.pages.getPanelUrl('signup')
                            });
                            popup.onClose = function() {
                                return (0, $yJnBa.SedestralStorage).setItem("CblogClosed", "open");
                            };
                            (0, $eQCFs.SedestralInterface).body.render(popup);
                        }
                        _this.blogRendered = true;
                    }
                //}
                }, 15000);
            }
        },
        {
            key: "blogWriteFinished",
            value: function blogWriteFinished() {
                var popup = new (0, $f03f5eca0427a383$export$a0872ea153981ca8)({
                    title: (0, $wYO7b.Resources).t("words.congratulationsFirstContent"),
                    content: (0, $wYO7b.Resources).t("words.scheduleDemoSeoBoost"),
                    buttonText: (0, $wYO7b.Resources).t("words.scheduleDemo"),
                    buttonUrl: (0, $3Qm5T.Network).router.pages.getWebsiteUrl('schedule'),
                    large: true,
                    cases: [
                        {
                            title: (0, $wYO7b.Resources).t("words.instructions"),
                            icon: "ai",
                            text: (0, $wYO7b.Resources).t("words.optimizeAiInstructions")
                        },
                        {
                            title: (0, $wYO7b.Resources).t("words.context"),
                            icon: "context",
                            text: (0, $wYO7b.Resources).t("words.explainBusinessActivity")
                        },
                        {
                            title: (0, $wYO7b.Resources).t("words.styleCloning"),
                            icon: "style",
                            text: (0, $wYO7b.Resources).t("words.keepWritingStyle")
                        }
                    ]
                });
                popup.onClose = function() {
                    return (0, $yJnBa.SedestralStorage).setItem("CblogClosed", "open");
                };
                (0, $eQCFs.SedestralInterface).body.render(popup);
            }
        }
    ]);
    return CustomerPopup;
}();
$8f67b912ef2ce121$export$4718cc74f3daff00.blogRendered = false;


var $ea4716edc57e8679$export$db95308c3d59a34d = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogComponent, Component);
    function WebsiteContentBlogComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $c94a38a55d85de37$export$dd68357b72560132)({
            title: (0, $wYO7b.Resources).t("words.letAIGenerateArticles"),
            text: (0, $wYO7b.Resources).t("words.smartBlogDescription"),
            productType: (0, $co7RM.ProductType).BLOG,
            url: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-a.webp"),
            buttonText: (0, $wYO7b.Resources).t("words.generatethreeFreeContents"),
            buttonUrl: (0, $3Qm5T.Network).router.pages.getPanelUrl('signup')
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.seeSmartBlogInAction"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-video-a.mp4"),
            color: "black",
            size: "tall",
            border: "border",
            shadow: "shadow"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $db62148f7de3d193$export$f03a647dc37f632a)({
            title: (0, $wYO7b.Resources).t("words.howItWorks"),
            grid: [
                {
                    name: (0, $wYO7b.Resources).t("words.customizeConfig"),
                    description: (0, $wYO7b.Resources).t("words.customizeDescription"),
                    icon: $c4d18c363f69c643$export$b714fa498b091246
                },
                {
                    name: (0, $wYO7b.Resources).t("words.explainTitle"),
                    description: (0, $wYO7b.Resources).t("words.explainDescription"),
                    icon: $c4d18c363f69c643$export$be246276456a52e7
                },
                {
                    name: (0, $wYO7b.Resources).t("words.publishArticleTitle"),
                    description: (0, $wYO7b.Resources).t("words.publishArticleDescription"),
                    icon: $c4d18c363f69c643$export$30780d0b6b610af8
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.connectExistingBlog"),
            description: (0, $wYO7b.Resources).t("words.chooseCmsPlatform"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).illus("illus-cms.svg"),
            color: "black",
            size: "intermediate"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.customizeYourBlog"),
            description: (0, $wYO7b.Resources).t("words.customizeBlogDescription"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-d.webp"),
            color: "multi",
            size: "tall"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $11905550a94e3587$export$21cf7e1029971b9d)((0, $wYO7b.Resources).t("words.iaArticleWriting"), [
            {
                icon: "draft",
                title: (0, $wYO7b.Resources).t("words.instructionsTitle"),
                desc: (0, $wYO7b.Resources).t("words.instructionsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $wYO7b.Resources).t("words.proposalsTitle"),
                desc: (0, $wYO7b.Resources).t("words.proposalsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $wYO7b.Resources).t("words.planTitle"),
                desc: (0, $wYO7b.Resources).t("words.planDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $wYO7b.Resources).t("words.writingTitle"),
                desc: (0, $wYO7b.Resources).t("words.writingDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ])), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $951a12393fe71ff0$export$e4b6d83931e2a971)({
            title: (0, $wYO7b.Resources).t("words.seoOptimizedBlog"),
            subtitle: (0, $wYO7b.Resources).t("words.seoOptimizedBlogSubtitle"),
            illus: "illus-seo",
            size: "medium"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $22bbd5ff065cc08a$export$1965e7302a1f5007)({
            title: (0, $wYO7b.Resources).t("words.otherFeatures"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-domains",
                    title: (0, $wYO7b.Resources).t("words.domainNameTitle"),
                    subtitle: (0, $wYO7b.Resources).t("words.domainNameSubtitle")
                },
                {
                    icon: "black-export",
                    title: (0, $wYO7b.Resources).t("words.exportArticlesTitle"),
                    subtitle: (0, $wYO7b.Resources).t("words.exportArticlesSubtitle")
                },
                {
                    icon: "black-lineal-delay",
                    title: (0, $wYO7b.Resources).t("words.scheduleArticlesTitle"),
                    subtitle: (0, $wYO7b.Resources).t("words.scheduleArticlesSubtitle")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2ad9de2cc8e904c9$export$e9f2082bf3648ed6)((0, $wYO7b.Resources).t("words.whatOurClientsSay"), (0, $3e10e981c2995cb0$export$a27e371a094e4e50).reviews())), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.doesGooglePenalizeAiContent"),
                    response: (0, $wYO7b.Resources).t("words.googleDoesNotPenalizeAiContent")
                }
            ].concat((0, $78NO5._)((0, $wYO7b.Resources).t("words.questions.smartblog")))
        })), "\n                    </div>\n                </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogComponent;
}((0, $9gCL8.Component));


var $3868289c2c610572$export$d7d15f70146cf1a7 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogPage, WebsitePageComponent);
    function WebsiteBlogPage() {
        (0, $3CDbU._)(this, WebsiteBlogPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogPage);
        _this.updateMetas("blog");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $ea4716edc57e8679$export$db95308c3d59a34d)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $1be04210fc8913dd$export$74766011f560cccc;
var $1be04210fc8913dd$export$130be424786e852f;
$1be04210fc8913dd$export$74766011f560cccc = "I68Mt";
$1be04210fc8913dd$export$130be424786e852f = "YSJEJ";




var $wYO7b = parcelRequire("wYO7b");
function $3ea28b5e58cb3479$export$2cb99e4be0dc4646(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            if (callback) callback();
        }
    };
    else script.onload = function() {
        if (callback) callback();
    };
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}




var $f8f1f60a176d22fd$export$fa6bf7fb87b222ae = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentScheduleComponent, Component);
    function WebsiteContentScheduleComponent() {
        (0, $3CDbU._)(this, WebsiteContentScheduleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentScheduleComponent), _this.loaderLightComponent = new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)();
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($1be04210fc8913dd$export$74766011f560cccc, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.schedule"),
            description: "",
            color: "white",
            size: "intermediate"
        })), '\n                        <div style="margin-top:40px;" class="meetings-iframe-container" data-src="https://meetings.hubspot.com/alexis-avril?embed=true"></div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: (0, $wYO7b.Resources).t("words.questions.schedule")
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentScheduleComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentScheduleComponent.prototype), "commit", this).call(this);
                (0, $3ea28b5e58cb3479$export$2cb99e4be0dc4646)("https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js", function() {});
            }
        }
    ]);
    return WebsiteContentScheduleComponent;
}((0, $9gCL8.Component));


var $418cf8fbbfbc9db9$export$dad0f9f593647209 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteSchedulePage, WebsitePageComponent);
    function WebsiteSchedulePage() {
        (0, $3CDbU._)(this, WebsiteSchedulePage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteSchedulePage);
        _this.updateMetas("schedule");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteSchedulePage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $f8f1f60a176d22fd$export$fa6bf7fb87b222ae)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteSchedulePage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $9gCL8 = parcelRequire("9gCL8");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $423eb79f6868be0b$export$27262836c31796ac;
var $423eb79f6868be0b$export$3481c78889e8fbe8;
var $423eb79f6868be0b$export$fb184b623420d9be;
var $423eb79f6868be0b$export$6d59db4903f20f7d;
var $423eb79f6868be0b$export$7317a7c5ea43bbe0;
var $423eb79f6868be0b$export$f83c4d891692a29b;
var $423eb79f6868be0b$export$de7e4d92f917a218;
var $423eb79f6868be0b$export$4bd6df12cc64b67d;
var $423eb79f6868be0b$export$86e62408adb4b70d;
var $423eb79f6868be0b$export$cc620c11ab3a91af;
var $423eb79f6868be0b$export$f333d7638cf8abde;
var $423eb79f6868be0b$export$bbea856fdb3e3c5f;
var $423eb79f6868be0b$export$b3571188c770cc5a;
var $423eb79f6868be0b$export$1ca1ec8b29a4ce27;
var $423eb79f6868be0b$export$8fa4e5556fd77a60;
var $423eb79f6868be0b$export$b8972b998723d602;
var $423eb79f6868be0b$export$a7db06668cad9adb;
var $423eb79f6868be0b$export$7c5480d2d52b096a;
var $423eb79f6868be0b$export$5c754c0557bd8d37;
var $423eb79f6868be0b$export$5eeba3dd1f988465;
$423eb79f6868be0b$export$27262836c31796ac = "_52VCW";
$423eb79f6868be0b$export$3481c78889e8fbe8 = "fzD9t";
$423eb79f6868be0b$export$fb184b623420d9be = "OYML3";
$423eb79f6868be0b$export$6d59db4903f20f7d = "pX5NR";
$423eb79f6868be0b$export$7317a7c5ea43bbe0 = "GujlJ";
$423eb79f6868be0b$export$f83c4d891692a29b = "Wi9mZ";
$423eb79f6868be0b$export$de7e4d92f917a218 = "GIt79";
$423eb79f6868be0b$export$4bd6df12cc64b67d = "_9Bt5v";
$423eb79f6868be0b$export$86e62408adb4b70d = "rO5f3";
$423eb79f6868be0b$export$cc620c11ab3a91af = "cpRAF";
$423eb79f6868be0b$export$f333d7638cf8abde = "tTGka";
$423eb79f6868be0b$export$bbea856fdb3e3c5f = "vuphj";
$423eb79f6868be0b$export$b3571188c770cc5a = "_2Mumn";
$423eb79f6868be0b$export$1ca1ec8b29a4ce27 = "ux-Oq";
$423eb79f6868be0b$export$8fa4e5556fd77a60 = "Sz80f";
$423eb79f6868be0b$export$b8972b998723d602 = "rkJA8";
$423eb79f6868be0b$export$a7db06668cad9adb = "-uSQp";
$423eb79f6868be0b$export$7c5480d2d52b096a = "GLQDJ";
$423eb79f6868be0b$export$5c754c0557bd8d37 = "ObTY6";
$423eb79f6868be0b$export$5eeba3dd1f988465 = "fXOt-";



var $3Qm5T = parcelRequire("3Qm5T");

var $wYO7b = parcelRequire("wYO7b");
var $d4f38fb53f9502a8$export$6d14472d28e42cd8 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackPresentationComponent, Component);
    function WebsiteBlackPresentationComponent(p) {
        (0, $3CDbU._)(this, WebsiteBlackPresentationComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackPresentationComponent);
        _this.p = p;
        var bigIconClass = undefined;
        if (p.partnerIcon) switch(p.partnerIcon){
            case "prestashop":
                bigIconClass = $423eb79f6868be0b$export$4bd6df12cc64b67d;
                break;
            case "wordpress":
                bigIconClass = $423eb79f6868be0b$export$cc620c11ab3a91af;
                break;
            case "shopify":
                bigIconClass = $423eb79f6868be0b$export$86e62408adb4b70d;
                break;
            case "wix":
                bigIconClass = $423eb79f6868be0b$export$f333d7638cf8abde;
                break;
        }
        var _p_firstButtonLink;
        //language=HTML
        _this.template = '\n            <div class="'.concat($423eb79f6868be0b$export$27262836c31796ac, " ").concat(p.center ? $423eb79f6868be0b$export$3481c78889e8fbe8 : "", '">\n                <div class="').concat($423eb79f6868be0b$export$5eeba3dd1f988465, '"></div>\n                <div class="').concat($423eb79f6868be0b$export$fb184b623420d9be, '">\n                    ').concat(p.title, '\n                </div>\n                <div class="').concat($423eb79f6868be0b$export$6d59db4903f20f7d, '">\n                    ').concat(p.description, "\n                </div>\n                ").concat(bigIconClass ? '\n                <div class="'.concat($423eb79f6868be0b$export$7317a7c5ea43bbe0, '">\n                    <div class="').concat($423eb79f6868be0b$export$f83c4d891692a29b, '"></div>\n                    <div class="').concat($423eb79f6868be0b$export$de7e4d92f917a218, '"></div>\n                   <div class="').concat(bigIconClass, '"></div>\n                </div>\n                ') : "", '\n                <div class="').concat($423eb79f6868be0b$export$bbea856fdb3e3c5f, '">\n                    <a href="').concat((_p_firstButtonLink = p.firstButtonLink) !== null && _p_firstButtonLink !== void 0 ? _p_firstButtonLink : (0, $3Qm5T.Network).router.pages.getPanelUrl('signup'), '" target="_blank" class="').concat($423eb79f6868be0b$export$b3571188c770cc5a, '">\n                        <div class="').concat($423eb79f6868be0b$export$b8972b998723d602, '"></div>\n                        <div class="').concat($423eb79f6868be0b$export$a7db06668cad9adb, '">\n                            ').concat(p.startText, '\n                            <div class="').concat($423eb79f6868be0b$export$1ca1ec8b29a4ce27, '"></div>\n                        </div>\n                    </a>\n                    ').concat(p.secondButton ? '\n                    <a href="https://prestashop.strl.io/my-blog" target="_blank" class="'.concat($423eb79f6868be0b$export$b3571188c770cc5a, " ").concat($423eb79f6868be0b$export$8fa4e5556fd77a60, '">\n                       <div class="').concat($423eb79f6868be0b$export$a7db06668cad9adb, '">\n                            <div class="').concat($423eb79f6868be0b$export$1ca1ec8b29a4ce27, " ").concat($423eb79f6868be0b$export$7c5480d2d52b096a, '"></div>\n                            ').concat((0, $wYO7b.Resources).t("words.viewDemoBlog"), '\n                            <div class="').concat($423eb79f6868be0b$export$1ca1ec8b29a4ce27, '"></div>\n                        </div>\n                    </a>\n                    ') : "", "\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackPresentationComponent, [
        {
            key: "commit",
            value: function commit() {
                this.buttons = this.el($423eb79f6868be0b$export$bbea856fdb3e3c5f);
                if (this.p.people) //language=HTML
                this.buttons.append('\n                <div class="'.concat($423eb79f6868be0b$export$5c754c0557bd8d37, '">\n                    <div class="').concat($423eb79f6868be0b$export$1ca1ec8b29a4ce27, '"></div>\n                    ').concat((0, $wYO7b.Resources).t("words.improveRankingMessage"), "\n                </div>\n            "));
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackPresentationComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteBlackPresentationComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a700d2ff960d6968$exports = {};

$parcel$export($a700d2ff960d6968$exports, "componentWebsiteBlackSteps", function () { return $a700d2ff960d6968$export$22248bcf0be7d5f1; }, function (v) { return $a700d2ff960d6968$export$22248bcf0be7d5f1 = v; });
$parcel$export($a700d2ff960d6968$exports, "bottomShadow", function () { return $a700d2ff960d6968$export$6e1e3cd95d0461b9; }, function (v) { return $a700d2ff960d6968$export$6e1e3cd95d0461b9 = v; });
$parcel$export($a700d2ff960d6968$exports, "top", function () { return $a700d2ff960d6968$export$1e95b668f3b82d; }, function (v) { return $a700d2ff960d6968$export$1e95b668f3b82d = v; });
$parcel$export($a700d2ff960d6968$exports, "topShadow", function () { return $a700d2ff960d6968$export$c9e520a45cbb2500; }, function (v) { return $a700d2ff960d6968$export$c9e520a45cbb2500 = v; });
$parcel$export($a700d2ff960d6968$exports, "title", function () { return $a700d2ff960d6968$export$fb184b623420d9be; }, function (v) { return $a700d2ff960d6968$export$fb184b623420d9be = v; });
$parcel$export($a700d2ff960d6968$exports, "icon", function () { return $a700d2ff960d6968$export$1ca1ec8b29a4ce27; }, function (v) { return $a700d2ff960d6968$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($a700d2ff960d6968$exports, "seo", function () { return $a700d2ff960d6968$export$7dc4b9367473a505; }, function (v) { return $a700d2ff960d6968$export$7dc4b9367473a505 = v; });
$parcel$export($a700d2ff960d6968$exports, "value", function () { return $a700d2ff960d6968$export$2ab9a8f9f1186f14; }, function (v) { return $a700d2ff960d6968$export$2ab9a8f9f1186f14 = v; });
$parcel$export($a700d2ff960d6968$exports, "buttons", function () { return $a700d2ff960d6968$export$bbea856fdb3e3c5f; }, function (v) { return $a700d2ff960d6968$export$bbea856fdb3e3c5f = v; });
$parcel$export($a700d2ff960d6968$exports, "button", function () { return $a700d2ff960d6968$export$2ba01fb71ed41cb6; }, function (v) { return $a700d2ff960d6968$export$2ba01fb71ed41cb6 = v; });
$parcel$export($a700d2ff960d6968$exports, "progress", function () { return $a700d2ff960d6968$export$504d7abb21fa8c9; }, function (v) { return $a700d2ff960d6968$export$504d7abb21fa8c9 = v; });
$parcel$export($a700d2ff960d6968$exports, "name", function () { return $a700d2ff960d6968$export$a8ff84c12d48cfa6; }, function (v) { return $a700d2ff960d6968$export$a8ff84c12d48cfa6 = v; });
$parcel$export($a700d2ff960d6968$exports, "content", function () { return $a700d2ff960d6968$export$a7db06668cad9adb; }, function (v) { return $a700d2ff960d6968$export$a7db06668cad9adb = v; });
$parcel$export($a700d2ff960d6968$exports, "image", function () { return $a700d2ff960d6968$export$5c452ff88e35e47d; }, function (v) { return $a700d2ff960d6968$export$5c452ff88e35e47d = v; });
var $a700d2ff960d6968$export$22248bcf0be7d5f1;
var $a700d2ff960d6968$export$6e1e3cd95d0461b9;
var $a700d2ff960d6968$export$1e95b668f3b82d;
var $a700d2ff960d6968$export$c9e520a45cbb2500;
var $a700d2ff960d6968$export$fb184b623420d9be;
var $a700d2ff960d6968$export$1ca1ec8b29a4ce27;
var $a700d2ff960d6968$export$7dc4b9367473a505;
var $a700d2ff960d6968$export$2ab9a8f9f1186f14;
var $a700d2ff960d6968$export$bbea856fdb3e3c5f;
var $a700d2ff960d6968$export$2ba01fb71ed41cb6;
var $a700d2ff960d6968$export$504d7abb21fa8c9;
var $a700d2ff960d6968$export$a8ff84c12d48cfa6;
var $a700d2ff960d6968$export$a7db06668cad9adb;
var $a700d2ff960d6968$export$5c452ff88e35e47d;
$a700d2ff960d6968$export$22248bcf0be7d5f1 = "PoB7X";
$a700d2ff960d6968$export$6e1e3cd95d0461b9 = "Vhl-t";
$a700d2ff960d6968$export$1e95b668f3b82d = "VkiXO";
$a700d2ff960d6968$export$c9e520a45cbb2500 = "oZZa3";
$a700d2ff960d6968$export$fb184b623420d9be = "HaV8-";
$a700d2ff960d6968$export$1ca1ec8b29a4ce27 = "DYaIt";
$a700d2ff960d6968$export$7dc4b9367473a505 = "c486o";
$a700d2ff960d6968$export$2ab9a8f9f1186f14 = "-KzaJ";
$a700d2ff960d6968$export$bbea856fdb3e3c5f = "_2MtyC";
$a700d2ff960d6968$export$2ba01fb71ed41cb6 = "qxc5x";
$a700d2ff960d6968$export$504d7abb21fa8c9 = "DwOoN";
$a700d2ff960d6968$export$a8ff84c12d48cfa6 = "IEX5n";
$a700d2ff960d6968$export$a7db06668cad9adb = "JQG93";
$a700d2ff960d6968$export$5c452ff88e35e47d = "hr8SM";


var $876aeb3188abd82e$export$41c8d4c54c27d95f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackStepsComponent, Component);
    function WebsiteBlackStepsComponent(steps) {
        (0, $3CDbU._)(this, WebsiteBlackStepsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackStepsComponent);
        _this.steps = steps;
        _this.buttons = [];
        //language=HTML
        _this.template = '\n            <div class="'.concat($a700d2ff960d6968$exports.componentWebsiteBlackSteps, '">\n                <div class="').concat($a700d2ff960d6968$exports.bottomShadow, '"></div>\n\n                <div class="').concat($a700d2ff960d6968$exports.top, '">\n                    <div class="').concat($a700d2ff960d6968$exports.topShadow, '"></div>\n                    <div class="').concat($a700d2ff960d6968$exports.title, '">\n                        <div class="').concat($a700d2ff960d6968$exports.icon, " ").concat($a700d2ff960d6968$exports[steps.icon], '"></div>\n                        <div class="').concat($a700d2ff960d6968$exports.value, '">\n                            ').concat(steps.title, '\n                        </div>\n                    </div>\n                    <div class="').concat($a700d2ff960d6968$exports.buttons, '"></div>\n                </div>\n                <div class="').concat($a700d2ff960d6968$exports.content, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackStepsComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.buttonsContainer = this.el($a700d2ff960d6968$exports.buttons);
                this.contentContainer = this.el($a700d2ff960d6968$exports.content);
                this.steps.contents.forEach(function(content) {
                    //language=HTML
                    var component = _this.buttonsContainer.append('\n                <div class="'.concat($a700d2ff960d6968$exports.button, '">\n                    <div class="').concat($a700d2ff960d6968$exports.progress, '"></div>\n                    <div class="').concat($a700d2ff960d6968$exports.name, '">').concat(content.name, "</div>\n                </div>\n            "));
                    var progress = component.el($a700d2ff960d6968$exports.progress);
                    var button = {
                        button: component,
                        progress: progress,
                        content: content
                    };
                    _this.buttons.push(button);
                    component.onClick(function() {
                        return _this.renderContent(button);
                    });
                });
                this.renderContent(this.buttons[0]);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackStepsComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderContent",
            value: function renderContent(button) {
                var _this = this;
                if (this.contentButton) {
                    this.contentButton.progress.setStyle("width:0%;transition:0s;");
                    clearTimeout(this.contentProgressInterval);
                }
                this.contentContainer.clearAll();
                clearTimeout(this.contentTimeout);
                this.contentButton = button;
                switch(this.contentButton.content.type){
                    case "img":
                        this.contentContainer.append('<img class="'.concat($a700d2ff960d6968$exports.image, '" src="').concat(this.contentButton.content.path, '"/>'));
                        break;
                    case "video":
                        //language=HTML
                        var video = this.contentContainer.append('\n                    <video autoplay loop muted playsinline style="width: 100%;">\n                        <source src="'.concat(this.contentButton.content.path, '" type="video/mp4"/>\n                    </video>'));
                        video.getHTMLElement().onloadedmetadata = function() {
                            _this.contentContainer.setStyle("height: ".concat(_this.contentContainer.getHeight(), "px;"));
                            var contentSizeTimeout;
                            _this.contentContainer.putListener(window, "resize", function() {
                                clearTimeout(contentSizeTimeout);
                                _this.contentContainer.setStyle("height: unset;");
                                contentSizeTimeout = _this.timeOut(function() {
                                    _this.contentContainer.setStyle("height: ".concat(_this.contentContainer.getHeight(), "px;"));
                                }, 1000);
                            });
                        };
                        break;
                }
                var width = 0;
                this.contentProgressInterval = this.interval(function() {
                    width += 0.5;
                    _this.contentButton.progress.setStyle("width:".concat(width, "%;transition:0s;"));
                }, button.content.duration / 200);
                this.contentTimeout = this.timeOut(function() {
                    var currentIndex = _this.buttons.indexOf(_this.contentButton);
                    var nextIndex = currentIndex + 1;
                    if (_this.buttons.length - 1 >= nextIndex) _this.renderContent(_this.buttons[nextIndex]);
                    else _this.renderContent(_this.buttons[0]);
                }, this.contentButton.content.duration);
            }
        }
    ]);
    return WebsiteBlackStepsComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $6da1364541e44edb$exports = {};

$parcel$export($6da1364541e44edb$exports, "componentWebsiteBlackText", function () { return $6da1364541e44edb$export$44742403a52a2f0f; }, function (v) { return $6da1364541e44edb$export$44742403a52a2f0f = v; });
$parcel$export($6da1364541e44edb$exports, "sizeNormal", function () { return $6da1364541e44edb$export$f1af96aedc86f3e3; }, function (v) { return $6da1364541e44edb$export$f1af96aedc86f3e3 = v; });
$parcel$export($6da1364541e44edb$exports, "content", function () { return $6da1364541e44edb$export$a7db06668cad9adb; }, function (v) { return $6da1364541e44edb$export$a7db06668cad9adb = v; });
$parcel$export($6da1364541e44edb$exports, "sizeBig", function () { return $6da1364541e44edb$export$253b27e74ad938c7; }, function (v) { return $6da1364541e44edb$export$253b27e74ad938c7 = v; });
$parcel$export($6da1364541e44edb$exports, "colorBlue", function () { return $6da1364541e44edb$export$4280a44aebc4cc67; }, function (v) { return $6da1364541e44edb$export$4280a44aebc4cc67 = v; });
$parcel$export($6da1364541e44edb$exports, "shadow", function () { return $6da1364541e44edb$export$b8972b998723d602; }, function (v) { return $6da1364541e44edb$export$b8972b998723d602 = v; });
var $6da1364541e44edb$export$44742403a52a2f0f;
var $6da1364541e44edb$export$f1af96aedc86f3e3;
var $6da1364541e44edb$export$a7db06668cad9adb;
var $6da1364541e44edb$export$253b27e74ad938c7;
var $6da1364541e44edb$export$4280a44aebc4cc67;
var $6da1364541e44edb$export$b8972b998723d602;
$6da1364541e44edb$export$44742403a52a2f0f = "-aEG-";
$6da1364541e44edb$export$f1af96aedc86f3e3 = "iCnEs";
$6da1364541e44edb$export$a7db06668cad9adb = "bA27x";
$6da1364541e44edb$export$253b27e74ad938c7 = "bHiY6";
$6da1364541e44edb$export$4280a44aebc4cc67 = "p4ztM";
$6da1364541e44edb$export$b8972b998723d602 = "YQURL";


var $529cecc0c9ce0c3a$export$67fc1824eabdc07e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackTextComponent, Component);
    function WebsiteBlackTextComponent(text) {
        (0, $3CDbU._)(this, WebsiteBlackTextComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackTextComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($6da1364541e44edb$exports.componentWebsiteBlackText, " ").concat($6da1364541e44edb$exports[text.size], " ").concat($6da1364541e44edb$exports[text.shadow], '">\n                <div class="').concat($6da1364541e44edb$exports.shadow, '"></div>\n                <div class="').concat($6da1364541e44edb$exports.content, '">\n                    ').concat(text.text, "\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteBlackTextComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $c3f41ac5a0bc4d68$export$b3ff231557e20c05;
var $c3f41ac5a0bc4d68$export$71ef6e19fae6c840;
var $c3f41ac5a0bc4d68$export$f38c853ae54ed474;
var $c3f41ac5a0bc4d68$export$2cc7ff91bcacba5e;
var $c3f41ac5a0bc4d68$export$1ca1ec8b29a4ce27;
var $c3f41ac5a0bc4d68$export$6f093cfa640b7166;
var $c3f41ac5a0bc4d68$export$6d59db4903f20f7d;
var $c3f41ac5a0bc4d68$export$53f1d5ea8de3d7c;
var $c3f41ac5a0bc4d68$export$b8972b998723d602;
var $c3f41ac5a0bc4d68$export$a7db06668cad9adb;
var $c3f41ac5a0bc4d68$export$324fbeb68ccbc72b;
$c3f41ac5a0bc4d68$export$b3ff231557e20c05 = "zT2fa";
$c3f41ac5a0bc4d68$export$71ef6e19fae6c840 = "_4krrE";
$c3f41ac5a0bc4d68$export$f38c853ae54ed474 = "APUgj";
$c3f41ac5a0bc4d68$export$2cc7ff91bcacba5e = "LTdkm";
$c3f41ac5a0bc4d68$export$1ca1ec8b29a4ce27 = "wJONj";
$c3f41ac5a0bc4d68$export$6f093cfa640b7166 = "QCAI8";
$c3f41ac5a0bc4d68$export$6d59db4903f20f7d = "haNuL";
$c3f41ac5a0bc4d68$export$53f1d5ea8de3d7c = "_8iGRt";
$c3f41ac5a0bc4d68$export$b8972b998723d602 = "_6GR0q";
$c3f41ac5a0bc4d68$export$a7db06668cad9adb = "jLehA";
$c3f41ac5a0bc4d68$export$324fbeb68ccbc72b = "NCbz5";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $a8202a5b7bd9f0d6$exports = {};

$parcel$export($a8202a5b7bd9f0d6$exports, "componentWebsiteBlackGrid", function () { return $a8202a5b7bd9f0d6$export$6ef958818d7dbb11; }, function (v) { return $a8202a5b7bd9f0d6$export$6ef958818d7dbb11 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "line", function () { return $a8202a5b7bd9f0d6$export$53f1d5ea8de3d7c; }, function (v) { return $a8202a5b7bd9f0d6$export$53f1d5ea8de3d7c = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "entry", function () { return $a8202a5b7bd9f0d6$export$c407db72103fecfa; }, function (v) { return $a8202a5b7bd9f0d6$export$c407db72103fecfa = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "names", function () { return $a8202a5b7bd9f0d6$export$e4b2ac9215619f8d; }, function (v) { return $a8202a5b7bd9f0d6$export$e4b2ac9215619f8d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "title", function () { return $a8202a5b7bd9f0d6$export$fb184b623420d9be; }, function (v) { return $a8202a5b7bd9f0d6$export$fb184b623420d9be = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "hasStep", function () { return $a8202a5b7bd9f0d6$export$93a5057b3118dcd; }, function (v) { return $a8202a5b7bd9f0d6$export$93a5057b3118dcd = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "step", function () { return $a8202a5b7bd9f0d6$export$35d34bc0ed591a92; }, function (v) { return $a8202a5b7bd9f0d6$export$35d34bc0ed591a92 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "stepShadow", function () { return $a8202a5b7bd9f0d6$export$60b3551206497142; }, function (v) { return $a8202a5b7bd9f0d6$export$60b3551206497142 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "text", function () { return $a8202a5b7bd9f0d6$export$6f093cfa640b7166; }, function (v) { return $a8202a5b7bd9f0d6$export$6f093cfa640b7166 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "ai", function () { return $a8202a5b7bd9f0d6$export$f38c853ae54ed474; }, function (v) { return $a8202a5b7bd9f0d6$export$f38c853ae54ed474 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "aiShadow", function () { return $a8202a5b7bd9f0d6$export$2516fe6c625b33a; }, function (v) { return $a8202a5b7bd9f0d6$export$2516fe6c625b33a = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "aiIcon", function () { return $a8202a5b7bd9f0d6$export$c142f6a77c53147e; }, function (v) { return $a8202a5b7bd9f0d6$export$c142f6a77c53147e = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "description", function () { return $a8202a5b7bd9f0d6$export$6d59db4903f20f7d; }, function (v) { return $a8202a5b7bd9f0d6$export$6d59db4903f20f7d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "iconContainer", function () { return $a8202a5b7bd9f0d6$export$acf4eaf431084f78; }, function (v) { return $a8202a5b7bd9f0d6$export$acf4eaf431084f78 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "icon", function () { return $a8202a5b7bd9f0d6$export$1ca1ec8b29a4ce27; }, function (v) { return $a8202a5b7bd9f0d6$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "optimize", function () { return $a8202a5b7bd9f0d6$export$f90719f89646befa; }, function (v) { return $a8202a5b7bd9f0d6$export$f90719f89646befa = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "ready", function () { return $a8202a5b7bd9f0d6$export$28ee1007e174a2a6; }, function (v) { return $a8202a5b7bd9f0d6$export$28ee1007e174a2a6 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "unique", function () { return $a8202a5b7bd9f0d6$export$7a5d5c156e7dc406; }, function (v) { return $a8202a5b7bd9f0d6$export$7a5d5c156e7dc406 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "picture", function () { return $a8202a5b7bd9f0d6$export$1188214e9d38144e; }, function (v) { return $a8202a5b7bd9f0d6$export$1188214e9d38144e = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "seo", function () { return $a8202a5b7bd9f0d6$export$7dc4b9367473a505; }, function (v) { return $a8202a5b7bd9f0d6$export$7dc4b9367473a505 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "write", function () { return $a8202a5b7bd9f0d6$export$68d8715fc104d294; }, function (v) { return $a8202a5b7bd9f0d6$export$68d8715fc104d294 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "plan", function () { return $a8202a5b7bd9f0d6$export$3c7172b0b56389d; }, function (v) { return $a8202a5b7bd9f0d6$export$3c7172b0b56389d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "chart", function () { return $a8202a5b7bd9f0d6$export$8fde8ebd684d5072; }, function (v) { return $a8202a5b7bd9f0d6$export$8fde8ebd684d5072 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "google", function () { return $a8202a5b7bd9f0d6$export$2d1fdedcfa4b711e; }, function (v) { return $a8202a5b7bd9f0d6$export$2d1fdedcfa4b711e = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "searchEngine", function () { return $a8202a5b7bd9f0d6$export$bc784e6c5653beec; }, function (v) { return $a8202a5b7bd9f0d6$export$bc784e6c5653beec = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "funnel", function () { return $a8202a5b7bd9f0d6$export$cd223ad0107da099; }, function (v) { return $a8202a5b7bd9f0d6$export$cd223ad0107da099 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "autopilot", function () { return $a8202a5b7bd9f0d6$export$5d910be2177c3c87; }, function (v) { return $a8202a5b7bd9f0d6$export$5d910be2177c3c87 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "chartPurple", function () { return $a8202a5b7bd9f0d6$export$b5c1237f4655e054; }, function (v) { return $a8202a5b7bd9f0d6$export$b5c1237f4655e054 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "languages", function () { return $a8202a5b7bd9f0d6$export$d0d68bb9ed2c643d; }, function (v) { return $a8202a5b7bd9f0d6$export$d0d68bb9ed2c643d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "imageContainer", function () { return $a8202a5b7bd9f0d6$export$63e82393dc8977bf; }, function (v) { return $a8202a5b7bd9f0d6$export$63e82393dc8977bf = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "image", function () { return $a8202a5b7bd9f0d6$export$5c452ff88e35e47d; }, function (v) { return $a8202a5b7bd9f0d6$export$5c452ff88e35e47d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "shadow", function () { return $a8202a5b7bd9f0d6$export$b8972b998723d602; }, function (v) { return $a8202a5b7bd9f0d6$export$b8972b998723d602 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "colorBlue", function () { return $a8202a5b7bd9f0d6$export$4280a44aebc4cc67; }, function (v) { return $a8202a5b7bd9f0d6$export$4280a44aebc4cc67 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "colorYellow", function () { return $a8202a5b7bd9f0d6$export$54336073cc165189; }, function (v) { return $a8202a5b7bd9f0d6$export$54336073cc165189 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "colorWhite", function () { return $a8202a5b7bd9f0d6$export$e440a56bff5718e8; }, function (v) { return $a8202a5b7bd9f0d6$export$e440a56bff5718e8 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "colorPurple", function () { return $a8202a5b7bd9f0d6$export$e2ab8c1ee254ce8f; }, function (v) { return $a8202a5b7bd9f0d6$export$e2ab8c1ee254ce8f = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "shadowBottomCenter", function () { return $a8202a5b7bd9f0d6$export$bd679f57ea2e4e2b; }, function (v) { return $a8202a5b7bd9f0d6$export$bd679f57ea2e4e2b = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "shadowLeftCenter", function () { return $a8202a5b7bd9f0d6$export$aecbfdca6b8a6495; }, function (v) { return $a8202a5b7bd9f0d6$export$aecbfdca6b8a6495 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "shadowNone", function () { return $a8202a5b7bd9f0d6$export$14fae57729df0db; }, function (v) { return $a8202a5b7bd9f0d6$export$14fae57729df0db = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "shadowMid", function () { return $a8202a5b7bd9f0d6$export$ded960129251095d; }, function (v) { return $a8202a5b7bd9f0d6$export$ded960129251095d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "sizeLarge", function () { return $a8202a5b7bd9f0d6$export$994c44911440ea2d; }, function (v) { return $a8202a5b7bd9f0d6$export$994c44911440ea2d = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "sizeLargeCenter", function () { return $a8202a5b7bd9f0d6$export$fc5cf8c4e7d669f4; }, function (v) { return $a8202a5b7bd9f0d6$export$fc5cf8c4e7d669f4 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "sizeMid", function () { return $a8202a5b7bd9f0d6$export$3cf57bd17692eda2; }, function (v) { return $a8202a5b7bd9f0d6$export$3cf57bd17692eda2 = v; });
$parcel$export($a8202a5b7bd9f0d6$exports, "sizeMidColumn", function () { return $a8202a5b7bd9f0d6$export$ae6e0e6826020bcd; }, function (v) { return $a8202a5b7bd9f0d6$export$ae6e0e6826020bcd = v; });
var $a8202a5b7bd9f0d6$export$6ef958818d7dbb11;
var $a8202a5b7bd9f0d6$export$53f1d5ea8de3d7c;
var $a8202a5b7bd9f0d6$export$c407db72103fecfa;
var $a8202a5b7bd9f0d6$export$e4b2ac9215619f8d;
var $a8202a5b7bd9f0d6$export$fb184b623420d9be;
var $a8202a5b7bd9f0d6$export$93a5057b3118dcd;
var $a8202a5b7bd9f0d6$export$35d34bc0ed591a92;
var $a8202a5b7bd9f0d6$export$60b3551206497142;
var $a8202a5b7bd9f0d6$export$6f093cfa640b7166;
var $a8202a5b7bd9f0d6$export$f38c853ae54ed474;
var $a8202a5b7bd9f0d6$export$2516fe6c625b33a;
var $a8202a5b7bd9f0d6$export$c142f6a77c53147e;
var $a8202a5b7bd9f0d6$export$6d59db4903f20f7d;
var $a8202a5b7bd9f0d6$export$acf4eaf431084f78;
var $a8202a5b7bd9f0d6$export$1ca1ec8b29a4ce27;
var $a8202a5b7bd9f0d6$export$f90719f89646befa;
var $a8202a5b7bd9f0d6$export$28ee1007e174a2a6;
var $a8202a5b7bd9f0d6$export$7a5d5c156e7dc406;
var $a8202a5b7bd9f0d6$export$1188214e9d38144e;
var $a8202a5b7bd9f0d6$export$7dc4b9367473a505;
var $a8202a5b7bd9f0d6$export$68d8715fc104d294;
var $a8202a5b7bd9f0d6$export$3c7172b0b56389d;
var $a8202a5b7bd9f0d6$export$8fde8ebd684d5072;
var $a8202a5b7bd9f0d6$export$2d1fdedcfa4b711e;
var $a8202a5b7bd9f0d6$export$bc784e6c5653beec;
var $a8202a5b7bd9f0d6$export$cd223ad0107da099;
var $a8202a5b7bd9f0d6$export$5d910be2177c3c87;
var $a8202a5b7bd9f0d6$export$b5c1237f4655e054;
var $a8202a5b7bd9f0d6$export$d0d68bb9ed2c643d;
var $a8202a5b7bd9f0d6$export$63e82393dc8977bf;
var $a8202a5b7bd9f0d6$export$5c452ff88e35e47d;
var $a8202a5b7bd9f0d6$export$b8972b998723d602;
var $a8202a5b7bd9f0d6$export$4280a44aebc4cc67;
var $a8202a5b7bd9f0d6$export$54336073cc165189;
var $a8202a5b7bd9f0d6$export$e440a56bff5718e8;
var $a8202a5b7bd9f0d6$export$e2ab8c1ee254ce8f;
var $a8202a5b7bd9f0d6$export$bd679f57ea2e4e2b;
var $a8202a5b7bd9f0d6$export$aecbfdca6b8a6495;
var $a8202a5b7bd9f0d6$export$14fae57729df0db;
var $a8202a5b7bd9f0d6$export$ded960129251095d;
var $a8202a5b7bd9f0d6$export$994c44911440ea2d;
var $a8202a5b7bd9f0d6$export$fc5cf8c4e7d669f4;
var $a8202a5b7bd9f0d6$export$3cf57bd17692eda2;
var $a8202a5b7bd9f0d6$export$ae6e0e6826020bcd;
$a8202a5b7bd9f0d6$export$6ef958818d7dbb11 = "qKCUJ";
$a8202a5b7bd9f0d6$export$53f1d5ea8de3d7c = "WPmMr";
$a8202a5b7bd9f0d6$export$c407db72103fecfa = "C8CXK";
$a8202a5b7bd9f0d6$export$e4b2ac9215619f8d = "dWs1Q";
$a8202a5b7bd9f0d6$export$fb184b623420d9be = "b-s4o";
$a8202a5b7bd9f0d6$export$93a5057b3118dcd = "gTIC5";
$a8202a5b7bd9f0d6$export$35d34bc0ed591a92 = "u-01b";
$a8202a5b7bd9f0d6$export$60b3551206497142 = "tyMh-";
$a8202a5b7bd9f0d6$export$6f093cfa640b7166 = "T-c5i";
$a8202a5b7bd9f0d6$export$f38c853ae54ed474 = "U-iGy";
$a8202a5b7bd9f0d6$export$2516fe6c625b33a = "BF8rl";
$a8202a5b7bd9f0d6$export$c142f6a77c53147e = "wQjPy";
$a8202a5b7bd9f0d6$export$6d59db4903f20f7d = "L-nqz";
$a8202a5b7bd9f0d6$export$acf4eaf431084f78 = "JJUy6";
$a8202a5b7bd9f0d6$export$1ca1ec8b29a4ce27 = "ff7Pk";
$a8202a5b7bd9f0d6$export$f90719f89646befa = "_7bZ0S";
$a8202a5b7bd9f0d6$export$28ee1007e174a2a6 = "lv8jF";
$a8202a5b7bd9f0d6$export$7a5d5c156e7dc406 = "S7SPX";
$a8202a5b7bd9f0d6$export$1188214e9d38144e = "YT-pf";
$a8202a5b7bd9f0d6$export$7dc4b9367473a505 = "Cliu1";
$a8202a5b7bd9f0d6$export$68d8715fc104d294 = "PYhl0";
$a8202a5b7bd9f0d6$export$3c7172b0b56389d = "CFik-";
$a8202a5b7bd9f0d6$export$8fde8ebd684d5072 = "pLCxC";
$a8202a5b7bd9f0d6$export$2d1fdedcfa4b711e = "rSty3";
$a8202a5b7bd9f0d6$export$bc784e6c5653beec = "Mo3sE";
$a8202a5b7bd9f0d6$export$cd223ad0107da099 = "MGs8X";
$a8202a5b7bd9f0d6$export$5d910be2177c3c87 = "MsCft";
$a8202a5b7bd9f0d6$export$b5c1237f4655e054 = "-oQhP";
$a8202a5b7bd9f0d6$export$d0d68bb9ed2c643d = "IpCFF";
$a8202a5b7bd9f0d6$export$63e82393dc8977bf = "pJg8E";
$a8202a5b7bd9f0d6$export$5c452ff88e35e47d = "IEky7";
$a8202a5b7bd9f0d6$export$b8972b998723d602 = "D-XNO";
$a8202a5b7bd9f0d6$export$4280a44aebc4cc67 = "KpKma";
$a8202a5b7bd9f0d6$export$54336073cc165189 = "_0oATR";
$a8202a5b7bd9f0d6$export$e440a56bff5718e8 = "_0EH4V";
$a8202a5b7bd9f0d6$export$e2ab8c1ee254ce8f = "iq-lJ";
$a8202a5b7bd9f0d6$export$bd679f57ea2e4e2b = "WTtBr";
$a8202a5b7bd9f0d6$export$aecbfdca6b8a6495 = "RLhYf";
$a8202a5b7bd9f0d6$export$14fae57729df0db = "NVEv7";
$a8202a5b7bd9f0d6$export$ded960129251095d = "S-jOx";
$a8202a5b7bd9f0d6$export$994c44911440ea2d = "qUy8L";
$a8202a5b7bd9f0d6$export$fc5cf8c4e7d669f4 = "hMPR6";
$a8202a5b7bd9f0d6$export$3cf57bd17692eda2 = "vdbJ-";
$a8202a5b7bd9f0d6$export$ae6e0e6826020bcd = "Qn-3O";


var $54fc49d8c8d59622$export$9cf1ff22c077cd0b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackGridComponent, Component);
    function WebsiteBlackGridComponent(grid) {
        (0, $3CDbU._)(this, WebsiteBlackGridComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackGridComponent);
        _this.grid = grid;
        //language=HTML
        _this.template = '\n            <div class="'.concat($a8202a5b7bd9f0d6$exports.componentWebsiteBlackGrid, '"></div>');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackGridComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.grid.lines.forEach(function(value) {
                    return _this.renderLine(value.entries);
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackGridComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderLine",
            value: function renderLine(entries) {
                var line = this.append('<div class="'.concat($a8202a5b7bd9f0d6$exports.line, '"></div>'));
                entries.forEach(function(entry) {
                    //language=HTML
                    var entryContainer = line.append('\n                <div class="'.concat($a8202a5b7bd9f0d6$exports.entry, " ").concat($a8202a5b7bd9f0d6$exports[entry.color], " ").concat($a8202a5b7bd9f0d6$exports[entry.size], " ").concat($a8202a5b7bd9f0d6$exports[entry.shadowPosition], '">\n                    <div class="').concat($a8202a5b7bd9f0d6$exports.names, '">\n                        <div class="').concat($a8202a5b7bd9f0d6$exports.title, " ").concat(entry.step ? $a8202a5b7bd9f0d6$exports.hasStep : "", '">\n                            ').concat(entry.step ? '<div class="'.concat($a8202a5b7bd9f0d6$exports.step, '"><div class="').concat($a8202a5b7bd9f0d6$exports.stepShadow, '"></div><div class="').concat($a8202a5b7bd9f0d6$exports.text, '">').concat(entry.step, "</div></div>") : "", "\n                            ").concat(entry.ai ? '<div class="'.concat($a8202a5b7bd9f0d6$exports.ai, '"><div class="').concat($a8202a5b7bd9f0d6$exports.aiShadow, '"></div><div class="').concat($a8202a5b7bd9f0d6$exports.aiIcon, '"></div></div>') : "", "\n                            ").concat(entry.title, '\n                        </div>\n                        <div class="').concat($a8202a5b7bd9f0d6$exports.description, '">\n                            ').concat(entry.description, "\n                        </div>\n                    </div>\n\n                    ").concat(entry.type == "image" ? '<div class="'.concat($a8202a5b7bd9f0d6$exports.imageContainer, '"><img class="').concat($a8202a5b7bd9f0d6$exports.image, '" src="').concat(entry.image, '" alt="presentation"/></div>') : "", "\n                    ").concat(entry.type == "icon" ? '<div class="'.concat($a8202a5b7bd9f0d6$exports.iconContainer, '"><div class="').concat($a8202a5b7bd9f0d6$exports.icon, " ").concat($a8202a5b7bd9f0d6$exports[entry.icon], '"></div></div>') : "", '\n                    <div class="').concat($a8202a5b7bd9f0d6$exports.shadow, '"></div>\n                </div>\n            '));
                    var imageContainer = entryContainer.el($a8202a5b7bd9f0d6$exports.imageContainer);
                    var iconContainer = entryContainer.el($a8202a5b7bd9f0d6$exports.iconContainer);
                    entryContainer.isBelowScroll(function(isVisible) {
                        if (!isVisible) {
                            if (!imageContainer.isNull()) imageContainer.translate({
                                opacity: 0,
                                translateY: 60,
                                delay: 200
                            });
                            if (!iconContainer.isNull()) iconContainer.translate({
                                opacity: 0,
                                translateY: 60,
                                delay: 200
                            });
                        } else {
                            if (!imageContainer.isNull()) imageContainer.translate({
                                opacity: 1,
                                translateY: 0,
                                delay: 250
                            });
                            if (!iconContainer.isNull()) iconContainer.translate({
                                opacity: 1,
                                translateY: 0,
                                delay: 250
                            });
                        }
                    }, true);
                });
            }
        }
    ]);
    return WebsiteBlackGridComponent;
}((0, $9gCL8.Component));


var $1cab359ba21725a5$export$ab765ed4f8df7556 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackDivideComponent, Component);
    function WebsiteBlackDivideComponent(divide) {
        (0, $3CDbU._)(this, WebsiteBlackDivideComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackDivideComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($c3f41ac5a0bc4d68$export$b3ff231557e20c05, '">\n                <div class="').concat($c3f41ac5a0bc4d68$export$71ef6e19fae6c840, '">\n                    <div class="').concat($c3f41ac5a0bc4d68$export$f38c853ae54ed474, '">\n                        <div class="').concat($c3f41ac5a0bc4d68$export$2cc7ff91bcacba5e, '"></div>\n                        <div class="').concat($c3f41ac5a0bc4d68$export$1ca1ec8b29a4ce27, '"></div>\n                    </div>\n                    <div class="').concat($c3f41ac5a0bc4d68$export$6f093cfa640b7166, '">\n                        Que fait Sedestral AI ?\n                    </div>\n                </div>\n                <div class="').concat($c3f41ac5a0bc4d68$export$6d59db4903f20f7d, "\">\n                    Sedestral AI s'occupe d'analyser vos concurrents, de mener les recherches et d'effectuer toutes les\n                    t\xe2ches fastidieuses pour vous.\n                </div>\n                <div class=\"").concat($c3f41ac5a0bc4d68$export$53f1d5ea8de3d7c, '">\n                    <div class="').concat($c3f41ac5a0bc4d68$export$b8972b998723d602, '"></div>\n                    <div class="').concat($c3f41ac5a0bc4d68$export$a7db06668cad9adb, '"></div>\n                </div>\n                <div class="').concat($c3f41ac5a0bc4d68$export$324fbeb68ccbc72b, '">\n                    Les t\xe2ches se divisent en plusieurs \xe9tapes\n                </div>\n                <div>\n                    ').concat(_this.draw(new (0, $54fc49d8c8d59622$export$9cf1ff22c077cd0b)(divide.grid)), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteBlackDivideComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $233ac063b79549b3$export$7766bce351faa67c;
var $233ac063b79549b3$export$71ef6e19fae6c840;
var $233ac063b79549b3$export$f38c853ae54ed474;
var $233ac063b79549b3$export$2cc7ff91bcacba5e;
var $233ac063b79549b3$export$1ca1ec8b29a4ce27;
var $233ac063b79549b3$export$6f093cfa640b7166;
var $233ac063b79549b3$export$1f6c9cc012ebacae;
var $233ac063b79549b3$export$98e628dec113755e;
var $233ac063b79549b3$export$e13cce2a2d16a9d4;
var $233ac063b79549b3$export$2aa0182783e7e9de;
var $233ac063b79549b3$export$32744b5b3bba4764;
var $233ac063b79549b3$export$6d59db4903f20f7d;
var $233ac063b79549b3$export$53f1d5ea8de3d7c;
var $233ac063b79549b3$export$853d2c6a78e32826;
var $233ac063b79549b3$export$3e523c77c1f23f8c;
var $233ac063b79549b3$export$6c6e679936662ba2;
var $233ac063b79549b3$export$9ba38043771de2c2;
var $233ac063b79549b3$export$c407db72103fecfa;
var $233ac063b79549b3$export$fb184b623420d9be;
var $233ac063b79549b3$export$8fde8ebd684d5072;
var $233ac063b79549b3$export$92840075cfbc6612;
var $233ac063b79549b3$export$8fa4e5556fd77a60;
var $233ac063b79549b3$export$2ab9a8f9f1186f14;
var $233ac063b79549b3$export$d927737047eb3867;
$233ac063b79549b3$export$7766bce351faa67c = "_7pnq0";
$233ac063b79549b3$export$71ef6e19fae6c840 = "USf1h";
$233ac063b79549b3$export$f38c853ae54ed474 = "_0JAhl";
$233ac063b79549b3$export$2cc7ff91bcacba5e = "CaPpf";
$233ac063b79549b3$export$1ca1ec8b29a4ce27 = "OIF4j";
$233ac063b79549b3$export$6f093cfa640b7166 = "jK8xj";
$233ac063b79549b3$export$1f6c9cc012ebacae = "_0e7rD";
$233ac063b79549b3$export$98e628dec113755e = "jNxQi";
$233ac063b79549b3$export$e13cce2a2d16a9d4 = "EKOK2";
$233ac063b79549b3$export$2aa0182783e7e9de = "yzn1U";
$233ac063b79549b3$export$32744b5b3bba4764 = "h-h3d";
$233ac063b79549b3$export$6d59db4903f20f7d = "tApxT";
$233ac063b79549b3$export$53f1d5ea8de3d7c = "_339gc";
$233ac063b79549b3$export$853d2c6a78e32826 = "Wjq5j";
$233ac063b79549b3$export$3e523c77c1f23f8c = "PR59F";
$233ac063b79549b3$export$6c6e679936662ba2 = "GtLcl";
$233ac063b79549b3$export$9ba38043771de2c2 = "tfe0b";
$233ac063b79549b3$export$c407db72103fecfa = "Ss-uZ";
$233ac063b79549b3$export$fb184b623420d9be = "M1iSK";
$233ac063b79549b3$export$8fde8ebd684d5072 = "u-1-W";
$233ac063b79549b3$export$92840075cfbc6612 = "UXbZk";
$233ac063b79549b3$export$8fa4e5556fd77a60 = "OFjmr";
$233ac063b79549b3$export$2ab9a8f9f1186f14 = "EJoIw";
$233ac063b79549b3$export$d927737047eb3867 = "lHulI";



var $wYO7b = parcelRequire("wYO7b");
var $2f9b971fa7f82f09$export$7f8c4dbd337fa85b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackWordsComponent, Component);
    function WebsiteBlackWordsComponent() {
        (0, $3CDbU._)(this, WebsiteBlackWordsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackWordsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($233ac063b79549b3$export$7766bce351faa67c, '">\n                <div class="').concat($233ac063b79549b3$export$71ef6e19fae6c840, '">\n                    <div class="').concat($233ac063b79549b3$export$f38c853ae54ed474, '">\n                        <div class="').concat($233ac063b79549b3$export$2cc7ff91bcacba5e, '"></div>\n                        <div class="').concat($233ac063b79549b3$export$1ca1ec8b29a4ce27, '"></div>\n                    </div>\n                    <div class="').concat($233ac063b79549b3$export$6f093cfa640b7166, '">\n                        ').concat((0, $wYO7b.Resources).t("words.sedestralAiIntro"), '\n                    </div>\n                </div>\n                <div class="').concat($233ac063b79549b3$export$1f6c9cc012ebacae, '">\n                    <div class="').concat($233ac063b79549b3$export$98e628dec113755e, " ").concat($233ac063b79549b3$export$e13cce2a2d16a9d4, '">\n                        <div class="').concat($233ac063b79549b3$export$32744b5b3bba4764, '">\n                            <div class="').concat($233ac063b79549b3$export$2cc7ff91bcacba5e, '"></div>\n                            <div class="').concat($233ac063b79549b3$export$6f093cfa640b7166, '">\n                                50+\n                            </div>\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.metricsUsed"), '\n                        </div>\n                    </div>\n                    <div class="').concat($233ac063b79549b3$export$98e628dec113755e, " ").concat($233ac063b79549b3$export$2aa0182783e7e9de, '">\n                        <div class="').concat($233ac063b79549b3$export$32744b5b3bba4764, '">\n                            <div class="').concat($233ac063b79549b3$export$2cc7ff91bcacba5e, '"></div>\n                            <div class="').concat($233ac063b79549b3$export$6f093cfa640b7166, '">\n                                350 000\n                            </div>\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.wordsAnalyzed"), '\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$53f1d5ea8de3d7c, '"></div>\n                    </div>\n                </div>\n                <div class="').concat($233ac063b79549b3$export$853d2c6a78e32826, '">\n                    <div class="').concat($233ac063b79549b3$export$3e523c77c1f23f8c, '"></div>\n                    <div class="').concat($233ac063b79549b3$export$2cc7ff91bcacba5e, '"></div>\n                </div>\n                <div class="').concat($233ac063b79549b3$export$6c6e679936662ba2, '">\n                    ').concat((0, $wYO7b.Resources).t("words.sedestralAiExploration"), '\n                </div>\n                <div class="').concat($233ac063b79549b3$export$9ba38043771de2c2, '">\n                    <div class="').concat($233ac063b79549b3$export$c407db72103fecfa, '">\n                        <div class="').concat($233ac063b79549b3$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.sedestralAnalysis"), '\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$8fde8ebd684d5072, " ").concat($233ac063b79549b3$export$2aa0182783e7e9de, '">\n                            <div class="').concat($233ac063b79549b3$export$d927737047eb3867, '">\n                                <div style="width: 100%;" class="').concat($233ac063b79549b3$export$92840075cfbc6612, '"></div>\n                            </div>\n                            <div class="').concat($233ac063b79549b3$export$2ab9a8f9f1186f14, '">\n                                350K\n                            </div>\n                        </div>\n                    </div>\n                    <div class="').concat($233ac063b79549b3$export$c407db72103fecfa, '">\n                        <div class="').concat($233ac063b79549b3$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.firstFourHarryPotter"), '\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$8fde8ebd684d5072, " ").concat($233ac063b79549b3$export$8fa4e5556fd77a60, '">\n                            <div class="').concat($233ac063b79549b3$export$d927737047eb3867, '">\n                                <div style="width: 90%;" class="').concat($233ac063b79549b3$export$92840075cfbc6612, '"></div>\n                            </div>\n                            <div class="').concat($233ac063b79549b3$export$2ab9a8f9f1186f14, '">\n                                327K\n                            </div>\n                        </div>\n                    </div>\n                    <div class="').concat($233ac063b79549b3$export$c407db72103fecfa, '">\n                        <div class="').concat($233ac063b79549b3$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.nineStarWarsFilms"), '\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$8fde8ebd684d5072, " ").concat($233ac063b79549b3$export$8fa4e5556fd77a60, '">\n                            <div class="').concat($233ac063b79549b3$export$d927737047eb3867, '">\n                                <div style="width: 70%;" class="').concat($233ac063b79549b3$export$92840075cfbc6612, '"></div>\n                            </div>\n                            <div class="').concat($233ac063b79549b3$export$2ab9a8f9f1186f14, '">\n                                267K\n                            </div>\n                        </div>\n                    </div>\n                    <div class="').concat($233ac063b79549b3$export$c407db72103fecfa, '">\n                        <div class="').concat($233ac063b79549b3$export$fb184b623420d9be, '">\n                            ').concat((0, $wYO7b.Resources).t("words.lotrAndHobbit"), '\n                        </div>\n                        <div class="').concat($233ac063b79549b3$export$8fde8ebd684d5072, " ").concat($233ac063b79549b3$export$8fa4e5556fd77a60, '">\n                            <div class="').concat($233ac063b79549b3$export$d927737047eb3867, '">\n                                <div style="width: 50%;" class="').concat($233ac063b79549b3$export$92840075cfbc6612, '"></div>\n                            </div>\n                            <div class="').concat($233ac063b79549b3$export$2ab9a8f9f1186f14, '">\n                                192K\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackWordsComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.els($233ac063b79549b3$export$92840075cfbc6612).forEach(function(progressionComponent) {
                    var width = parseInt(progressionComponent.getHTMLElement().style.width);
                    _this.el($233ac063b79549b3$export$9ba38043771de2c2).isBelowScroll(function(isVisible) {
                        if (isVisible) progressionComponent.translate({
                            widthPercent: width,
                            delay: 600
                        });
                        else progressionComponent.translate({
                            widthPercent: 0,
                            delay: 600
                        });
                    }, true);
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackWordsComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteBlackWordsComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $5656a92efeab444e$export$ba553c79a28cb56e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogWritingComponent, Component);
    function WebsiteContentBlogWritingComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogWritingComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogWritingComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            title: (0, $wYO7b.Resources).t("words.sedestralTrafficGeneration"),
            description: (0, $wYO7b.Resources).t("words.sedestralContentGenerationDescription"),
            people: false,
            center: true
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $529cecc0c9ce0c3a$export$67fc1824eabdc07e)({
            text: (0, $wYO7b.Resources).t("words.fiveMinuteArticle"),
            size: "sizeBig"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $1cab359ba21725a5$export$ab765ed4f8df7556)({
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                step: 1,
                                title: (0, $wYO7b.Resources).t("words.googleResearch"),
                                description: (0, $wYO7b.Resources).t("words.googleResearchDescription"),
                                type: "icon",
                                icon: "google",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            },
                            {
                                step: 2,
                                title: (0, $wYO7b.Resources).t("words.detailedSiteAnalysis"),
                                description: (0, $wYO7b.Resources).t("words.detailedSiteAnalysisDescription"),
                                type: "icon",
                                icon: "chart",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 3,
                                title: (0, $wYO7b.Resources).t("words.createPlanProvideGuidelines"),
                                description: (0, $wYO7b.Resources).t("words.createPlanProvideGuidelinesDescription"),
                                type: "icon",
                                icon: "plan",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                step: 4,
                                title: (0, $wYO7b.Resources).t("words.generateContentFromMetrics"),
                                description: (0, $wYO7b.Resources).t("words.generateContentFromMetricsDescription"),
                                type: "icon",
                                icon: "write",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 5,
                                title: (0, $wYO7b.Resources).t("words.applySeoPractices"),
                                description: (0, $wYO7b.Resources).t("words.applySeoPracticesDescription"),
                                type: "icon",
                                icon: "seo",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                step: 6,
                                title: (0, $wYO7b.Resources).t("words.searchSuitableImages"),
                                description: (0, $wYO7b.Resources).t("words.searchSuitableImagesDescription"),
                                type: "icon",
                                icon: "picture",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 7,
                                title: (0, $wYO7b.Resources).t("words.enhanceAuthenticity"),
                                description: (0, $wYO7b.Resources).t("words.enhanceAuthenticityDescription"),
                                type: "icon",
                                icon: "unique",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            },
                            {
                                step: 8,
                                title: (0, $wYO7b.Resources).t("words.readyContentIntent"),
                                description: (0, $wYO7b.Resources).t("words.readyContentIntentDescription"),
                                type: "icon",
                                icon: "ready",
                                size: "sizeMid",
                                color: "colorYellow",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.nativeIntegration"),
                                description: (0, $wYO7b.Resources).t("words.nativeIntegrationDescription"),
                                type: "icon",
                                icon: "funnel",
                                size: "sizeLargeCenter",
                                color: "colorPurple",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2f9b971fa7f82f09$export$7f8c4dbd337fa85b)()), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentBlogWritingComponent;
}((0, $9gCL8.Component));


var $5af9bae3614e2ddb$export$aa5b5f3c49dad377 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogWritingPage, WebsitePageComponent);
    function WebsiteBlogWritingPage() {
        (0, $3CDbU._)(this, WebsiteBlogWritingPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogWritingPage);
        _this.updateMetas("ai");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogWritingPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $5656a92efeab444e$export$ba553c79a28cb56e)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogWritingPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");




var $wYO7b = parcelRequire("wYO7b");





var $d0e4140821be6b81$export$18552b4bb0fbada3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogAutopilotComponent, Component);
    function WebsiteContentBlogAutopilotComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogAutopilotComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogAutopilotComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            title: (0, $wYO7b.Resources).t("words.automateBlogManagement"),
            description: (0, $wYO7b.Resources).t("words.aiHandlesEverything"),
            people: false,
            center: true
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.autopilotConfiguration"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.autopilot"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-video-c.mp4"),
                    duration: 7000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $63f6c7e7bfe0384f$export$d8eb6fbe0ee5dec2)({
            title: (0, $wYO7b.Resources).t("words.howItWorks"),
            columns: [
                {
                    icon: "articleAi",
                    name: (0, $wYO7b.Resources).t("words.intelligentCreation"),
                    text: (0, $wYO7b.Resources).t("words.aiThinksAndWrites")
                },
                {
                    icon: "letter",
                    name: (0, $wYO7b.Resources).t("words.personalizedDelivery"),
                    text: (0, $wYO7b.Resources).t("words.chooseDelivery")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $22bbd5ff065cc08a$export$1965e7302a1f5007)({
            title: (0, $wYO7b.Resources).t("words.whyUseAutopilot"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-time",
                    title: (0, $wYO7b.Resources).t("words.savePreciousTime"),
                    subtitle: (0, $wYO7b.Resources).t("words.aiHandlesResearchAndWriting")
                },
                {
                    icon: "black-chart",
                    title: (0, $wYO7b.Resources).t("words.boostVisibility"),
                    subtitle: (0, $wYO7b.Resources).t("words.maximizeSEOPositioning")
                },
                {
                    icon: "black-lineal-good",
                    title: (0, $wYO7b.Resources).t("words.ensureConstantPublication"),
                    subtitle: (0, $wYO7b.Resources).t("words.freshContentAlignedWithTrends")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        <div class="').concat($e90ba9dd4a4f2e91$export$2217aca24454a969, '">\n                        <div class="').concat($e90ba9dd4a4f2e91$export$f7c42a96c638d4dc, '">\n                            <div class="').concat($e90ba9dd4a4f2e91$export$79ffe56a765070d2, '">\n                                <img class="').concat($e90ba9dd4a4f2e91$export$5c452ff88e35e47d, '" src="').concat((0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.webp"), '"\n                                     alt="styleCloning" draggable="false"\n                                     width="380" height="347.51"\n                                />\n                            </div>\n                            <div class="').concat($e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4, '">\n                                <h2 class="').concat($e90ba9dd4a4f2e91$export$fb184b623420d9be, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleTitle"), '\n                                </h2>\n                                <p class="').concat($e90ba9dd4a4f2e91$export$c96745152eb2740f, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleText"), '\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.howAiGeneratesIdeas"),
                    response: (0, $wYO7b.Resources).t("words.aiAnalyzesIndustry")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.areContentsSEOOptimized"),
                    response: (0, $wYO7b.Resources).t("words.articlesSEOOptimized")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.canChooseArticleFrequency"),
                    response: (0, $wYO7b.Resources).t("words.controlArticleFrequency")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.howArecContentsDelivered"),
                    response: (0, $wYO7b.Resources).t("words.chooseArticleDelivery")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.canModifyContentsBeforePublication"),
                    response: (0, $wYO7b.Resources).t("words.reviseAndPersonalizeArticles")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.canAiAdaptToDifferentContentTypes"),
                    response: (0, $wYO7b.Resources).t("words.aiAdaptsToVariousContentTypes")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.howAiUnderstandsBusiness"),
                    response: (0, $wYO7b.Resources).t("words.provideInfoForAiToAdapt")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.doesAiMaintainBrandTone"),
                    response: (0, $wYO7b.Resources).t("words.aiMaintainsBrandTone")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.whoCanUseAutopilot"),
                    response: (0, $wYO7b.Resources).t("words.autopilotForAllBusinesses")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.canModifyOrStopServiceAnytime"),
                    response: (0, $wYO7b.Resources).t("words.freedomToModifyOrStopService")
                }
            ]
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentBlogAutopilotComponent;
}((0, $9gCL8.Component));


var $60a54bb947739012$export$c87593f158eae05c = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogAutopilotPage, WebsitePageComponent);
    function WebsiteBlogAutopilotPage() {
        (0, $3CDbU._)(this, WebsiteBlogAutopilotPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogAutopilotPage);
        _this.updateMetas("autopilot");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogAutopilotPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $d0e4140821be6b81$export$18552b4bb0fbada3)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogAutopilotPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $wYO7b = parcelRequire("wYO7b");

var $9gCL8 = parcelRequire("9gCL8");






var $844bc4c3e86415b3$export$402470387581fde2 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogStyleComponent, Component);
    function WebsiteContentBlogStyleComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogStyleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogStyleComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.writingStyleReplication"),
            description: (0, $wYO7b.Resources).t("words.styleCloningFeatureDescription"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h.webp"),
            color: "white",
            size: "tall",
            border: "border",
            shadow: "shadow"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $63f6c7e7bfe0384f$export$d8eb6fbe0ee5dec2)({
            title: (0, $wYO7b.Resources).t("words.whyAdoptStyleCloning"),
            columns: [
                {
                    icon: "handshake",
                    name: (0, $wYO7b.Resources).t("words.brandConsistency"),
                    text: (0, $wYO7b.Resources).t("words.brandConsistencyDescription")
                },
                {
                    icon: "seo",
                    name: (0, $wYO7b.Resources).t("words.seoOptimization"),
                    text: (0, $wYO7b.Resources).t("words.seoOptimizationDescription")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.howDoesStyleCloningWork"),
                    response: (0, $wYO7b.Resources).t("words.styleCloningWorkDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.styleCloningAccuracy"),
                    response: (0, $wYO7b.Resources).t("words.styleCloningAccuracyDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.canEditGeneratedArticles"),
                    response: (0, $wYO7b.Resources).t("words.canEditGeneratedArticlesDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.adaptableToDifferentContentTypes"),
                    response: (0, $wYO7b.Resources).t("words.adaptableToDifferentContentTypesDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.seoOptimizedArticles"),
                    response: (0, $wYO7b.Resources).t("words.seoOptimizedArticlesDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.styleCloningTime"),
                    response: (0, $wYO7b.Resources).t("words.styleCloningTimeDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.changeWritingStyle"),
                    response: (0, $wYO7b.Resources).t("words.changeWritingStyleDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.adaptableToAllIndustries"),
                    response: (0, $wYO7b.Resources).t("words.adaptableToAllIndustriesDescription")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.multipleAuthors"),
                    response: (0, $wYO7b.Resources).t("words.multipleAuthorsDescription")
                }
            ]
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentBlogStyleComponent;
}((0, $9gCL8.Component));


var $aa8e4074a3128741$export$441a0cd60fee079c = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogStylePage, WebsitePageComponent);
    function WebsiteBlogStylePage() {
        (0, $3CDbU._)(this, WebsiteBlogStylePage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogStylePage);
        _this.updateMetas("writingStyle");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogStylePage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $844bc4c3e86415b3$export$402470387581fde2)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogStylePage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");





var $wYO7b = parcelRequire("wYO7b");






var $83d7ac709bd23064$export$1739ae649e596444 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogWixComponent, Component);
    function WebsiteContentBlogWixComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogWixComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogWixComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            center: true,
            title: (0, $wYO7b.Resources).t("words.wixSeoModuleTitle"),
            description: (0, $wYO7b.Resources).t("words.wixSeoModuleDescription"),
            partnerIcon: "wix",
            secondButton: false,
            firstButtonLink: "https://sedestral.com/connect-wix"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $22bbd5ff065cc08a$export$1965e7302a1f5007)({
            title: (0, $wYO7b.Resources).t("words.searchEngineContent"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-read",
                    title: (0, $wYO7b.Resources).t("words.fleschReadingEase"),
                    subtitle: (0, $wYO7b.Resources).t("words.fleschReadingEaseSubtitle")
                },
                {
                    icon: "black-lineal-keywords",
                    title: (0, $wYO7b.Resources).t("words.keywords"),
                    subtitle: (0, $wYO7b.Resources).t("words.keywordsSubtitle")
                },
                {
                    icon: "black-lineal-words",
                    title: (0, $wYO7b.Resources).t("words.transitionWords"),
                    subtitle: (0, $wYO7b.Resources).t("words.transitionWordsSubtitle")
                },
                {
                    icon: "black-lineal-code",
                    title: (0, $wYO7b.Resources).t("words.htmlTagging"),
                    subtitle: (0, $wYO7b.Resources).t("words.htmlTaggingSubtitle")
                },
                {
                    icon: "black-lineal-voice",
                    title: (0, $wYO7b.Resources).t("words.passiveVoice"),
                    subtitle: (0, $wYO7b.Resources).t("words.passiveVoiceSubtitle")
                },
                {
                    icon: "black-lineal-seo",
                    title: (0, $wYO7b.Resources).t("words.seoTools"),
                    subtitle: (0, $wYO7b.Resources).t("words.seoToolsSubtitle")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($e90ba9dd4a4f2e91$export$2217aca24454a969, '">\n                        <div class="').concat($e90ba9dd4a4f2e91$export$f7c42a96c638d4dc, '">\n                            <div class="').concat($e90ba9dd4a4f2e91$export$79ffe56a765070d2, '">\n                                <img class="').concat($e90ba9dd4a4f2e91$export$5c452ff88e35e47d, '" src="').concat((0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.webp"), '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.styleCloning"), '" draggable="false"\n                                     width="380" height="347.51"\n                                />\n                            </div>\n                            <div class="').concat($e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4, '">\n                                <h2 class="').concat($e90ba9dd4a4f2e91$export$fb184b623420d9be, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleTitle"), '\n                                </h2>\n                                <p class="').concat($e90ba9dd4a4f2e91$export$c96745152eb2740f, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleText"), '\n                                </p>\n                                <img class="').concat($e90ba9dd4a4f2e91$export$53f1d5ea8de3d7c, '" src="').concat((0, $3e10e981c2995cb0$export$a27e371a094e4e50).illus("separator-line.svg"), '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.separationLine"), '" draggable="false"/>\n                            </div>\n                        </div>\n                        <div class="').concat($e90ba9dd4a4f2e91$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.explainContextToAI"),
            description: (0, $wYO7b.Resources).t("words.contextFeatureText"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.webp"),
            color: "black",
            size: "medium",
            border: "border"
        })), '\n                        </div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $11905550a94e3587$export$21cf7e1029971b9d)((0, $wYO7b.Resources).t("words.howItWorks"), [
            {
                icon: "draft",
                title: (0, $wYO7b.Resources).t("words.instructionsTitle"),
                desc: (0, $wYO7b.Resources).t("words.instructionsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $wYO7b.Resources).t("words.proposalsTitle"),
                desc: (0, $wYO7b.Resources).t("words.proposalsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $wYO7b.Resources).t("words.planTitle"),
                desc: (0, $wYO7b.Resources).t("words.planDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $wYO7b.Resources).t("words.writingTitle"),
                desc: (0, $wYO7b.Resources).t("words.writingDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ])), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.doesGooglePenalizeAiContent"),
                    response: (0, $wYO7b.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.seoOptimizationQuestion"),
                    response: (0, $wYO7b.Resources).t("words.seoOptimizationResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.platformConnectionQuestion"),
                    response: (0, $wYO7b.Resources).t("words.platformConnectionResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.articleFormattingQuestion"),
                    response: (0, $wYO7b.Resources).t("words.articleFormattingResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.smartBlogAdvantagesQuestion"),
                    response: (0, $wYO7b.Resources).t("words.smartBlogAdvantagesResponse")
                }
            ]
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogWixComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogWixComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogWixComponent;
}((0, $9gCL8.Component));


var $cb2d6793f7eecd1a$export$a58278a45a3d1e00 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogWixPage, WebsitePageComponent);
    function WebsiteBlogWixPage() {
        (0, $3CDbU._)(this, WebsiteBlogWixPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogWixPage);
        _this.updateMetas("wix");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogWixPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $83d7ac709bd23064$export$1739ae649e596444)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogWixPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");




var $wYO7b = parcelRequire("wYO7b");







var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $6e0b847710b787d5$exports = {};

$parcel$export($6e0b847710b787d5$exports, "componentWebsiteBlackFlow", function () { return $6e0b847710b787d5$export$bd457616a7188bb8; }, function (v) { return $6e0b847710b787d5$export$bd457616a7188bb8 = v; });
$parcel$export($6e0b847710b787d5$exports, "title", function () { return $6e0b847710b787d5$export$fb184b623420d9be; }, function (v) { return $6e0b847710b787d5$export$fb184b623420d9be = v; });
$parcel$export($6e0b847710b787d5$exports, "bigTitle", function () { return $6e0b847710b787d5$export$b2b3286365e789d9; }, function (v) { return $6e0b847710b787d5$export$b2b3286365e789d9 = v; });
$parcel$export($6e0b847710b787d5$exports, "contents", function () { return $6e0b847710b787d5$export$fd59df041b888442; }, function (v) { return $6e0b847710b787d5$export$fd59df041b888442 = v; });
$parcel$export($6e0b847710b787d5$exports, "imageContainer", function () { return $6e0b847710b787d5$export$63e82393dc8977bf; }, function (v) { return $6e0b847710b787d5$export$63e82393dc8977bf = v; });
$parcel$export($6e0b847710b787d5$exports, "image", function () { return $6e0b847710b787d5$export$5c452ff88e35e47d; }, function (v) { return $6e0b847710b787d5$export$5c452ff88e35e47d = v; });
$parcel$export($6e0b847710b787d5$exports, "imgShadow", function () { return $6e0b847710b787d5$export$7d74a5d084cc5a23; }, function (v) { return $6e0b847710b787d5$export$7d74a5d084cc5a23 = v; });
$parcel$export($6e0b847710b787d5$exports, "texts", function () { return $6e0b847710b787d5$export$29f9f81de5c56283; }, function (v) { return $6e0b847710b787d5$export$29f9f81de5c56283 = v; });
$parcel$export($6e0b847710b787d5$exports, "textCollapse", function () { return $6e0b847710b787d5$export$d88b746f6a4665c4; }, function (v) { return $6e0b847710b787d5$export$d88b746f6a4665c4 = v; });
$parcel$export($6e0b847710b787d5$exports, "entry", function () { return $6e0b847710b787d5$export$c407db72103fecfa; }, function (v) { return $6e0b847710b787d5$export$c407db72103fecfa = v; });
$parcel$export($6e0b847710b787d5$exports, "canCollapse", function () { return $6e0b847710b787d5$export$6cefeda42b08f11c; }, function (v) { return $6e0b847710b787d5$export$6cefeda42b08f11c = v; });
$parcel$export($6e0b847710b787d5$exports, "name", function () { return $6e0b847710b787d5$export$a8ff84c12d48cfa6; }, function (v) { return $6e0b847710b787d5$export$a8ff84c12d48cfa6 = v; });
$parcel$export($6e0b847710b787d5$exports, "arrow", function () { return $6e0b847710b787d5$export$f2120bbfa5450bd2; }, function (v) { return $6e0b847710b787d5$export$f2120bbfa5450bd2 = v; });
$parcel$export($6e0b847710b787d5$exports, "collapsed", function () { return $6e0b847710b787d5$export$27c57cc52d388509; }, function (v) { return $6e0b847710b787d5$export$27c57cc52d388509 = v; });
$parcel$export($6e0b847710b787d5$exports, "description", function () { return $6e0b847710b787d5$export$6d59db4903f20f7d; }, function (v) { return $6e0b847710b787d5$export$6d59db4903f20f7d = v; });
$parcel$export($6e0b847710b787d5$exports, "nameContainer", function () { return $6e0b847710b787d5$export$3b9d909fcd39d8ae; }, function (v) { return $6e0b847710b787d5$export$3b9d909fcd39d8ae = v; });
$parcel$export($6e0b847710b787d5$exports, "icon", function () { return $6e0b847710b787d5$export$1ca1ec8b29a4ce27; }, function (v) { return $6e0b847710b787d5$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($6e0b847710b787d5$exports, "aiWrite", function () { return $6e0b847710b787d5$export$c79b3a2d88454829; }, function (v) { return $6e0b847710b787d5$export$c79b3a2d88454829 = v; });
$parcel$export($6e0b847710b787d5$exports, "aiStars", function () { return $6e0b847710b787d5$export$12258f938f4857fd; }, function (v) { return $6e0b847710b787d5$export$12258f938f4857fd = v; });
$parcel$export($6e0b847710b787d5$exports, "colorPurple", function () { return $6e0b847710b787d5$export$e2ab8c1ee254ce8f; }, function (v) { return $6e0b847710b787d5$export$e2ab8c1ee254ce8f = v; });
var $6e0b847710b787d5$export$bd457616a7188bb8;
var $6e0b847710b787d5$export$fb184b623420d9be;
var $6e0b847710b787d5$export$b2b3286365e789d9;
var $6e0b847710b787d5$export$fd59df041b888442;
var $6e0b847710b787d5$export$63e82393dc8977bf;
var $6e0b847710b787d5$export$5c452ff88e35e47d;
var $6e0b847710b787d5$export$7d74a5d084cc5a23;
var $6e0b847710b787d5$export$29f9f81de5c56283;
var $6e0b847710b787d5$export$d88b746f6a4665c4;
var $6e0b847710b787d5$export$c407db72103fecfa;
var $6e0b847710b787d5$export$6cefeda42b08f11c;
var $6e0b847710b787d5$export$a8ff84c12d48cfa6;
var $6e0b847710b787d5$export$f2120bbfa5450bd2;
var $6e0b847710b787d5$export$27c57cc52d388509;
var $6e0b847710b787d5$export$6d59db4903f20f7d;
var $6e0b847710b787d5$export$3b9d909fcd39d8ae;
var $6e0b847710b787d5$export$1ca1ec8b29a4ce27;
var $6e0b847710b787d5$export$c79b3a2d88454829;
var $6e0b847710b787d5$export$12258f938f4857fd;
var $6e0b847710b787d5$export$e2ab8c1ee254ce8f;
$6e0b847710b787d5$export$bd457616a7188bb8 = "_75Y8q";
$6e0b847710b787d5$export$fb184b623420d9be = "_8Pp7V";
$6e0b847710b787d5$export$b2b3286365e789d9 = "ONbEQ";
$6e0b847710b787d5$export$fd59df041b888442 = "Pj9Wo";
$6e0b847710b787d5$export$63e82393dc8977bf = "RV-V3";
$6e0b847710b787d5$export$5c452ff88e35e47d = "IiyNK";
$6e0b847710b787d5$export$7d74a5d084cc5a23 = "OLoHn";
$6e0b847710b787d5$export$29f9f81de5c56283 = "_5Rxs4";
$6e0b847710b787d5$export$d88b746f6a4665c4 = "hbHMv";
$6e0b847710b787d5$export$c407db72103fecfa = "mj-Wj";
$6e0b847710b787d5$export$6cefeda42b08f11c = "VRqmf";
$6e0b847710b787d5$export$a8ff84c12d48cfa6 = "_-2n00";
$6e0b847710b787d5$export$f2120bbfa5450bd2 = "N9jiU";
$6e0b847710b787d5$export$27c57cc52d388509 = "ovOfg";
$6e0b847710b787d5$export$6d59db4903f20f7d = "-K7MZ";
$6e0b847710b787d5$export$3b9d909fcd39d8ae = "qhSaF";
$6e0b847710b787d5$export$1ca1ec8b29a4ce27 = "-NYLb";
$6e0b847710b787d5$export$c79b3a2d88454829 = "R8Qym";
$6e0b847710b787d5$export$12258f938f4857fd = "_0MS0V";
$6e0b847710b787d5$export$e2ab8c1ee254ce8f = "MnNf1";



var $abV4P = parcelRequire("abV4P");
var $6a9745de553f4d89$export$27a48b752485acc3 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackFlowComponent, Component);
    function WebsiteBlackFlowComponent(flow) {
        (0, $3CDbU._)(this, WebsiteBlackFlowComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackFlowComponent);
        _this.flow = flow;
        _this.entriesComponents = [];
        //language=HTML
        _this.template = '\n            <div class="'.concat($6e0b847710b787d5$exports.componentWebsiteBlackFlow, '">\n                <div class="').concat($6e0b847710b787d5$exports.title, '">\n                    ').concat(flow.title, '\n                </div>\n                <div class="').concat($6e0b847710b787d5$exports.bigTitle, '">\n                    ').concat(flow.bigTitle, '\n                </div>\n                <div class="').concat($6e0b847710b787d5$exports.contents, '">\n                    <div class="').concat($6e0b847710b787d5$exports.imageContainer, '">\n                        <div class="').concat($6e0b847710b787d5$exports.imgShadow, '"></div>\n                        <img class="').concat($6e0b847710b787d5$exports.image, '" src="').concat(flow.image, '" alt="slide"/>\n                    </div>\n                    <div class="').concat($6e0b847710b787d5$exports.texts, " ").concat(_this.flow.texts.canCollapse ? $6e0b847710b787d5$exports.textCollapse : "", '"></div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackFlowComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.textsContainer = this.el($6e0b847710b787d5$exports.texts);
                this.imageContainer = this.el($6e0b847710b787d5$exports.imageContainer);
                this.image = this.el($6e0b847710b787d5$exports.image);
                this.flow.texts.entries.forEach(function(entry) {
                    return _this.renderEntry(entry);
                });
                if (this.flow.texts.canCollapse) this.entriesComponents[0].removeClass($6e0b847710b787d5$exports.collapsed);
                if (!(0, $abV4P.isMobile)()) this.image.getHTMLElement().onload = function() {
                    var imageWidth = _this.image.getWidth();
                    _this.imageContainer.isBelowScroll(function(isVisible) {
                        if (isVisible) {
                            _this.imageContainer.translate({
                                translateX: 0,
                                delay: 750
                            });
                            _this.timeOut(function() {
                                return _this.textsContainer.translate({
                                    opacity: 1,
                                    delay: 1000
                                });
                            }, 300);
                        } else {
                            _this.imageContainer.translate({
                                translateX: imageWidth / 2,
                                delay: 1000
                            });
                            _this.textsContainer.translate({
                                opacity: 0,
                                delay: 1000
                            });
                        }
                    }, true);
                };
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackFlowComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderEntry",
            value: function renderEntry(entry) {
                var _this = this;
                //language=HTML
                var entryComponent = this.textsContainer.append('\n            <div class="'.concat($6e0b847710b787d5$exports.entry, " ").concat(this.flow.texts.canCollapse ? $6e0b847710b787d5$exports.canCollapse : "", '">\n                <div class="').concat($6e0b847710b787d5$exports.nameContainer, '">\n                    <div class="').concat($6e0b847710b787d5$exports.name, '">\n                        <div class="').concat($6e0b847710b787d5$exports.icon, " ").concat($6e0b847710b787d5$exports[entry.icon], " ").concat($6e0b847710b787d5$exports[entry.iconColor], '"></div>\n                        ').concat(entry.title, '\n                    </div>\n                    <div class="').concat($6e0b847710b787d5$exports.arrow, '"></div>\n                </div>\n                <div class="').concat($6e0b847710b787d5$exports.description, '">\n                    ').concat(entry.description, "\n                </div>\n            </div>\n        "));
                this.entriesComponents.push(entryComponent);
                if (this.flow.texts.canCollapse) {
                    entryComponent.addClass($6e0b847710b787d5$exports.collapsed);
                    entryComponent.onClick(function() {
                        _this.entriesComponents.forEach(function(value) {
                            return value.addClass($6e0b847710b787d5$exports.collapsed);
                        });
                        entryComponent.removeClass($6e0b847710b787d5$exports.collapsed);
                    });
                }
            }
        }
    ]);
    return WebsiteBlackFlowComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $add4ce80ffa57941$export$a47911b81bc97c6f;
var $add4ce80ffa57941$export$fb184b623420d9be;
var $add4ce80ffa57941$export$6d59db4903f20f7d;
var $add4ce80ffa57941$export$b8972b998723d602;
var $add4ce80ffa57941$export$a7db06668cad9adb;
var $add4ce80ffa57941$export$85fc379452d91af0;
$add4ce80ffa57941$export$a47911b81bc97c6f = "WQMTb";
$add4ce80ffa57941$export$fb184b623420d9be = "YX2FI";
$add4ce80ffa57941$export$6d59db4903f20f7d = "ttH3u";
$add4ce80ffa57941$export$b8972b998723d602 = "CNm8g";
$add4ce80ffa57941$export$a7db06668cad9adb = "VnLNW";
$add4ce80ffa57941$export$85fc379452d91af0 = "MET-I";



var $91b2ad7d68885d02$export$e95aadd4cd13f6de = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackPlatformComponent, Component);
    function WebsiteBlackPlatformComponent(platform) {
        (0, $3CDbU._)(this, WebsiteBlackPlatformComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackPlatformComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($add4ce80ffa57941$export$a47911b81bc97c6f, '">\n                <div class="').concat($add4ce80ffa57941$export$fb184b623420d9be, '">\n                    ').concat(platform.title, '\n                </div>\n                <div class="').concat($add4ce80ffa57941$export$6d59db4903f20f7d, '">\n                    <div class="').concat($add4ce80ffa57941$export$b8972b998723d602, '"></div>\n                    <div class="').concat($add4ce80ffa57941$export$a7db06668cad9adb, '">\n                        ').concat(platform.description, '\n                    </div>\n                </div>\n                <div class="').concat($add4ce80ffa57941$export$85fc379452d91af0, '">\n                    ').concat(_this.draw(new (0, $54fc49d8c8d59622$export$9cf1ff22c077cd0b)(platform.grid)), "\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteBlackPlatformComponent;
}((0, $9gCL8.Component));



var $dd2f578fb103f832$export$ba30467c9e89462a = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogShopifyComponent, Component);
    function WebsiteContentBlogShopifyComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogShopifyComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogShopifyComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            center: true,
            title: (0, $wYO7b.Resources).t("words.shopifyModuleTitle"),
            description: (0, $wYO7b.Resources).t("words.shopifyModuleDescription"),
            partnerIcon: "shopify",
            secondButton: false
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2ad9de2cc8e904c9$export$e9f2082bf3648ed6)((0, $wYO7b.Resources).t("words.whatShopifyClientsSay"), (0, $3e10e981c2995cb0$export$a27e371a094e4e50).reviews())), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $22bbd5ff065cc08a$export$1965e7302a1f5007)({
            title: (0, $wYO7b.Resources).t("words.searchEngineContent"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-read",
                    title: (0, $wYO7b.Resources).t("words.fleschReadingEase"),
                    subtitle: (0, $wYO7b.Resources).t("words.fleschReadingEaseSubtitle")
                },
                {
                    icon: "black-lineal-keywords",
                    title: (0, $wYO7b.Resources).t("words.keywords"),
                    subtitle: (0, $wYO7b.Resources).t("words.keywordsSubtitle")
                },
                {
                    icon: "black-lineal-words",
                    title: (0, $wYO7b.Resources).t("words.transitionWords"),
                    subtitle: (0, $wYO7b.Resources).t("words.transitionWordsSubtitle")
                },
                {
                    icon: "black-lineal-code",
                    title: (0, $wYO7b.Resources).t("words.htmlTagging"),
                    subtitle: (0, $wYO7b.Resources).t("words.htmlTaggingSubtitle")
                },
                {
                    icon: "black-lineal-voice",
                    title: (0, $wYO7b.Resources).t("words.passiveVoice"),
                    subtitle: (0, $wYO7b.Resources).t("words.passiveVoiceSubtitle")
                },
                {
                    icon: "black-lineal-seo",
                    title: (0, $wYO7b.Resources).t("words.seoTools"),
                    subtitle: (0, $wYO7b.Resources).t("words.seoToolsSubtitle")
                }
            ]
        })), '\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $6a9745de553f4d89$export$27a48b752485acc3)({
            title: (0, $wYO7b.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $wYO7b.Resources).t("words.shopifySeoApp"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $wYO7b.Resources).t("words.optimizeExistingSeoShopify"),
                        description: (0, $wYO7b.Resources).t("words.optimizeExistingSeoDescriptionShopify"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.createEngagingContent"),
                        description: (0, $wYO7b.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.competitorAnalysis"),
                        description: (0, $wYO7b.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.autopilot"),
                        description: (0, $wYO7b.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        })), '\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $91b2ad7d68885d02$export$e95aadd4cd13f6de)({
            title: (0, $wYO7b.Resources).t("words.ourPlatform"),
            description: (0, $wYO7b.Resources).t("words.shopifySeoModuleDescription"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.automaticPilot"),
                                description: (0, $wYO7b.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.workInAnyLanguage"),
                                description: (0, $wYO7b.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.doesGooglePenalizeAiContent"),
                    response: (0, $wYO7b.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.seoOptimizationQuestion"),
                    response: (0, $wYO7b.Resources).t("words.seoOptimizationResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.importContentQuestion"),
                    response: (0, $wYO7b.Resources).t("words.importContentResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.contentCustomizationQuestion"),
                    response: (0, $wYO7b.Resources).t("words.contentCustomizationResponse")
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2f9b971fa7f82f09$export$7f8c4dbd337fa85b)()), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogShopifyComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogShopifyComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogShopifyComponent;
}((0, $9gCL8.Component));


var $ab4480f67852b6be$export$cb59a6d6d90ba48b = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogShopifyPage, WebsitePageComponent);
    function WebsiteBlogShopifyPage() {
        (0, $3CDbU._)(this, WebsiteBlogShopifyPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogShopifyPage);
        _this.updateMetas("shopify");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogShopifyPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $dd2f578fb103f832$export$ba30467c9e89462a)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogShopifyPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");










var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $deb3f7a940e3dbee$exports = {};

$parcel$export($deb3f7a940e3dbee$exports, "componentWebsiteBlackCases", function () { return $deb3f7a940e3dbee$export$806ec8ebcc7680ea; }, function (v) { return $deb3f7a940e3dbee$export$806ec8ebcc7680ea = v; });
$parcel$export($deb3f7a940e3dbee$exports, "title", function () { return $deb3f7a940e3dbee$export$fb184b623420d9be; }, function (v) { return $deb3f7a940e3dbee$export$fb184b623420d9be = v; });
$parcel$export($deb3f7a940e3dbee$exports, "cases", function () { return $deb3f7a940e3dbee$export$3931a0da49df8dc0; }, function (v) { return $deb3f7a940e3dbee$export$3931a0da49df8dc0 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "case", function () { return $deb3f7a940e3dbee$export$e850e66917a23e0f; }, function (v) { return $deb3f7a940e3dbee$export$e850e66917a23e0f = v; });
$parcel$export($deb3f7a940e3dbee$exports, "name", function () { return $deb3f7a940e3dbee$export$a8ff84c12d48cfa6; }, function (v) { return $deb3f7a940e3dbee$export$a8ff84c12d48cfa6 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "description", function () { return $deb3f7a940e3dbee$export$6d59db4903f20f7d; }, function (v) { return $deb3f7a940e3dbee$export$6d59db4903f20f7d = v; });
$parcel$export($deb3f7a940e3dbee$exports, "iconContainer", function () { return $deb3f7a940e3dbee$export$acf4eaf431084f78; }, function (v) { return $deb3f7a940e3dbee$export$acf4eaf431084f78 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "icon", function () { return $deb3f7a940e3dbee$export$1ca1ec8b29a4ce27; }, function (v) { return $deb3f7a940e3dbee$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "page", function () { return $deb3f7a940e3dbee$export$523fb3936f49e028; }, function (v) { return $deb3f7a940e3dbee$export$523fb3936f49e028 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "target", function () { return $deb3f7a940e3dbee$export$44271b4f0c6a3563; }, function (v) { return $deb3f7a940e3dbee$export$44271b4f0c6a3563 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "box", function () { return $deb3f7a940e3dbee$export$827f4ee28efc37; }, function (v) { return $deb3f7a940e3dbee$export$827f4ee28efc37 = v; });
$parcel$export($deb3f7a940e3dbee$exports, "shadow", function () { return $deb3f7a940e3dbee$export$b8972b998723d602; }, function (v) { return $deb3f7a940e3dbee$export$b8972b998723d602 = v; });
var $deb3f7a940e3dbee$export$806ec8ebcc7680ea;
var $deb3f7a940e3dbee$export$fb184b623420d9be;
var $deb3f7a940e3dbee$export$3931a0da49df8dc0;
var $deb3f7a940e3dbee$export$e850e66917a23e0f;
var $deb3f7a940e3dbee$export$a8ff84c12d48cfa6;
var $deb3f7a940e3dbee$export$6d59db4903f20f7d;
var $deb3f7a940e3dbee$export$acf4eaf431084f78;
var $deb3f7a940e3dbee$export$1ca1ec8b29a4ce27;
var $deb3f7a940e3dbee$export$523fb3936f49e028;
var $deb3f7a940e3dbee$export$44271b4f0c6a3563;
var $deb3f7a940e3dbee$export$827f4ee28efc37;
var $deb3f7a940e3dbee$export$b8972b998723d602;
$deb3f7a940e3dbee$export$806ec8ebcc7680ea = "tANMT";
$deb3f7a940e3dbee$export$fb184b623420d9be = "tXBMU";
$deb3f7a940e3dbee$export$3931a0da49df8dc0 = "L-boR";
$deb3f7a940e3dbee$export$e850e66917a23e0f = "C6-fI";
$deb3f7a940e3dbee$export$a8ff84c12d48cfa6 = "XOTpq";
$deb3f7a940e3dbee$export$6d59db4903f20f7d = "SLsTh";
$deb3f7a940e3dbee$export$acf4eaf431084f78 = "_7jvfw";
$deb3f7a940e3dbee$export$1ca1ec8b29a4ce27 = "_6LQ3h";
$deb3f7a940e3dbee$export$523fb3936f49e028 = "_7wE4r";
$deb3f7a940e3dbee$export$44271b4f0c6a3563 = "-op1F";
$deb3f7a940e3dbee$export$827f4ee28efc37 = "_9BFxK";
$deb3f7a940e3dbee$export$b8972b998723d602 = "k8h4B";


var $834b125772616626$export$81d85f5ace7f975f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackCasesComponent, Component);
    function WebsiteBlackCasesComponent(cases) {
        (0, $3CDbU._)(this, WebsiteBlackCasesComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackCasesComponent);
        _this.cases = cases;
        //language=HTML
        _this.template = '\n            <div class="'.concat($deb3f7a940e3dbee$exports.componentWebsiteBlackCases, '">\n                <div class="').concat($deb3f7a940e3dbee$exports.title, '">').concat(cases.title, '</div>\n                <div class="').concat($deb3f7a940e3dbee$exports.cases, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackCasesComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.casesContainer = this.el($deb3f7a940e3dbee$exports.cases);
                this.cases.cases.forEach(function(value) {
                    //language=HTML
                    _this.casesContainer.append('\n                <div class="'.concat($deb3f7a940e3dbee$exports["case"], '">\n                    <div class="').concat($deb3f7a940e3dbee$exports.name, '">').concat(value.name, '</div>\n                    <div class="').concat($deb3f7a940e3dbee$exports.description, '">\n                        ').concat(value.description, '\n                    </div>\n                    <div class="').concat($deb3f7a940e3dbee$exports.iconContainer, '">\n                        <div class="').concat($deb3f7a940e3dbee$exports.icon, " ").concat($deb3f7a940e3dbee$exports[value.icon], '"></div>\n                    </div>\n                    <div class="').concat($deb3f7a940e3dbee$exports.shadow, '"></div>\n                </div>\n            '));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackCasesComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteBlackCasesComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $d6f193704760ee55$export$13d8c63fa0fa71bd = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogPrestashopComponent, Component);
    function WebsiteContentBlogPrestashopComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogPrestashopComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogPrestashopComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.downloadModuleFree"),
            center: true,
            title: (0, $wYO7b.Resources).t("words.freeBlogModuleTitle"),
            description: (0, $wYO7b.Resources).t("words.freeBlogModuleDescription"),
            partnerIcon: "prestashop",
            secondButton: true
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.stepsToCreatePublishArticle"),
            icon: "seo",
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-i.mp4"),
                    duration: 16300
                },
                {
                    name: (0, $wYO7b.Resources).t("words.managementInPrestaShop"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-j.mp4"),
                    duration: 20000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.finalRender"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-k.mp4"),
                    duration: 7000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $529cecc0c9ce0c3a$export$67fc1824eabdc07e)({
            text: (0, $wYO7b.Resources).t("words.dailyEcommerceOptimization"),
            size: "sizeNormal",
            shadow: "colorBlue"
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $834b125772616626$export$81d85f5ace7f975f)({
            title: (0, $wYO7b.Resources).t("words.moduleFeatures"),
            cases: [
                {
                    name: (0, $wYO7b.Resources).t("words.fullInterface"),
                    description: (0, $wYO7b.Resources).t("words.fullInterfaceDescription"),
                    icon: "page"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.seoFriendly"),
                    description: (0, $wYO7b.Resources).t("words.seoFriendlyDescription"),
                    icon: "target"
                },
                {
                    name: (0, $wYO7b.Resources).t("words.compatibleWithExistingBlog"),
                    description: (0, $wYO7b.Resources).t("words.compatibleWithExistingBlogDescription"),
                    icon: "box"
                }
            ]
        })), '\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $6a9745de553f4d89$export$27a48b752485acc3)({
            title: (0, $wYO7b.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $wYO7b.Resources).t("words.completeSeoPlatform"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $wYO7b.Resources).t("words.optimizeExistingSeo"),
                        description: (0, $wYO7b.Resources).t("words.optimizeExistingSeoDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.createEngagingContent"),
                        description: (0, $wYO7b.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.competitorAnalysis"),
                        description: (0, $wYO7b.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.autopilot"),
                        description: (0, $wYO7b.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        })), '\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $91b2ad7d68885d02$export$e95aadd4cd13f6de)({
            title: (0, $wYO7b.Resources).t("words.ourPlatform"),
            description: (0, $wYO7b.Resources).t("words.perfectForPrestashop"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.automaticPilot"),
                                description: (0, $wYO7b.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.workInAnyLanguage"),
                                description: (0, $wYO7b.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2f9b971fa7f82f09$export$7f8c4dbd337fa85b)()), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogPrestashopComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogPrestashopComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogPrestashopComponent;
}((0, $9gCL8.Component));


var $f9faa03fb7434e07$export$26219a799f10bcc9 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogPrestashopPage, WebsitePageComponent);
    function WebsiteBlogPrestashopPage() {
        (0, $3CDbU._)(this, WebsiteBlogPrestashopPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogPrestashopPage);
        _this.updateMetas("prestashop");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogPrestashopPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $d6f193704760ee55$export$13d8c63fa0fa71bd)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogPrestashopPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");





var $wYO7b = parcelRequire("wYO7b");








var $ef6d5ed6e25033d5$export$7405d286852a5a68 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogWordpressComponent, Component);
    function WebsiteContentBlogWordpressComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogWordpressComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogWordpressComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($e90ba9dd4a4f2e91$export$8fa521ed3b789f84, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            center: true,
            title: (0, $wYO7b.Resources).t("words.wordpressExtensionTraffic"),
            description: (0, $wYO7b.Resources).t("words.wordpressExtensionDescription"),
            partnerIcon: "wordpress",
            secondButton: false
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $11905550a94e3587$export$21cf7e1029971b9d)((0, $wYO7b.Resources).t("words.howItWorks"), [
            {
                icon: "draft",
                title: (0, $wYO7b.Resources).t("words.instructionsTitle"),
                desc: (0, $wYO7b.Resources).t("words.instructionsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $wYO7b.Resources).t("words.proposalsTitle"),
                desc: (0, $wYO7b.Resources).t("words.proposalsDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $wYO7b.Resources).t("words.planTitle"),
                desc: (0, $wYO7b.Resources).t("words.planDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $wYO7b.Resources).t("words.writingTitle"),
                desc: (0, $wYO7b.Resources).t("words.writingDescription"),
                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ])), '\n                    </div>\n                    <div class="').concat($e90ba9dd4a4f2e91$export$2217aca24454a969, '">\n                        <div class="').concat($e90ba9dd4a4f2e91$export$f7c42a96c638d4dc, '">\n                            <div class="').concat($e90ba9dd4a4f2e91$export$79ffe56a765070d2, '">\n                                <img class="').concat($e90ba9dd4a4f2e91$export$5c452ff88e35e47d, '" src="').concat((0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-e.webp"), '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.styleCloning"), '" draggable="false"\n                                     width="380" height="347.51"\n                                />\n                            </div>\n                            <div class="').concat($e90ba9dd4a4f2e91$export$eabcd2c8791e7bf4, '">\n                                <h2 class="').concat($e90ba9dd4a4f2e91$export$fb184b623420d9be, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleTitle"), '\n                                </h2>\n                                <p class="').concat($e90ba9dd4a4f2e91$export$c96745152eb2740f, '">\n                                    ').concat((0, $wYO7b.Resources).t("words.keepWritingStyleText"), '\n                                </p>\n                                <img class="').concat($e90ba9dd4a4f2e91$export$53f1d5ea8de3d7c, '" src="').concat((0, $3e10e981c2995cb0$export$a27e371a094e4e50).illus("separator-line.svg"), '"\n                                     alt="').concat((0, $wYO7b.Resources).t("words.separationLine"), '" draggable="false"/>\n                            </div>\n                        </div>\n                        <div class="').concat($e90ba9dd4a4f2e91$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $a065dfaf6e33fc91$export$366de2f3346a7a26)({
            title: (0, $wYO7b.Resources).t("words.explainContextToAI"),
            description: (0, $wYO7b.Resources).t("words.contextFeatureText"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-f.webp"),
            color: "black",
            size: "medium",
            border: "border"
        })), '\n                        </div>\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $e208639b04565fea$export$f6f77077605a705e)({
            theme: "black",
            questions: [
                {
                    question: (0, $wYO7b.Resources).t("words.doesGooglePenalizeAiContent"),
                    response: (0, $wYO7b.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.seoOptimizationQuestion"),
                    response: (0, $wYO7b.Resources).t("words.seoOptimizationResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.platformConnectionQuestion"),
                    response: (0, $wYO7b.Resources).t("words.platformConnectionResponse")
                },
                {
                    question: (0, $wYO7b.Resources).t("words.smartBlogAdvantagesQuestion"),
                    response: (0, $wYO7b.Resources).t("words.smartBlogAdvantagesResponse")
                }
            ]
        })), '\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $6a9745de553f4d89$export$27a48b752485acc3)({
            title: (0, $wYO7b.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $wYO7b.Resources).t("words.completeWordpressExtension"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $wYO7b.Resources).t("words.optimizeExistingSeoWordpress"),
                        description: (0, $wYO7b.Resources).t("words.optimizeExistingSeoDescriptionWordpress"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.createEngagingContent"),
                        description: (0, $wYO7b.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.competitorAnalysis"),
                        description: (0, $wYO7b.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.autopilot"),
                        description: (0, $wYO7b.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        })), '\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $91b2ad7d68885d02$export$e95aadd4cd13f6de)({
            title: (0, $wYO7b.Resources).t("words.ourPlatform"),
            description: (0, $wYO7b.Resources).t("words.seoToolDescriptionWordpress"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.automaticPilot"),
                                description: (0, $wYO7b.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.workInAnyLanguage"),
                                description: (0, $wYO7b.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        })), '\n                                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $2f9b971fa7f82f09$export$7f8c4dbd337fa85b)()), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogWordpressComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogWordpressComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogWordpressComponent;
}((0, $9gCL8.Component));


var $8d423849995d5587$export$3a96fed2f93e0d19 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogWordpressPage, WebsitePageComponent);
    function WebsiteBlogWordpressPage() {
        (0, $3CDbU._)(this, WebsiteBlogWordpressPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogWordpressPage);
        _this.updateMetas("wordpress");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogWordpressPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $ef6d5ed6e25033d5$export$7405d286852a5a68)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogWordpressPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $wYO7b = parcelRequire("wYO7b");

var $9gCL8 = parcelRequire("9gCL8");






var $bc894d53df3900c2$export$45e36e94ebd3c478 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentHomeComponent, Component);
    function WebsiteContentHomeComponent() {
        (0, $3CDbU._)(this, WebsiteContentHomeComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentHomeComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            title: (0, $wYO7b.Resources).t("words.mostPerformantContent"),
            description: (0, $wYO7b.Resources).t("words.sedestralSystemDescription"),
            people: true,
            center: true
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.simplifiedSeoSteps"),
            icon: "seo",
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.analysisAndResearch"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-a.mp4"),
                    duration: 5700
                },
                {
                    name: (0, $wYO7b.Resources).t("words.writeOrGenerate"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-b.mp4"),
                    duration: 22000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.verifyAndPublish"),
                    type: "img",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-c.webp"),
                    duration: 6000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $529cecc0c9ce0c3a$export$67fc1824eabdc07e)({
            text: (0, $wYO7b.Resources).t("words.dailyOptimizationUsers"),
            size: "sizeNormal",
            shadow: "colorBlue"
        })), '\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $6a9745de553f4d89$export$27a48b752485acc3)({
            title: (0, $wYO7b.Resources).t("words.createAndOptimize"),
            bigTitle: (0, $wYO7b.Resources).t("words.createEngagingContent"),
            image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-c.webp"),
            texts: {
                canCollapse: false,
                entries: [
                    {
                        title: (0, $wYO7b.Resources).t("words.autoOptimizeExistingContent"),
                        description: (0, $wYO7b.Resources).t("words.autoOptimizeDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $wYO7b.Resources).t("words.createEngagingSeoContent"),
                        description: (0, $wYO7b.Resources).t("words.createEngagingDescription"),
                        icon: "aiWrite",
                        iconColor: "colorPurple"
                    }
                ]
            }
        })), '\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $91b2ad7d68885d02$export$e95aadd4cd13f6de)({
            title: (0, $wYO7b.Resources).t("words.ourPlatform"),
            description: (0, $wYO7b.Resources).t("words.ourPlatformDescription"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.seoScore"),
                                description: (0, $wYO7b.Resources).t("words.seoScoreDescription"),
                                type: "icon",
                                icon: "optimize",
                                ai: true
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.sedestralAi"),
                                description: (0, $wYO7b.Resources).t("words.sedestralAiDescription"),
                                type: "image",
                                image: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-d.webp"),
                                ai: true,
                                size: "sizeLarge",
                                color: "colorBlue"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.workInAnyLanguage"),
                                description: (0, $wYO7b.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMid",
                                color: "colorYellow",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.deepCompetitorAnalysis"),
                                description: (0, $wYO7b.Resources).t("words.deepCompetitorDescription"),
                                type: "icon",
                                icon: "chartPurple",
                                size: "sizeMid",
                                color: "colorPurple",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $wYO7b.Resources).t("words.automaticPiloting"),
                                description: (0, $wYO7b.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $wYO7b.Resources).t("words.nativeIntegration"),
                                description: (0, $wYO7b.Resources).t("words.nativeIntegrationDescription"),
                                type: "icon",
                                icon: "funnel",
                                size: "sizeMidColumn",
                                color: "colorPurple",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        })), "\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentHomeComponent;
}((0, $9gCL8.Component));


var $d06cae3c682de532$export$a04f4b273a33409f = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteHomePage, WebsitePageComponent);
    function WebsiteHomePage() {
        (0, $3CDbU._)(this, WebsiteHomePage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteHomePage);
        _this.updateMetas("home");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteHomePage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $bc894d53df3900c2$export$45e36e94ebd3c478)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteHomePage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");






var $wYO7b = parcelRequire("wYO7b");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $0762a9f227eca383$export$a47911b81bc97c6f;
var $0762a9f227eca383$export$6d59db4903f20f7d;
var $0762a9f227eca383$export$a7db06668cad9adb;
var $0762a9f227eca383$export$55518a6b07703516;
var $0762a9f227eca383$export$2cc7ff91bcacba5e;
$0762a9f227eca383$export$a47911b81bc97c6f = "NZXhT";
$0762a9f227eca383$export$6d59db4903f20f7d = "yRwUc";
$0762a9f227eca383$export$a7db06668cad9adb = "BsxTO";
$0762a9f227eca383$export$55518a6b07703516 = "HvZho";
$0762a9f227eca383$export$2cc7ff91bcacba5e = "hENoT";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $11f9b23ed6070ffb$exports = {};

$parcel$export($11f9b23ed6070ffb$exports, "componentWebsiteBlackUnion", function () { return $11f9b23ed6070ffb$export$31612e1b4b9ea7c2; }, function (v) { return $11f9b23ed6070ffb$export$31612e1b4b9ea7c2 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "rect", function () { return $11f9b23ed6070ffb$export$4b409e53cf4df6e6; }, function (v) { return $11f9b23ed6070ffb$export$4b409e53cf4df6e6 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "pastille", function () { return $11f9b23ed6070ffb$export$564e4a74ab2e0db0; }, function (v) { return $11f9b23ed6070ffb$export$564e4a74ab2e0db0 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "iconContainer", function () { return $11f9b23ed6070ffb$export$acf4eaf431084f78; }, function (v) { return $11f9b23ed6070ffb$export$acf4eaf431084f78 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "shadow", function () { return $11f9b23ed6070ffb$export$b8972b998723d602; }, function (v) { return $11f9b23ed6070ffb$export$b8972b998723d602 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "icon", function () { return $11f9b23ed6070ffb$export$1ca1ec8b29a4ce27; }, function (v) { return $11f9b23ed6070ffb$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "union", function () { return $11f9b23ed6070ffb$export$971dd5b0dfd021b6; }, function (v) { return $11f9b23ed6070ffb$export$971dd5b0dfd021b6 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "cases", function () { return $11f9b23ed6070ffb$export$3931a0da49df8dc0; }, function (v) { return $11f9b23ed6070ffb$export$3931a0da49df8dc0 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "case", function () { return $11f9b23ed6070ffb$export$e850e66917a23e0f; }, function (v) { return $11f9b23ed6070ffb$export$e850e66917a23e0f = v; });
$parcel$export($11f9b23ed6070ffb$exports, "blue", function () { return $11f9b23ed6070ffb$export$2aa0182783e7e9de; }, function (v) { return $11f9b23ed6070ffb$export$2aa0182783e7e9de = v; });
$parcel$export($11f9b23ed6070ffb$exports, "content", function () { return $11f9b23ed6070ffb$export$a7db06668cad9adb; }, function (v) { return $11f9b23ed6070ffb$export$a7db06668cad9adb = v; });
$parcel$export($11f9b23ed6070ffb$exports, "blur", function () { return $11f9b23ed6070ffb$export$2cc7ff91bcacba5e; }, function (v) { return $11f9b23ed6070ffb$export$2cc7ff91bcacba5e = v; });
$parcel$export($11f9b23ed6070ffb$exports, "name", function () { return $11f9b23ed6070ffb$export$a8ff84c12d48cfa6; }, function (v) { return $11f9b23ed6070ffb$export$a8ff84c12d48cfa6 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "purple", function () { return $11f9b23ed6070ffb$export$e13cce2a2d16a9d4; }, function (v) { return $11f9b23ed6070ffb$export$e13cce2a2d16a9d4 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "yellow", function () { return $11f9b23ed6070ffb$export$594c5a8758200c32; }, function (v) { return $11f9b23ed6070ffb$export$594c5a8758200c32 = v; });
$parcel$export($11f9b23ed6070ffb$exports, "names", function () { return $11f9b23ed6070ffb$export$e4b2ac9215619f8d; }, function (v) { return $11f9b23ed6070ffb$export$e4b2ac9215619f8d = v; });
$parcel$export($11f9b23ed6070ffb$exports, "description", function () { return $11f9b23ed6070ffb$export$6d59db4903f20f7d; }, function (v) { return $11f9b23ed6070ffb$export$6d59db4903f20f7d = v; });
var $11f9b23ed6070ffb$export$31612e1b4b9ea7c2;
var $11f9b23ed6070ffb$export$4b409e53cf4df6e6;
var $11f9b23ed6070ffb$export$564e4a74ab2e0db0;
var $11f9b23ed6070ffb$export$acf4eaf431084f78;
var $11f9b23ed6070ffb$export$b8972b998723d602;
var $11f9b23ed6070ffb$export$1ca1ec8b29a4ce27;
var $11f9b23ed6070ffb$export$971dd5b0dfd021b6;
var $11f9b23ed6070ffb$export$3931a0da49df8dc0;
var $11f9b23ed6070ffb$export$e850e66917a23e0f;
var $11f9b23ed6070ffb$export$2aa0182783e7e9de;
var $11f9b23ed6070ffb$export$a7db06668cad9adb;
var $11f9b23ed6070ffb$export$2cc7ff91bcacba5e;
var $11f9b23ed6070ffb$export$a8ff84c12d48cfa6;
var $11f9b23ed6070ffb$export$e13cce2a2d16a9d4;
var $11f9b23ed6070ffb$export$594c5a8758200c32;
var $11f9b23ed6070ffb$export$e4b2ac9215619f8d;
var $11f9b23ed6070ffb$export$6d59db4903f20f7d;
$11f9b23ed6070ffb$export$31612e1b4b9ea7c2 = "klryu";
$11f9b23ed6070ffb$export$4b409e53cf4df6e6 = "PoaQ4";
$11f9b23ed6070ffb$export$564e4a74ab2e0db0 = "BGowu";
$11f9b23ed6070ffb$export$acf4eaf431084f78 = "_943qj";
$11f9b23ed6070ffb$export$b8972b998723d602 = "Stx-W";
$11f9b23ed6070ffb$export$1ca1ec8b29a4ce27 = "g9YOi";
$11f9b23ed6070ffb$export$971dd5b0dfd021b6 = "EEDpq";
$11f9b23ed6070ffb$export$3931a0da49df8dc0 = "vYEcJ";
$11f9b23ed6070ffb$export$e850e66917a23e0f = "ckG9B";
$11f9b23ed6070ffb$export$2aa0182783e7e9de = "XuQ9s";
$11f9b23ed6070ffb$export$a7db06668cad9adb = "bD7k7";
$11f9b23ed6070ffb$export$2cc7ff91bcacba5e = "_7-4ya";
$11f9b23ed6070ffb$export$a8ff84c12d48cfa6 = "_1kcaj";
$11f9b23ed6070ffb$export$e13cce2a2d16a9d4 = "d84Qm";
$11f9b23ed6070ffb$export$594c5a8758200c32 = "h9MMA";
$11f9b23ed6070ffb$export$e4b2ac9215619f8d = "CpC5t";
$11f9b23ed6070ffb$export$6d59db4903f20f7d = "xurSr";


var $8cf4d5a25e891eb5$export$1c0bc67f9d9907fa = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackUnionComponent, Component);
    function WebsiteBlackUnionComponent(union) {
        (0, $3CDbU._)(this, WebsiteBlackUnionComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackUnionComponent);
        _this.union = union;
        //language=HTML
        _this.template = '\n            <div class="'.concat($11f9b23ed6070ffb$exports.componentWebsiteBlackUnion, '">\n                <div class="').concat($11f9b23ed6070ffb$exports.rect, '">\n                    <div class="').concat($11f9b23ed6070ffb$exports.pastille, '">\n                        <div class="').concat($11f9b23ed6070ffb$exports.iconContainer, '">\n                            <div class="').concat($11f9b23ed6070ffb$exports.shadow, '"></div>\n                            <div class="').concat($11f9b23ed6070ffb$exports.icon, '"></div>\n                        </div>\n                        ').concat(union.ai, '\n                    </div>\n                </div>\n                <div class="').concat($11f9b23ed6070ffb$exports.union, '"></div>\n                <div class="').concat($11f9b23ed6070ffb$exports.cases, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlackUnionComponent, [
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                this.casesContainer = this.el($11f9b23ed6070ffb$exports.cases);
                this.union.cases.forEach(function(value) {
                    //language=HTML
                    _this.casesContainer.append('\n                <div class="'.concat($11f9b23ed6070ffb$exports["case"], " ").concat($11f9b23ed6070ffb$exports[value.color], '">\n                    <div class="').concat($11f9b23ed6070ffb$exports.content, '">\n                        <div class="').concat($11f9b23ed6070ffb$exports.names, '">\n                            <div class="').concat($11f9b23ed6070ffb$exports.blur, '"></div>\n                            <div class="').concat($11f9b23ed6070ffb$exports.name, '">\n                                ').concat(value.name, '\n                            </div>\n                        </div>\n                        <div class="').concat($11f9b23ed6070ffb$exports.description, '">\n                            ').concat(value.description, "\n                        </div>\n                    </div>\n                </div>\n            "));
                });
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlackUnionComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteBlackUnionComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $3e605aaf756573e2$export$dc94a094b7b0ae05 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackIndicatorsComponent, Component);
    function WebsiteBlackIndicatorsComponent(indicators) {
        (0, $3CDbU._)(this, WebsiteBlackIndicatorsComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackIndicatorsComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($0762a9f227eca383$export$a47911b81bc97c6f, '">\n                <div class="').concat($0762a9f227eca383$export$6d59db4903f20f7d, '">\n                    <div class="').concat($0762a9f227eca383$export$a7db06668cad9adb, '">\n                        ').concat(indicators.description, '\n                    </div>\n                </div>\n                <div class="').concat($0762a9f227eca383$export$55518a6b07703516, '">\n                    <div class="').concat($0762a9f227eca383$export$2cc7ff91bcacba5e, '"></div>\n                    <div class="').concat($0762a9f227eca383$export$a7db06668cad9adb, '">\n                        ').concat(indicators.content, "\n                    </div>\n                </div>\n                ").concat(_this.draw(new (0, $8cf4d5a25e891eb5$export$1c0bc67f9d9907fa)({
            ai: (0, $wYO7b.Resources).t("words.sedestralAI"),
            cases: [
                {
                    color: "blue",
                    name: (0, $wYO7b.Resources).t("words.siteAnalysis"),
                    description: (0, $wYO7b.Resources).t("words.siteAnalysisDescription")
                },
                {
                    color: "purple",
                    name: (0, $wYO7b.Resources).t("words.firstKeywords"),
                    description: (0, $wYO7b.Resources).t("words.firstKeywordsDescription")
                },
                {
                    color: "yellow",
                    name: (0, $wYO7b.Resources).t("words.googleSearches"),
                    description: (0, $wYO7b.Resources).t("words.googleSearchesDescription")
                }
            ]
        })), "\n            </div>\n        ");
        return _this;
    }
    return WebsiteBlackIndicatorsComponent;
}((0, $9gCL8.Component));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $5f3572c621ebb9a2$export$e079a52b1c897733;
var $5f3572c621ebb9a2$export$fb184b623420d9be;
var $5f3572c621ebb9a2$export$b2b3286365e789d9;
var $5f3572c621ebb9a2$export$3931a0da49df8dc0;
var $5f3572c621ebb9a2$export$e850e66917a23e0f;
var $5f3572c621ebb9a2$export$2adb16ac204af30e;
var $5f3572c621ebb9a2$export$a8ff84c12d48cfa6;
var $5f3572c621ebb9a2$export$1ca1ec8b29a4ce27;
var $5f3572c621ebb9a2$export$8fde8ebd684d5072;
var $5f3572c621ebb9a2$export$dd9cd24e500b6d0b;
var $5f3572c621ebb9a2$export$2d6e9b4c68afb6c8;
var $5f3572c621ebb9a2$export$6d59db4903f20f7d;
var $5f3572c621ebb9a2$export$df03f54e09e486fa;
var $5f3572c621ebb9a2$export$75904fce00b7240e;
var $5f3572c621ebb9a2$export$f90719f89646befa;
var $5f3572c621ebb9a2$export$3c7172b0b56389d;
var $5f3572c621ebb9a2$export$a4331299cbd0247f;
$5f3572c621ebb9a2$export$e079a52b1c897733 = "mmdtX";
$5f3572c621ebb9a2$export$fb184b623420d9be = "_1XfjP";
$5f3572c621ebb9a2$export$b2b3286365e789d9 = "Ximav";
$5f3572c621ebb9a2$export$3931a0da49df8dc0 = "q9R-P";
$5f3572c621ebb9a2$export$e850e66917a23e0f = "hErou";
$5f3572c621ebb9a2$export$2adb16ac204af30e = "htg4g";
$5f3572c621ebb9a2$export$a8ff84c12d48cfa6 = "gfp3D";
$5f3572c621ebb9a2$export$1ca1ec8b29a4ce27 = "Lh8-0";
$5f3572c621ebb9a2$export$8fde8ebd684d5072 = "nOlcb";
$5f3572c621ebb9a2$export$dd9cd24e500b6d0b = "jExnb";
$5f3572c621ebb9a2$export$2d6e9b4c68afb6c8 = "Pa1qn";
$5f3572c621ebb9a2$export$6d59db4903f20f7d = "_5spjo";
$5f3572c621ebb9a2$export$df03f54e09e486fa = "gpTJb";
$5f3572c621ebb9a2$export$75904fce00b7240e = "Ou0oS";
$5f3572c621ebb9a2$export$f90719f89646befa = "su6yq";
$5f3572c621ebb9a2$export$3c7172b0b56389d = "AexdA";
$5f3572c621ebb9a2$export$a4331299cbd0247f = "U5Kmi";



var $wYO7b = parcelRequire("wYO7b");
var $e1490949ae97f53a$export$8697f8918118012b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlackAllieComponent, Component);
    function WebsiteBlackAllieComponent() {
        (0, $3CDbU._)(this, WebsiteBlackAllieComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlackAllieComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($5f3572c621ebb9a2$export$e079a52b1c897733, '">\n                <div class="').concat($5f3572c621ebb9a2$export$fb184b623420d9be, '">\n                    ').concat((0, $wYO7b.Resources).t("words.yourBestSeoAlly"), '\n                </div>\n                <div class="').concat($5f3572c621ebb9a2$export$b2b3286365e789d9, '">\n                    ').concat((0, $wYO7b.Resources).t("words.analyzeRankingAndCompetitors"), '\n                </div>\n                <div class="').concat($5f3572c621ebb9a2$export$3931a0da49df8dc0, '">\n                    <div class="').concat($5f3572c621ebb9a2$export$e850e66917a23e0f, '">\n                        <div class="').concat($5f3572c621ebb9a2$export$a8ff84c12d48cfa6, '">\n                            <div class="').concat($5f3572c621ebb9a2$export$1ca1ec8b29a4ce27, " ").concat($5f3572c621ebb9a2$export$8fde8ebd684d5072, '"></div>\n                            ').concat((0, $wYO7b.Resources).t("words.identifyKeywordsToOptimize"), '\n                        </div>\n                        <div class="').concat($5f3572c621ebb9a2$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.identifyLowCompetitionKeywords"), '\n                        </div>\n                    </div>\n                    <div class="').concat($5f3572c621ebb9a2$export$e850e66917a23e0f, '">\n                        <div class="').concat($5f3572c621ebb9a2$export$a8ff84c12d48cfa6, '">\n                            <div class="').concat($5f3572c621ebb9a2$export$1ca1ec8b29a4ce27, " ").concat($5f3572c621ebb9a2$export$dd9cd24e500b6d0b, '"></div>\n                            ').concat((0, $wYO7b.Resources).t("words.trackKeywordsYouWorkOn"), '\n                        </div>\n                        <div class="').concat($5f3572c621ebb9a2$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.monitorPerformanceAndRanking"), '\n                        </div>\n                    </div>\n                    <div class="').concat($5f3572c621ebb9a2$export$e850e66917a23e0f, '">\n                        <div class="').concat($5f3572c621ebb9a2$export$a8ff84c12d48cfa6, '">\n                            <div class="').concat($5f3572c621ebb9a2$export$1ca1ec8b29a4ce27, " ").concat($5f3572c621ebb9a2$export$2d6e9b4c68afb6c8, '"></div>\n                            ').concat((0, $wYO7b.Resources).t("words.reactQuicklyToChanges"), '\n                        </div>\n                        <div class="').concat($5f3572c621ebb9a2$export$6d59db4903f20f7d, '">\n                            ').concat((0, $wYO7b.Resources).t("words.realTimeAnalysisToOptimize"), '\n                        </div>\n                    </div>\n                </div>\n                <div class="').concat($5f3572c621ebb9a2$export$a4331299cbd0247f, '"></div>\n                <div class="').concat($5f3572c621ebb9a2$export$b2b3286365e789d9, '">\n                    ').concat((0, $wYO7b.Resources).t("words.useAiToCreateAndOptimizeContent"), '\n                </div>\n                <div class="').concat($5f3572c621ebb9a2$export$3931a0da49df8dc0, '">\n                    <div class="').concat($5f3572c621ebb9a2$export$e850e66917a23e0f, " ").concat($5f3572c621ebb9a2$export$2adb16ac204af30e, '">\n                        <div class="').concat($5f3572c621ebb9a2$export$a8ff84c12d48cfa6, '">\n                            ').concat((0, $wYO7b.Resources).t("words.optimizeExistingContentForKeyword"), '\n                        </div>\n                        <div class="').concat($5f3572c621ebb9a2$export$df03f54e09e486fa, '">\n                            <div class="').concat($5f3572c621ebb9a2$export$6d59db4903f20f7d, '">\n                                ').concat((0, $wYO7b.Resources).t("words.advancedSystemForOptimization"), '\n                            </div>\n                            <div class="').concat($5f3572c621ebb9a2$export$75904fce00b7240e, " ").concat($5f3572c621ebb9a2$export$f90719f89646befa, '"></div>\n                        </div>\n                    </div>\n                    <div class="').concat($5f3572c621ebb9a2$export$e850e66917a23e0f, " ").concat($5f3572c621ebb9a2$export$2adb16ac204af30e, '">\n                        <div class="').concat($5f3572c621ebb9a2$export$a8ff84c12d48cfa6, '">\n                            ').concat((0, $wYO7b.Resources).t("words.createEngagingSeoContent"), '\n                        </div>\n                        <div class="').concat($5f3572c621ebb9a2$export$df03f54e09e486fa, '">\n                            <div class="').concat($5f3572c621ebb9a2$export$6d59db4903f20f7d, '">\n                                ').concat((0, $wYO7b.Resources).t("words.generateOptimizedContents"), '\n                            </div>\n                            <div class="').concat($5f3572c621ebb9a2$export$75904fce00b7240e, " ").concat($5f3572c621ebb9a2$export$3c7172b0b56389d, '"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ');
        return _this;
    }
    return WebsiteBlackAllieComponent;
}((0, $9gCL8.Component));


var $542a8e6ede62a961$export$b45c10ab8c2a6c72 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentBlogAnalysisComponent, Component);
    function WebsiteContentBlogAnalysisComponent() {
        (0, $3CDbU._)(this, WebsiteContentBlogAnalysisComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentBlogAnalysisComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, '">\n                <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $d4f38fb53f9502a8$export$6d14472d28e42cd8)({
            startText: (0, $wYO7b.Resources).t("words.beginFree"),
            center: true,
            title: (0, $wYO7b.Resources).t("words.indicatorsGiveEdge"),
            description: (0, $wYO7b.Resources).t("words.sedestralTrackingDescription")
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $876aeb3188abd82e$export$41c8d4c54c27d95f)({
            title: (0, $wYO7b.Resources).t("words.steps"),
            icon: "seo",
            contents: [
                {
                    name: (0, $wYO7b.Resources).t("words.rankVisualization"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-l.mp4"),
                    duration: 10000
                },
                {
                    name: (0, $wYO7b.Resources).t("words.competitorComparison"),
                    type: "video",
                    path: (0, $3e10e981c2995cb0$export$a27e371a094e4e50).image("blog-m.mp4"),
                    duration: 14000
                }
            ]
        })), '\n                    </div>\n                    <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                        ').concat(_this.draw(new (0, $3e605aaf756573e2$export$dc94a094b7b0ae05)({
            description: (0, $wYO7b.Resources).t("words.cannotImproveWhatNotSeen"),
            content: (0, $wYO7b.Resources).t("words.sedestralReviewDescription")
        })), '\n                    </div>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            ').concat(_this.draw(new (0, $e1490949ae97f53a$export$8697f8918118012b)()), "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteContentBlogAnalysisComponent, [
        {
            key: "commit",
            value: function commit() {
                (0, $8f67b912ef2ce121$export$4718cc74f3daff00).blog();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteContentBlogAnalysisComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return WebsiteContentBlogAnalysisComponent;
}((0, $9gCL8.Component));


var $91e50878e5d11d16$export$ab7ea9573211da38 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogAnalysisPage, WebsitePageComponent);
    function WebsiteBlogAnalysisPage() {
        (0, $3CDbU._)(this, WebsiteBlogAnalysisPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogAnalysisPage);
        _this.updateMetas("analysis");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogAnalysisPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $542a8e6ede62a961$export$b45c10ab8c2a6c72)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteBlogAnalysisPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");

var $4dbbe850674b8fb3$export$e434ce7de9258df4;
var $4dbbe850674b8fb3$export$d92e6f982d8d582;
var $4dbbe850674b8fb3$export$fb184b623420d9be;
$4dbbe850674b8fb3$export$e434ce7de9258df4 = "_1Gqz5";
$4dbbe850674b8fb3$export$d92e6f982d8d582 = "wgKID";
$4dbbe850674b8fb3$export$fb184b623420d9be = "w60GZ";



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $d255aff675622b68$export$717af95ad73b5517;
var $d255aff675622b68$export$a7db06668cad9adb;
var $d255aff675622b68$export$fb184b623420d9be;
var $d255aff675622b68$export$5c452ff88e35e47d;
var $d255aff675622b68$export$6e22c362a0406a2c;
var $d255aff675622b68$export$6f093cfa640b7166;
var $d255aff675622b68$export$41ee12f6f6f05843;
var $d255aff675622b68$export$40e543e69a8b3fbb;
$d255aff675622b68$export$717af95ad73b5517 = "_6e4O7";
$d255aff675622b68$export$a7db06668cad9adb = "Ck9DZ";
$d255aff675622b68$export$fb184b623420d9be = "_111Lr";
$d255aff675622b68$export$5c452ff88e35e47d = "k1jrV";
$d255aff675622b68$export$6e22c362a0406a2c = "UHgVd";
$d255aff675622b68$export$6f093cfa640b7166 = "_25oiB";
$d255aff675622b68$export$41ee12f6f6f05843 = "_4reGz";
$d255aff675622b68$export$40e543e69a8b3fbb = "fK-rB";



var $5Azrw = parcelRequire("5Azrw");

var $3D7wv = parcelRequire("3D7wv");

var $wYO7b = parcelRequire("wYO7b");
/**
 * retourne la date pour les metas
 */ function $8e39797066a0a463$export$9863893cf6a97125(date) {
    var isoDate = date.toISOString();
    var offset = -date.getTimezoneOffset();
    var offsetSign = offset >= 0 ? '+' : '-';
    var offsetHours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, '0');
    var offsetMinutes = Math.abs(offset % 60).toString().padStart(2, '0');
    var timezoneFormat = "".concat(offsetSign).concat(offsetHours, ":").concat(offsetMinutes);
    var localISODate = "".concat(isoDate.substring(0, isoDate.length - 1)).concat(timezoneFormat);
    return localISODate;
}



var $wYO7b = parcelRequire("wYO7b");
function $da575c98c1c64962$export$4d4ebea86394cbb3(date) {
    return new Intl.DateTimeFormat((0, $wYO7b.Resources).language, {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).format(new Date(date));
}


var $8fa943e3a453140e$export$be23e26c77269b4e = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteBlogArticleComponent, Component);
    function WebsiteBlogArticleComponent(article) {
        (0, $3CDbU._)(this, WebsiteBlogArticleComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteBlogArticleComponent);
        _this.article = article;
        //language=HTML
        _this.template = '\n            <article itemprop="blogPosts" itemscope itemtype="https://schema.org/BlogPosting"\n                     class="'.concat($d255aff675622b68$export$717af95ad73b5517, '">\n                <meta itemprop="url" content="').concat(_this.article.url, '">\n                <meta itemprop="inLanguage" content="fr">\n                <meta itemprop="articleSection" content="').concat((0, $3D7wv.filterXSS)(_this.article.title), '">\n                <div class="').concat($d255aff675622b68$export$5c452ff88e35e47d, '"></div>\n                <div class="').concat($d255aff675622b68$export$a7db06668cad9adb, '">\n                    <h2 itemprop="headline" class="').concat($d255aff675622b68$export$fb184b623420d9be, '">\n                        ').concat((0, $3D7wv.filterXSS)(_this.article.title), '\n                    </h2>\n                    <p itemprop="description" class="').concat($d255aff675622b68$export$6f093cfa640b7166, '">\n                        ').concat((0, $3D7wv.filterXSS)(_this.article.snippet), '\n                    </p>\n                </div>\n\n                <div class="').concat($d255aff675622b68$export$41ee12f6f6f05843, '">\n                    ').concat((0, $da575c98c1c64962$export$4d4ebea86394cbb3)(new Date(_this.article.time)), " |\n                    ").concat(Math.round(_this.article.readingSeconds / 60), " ").concat((0, $wYO7b.Resources).t("words.timeToRead"), "\n                </div>\n                ").concat(_this.article.keywords.length > 0 ? '<meta itemprop="keywords" content="'.concat((0, $3D7wv.filterXSS)(_this.article.keywords.join(", ")), '">') : "", '\n                <meta itemprop="datePublished" content="').concat((0, $8e39797066a0a463$export$9863893cf6a97125)(new Date(_this.article.time)), '">\n                ').concat(_this.article.lastEditTime > 0 ? '<meta itemprop="dateModified" content="'.concat((0, $8e39797066a0a463$export$9863893cf6a97125)(new Date(_this.article.lastEditTime)), '">') : "", "\n            </article>\n        ");
        return _this;
    }
    (0, $jyA4z._)(WebsiteBlogArticleComponent, [
        {
            key: "commit",
            value: function commit() {
                this.imageContainer = this.el($d255aff675622b68$export$5c452ff88e35e47d);
                this.renderImage();
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteBlogArticleComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "renderImage",
            value: function renderImage() {
                //language=HTML
                this.imageContainer.append('\n            <img class="lazyload" itemprop="image" alt="'.concat(this.article.title, '"\n                 src="').concat((0, $5Azrw.IMG_EMPTY), '"\n                 data-src="https://marketing-assets.surferseo.art/wf-cdn/62666115cfab453aacbd513c/67584a0e2d788b53571b9762_Academy%2010%20-%20Cover-p-1080.png"\n                 data-sizes="auto"\n                 width="auto"\n                 height="auto"\n            />\n        '));
                //language=HTML
                this.imageContainer.append('\n            <noscript>\n                <img itemprop="image" src="https://marketing-assets.surferseo.art/wf-cdn/62666115cfab453aacbd513c/67584a0e2d788b53571b9762_Academy%2010%20-%20Cover-p-1080.png" alt="'.concat(this.article.title, '" width="auto"\n                     height="auto"/>\n            </noscript>\n        '));
            }
        }
    ]);
    return WebsiteBlogArticleComponent;
}((0, $9gCL8.Component));


var $f4f0eafd0a4cbd29$export$c4ac2da9aee0d2eb = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(WebsiteContentAcademyComponent, Component);
    function WebsiteContentAcademyComponent() {
        (0, $3CDbU._)(this, WebsiteContentAcademyComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteContentAcademyComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($95cb205eff9a45f3$export$f997558458ede46c, " ").concat($4dbbe850674b8fb3$export$e434ce7de9258df4, '">\n                <div style="gap:20px;" class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                    <div class="').concat($4dbbe850674b8fb3$export$d92e6f982d8d582, '">\n                        Acad\xe9mie\n                    </div>\n                    <h2 class="').concat($4dbbe850674b8fb3$export$fb184b623420d9be, '">\n                        D\xe9couvrez nos cours et conseils pratiques pour optimiser efficacement votre SEO\n                    </h2>\n                </div>\n                <div class="').concat($95cb205eff9a45f3$export$8fa4e5556fd77a60, '">\n                    <div class="').concat($95cb205eff9a45f3$export$a7db06668cad9adb, '">\n                        <div class="').concat($95cb205eff9a45f3$export$34e0f9847d4c02dd, '">\n                            <div style="display: flex;gap:30px;width: 100%;margin-bottom: 35px;">\n                                ').concat(_this.draw(new (0, $8fa943e3a453140e$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        })), "\n                                ").concat(_this.draw(new (0, $8fa943e3a453140e$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        })), '\n                            </div>\n                            <div style="display: flex;gap:30px;width: 100%;">\n                                ').concat(_this.draw(new (0, $8fa943e3a453140e$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        })), "\n                                ").concat(_this.draw(new (0, $8fa943e3a453140e$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        })), "\n                                ").concat(_this.draw(new (0, $8fa943e3a453140e$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        })), "\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
        return _this;
    }
    return WebsiteContentAcademyComponent;
}((0, $9gCL8.Component));


var $d0943108d77f8148$export$649513343506d210 = /*#__PURE__*/ function(WebsitePageComponent) {
    "use strict";
    (0, $jCmGC._)(WebsiteAcademyPage, WebsitePageComponent);
    function WebsiteAcademyPage() {
        (0, $3CDbU._)(this, WebsiteAcademyPage);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsiteAcademyPage);
        _this.updateMetas("academy");
        _this.status.online = undefined;
        return _this;
    }
    (0, $jyA4z._)(WebsiteAcademyPage, [
        {
            key: "contentComponent",
            value: function contentComponent() {
                return new (0, $f4f0eafd0a4cbd29$export$c4ac2da9aee0d2eb)();
            }
        },
        {
            key: "onHash",
            value: function onHash() {}
        }
    ]);
    return WebsiteAcademyPage;
}((0, $f8a487b4e0321a84$export$f58f12b264b5aeb7));


var $614db50d2a9fb733$export$6c295a1800b38e94 = /*#__PURE__*/ function(SedestralRouter) {
    "use strict";
    (0, $jCmGC._)(WebsiteRouter, SedestralRouter);
    function WebsiteRouter() {
        (0, $3CDbU._)(this, WebsiteRouter);
        return (0, $ep9cZ._)(this, WebsiteRouter, arguments);
    }
    (0, $jyA4z._)(WebsiteRouter, [
        {
            key: "init",
            value: function init(config) {
                var _this = this;
                var _this1 = this, _superprop_get_init = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteRouter.prototype), "init", _this);
                }, _superprop_get_initStarted = function() {
                    return (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsiteRouter.prototype), "initStarted", _this);
                };
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        _superprop_get_init().call(_this1, config);
                        _superprop_get_initStarted().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "registerPages",
            value: function registerPages() {
                this.pages.registerPage("/404", function() {
                    return new (0, $e52e2ad4a7d03c16$export$31641b61980e511f)();
                });
                this.pages.registerPage("/home", function() {
                    return new (0, $d06cae3c682de532$export$a04f4b273a33409f)();
                });
                this.pages.registerPage("/inbox", function() {
                    return new (0, $de8535061b5d4d06$export$fdf70f43a3a81415)();
                });
                this.pages.registerPage("/pricing", function() {
                    return new (0, $78c597d9d50d6293$export$36d652602e27a852)();
                });
                this.pages.registerPage("/academy", function() {
                    return new (0, $d0943108d77f8148$export$649513343506d210)();
                });
                this.pages.registerPage("/livechat", function() {
                    return new (0, $a51cb86f8dc1fa90$export$3cbb6273c610a30)();
                });
                this.pages.registerPage("/mail", function() {
                    return new (0, $83c6fbe919b812f9$export$98018fbb31b537b8)();
                });
                this.pages.registerPage("/publisher", function() {
                    return new (0, $db8c0d2f48b2ae25$export$574699e312ffd9fc)();
                });
                this.pages.registerPage("/helpcenter", function() {
                    return new (0, $b01c73757609a7d8$export$17f3ea6ee3033913)();
                });
                this.pages.registerPage("/service-client", function() {
                    return new (0, $b608fbce79f44631$export$ea798b7c680ee0d5)();
                });
                this.pages.registerPage("/statistics", function() {
                    return new (0, $134535f50b7b8404$export$4f14dbe3a32e74d3)();
                });
                this.pages.registerPage("/schedule", function() {
                    return new (0, $418cf8fbbfbc9db9$export$dad0f9f593647209)();
                });
                this.pages.registerPage("/cgv", function() {
                    return new (0, $fe54d12263e975be$export$fb06d92033ba4bca)();
                });
                this.pages.registerPage("/smartblog", function() {
                    return new (0, $3868289c2c610572$export$d7d15f70146cf1a7)();
                });
                this.pages.registerPage("/ai", function() {
                    return new (0, $5af9bae3614e2ddb$export$aa5b5f3c49dad377)();
                });
                this.pages.registerPage("/autopilot", function() {
                    return new (0, $60a54bb947739012$export$c87593f158eae05c)();
                });
                this.pages.registerPage("/style", function() {
                    return new (0, $aa8e4074a3128741$export$441a0cd60fee079c)();
                });
                this.pages.registerPage("/analysis", function() {
                    return new (0, $91e50878e5d11d16$export$ab7ea9573211da38)();
                });
                this.pages.registerPage("/wix", function() {
                    return new (0, $cb2d6793f7eecd1a$export$a58278a45a3d1e00)();
                });
                this.pages.registerPage("/wordpress", function() {
                    return new (0, $8d423849995d5587$export$3a96fed2f93e0d19)();
                });
                this.pages.registerPage("/shopify", function() {
                    return new (0, $ab4480f67852b6be$export$cb59a6d6d90ba48b)();
                });
                this.pages.registerPage("/prestashop", function() {
                    return new (0, $f9faa03fb7434e07$export$26219a799f10bcc9)();
                });
                this.pages.registerPage("/cgu", function() {
                    return new (0, $89ba3010f6bc10c8$export$2422684a229ca95d)();
                });
                this.pages.registerPage("/policy", function() {
                    return new (0, $9e7e16e1bfaa898c$export$8c2ad8bee15c420d)();
                });
                this.pages.path404 = "/404";
                this.pages.pathHome = "/home";
                this.pages.pathLogin = "/home";
            }
        },
        {
            key: "registerStatic",
            value: function registerStatic() {
                this["static"].register("loader", new (0, $08238b120245f836$export$854fe5f7a33d16c2)());
            }
        },
        {
            key: "onLogin",
            value: function onLogin() {
                this.pages.redirect(this.pages.pathHome);
            }
        },
        {
            key: "onLogout",
            value: function onLogout() {
                var _this = this;
                setTimeout(function() {
                    _this.pages.redirect(_this.pages.pathLogin);
                }, 3000);
            }
        }
    ]);
    return WebsiteRouter;
}((0, $2b52f0ec3a5ceed6$export$d35034d02907e61a));





var $66039daec1c37d8f$export$e9fe003e12bfbc08 = /*#__PURE__*/ function() {
    "use strict";
    function Website() {
        (0, $3CDbU._)(this, Website);
    }
    (0, $jyA4z._)(Website, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var _, _tmp, e;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.router = new (0, $614db50d2a9fb733$export$6c295a1800b38e94)((0, $790bb746928a4e16$export$b25f5cc1eb7681bd).website);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).start(_this.router)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $wYO7b.Resources).init([
                                        _this.router.language()
                                    ], _this.router.languages)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    ,
                                    9
                                ]);
                                _ = Promise.all;
                                return [
                                    4,
                                    (0, $wYO7b.Resources).loadI18n("website")
                                ];
                            case 4:
                                _tmp = [
                                    _state.sent()
                                ];
                                return [
                                    4,
                                    (0, $wYO7b.Resources).loadCountries()
                                ];
                            case 5:
                                _tmp = _tmp.concat([
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    (0, $wYO7b.Resources).loadWorldLanguages()
                                ];
                            case 6:
                                return [
                                    4,
                                    _.apply(Promise, [
                                        _tmp.concat([
                                            _state.sent()
                                        ])
                                    ])
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                e = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                return [
                                    4,
                                    _this.router.init({
                                        defaultLanguage: (0, $wYO7b.Resources).language,
                                        languages: (0, $wYO7b.Resources).languages
                                    })
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Website;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");


var $1LZ0s = parcelRequire("1LZ0s");

var $htL4C = parcelRequire("htL4C");

var $fIUGb = parcelRequire("fIUGb");

var $jaTWB = parcelRequire("jaTWB");

var $8zF1W = parcelRequire("8zF1W");

var $38D2A = parcelRequire("38D2A");

var $lThic = parcelRequire("lThic");


var $eQCFs = parcelRequire("eQCFs");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $4ac02454217e7cf5$export$94079eade4e4655e;
var $4ac02454217e7cf5$export$97691fbb80847c19;
var $4ac02454217e7cf5$export$1ca1ec8b29a4ce27;
var $4ac02454217e7cf5$export$6f093cfa640b7166;
var $4ac02454217e7cf5$export$db3c28d99448dcff;
var $4ac02454217e7cf5$export$351f93dff0fc1e76;
var $4ac02454217e7cf5$export$a8ff84c12d48cfa6;
$4ac02454217e7cf5$export$94079eade4e4655e = "zRLIt";
$4ac02454217e7cf5$export$97691fbb80847c19 = "TKUoI";
$4ac02454217e7cf5$export$1ca1ec8b29a4ce27 = "C2Rxd";
$4ac02454217e7cf5$export$6f093cfa640b7166 = "XP-33";
$4ac02454217e7cf5$export$db3c28d99448dcff = "o8tgT";
$4ac02454217e7cf5$export$351f93dff0fc1e76 = "_7Y2KA";
$4ac02454217e7cf5$export$a8ff84c12d48cfa6 = "hu4NY";





var $co7RM = parcelRequire("co7RM");

var $wYO7b = parcelRequire("wYO7b");
var $f6bb03a8aeeb2fca$export$cb3fc5fbc3cd8ca6 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(EmptyNetworkComponent, Component);
    function EmptyNetworkComponent() {
        (0, $3CDbU._)(this, EmptyNetworkComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, EmptyNetworkComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($4ac02454217e7cf5$export$94079eade4e4655e, '">\n\n                <div style="margin-top:100px;">\n                    <div class="').concat($4ac02454217e7cf5$export$97691fbb80847c19, '">\n                        <div class="').concat($4ac02454217e7cf5$export$1ca1ec8b29a4ce27, '">\n                            ').concat(_this.draw(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).SEDESTRAL)), '\n                        </div>\n                    </div>\n                    <div class="').concat($4ac02454217e7cf5$export$97691fbb80847c19, '">\n                        <div class="').concat($4ac02454217e7cf5$export$6f093cfa640b7166, '">\n                            ').concat((0, $wYO7b.Resources).t("words.unavailableMessage"), '\n                        </div>\n                    </div>\n                    <div class="').concat($4ac02454217e7cf5$export$97691fbb80847c19, '">\n                        <div style="position: relative;height: 80px;width: 100%;">\n                            ').concat(_this.draw(new (0, $13657ca4b0c85698$export$8ed40a6e8d9e757d)()), '\n                        </div>\n                    </div>\n                    <div class="').concat($4ac02454217e7cf5$export$97691fbb80847c19, '">\n                        <div class="').concat($4ac02454217e7cf5$export$db3c28d99448dcff, '">\n                            <div class="').concat($4ac02454217e7cf5$export$351f93dff0fc1e76, '">\n                                ').concat(_this.draw(new (0, $c388cbcac7991775$export$5c3f85cf9710806e)((0, $co7RM.ProductType).SEDESTRAL)), '\n                            </div>\n                            <div class="').concat($4ac02454217e7cf5$export$a8ff84c12d48cfa6, '">\n                                Sedestral\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n        ');
        return _this;
    }
    return EmptyNetworkComponent;
}((0, $9gCL8.Component));



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");
var $7d1bda405ba71b14$export$3aed5f2d684ba248 = /*#__PURE__*/ function() {
    "use strict";
    function WebPushService() {
        (0, $3CDbU._)(this, WebPushService);
    }
    (0, $jyA4z._)(WebPushService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "create",
            value: /**
     * http
     */ function create(currentToken, isMobile, component) {
                return (0, $hWZw8._)(function() {
                    var request, webPush;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).PANEL, "/webpush", {
                                        token: currentToken,
                                        isMobile: isMobile
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    webPush = request.data;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return WebPushService;
}();



var $dmlE6 = parcelRequire("dmlE6");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");
var $44cfe4ccb2bf5021$export$952b839b257f74a4 = /*#__PURE__*/ function(StatisticsSplitType) {
    StatisticsSplitType[StatisticsSplitType["HOUR"] = 1] = "HOUR";
    StatisticsSplitType[StatisticsSplitType["DAY"] = 2] = "DAY";
    StatisticsSplitType[StatisticsSplitType["WEEK"] = 3] = "WEEK";
    StatisticsSplitType[StatisticsSplitType["MONTH"] = 4] = "MONTH";
    return StatisticsSplitType;
}({});



var $wYO7b = parcelRequire("wYO7b");


var $3NRZT = parcelRequire("3NRZT");

var $6hmLA = parcelRequire("6hmLA");

var $3NRZT = parcelRequire("3NRZT");

var $alboN = parcelRequire("alboN");
function $c4589a462e2b906d$export$eb61126ed8585dd(startTime, endTime) {
    var from = (0, $alboN.dateToCompare)(new Date(startTime));
    var to = (0, $alboN.dateToCompare)(new Date(endTime), true);
    var daysCount = (0, $3NRZT.dateCountDaysBetweenDates)(from, to);
    var result = [];
    for(var i = 0; i < daysCount; i++){
        if (from.getDay() == 1) result.push(new Date((0, $alboN.dateToCompare)(from)));
        from.setDate(from.getDate() + 1);
    }
    return result;
}


/**
 * Retourne les codes de mois entre deux dates
 */ 
var $3NRZT = parcelRequire("3NRZT");

var $alboN = parcelRequire("alboN");
function $47a825596506e948$export$dfb4d92304ae9a88(startTime, endTime) {
    var months = [];
    var from = (0, $alboN.dateToCompare)(new Date(startTime));
    var to = (0, $alboN.dateToCompare)(new Date(endTime), true);
    var daysCount = (0, $3NRZT.dateCountDaysBetweenDates)(from, to);
    for(var i = 0; i < daysCount; i++){
        if (months.filter(function(value) {
            return value[0] == from.getFullYear() && value[1] == from.getMonth();
        })[0] == undefined) months.push([
            from.getFullYear(),
            from.getMonth()
        ]);
        from.setDate(from.getDate() + 1);
    }
    return months;
}


/**
 * date format display date
 */ function $0817791a1090c9e1$export$f38b86edb697ac0d(date, language, format) {
    var formatter = new Intl.DateTimeFormat(language, format == undefined ? {
        day: "numeric",
        month: "long",
        year: "numeric"
    } : format);
    return formatter.format(date);
}



var $alboN = parcelRequire("alboN");
/**
 * Retourne retourne l'année et le code de semaine
 */ function $e97495a1a5c56f12$export$2d23e4485b86a497(d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    //console.log(d.getUTCDate() + 4 - (d.getUTCDay() || 2))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 3));
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // @ts-ignore
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return [
        d.getUTCFullYear(),
        weekNo
    ];
}


var $3bf4287f7ed05e66$export$2ba536885b8718d9 = /*#__PURE__*/ function() {
    "use strict";
    function StatisticsService() {
        (0, $3CDbU._)(this, StatisticsService);
    }
    (0, $jyA4z._)(StatisticsService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "cleanValues",
            value: /**
     * values to charts
     */ function cleanValues(values, oldValues) {
                if (oldValues[0].length > values[0].length) oldValues[0].splice(0, oldValues[0].length - values[0].length);
                if (values[0].length > oldValues[0].length) values[0].splice(0, values[0].length - oldValues[0].length);
                return [
                    values,
                    oldValues
                ];
            }
        },
        {
            key: "typeValues",
            value: function typeValues(type, startTime, endTime, values) {
                if (values == undefined) return [
                    [],
                    []
                ];
                switch(type){
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).HOUR:
                        return StatisticsService.hourValues(startTime, endTime, values);
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).WEEK:
                        return StatisticsService.weeksValues(startTime, endTime, values);
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).MONTH:
                        return StatisticsService.monthsValues(startTime, endTime, values);
                }
                return StatisticsService.dayValues(startTime, endTime, values);
            }
        },
        {
            key: "hourValues",
            value: function hourValues(startTime, endTime, values) {
                var _loop = function(i) {
                    var dayDate = new Date(from);
                    for(var h = 0; h < 24; h++){
                        dayDate.setHours(h);
                        if (dayDate.getTime() <= now) {
                            var value = values.find(function(v) {
                                return v.dateKey == dayDate.getTime();
                            });
                            resultValues.push(value == undefined ? 0 : value.value);
                            resultKeys.push(dayDate.getTime());
                        }
                    }
                    from.setDate(from.getDate() + 1);
                };
                var from = (0, $alboN.dateToCompare)(new Date(startTime));
                var to = (0, $alboN.dateToCompare)(new Date(endTime), true);
                var daysCount = (0, $3NRZT.dateCountDaysBetweenDates)(from, to);
                var resultValues = [];
                var resultKeys = [];
                var now = Date.now();
                for(var i = 0; i < daysCount; i++)_loop(i);
                return [
                    resultValues,
                    resultKeys
                ];
            }
        },
        {
            key: "dayValues",
            value: function dayValues(startTime, endTime, values) {
                var entries = {};
                var resultValues = [];
                var resultKeys = [];
                var from = (0, $alboN.dateToCompare)(new Date(startTime));
                var to = (0, $alboN.dateToCompare)(new Date(endTime), true);
                var daysCount = (0, $3NRZT.dateCountDaysBetweenDates)(from, to);
                values.sort(function(a, b) {
                    return a.dateKey > b.dateKey ? 1 : -1;
                });
                values.forEach(function(value) {
                    return entries[(0, $alboN.dateToCompare)(new Date(value.dateKey)).getTime()] = value.value;
                });
                while(resultValues.length < daysCount){
                    resultValues.push(entries[from.getTime()] == undefined ? 0 : entries[from.getTime()]);
                    resultKeys.push(from.getTime());
                    from.setDate(from.getDate() + 1);
                }
                return [
                    resultValues,
                    resultKeys
                ];
            }
        },
        {
            key: "weeksValues",
            value: function weeksValues(startTime, endTime, values) {
                var sundays = (0, $c4589a462e2b906d$export$eb61126ed8585dd)(startTime, endTime);
                var resultValues = [];
                var resultKeys = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var sunday = _step.value;
                        var weekResult = (0, $e97495a1a5c56f12$export$2d23e4485b86a497)(sunday);
                        var value = values.find(function(v) {
                            return v.dateKey == weekResult[0] + weekResult[1];
                        });
                        resultValues.push(value ? value.value : 0);
                        resultKeys.push(sunday.getTime());
                    };
                    for(var _iterator = sundays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    resultValues,
                    resultKeys
                ];
            }
        },
        {
            key: "monthsValues",
            value: function monthsValues(startTime, endTime, values) {
                var months = (0, $47a825596506e948$export$dfb4d92304ae9a88)(startTime, endTime);
                var resultValues = [];
                var resultKeys = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var month = _step.value;
                        var value = values.find(function(v) {
                            return v.dateKey == month[0] + month[1];
                        });
                        resultValues.push(value ? value.value : 0);
                        resultKeys.push(new Date(month[0], month[1]).getTime());
                    };
                    for(var _iterator = months[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    resultValues,
                    resultKeys
                ];
            }
        },
        {
            key: "valueFormat",
            value: /**
     * format
     */ function valueFormat(date, type) {
                switch(type){
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).DAY:
                        return (0, $0817791a1090c9e1$export$f38b86edb697ac0d)(date, (0, $wYO7b.Resources).language, {
                            month: "short",
                            day: "numeric",
                            year: "numeric"
                        });
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).MONTH:
                        return (0, $0817791a1090c9e1$export$f38b86edb697ac0d)(date, (0, $wYO7b.Resources).language, {
                            month: "short",
                            year: "numeric"
                        });
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).WEEK:
                        var endDate = new Date(date);
                        endDate.setDate(endDate.getDate() + 7);
                        return (0, $0817791a1090c9e1$export$f38b86edb697ac0d)(date, (0, $wYO7b.Resources).language, {
                            month: "short",
                            day: "numeric"
                        }) + " - " + (0, $0817791a1090c9e1$export$f38b86edb697ac0d)(endDate, (0, $wYO7b.Resources).language, {
                            month: "short",
                            day: "numeric"
                        });
                    case (0, $44cfe4ccb2bf5021$export$952b839b257f74a4).HOUR:
                        date.setMinutes(0);
                        return (0, $c9c1c4776943ab22$export$1aac387c4ed0273c)(date);
                }
            }
        },
        {
            key: "startTime",
            value: /**
     * time
     */ function startTime(previousDays) {
                return (0, $alboN.dateToCompare)((0, $6hmLA.datePrevious)(previousDays)).getTime();
            }
        },
        {
            key: "endTime",
            value: function endTime(startTime) {
                if (startTime) {
                    var date = new Date(startTime);
                    date.setDate(date.getDate() - 1);
                    return (0, $alboN.dateToCompare)(date, true).getTime();
                } else return (0, $alboN.dateToCompare)(new Date(), true).getTime();
            }
        }
    ]);
    return StatisticsService;
}();




var $1cwwH = parcelRequire("1cwwH");

var $8FuDB = parcelRequire("8FuDB");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $1cwwH = parcelRequire("1cwwH");

var $gpm9v = parcelRequire("gpm9v");

var $lThic = parcelRequire("lThic");
var $97d6e5c8b4e5da89$export$bcc04e5ab52ff38 = /*#__PURE__*/ function() {
    "use strict";
    function PermissionsService() {
        (0, $3CDbU._)(this, PermissionsService);
    }
    (0, $jyA4z._)(PermissionsService, null, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "admin",
            value: function admin() {
                return (0, $1cwwH.RoleService).can((0, $gpm9v.RolePermissionsType).ADMINISTRATOR);
            }
        },
        {
            key: "blogWriting",
            value: function blogWriting() {
                return (0, $1cwwH.RoleService).can((0, $gpm9v.RolePermissionsType).BLOG_WRITING, (0, $gpm9v.RolePermissionsType).BLOG_ADMINISTRATOR, (0, $gpm9v.RolePermissionsType).BLOG_PUBLISH);
            }
        },
        {
            key: "blogLoad",
            value: function blogLoad() {
                return (0, $1cwwH.RoleService).can((0, $gpm9v.RolePermissionsType).BLOG_READING, (0, $gpm9v.RolePermissionsType).BLOG_WRITING, (0, $gpm9v.RolePermissionsType).BLOG_ADMINISTRATOR, (0, $gpm9v.RolePermissionsType).BLOG_PUBLISH);
            }
        },
        {
            key: "helpcenterWriting",
            value: function helpcenterWriting() {
                return (0, $1cwwH.RoleService).can((0, $gpm9v.RolePermissionsType).HELPCENTER_WRITING, (0, $gpm9v.RolePermissionsType).HELPCENTER_ADMINISTRATOR, (0, $gpm9v.RolePermissionsType).HELPCENTER_PUBLISH);
            }
        },
        {
            key: "canProduct",
            value: /**
     * product
     */ function canProduct(type) {
                if (!(0, $lThic.EntityService).activeSite) return false;
                return (0, $lThic.EntityService).activeSite.products.includes(type);
            }
        },
        {
            key: "d",
            value: /**
     * utilities
     */ function d(permission) {
                return permission ? "" : "display:none;";
            }
        },
        {
            key: "o",
            value: function o(permission) {
                return permission ? "" : "opacity:0.3;pointer-events:none;";
            }
        }
    ]);
    return PermissionsService;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $78NO5 = parcelRequire("78NO5");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $3Qm5T = parcelRequire("3Qm5T");

var $7WDX1 = parcelRequire("7WDX1");

var $8GOyH = parcelRequire("8GOyH");

var $fIUGb = parcelRequire("fIUGb");

var $3PS2c = parcelRequire("3PS2c");

var $38D2A = parcelRequire("38D2A");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $fEm89 = parcelRequire("fEm89");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $cgG2i = parcelRequire("cgG2i");

var $hiGMu = parcelRequire("hiGMu");

var $bN2zx = parcelRequire("bN2zx");

var $78NO5 = parcelRequire("78NO5");

var $7tffA = parcelRequire("7tffA");

var $eJDpD = parcelRequire("eJDpD");
/**
 * Observable class prototype.
 *
 * @module observable
 */ 
var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $78NO5 = parcelRequire("78NO5");

var $89wqq = parcelRequire("89wqq");

var $kgvSK = parcelRequire("kgvSK");

var $397ju = parcelRequire("397ju");
var $b78261e7e572625c$export$e23d3436ce401adc = /*#__PURE__*/ function() {
    "use strict";
    function ObservableV2() {
        (0, $3CDbU._)(this, ObservableV2);
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $89wqq.create();
    }
    (0, $jyA4z._)(ObservableV2, [
        {
            /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ key: "on",
            value: function on(name, f) {
                $89wqq.setIfUndefined(this._observers, /** @type {string} */ name, $kgvSK.create).add(f);
                return f;
            }
        },
        {
            /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ key: "once",
            value: function once(name, f) {
                var _this = this;
                /**
     * @param  {...any} args
     */ var _f = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    _this.off(name, /** @type {any} */ _f);
                    f.apply(void 0, (0, $78NO5._)(args));
                };
                this.on(name, /** @type {any} */ _f);
            }
        },
        {
            /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ key: "off",
            value: function off(name, f) {
                var observers = this._observers.get(name);
                if (observers !== undefined) {
                    observers["delete"](f);
                    if (observers.size === 0) this._observers["delete"](name);
                }
            }
        },
        {
            /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ key: "emit",
            value: function emit(name, args) {
                // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
                return $397ju.from((this._observers.get(name) || $89wqq.create()).values()).forEach(function(f) {
                    return f.apply(void 0, (0, $78NO5._)(args));
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._observers = $89wqq.create();
            }
        }
    ]);
    return ObservableV2;
}();
var $b78261e7e572625c$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function Observable() {
        (0, $3CDbU._)(this, Observable);
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $89wqq.create();
    }
    (0, $jyA4z._)(Observable, [
        {
            /**
   * @param {N} name
   * @param {function} f
   */ key: "on",
            value: function on(name, f) {
                $89wqq.setIfUndefined(this._observers, name, $kgvSK.create).add(f);
            }
        },
        {
            /**
   * @param {N} name
   * @param {function} f
   */ key: "once",
            value: function once(name, f) {
                var _this = this;
                /**
     * @param  {...any} args
     */ var _f = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    _this.off(name, _f);
                    f.apply(void 0, (0, $78NO5._)(args));
                };
                this.on(name, _f);
            }
        },
        {
            /**
   * @param {N} name
   * @param {function} f
   */ key: "off",
            value: function off(name, f) {
                var observers = this._observers.get(name);
                if (observers !== undefined) {
                    observers["delete"](f);
                    if (observers.size === 0) this._observers["delete"](name);
                }
            }
        },
        {
            /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ key: "emit",
            value: function emit(name, args) {
                // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
                return $397ju.from((this._observers.get(name) || $89wqq.create()).values()).forEach(function(f) {
                    return f.apply(void 0, (0, $78NO5._)(args));
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._observers = $89wqq.create();
            }
        }
    ]);
    return Observable;
} /* c8 ignore end */ ();



var $397ju = parcelRequire("397ju");

var $02E42 = parcelRequire("02E42");

var $89wqq = parcelRequire("89wqq");
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");

var $7tffA = parcelRequire("7tffA");

var $02E42 = parcelRequire("02E42");
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
var $02E42 = parcelRequire("02E42");
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ var $eab0623b6aed22da$export$ee2c6657cb286da4 = 1;
var $eab0623b6aed22da$export$1f117f3b0edc2676 = 2;
var $eab0623b6aed22da$export$e5294f8c78cf7711 = 4;
var $eab0623b6aed22da$export$873ae8db4cef5125 = 8;
var $eab0623b6aed22da$export$b6e6496517dfbd31 = 16;
var $eab0623b6aed22da$export$daf23f774967089 = 32;
var $eab0623b6aed22da$export$eb5a8e0006ab4bb5 = 64;
var $eab0623b6aed22da$export$e25597372303a045 = 128;
var $eab0623b6aed22da$export$f15587807021fe79 = 256;
var $eab0623b6aed22da$export$70939d57ba836c5 = 512;
var $eab0623b6aed22da$export$9ec47920d80e8c85 = 1024;
var $eab0623b6aed22da$export$bc5dd16b35d4584b = 2048;
var $eab0623b6aed22da$export$76a85e893e6d6ecc = 4096;
var $eab0623b6aed22da$export$fb6ca64a3ffa3aa9 = 8192;
var $eab0623b6aed22da$export$e7adc86ee9ea4b00 = 16384;
var $eab0623b6aed22da$export$6aa68b9346d558bb = 32768;
var $eab0623b6aed22da$export$5d7aab37466c79ea = 65536;
var $eab0623b6aed22da$export$3aa401309ff3940 = 131072;
var $eab0623b6aed22da$export$1fd8467d3320465f = 262144;
var $eab0623b6aed22da$export$d1dceb84a396f684 = 524288;
var $eab0623b6aed22da$export$ef62e7729d79baec = 1048576;
var $eab0623b6aed22da$export$40651ae3846a7710 = 2097152;
var $eab0623b6aed22da$export$e03976987cb0b818 = 4194304;
var $eab0623b6aed22da$export$dd5dceb22223d8ef = 8388608;
var $eab0623b6aed22da$export$aecaefba6ae044e4 = 16777216;
var $eab0623b6aed22da$export$6e47d6f6c411c0e1 = 33554432;
var $eab0623b6aed22da$export$321a8fda0150a18 = 67108864;
var $eab0623b6aed22da$export$d7843230fff08622 = 134217728;
var $eab0623b6aed22da$export$9fe7219cb72d1ed8 = 268435456;
var $eab0623b6aed22da$export$c85121a54e1cc97f = 536870912;
var $eab0623b6aed22da$export$76075a64dc7c21ef = 1073741824;
var $eab0623b6aed22da$export$49d5cdcf29800e09 = -2147483648;
var $eab0623b6aed22da$export$853d99058378c102 = 0;
var $eab0623b6aed22da$export$b859c32a415b3ec1 = 1;
var $eab0623b6aed22da$export$decefe6957191373 = 3;
var $eab0623b6aed22da$export$d1defff3cbd2c6f4 = 7;
var $eab0623b6aed22da$export$8d2b432c8c02ae65 = 15;
var $eab0623b6aed22da$export$bc2aba63e4099c09 = 31;
var $eab0623b6aed22da$export$f39f4e074e983a34 = 63;
var $eab0623b6aed22da$export$f84d6bebff154ceb = 127;
var $eab0623b6aed22da$export$c880072ee0e87648 = 255;
var $eab0623b6aed22da$export$cbbfa5d3c076ad8c = 511;
var $eab0623b6aed22da$export$e365aa75b5fa7293 = 1023;
var $eab0623b6aed22da$export$51bfc23c1b7b60c3 = 2047;
var $eab0623b6aed22da$export$3b0a099b88523ac = 4095;
var $eab0623b6aed22da$export$8345c1c06d3e5fc1 = 8191;
var $eab0623b6aed22da$export$e20cffba663a7688 = 16383;
var $eab0623b6aed22da$export$cd0970fd37b207c6 = 32767;
var $eab0623b6aed22da$export$250487b182389b6a = 65535;
var $eab0623b6aed22da$export$9d6e01d73abdaadb = $eab0623b6aed22da$export$3aa401309ff3940 - 1;
var $eab0623b6aed22da$export$eedeab0ac4009664 = $eab0623b6aed22da$export$1fd8467d3320465f - 1;
var $eab0623b6aed22da$export$e1840c3c33a76ffc = $eab0623b6aed22da$export$d1dceb84a396f684 - 1;
var $eab0623b6aed22da$export$f0ae3ba8312e92e3 = $eab0623b6aed22da$export$ef62e7729d79baec - 1;
var $eab0623b6aed22da$export$b5ffbef7f0f6f536 = $eab0623b6aed22da$export$40651ae3846a7710 - 1;
var $eab0623b6aed22da$export$33ae34bc8e747862 = $eab0623b6aed22da$export$e03976987cb0b818 - 1;
var $eab0623b6aed22da$export$3629272792e6a9a0 = $eab0623b6aed22da$export$dd5dceb22223d8ef - 1;
var $eab0623b6aed22da$export$a07300a4cc2ba23c = $eab0623b6aed22da$export$aecaefba6ae044e4 - 1;
var $eab0623b6aed22da$export$9137f2824b26e02b = $eab0623b6aed22da$export$6e47d6f6c411c0e1 - 1;
var $eab0623b6aed22da$export$94d4c3aa7cfbb8dd = $eab0623b6aed22da$export$321a8fda0150a18 - 1;
var $eab0623b6aed22da$export$8af89455097efce0 = $eab0623b6aed22da$export$d7843230fff08622 - 1;
var $eab0623b6aed22da$export$dee9196bb8567fe9 = $eab0623b6aed22da$export$9fe7219cb72d1ed8 - 1;
var $eab0623b6aed22da$export$bd0b5ef1d89e90f = $eab0623b6aed22da$export$c85121a54e1cc97f - 1;
var $eab0623b6aed22da$export$e5560e011efa8766 = $eab0623b6aed22da$export$76075a64dc7c21ef - 1;
var $eab0623b6aed22da$export$87ec42487f19c66c = 0x7FFFFFFF;
var $eab0623b6aed22da$export$3ea07c5174cba08a = 0xFFFFFFFF;


var $fd61ae8e5cc2fe78$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
var $fd61ae8e5cc2fe78$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
var $fd61ae8e5cc2fe78$export$7accc3db8e859605 = -2147483648;
var $fd61ae8e5cc2fe78$export$a5f353c3c14c00d0 = $eab0623b6aed22da$export$87ec42487f19c66c;
var $fd61ae8e5cc2fe78$export$f055c566d4c0f541 = $eab0623b6aed22da$export$3ea07c5174cba08a;
var $fd61ae8e5cc2fe78$export$a287f47fed4544b8 = Number.isInteger || function(num) {
    return typeof num === 'number' && isFinite(num) && $02E42.floor(num) === num;
};
var $fd61ae8e5cc2fe78$export$c9f5652083b8129d = Number.isNaN;
var $fd61ae8e5cc2fe78$export$5f87784a266e50a4 = Number.parseInt;
var $fd61ae8e5cc2fe78$export$33de6ea056a4cdbb = function(n) {
    n &= $eab0623b6aed22da$export$3ea07c5174cba08a;
    var count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};




var $80Ijr = parcelRequire("80Ijr");

var $397ju = parcelRequire("397ju");
var $917f0b264ff88d53$export$a50aceb0e02a00aa = function Encoder() {
    "use strict";
    (0, $3CDbU._)(this, Encoder);
    this.cpos = 0;
    this.cbuf = new Uint8Array(100);
    /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
};
var $917f0b264ff88d53$export$4e76eeb6df88c889 = function() {
    return new $917f0b264ff88d53$export$a50aceb0e02a00aa();
};
var $917f0b264ff88d53$export$c564cdbbe6da493 = function(f) {
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    f(encoder);
    return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
};
var $917f0b264ff88d53$export$f24224f1c91d8156 = function(encoder) {
    var len = encoder.cpos;
    for(var i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
var $917f0b264ff88d53$export$7ad75c69830b76d7 = function(encoder) {
    return encoder.cpos > 0 || encoder.bufs.length > 0;
};
var $917f0b264ff88d53$export$73470fd2221e6aef = function(encoder) {
    var uint8arr = new Uint8Array($917f0b264ff88d53$export$f24224f1c91d8156(encoder));
    var curPos = 0;
    for(var i = 0; i < encoder.bufs.length; i++){
        var d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
var $917f0b264ff88d53$export$39fb588b9aff60c5 = function(encoder, len) {
    var bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($02E42.max(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
var $917f0b264ff88d53$export$68d8715fc104d294 = function(encoder, num) {
    var bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
var $917f0b264ff88d53$export$adaa4cf7ef1b65be = function(encoder, pos, num) {
    var buffer = null;
    // iterate all buffers and adjust position
    for(var i = 0; i < encoder.bufs.length && buffer === null; i++){
        var b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
var $917f0b264ff88d53$export$826a1a6619653272 = $917f0b264ff88d53$export$68d8715fc104d294;
var $917f0b264ff88d53$export$83964ea8501fbf8 = $917f0b264ff88d53$export$adaa4cf7ef1b65be;
var $917f0b264ff88d53$export$ba6b74b6f3145a00 = function(encoder, num) {
    $917f0b264ff88d53$export$68d8715fc104d294(encoder, num & $eab0623b6aed22da$export$c880072ee0e87648);
    $917f0b264ff88d53$export$68d8715fc104d294(encoder, num >>> 8 & $eab0623b6aed22da$export$c880072ee0e87648);
};
var $917f0b264ff88d53$export$f86e1edc3d839287 = function(encoder, pos, num) {
    $917f0b264ff88d53$export$adaa4cf7ef1b65be(encoder, pos, num & $eab0623b6aed22da$export$c880072ee0e87648);
    $917f0b264ff88d53$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $eab0623b6aed22da$export$c880072ee0e87648);
};
var $917f0b264ff88d53$export$835343b0f7799f5b = function(encoder, num) {
    for(var i = 0; i < 4; i++){
        $917f0b264ff88d53$export$68d8715fc104d294(encoder, num & $eab0623b6aed22da$export$c880072ee0e87648);
        num >>>= 8;
    }
};
var $917f0b264ff88d53$export$efed0d8c16230d13 = function(encoder, num) {
    for(var i = 3; i >= 0; i--)$917f0b264ff88d53$export$68d8715fc104d294(encoder, num >>> 8 * i & $eab0623b6aed22da$export$c880072ee0e87648);
};
var $917f0b264ff88d53$export$5517b6394fc440fb = function(encoder, pos, num) {
    for(var i = 0; i < 4; i++){
        $917f0b264ff88d53$export$adaa4cf7ef1b65be(encoder, pos + i, num & $eab0623b6aed22da$export$c880072ee0e87648);
        num >>>= 8;
    }
};
var $917f0b264ff88d53$export$872f48c75febcd2b = function(encoder, num) {
    while(num > $eab0623b6aed22da$export$f84d6bebff154ceb){
        $917f0b264ff88d53$export$68d8715fc104d294(encoder, $eab0623b6aed22da$export$e25597372303a045 | $eab0623b6aed22da$export$f84d6bebff154ceb & num);
        num = $02E42.floor(num / 128) // shift >>> 7
        ;
    }
    $917f0b264ff88d53$export$68d8715fc104d294(encoder, $eab0623b6aed22da$export$f84d6bebff154ceb & num);
};
var $917f0b264ff88d53$export$ff90f819e16cc9bb = function(encoder, num) {
    var isNegative = $02E42.isNegativeZero(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $917f0b264ff88d53$export$68d8715fc104d294(encoder, (num > $eab0623b6aed22da$export$f39f4e074e983a34 ? $eab0623b6aed22da$export$e25597372303a045 : 0) | (isNegative ? $eab0623b6aed22da$export$eb5a8e0006ab4bb5 : 0) | $eab0623b6aed22da$export$f39f4e074e983a34 & num);
    num = $02E42.floor(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $917f0b264ff88d53$export$68d8715fc104d294(encoder, (num > $eab0623b6aed22da$export$f84d6bebff154ceb ? $eab0623b6aed22da$export$e25597372303a045 : 0) | $eab0623b6aed22da$export$f84d6bebff154ceb & num);
        num = $02E42.floor(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ var $917f0b264ff88d53$var$_strBuffer = new Uint8Array(30000);
var $917f0b264ff88d53$var$_maxStrBSize = $917f0b264ff88d53$var$_strBuffer.length / 3;
var $917f0b264ff88d53$export$dff327976627e12b = function(encoder, str) {
    if (str.length < $917f0b264ff88d53$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ var written = $80Ijr.utf8TextEncoder.encodeInto(str, $917f0b264ff88d53$var$_strBuffer).written || 0;
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, written);
        for(var i = 0; i < written; i++)$917f0b264ff88d53$export$68d8715fc104d294(encoder, $917f0b264ff88d53$var$_strBuffer[i]);
    } else $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $80Ijr.encodeUtf8(str));
};
var $917f0b264ff88d53$export$94cf4193edfe959a = function(encoder, str) {
    var encodedString = unescape(encodeURIComponent(str));
    var len = encodedString.length;
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, len);
    for(var i = 0; i < len; i++)$917f0b264ff88d53$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
var $917f0b264ff88d53$export$dde49cb52d5f1650 = $80Ijr.utf8TextEncoder && /** @type {any} */ $80Ijr.utf8TextEncoder.encodeInto ? $917f0b264ff88d53$export$dff327976627e12b : $917f0b264ff88d53$export$94cf4193edfe959a;
var $917f0b264ff88d53$export$be5604ffb9fbbd0c = function(encoder, str) {
    return $917f0b264ff88d53$export$6c17d6eec4abdaa6(encoder, $80Ijr.encodeUtf8(str));
};
var $917f0b264ff88d53$export$6c17d6eec4abdaa6 = function(encoder, buf) {
    for(var i = 0; i < buf.length; i++){
        var b = buf[i];
        if (b === 0 || b === 1) $917f0b264ff88d53$export$68d8715fc104d294(encoder, 1);
        $917f0b264ff88d53$export$68d8715fc104d294(encoder, buf[i]);
    }
    $917f0b264ff88d53$export$68d8715fc104d294(encoder, 0);
};
var $917f0b264ff88d53$export$c029b62321ea3da = function(encoder, append) {
    return $917f0b264ff88d53$export$73b5e63e27d2b4c7(encoder, $917f0b264ff88d53$export$73470fd2221e6aef(append));
};
var $917f0b264ff88d53$export$73b5e63e27d2b4c7 = function(encoder, uint8Array) {
    var bufferLen = encoder.cbuf.length;
    var cpos = encoder.cpos;
    var leftCopyLen = $02E42.min(bufferLen - cpos, uint8Array.length);
    var rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($02E42.max(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
var $917f0b264ff88d53$export$f7d11515275e88a2 = function(encoder, uint8Array) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $917f0b264ff88d53$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
var $917f0b264ff88d53$export$1f031ae9c71bd530 = function(encoder, len) {
    $917f0b264ff88d53$export$39fb588b9aff60c5(encoder, len);
    var dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
var $917f0b264ff88d53$export$a33455db0a9638a6 = function(encoder, num) {
    return $917f0b264ff88d53$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
};
var $917f0b264ff88d53$export$231a04cea676c54c = function(encoder, num) {
    return $917f0b264ff88d53$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
};
var $917f0b264ff88d53$export$4fbfa93dd6e14543 = function(encoder, num) {
    return /** @type {any} */ $917f0b264ff88d53$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
};
var $917f0b264ff88d53$export$663ca46034903888 = function(encoder, num) {
    return /** @type {any} */ $917f0b264ff88d53$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
};
var $917f0b264ff88d53$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ var $917f0b264ff88d53$var$isFloat32 = function(num) {
    $917f0b264ff88d53$var$floatTestBed.setFloat32(0, num);
    return $917f0b264ff88d53$var$floatTestBed.getFloat32(0) === num;
};
var $917f0b264ff88d53$export$264b1e8551468ea = function(encoder, data) {
    switch(typeof data === "undefined" ? "undefined" : (0, $7tffA._)(data)){
        case 'string':
            // TYPE 119: STRING
            $917f0b264ff88d53$export$68d8715fc104d294(encoder, 119);
            $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, data);
            break;
        case 'number':
            if ($fd61ae8e5cc2fe78$export$a287f47fed4544b8(data) && $02E42.abs(data) <= $eab0623b6aed22da$export$87ec42487f19c66c) {
                // TYPE 125: INTEGER
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 125);
                $917f0b264ff88d53$export$ff90f819e16cc9bb(encoder, data);
            } else if ($917f0b264ff88d53$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 124);
                $917f0b264ff88d53$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 123);
                $917f0b264ff88d53$export$231a04cea676c54c(encoder, data);
            }
            break;
        case 'bigint':
            // TYPE 122: BigInt
            $917f0b264ff88d53$export$68d8715fc104d294(encoder, 122);
            $917f0b264ff88d53$export$4fbfa93dd6e14543(encoder, data);
            break;
        case 'object':
            if (data === null) // TYPE 126: null
            $917f0b264ff88d53$export$68d8715fc104d294(encoder, 126);
            else if ($397ju.isArray(data)) {
                // TYPE 117: Array
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 117);
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, data.length);
                for(var i = 0; i < data.length; i++)$917f0b264ff88d53$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 116);
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $917f0b264ff88d53$export$68d8715fc104d294(encoder, 118);
                var keys = Object.keys(data);
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, keys.length);
                for(var i1 = 0; i1 < keys.length; i1++){
                    var key = keys[i1];
                    $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, key);
                    $917f0b264ff88d53$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case 'boolean':
            // TYPE 120/121: boolean (true/false)
            $917f0b264ff88d53$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $917f0b264ff88d53$export$68d8715fc104d294(encoder, 127);
    }
};
var $917f0b264ff88d53$export$8fa72bb4fa9409ff = /*#__PURE__*/ function(Encoder) {
    "use strict";
    (0, $jCmGC._)(RleEncoder, Encoder);
    function RleEncoder(writer) {
        (0, $3CDbU._)(this, RleEncoder);
        var _this;
        _this = (0, $ep9cZ._)(this, RleEncoder);
        /**
     * The writer
     */ _this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ _this.s = null;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(RleEncoder, [
        {
            /**
   * @param {T} v
   */ key: "write",
            value: function write(v) {
                if (this.s === v) this.count++;
                else {
                    if (this.count > 0) // flush counter, unless this is the first value (count = 0)
                    $917f0b264ff88d53$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
                    ;
                    this.count = 1;
                    // write first value
                    this.w(this, v);
                    this.s = v;
                }
            }
        }
    ]);
    return RleEncoder;
}($917f0b264ff88d53$export$a50aceb0e02a00aa);
var $917f0b264ff88d53$export$c636f3fa46f2752c = /*#__PURE__*/ function(Encoder) {
    "use strict";
    (0, $jCmGC._)(IntDiffEncoder, Encoder);
    function IntDiffEncoder(start) {
        (0, $3CDbU._)(this, IntDiffEncoder);
        var _this;
        _this = (0, $ep9cZ._)(this, IntDiffEncoder);
        /**
     * Current state
     * @type {number}
     */ _this.s = start;
        return _this;
    }
    (0, $jyA4z._)(IntDiffEncoder, [
        {
            /**
   * @param {number} v
   */ key: "write",
            value: function write(v) {
                $917f0b264ff88d53$export$ff90f819e16cc9bb(this, v - this.s);
                this.s = v;
            }
        }
    ]);
    return IntDiffEncoder;
}($917f0b264ff88d53$export$a50aceb0e02a00aa);
var $917f0b264ff88d53$export$29917ece4cb403fb = /*#__PURE__*/ function(Encoder) {
    "use strict";
    (0, $jCmGC._)(RleIntDiffEncoder, Encoder);
    function RleIntDiffEncoder(start) {
        (0, $3CDbU._)(this, RleIntDiffEncoder);
        var _this;
        _this = (0, $ep9cZ._)(this, RleIntDiffEncoder);
        /**
     * Current state
     * @type {number}
     */ _this.s = start;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(RleIntDiffEncoder, [
        {
            /**
   * @param {number} v
   */ key: "write",
            value: function write(v) {
                if (this.s === v && this.count > 0) this.count++;
                else {
                    if (this.count > 0) // flush counter, unless this is the first value (count = 0)
                    $917f0b264ff88d53$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
                    ;
                    this.count = 1;
                    // write first value
                    $917f0b264ff88d53$export$ff90f819e16cc9bb(this, v - this.s);
                    this.s = v;
                }
            }
        }
    ]);
    return RleIntDiffEncoder;
}($917f0b264ff88d53$export$a50aceb0e02a00aa);
/**
 * @param {UintOptRleEncoder} encoder
 */ var $917f0b264ff88d53$var$flushUintOptRleEncoder = function(encoder) {
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $917f0b264ff88d53$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $917f0b264ff88d53$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
var $917f0b264ff88d53$export$785ebd3312c38061 = /*#__PURE__*/ function() {
    "use strict";
    function UintOptRleEncoder() {
        (0, $3CDbU._)(this, UintOptRleEncoder);
        this.encoder = new $917f0b264ff88d53$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    (0, $jyA4z._)(UintOptRleEncoder, [
        {
            /**
   * @param {number} v
   */ key: "write",
            value: function write(v) {
                if (this.s === v) this.count++;
                else {
                    $917f0b264ff88d53$var$flushUintOptRleEncoder(this);
                    this.count = 1;
                    this.s = v;
                }
            }
        },
        {
            /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ key: "toUint8Array",
            value: function toUint8Array1() {
                $917f0b264ff88d53$var$flushUintOptRleEncoder(this);
                return $917f0b264ff88d53$export$73470fd2221e6aef(this.encoder);
            }
        }
    ]);
    return UintOptRleEncoder;
}();
var $917f0b264ff88d53$export$f460a01fb0702193 = /*#__PURE__*/ function() {
    "use strict";
    function IncUintOptRleEncoder() {
        (0, $3CDbU._)(this, IncUintOptRleEncoder);
        this.encoder = new $917f0b264ff88d53$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    (0, $jyA4z._)(IncUintOptRleEncoder, [
        {
            /**
   * @param {number} v
   */ key: "write",
            value: function write(v) {
                if (this.s + this.count === v) this.count++;
                else {
                    $917f0b264ff88d53$var$flushUintOptRleEncoder(this);
                    this.count = 1;
                    this.s = v;
                }
            }
        },
        {
            /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ key: "toUint8Array",
            value: function toUint8Array1() {
                $917f0b264ff88d53$var$flushUintOptRleEncoder(this);
                return $917f0b264ff88d53$export$73470fd2221e6aef(this.encoder);
            }
        }
    ]);
    return IncUintOptRleEncoder;
}();
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ var $917f0b264ff88d53$var$flushIntDiffOptRleEncoder = function(encoder) {
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        var encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $917f0b264ff88d53$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $917f0b264ff88d53$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
var $917f0b264ff88d53$export$7542c66a59375c6f = /*#__PURE__*/ function() {
    "use strict";
    function IntDiffOptRleEncoder() {
        (0, $3CDbU._)(this, IntDiffOptRleEncoder);
        this.encoder = new $917f0b264ff88d53$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    (0, $jyA4z._)(IntDiffOptRleEncoder, [
        {
            /**
   * @param {number} v
   */ key: "write",
            value: function write(v) {
                if (this.diff === v - this.s) {
                    this.s = v;
                    this.count++;
                } else {
                    $917f0b264ff88d53$var$flushIntDiffOptRleEncoder(this);
                    this.count = 1;
                    this.diff = v - this.s;
                    this.s = v;
                }
            }
        },
        {
            /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ key: "toUint8Array",
            value: function toUint8Array1() {
                $917f0b264ff88d53$var$flushIntDiffOptRleEncoder(this);
                return $917f0b264ff88d53$export$73470fd2221e6aef(this.encoder);
            }
        }
    ]);
    return IntDiffOptRleEncoder;
}();
var $917f0b264ff88d53$export$7dcdc5c32f31c550 = /*#__PURE__*/ function() {
    "use strict";
    function StringEncoder() {
        (0, $3CDbU._)(this, StringEncoder);
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = '';
        this.lensE = new $917f0b264ff88d53$export$785ebd3312c38061();
    }
    (0, $jyA4z._)(StringEncoder, [
        {
            /**
   * @param {string} string
   */ key: "write",
            value: function write(string) {
                this.s += string;
                if (this.s.length > 19) {
                    this.sarr.push(this.s);
                    this.s = '';
                }
                this.lensE.write(string.length);
            }
        },
        {
            key: "toUint8Array",
            value: function toUint8Array1() {
                var encoder = new $917f0b264ff88d53$export$a50aceb0e02a00aa();
                this.sarr.push(this.s);
                this.s = '';
                $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, this.sarr.join(''));
                $917f0b264ff88d53$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
                return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
            }
        }
    ]);
    return StringEncoder;
}();


/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 
var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $jCmGC = parcelRequire("jCmGC");


var $02E42 = parcelRequire("02E42");


var $80Ijr = parcelRequire("80Ijr");
/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ var $4338d6312e5ee7d6$export$185802fd694ee1f5 = function(s) {
    return new Error(s);
};
var $4338d6312e5ee7d6$export$73ced5c7e10d6d0f = function() {
    throw $4338d6312e5ee7d6$export$185802fd694ee1f5('Method unimplemented');
};
var $4338d6312e5ee7d6$export$965b6bccecbd9673 = function() {
    throw $4338d6312e5ee7d6$export$185802fd694ee1f5('Unexpected case');
};



var $182bfc4830c83d2c$var$errorUnexpectedEndOfArray = $4338d6312e5ee7d6$export$185802fd694ee1f5('Unexpected end of array');
var $182bfc4830c83d2c$var$errorIntegerOutOfRange = $4338d6312e5ee7d6$export$185802fd694ee1f5('Integer out of Range');
var $182bfc4830c83d2c$export$f9de6ca0bc043724 = function Decoder(uint8Array) {
    "use strict";
    (0, $3CDbU._)(this, Decoder);
    /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
    /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
};
var $182bfc4830c83d2c$export$f8c898e83b60faaa = function(uint8Array) {
    return new $182bfc4830c83d2c$export$f9de6ca0bc043724(uint8Array);
};
var $182bfc4830c83d2c$export$7ad75c69830b76d7 = function(decoder) {
    return decoder.pos !== decoder.arr.length;
};
var $182bfc4830c83d2c$export$9cd59f9826255e47 = function(decoder) {
    var newPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : decoder.pos;
    var _decoder = $182bfc4830c83d2c$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
var $182bfc4830c83d2c$export$e21b2fe168d56a89 = function(decoder, len) {
    var view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
var $182bfc4830c83d2c$export$7418bbc18dee40f3 = function(decoder) {
    return $182bfc4830c83d2c$export$e21b2fe168d56a89(decoder, $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder));
};
var $182bfc4830c83d2c$export$8c9f57cb3e3e2d3b = function(decoder) {
    return $182bfc4830c83d2c$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
};
var $182bfc4830c83d2c$export$228a9507fbdfcdb6 = function(decoder) {
    return decoder.pos++;
};
var $182bfc4830c83d2c$export$d5778a2beba4ceef = function(decoder) {
    return decoder.arr[decoder.pos++];
};
var $182bfc4830c83d2c$export$ef14636f4cf20706 = function(decoder) {
    var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
var $182bfc4830c83d2c$export$967c96218130b9ba = function(decoder) {
    var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
var $182bfc4830c83d2c$export$adb88b5d4ab91f4e = function(decoder) {
    var uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
var $182bfc4830c83d2c$export$c6eca102d0b41ca0 = function(decoder) {
    return decoder.arr[decoder.pos];
};
var $182bfc4830c83d2c$export$e5eb1e52afa13f8d = function(decoder) {
    return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
};
var $182bfc4830c83d2c$export$67e54e775d28f9ae = function(decoder) {
    return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
};
var $182bfc4830c83d2c$export$5a476e4dbe7923d5 = function(decoder) {
    var num = 0;
    var mult = 1;
    var len = decoder.arr.length;
    while(decoder.pos < len){
        var r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $eab0623b6aed22da$export$f84d6bebff154ceb) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $eab0623b6aed22da$export$e25597372303a045) return num;
        /* c8 ignore start */ if (num > $fd61ae8e5cc2fe78$export$18510406f204a1b9) throw $182bfc4830c83d2c$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $182bfc4830c83d2c$var$errorUnexpectedEndOfArray;
};
var $182bfc4830c83d2c$export$1dd5b9ddf6575ae8 = function(decoder) {
    var r = decoder.arr[decoder.pos++];
    var num = r & $eab0623b6aed22da$export$f39f4e074e983a34;
    var mult = 64;
    var sign = (r & $eab0623b6aed22da$export$eb5a8e0006ab4bb5) > 0 ? -1 : 1;
    if ((r & $eab0623b6aed22da$export$e25597372303a045) === 0) // don't continue reading
    return sign * num;
    var len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $eab0623b6aed22da$export$f84d6bebff154ceb) * mult;
        mult *= 128;
        if (r < $eab0623b6aed22da$export$e25597372303a045) return sign * num;
        /* c8 ignore start */ if (num > $fd61ae8e5cc2fe78$export$18510406f204a1b9) throw $182bfc4830c83d2c$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $182bfc4830c83d2c$var$errorUnexpectedEndOfArray;
};
var $182bfc4830c83d2c$export$dc86e1eb544aa5ab = function(decoder) {
    var pos = decoder.pos;
    var s = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
var $182bfc4830c83d2c$export$47c43df02cd47fca = function(decoder) {
    var pos = decoder.pos;
    var s = $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
var $182bfc4830c83d2c$export$e73299e6158668bb = function(decoder) {
    var remainingLen = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return '';
    else {
        var encodedString = String.fromCodePoint($182bfc4830c83d2c$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($182bfc4830c83d2c$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            var nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            var bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
var $182bfc4830c83d2c$export$7247eefae50fb91a = function(decoder) {
    return /** @type any */ $80Ijr.utf8TextDecoder.decode($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
};
var $182bfc4830c83d2c$export$3b64b4d753b81ec2 = $80Ijr.utf8TextDecoder ? $182bfc4830c83d2c$export$7247eefae50fb91a : $182bfc4830c83d2c$export$e73299e6158668bb;
var $182bfc4830c83d2c$export$23764cfecad9ae2f = function(decoder) {
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    var b;
    while(true){
        b = $182bfc4830c83d2c$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
        if (b === 1) b = $182bfc4830c83d2c$export$d5778a2beba4ceef(decoder);
        $917f0b264ff88d53$export$68d8715fc104d294(encoder, b);
    }
};
var $182bfc4830c83d2c$export$d38ec182b293d566 = function(decoder) {
    return $80Ijr.decodeUtf8($182bfc4830c83d2c$export$23764cfecad9ae2f(decoder));
};
var $182bfc4830c83d2c$export$91c1f3f0dd9bd2f5 = function(decoder) {
    var pos = decoder.pos;
    var s = $182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
var $182bfc4830c83d2c$export$d7dd05f632129fe5 = function(decoder, len) {
    var dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
var $182bfc4830c83d2c$export$dbc4aa781d9afe3b = function(decoder) {
    return $182bfc4830c83d2c$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
};
var $182bfc4830c83d2c$export$d89a471990a89a7f = function(decoder) {
    return $182bfc4830c83d2c$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
};
var $182bfc4830c83d2c$export$99e633bd4f295d85 = function(decoder) {
    return /** @type {any} */ $182bfc4830c83d2c$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
};
var $182bfc4830c83d2c$export$21575c47d1f9b652 = function(decoder) {
    return /** @type {any} */ $182bfc4830c83d2c$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
};
/**
 * @type {Array<function(Decoder):any>}
 */ var $182bfc4830c83d2c$var$readAnyLookupTable = [
    function(decoder) {
        return undefined;
    },
    function(decoder) {
        return null;
    },
    $182bfc4830c83d2c$export$1dd5b9ddf6575ae8,
    $182bfc4830c83d2c$export$dbc4aa781d9afe3b,
    $182bfc4830c83d2c$export$d89a471990a89a7f,
    $182bfc4830c83d2c$export$99e633bd4f295d85,
    function(decoder) {
        return false;
    },
    function(decoder) {
        return true;
    },
    $182bfc4830c83d2c$export$3b64b4d753b81ec2,
    function(decoder) {
        var len = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ var obj = {};
        for(var i = 0; i < len; i++){
            var key = $182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder);
            obj[key] = $182bfc4830c83d2c$export$82863139061f472f(decoder);
        }
        return obj;
    },
    function(decoder) {
        var len = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var arr = [];
        for(var i = 0; i < len; i++)arr.push($182bfc4830c83d2c$export$82863139061f472f(decoder));
        return arr;
    },
    $182bfc4830c83d2c$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
var $182bfc4830c83d2c$export$82863139061f472f = function(decoder) {
    return $182bfc4830c83d2c$var$readAnyLookupTable[127 - $182bfc4830c83d2c$export$d5778a2beba4ceef(decoder)](decoder);
};
var $182bfc4830c83d2c$export$f1f1200492b832af = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(RleDecoder, Decoder);
    function RleDecoder(uint8Array, reader) {
        (0, $3CDbU._)(this, RleDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, RleDecoder, [
            uint8Array
        ]);
        /**
     * The reader
     */ _this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ _this.s = null;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(RleDecoder, [
        {
            key: "read",
            value: function read() {
                if (this.count === 0) {
                    this.s = this.reader(this);
                    if ($182bfc4830c83d2c$export$7ad75c69830b76d7(this)) this.count = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
                    ;
                    else this.count = -1 // read the current value forever
                    ;
                }
                this.count--;
                return /** @type {T} */ this.s;
            }
        }
    ]);
    return RleDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$938378143fffe1b4 = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(IntDiffDecoder, Decoder);
    function IntDiffDecoder(uint8Array, start) {
        (0, $3CDbU._)(this, IntDiffDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, IntDiffDecoder, [
            uint8Array
        ]);
        /**
     * Current state
     * @type {number}
     */ _this.s = start;
        return _this;
    }
    (0, $jyA4z._)(IntDiffDecoder, [
        {
            /**
   * @return {number}
   */ key: "read",
            value: function read() {
                this.s += $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(this);
                return this.s;
            }
        }
    ]);
    return IntDiffDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$595b36f1b42934c6 = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(RleIntDiffDecoder, Decoder);
    function RleIntDiffDecoder(uint8Array, start) {
        (0, $3CDbU._)(this, RleIntDiffDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, RleIntDiffDecoder, [
            uint8Array
        ]);
        /**
     * Current state
     * @type {number}
     */ _this.s = start;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(RleIntDiffDecoder, [
        {
            /**
   * @return {number}
   */ key: "read",
            value: function read() {
                if (this.count === 0) {
                    this.s += $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(this);
                    if ($182bfc4830c83d2c$export$7ad75c69830b76d7(this)) this.count = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
                    ;
                    else this.count = -1 // read the current value forever
                    ;
                }
                this.count--;
                return /** @type {number} */ this.s;
            }
        }
    ]);
    return RleIntDiffDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$2dc62fb2f864b82e = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(UintOptRleDecoder, Decoder);
    function UintOptRleDecoder(uint8Array) {
        (0, $3CDbU._)(this, UintOptRleDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, UintOptRleDecoder, [
            uint8Array
        ]);
        /**
     * @type {number}
     */ _this.s = 0;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(UintOptRleDecoder, [
        {
            key: "read",
            value: function read() {
                if (this.count === 0) {
                    this.s = $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(this);
                    // if the sign is negative, we read the count too, otherwise count is 1
                    var isNegative = $02E42.isNegativeZero(this.s);
                    this.count = 1;
                    if (isNegative) {
                        this.s = -this.s;
                        this.count = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this) + 2;
                    }
                }
                this.count--;
                return /** @type {number} */ this.s;
            }
        }
    ]);
    return UintOptRleDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$727389af14dfe417 = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(IncUintOptRleDecoder, Decoder);
    function IncUintOptRleDecoder(uint8Array) {
        (0, $3CDbU._)(this, IncUintOptRleDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, IncUintOptRleDecoder, [
            uint8Array
        ]);
        /**
     * @type {number}
     */ _this.s = 0;
        _this.count = 0;
        return _this;
    }
    (0, $jyA4z._)(IncUintOptRleDecoder, [
        {
            key: "read",
            value: function read() {
                if (this.count === 0) {
                    this.s = $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(this);
                    // if the sign is negative, we read the count too, otherwise count is 1
                    var isNegative = $02E42.isNegativeZero(this.s);
                    this.count = 1;
                    if (isNegative) {
                        this.s = -this.s;
                        this.count = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this) + 2;
                    }
                }
                this.count--;
                return /** @type {number} */ this.s++;
            }
        }
    ]);
    return IncUintOptRleDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$d502ab0bf048a596 = /*#__PURE__*/ function(Decoder) {
    "use strict";
    (0, $jCmGC._)(IntDiffOptRleDecoder, Decoder);
    function IntDiffOptRleDecoder(uint8Array) {
        (0, $3CDbU._)(this, IntDiffOptRleDecoder);
        var _this;
        _this = (0, $ep9cZ._)(this, IntDiffOptRleDecoder, [
            uint8Array
        ]);
        /**
     * @type {number}
     */ _this.s = 0;
        _this.count = 0;
        _this.diff = 0;
        return _this;
    }
    (0, $jyA4z._)(IntDiffOptRleDecoder, [
        {
            /**
   * @return {number}
   */ key: "read",
            value: function read() {
                if (this.count === 0) {
                    var diff = $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(this);
                    // if the first bit is set, we read more data
                    var hasCount = diff & 1;
                    this.diff = $02E42.floor(diff / 2) // shift >> 1
                    ;
                    this.count = 1;
                    if (hasCount) this.count = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this) + 2;
                }
                this.s += this.diff;
                this.count--;
                return this.s;
            }
        }
    ]);
    return IntDiffOptRleDecoder;
}($182bfc4830c83d2c$export$f9de6ca0bc043724);
var $182bfc4830c83d2c$export$63a7aa211a91ed69 = /*#__PURE__*/ function() {
    "use strict";
    function StringDecoder(uint8Array) {
        (0, $3CDbU._)(this, StringDecoder);
        this.decoder = new $182bfc4830c83d2c$export$2dc62fb2f864b82e(uint8Array);
        this.str = $182bfc4830c83d2c$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    (0, $jyA4z._)(StringDecoder, [
        {
            /**
   * @return {string}
   */ key: "read",
            value: function read() {
                var end = this.spos + this.decoder.read();
                var res = this.str.slice(this.spos, end);
                this.spos = end;
                return res;
            }
        }
    ]);
    return StringDecoder;
}();


/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
var $02E42 = parcelRequire("02E42");

/* eslint-env browser */ var $f66f4d96df2e9537$export$f45422fd2e8042d4 = crypto.subtle;
var $f66f4d96df2e9537$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);


var $a5a2dfa50b264217$export$bb0a9c36cf454ea0 = Math.random;
var $a5a2dfa50b264217$export$de9ffb9418dd7d0d = function() {
    return (0, $f66f4d96df2e9537$export$960b9ff25e7d4257)(new Uint32Array(1))[0];
};
var $a5a2dfa50b264217$export$6bf94e3d82617e4e = function() {
    var arr = (0, $f66f4d96df2e9537$export$960b9ff25e7d4257)(new Uint32Array(8));
    return (arr[0] & $eab0623b6aed22da$export$b5ffbef7f0f6f536) * ($eab0623b6aed22da$export$3ea07c5174cba08a + 1) + (arr[1] >>> 0);
};
var $a5a2dfa50b264217$export$a9a18ae5ba42aeab = function(arr) {
    return arr[$02E42.floor($a5a2dfa50b264217$export$bb0a9c36cf454ea0() * arr.length)];
};
// @ts-ignore
var $a5a2dfa50b264217$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
var $a5a2dfa50b264217$export$abe4376e1bf796d6 = function() {
    return $a5a2dfa50b264217$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ function(c) {
        return (c ^ $a5a2dfa50b264217$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16);
    });
};


/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
var $hWZw8 = parcelRequire("hWZw8");

var $eJDpD = parcelRequire("eJDpD");

var $gL882 = parcelRequire("gL882");
var $a79a86cce24f362c$export$185802fd694ee1f5 = function(f) {
    return /** @type {Promise<T>} */ new Promise(f);
};
var $a79a86cce24f362c$export$fe201bb3bbe031e9 = function(f) {
    return new Promise(f);
};
var $a79a86cce24f362c$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
var $a79a86cce24f362c$export$2800f3ceda99eb84 = function(reason) {
    return Promise.reject(reason);
};
var $a79a86cce24f362c$export$f7ad0328861e2f03 = function(res) {
    return Promise.resolve(res);
};
var $a79a86cce24f362c$export$65eff93aa071dbbd = function(res) {
    return Promise.resolve(res);
};
var $a79a86cce24f362c$export$a40009bd2c363351 = function(timeout, check) {
    var intervalResolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    return $a79a86cce24f362c$export$185802fd694ee1f5(function(resolve, reject) {
        var startTime = $gL882.getUnixTime();
        var hasTimeout = timeout > 0;
        var untilInterval = function() {
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($gL882.getUnixTime() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error('Timeout'));
                }
            }
        };
        var intervalHandle = setInterval(untilInterval, intervalResolution);
    });
};
var $a79a86cce24f362c$export$6ab8c822a2b03a03 = /*#__PURE__*/ function() {
    var _ref = (0, $hWZw8._)(function(check) {
        var timeout, intervalResolution, startTime, noTimeout;
        var _arguments = arguments;
        return (0, $eJDpD.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, intervalResolution = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 10;
                    startTime = $gL882.getUnixTime();
                    noTimeout = timeout <= 0;
                    _state.label = 1;
                case 1:
                    if (!(noTimeout || $gL882.getUnixTime() - startTime <= timeout)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        check()
                    ];
                case 2:
                    if (_state.sent()) return [
                        2
                    ];
                    return [
                        4,
                        $a79a86cce24f362c$export$5c069c93d2b7493f(intervalResolution)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 4:
                    throw new Error('Timeout');
            }
        });
    });
    return function untilAsync(check) {
        return _ref.apply(this, arguments);
    };
}();
var $a79a86cce24f362c$export$5c069c93d2b7493f = function(timeout) {
    return $a79a86cce24f362c$export$185802fd694ee1f5(function(resolve, _reject) {
        return setTimeout(resolve, timeout);
    });
};
var $a79a86cce24f362c$export$4369c812aac99591 = function(p) {
    return p instanceof Promise || p && p.then && p["catch"] && p["finally"];
};


/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
var $80Ijr = parcelRequire("80Ijr");

var $apk8q = parcelRequire("apk8q");

var $397ju = parcelRequire("397ju");

var $02E42 = parcelRequire("02E42");



var $eWKeP = parcelRequire("eWKeP");
var $824d4a265ce17f90$require$Buffer = $eWKeP.Buffer;
var $824d4a265ce17f90$export$79a0c4c40eecffbb = function(len) {
    return new Uint8Array(len);
};
var $824d4a265ce17f90$export$f3c8b5f6d250ec43 = function(buffer, byteOffset, length) {
    return new Uint8Array(buffer, byteOffset, length);
};
var $824d4a265ce17f90$export$1b999ddd54e5bed1 = function(buffer) {
    return new Uint8Array(buffer);
};
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ var $824d4a265ce17f90$var$toBase64Browser = function(bytes) {
    var s = '';
    for(var i = 0; i < bytes.byteLength; i++)s += $80Ijr.fromCharCode(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ var $824d4a265ce17f90$var$toBase64Node = function(bytes) {
    return $824d4a265ce17f90$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
};
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ var $824d4a265ce17f90$var$fromBase64Browser = function(s) {
    // eslint-disable-next-line no-undef
    var a = atob(s);
    var bytes = $824d4a265ce17f90$export$79a0c4c40eecffbb(a.length);
    for(var i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ var $824d4a265ce17f90$var$fromBase64Node = function(s) {
    var buf = $824d4a265ce17f90$require$Buffer.from(s, 'base64');
    return $824d4a265ce17f90$export$f3c8b5f6d250ec43(buf.buffer, buf.byteOffset, buf.byteLength);
};
var $824d4a265ce17f90$export$37cc283d8fbd3462 = $apk8q.isBrowser ? $824d4a265ce17f90$var$toBase64Browser : $824d4a265ce17f90$var$toBase64Node;
var $824d4a265ce17f90$export$c537b38001c583b7 = $apk8q.isBrowser ? $824d4a265ce17f90$var$fromBase64Browser : $824d4a265ce17f90$var$fromBase64Node;
var $824d4a265ce17f90$export$31f478961f22a29 = function(buf) {
    return $824d4a265ce17f90$export$37cc283d8fbd3462(buf).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
};
var $824d4a265ce17f90$export$2fcb175ca881fa06 = function(base64) {
    return $824d4a265ce17f90$export$c537b38001c583b7(base64.replaceAll('-', '+').replaceAll('_', '/'));
};
var $824d4a265ce17f90$export$f4915efbb94d4d01 = function(buf) {
    return $397ju.map(buf, function(b) {
        return b.toString(16).padStart(2, '0');
    }).join('');
};
var $824d4a265ce17f90$export$99a70112ceb8327b = function(hex) {
    var hlen = hex.length;
    var buf = new Uint8Array($02E42.ceil(hlen / 2));
    for(var i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
var $824d4a265ce17f90$export$fe6f60023cd5ffaf = function(uint8Array) {
    var newBuf = $824d4a265ce17f90$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
var $824d4a265ce17f90$export$355ad3726be07997 = function(data) {
    return $917f0b264ff88d53$export$c564cdbbe6da493(function(encoder) {
        return $917f0b264ff88d53$export$264b1e8551468ea(encoder, data);
    });
};
var $824d4a265ce17f90$export$929c279cfec29a23 = function(buf) {
    return $182bfc4830c83d2c$export$82863139061f472f($182bfc4830c83d2c$export$f8c898e83b60faaa(buf));
};
var $824d4a265ce17f90$export$e87773390ebfdab4 = function(bs, N) {
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(var i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};





var $1PYZG = parcelRequire("1PYZG");

var $kgvSK = parcelRequire("kgvSK");
parcelRequire("6XDMd");
var $fJDQU = parcelRequire("fJDQU");
var $6XDMd = parcelRequire("6XDMd");

var $gL882 = parcelRequire("gL882");

var $80Ijr = parcelRequire("80Ijr");
/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ 
var $fEm89 = parcelRequire("fEm89");
var $17002e7fafa8640f$export$68b1bda190f54159 = function(iterator, f) {
    var _obj;
    return _obj = {}, (0, $fEm89._)(_obj, Symbol.iterator, function() {
        return this;
    }), // @ts-ignore
    (0, $fEm89._)(_obj, "next", function() {
        var r = iterator.next();
        return {
            value: r.done ? undefined : f(r.value),
            done: r.done
        };
    }), _obj;
};
var $17002e7fafa8640f$export$7342c78d7e13e778 = function(next) {
    var _obj;
    return _obj = {}, /**
   * @return {IterableIterator<T>}
   */ (0, $fEm89._)(_obj, Symbol.iterator, function() {
        return this;
    }), // @ts-ignore
    (0, $fEm89._)(_obj, "next", next), _obj;
};
var $17002e7fafa8640f$export$88f0b2eef157f31a = function(iterator, filter) {
    return $17002e7fafa8640f$export$7342c78d7e13e778(function() {
        var res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
};
var $17002e7fafa8640f$export$1570d514f543056a = function(iterator, fmap) {
    return $17002e7fafa8640f$export$7342c78d7e13e778(function() {
        var _iterator_next = iterator.next(), done = _iterator_next.done, value = _iterator_next.value;
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });
};



var $eCHRC = parcelRequire("eCHRC");

var $apk8q = parcelRequire("apk8q");
/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ var $81089639773113c2$export$c3faceeb92aa39dd = /*#__PURE__*/ function(ObservableV2) {
    "use strict";
    (0, $jCmGC._)(AbstractConnector, ObservableV2);
    function AbstractConnector(ydoc, awareness) {
        (0, $3CDbU._)(this, AbstractConnector);
        var _this;
        _this = (0, $ep9cZ._)(this, AbstractConnector);
        _this.doc = ydoc;
        _this.awareness = awareness;
        return _this;
    }
    return AbstractConnector;
}((0, $b78261e7e572625c$export$e23d3436ce401adc));
var $81089639773113c2$var$DeleteItem = function DeleteItem(clock, len) {
    "use strict";
    (0, $3CDbU._)(this, DeleteItem);
    /**
     * @type {number}
     */ this.clock = clock;
    /**
     * @type {number}
     */ this.len = len;
};
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ var $81089639773113c2$var$DeleteSet = function DeleteSet() {
    "use strict";
    (0, $3CDbU._)(this, DeleteSet);
    /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
};
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ var $81089639773113c2$export$8afefebbaf4e4c78 = function(transaction, ds, f) {
    return ds.clients.forEach(function(deletes, clientid) {
        var structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(var i = 0; i < deletes.length; i++){
            var del = deletes[i];
            $81089639773113c2$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
};
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$findIndexDS = function(dis, clock) {
    var left = 0;
    var right = dis.length - 1;
    while(left <= right){
        var midindex = $02E42.floor((left + right) / 2);
        var mid = dis[midindex];
        var midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$dcb04af092e44fde = function(ds, id) {
    var dis = ds.clients.get(id.client);
    return dis !== undefined && $81089639773113c2$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ var $81089639773113c2$var$sortAndMergeDeleteSet = function(ds) {
    ds.clients.forEach(function(dels) {
        dels.sort(function(a, b) {
            return a.clock - b.clock;
        });
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        var i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            var left = dels[j - 1];
            var right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $02E42.max(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ var $81089639773113c2$export$b7826cadad53901e = function(dss) {
    var _loop = function(dssI) {
        dss[dssI].clients.forEach(function(delsLeft, client) {
            if (!merged.clients.has(client)) {
                // Write all missing keys from current ds and all following.
                // If merged already contains `client` current ds has already been added.
                /**
         * @type {Array<DeleteItem>}
         */ var dels = delsLeft.slice();
                for(var i = dssI + 1; i < dss.length; i++)$397ju.appendTo(dels, dss[i].clients.get(client) || []);
                merged.clients.set(client, dels);
            }
        });
    };
    var merged = new $81089639773113c2$var$DeleteSet();
    for(var dssI = 0; dssI < dss.length; dssI++)_loop(dssI);
    $81089639773113c2$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ var $81089639773113c2$var$addToDeleteSet = function(ds, client, clock, length) {
    $89wqq.setIfUndefined(ds.clients, client, function() {
        return /** @type {Array<DeleteItem>} */ [];
    }).push(new $81089639773113c2$var$DeleteItem(clock, length));
};
var $81089639773113c2$export$8cbac0d946238699 = function() {
    return new $81089639773113c2$var$DeleteSet();
};
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ var $81089639773113c2$export$8450d668bec558e2 = function(ss) {
    var ds = $81089639773113c2$export$8cbac0d946238699();
    ss.clients.forEach(function(structs, client) {
        /**
     * @type {Array<DeleteItem>}
     */ var dsitems = [];
        for(var i = 0; i < structs.length; i++){
            var struct = structs[i];
            if (struct.deleted) {
                var clock = struct.id.clock;
                var len = struct.length;
                if (i + 1 < structs.length) for(var next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $81089639773113c2$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ var $81089639773113c2$var$writeDeleteSet = function(encoder, ds) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $397ju.from(ds.clients.entries()).sort(function(a, b) {
        return b[0] - a[0];
    }).forEach(function(param) {
        var _param = (0, $bN2zx._)(param, 2), client = _param[0], dsitems = _param[1];
        encoder.resetDsCurVal();
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, client);
        var len = dsitems.length;
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, len);
        for(var i = 0; i < len; i++){
            var item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readDeleteSet = function(decoder) {
    var ds = new $81089639773113c2$var$DeleteSet();
    var numClients = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(var i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        var client = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        var numberOfDeletes = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            var dsField = $89wqq.setIfUndefined(ds.clients, client, function() {
                return /** @type {Array<DeleteItem>} */ [];
            });
            for(var i1 = 0; i1 < numberOfDeletes; i1++)dsField.push(new $81089639773113c2$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readAndApplyDeleteSet = function(decoder, transaction, store) {
    var unappliedDS = new $81089639773113c2$var$DeleteSet();
    var numClients = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(var i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        var client = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        var numberOfDeletes = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        var structs = store.clients.get(client) || [];
        var state = $81089639773113c2$export$50fdfeece43146fd(store, client);
        for(var i1 = 0; i1 < numberOfDeletes; i1++){
            var clock = decoder.readDsClock();
            var clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $81089639773113c2$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                var index = $81089639773113c2$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                var struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $81089639773113c2$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $81089639773113c2$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct["delete"](transaction);
                        }
                    } else break;
                }
            } else $81089639773113c2$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        var ds = new $81089639773113c2$export$30c99e08943e1c2();
        $917f0b264ff88d53$export$872f48c75febcd2b(ds.restEncoder, 0); // encode 0 structs
        $81089639773113c2$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ var $81089639773113c2$export$9697b72c46fd3a5d = function(ds1, ds2) {
    if (ds1.clients.size !== ds2.clients.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ds1.clients.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), client = _step_value[0], deleteItems1 = _step_value[1];
            var deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
            if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
            for(var i = 0; i < deleteItems1.length; i++){
                var di1 = deleteItems1[i];
                var di2 = deleteItems2[i];
                if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
/**
 * @module Y
 */ var $81089639773113c2$var$generateNewClientId = $a5a2dfa50b264217$export$de9ffb9418dd7d0d;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ var $81089639773113c2$export$bceacc74c2212615 = /*#__PURE__*/ function(ObservableV2) {
    "use strict";
    (0, $jCmGC._)(Doc, ObservableV2);
    function Doc() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_guid = _ref.guid, guid = _ref_guid === void 0 ? $a5a2dfa50b264217$export$abe4376e1bf796d6() : _ref_guid, _ref_collectionid = _ref.collectionid, collectionid = _ref_collectionid === void 0 ? null : _ref_collectionid, _ref_gc = _ref.gc, gc = _ref_gc === void 0 ? true : _ref_gc, _ref_gcFilter = _ref.gcFilter, gcFilter = _ref_gcFilter === void 0 ? function() {
            return true;
        } : _ref_gcFilter, _ref_meta = _ref.meta, meta = _ref_meta === void 0 ? null : _ref_meta, _ref_autoLoad = _ref.autoLoad, autoLoad = _ref_autoLoad === void 0 ? false : _ref_autoLoad, _ref_shouldLoad = _ref.shouldLoad, shouldLoad = _ref_shouldLoad === void 0 ? true : _ref_shouldLoad;
        (0, $3CDbU._)(this, Doc);
        var _this;
        _this = (0, $ep9cZ._)(this, Doc);
        _this.gc = gc;
        _this.gcFilter = gcFilter;
        _this.clientID = $81089639773113c2$var$generateNewClientId();
        _this.guid = guid;
        _this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ _this.share = new Map();
        _this.store = new $81089639773113c2$var$StructStore();
        /**
     * @type {Transaction | null}
     */ _this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ _this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ _this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ _this._item = null;
        _this.shouldLoad = shouldLoad;
        _this.autoLoad = autoLoad;
        _this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ _this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ _this.isSynced = false;
        _this.isDestroyed = false;
        /**
     * Promise that resolves once the document has been loaded from a persistence provider.
     */ _this.whenLoaded = $a79a86cce24f362c$export$185802fd694ee1f5(function(resolve) {
            _this.on('load', function() {
                _this.isLoaded = true;
                resolve(_this);
            });
        });
        var provideSyncedPromise = function() {
            return $a79a86cce24f362c$export$185802fd694ee1f5(function(resolve) {
                /**
       * @param {boolean} isSynced
       */ var eventHandler = function(isSynced) {
                    if (isSynced === undefined || isSynced === true) {
                        _this.off('sync', eventHandler);
                        resolve();
                    }
                };
                _this.on('sync', eventHandler);
            });
        };
        _this.on('sync', function(isSynced) {
            if (isSynced === false && _this.isSynced) _this.whenSynced = provideSyncedPromise();
            _this.isSynced = isSynced === undefined || isSynced === true;
            if (_this.isSynced && !_this.isLoaded) _this.emit('load', [
                _this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ _this.whenSynced = provideSyncedPromise();
        return _this;
    }
    (0, $jyA4z._)(Doc, [
        {
            /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ key: "load",
            value: function load() {
                var _this = this;
                var item = this._item;
                if (item !== null && !this.shouldLoad) $81089639773113c2$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, function(transaction) {
                    transaction.subdocsLoaded.add(_this);
                }, null, true);
                this.shouldLoad = true;
            }
        },
        {
            key: "getSubdocs",
            value: function getSubdocs() {
                return this.subdocs;
            }
        },
        {
            key: "getSubdocGuids",
            value: function getSubdocGuids() {
                return new Set($397ju.from(this.subdocs).map(function(doc) {
                    return doc.guid;
                }));
            }
        },
        {
            /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ key: "transact",
            value: function transact1(f) {
                var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return $81089639773113c2$export$dac1bad6146b2469(this, f, origin);
            }
        },
        {
            /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ key: "get",
            value: function get(name) {
                var _this = this;
                var TypeConstructor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /** @type {any} */ $81089639773113c2$export$c265dc8338484497;
                var type = $89wqq.setIfUndefined(this.share, name, function() {
                    // @ts-ignore
                    var t = new TypeConstructor();
                    t._integrate(_this, null);
                    return t;
                });
                var Constr = type.constructor;
                if (TypeConstructor !== $81089639773113c2$export$c265dc8338484497 && Constr !== TypeConstructor) {
                    if (Constr === $81089639773113c2$export$c265dc8338484497) {
                        // @ts-ignore
                        var t = new TypeConstructor();
                        t._map = type._map;
                        type._map.forEach(/** @param {Item?} n */ function(n) {
                            for(; n !== null; n = n.left)// @ts-ignore
                            n.parent = t;
                        });
                        t._start = type._start;
                        for(var n = t._start; n !== null; n = n.right)n.parent = t;
                        t._length = type._length;
                        this.share.set(name, t);
                        t._integrate(this, null);
                        return /** @type {InstanceType<Type>} */ t;
                    } else throw new Error("Type with the name ".concat(name, " has already been defined with a different constructor"));
                }
                return /** @type {InstanceType<Type>} */ type;
            }
        },
        {
            /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ key: "getArray",
            value: function getArray() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                return /** @type {YArray<T>} */ this.get(name, $81089639773113c2$export$c4be6576ca6fe4aa);
            }
        },
        {
            /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ key: "getText",
            value: function getText() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                return this.get(name, $81089639773113c2$export$5f1af8db9871e1d6);
            }
        },
        {
            /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ key: "getMap",
            value: function getMap() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                return /** @type {YMap<T>} */ this.get(name, $81089639773113c2$export$a5c7b93649eaf8f8);
            }
        },
        {
            /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ key: "getXmlElement",
            value: function getXmlElement() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $81089639773113c2$export$4db87581d3ca170d);
            }
        },
        {
            /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ key: "getXmlFragment",
            value: function getXmlFragment() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                return this.get(name, $81089639773113c2$export$d5ce8c3e1731f1a7);
            }
        },
        {
            /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ key: "toJSON",
            value: function toJSON() {
                /**
     * @type {Object<string, any>}
     */ var doc = {};
                this.share.forEach(function(value, key) {
                    doc[key] = value.toJSON();
                });
                return doc;
            }
        },
        {
            /**
   * Emit `destroy` event and unregister all event handlers.
   */ key: "destroy",
            value: function destroy() {
                var _this = this;
                this.isDestroyed = true;
                $397ju.from(this.subdocs).forEach(function(subdoc) {
                    return subdoc.destroy();
                });
                var item = this._item;
                if (item !== null) {
                    this._item = null;
                    var content = /** @type {ContentDoc} */ item.content;
                    content.doc = new Doc((0, $hiGMu._)((0, $cgG2i._)({
                        guid: this.guid
                    }, content.opts), {
                        shouldLoad: false
                    }));
                    content.doc._item = item;
                    $81089639773113c2$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, function(transaction) {
                        var doc = content.doc;
                        if (!item.deleted) transaction.subdocsAdded.add(doc);
                        transaction.subdocsRemoved.add(_this);
                    }, null, true);
                }
                // @ts-ignore
                this.emit('destroyed', [
                    true
                ]); // DEPRECATED!
                this.emit('destroy', [
                    this
                ]);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(Doc.prototype), "destroy", this).call(this);
            }
        }
    ]);
    return Doc;
}((0, $b78261e7e572625c$export$e23d3436ce401adc));
var $81089639773113c2$var$DSDecoderV1 = /*#__PURE__*/ function() {
    "use strict";
    function DSDecoderV1(decoder) {
        (0, $3CDbU._)(this, DSDecoderV1);
        this.restDecoder = decoder;
    }
    (0, $jyA4z._)(DSDecoderV1, [
        {
            key: "resetDsCurVal",
            value: function resetDsCurVal() {
            // nop
            }
        },
        {
            /**
   * @return {number}
   */ key: "readDsClock",
            value: function readDsClock() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
            }
        },
        {
            /**
   * @return {number}
   */ key: "readDsLen",
            value: function readDsLen() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
            }
        }
    ]);
    return DSDecoderV1;
}();
var $81089639773113c2$export$1aa46d9818b5d1ec = /*#__PURE__*/ function(DSDecoderV1) {
    "use strict";
    (0, $jCmGC._)(UpdateDecoderV1, DSDecoderV1);
    function UpdateDecoderV1() {
        (0, $3CDbU._)(this, UpdateDecoderV1);
        return (0, $ep9cZ._)(this, UpdateDecoderV1, arguments);
    }
    (0, $jyA4z._)(UpdateDecoderV1, [
        {
            /**
   * @return {ID}
   */ key: "readLeftID",
            value: function readLeftID() {
                return $81089639773113c2$export$6c7d4e6171d008d0($182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder), $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder));
            }
        },
        {
            /**
   * @return {ID}
   */ key: "readRightID",
            value: function readRightID() {
                return $81089639773113c2$export$6c7d4e6171d008d0($182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder), $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder));
            }
        },
        {
            /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ key: "readClient",
            value: function readClient() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
            }
        },
        {
            /**
   * @return {number} info An unsigned 8-bit integer
   */ key: "readInfo",
            value: function readInfo() {
                return $182bfc4830c83d2c$export$d5778a2beba4ceef(this.restDecoder);
            }
        },
        {
            /**
   * @return {string}
   */ key: "readString",
            value: function readString() {
                return $182bfc4830c83d2c$export$3b64b4d753b81ec2(this.restDecoder);
            }
        },
        {
            /**
   * @return {boolean} isKey
   */ key: "readParentInfo",
            value: function readParentInfo() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder) === 1;
            }
        },
        {
            /**
   * @return {number} info An unsigned 8-bit integer
   */ key: "readTypeRef",
            value: function readTypeRef() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
            }
        },
        {
            /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ key: "readLen",
            value: function readLen() {
                return $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
            }
        },
        {
            /**
   * @return {any}
   */ key: "readAny",
            value: function readAny() {
                return $182bfc4830c83d2c$export$82863139061f472f(this.restDecoder);
            }
        },
        {
            /**
   * @return {Uint8Array}
   */ key: "readBuf",
            value: function readBuf() {
                return $824d4a265ce17f90$export$fe6f60023cd5ffaf($182bfc4830c83d2c$export$7418bbc18dee40f3(this.restDecoder));
            }
        },
        {
            /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ key: "readJSON",
            value: function readJSON() {
                return JSON.parse($182bfc4830c83d2c$export$3b64b4d753b81ec2(this.restDecoder));
            }
        },
        {
            /**
   * @return {string}
   */ key: "readKey",
            value: function readKey() {
                return $182bfc4830c83d2c$export$3b64b4d753b81ec2(this.restDecoder);
            }
        }
    ]);
    return UpdateDecoderV1;
}($81089639773113c2$var$DSDecoderV1);
var $81089639773113c2$var$DSDecoderV2 = /*#__PURE__*/ function() {
    "use strict";
    function DSDecoderV2(decoder) {
        (0, $3CDbU._)(this, DSDecoderV2);
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    (0, $jyA4z._)(DSDecoderV2, [
        {
            key: "resetDsCurVal",
            value: function resetDsCurVal() {
                this.dsCurrVal = 0;
            }
        },
        {
            /**
   * @return {number}
   */ key: "readDsClock",
            value: function readDsClock() {
                this.dsCurrVal += $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder);
                return this.dsCurrVal;
            }
        },
        {
            /**
   * @return {number}
   */ key: "readDsLen",
            value: function readDsLen() {
                var diff = $182bfc4830c83d2c$export$5a476e4dbe7923d5(this.restDecoder) + 1;
                this.dsCurrVal += diff;
                return diff;
            }
        }
    ]);
    return DSDecoderV2;
}();
var $81089639773113c2$export$1c932452355c5571 = /*#__PURE__*/ function(DSDecoderV2) {
    "use strict";
    (0, $jCmGC._)(UpdateDecoderV2, DSDecoderV2);
    function UpdateDecoderV2(decoder) {
        (0, $3CDbU._)(this, UpdateDecoderV2);
        var _this;
        _this = (0, $ep9cZ._)(this, UpdateDecoderV2, [
            decoder
        ]);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ _this.keys = [];
        $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder); // read feature flag - currently unused
        _this.keyClockDecoder = new $182bfc4830c83d2c$export$d502ab0bf048a596($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.clientDecoder = new $182bfc4830c83d2c$export$2dc62fb2f864b82e($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.leftClockDecoder = new $182bfc4830c83d2c$export$d502ab0bf048a596($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.rightClockDecoder = new $182bfc4830c83d2c$export$d502ab0bf048a596($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.infoDecoder = new $182bfc4830c83d2c$export$f1f1200492b832af($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder), $182bfc4830c83d2c$export$d5778a2beba4ceef);
        _this.stringDecoder = new $182bfc4830c83d2c$export$63a7aa211a91ed69($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.parentInfoDecoder = new $182bfc4830c83d2c$export$f1f1200492b832af($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder), $182bfc4830c83d2c$export$d5778a2beba4ceef);
        _this.typeRefDecoder = new $182bfc4830c83d2c$export$2dc62fb2f864b82e($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        _this.lenDecoder = new $182bfc4830c83d2c$export$2dc62fb2f864b82e($182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
        return _this;
    }
    (0, $jyA4z._)(UpdateDecoderV2, [
        {
            /**
   * @return {ID}
   */ key: "readLeftID",
            value: function readLeftID() {
                return new $81089639773113c2$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
            }
        },
        {
            /**
   * @return {ID}
   */ key: "readRightID",
            value: function readRightID() {
                return new $81089639773113c2$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
            }
        },
        {
            /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ key: "readClient",
            value: function readClient() {
                return this.clientDecoder.read();
            }
        },
        {
            /**
   * @return {number} info An unsigned 8-bit integer
   */ key: "readInfo",
            value: function readInfo() {
                return /** @type {number} */ this.infoDecoder.read();
            }
        },
        {
            /**
   * @return {string}
   */ key: "readString",
            value: function readString() {
                return this.stringDecoder.read();
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "readParentInfo",
            value: function readParentInfo() {
                return this.parentInfoDecoder.read() === 1;
            }
        },
        {
            /**
   * @return {number} An unsigned 8-bit integer
   */ key: "readTypeRef",
            value: function readTypeRef() {
                return this.typeRefDecoder.read();
            }
        },
        {
            /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ key: "readLen",
            value: function readLen() {
                return this.lenDecoder.read();
            }
        },
        {
            /**
   * @return {any}
   */ key: "readAny",
            value: function readAny() {
                return $182bfc4830c83d2c$export$82863139061f472f(this.restDecoder);
            }
        },
        {
            /**
   * @return {Uint8Array}
   */ key: "readBuf",
            value: function readBuf() {
                return $182bfc4830c83d2c$export$7418bbc18dee40f3(this.restDecoder);
            }
        },
        {
            /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ key: "readJSON",
            value: function readJSON() {
                return $182bfc4830c83d2c$export$82863139061f472f(this.restDecoder);
            }
        },
        {
            /**
   * @return {string}
   */ key: "readKey",
            value: function readKey() {
                var keyClock = this.keyClockDecoder.read();
                if (keyClock < this.keys.length) return this.keys[keyClock];
                else {
                    var key = this.stringDecoder.read();
                    this.keys.push(key);
                    return key;
                }
            }
        }
    ]);
    return UpdateDecoderV2;
}($81089639773113c2$var$DSDecoderV2);
var $81089639773113c2$var$DSEncoderV1 = /*#__PURE__*/ function() {
    "use strict";
    function DSEncoderV1() {
        (0, $3CDbU._)(this, DSEncoderV1);
        this.restEncoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    }
    (0, $jyA4z._)(DSEncoderV1, [
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                return $917f0b264ff88d53$export$73470fd2221e6aef(this.restEncoder);
            }
        },
        {
            key: "resetDsCurVal",
            value: function resetDsCurVal() {
            // nop
            }
        },
        {
            /**
   * @param {number} clock
   */ key: "writeDsClock",
            value: function writeDsClock(clock) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, clock);
            }
        },
        {
            /**
   * @param {number} len
   */ key: "writeDsLen",
            value: function writeDsLen(len) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, len);
            }
        }
    ]);
    return DSEncoderV1;
}();
var $81089639773113c2$export$99171b804d9c5b54 = /*#__PURE__*/ function(DSEncoderV1) {
    "use strict";
    (0, $jCmGC._)(UpdateEncoderV1, DSEncoderV1);
    function UpdateEncoderV1() {
        (0, $3CDbU._)(this, UpdateEncoderV1);
        return (0, $ep9cZ._)(this, UpdateEncoderV1, arguments);
    }
    (0, $jyA4z._)(UpdateEncoderV1, [
        {
            /**
   * @param {ID} id
   */ key: "writeLeftID",
            value: function writeLeftID(id) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, id.client);
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, id.clock);
            }
        },
        {
            /**
   * @param {ID} id
   */ key: "writeRightID",
            value: function writeRightID(id) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, id.client);
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, id.clock);
            }
        },
        {
            /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ key: "writeClient",
            value: function writeClient(client) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, client);
            }
        },
        {
            /**
   * @param {number} info An unsigned 8-bit integer
   */ key: "writeInfo",
            value: function writeInfo(info) {
                $917f0b264ff88d53$export$826a1a6619653272(this.restEncoder, info);
            }
        },
        {
            /**
   * @param {string} s
   */ key: "writeString",
            value: function writeString(s) {
                $917f0b264ff88d53$export$dde49cb52d5f1650(this.restEncoder, s);
            }
        },
        {
            /**
   * @param {boolean} isYKey
   */ key: "writeParentInfo",
            value: function writeParentInfo(isYKey) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, isYKey ? 1 : 0);
            }
        },
        {
            /**
   * @param {number} info An unsigned 8-bit integer
   */ key: "writeTypeRef",
            value: function writeTypeRef(info) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, info);
            }
        },
        {
            /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ key: "writeLen",
            value: function writeLen(len) {
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, len);
            }
        },
        {
            /**
   * @param {any} any
   */ key: "writeAny",
            value: function writeAny(any) {
                $917f0b264ff88d53$export$264b1e8551468ea(this.restEncoder, any);
            }
        },
        {
            /**
   * @param {Uint8Array} buf
   */ key: "writeBuf",
            value: function writeBuf(buf) {
                $917f0b264ff88d53$export$f7d11515275e88a2(this.restEncoder, buf);
            }
        },
        {
            /**
   * @param {any} embed
   */ key: "writeJSON",
            value: function writeJSON(embed) {
                $917f0b264ff88d53$export$dde49cb52d5f1650(this.restEncoder, JSON.stringify(embed));
            }
        },
        {
            /**
   * @param {string} key
   */ key: "writeKey",
            value: function writeKey(key) {
                $917f0b264ff88d53$export$dde49cb52d5f1650(this.restEncoder, key);
            }
        }
    ]);
    return UpdateEncoderV1;
}($81089639773113c2$var$DSEncoderV1);
var $81089639773113c2$var$DSEncoderV2 = /*#__PURE__*/ function() {
    "use strict";
    function DSEncoderV2() {
        (0, $3CDbU._)(this, DSEncoderV2);
        this.restEncoder = $917f0b264ff88d53$export$4e76eeb6df88c889(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    (0, $jyA4z._)(DSEncoderV2, [
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                return $917f0b264ff88d53$export$73470fd2221e6aef(this.restEncoder);
            }
        },
        {
            key: "resetDsCurVal",
            value: function resetDsCurVal() {
                this.dsCurrVal = 0;
            }
        },
        {
            /**
   * @param {number} clock
   */ key: "writeDsClock",
            value: function writeDsClock(clock) {
                var diff = clock - this.dsCurrVal;
                this.dsCurrVal = clock;
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, diff);
            }
        },
        {
            /**
   * @param {number} len
   */ key: "writeDsLen",
            value: function writeDsLen(len) {
                if (len === 0) $4338d6312e5ee7d6$export$965b6bccecbd9673();
                $917f0b264ff88d53$export$872f48c75febcd2b(this.restEncoder, len - 1);
                this.dsCurrVal += len;
            }
        }
    ]);
    return DSEncoderV2;
}();
var $81089639773113c2$export$30c99e08943e1c2 = /*#__PURE__*/ function(DSEncoderV2) {
    "use strict";
    (0, $jCmGC._)(UpdateEncoderV2, DSEncoderV2);
    function UpdateEncoderV2() {
        (0, $3CDbU._)(this, UpdateEncoderV2);
        var _this;
        _this = (0, $ep9cZ._)(this, UpdateEncoderV2);
        /**
     * @type {Map<string,number>}
     */ _this.keyMap = new Map();
        /**
     * Refers to the next unique key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ _this.keyClock = 0;
        _this.keyClockEncoder = new $917f0b264ff88d53$export$7542c66a59375c6f();
        _this.clientEncoder = new $917f0b264ff88d53$export$785ebd3312c38061();
        _this.leftClockEncoder = new $917f0b264ff88d53$export$7542c66a59375c6f();
        _this.rightClockEncoder = new $917f0b264ff88d53$export$7542c66a59375c6f();
        _this.infoEncoder = new $917f0b264ff88d53$export$8fa72bb4fa9409ff($917f0b264ff88d53$export$826a1a6619653272);
        _this.stringEncoder = new $917f0b264ff88d53$export$7dcdc5c32f31c550();
        _this.parentInfoEncoder = new $917f0b264ff88d53$export$8fa72bb4fa9409ff($917f0b264ff88d53$export$826a1a6619653272);
        _this.typeRefEncoder = new $917f0b264ff88d53$export$785ebd3312c38061();
        _this.lenEncoder = new $917f0b264ff88d53$export$785ebd3312c38061();
        return _this;
    }
    (0, $jyA4z._)(UpdateEncoderV2, [
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, 0); // this is a feature flag that we might use in the future
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.keyClockEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.clientEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.leftClockEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.rightClockEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $917f0b264ff88d53$export$73470fd2221e6aef(this.infoEncoder));
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.stringEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $917f0b264ff88d53$export$73470fd2221e6aef(this.parentInfoEncoder));
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.typeRefEncoder.toUint8Array());
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, this.lenEncoder.toUint8Array());
                // @note The rest encoder is appended! (note the missing var)
                $917f0b264ff88d53$export$73b5e63e27d2b4c7(encoder, $917f0b264ff88d53$export$73470fd2221e6aef(this.restEncoder));
                return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
            }
        },
        {
            /**
   * @param {ID} id
   */ key: "writeLeftID",
            value: function writeLeftID(id) {
                this.clientEncoder.write(id.client);
                this.leftClockEncoder.write(id.clock);
            }
        },
        {
            /**
   * @param {ID} id
   */ key: "writeRightID",
            value: function writeRightID(id) {
                this.clientEncoder.write(id.client);
                this.rightClockEncoder.write(id.clock);
            }
        },
        {
            /**
   * @param {number} client
   */ key: "writeClient",
            value: function writeClient(client) {
                this.clientEncoder.write(client);
            }
        },
        {
            /**
   * @param {number} info An unsigned 8-bit integer
   */ key: "writeInfo",
            value: function writeInfo(info) {
                this.infoEncoder.write(info);
            }
        },
        {
            /**
   * @param {string} s
   */ key: "writeString",
            value: function writeString(s) {
                this.stringEncoder.write(s);
            }
        },
        {
            /**
   * @param {boolean} isYKey
   */ key: "writeParentInfo",
            value: function writeParentInfo(isYKey) {
                this.parentInfoEncoder.write(isYKey ? 1 : 0);
            }
        },
        {
            /**
   * @param {number} info An unsigned 8-bit integer
   */ key: "writeTypeRef",
            value: function writeTypeRef(info) {
                this.typeRefEncoder.write(info);
            }
        },
        {
            /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ key: "writeLen",
            value: function writeLen(len) {
                this.lenEncoder.write(len);
            }
        },
        {
            /**
   * @param {any} any
   */ key: "writeAny",
            value: function writeAny(any) {
                $917f0b264ff88d53$export$264b1e8551468ea(this.restEncoder, any);
            }
        },
        {
            /**
   * @param {Uint8Array} buf
   */ key: "writeBuf",
            value: function writeBuf(buf) {
                $917f0b264ff88d53$export$f7d11515275e88a2(this.restEncoder, buf);
            }
        },
        {
            /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ key: "writeJSON",
            value: function writeJSON(embed) {
                $917f0b264ff88d53$export$264b1e8551468ea(this.restEncoder, embed);
            }
        },
        {
            /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ key: "writeKey",
            value: function writeKey(key) {
                var clock = this.keyMap.get(key);
                if (clock === undefined) {
                    /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
                    this.keyClockEncoder.write(this.keyClock++);
                    this.stringEncoder.write(key);
                } else this.keyClockEncoder.write(clock);
            }
        }
    ]);
    return UpdateEncoderV2;
}($81089639773113c2$var$DSEncoderV2);
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ var $81089639773113c2$var$writeStructs = function(encoder, structs, client, clock) {
    // write first id
    clock = $02E42.max(clock, structs[0].id.clock); // make sure the first id exists
    var startNewStructs = $81089639773113c2$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, clock);
    var firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(var i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ var $81089639773113c2$var$writeClientsStructs = function(encoder, store, _sm) {
    // we filter all valid _sm entries into sm
    var sm = new Map();
    _sm.forEach(function(clock, client) {
        // only write if new structs are available
        if ($81089639773113c2$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $81089639773113c2$var$getStateVector(store).forEach(function(_clock, client) {
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $397ju.from(sm.entries()).sort(function(a, b) {
        return b[0] - a[0];
    }).forEach(function(param) {
        var _param = (0, $bN2zx._)(param, 2), client = _param[0], clock = _param[1];
        $81089639773113c2$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readClientsStructRefs = function(decoder, doc) {
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ var clientRefs = $89wqq.create();
    var numOfStateUpdates = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(var i = 0; i < numOfStateUpdates; i++){
        var numberOfStructs = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ var refs = new Array(numberOfStructs);
        var client = decoder.readClient();
        var clock = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(var i1 = 0; i1 < numberOfStructs; i1++){
            var info = decoder.readInfo();
            switch($eab0623b6aed22da$export$bc2aba63e4099c09 & info){
                case 0:
                    {
                        var len = decoder.readLen();
                        refs[i1] = new $81089639773113c2$export$12d259ff017e6b58($81089639773113c2$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        var len1 = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
                        refs[i1] = new $81089639773113c2$export$38d24f5c1eb0e4c0($81089639773113c2$export$6c7d4e6171d008d0(client, clock), len1);
                        clock += len1;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ var cantCopyParentInfo = (info & ($eab0623b6aed22da$export$eb5a8e0006ab4bb5 | $eab0623b6aed22da$export$e25597372303a045)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        var struct = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(client, clock), null, (info & $eab0623b6aed22da$export$e25597372303a045) === $eab0623b6aed22da$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $eab0623b6aed22da$export$eb5a8e0006ab4bb5) === $eab0623b6aed22da$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $eab0623b6aed22da$export$daf23f774967089) === $eab0623b6aed22da$export$daf23f774967089 ? decoder.readString() : null, $81089639773113c2$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // left
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i1] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is equal to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ var $81089639773113c2$var$integrateStructs = function(transaction, store, clientsStructRefs) {
    /**
   * @type {Array<Item | GC>}
   */ var stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    var clientsStructRefsIds = $397ju.from(clientsStructRefs.keys()).sort(function(a, b) {
        return a - b;
    });
    if (clientsStructRefsIds.length === 0) return null;
    var getNextStructTarget = function() {
        if (clientsStructRefsIds.length === 0) return null;
        var nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    var curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ var restStructs = new $81089639773113c2$var$StructStore();
    var missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ var updateMissingSv = function(client, clock) {
        var mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ var stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    var state = new Map();
    var addStackToRestSS = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var item = _step.value;
                var client = item.id.client;
                var inapplicableItems = clientsStructRefs.get(client);
                if (inapplicableItems) {
                    // decrement because we weren't able to apply previous operation
                    inapplicableItems.i--;
                    restStructs.clients.set(client, inapplicableItems.refs.slice(inapplicableItems.i));
                    clientsStructRefs["delete"](client);
                    inapplicableItems.i = 0;
                    inapplicableItems.refs = [];
                } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
                restStructs.clients.set(client, [
                    item
                ]);
                // remove client from clientsStructRefsIds to prevent users from applying the same update again
                clientsStructRefsIds = clientsStructRefsIds.filter(function(c) {
                    return c !== client;
                });
            };
            for(var _iterator = stack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $81089639773113c2$export$38d24f5c1eb0e4c0) {
            var localClock = $89wqq.setIfUndefined(state, stackHead.id.client, function() {
                return $81089639773113c2$export$50fdfeece43146fd(store, stackHead.id.client);
            });
            var offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                var missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ var structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $81089639773113c2$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        var encoder = new $81089639773113c2$export$30c99e08943e1c2();
        $81089639773113c2$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ var $81089639773113c2$var$writeStructsFromTransaction = function(encoder, transaction) {
    return $81089639773113c2$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
};
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ var $81089639773113c2$export$7abe492a0b891b4d = function(decoder, ydoc, transactionOrigin) {
    var structDecoder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $81089639773113c2$export$1c932452355c5571(decoder);
    return $81089639773113c2$export$dac1bad6146b2469(ydoc, function(transaction) {
        // force that transaction.local is set to non-local
        transaction.local = false;
        var retry = false;
        var doc = transaction.doc;
        var store = doc.store;
        // let start = performance.now()
        var ss = $81089639773113c2$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        var restStructs = $81089639773113c2$var$integrateStructs(transaction, store, ss);
        var pending = store.pendingStructs;
        if (pending) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // check if we can apply something
                for(var _iterator = pending.missing[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $bN2zx._)(_step.value, 2), client = _step_value[0], clock = _step_value[1];
                    if (clock < $81089639773113c2$export$50fdfeece43146fd(store, client)) {
                        retry = true;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (restStructs) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // merge restStructs into store.pending
                    for(var _iterator1 = restStructs.missing[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $bN2zx._)(_step1.value, 2), client1 = _step_value1[0], clock1 = _step_value1[1];
                        var mclock = pending.missing.get(client1);
                        if (mclock == null || mclock > clock1) pending.missing.set(client1, clock1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                pending.update = $81089639773113c2$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        var dsRest = $81089639773113c2$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            var pendingDSUpdate = new $81089639773113c2$export$1c932452355c5571($182bfc4830c83d2c$export$f8c898e83b60faaa(store.pendingDs));
            $182bfc4830c83d2c$export$5a476e4dbe7923d5(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            var dsRest2 = $81089639773113c2$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $81089639773113c2$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            var update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $81089639773113c2$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
};
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ var $81089639773113c2$export$d67ac8d73b7d336c = function(decoder, ydoc, transactionOrigin) {
    return $81089639773113c2$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $81089639773113c2$export$1aa46d9818b5d1ec(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ var $81089639773113c2$export$acc3b0324aabf1b6 = function(ydoc, update, transactionOrigin) {
    var YDecoder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $81089639773113c2$export$1c932452355c5571;
    var decoder = $182bfc4830c83d2c$export$f8c898e83b60faaa(update);
    $81089639773113c2$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ var $81089639773113c2$export$c271737a9c02e925 = function(ydoc, update, transactionOrigin) {
    return $81089639773113c2$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $81089639773113c2$export$1aa46d9818b5d1ec);
};
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ var $81089639773113c2$var$writeStateAsUpdate = function(encoder, doc) {
    var targetStateVector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Map();
    $81089639773113c2$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $81089639773113c2$var$writeDeleteSet(encoder, $81089639773113c2$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ var $81089639773113c2$export$90338e0798f6f64f = function(doc) {
    var encodedTargetStateVector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Uint8Array([
        0
    ]), encoder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $81089639773113c2$export$30c99e08943e1c2();
    var targetStateVector = $81089639773113c2$export$324ac6fb20a844e3(encodedTargetStateVector);
    $81089639773113c2$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    var updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($81089639773113c2$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $81089639773113c2$export$99171b804d9c5b54) return $81089639773113c2$export$6319871659fd2460(updates.map(function(update, i) {
            return i === 0 ? update : $81089639773113c2$export$afffbdeed14adbd(update);
        }));
        else if (encoder.constructor === $81089639773113c2$export$30c99e08943e1c2) return $81089639773113c2$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ var $81089639773113c2$export$e5848df80e65bd53 = function(doc, encodedTargetStateVector) {
    return $81089639773113c2$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $81089639773113c2$export$99171b804d9c5b54());
};
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ var $81089639773113c2$var$readStateVector = function(decoder) {
    var ss = new Map();
    var ssLength = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(var i = 0; i < ssLength; i++){
        var client = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        var clock = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ var $81089639773113c2$export$324ac6fb20a844e3 = function(decodedState) {
    return $81089639773113c2$var$readStateVector(new $81089639773113c2$var$DSDecoderV1($182bfc4830c83d2c$export$f8c898e83b60faaa(decodedState)));
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ var $81089639773113c2$var$writeStateVector = function(encoder, sv) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, sv.size);
    $397ju.from(sv.entries()).sort(function(a, b) {
        return b[0] - a[0];
    }).forEach(function(param) {
        var _param = (0, $bN2zx._)(param, 2), client = _param[0], clock = _param[1];
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ var $81089639773113c2$var$writeDocumentStateVector = function(encoder, doc) {
    return $81089639773113c2$var$writeStateVector(encoder, $81089639773113c2$var$getStateVector(doc.store));
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ var $81089639773113c2$var$encodeStateVectorV2 = function(doc) {
    var encoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $81089639773113c2$var$DSEncoderV2();
    if (doc instanceof Map) $81089639773113c2$var$writeStateVector(encoder, doc);
    else $81089639773113c2$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ var $81089639773113c2$export$3e2f5393f32e71f = function(doc) {
    return $81089639773113c2$var$encodeStateVectorV2(doc, new $81089639773113c2$var$DSEncoderV1());
};
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ var $81089639773113c2$var$EventHandler = function EventHandler() {
    "use strict";
    (0, $3CDbU._)(this, EventHandler);
    /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
};
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$createEventHandler = function() {
    return new $81089639773113c2$var$EventHandler();
};
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ var $81089639773113c2$var$addEventHandlerListener = function(eventHandler, f) {
    return eventHandler.l.push(f);
};
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$removeEventHandlerListener = function(eventHandler, f) {
    var l = eventHandler.l;
    var len = l.length;
    eventHandler.l = l.filter(function(g) {
        return f !== g;
    });
    if (len === eventHandler.l.length) console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ var $81089639773113c2$var$callEventHandlerListeners = function(eventHandler, arg0, arg1) {
    return $1PYZG.callAll(eventHandler.l, [
        arg0,
        arg1
    ]);
};
var $81089639773113c2$export$8be180ec26319f9f = function ID(client, clock) {
    "use strict";
    (0, $3CDbU._)(this, ID);
    /**
     * Client id
     * @type {number}
     */ this.client = client;
    /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
};
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ var $81089639773113c2$export$c0af976e7e459c02 = function(a, b) {
    return a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
};
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ var $81089639773113c2$export$6c7d4e6171d008d0 = function(client, clock) {
    return new $81089639773113c2$export$8be180ec26319f9f(client, clock);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ var $81089639773113c2$var$writeID = function(encoder, id) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, id.client);
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readID = function(decoder) {
    return $81089639773113c2$export$6c7d4e6171d008d0($182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder), $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder));
};
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$e726a40920d54663 = function(type) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // @ts-ignore _y must be defined, otherwise unexpected case
        for(var _iterator = type.doc.share.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value === type) return key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ var $81089639773113c2$export$3c81af374b054d6a = function(parent, child) {
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ var $81089639773113c2$export$e9068ad704ba2f79 = function(type) {
    var res = [];
    var n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log('Children: ', res);
    console.log('Children content: ', res.filter(function(m) {
        return !m.deleted;
    }).map(function(m) {
        return m.content;
    }));
};
var $81089639773113c2$export$b9e8b5fa1162ca4e = /*#__PURE__*/ function() {
    "use strict";
    function PermanentUserData(doc) {
        var _this = this;
        var storeType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : doc.getMap('users');
        (0, $3CDbU._)(this, PermanentUserData);
        /**
     * @type {Map<string,DeleteSet>}
     */ var dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ var initUser = function(user, userDescription) {
            /**
       * @type {YArray<Uint8Array>}
       */ var ds = user.get('ds');
            var ids = user.get('ids');
            var addClientId = /** @param {number} clientid */ function(clientid) {
                return _this.clients.set(clientid, userDescription);
            };
            ds.observe(/** @param {YArrayEvent<any>} event */ function(event) {
                event.changes.added.forEach(function(item) {
                    item.content.getContent().forEach(function(encodedDs) {
                        if (encodedDs instanceof Uint8Array) _this.dss.set(userDescription, $81089639773113c2$export$b7826cadad53901e([
                            _this.dss.get(userDescription) || $81089639773113c2$export$8cbac0d946238699(),
                            $81089639773113c2$var$readDeleteSet(new $81089639773113c2$var$DSDecoderV1($182bfc4830c83d2c$export$f8c898e83b60faaa(encodedDs)))
                        ]));
                    });
                });
            });
            _this.dss.set(userDescription, $81089639773113c2$export$b7826cadad53901e(ds.map(function(encodedDs) {
                return $81089639773113c2$var$readDeleteSet(new $81089639773113c2$var$DSDecoderV1($182bfc4830c83d2c$export$f8c898e83b60faaa(encodedDs)));
            })));
            ids.observe(/** @param {YArrayEvent<any>} event */ function(event) {
                return event.changes.added.forEach(function(item) {
                    return item.content.getContent().forEach(addClientId);
                });
            });
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe(function(event) {
            event.keysChanged.forEach(function(userDescription) {
                return initUser(storeType.get(userDescription), userDescription);
            });
        });
        // add initial data
        storeType.forEach(initUser);
    }
    (0, $jyA4z._)(PermanentUserData, [
        {
            /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ key: "setUserMapping",
            value: function setUserMapping(doc, clientid, userDescription) {
                var _this = this;
                var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_filter = _ref.filter, filter = _ref_filter === void 0 ? function() {
                    return true;
                } : _ref_filter;
                var users = this.yusers;
                var user = users.get(userDescription);
                if (!user) {
                    user = new $81089639773113c2$export$a5c7b93649eaf8f8();
                    user.set('ids', new $81089639773113c2$export$c4be6576ca6fe4aa());
                    user.set('ds', new $81089639773113c2$export$c4be6576ca6fe4aa());
                    users.set(userDescription, user);
                }
                user.get('ids').push([
                    clientid
                ]);
                users.observe(function(_event) {
                    setTimeout(function() {
                        var userOverwrite = users.get(userDescription);
                        if (userOverwrite !== user) {
                            // user was overwritten, port all data over to the next user object
                            // @todo Experiment with Y.Sets here
                            user = userOverwrite;
                            // @todo iterate over old type
                            _this.clients.forEach(function(_userDescription, clientid) {
                                if (userDescription === _userDescription) user.get('ids').push([
                                    clientid
                                ]);
                            });
                            var encoder = new $81089639773113c2$var$DSEncoderV1();
                            var ds = _this.dss.get(userDescription);
                            if (ds) {
                                $81089639773113c2$var$writeDeleteSet(encoder, ds);
                                user.get('ds').push([
                                    encoder.toUint8Array()
                                ]);
                            }
                        }
                    }, 0);
                });
                doc.on('afterTransaction', /** @param {Transaction} transaction */ function(transaction) {
                    setTimeout(function() {
                        var yds = user.get('ds');
                        var ds = transaction.deleteSet;
                        if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                            var encoder = new $81089639773113c2$var$DSEncoderV1();
                            $81089639773113c2$var$writeDeleteSet(encoder, ds);
                            yds.push([
                                encoder.toUint8Array()
                            ]);
                        }
                    });
                });
            }
        },
        {
            /**
   * @param {number} clientid
   * @return {any}
   */ key: "getUserByClientId",
            value: function getUserByClientId(clientid) {
                return this.clients.get(clientid) || null;
            }
        },
        {
            /**
   * @param {ID} id
   * @return {string | null}
   */ key: "getUserByDeletedId",
            value: function getUserByDeletedId(id) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.dss.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $bN2zx._)(_step.value, 2), userDescription = _step_value[0], ds = _step_value[1];
                        if ($81089639773113c2$export$dcb04af092e44fde(ds, id)) return userDescription;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        }
    ]);
    return PermanentUserData;
}();
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ var $81089639773113c2$export$da21a415c5907662 = function RelativePosition(type, tname, item) {
    "use strict";
    var assoc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    (0, $3CDbU._)(this, RelativePosition);
    /**
     * @type {ID|null}
     */ this.type = type;
    /**
     * @type {string|null}
     */ this.tname = tname;
    /**
     * @type {ID | null}
     */ this.item = item;
    /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the character
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
};
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ var $81089639773113c2$export$a783b081767a452e = function(rpos) {
    var json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ var $81089639773113c2$export$ddad8a1b8f7475d8 = function(json) {
    var _json_tname;
    return new $81089639773113c2$export$da21a415c5907662(json.type == null ? null : $81089639773113c2$export$6c7d4e6171d008d0(json.type.client, json.type.clock), (_json_tname = json.tname) !== null && _json_tname !== void 0 ? _json_tname : null, json.item == null ? null : $81089639773113c2$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
};
var $81089639773113c2$export$64c95a3fb7344864 = function AbsolutePosition(type, index) {
    "use strict";
    var assoc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    (0, $3CDbU._)(this, AbsolutePosition);
    /**
     * @type {AbstractType<any>}
     */ this.type = type;
    /**
     * @type {number}
     */ this.index = index;
    this.assoc = assoc;
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ var $81089639773113c2$var$createAbsolutePosition = function(type, index) {
    var assoc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return new $81089639773113c2$export$64c95a3fb7344864(type, index, assoc);
};
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ var $81089639773113c2$var$createRelativePosition = function(type, item, assoc) {
    var typeid = null;
    var tname = null;
    if (type._item === null) tname = $81089639773113c2$export$e726a40920d54663(type);
    else typeid = $81089639773113c2$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $81089639773113c2$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ var $81089639773113c2$export$197e7d99e3857e88 = function(type, index) {
    var assoc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $81089639773113c2$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $81089639773113c2$var$createRelativePosition(type, $81089639773113c2$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $81089639773113c2$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $81089639773113c2$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ var $81089639773113c2$var$writeRelativePosition = function(encoder, rpos) {
    var type = rpos.type, tname = rpos.tname, item = rpos.item, assoc = rpos.assoc;
    if (item !== null) {
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, 0);
        $81089639773113c2$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $917f0b264ff88d53$export$826a1a6619653272(encoder, 1);
        $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $917f0b264ff88d53$export$826a1a6619653272(encoder, 2);
        $81089639773113c2$var$writeID(encoder, type);
    } else throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
    $917f0b264ff88d53$export$ff90f819e16cc9bb(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ var $81089639773113c2$export$c5c95ef724203575 = function(rpos) {
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    $81089639773113c2$var$writeRelativePosition(encoder, rpos);
    return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ var $81089639773113c2$var$readRelativePosition = function(decoder) {
    var type = null;
    var tname = null;
    var itemID = null;
    switch($182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $81089639773113c2$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $81089639773113c2$var$readID(decoder);
    }
    var assoc = $182bfc4830c83d2c$export$7ad75c69830b76d7(decoder) ? $182bfc4830c83d2c$export$1dd5b9ddf6575ae8(decoder) : 0;
    return new $81089639773113c2$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ var $81089639773113c2$export$58a46cebc90e7851 = function(uint8Array) {
    return $81089639773113c2$var$readRelativePosition($182bfc4830c83d2c$export$f8c898e83b60faaa(uint8Array));
};
/**
 * @param {StructStore} store
 * @param {ID} id
 */ var $81089639773113c2$var$getItemWithOffset = function(store, id) {
    var item = $81089639773113c2$export$f92dfeb71e9bb569(store, id);
    var diff = id.clock - item.id.clock;
    return {
        item: item,
        diff: diff
    };
};
/**
 * Transform a relative position to an absolute position.
 *
 * If you want to share the relative position with other users, you should set
 * `followUndoneDeletions` to false to get consistent results across all clients.
 *
 * When calculating the absolute position, we try to follow the "undone deletions". This yields
 * better results for the user who performed undo. However, only the user who performed the undo
 * will get the better results, the other users don't know which operations recreated a deleted
 * range of content. There is more information in this ticket: https://github.com/yjs/yjs/issues/638
 *
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @param {boolean} followUndoneDeletions - whether to follow undone deletions - see https://github.com/yjs/yjs/issues/638
 * @return {AbsolutePosition|null}
 *
 * @function
 */ var $81089639773113c2$export$8fc3152f62fb7ed1 = function(rpos, doc) {
    var followUndoneDeletions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var store = doc.store;
    var rightID = rpos.item;
    var typeID = rpos.type;
    var tname = rpos.tname;
    var assoc = rpos.assoc;
    var type = null;
    var index = 0;
    if (rightID !== null) {
        if ($81089639773113c2$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        var res = followUndoneDeletions ? $81089639773113c2$var$followRedone(store, rightID) : $81089639773113c2$var$getItemWithOffset(store, rightID);
        var right = res.item;
        if (!(right instanceof $81089639773113c2$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            var n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($81089639773113c2$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            var item = (followUndoneDeletions ? $81089639773113c2$var$followRedone(store, typeID) : {
                item: $81089639773113c2$export$f92dfeb71e9bb569(store, typeID)
            }).item;
            if (item instanceof $81089639773113c2$export$6d08773d2e66f8f2 && item.content instanceof $81089639773113c2$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $81089639773113c2$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ var $81089639773113c2$export$fc8bd253c948b475 = function(a, b) {
    return a === b || a !== null && b !== null && a.tname === b.tname && $81089639773113c2$export$c0af976e7e459c02(a.item, b.item) && $81089639773113c2$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
};
var $81089639773113c2$export$c963130a5525248f = function Snapshot(ds, sv) {
    "use strict";
    (0, $3CDbU._)(this, Snapshot);
    /**
     * @type {DeleteSet}
     */ this.ds = ds;
    /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
};
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ var $81089639773113c2$export$742742a0f55b273d = function(snap1, snap2) {
    var ds1 = snap1.ds.clients;
    var ds2 = snap2.ds.clients;
    var sv1 = snap1.sv;
    var sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sv1.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (sv2.get(key) !== value) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = ds1.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $bN2zx._)(_step1.value, 2), client = _step_value1[0], dsitems1 = _step_value1[1];
            var dsitems2 = ds2.get(client) || [];
            if (dsitems1.length !== dsitems2.length) return false;
            for(var i = 0; i < dsitems1.length; i++){
                var dsitem1 = dsitems1[i];
                var dsitem2 = dsitems2[i];
                if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ var $81089639773113c2$export$b946cadc55f8e512 = function(snapshot) {
    var encoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $81089639773113c2$var$DSEncoderV2();
    $81089639773113c2$var$writeDeleteSet(encoder, snapshot.ds);
    $81089639773113c2$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ var $81089639773113c2$export$a6d29989648e995 = function(snapshot) {
    return $81089639773113c2$export$b946cadc55f8e512(snapshot, new $81089639773113c2$var$DSEncoderV1());
};
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ var $81089639773113c2$export$b0049fa299f4f58e = function(buf) {
    var decoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $81089639773113c2$var$DSDecoderV2($182bfc4830c83d2c$export$f8c898e83b60faaa(buf));
    return new $81089639773113c2$export$c963130a5525248f($81089639773113c2$var$readDeleteSet(decoder), $81089639773113c2$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ var $81089639773113c2$export$5c696daccf32bd2e = function(buf) {
    return $81089639773113c2$export$b0049fa299f4f58e(buf, new $81089639773113c2$var$DSDecoderV1($182bfc4830c83d2c$export$f8c898e83b60faaa(buf)));
};
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ var $81089639773113c2$export$548fae0445f878fd = function(ds, sm) {
    return new $81089639773113c2$export$c963130a5525248f(ds, sm);
};
var $81089639773113c2$export$d4568a81dd107a34 = $81089639773113c2$export$548fae0445f878fd($81089639773113c2$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ var $81089639773113c2$export$b8801ea43165ed7d = function(doc) {
    return $81089639773113c2$export$548fae0445f878fd($81089639773113c2$export$8450d668bec558e2(doc.store), $81089639773113c2$var$getStateVector(doc.store));
};
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ var $81089639773113c2$var$isVisible = function(item, snapshot) {
    return snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$81089639773113c2$export$dcb04af092e44fde(snapshot.ds, item.id);
};
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ var $81089639773113c2$var$splitSnapshotAffectedStructs = function(transaction, snapshot) {
    var meta = $89wqq.setIfUndefined(transaction.meta, $81089639773113c2$var$splitSnapshotAffectedStructs, $kgvSK.create);
    var store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach(function(clock, client) {
            if (clock < $81089639773113c2$export$50fdfeece43146fd(store, client)) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(client, clock));
        });
        $81089639773113c2$export$8afefebbaf4e4c78(transaction, snapshot.ds, function(_item) {});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ var $81089639773113c2$export$5be4ae1e1e56a014 = function(originDoc, snapshot) {
    var newDoc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $81089639773113c2$export$bceacc74c2212615();
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('Garbage-collection must be disabled in `originDoc`!');
    var sv = snapshot.sv, ds = snapshot.ds;
    var encoder = new $81089639773113c2$export$30c99e08943e1c2();
    originDoc.transact(function(transaction) {
        var size = 0;
        sv.forEach(function(clock) {
            if (clock > 0) size++;
        });
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, size);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // splitting the structs before writing them to the encoder
            for(var _iterator = sv[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $bN2zx._)(_step.value, 2), client = _step_value[0], clock = _step_value[1];
                if (clock === 0) continue;
                if (clock < $81089639773113c2$export$50fdfeece43146fd(originDoc.store, client)) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(client, clock));
                var structs = originDoc.store.clients.get(client) || [];
                var lastStructIndex = $81089639773113c2$export$5f8f02523cf47b58(structs, clock - 1);
                // write # encoded structs
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, lastStructIndex + 1);
                encoder.writeClient(client);
                // first clock written is 0
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, 0);
                for(var i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        $81089639773113c2$var$writeDeleteSet(encoder, ds);
    });
    $81089639773113c2$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), 'snapshot');
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ var $81089639773113c2$var$snapshotContainsUpdateV2 = function(snapshot, update) {
    var YDecoder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $81089639773113c2$export$1c932452355c5571;
    var updateDecoder = new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    var lazyDecoder = new $81089639773113c2$var$LazyStructReader(updateDecoder, false);
    for(var curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    var mergedDS = $81089639773113c2$export$b7826cadad53901e([
        snapshot.ds,
        $81089639773113c2$var$readDeleteSet(updateDecoder)
    ]);
    return $81089639773113c2$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ var $81089639773113c2$export$f938135bed5d8db7 = function(snapshot, update) {
    return $81089639773113c2$var$snapshotContainsUpdateV2(snapshot, update, $81089639773113c2$export$1aa46d9818b5d1ec);
};
var $81089639773113c2$var$StructStore = function StructStore() {
    "use strict";
    (0, $3CDbU._)(this, StructStore);
    /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
    /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
    /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
};
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ var $81089639773113c2$var$getStateVector = function(store) {
    var sm = new Map();
    store.clients.forEach(function(structs, client) {
        var struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ var $81089639773113c2$export$50fdfeece43146fd = function(store, client) {
    var structs = store.clients.get(client);
    if (structs === undefined) return 0;
    var lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ var $81089639773113c2$var$addStruct = function(store, struct) {
    var structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        var lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$5f8f02523cf47b58 = function(structs, clock) {
    var left = 0;
    var right = structs.length - 1;
    var mid = structs[right];
    var midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    var midindex = $02E42.floor(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $02E42.floor((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$find = function(store, id) {
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    var structs = store.clients.get(id.client);
    return structs[$81089639773113c2$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ var $81089639773113c2$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $81089639773113c2$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ var $81089639773113c2$var$findIndexCleanStart = function(transaction, structs, clock) {
    var index = $81089639773113c2$export$5f8f02523cf47b58(structs, clock);
    var struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $81089639773113c2$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $81089639773113c2$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$e550586ad633138d = function(transaction, id) {
    var structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$81089639773113c2$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$73a181de908c608 = function(transaction, store, id) {
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    var structs = store.clients.get(id.client);
    var index = $81089639773113c2$export$5f8f02523cf47b58(structs, id.clock);
    var struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $81089639773113c2$export$12d259ff017e6b58) structs.splice(index + 1, 0, $81089639773113c2$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ var $81089639773113c2$var$replaceStruct = function(store, struct, newStruct) {
    var structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$81089639773113c2$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ var $81089639773113c2$var$iterateStructs = function(transaction, structs, clockStart, len, f) {
    if (len === 0) return;
    var clockEnd = clockStart + len;
    var index = $81089639773113c2$var$findIndexCleanStart(transaction, structs, clockStart);
    var struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $81089639773113c2$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const ydoc = new Y.Doc()
 * const map = ydoc.getMap('map')
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * ydoc.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ var $81089639773113c2$export$febc5573c75cefb0 = function Transaction(doc, origin, local) {
    "use strict";
    (0, $3CDbU._)(this, Transaction);
    /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
    /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $81089639773113c2$var$DeleteSet();
    /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $81089639773113c2$var$getStateVector(doc.store);
    /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
    /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
    /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
    /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
    /**
     * @type {any}
     */ this.origin = origin;
    /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
    /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
    /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
    /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
    /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
    /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ var $81089639773113c2$var$writeUpdateMessageFromTransaction = function(encoder, transaction) {
    if (transaction.deleteSet.clients.size === 0 && !$89wqq.any(transaction.afterState, function(clock, client) {
        return transaction.beforeState.get(client) !== clock;
    })) return false;
    $81089639773113c2$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $81089639773113c2$var$writeStructsFromTransaction(encoder, transaction);
    $81089639773113c2$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ var $81089639773113c2$var$addChangedTypeToTransaction = function(transaction, type, parentSub) {
    var item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $89wqq.setIfUndefined(transaction.changed, type, $kgvSK.create).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ var $81089639773113c2$var$tryToMergeWithLefts = function(structs, pos) {
    var right = structs[pos];
    var left = structs[pos - 1];
    var i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $81089639773113c2$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    var merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ var $81089639773113c2$var$tryGcDeleteSet = function(ds, store, gcFilter) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ds.clients.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), client = _step_value[0], deleteItems = _step_value[1];
            var structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
            for(var di = deleteItems.length - 1; di >= 0; di--){
                var deleteItem = deleteItems[di];
                var endDeleteItemClock = deleteItem.clock + deleteItem.len;
                for(var si = $81089639773113c2$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                    var struct1 = structs[si];
                    if (deleteItem.clock + deleteItem.len <= struct1.id.clock) break;
                    if (struct1 instanceof $81089639773113c2$export$6d08773d2e66f8f2 && struct1.deleted && !struct1.keep && gcFilter(struct1)) struct1.gc(store, false);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ var $81089639773113c2$var$tryMergeDeleteSet = function(ds, store) {
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiency and so we don't miss any merge targets
    ds.clients.forEach(function(deleteItems, client) {
        var structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(var di = deleteItems.length - 1; di >= 0; di--){
            var deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            var mostRightIndexToCheck = $02E42.min(structs.length - 1, 1 + $81089639773113c2$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(var si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $81089639773113c2$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ var $81089639773113c2$export$c2e5de00fc43f658 = function(ds, store, gcFilter) {
    $81089639773113c2$var$tryGcDeleteSet(ds, store, gcFilter);
    $81089639773113c2$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ var $81089639773113c2$var$cleanupTransactions = function(transactionCleanups, i) {
    if (i < transactionCleanups.length) {
        var transaction = transactionCleanups[i];
        var doc = transaction.doc;
        var store = doc.store;
        var ds = transaction.deleteSet;
        var mergeStructs = transaction._mergeStructs;
        try {
            $81089639773113c2$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $81089639773113c2$var$getStateVector(transaction.doc.store);
            doc.emit('beforeObserverCalls', [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ var fs = [];
            // observe events on changed types
            transaction.changed.forEach(function(subs, itemtype) {
                return fs.push(function() {
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                });
            });
            fs.push(function() {
                // deep observe events
                transaction.changedParentTypes.forEach(function(events, type) {
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                        events = events.filter(function(event) {
                            return event.target._item === null || !event.target._item.deleted;
                        });
                        events.forEach(function(event) {
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort(function(event1, event2) {
                            return event1.path.length - event2.path.length;
                        });
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $81089639773113c2$var$callEventHandlerListeners(type._dEH, events, transaction);
                    }
                });
            });
            fs.push(function() {
                return doc.emit('afterTransaction', [
                    transaction,
                    doc
                ]);
            });
            (0, $1PYZG.callAll)(fs, []);
            if (transaction._needFormattingCleanup) $81089639773113c2$var$cleanupYTextAfterTransaction(transaction);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $81089639773113c2$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $81089639773113c2$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach(function(clock, client) {
                var beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    var structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    var firstChangePos = $02E42.max($81089639773113c2$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(var _$i = structs.length - 1; _$i >= firstChangePos;)_$i -= 1 + $81089639773113c2$var$tryToMergeWithLefts(structs, _$i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(var _$i = mergeStructs.length - 1; _$i >= 0; _$i--){
                var _mergeStructs_i_id = mergeStructs[_$i].id, client = _mergeStructs_i_id.client, clock = _mergeStructs_i_id.clock;
                var structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                var replacedStructPos = $81089639773113c2$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($81089639773113c2$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $81089639773113c2$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $6XDMd.print($fJDQU.ORANGE, $fJDQU.BOLD, '[yjs] ', $fJDQU.UNBOLD, $fJDQU.RED, 'Changed the client-id because another client seems to be using it.');
                doc.clientID = $81089639773113c2$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit('afterTransactionCleanup', [
                transaction,
                doc
            ]);
            if (doc._observers.has('update')) {
                var encoder = new $81089639773113c2$export$99171b804d9c5b54();
                var hasContent = $81089639773113c2$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('update', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has('updateV2')) {
                var encoder1 = new $81089639773113c2$export$30c99e08943e1c2();
                var hasContent1 = $81089639773113c2$var$writeUpdateMessageFromTransaction(encoder1, transaction);
                if (hasContent1) doc.emit('updateV2', [
                    encoder1.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            var subdocsAdded = transaction.subdocsAdded, subdocsLoaded = transaction.subdocsLoaded, subdocsRemoved = transaction.subdocsRemoved;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach(function(subdoc) {
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach(function(subdoc) {
                    return doc.subdocs["delete"](subdoc);
                });
                doc.emit('subdocs', [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach(function(subdoc) {
                    return subdoc.destroy();
                });
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit('afterAllTransactions', [
                    doc,
                    transactionCleanups
                ]);
            } else $81089639773113c2$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ var $81089639773113c2$export$dac1bad6146b2469 = function(doc, f) {
    var origin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, local = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var transactionCleanups = doc._transactionCleanups;
    var initialCall = false;
    /**
   * @type {any}
   */ var result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $81089639773113c2$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit('beforeAllTransactions', [
            doc
        ]);
        doc.emit('beforeTransaction', [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            var finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $81089639773113c2$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
var $81089639773113c2$var$StackItem = function StackItem(deletions, insertions) {
    "use strict";
    (0, $3CDbU._)(this, StackItem);
    this.insertions = insertions;
    this.deletions = deletions;
    /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
};
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ var $81089639773113c2$var$clearUndoManagerStackItem = function(tr, um, stackItem) {
    $81089639773113c2$export$8afefebbaf4e4c78(tr, stackItem.deletions, function(item) {
        if (item instanceof $81089639773113c2$export$6d08773d2e66f8f2 && um.scope.some(function(type) {
            return type === tr.doc || $81089639773113c2$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item);
        })) $81089639773113c2$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ var $81089639773113c2$var$popStackItem = function(undoManager, stack, eventType) {
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ var _tr = null;
    var doc = undoManager.doc;
    var scope = undoManager.scope;
    $81089639773113c2$export$dac1bad6146b2469(doc, function(transaction) {
        var _loop = function() {
            var store = doc.store;
            var stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ var itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ var itemsToDelete = [];
            var performedChange = false;
            $81089639773113c2$export$8afefebbaf4e4c78(transaction, stackItem.insertions, function(struct) {
                if (struct instanceof $81089639773113c2$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        var _followRedone = $81089639773113c2$var$followRedone(store, struct.id), item = _followRedone.item, diff = _followRedone.diff;
                        if (diff > 0) item = $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some(function(type) {
                        return type === transaction.doc || $81089639773113c2$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, /** @type {Item} */ struct);
                    })) itemsToDelete.push(struct);
                }
            });
            $81089639773113c2$export$8afefebbaf4e4c78(transaction, stackItem.deletions, function(struct) {
                if (struct instanceof $81089639773113c2$export$6d08773d2e66f8f2 && scope.some(function(type) {
                    return type === transaction.doc || $81089639773113c2$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, struct);
                }) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$81089639773113c2$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach(function(struct) {
                performedChange = $81089639773113c2$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(var i = itemsToDelete.length - 1; i >= 0; i--){
                var item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item["delete"](transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        };
        while(stack.length > 0 && undoManager.currStackItem === null)_loop();
        transaction.changed.forEach(function(subProps, type) {
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    var res = undoManager.currStackItem;
    if (res != null) {
        var changedParentTypes = _tr.changedParentTypes;
        undoManager.emit('stack-item-popped', [
            {
                stackItem: res,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return res;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ var $81089639773113c2$export$932a3f9a7e88971c = /*#__PURE__*/ function(ObservableV2) {
    "use strict";
    (0, $jCmGC._)(UndoManager, ObservableV2);
    function UndoManager(typeScope) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_captureTimeout = _ref.captureTimeout, captureTimeout = _ref_captureTimeout === void 0 ? 500 : _ref_captureTimeout, _ref_captureTransaction = _ref.captureTransaction, captureTransaction = _ref_captureTransaction === void 0 ? function(_tr) {
            return true;
        } : _ref_captureTransaction, _ref_deleteFilter = _ref.deleteFilter, deleteFilter = _ref_deleteFilter === void 0 ? function() {
            return true;
        } : _ref_deleteFilter, _ref_trackedOrigins = _ref.trackedOrigins, trackedOrigins = _ref_trackedOrigins === void 0 ? new Set([
            null
        ]) : _ref_trackedOrigins, _ref_ignoreRemoteMapChanges = _ref.ignoreRemoteMapChanges, ignoreRemoteMapChanges = _ref_ignoreRemoteMapChanges === void 0 ? false : _ref_ignoreRemoteMapChanges, _ref_doc = _ref.doc, doc = _ref_doc === void 0 ? /** @type {Doc} */ $397ju.isArray(typeScope) ? typeScope[0].doc : typeScope instanceof $81089639773113c2$export$bceacc74c2212615 ? typeScope : typeScope.doc : _ref_doc;
        (0, $3CDbU._)(this, UndoManager);
        var _this;
        _this = (0, $ep9cZ._)(this, UndoManager);
        /**
     * @type {Array<AbstractType<any> | Doc>}
     */ _this.scope = [];
        _this.doc = doc;
        _this.addToScope(typeScope);
        _this.deleteFilter = deleteFilter;
        trackedOrigins.add(_this);
        _this.trackedOrigins = trackedOrigins;
        _this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ _this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ _this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ _this.undoing = false;
        _this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ _this.currStackItem = null;
        _this.lastChange = 0;
        _this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        _this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ _this.afterTransactionHandler = function(transaction) {
            // Only track certain transactions
            if (!_this.captureTransaction(transaction) || !_this.scope.some(function(type) {
                return transaction.changedParentTypes.has(/** @type {AbstractType<any>} */ type) || type === _this.doc;
            }) || !_this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !_this.trackedOrigins.has(transaction.origin.constructor))) return;
            var undoing = _this.undoing;
            var redoing = _this.redoing;
            var stack = undoing ? _this.redoStack : _this.undoStack;
            if (undoing) _this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            _this.clear(false, true);
            var insertions = new $81089639773113c2$var$DeleteSet();
            transaction.afterState.forEach(function(endClock, client) {
                var startClock = transaction.beforeState.get(client) || 0;
                var len = endClock - startClock;
                if (len > 0) $81089639773113c2$var$addToDeleteSet(insertions, client, startClock, len);
            });
            var now = $gL882.getUnixTime();
            var didAdd = false;
            if (_this.lastChange > 0 && now - _this.lastChange < _this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                var lastOp = stack[stack.length - 1];
                lastOp.deletions = $81089639773113c2$export$b7826cadad53901e([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $81089639773113c2$export$b7826cadad53901e([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $81089639773113c2$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) _this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $81089639773113c2$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ function(item) {
                if (item instanceof $81089639773113c2$export$6d08773d2e66f8f2 && _this.scope.some(function(type) {
                    return type === transaction.doc || $81089639773113c2$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item);
                })) $81089639773113c2$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ var changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? 'redo' : 'undo',
                    changedParentTypes: transaction.changedParentTypes
                },
                _this
            ];
            if (didAdd) _this.emit('stack-item-added', changeEvent);
            else _this.emit('stack-item-updated', changeEvent);
        };
        _this.doc.on('afterTransaction', _this.afterTransactionHandler);
        _this.doc.on('destroy', function() {
            _this.destroy();
        });
        return _this;
    }
    (0, $jyA4z._)(UndoManager, [
        {
            /**
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */ key: "addToScope",
            value: function addToScope(ytypes) {
                var _this = this;
                var tmpSet = new Set(this.scope);
                ytypes = $397ju.isArray(ytypes) ? ytypes : [
                    ytypes
                ];
                ytypes.forEach(function(ytype) {
                    if (!tmpSet.has(ytype)) {
                        tmpSet.add(ytype);
                        if (ytype instanceof $81089639773113c2$export$c265dc8338484497 ? ytype.doc !== _this.doc : ytype !== _this.doc) $6XDMd.warn('[yjs#509] Not same Y.Doc'); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                        _this.scope.push(ytype);
                    }
                });
            }
        },
        {
            /**
   * @param {any} origin
   */ key: "addTrackedOrigin",
            value: function addTrackedOrigin(origin) {
                this.trackedOrigins.add(origin);
            }
        },
        {
            /**
   * @param {any} origin
   */ key: "removeTrackedOrigin",
            value: function removeTrackedOrigin(origin) {
                this.trackedOrigins["delete"](origin);
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                var clearUndoStack = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, clearRedoStack = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact(function(tr) {
                    if (clearUndoStack) {
                        _this.undoStack.forEach(function(item) {
                            return $81089639773113c2$var$clearUndoManagerStackItem(tr, _this, item);
                        });
                        _this.undoStack = [];
                    }
                    if (clearRedoStack) {
                        _this.redoStack.forEach(function(item) {
                            return $81089639773113c2$var$clearUndoManagerStackItem(tr, _this, item);
                        });
                        _this.redoStack = [];
                    }
                    _this.emit('stack-cleared', [
                        {
                            undoStackCleared: clearUndoStack,
                            redoStackCleared: clearRedoStack
                        }
                    ]);
                });
            }
        },
        {
            /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ key: "stopCapturing",
            value: function stopCapturing() {
                this.lastChange = 0;
            }
        },
        {
            /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ key: "undo",
            value: function undo() {
                this.undoing = true;
                var res;
                try {
                    res = $81089639773113c2$var$popStackItem(this, this.undoStack, 'undo');
                } finally{
                    this.undoing = false;
                }
                return res;
            }
        },
        {
            /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ key: "redo",
            value: function redo() {
                this.redoing = true;
                var res;
                try {
                    res = $81089639773113c2$var$popStackItem(this, this.redoStack, 'redo');
                } finally{
                    this.redoing = false;
                }
                return res;
            }
        },
        {
            /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ key: "canUndo",
            value: function canUndo() {
                return this.undoStack.length > 0;
            }
        },
        {
            /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ key: "canRedo",
            value: function canRedo() {
                return this.redoStack.length > 0;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.trackedOrigins["delete"](this);
                this.doc.off('afterTransaction', this.afterTransactionHandler);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(UndoManager.prototype), "destroy", this).call(this);
            }
        }
    ]);
    return UndoManager;
}((0, $b78261e7e572625c$export$e23d3436ce401adc));
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function $81089639773113c2$var$lazyStructReaderGenerator(decoder) {
    var numOfStateUpdates, i, numberOfStructs, client, clock, i1, info, len, cantCopyParentInfo, struct, len1;
    return (0, $eJDpD.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                numOfStateUpdates = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
                i = 0;
                _state.label = 1;
            case 1:
                if (!(i < numOfStateUpdates)) return [
                    3,
                    10
                ];
                numberOfStructs = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
                client = decoder.readClient();
                clock = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
                i1 = 0;
                _state.label = 2;
            case 2:
                if (!(i1 < numberOfStructs)) return [
                    3,
                    9
                ];
                info = decoder.readInfo();
                if (!(info === 10)) return [
                    3,
                    4
                ];
                len = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder.restDecoder);
                return [
                    4,
                    new $81089639773113c2$export$38d24f5c1eb0e4c0($81089639773113c2$export$6c7d4e6171d008d0(client, clock), len)
                ];
            case 3:
                _state.sent();
                clock += len;
                return [
                    3,
                    8
                ];
            case 4:
                if (!(($eab0623b6aed22da$export$bc2aba63e4099c09 & info) !== 0)) return [
                    3,
                    6
                ];
                cantCopyParentInfo = (info & ($eab0623b6aed22da$export$eb5a8e0006ab4bb5 | $eab0623b6aed22da$export$e25597372303a045)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                struct = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(client, clock), null, (info & $eab0623b6aed22da$export$e25597372303a045) === $eab0623b6aed22da$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $eab0623b6aed22da$export$eb5a8e0006ab4bb5) === $eab0623b6aed22da$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $eab0623b6aed22da$export$daf23f774967089) === $eab0623b6aed22da$export$daf23f774967089 ? decoder.readString() : null, $81089639773113c2$var$readItemContent(decoder, info) // item content
                );
                return [
                    4,
                    struct
                ];
            case 5:
                _state.sent();
                clock += struct.length;
                return [
                    3,
                    8
                ];
            case 6:
                len1 = decoder.readLen();
                return [
                    4,
                    new $81089639773113c2$export$12d259ff017e6b58($81089639773113c2$export$6c7d4e6171d008d0(client, clock), len1)
                ];
            case 7:
                _state.sent();
                clock += len1;
                _state.label = 8;
            case 8:
                i1++;
                return [
                    3,
                    2
                ];
            case 9:
                i++;
                return [
                    3,
                    1
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
var $81089639773113c2$var$LazyStructReader = /*#__PURE__*/ function() {
    "use strict";
    function LazyStructReader(decoder, filterSkips) {
        (0, $3CDbU._)(this, LazyStructReader);
        this.gen = $81089639773113c2$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    (0, $jyA4z._)(LazyStructReader, [
        {
            /**
   * @return {Item | GC | Skip |null}
   */ key: "next",
            value: function next() {
                // ignore "Skip" structs
                do this.curr = this.gen.next().value || null;
                while (this.filterSkips && this.curr !== null && this.curr.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0);
                return this.curr;
            }
        }
    ]);
    return LazyStructReader;
}();
/**
 * @param {Uint8Array} update
 *
 */ var $81089639773113c2$export$d6235ced6e55ace9 = function(update) {
    return $81089639773113c2$export$624b3f0248c2dc40(update, $81089639773113c2$export$1aa46d9818b5d1ec);
};
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ var $81089639773113c2$export$624b3f0248c2dc40 = function(update) {
    var YDecoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81089639773113c2$export$1c932452355c5571;
    var structs = [];
    var updateDecoder = new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    var lazyDecoder = new $81089639773113c2$var$LazyStructReader(updateDecoder, false);
    for(var curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $6XDMd.print('Structs: ', structs);
    var ds = $81089639773113c2$var$readDeleteSet(updateDecoder);
    $6XDMd.print('DeleteSet: ', ds);
};
/**
 * @param {Uint8Array} update
 *
 */ var $81089639773113c2$export$aa45cba8121663dc = function(update) {
    return $81089639773113c2$export$2fed33908eb23d71(update, $81089639773113c2$export$1aa46d9818b5d1ec);
};
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ var $81089639773113c2$export$2fed33908eb23d71 = function(update) {
    var YDecoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81089639773113c2$export$1c932452355c5571;
    var structs = [];
    var updateDecoder = new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    var lazyDecoder = new $81089639773113c2$var$LazyStructReader(updateDecoder, false);
    for(var curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $81089639773113c2$var$readDeleteSet(updateDecoder)
    };
};
var $81089639773113c2$var$LazyStructWriter = function LazyStructWriter(encoder) {
    "use strict";
    (0, $3CDbU._)(this, LazyStructWriter);
    this.currClient = 0;
    this.startClock = 0;
    this.written = 0;
    this.encoder = encoder;
    /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
};
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ var $81089639773113c2$export$6319871659fd2460 = function(updates) {
    return $81089639773113c2$export$ce273d78de0331d1(updates, $81089639773113c2$export$1aa46d9818b5d1ec, $81089639773113c2$export$99171b804d9c5b54);
};
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ var $81089639773113c2$export$ed51750cf3ab2381 = function(update) {
    var YEncoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81089639773113c2$var$DSEncoderV2, YDecoder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $81089639773113c2$export$1c932452355c5571;
    var encoder = new YEncoder();
    var updateDecoder = new $81089639773113c2$var$LazyStructReader(new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update)), false);
    var curr = updateDecoder.curr;
    if (curr !== null) {
        var size = 0;
        var currClient = curr.id.client;
        var stopCounting = curr.id.clock !== 0; // must start at 0
        var currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, currClient);
                    $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, currClient);
            $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        var enc = $917f0b264ff88d53$export$4e76eeb6df88c889();
        $917f0b264ff88d53$export$872f48c75febcd2b(enc, size);
        $917f0b264ff88d53$export$c029b62321ea3da(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ var $81089639773113c2$export$5c451fd8502b011f = function(update) {
    return $81089639773113c2$export$ed51750cf3ab2381(update, $81089639773113c2$var$DSEncoderV1, $81089639773113c2$export$1aa46d9818b5d1ec);
};
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ var $81089639773113c2$export$8212a58b2178fdcf = function(update) {
    var YDecoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81089639773113c2$export$1c932452355c5571;
    /**
   * @type {Map<number, number>}
   */ var from = new Map();
    /**
   * @type {Map<number, number>}
   */ var to = new Map();
    var updateDecoder = new $81089639773113c2$var$LazyStructReader(new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update)), false);
    var curr = updateDecoder.curr;
    if (curr !== null) {
        var currClient = curr.id.client;
        var currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ var $81089639773113c2$export$e212b06fd4bf78fd = function(update) {
    return $81089639773113c2$export$8212a58b2178fdcf(update, $81089639773113c2$export$1aa46d9818b5d1ec);
};
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ var $81089639773113c2$var$sliceStruct = function(left, diff) {
    if (left.constructor === $81089639773113c2$export$12d259ff017e6b58) {
        var _left_id = left.id, client = _left_id.client, clock = _left_id.clock;
        return new $81089639773113c2$export$12d259ff017e6b58($81089639773113c2$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0) {
        var _left_id1 = left.id, client1 = _left_id1.client, clock1 = _left_id1.clock;
        return new $81089639773113c2$export$38d24f5c1eb0e4c0($81089639773113c2$export$6c7d4e6171d008d0(client1, clock1 + diff), left.length - diff);
    } else {
        var leftItem = /** @type {Item} */ left;
        var _leftItem_id = leftItem.id, client2 = _leftItem_id.client, clock2 = _leftItem_id.clock;
        return new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(client2, clock2 + diff), null, $81089639773113c2$export$6c7d4e6171d008d0(client2, clock2 + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ var $81089639773113c2$export$ce273d78de0331d1 = function(updates) {
    var YDecoder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81089639773113c2$export$1c932452355c5571, YEncoder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $81089639773113c2$export$30c99e08943e1c2;
    if (updates.length === 1) return updates[0];
    var updateDecoders = updates.map(function(update) {
        return new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    });
    var lazyStructDecoders = updateDecoders.map(function(decoder) {
        return new $81089639773113c2$var$LazyStructReader(decoder, true);
    });
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ var currWrite = null;
    var updateEncoder = new YEncoder();
    // write structs lazily
    var lazyStructEncoder = new $81089639773113c2$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter(function(dec) {
            return dec.curr !== null;
        });
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ function(dec1, dec2) {
            if (dec1.curr.id.client === dec2.curr.id.client) {
                var clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        var currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        var firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            var curr = /** @type {Item | GC | null} */ currDecoder.curr;
            var iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    var diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ var struct = new $81089639773113c2$export$38d24f5c1eb0e4c0($81089639773113c2$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                var diff1 = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff1 > 0) {
                    if (currWrite.struct.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff1;
                    else curr = $81089639773113c2$var$sliceStruct(curr, diff1);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(var next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $81089639773113c2$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $81089639773113c2$var$finishLazyStructWriting(lazyStructEncoder);
    var dss = updateDecoders.map(function(decoder) {
        return $81089639773113c2$var$readDeleteSet(decoder);
    });
    var ds = $81089639773113c2$export$b7826cadad53901e(dss);
    $81089639773113c2$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ var $81089639773113c2$export$a8143edf39d2ad8e = function(update, sv) {
    var YDecoder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $81089639773113c2$export$1c932452355c5571, YEncoder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $81089639773113c2$export$30c99e08943e1c2;
    var state = $81089639773113c2$export$324ac6fb20a844e3(sv);
    var encoder = new YEncoder();
    var lazyStructWriter = new $81089639773113c2$var$LazyStructWriter(encoder);
    var decoder = new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    var reader = new $81089639773113c2$var$LazyStructReader(decoder, false);
    while(reader.curr){
        var curr = reader.curr;
        var currClient = curr.id.client;
        var svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $81089639773113c2$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $02E42.max(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $81089639773113c2$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $81089639773113c2$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    var ds = $81089639773113c2$var$readDeleteSet(decoder);
    $81089639773113c2$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ var $81089639773113c2$export$bf60b51d6c283426 = function(update, sv) {
    return $81089639773113c2$export$a8143edf39d2ad8e(update, sv, $81089639773113c2$export$1aa46d9818b5d1ec, $81089639773113c2$export$99171b804d9c5b54);
};
/**
 * @param {LazyStructWriter} lazyWriter
 */ var $81089639773113c2$var$flushLazyStructWriter = function(lazyWriter) {
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $917f0b264ff88d53$export$73470fd2221e6aef(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ var $81089639773113c2$var$writeStructToLazyStructWriter = function(lazyWriter, struct, offset) {
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $81089639773113c2$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $917f0b264ff88d53$export$872f48c75febcd2b(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ var $81089639773113c2$var$finishLazyStructWriting = function(lazyWriter) {
    $81089639773113c2$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    var restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $917f0b264ff88d53$export$872f48c75febcd2b(restEncoder, lazyWriter.clientStructs.length);
    for(var i = 0; i < lazyWriter.clientStructs.length; i++){
        var partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $917f0b264ff88d53$export$872f48c75febcd2b(restEncoder, partStructs.written);
        // write the rest of the fragment
        $917f0b264ff88d53$export$73b5e63e27d2b4c7(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ var $81089639773113c2$var$convertUpdateFormat = function(update, blockTransformer, YDecoder, YEncoder) {
    var updateDecoder = new YDecoder($182bfc4830c83d2c$export$f8c898e83b60faaa(update));
    var lazyDecoder = new $81089639773113c2$var$LazyStructReader(updateDecoder, false);
    var updateEncoder = new YEncoder();
    var lazyWriter = new $81089639773113c2$var$LazyStructWriter(updateEncoder);
    for(var curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$81089639773113c2$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $81089639773113c2$var$finishLazyStructWriting(lazyWriter);
    var ds = $81089639773113c2$var$readDeleteSet(updateDecoder);
    $81089639773113c2$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ var $81089639773113c2$var$createObfuscator = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_formatting = _ref.formatting, formatting = _ref_formatting === void 0 ? true : _ref_formatting, _ref_subdocs = _ref.subdocs, subdocs = _ref_subdocs === void 0 ? true : _ref_subdocs, _ref_yxml = _ref.yxml, yxml = _ref_yxml === void 0 ? true : _ref_yxml;
    var i = 0;
    var mapKeyCache = $89wqq.create();
    var nodeNameCache = $89wqq.create();
    var formattingKeyCache = $89wqq.create();
    var formattingValueCache = $89wqq.create();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return function(block) {
        switch(block.constructor){
            case $81089639773113c2$export$12d259ff017e6b58:
            case $81089639773113c2$export$38d24f5c1eb0e4c0:
                return block;
            case $81089639773113c2$export$6d08773d2e66f8f2:
                {
                    var item = /** @type {Item} */ block;
                    var content = item.content;
                    switch(content.constructor){
                        case $81089639773113c2$export$3b06e0b3a2ece602:
                            break;
                        case $81089639773113c2$export$e2e108cbe2e4f865:
                            if (yxml) {
                                var type = /** @type {ContentType} */ content.type;
                                if (type instanceof $81089639773113c2$export$4db87581d3ca170d) type.nodeName = $89wqq.setIfUndefined(nodeNameCache, type.nodeName, function() {
                                    return 'node-' + i;
                                });
                                if (type instanceof $81089639773113c2$export$ec64c1dd5e7a264) type.hookName = $89wqq.setIfUndefined(nodeNameCache, type.hookName, function() {
                                    return 'hook-' + i;
                                });
                            }
                            break;
                        case $81089639773113c2$export$1d788b93bbb631a0:
                            {
                                var c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(function() {
                                    return i;
                                });
                                break;
                            }
                        case $81089639773113c2$export$e8d530cdf62d1cbd:
                            {
                                var c1 = /** @type {ContentBinary} */ content;
                                c1.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $81089639773113c2$export$b564c0e69572c0e:
                            {
                                var c2 = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c2.opts = {};
                                    c2.doc.guid = i + '';
                                }
                                break;
                            }
                        case $81089639773113c2$export$c3787ba7f6086664:
                            {
                                var c3 = /** @type {ContentEmbed} */ content;
                                c3.embed = {};
                                break;
                            }
                        case $81089639773113c2$export$3194899188fb5a88:
                            {
                                var c4 = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c4.key = $89wqq.setIfUndefined(formattingKeyCache, c4.key, function() {
                                        return i + '';
                                    });
                                    c4.value = $89wqq.setIfUndefined(formattingValueCache, c4.value, function() {
                                        return {
                                            i: i
                                        };
                                    });
                                }
                                break;
                            }
                        case $81089639773113c2$export$6a907ea8f733ecf3:
                            {
                                var c5 = /** @type {ContentJSON} */ content;
                                c5.arr = c5.arr.map(function() {
                                    return i;
                                });
                                break;
                            }
                        case $81089639773113c2$export$ee670b2cf091bbb6:
                            {
                                var c6 = /** @type {ContentString} */ content;
                                c6.str = $80Ijr.repeat(i % 10 + '', c6.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $4338d6312e5ee7d6$export$965b6bccecbd9673();
                    }
                    if (item.parentSub) item.parentSub = $89wqq.setIfUndefined(mapKeyCache, item.parentSub, function() {
                        return i + '';
                    });
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $4338d6312e5ee7d6$export$965b6bccecbd9673();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ var $81089639773113c2$export$2dc24d59ec48a24e = function(update, opts) {
    return $81089639773113c2$var$convertUpdateFormat(update, $81089639773113c2$var$createObfuscator(opts), $81089639773113c2$export$1aa46d9818b5d1ec, $81089639773113c2$export$99171b804d9c5b54);
};
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ var $81089639773113c2$export$90648fb14f8c31aa = function(update, opts) {
    return $81089639773113c2$var$convertUpdateFormat(update, $81089639773113c2$var$createObfuscator(opts), $81089639773113c2$export$1c932452355c5571, $81089639773113c2$export$30c99e08943e1c2);
};
/**
 * @param {Uint8Array} update
 */ var $81089639773113c2$export$162408325d5832c = function(update) {
    return $81089639773113c2$var$convertUpdateFormat(update, $1PYZG.id, $81089639773113c2$export$1aa46d9818b5d1ec, $81089639773113c2$export$30c99e08943e1c2);
};
/**
 * @param {Uint8Array} update
 */ var $81089639773113c2$export$afffbdeed14adbd = function(update) {
    return $81089639773113c2$var$convertUpdateFormat(update, $1PYZG.id, $81089639773113c2$export$1c932452355c5571, $81089639773113c2$export$99171b804d9c5b54);
};
var $81089639773113c2$var$errorComputeChanges = 'You must not compute changes after the event-handler fired.';
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ var $81089639773113c2$export$80fac438977fb51c = /*#__PURE__*/ function() {
    "use strict";
    function YEvent(target, transaction) {
        (0, $3CDbU._)(this, YEvent);
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
    (0, $jyA4z._)(YEvent, [
        {
            key: "path",
            get: /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ function get() {
                return this._path || (this._path = $81089639773113c2$var$getPathTo(this.currentTarget, this.target));
            }
        },
        {
            /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ key: "deletes",
            value: function deletes(struct) {
                return $81089639773113c2$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
            }
        },
        {
            key: "keys",
            get: /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ function get() {
                var _this = this;
                if (this._keys === null) {
                    if (this.transaction.doc._transactionCleanups.length === 0) throw $4338d6312e5ee7d6$export$185802fd694ee1f5($81089639773113c2$var$errorComputeChanges);
                    var keys = new Map();
                    var target = this.target;
                    var changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
                    changed.forEach(function(key) {
                        if (key !== null) {
                            var item = /** @type {Item} */ target._map.get(key);
                            /**
           * @type {'delete' | 'add' | 'update'}
           */ var action;
                            var oldValue;
                            if (_this.adds(item)) {
                                var prev = item.left;
                                while(prev !== null && _this.adds(prev))prev = prev.left;
                                if (_this.deletes(item)) {
                                    if (prev !== null && _this.deletes(prev)) {
                                        action = 'delete';
                                        oldValue = $397ju.last(prev.content.getContent());
                                    } else return;
                                } else if (prev !== null && _this.deletes(prev)) {
                                    action = 'update';
                                    oldValue = $397ju.last(prev.content.getContent());
                                } else {
                                    action = 'add';
                                    oldValue = undefined;
                                }
                            } else {
                                if (_this.deletes(item)) {
                                    action = 'delete';
                                    oldValue = $397ju.last(/** @type {Item} */ item.content.getContent());
                                } else return; // nop
                            }
                            keys.set(key, {
                                action: action,
                                oldValue: oldValue
                            });
                        }
                    });
                    this._keys = keys;
                }
                return this._keys;
            }
        },
        {
            key: "delta",
            get: /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ function get() {
                return this.changes.delta;
            }
        },
        {
            /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ key: "adds",
            value: function adds(struct) {
                return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
            }
        },
        {
            key: "changes",
            get: /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ function get() {
                var changes = this._changes;
                if (changes === null) {
                    if (this.transaction.doc._transactionCleanups.length === 0) throw $4338d6312e5ee7d6$export$185802fd694ee1f5($81089639773113c2$var$errorComputeChanges);
                    var target = this.target;
                    var added = $kgvSK.create();
                    var deleted = $kgvSK.create();
                    /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ var delta = [];
                    changes = {
                        added: added,
                        deleted: deleted,
                        delta: delta,
                        keys: this.keys
                    };
                    var changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
                    if (changed.has(null)) {
                        /**
         * @type {any}
         */ var lastOp = null;
                        var packOp = function() {
                            if (lastOp) delta.push(lastOp);
                        };
                        for(var item = target._start; item !== null; item = item.right){
                            if (item.deleted) {
                                if (this.deletes(item) && !this.adds(item)) {
                                    if (lastOp === null || lastOp["delete"] === undefined) {
                                        packOp();
                                        lastOp = {
                                            "delete": 0
                                        };
                                    }
                                    lastOp["delete"] += item.length;
                                    deleted.add(item);
                                } // else nop
                            } else if (this.adds(item)) {
                                if (lastOp === null || lastOp.insert === undefined) {
                                    packOp();
                                    lastOp = {
                                        insert: []
                                    };
                                }
                                lastOp.insert = lastOp.insert.concat(item.content.getContent());
                                added.add(item);
                            } else {
                                if (lastOp === null || lastOp.retain === undefined) {
                                    packOp();
                                    lastOp = {
                                        retain: 0
                                    };
                                }
                                lastOp.retain += item.length;
                            }
                        }
                        if (lastOp !== null && lastOp.retain === undefined) packOp();
                    }
                    this._changes = changes;
                }
                return /** @type {any} */ changes;
            }
        }
    ]);
    return YEvent;
}();
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ var $81089639773113c2$var$getPathTo = function(parent, child) {
    var path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            var i = 0;
            var c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted && c.countable) i += c.length;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
/**
 * https://docs.yjs.dev/getting-started/working-with-shared-types#caveats
 */ var $81089639773113c2$var$warnPrematureAccess = function() {
    $6XDMd.warn('Invalid access: Add Yjs type to a document before reading data.');
};
var $81089639773113c2$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ var $81089639773113c2$var$globalSearchMarkerTimestamp = 0;
var $81089639773113c2$var$ArraySearchMarker = function ArraySearchMarker(p, index) {
    "use strict";
    (0, $3CDbU._)(this, ArraySearchMarker);
    p.marker = true;
    this.p = p;
    this.index = index;
    this.timestamp = $81089639773113c2$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {ArraySearchMarker} marker
 */ var $81089639773113c2$var$refreshMarkerTimestamp = function(marker) {
    marker.timestamp = $81089639773113c2$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ var $81089639773113c2$var$overwriteMarker = function(marker, p, index) {
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $81089639773113c2$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ var $81089639773113c2$var$markPosition = function(searchMarker, p, index) {
    if (searchMarker.length >= $81089639773113c2$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        var marker = searchMarker.reduce(function(a, b) {
            return a.timestamp < b.timestamp ? a : b;
        });
        $81089639773113c2$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        var pm = new $81089639773113c2$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ var $81089639773113c2$var$findMarker = function(yarray, index) {
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    var marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce(function(a, b) {
        return $02E42.abs(index - a.index) < $02E42.abs(index - b.index) ? a : b;
    });
    var p = yarray._start;
    var pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $81089639773113c2$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengths == null) {
    //     window.lengths = []
    //     window.getLengths = () => window.lengths.sort((a, b) => a - b)
    //   }
    //   window.lengths.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $02E42.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $81089639773113c2$var$maxSearchMarker) {
        // adjust existing marker
        $81089639773113c2$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $81089639773113c2$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ var $81089639773113c2$var$updateMarkerChanges = function(searchMarker, index, len) {
    for(var i = searchMarker.length - 1; i >= 0; i--){
        var m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ var p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $02E42.max(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ var $81089639773113c2$export$5418d693f13991b3 = function(t) {
    var _t_doc;
    (_t_doc = t.doc) !== null && _t_doc !== void 0 ? _t_doc : $81089639773113c2$var$warnPrematureAccess();
    var s = t._start;
    var arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ var $81089639773113c2$var$callTypeObservers = function(type, transaction, event) {
    var changedType = type;
    var changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $89wqq.setIfUndefined(changedParentTypes, type, function() {
            return [];
        }).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $81089639773113c2$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ var $81089639773113c2$export$c265dc8338484497 = /*#__PURE__*/ function() {
    "use strict";
    function AbstractType() {
        (0, $3CDbU._)(this, AbstractType);
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $81089639773113c2$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $81089639773113c2$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    (0, $jyA4z._)(AbstractType, [
        {
            key: "parent",
            get: /**
   * @return {AbstractType<any>|null}
   */ function get() {
                return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
            }
        },
        {
            /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                this.doc = y;
                this._item = item;
            }
        },
        {
            /**
   * @return {AbstractType<EventType>}
   */ key: "_copy",
            value: function _copy() {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */ key: "clone",
            value: function clone() {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ key: "_write",
            value: function _write(_encoder) {}
        },
        {
            key: "_first",
            get: /**
   * The first non-deleted item
   */ function get() {
                var n = this._start;
                while(n !== null && n.deleted)n = n.right;
                return n;
            }
        },
        {
            /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ key: "_callObserver",
            value: function _callObserver(transaction, _parentSubs) {
                if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
            }
        },
        {
            /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ key: "observe",
            value: function observe(f) {
                $81089639773113c2$var$addEventHandlerListener(this._eH, f);
            }
        },
        {
            /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ key: "observeDeep",
            value: function observeDeep(f) {
                $81089639773113c2$var$addEventHandlerListener(this._dEH, f);
            }
        },
        {
            /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ key: "unobserve",
            value: function unobserve(f) {
                $81089639773113c2$var$removeEventHandlerListener(this._eH, f);
            }
        },
        {
            /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ key: "unobserveDeep",
            value: function unobserveDeep(f) {
                $81089639773113c2$var$removeEventHandlerListener(this._dEH, f);
            }
        },
        {
            /**
   * @abstract
   * @return {any}
   */ key: "toJSON",
            value: function toJSON() {}
        }
    ]);
    return AbstractType;
}();
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListSlice = function(type, start, end) {
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $81089639773113c2$var$warnPrematureAccess();
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    var len = end - start;
    var cs = [];
    var n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            var c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(var i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListToArray = function(type) {
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $81089639773113c2$var$warnPrematureAccess();
    var cs = [];
    var n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            var c = n.content.getContent();
            for(var i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$9de42b6dda4c7e48 = function(type, snapshot) {
    var cs = [];
    var n = type._start;
    while(n !== null){
        if (n.countable && $81089639773113c2$var$isVisible(n, snapshot)) {
            var c = n.content.getContent();
            for(var i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on every element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListForEach = function(type, f) {
    var index = 0;
    var n = type._start;
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $81089639773113c2$var$warnPrematureAccess();
    while(n !== null){
        if (n.countable && !n.deleted) {
            var c = n.content.getContent();
            for(var i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListMap = function(type, f) {
    /**
   * @type {Array<any>}
   */ var result = [];
    $81089639773113c2$var$typeListForEach(type, function(c, i) {
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListCreateIterator = function(type) {
    var n = type._start;
    /**
   * @type {Array<any>|null}
   */ var currentContent = null;
    var currentContentIndex = 0;
    var _obj;
    return _obj = {}, (0, $fEm89._)(_obj, Symbol.iterator, function() {
        return this;
    }), (0, $fEm89._)(_obj, "next", function() {
        // find some content
        if (currentContent === null) {
            while(n !== null && n.deleted)n = n.right;
            // check if we reached the end, no need to check currentContent, because it does not exist
            if (n === null) return {
                done: true,
                value: undefined
            };
            // we found n, so we can set currentContent
            currentContent = n.content.getContent();
            currentContentIndex = 0;
            n = n.right; // we used the content of n, now iterate to next
        }
        var value = currentContent[currentContentIndex++];
        // check if we need to empty currentContent
        if (currentContent.length <= currentContentIndex) currentContent = null;
        return {
            done: false,
            value: value
        };
    }), _obj;
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListGet = function(type, index) {
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $81089639773113c2$var$warnPrematureAccess();
    var marker = $81089639773113c2$var$findMarker(type, index);
    var n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListInsertGenericsAfter = function(transaction, parent, referenceItem, content) {
    var left = referenceItem;
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    var store = doc.store;
    var right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ var jsonContent = [];
    var packJsonContent = function() {
        if (jsonContent.length > 0) {
            left = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach(function(c) {
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $81089639773113c2$export$bceacc74c2212615:
                        left = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $81089639773113c2$export$c265dc8338484497) {
                            left = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error('Unexpected content type in insert operation');
                }
        }
    });
    packJsonContent();
};
var $81089639773113c2$var$lengthExceeded = function() {
    return $4338d6312e5ee7d6$export$185802fd694ee1f5('Length exceeded!');
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListInsertGenerics = function(transaction, parent, index, content) {
    if (index > parent._length) throw $81089639773113c2$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $81089639773113c2$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $81089639773113c2$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    var startIndex = index;
    var marker = $81089639773113c2$var$findMarker(parent, index);
    var n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $81089639773113c2$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $81089639773113c2$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the search marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListPushGenerics = function(transaction, parent, content) {
    // Use the marker with the highest index and iterate to the right.
    var marker = (parent._searchMarker || []).reduce(function(maxMarker, currMarker) {
        return currMarker.index > maxMarker.index ? currMarker : maxMarker;
    }, {
        index: 0,
        p: parent._start
    });
    var n = marker.p;
    if (n) while(n.right)n = n.right;
    return $81089639773113c2$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeListDelete = function(transaction, parent, index, length) {
    if (length === 0) return;
    var startIndex = index;
    var startLength = length;
    var marker = $81089639773113c2$var$findMarker(parent, index);
    var n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n["delete"](transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $81089639773113c2$var$lengthExceeded();
    if (parent._searchMarker) $81089639773113c2$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeMapDelete = function(transaction, parent, key) {
    var c = parent._map.get(key);
    if (c !== undefined) c["delete"](transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeMapSet = function(transaction, parent, key, value) {
    var left = parent._map.get(key) || null;
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    var content;
    if (value == null) content = new $81089639773113c2$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $81089639773113c2$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $81089639773113c2$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $81089639773113c2$export$bceacc74c2212615:
            content = new $81089639773113c2$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $81089639773113c2$export$c265dc8338484497) content = new $81089639773113c2$export$e2e108cbe2e4f865(value);
            else throw new Error('Unexpected content type');
    }
    new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeMapGet = function(parent, key) {
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $81089639773113c2$var$warnPrematureAccess();
    var val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeMapGetAll = function(parent) {
    /**
   * @type {Object<string,any>}
   */ var res = {};
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $81089639773113c2$var$warnPrematureAccess();
    parent._map.forEach(function(value, key) {
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$typeMapHas = function(parent, key) {
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $81089639773113c2$var$warnPrematureAccess();
    var val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$a7c089bf6c22a1db = function(parent, key, snapshot) {
    var v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $81089639773113c2$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ var $81089639773113c2$export$7769bdedaef2c91b = function(parent, snapshot) {
    /**
   * @type {Object<string,any>}
   */ var res = {};
    parent._map.forEach(function(value, key) {
        /**
     * @type {Item|null}
     */ var v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $81089639773113c2$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any> & { _map: Map<string, Item> }} type
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$createMapIterator = function(type) {
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $81089639773113c2$var$warnPrematureAccess();
    return $17002e7fafa8640f$export$88f0b2eef157f31a(type._map.entries(), /** @param {any} entry */ function(entry) {
        return !entry[1].deleted;
    });
};
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ var $81089639773113c2$export$a095f7fee639264a = /*#__PURE__*/ function(YEvent) {
    "use strict";
    (0, $jCmGC._)(YArrayEvent, YEvent);
    function YArrayEvent() {
        (0, $3CDbU._)(this, YArrayEvent);
        return (0, $ep9cZ._)(this, YArrayEvent, arguments);
    }
    return YArrayEvent;
}($81089639773113c2$export$80fac438977fb51c);
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ var $81089639773113c2$export$c4be6576ca6fe4aa = /*#__PURE__*/ function(AbstractType1) {
    "use strict";
    (0, $jCmGC._)(YArray, AbstractType1);
    function YArray() {
        (0, $3CDbU._)(this, YArray);
        var _this;
        _this = (0, $ep9cZ._)(this, YArray);
        /**
     * @type {Array<any>?}
     * @private
     */ _this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ _this._searchMarker = [];
        return _this;
    }
    (0, $jyA4z._)(YArray, [
        {
            /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YArray.prototype), "_integrate", this).call(this, y, item);
                this.insert(0, /** @type {Array<any>} */ this._prelimContent);
                this._prelimContent = null;
            }
        },
        {
            /**
   * @return {YArray<T>}
   */ key: "_copy",
            value: function _copy() {
                return new YArray();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */ key: "clone",
            value: function clone() {
                /**
     * @type {YArray<T>}
     */ var arr = new YArray();
                arr.insert(0, this.toArray().map(function(el) {
                    return el instanceof $81089639773113c2$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el;
                }));
                return arr;
            }
        },
        {
            key: "length",
            get: function get() {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                return this._length;
            }
        },
        {
            /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ key: "_callObserver",
            value: function _callObserver(transaction, parentSubs) {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YArray.prototype), "_callObserver", this).call(this, transaction, parentSubs);
                $81089639773113c2$var$callTypeObservers(this, transaction, new $81089639773113c2$export$a095f7fee639264a(this, transaction));
            }
        },
        {
            /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ key: "insert",
            value: function insert(index, content) {
                var _this = this;
                var /** @type {Array<any>} */ _this__prelimContent;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeListInsertGenerics(transaction, _this, index, /** @type {any} */ content);
                });
                else (_this__prelimContent = this._prelimContent).splice.apply(_this__prelimContent, [
                    index,
                    0
                ].concat((0, $78NO5._)(content)));
            }
        },
        {
            /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ key: "push",
            value: function push(content) {
                var _this = this;
                var /** @type {Array<any>} */ _this__prelimContent;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeListPushGenerics(transaction, _this, /** @type {any} */ content);
                });
                else (_this__prelimContent = this._prelimContent).push.apply(_this__prelimContent, (0, $78NO5._)(content));
            }
        },
        {
            /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */ key: "unshift",
            value: function unshift(content) {
                this.insert(0, content);
            }
        },
        {
            /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ key: "delete",
            value: function _delete(index) {
                var _this = this;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeListDelete(transaction, _this, index, length);
                });
                else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
            }
        },
        {
            /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ key: "get",
            value: function get(index) {
                return $81089639773113c2$var$typeListGet(this, index);
            }
        },
        {
            /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ key: "toArray",
            value: function toArray() {
                return $81089639773113c2$var$typeListToArray(this);
            }
        },
        {
            /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ key: "slice",
            value: function slice() {
                var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length;
                return $81089639773113c2$var$typeListSlice(this, start, end);
            }
        },
        {
            /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ key: "toJSON",
            value: function toJSON() {
                return this.map(function(c) {
                    return c instanceof $81089639773113c2$export$c265dc8338484497 ? c.toJSON() : c;
                });
            }
        },
        {
            /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ key: "map",
            value: function map(f) {
                return $81089639773113c2$var$typeListMap(this, /** @type {any} */ f);
            }
        },
        {
            /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ key: "forEach",
            value: function forEach(f) {
                $81089639773113c2$var$typeListForEach(this, f);
            }
        },
        {
            /**
   * @return {IterableIterator<T>}
   */ key: Symbol.iterator,
            value: function value() {
                return $81089639773113c2$var$typeListCreateIterator(this);
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YArrayRefID);
            }
        }
    ], [
        {
            key: "from",
            value: /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ function from(items) {
                /**
     * @type {YArray<T>}
     */ var a = new YArray();
                a.push(items);
                return a;
            }
        }
    ]);
    return YArray;
}($81089639773113c2$export$c265dc8338484497);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYArray = function(_decoder) {
    return new $81089639773113c2$export$c4be6576ca6fe4aa();
};
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ var $81089639773113c2$export$33aab1b1a47c1cc3 = /*#__PURE__*/ function(YEvent) {
    "use strict";
    (0, $jCmGC._)(YMapEvent, YEvent);
    function YMapEvent(ymap, transaction, subs) {
        (0, $3CDbU._)(this, YMapEvent);
        var _this;
        _this = (0, $ep9cZ._)(this, YMapEvent, [
            ymap,
            transaction
        ]);
        _this.keysChanged = subs;
        return _this;
    }
    return YMapEvent;
}($81089639773113c2$export$80fac438977fb51c);
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ var $81089639773113c2$export$a5c7b93649eaf8f8 = /*#__PURE__*/ function(AbstractType1) {
    "use strict";
    (0, $jCmGC._)(YMap, AbstractType1);
    function YMap(entries) {
        (0, $3CDbU._)(this, YMap);
        var _this;
        _this = (0, $ep9cZ._)(this, YMap);
        /**
     * @type {Map<string,any>?}
     * @private
     */ _this._prelimContent = null;
        if (entries === undefined) _this._prelimContent = new Map();
        else _this._prelimContent = new Map(entries);
        return _this;
    }
    (0, $jyA4z._)(YMap, [
        {
            /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                var _this = this;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YMap.prototype), "_integrate", this).call(this, y, item); /** @type {Map<string, any>} */ 
                this._prelimContent.forEach(function(value, key) {
                    _this.set(key, value);
                });
                this._prelimContent = null;
            }
        },
        {
            /**
   * @return {YMap<MapType>}
   */ key: "_copy",
            value: function _copy() {
                return new YMap();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */ key: "clone",
            value: function clone() {
                /**
     * @type {YMap<MapType>}
     */ var map = new YMap();
                this.forEach(function(value, key) {
                    map.set(key, value instanceof $81089639773113c2$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
                });
                return map;
            }
        },
        {
            /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ key: "_callObserver",
            value: function _callObserver(transaction, parentSubs) {
                $81089639773113c2$var$callTypeObservers(this, transaction, new $81089639773113c2$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
            }
        },
        {
            /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ key: "toJSON",
            value: function toJSON() {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                /**
     * @type {Object<string,MapType>}
     */ var map = {};
                this._map.forEach(function(item, key) {
                    if (!item.deleted) {
                        var v = item.content.getContent()[item.length - 1];
                        map[key] = v instanceof $81089639773113c2$export$c265dc8338484497 ? v.toJSON() : v;
                    }
                });
                return map;
            }
        },
        {
            key: "size",
            get: /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ function get() {
                return (0, $78NO5._)($81089639773113c2$var$createMapIterator(this)).length;
            }
        },
        {
            /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ key: "keys",
            value: function keys() {
                return $17002e7fafa8640f$export$1570d514f543056a($81089639773113c2$var$createMapIterator(this), /** @param {any} v */ function(v) {
                    return v[0];
                });
            }
        },
        {
            /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ key: "values",
            value: function values() {
                return $17002e7fafa8640f$export$1570d514f543056a($81089639773113c2$var$createMapIterator(this), /** @param {any} v */ function(v) {
                    return v[1].content.getContent()[v[1].length - 1];
                });
            }
        },
        {
            /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ key: "entries",
            value: function entries() {
                return $17002e7fafa8640f$export$1570d514f543056a($81089639773113c2$var$createMapIterator(this), /** @param {any} v */ function(v) {
                    return /** @type {any} */ [
                        v[0],
                        v[1].content.getContent()[v[1].length - 1]
                    ];
                });
            }
        },
        {
            /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ key: "forEach",
            value: function forEach(f) {
                var _this = this;
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                this._map.forEach(function(item, key) {
                    if (!item.deleted) f(item.content.getContent()[item.length - 1], key, _this);
                });
            }
        },
        {
            /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ key: "delete",
            value: function _delete(key) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapDelete(transaction, _this, key);
                });
                else /** @type {Map<string, any>} */ this._prelimContent["delete"](key);
            }
        },
        {
            /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ key: "set",
            value: function set(key, value) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapSet(transaction, _this, key, /** @type {any} */ value);
                });
                else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
                return value;
            }
        },
        {
            /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ key: "get",
            value: function get(key) {
                return /** @type {any} */ $81089639773113c2$var$typeMapGet(this, key);
            }
        },
        {
            /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ key: "has",
            value: function has(key) {
                return $81089639773113c2$var$typeMapHas(this, key);
            }
        },
        {
            /**
   * Removes all elements from this YMap.
   */ key: "clear",
            value: function clear() {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    _this.forEach(function(_value, key, map) {
                        $81089639773113c2$var$typeMapDelete(transaction, map, key);
                    });
                });
                else /** @type {Map<string, any>} */ this._prelimContent.clear();
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YMapRefID);
            }
        }
    ]);
    return YMap;
}($81089639773113c2$export$c265dc8338484497);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYMap = function(_decoder) {
    return new $81089639773113c2$export$a5c7b93649eaf8f8();
};
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ var $81089639773113c2$var$equalAttrs = function(a, b) {
    return a === b || (typeof a === "undefined" ? "undefined" : (0, $7tffA._)(a)) === 'object' && (typeof b === "undefined" ? "undefined" : (0, $7tffA._)(b)) === 'object' && a && b && $eCHRC.equalFlat(a, b);
};
var $81089639773113c2$var$ItemTextListPosition = /*#__PURE__*/ function() {
    "use strict";
    function ItemTextListPosition(left, right, index, currentAttributes) {
        (0, $3CDbU._)(this, ItemTextListPosition);
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    (0, $jyA4z._)(ItemTextListPosition, [
        {
            /**
   * Only call this if you know that this.right is defined
   */ key: "forward",
            value: function forward() {
                if (this.right === null) $4338d6312e5ee7d6$export$965b6bccecbd9673();
                switch(this.right.content.constructor){
                    case $81089639773113c2$export$3194899188fb5a88:
                        if (!this.right.deleted) $81089639773113c2$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                        break;
                    default:
                        if (!this.right.deleted) this.index += this.right.length;
                        break;
                }
                this.left = this.right;
                this.right = this.right.right;
            }
        }
    ]);
    return ItemTextListPosition;
}();
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$findNextPosition = function(transaction, pos, count) {
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $81089639773113c2$export$3194899188fb5a88:
                if (!pos.right.deleted) $81089639773113c2$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$findPosition = function(transaction, parent, index, useSearchMarker) {
    var currentAttributes = new Map();
    var marker = useSearchMarker ? $81089639773113c2$var$findMarker(parent, index) : null;
    if (marker) {
        var pos = new $81089639773113c2$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $81089639773113c2$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        var pos1 = new $81089639773113c2$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $81089639773113c2$var$findNextPosition(transaction, pos1, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ var $81089639773113c2$var$insertNegatedAttributes = function(transaction, parent, currPos, negatedAttributes) {
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $81089639773113c2$export$3194899188fb5a88 && $81089639773113c2$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes["delete"](/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    negatedAttributes.forEach(function(val, key) {
        var left = currPos.left;
        var right = currPos.right;
        var nextFormat = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ var $81089639773113c2$var$updateCurrentAttributes = function(currentAttributes, format) {
    var key = format.key, value = format.value;
    if (value === null) currentAttributes["delete"](key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ var $81089639773113c2$var$minimizeAttributeChanges = function(currPos, attributes) {
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        var _attributes_currPos_right_content_key;
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $81089639773113c2$export$3194899188fb5a88 && $81089639773113c2$var$equalAttrs((_attributes_currPos_right_content_key = attributes[/** @type {ContentFormat} */ currPos.right.content.key]) !== null && _attributes_currPos_right_content_key !== void 0 ? _attributes_currPos_right_content_key : null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ var $81089639773113c2$var$insertAttributes = function(transaction, parent, currPos, attributes) {
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    var negatedAttributes = new Map();
    // insert format-start items
    for(var key in attributes){
        var val = attributes[key];
        var _currPos_currentAttributes_get;
        var currentVal = (_currPos_currentAttributes_get = currPos.currentAttributes.get(key)) !== null && _currPos_currentAttributes_get !== void 0 ? _currPos_currentAttributes_get : null;
        if (!$81089639773113c2$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            var left = currPos.left, right = currPos.right;
            currPos.right = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $81089639773113c2$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ var $81089639773113c2$var$insertText = function(transaction, parent, currPos, text, attributes) {
    currPos.currentAttributes.forEach(function(_val, key) {
        if (attributes[key] === undefined) attributes[key] = null;
    });
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    $81089639773113c2$var$minimizeAttributeChanges(currPos, attributes);
    var negatedAttributes = $81089639773113c2$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    var content = text.constructor === String ? new $81089639773113c2$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $81089639773113c2$export$c265dc8338484497 ? new $81089639773113c2$export$e2e108cbe2e4f865(text) : new $81089639773113c2$export$c3787ba7f6086664(text);
    var left = currPos.left, right = currPos.right, index = currPos.index;
    if (parent._searchMarker) $81089639773113c2$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $81089639773113c2$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ var $81089639773113c2$var$formatText = function(transaction, parent, currPos, length, attributes) {
    var doc = transaction.doc;
    var ownClientId = doc.clientID;
    $81089639773113c2$var$minimizeAttributeChanges(currPos, attributes);
    var negatedAttributes = $81089639773113c2$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $81089639773113c2$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $81089639773113c2$export$3194899188fb5a88:
                {
                    var /** @type {ContentFormat} */ _currPos_right_content = currPos.right.content, key = _currPos_right_content.key, value = _currPos_right_content.value;
                    var attr = attributes[key];
                    if (attr !== undefined) {
                        if ($81089639773113c2$var$equalAttrs(attr, value)) negatedAttributes["delete"](key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right["delete"](transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        var newlines = '';
        for(; length > 0; length--)newlines += '\n';
        currPos.right = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(ownClientId, $81089639773113c2$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $81089639773113c2$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $81089639773113c2$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ var $81089639773113c2$var$cleanupFormattingGap = function(transaction, start, curr, startAttributes, currAttributes) {
    /**
   * @type {Item|null}
   */ var end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ var endFormats = $89wqq.create();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $81089639773113c2$export$3194899188fb5a88) {
            var cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    var cleanups = 0;
    var reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            var content = start.content;
            switch(content.constructor){
                case $81089639773113c2$export$3194899188fb5a88:
                    {
                        var key = /** @type {ContentFormat} */ content.key, value = content.value;
                        var _startAttributes_get;
                        var startAttrValue = (_startAttributes_get = startAttributes.get(key)) !== null && _startAttributes_get !== void 0 ? _startAttributes_get : null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start["delete"](transaction);
                            cleanups++;
                            var _currAttributes_get;
                            if (!reachedCurr && ((_currAttributes_get = currAttributes.get(key)) !== null && _currAttributes_get !== void 0 ? _currAttributes_get : null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes["delete"](key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $81089639773113c2$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ var $81089639773113c2$var$cleanupContextlessFormattingGap = function(transaction, item) {
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    var attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $81089639773113c2$export$3194899188fb5a88) {
            var key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item["delete"](transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ var $81089639773113c2$export$5d9f53c13ebffb65 = function(type) {
    var res = 0;
    $81089639773113c2$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, function(transaction) {
        var start = /** @type {Item} */ type._start;
        var end = type._start;
        var startAttributes = $89wqq.create();
        var currentAttributes = $89wqq.copy(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $81089639773113c2$export$3194899188fb5a88:
                    $81089639773113c2$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $81089639773113c2$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $89wqq.copy(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transaction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ var $81089639773113c2$var$cleanupYTextAfterTransaction = function(transaction) {
    /**
   * @type {Set<YText>}
   */ var needFullCleanup = new Set();
    // check if another formatting item was inserted
    var doc = transaction.doc;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = transaction.afterState.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $bN2zx._)(_step.value, 2), client = _step_value[0], afterClock = _step_value[1];
            var clock = transaction.beforeState.get(client) || 0;
            if (afterClock === clock) continue;
            $81089639773113c2$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, function(item) {
                if (!item.deleted && /** @type {Item} */ item.content.constructor === $81089639773113c2$export$3194899188fb5a88 && item.constructor !== $81089639773113c2$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // cleanup in a new transaction
    $81089639773113c2$export$dac1bad6146b2469(doc, function(t) {
        $81089639773113c2$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, function(item) {
            if (item instanceof $81089639773113c2$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            var parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $81089639773113c2$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $81089639773113c2$var$cleanupContextlessFormattingGap(t, item);
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // If a formatting item was inserted, we simply clean the whole type.
            // We need to compute currentAttributes for the current position anyway.
            for(var _iterator = needFullCleanup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var yText = _step.value;
                $81089639773113c2$export$5d9f53c13ebffb65(yText);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$deleteText = function(transaction, currPos, length) {
    var startLength = length;
    var startAttrs = $89wqq.copy(currPos.currentAttributes);
    var start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $81089639773113c2$export$e2e108cbe2e4f865:
            case $81089639773113c2$export$c3787ba7f6086664:
            case $81089639773113c2$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $81089639773113c2$export$e550586ad633138d(transaction, $81089639773113c2$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right["delete"](transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $81089639773113c2$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    var parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $81089639773113c2$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For more information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ var $81089639773113c2$export$51155b8ebb74188a = /*#__PURE__*/ function(YEvent) {
    "use strict";
    (0, $jCmGC._)(YTextEvent, YEvent);
    function YTextEvent(ytext, transaction, subs) {
        (0, $3CDbU._)(this, YTextEvent);
        var _this;
        _this = (0, $ep9cZ._)(this, YTextEvent, [
            ytext,
            transaction
        ]);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ _this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ _this.keysChanged = new Set();
        subs.forEach(function(sub) {
            if (sub === null) _this.childListChanged = true;
            else _this.keysChanged.add(sub);
        });
        return _this;
    }
    (0, $jyA4z._)(YTextEvent, [
        {
            key: "changes",
            get: /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ function get() {
                if (this._changes === null) {
                    /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ var changes = {
                        keys: this.keys,
                        delta: this.delta,
                        added: new Set(),
                        deleted: new Set()
                    };
                    this._changes = changes;
                }
                return /** @type {any} */ this._changes;
            }
        },
        {
            key: "delta",
            get: /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ function get() {
                var _this = this;
                if (this._delta === null) {
                    var y = /** @type {Doc} */ this.target.doc;
                    /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ var delta = [];
                    $81089639773113c2$export$dac1bad6146b2469(y, function(transaction) {
                        var currentAttributes = new Map(); // saves all current attributes for insert
                        var oldAttributes = new Map();
                        var item = _this.target._start;
                        /**
         * @type {string?}
         */ var action = null;
                        /**
         * @type {Object<string,any>}
         */ var attributes = {}; // counts added or removed new attributes for retain
                        /**
         * @type {string|object}
         */ var insert = '';
                        var retain = 0;
                        var deleteLen = 0;
                        var addOp = function() {
                            if (action !== null) {
                                /**
             * @type {any}
             */ var op = null;
                                switch(action){
                                    case 'delete':
                                        if (deleteLen > 0) op = {
                                            "delete": deleteLen
                                        };
                                        deleteLen = 0;
                                        break;
                                    case 'insert':
                                        if ((typeof insert === "undefined" ? "undefined" : (0, $7tffA._)(insert)) === 'object' || insert.length > 0) {
                                            op = {
                                                insert: insert
                                            };
                                            if (currentAttributes.size > 0) {
                                                op.attributes = {};
                                                currentAttributes.forEach(function(value, key) {
                                                    if (value !== null) op.attributes[key] = value;
                                                });
                                            }
                                        }
                                        insert = '';
                                        break;
                                    case 'retain':
                                        if (retain > 0) {
                                            op = {
                                                retain: retain
                                            };
                                            if (!$eCHRC.isEmpty(attributes)) op.attributes = $eCHRC.assign({}, attributes);
                                        }
                                        retain = 0;
                                        break;
                                }
                                if (op) delta.push(op);
                                action = null;
                            }
                        };
                        while(item !== null){
                            switch(item.content.constructor){
                                case $81089639773113c2$export$e2e108cbe2e4f865:
                                case $81089639773113c2$export$c3787ba7f6086664:
                                    if (_this.adds(item)) {
                                        if (!_this.deletes(item)) {
                                            addOp();
                                            action = 'insert';
                                            insert = item.content.getContent()[0];
                                            addOp();
                                        }
                                    } else if (_this.deletes(item)) {
                                        if (action !== 'delete') {
                                            addOp();
                                            action = 'delete';
                                        }
                                        deleteLen += 1;
                                    } else if (!item.deleted) {
                                        if (action !== 'retain') {
                                            addOp();
                                            action = 'retain';
                                        }
                                        retain += 1;
                                    }
                                    break;
                                case $81089639773113c2$export$ee670b2cf091bbb6:
                                    if (_this.adds(item)) {
                                        if (!_this.deletes(item)) {
                                            if (action !== 'insert') {
                                                addOp();
                                                action = 'insert';
                                            }
                                            insert += /** @type {ContentString} */ item.content.str;
                                        }
                                    } else if (_this.deletes(item)) {
                                        if (action !== 'delete') {
                                            addOp();
                                            action = 'delete';
                                        }
                                        deleteLen += item.length;
                                    } else if (!item.deleted) {
                                        if (action !== 'retain') {
                                            addOp();
                                            action = 'retain';
                                        }
                                        retain += item.length;
                                    }
                                    break;
                                case $81089639773113c2$export$3194899188fb5a88:
                                    {
                                        var /** @type {ContentFormat} */ _item_content = item.content, key = _item_content.key, value = _item_content.value;
                                        if (_this.adds(item)) {
                                            if (!_this.deletes(item)) {
                                                var _currentAttributes_get;
                                                var curVal = (_currentAttributes_get = currentAttributes.get(key)) !== null && _currentAttributes_get !== void 0 ? _currentAttributes_get : null;
                                                if (!$81089639773113c2$var$equalAttrs(curVal, value)) {
                                                    if (action === 'retain') addOp();
                                                    var _oldAttributes_get;
                                                    if ($81089639773113c2$var$equalAttrs(value, (_oldAttributes_get = oldAttributes.get(key)) !== null && _oldAttributes_get !== void 0 ? _oldAttributes_get : null)) delete attributes[key];
                                                    else attributes[key] = value;
                                                } else if (value !== null) item["delete"](transaction);
                                            }
                                        } else if (_this.deletes(item)) {
                                            oldAttributes.set(key, value);
                                            var _currentAttributes_get1;
                                            var curVal1 = (_currentAttributes_get1 = currentAttributes.get(key)) !== null && _currentAttributes_get1 !== void 0 ? _currentAttributes_get1 : null;
                                            if (!$81089639773113c2$var$equalAttrs(curVal1, value)) {
                                                if (action === 'retain') addOp();
                                                attributes[key] = curVal1;
                                            }
                                        } else if (!item.deleted) {
                                            oldAttributes.set(key, value);
                                            var attr = attributes[key];
                                            if (attr !== undefined) {
                                                if (!$81089639773113c2$var$equalAttrs(attr, value)) {
                                                    if (action === 'retain') addOp();
                                                    if (value === null) delete attributes[key];
                                                    else attributes[key] = value;
                                                } else if (attr !== null) item["delete"](transaction);
                                            }
                                        }
                                        if (!item.deleted) {
                                            if (action === 'insert') addOp();
                                            $81089639773113c2$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                        }
                                        break;
                                    }
                            }
                            item = item.right;
                        }
                        addOp();
                        while(delta.length > 0){
                            var lastOp = delta[delta.length - 1];
                            if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                            delta.pop();
                            else break;
                        }
                    });
                    this._delta = delta;
                }
                return /** @type {any} */ this._delta;
            }
        }
    ]);
    return YTextEvent;
}($81089639773113c2$export$80fac438977fb51c);
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ var $81089639773113c2$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(AbstractType) {
    "use strict";
    (0, $jCmGC._)(YText, AbstractType);
    function YText(string) {
        (0, $3CDbU._)(this, YText);
        var _this;
        _this = (0, $ep9cZ._)(this, YText);
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ _this._pending = string !== undefined ? [
            function() {
                return _this.insert(0, string);
            }
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ _this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ _this._hasFormatting = false;
        return _this;
    }
    (0, $jyA4z._)(YText, [
        {
            key: "length",
            get: /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ function get() {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                return this._length;
            }
        },
        {
            /**
   * @param {Doc} y
   * @param {Item} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YText.prototype), "_integrate", this).call(this, y, item);
                try {
                    /** @type {Array<function>} */ this._pending.forEach(function(f) {
                        return f();
                    });
                } catch (e) {
                    console.error(e);
                }
                this._pending = null;
            }
        },
        {
            key: "_copy",
            value: function _copy() {
                return new YText();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */ key: "clone",
            value: function clone() {
                var text = new YText();
                text.applyDelta(this.toDelta());
                return text;
            }
        },
        {
            /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ key: "_callObserver",
            value: function _callObserver(transaction, parentSubs) {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YText.prototype), "_callObserver", this).call(this, transaction, parentSubs);
                var event = new $81089639773113c2$export$51155b8ebb74188a(this, transaction, parentSubs);
                $81089639773113c2$var$callTypeObservers(this, transaction, event);
                // If a remote change happened, we try to cleanup potential formatting duplicates.
                if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
            }
        },
        {
            /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ key: "toString",
            value: function toString() {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                var str = '';
                /**
     * @type {Item|null}
     */ var n = this._start;
                while(n !== null){
                    if (!n.deleted && n.countable && n.content.constructor === $81089639773113c2$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
                    n = n.right;
                }
                return str;
            }
        },
        {
            /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ key: "applyDelta",
            value: function applyDelta(delta) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_sanitize = _ref.sanitize, sanitize = _ref_sanitize === void 0 ? true : _ref_sanitize;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    var currPos = new $81089639773113c2$var$ItemTextListPosition(null, _this._start, 0, new Map());
                    for(var i = 0; i < delta.length; i++){
                        var op = delta[i];
                        if (op.insert !== undefined) {
                            // Quill assumes that the content starts with an empty paragraph.
                            // Yjs/Y.Text assumes that it starts empty. We always hide that
                            // there is a newline at the end of the content.
                            // If we omit this step, clients will see a different number of
                            // paragraphs, but nothing bad will happen.
                            var ins = !sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n' ? op.insert.slice(0, -1) : op.insert;
                            if (typeof ins !== 'string' || ins.length > 0) $81089639773113c2$var$insertText(transaction, _this, currPos, ins, op.attributes || {});
                        } else if (op.retain !== undefined) $81089639773113c2$var$formatText(transaction, _this, currPos, op.retain, op.attributes || {});
                        else if (op["delete"] !== undefined) $81089639773113c2$var$deleteText(transaction, currPos, op["delete"]);
                    }
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.applyDelta(delta);
                });
            }
        },
        {
            /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ key: "toDelta",
            value: function toDelta(snapshot, prevSnapshot, computeYChange) {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                /**
     * @type{Array<any>}
     */ var ops = [];
                var currentAttributes = new Map();
                var doc = /** @type {Doc} */ this.doc;
                var str = '';
                var n = this._start;
                function packStr() {
                    if (str.length > 0) {
                        // pack str with attributes to ops
                        /**
         * @type {Object<string,any>}
         */ var attributes = {};
                        var addAttributes = false;
                        currentAttributes.forEach(function(value, key) {
                            addAttributes = true;
                            attributes[key] = value;
                        });
                        /**
         * @type {Object<string,any>}
         */ var op = {
                            insert: str
                        };
                        if (addAttributes) op.attributes = attributes;
                        ops.push(op);
                        str = '';
                    }
                }
                var computeDelta = function() {
                    var _loop = function() {
                        if ($81089639773113c2$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $81089639773113c2$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                            case $81089639773113c2$export$ee670b2cf091bbb6:
                                {
                                    var cur = currentAttributes.get('ychange');
                                    if (snapshot !== undefined && !$81089639773113c2$var$isVisible(n, snapshot)) {
                                        if (cur === undefined || cur.user !== n.id.client || cur.type !== 'removed') {
                                            packStr();
                                            currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : {
                                                type: 'removed'
                                            });
                                        }
                                    } else if (prevSnapshot !== undefined && !$81089639773113c2$var$isVisible(n, prevSnapshot)) {
                                        if (cur === undefined || cur.user !== n.id.client || cur.type !== 'added') {
                                            packStr();
                                            currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : {
                                                type: 'added'
                                            });
                                        }
                                    } else if (cur !== undefined) {
                                        packStr();
                                        currentAttributes["delete"]('ychange');
                                    }
                                    str += /** @type {ContentString} */ n.content.str;
                                    break;
                                }
                            case $81089639773113c2$export$e2e108cbe2e4f865:
                            case $81089639773113c2$export$c3787ba7f6086664:
                                {
                                    packStr();
                                    /**
               * @type {Object<string,any>}
               */ var op = {
                                        insert: n.content.getContent()[0]
                                    };
                                    if (currentAttributes.size > 0) {
                                        var attrs = /** @type {Object<string,any>} */ {};
                                        op.attributes = attrs;
                                        currentAttributes.forEach(function(value, key) {
                                            attrs[key] = value;
                                        });
                                    }
                                    ops.push(op);
                                    break;
                                }
                            case $81089639773113c2$export$3194899188fb5a88:
                                if ($81089639773113c2$var$isVisible(n, snapshot)) {
                                    packStr();
                                    $81089639773113c2$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                                }
                                break;
                        }
                        n = n.right;
                    };
                    while(n !== null)_loop();
                    packStr();
                };
                if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
                // transaction alive until we are done
                $81089639773113c2$export$dac1bad6146b2469(doc, function(transaction) {
                    if (snapshot) $81089639773113c2$var$splitSnapshotAffectedStructs(transaction, snapshot);
                    if (prevSnapshot) $81089639773113c2$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
                    computeDelta();
                }, 'cleanup');
                else computeDelta();
                return ops;
            }
        },
        {
            /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ key: "insert",
            value: function insert(index, text, attributes) {
                var _this = this;
                if (text.length <= 0) return;
                var y = this.doc;
                if (y !== null) $81089639773113c2$export$dac1bad6146b2469(y, function(transaction) {
                    var pos = $81089639773113c2$var$findPosition(transaction, _this, index, !attributes);
                    if (!attributes) {
                        attributes = {};
                        // @ts-ignore
                        pos.currentAttributes.forEach(function(v, k) {
                            attributes[k] = v;
                        });
                    }
                    $81089639773113c2$var$insertText(transaction, _this, pos, text, attributes);
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.insert(index, text, attributes);
                });
            }
        },
        {
            /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ key: "insertEmbed",
            value: function insertEmbed(index, embed, attributes) {
                var _this = this;
                var y = this.doc;
                if (y !== null) $81089639773113c2$export$dac1bad6146b2469(y, function(transaction) {
                    var pos = $81089639773113c2$var$findPosition(transaction, _this, index, !attributes);
                    $81089639773113c2$var$insertText(transaction, _this, pos, embed, attributes || {});
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.insertEmbed(index, embed, attributes || {});
                });
            }
        },
        {
            /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ key: "delete",
            value: function _delete(index, length) {
                var _this = this;
                if (length === 0) return;
                var y = this.doc;
                if (y !== null) $81089639773113c2$export$dac1bad6146b2469(y, function(transaction) {
                    $81089639773113c2$var$deleteText(transaction, $81089639773113c2$var$findPosition(transaction, _this, index, true), length);
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this["delete"](index, length);
                });
            }
        },
        {
            /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ key: "format",
            value: function format(index, length, attributes) {
                var _this = this;
                if (length === 0) return;
                var y = this.doc;
                if (y !== null) $81089639773113c2$export$dac1bad6146b2469(y, function(transaction) {
                    var pos = $81089639773113c2$var$findPosition(transaction, _this, index, false);
                    if (pos.right === null) return;
                    $81089639773113c2$var$formatText(transaction, _this, pos, length, attributes);
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.format(index, length, attributes);
                });
            }
        },
        {
            /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ key: "removeAttribute",
            value: function removeAttribute(attributeName) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapDelete(transaction, _this, attributeName);
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.removeAttribute(attributeName);
                });
            }
        },
        {
            /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ key: "setAttribute",
            value: function setAttribute(attributeName, attributeValue) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapSet(transaction, _this, attributeName, attributeValue);
                });
                else /** @type {Array<function>} */ this._pending.push(function() {
                    return _this.setAttribute(attributeName, attributeValue);
                });
            }
        },
        {
            /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ key: "getAttribute",
            value: function getAttribute(attributeName) {
                return /** @type {any} */ $81089639773113c2$var$typeMapGet(this, attributeName);
            }
        },
        {
            /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ key: "getAttributes",
            value: function getAttributes() {
                return $81089639773113c2$var$typeMapGetAll(this);
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YTextRefID);
            }
        }
    ]);
    return YText;
}($81089639773113c2$export$c265dc8338484497);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYText = function(_decoder) {
    return new $81089639773113c2$export$5f1af8db9871e1d6();
};
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ var $81089639773113c2$var$YXmlTreeWalker = /*#__PURE__*/ function() {
    "use strict";
    function YXmlTreeWalker(root) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
            return true;
        };
        (0, $3CDbU._)(this, YXmlTreeWalker);
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
        var _root_doc;
        (_root_doc = root.doc) !== null && _root_doc !== void 0 ? _root_doc : $81089639773113c2$var$warnPrematureAccess();
    }
    (0, $jyA4z._)(YXmlTreeWalker, [
        {
            key: Symbol.iterator,
            value: function value() {
                return this;
            }
        },
        {
            /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ key: "next",
            value: function next() {
                /**
     * @type {Item|null}
     */ var n = this._currentNode;
                var type = n && n.content && /** @type {any} */ n.content.type;
                if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
                    type = /** @type {any} */ n.content.type;
                    if (!n.deleted && (type.constructor === $81089639773113c2$export$4db87581d3ca170d || type.constructor === $81089639773113c2$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
                    n = type._start;
                    else // walk right or up in the tree
                    while(n !== null){
                        /**
             * @type {Item | null}
             */ var nxt = n.next;
                        if (nxt !== null) {
                            n = nxt;
                            break;
                        } else if (n.parent === this._root) n = null;
                        else n = /** @type {AbstractType<any>} */ n.parent._item;
                    }
                }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
                this._firstCall = false;
                if (n === null) // @ts-ignore
                return {
                    value: undefined,
                    done: true
                };
                this._currentNode = n;
                return {
                    value: /** @type {any} */ n.content.type,
                    done: false
                };
            }
        }
    ]);
    return YXmlTreeWalker;
}();
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ var $81089639773113c2$export$d5ce8c3e1731f1a7 = /*#__PURE__*/ function(AbstractType1) {
    "use strict";
    (0, $jCmGC._)(YXmlFragment, AbstractType1);
    function YXmlFragment() {
        (0, $3CDbU._)(this, YXmlFragment);
        var _this;
        _this = (0, $ep9cZ._)(this, YXmlFragment);
        /**
     * @type {Array<any>|null}
     */ _this._prelimContent = [];
        return _this;
    }
    (0, $jyA4z._)(YXmlFragment, [
        {
            key: "firstChild",
            get: /**
   * @type {YXmlElement|YXmlText|null}
   */ function get() {
                var first = this._first;
                return first ? first.content.getContent()[0] : null;
            }
        },
        {
            /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YXmlFragment.prototype), "_integrate", this).call(this, y, item);
                this.insert(0, /** @type {Array<any>} */ this._prelimContent);
                this._prelimContent = null;
            }
        },
        {
            key: "_copy",
            value: function _copy() {
                return new YXmlFragment();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */ key: "clone",
            value: function clone() {
                var el = new YXmlFragment();
                // @ts-ignore
                el.insert(0, this.toArray().map(function(item) {
                    return item instanceof $81089639773113c2$export$c265dc8338484497 ? item.clone() : item;
                }));
                return el;
            }
        },
        {
            key: "length",
            get: function get() {
                var _this_doc;
                (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $81089639773113c2$var$warnPrematureAccess();
                return this._prelimContent === null ? this._length : this._prelimContent.length;
            }
        },
        {
            /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ key: "createTreeWalker",
            value: function createTreeWalker(filter) {
                return new $81089639773113c2$var$YXmlTreeWalker(this, filter);
            }
        },
        {
            /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ key: "querySelector",
            value: function querySelector(query) {
                query = query.toUpperCase();
                // @ts-ignore
                var iterator = new $81089639773113c2$var$YXmlTreeWalker(this, function(element) {
                    return element.nodeName && element.nodeName.toUpperCase() === query;
                });
                var next = iterator.next();
                if (next.done) return null;
                else return next.value;
            }
        },
        {
            /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ key: "querySelectorAll",
            value: function querySelectorAll(query) {
                query = query.toUpperCase();
                // @ts-ignore
                return $397ju.from(new $81089639773113c2$var$YXmlTreeWalker(this, function(element) {
                    return element.nodeName && element.nodeName.toUpperCase() === query;
                }));
            }
        },
        {
            /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ key: "_callObserver",
            value: function _callObserver(transaction, parentSubs) {
                $81089639773113c2$var$callTypeObservers(this, transaction, new $81089639773113c2$export$88c9145a0c3b556c(this, parentSubs, transaction));
            }
        },
        {
            /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ key: "toString",
            value: function toString() {
                return $81089639773113c2$var$typeListMap(this, function(xml) {
                    return xml.toString();
                }).join('');
            }
        },
        {
            /**
   * @return {string}
   */ key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ key: "toDOM",
            value: function toDOM() {
                var _document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, binding = arguments.length > 2 ? arguments[2] : void 0;
                var fragment = _document.createDocumentFragment();
                if (binding !== undefined) binding._createAssociation(fragment, this);
                $81089639773113c2$var$typeListForEach(this, function(xmlType) {
                    fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
                });
                return fragment;
            }
        },
        {
            /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ key: "insert",
            value: function insert(index, content) {
                var _this = this;
                var // @ts-ignore _prelimContent is defined because this is not yet integrated
                _this__prelimContent;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeListInsertGenerics(transaction, _this, index, content);
                });
                else (_this__prelimContent = this._prelimContent).splice.apply(_this__prelimContent, [
                    index,
                    0
                ].concat((0, $78NO5._)(content)));
            }
        },
        {
            /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ key: "insertAfter",
            value: function insertAfter(ref, content) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    var refItem = ref && ref instanceof $81089639773113c2$export$c265dc8338484497 ? ref._item : ref;
                    $81089639773113c2$var$typeListInsertGenericsAfter(transaction, _this, refItem, content);
                });
                else {
                    var _pc;
                    var pc = /** @type {Array<any>} */ this._prelimContent;
                    var index = ref === null ? 0 : pc.findIndex(function(el) {
                        return el === ref;
                    }) + 1;
                    if (index === 0 && ref !== null) throw $4338d6312e5ee7d6$export$185802fd694ee1f5('Reference item not found');
                    (_pc = pc).splice.apply(_pc, [
                        index,
                        0
                    ].concat((0, $78NO5._)(content)));
                }
            }
        },
        {
            /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ key: "delete",
            value: function _delete(index) {
                var _this = this;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeListDelete(transaction, _this, index, length);
                });
                else // @ts-ignore _prelimContent is defined because this is not yet integrated
                this._prelimContent.splice(index, length);
            }
        },
        {
            /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ key: "toArray",
            value: function toArray() {
                return $81089639773113c2$var$typeListToArray(this);
            }
        },
        {
            /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ key: "push",
            value: function push(content) {
                this.insert(this.length, content);
            }
        },
        {
            /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */ key: "unshift",
            value: function unshift(content) {
                this.insert(0, content);
            }
        },
        {
            /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ key: "get",
            value: function get(index) {
                return $81089639773113c2$var$typeListGet(this, index);
            }
        },
        {
            /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ key: "slice",
            value: function slice() {
                var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length;
                return $81089639773113c2$var$typeListSlice(this, start, end);
            }
        },
        {
            /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ key: "forEach",
            value: function forEach(f) {
                $81089639773113c2$var$typeListForEach(this, f);
            }
        },
        {
            /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YXmlFragmentRefID);
            }
        }
    ]);
    return YXmlFragment;
}($81089639773113c2$export$c265dc8338484497);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYXmlFragment = function(_decoder) {
    return new $81089639773113c2$export$d5ce8c3e1731f1a7();
};
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ var $81089639773113c2$export$4db87581d3ca170d = /*#__PURE__*/ function(YXmlFragment) {
    "use strict";
    (0, $jCmGC._)(YXmlElement, YXmlFragment);
    function YXmlElement() {
        var nodeName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'UNDEFINED';
        (0, $3CDbU._)(this, YXmlElement);
        var _this;
        _this = (0, $ep9cZ._)(this, YXmlElement);
        _this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ _this._prelimAttrs = new Map();
        return _this;
    }
    (0, $jyA4z._)(YXmlElement, [
        {
            key: "nextSibling",
            get: /**
   * @type {YXmlElement|YXmlText|null}
   */ function get() {
                var n = this._item ? this._item.next : null;
                return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
            }
        },
        {
            key: "prevSibling",
            get: /**
   * @type {YXmlElement|YXmlText|null}
   */ function get() {
                var n = this._item ? this._item.prev : null;
                return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
            }
        },
        {
            /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ key: "_integrate",
            value: function _integrate(y, item) {
                var _this = this;
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YXmlElement.prototype), "_integrate", this).call(this, y, item);
                /** @type {Map<string, any>} */ this._prelimAttrs.forEach(function(value, key) {
                    _this.setAttribute(key, value);
                });
                this._prelimAttrs = null;
            }
        },
        {
            /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ key: "_copy",
            value: function _copy() {
                return new YXmlElement(this.nodeName);
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */ key: "clone",
            value: function clone() {
                /**
     * @type {YXmlElement<KV>}
     */ var el = new YXmlElement(this.nodeName);
                var attrs = this.getAttributes();
                $eCHRC.forEach(attrs, function(value, key) {
                    if (typeof value === 'string') el.setAttribute(key, value);
                });
                // @ts-ignore
                el.insert(0, this.toArray().map(function(item) {
                    return item instanceof $81089639773113c2$export$c265dc8338484497 ? item.clone() : item;
                }));
                return el;
            }
        },
        {
            /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ key: "toString",
            value: function toString() {
                var attrs = this.getAttributes();
                var stringBuilder = [];
                var keys = [];
                for(var key in attrs)keys.push(key);
                keys.sort();
                var keysLen = keys.length;
                for(var i = 0; i < keysLen; i++){
                    var key1 = keys[i];
                    stringBuilder.push(key1 + '="' + attrs[key1] + '"');
                }
                var nodeName = this.nodeName.toLocaleLowerCase();
                var attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
                return "<".concat(nodeName).concat(attrsString, ">").concat((0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(YXmlElement.prototype), "toString", this).call(this), "</").concat(nodeName, ">");
            }
        },
        {
            /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ key: "removeAttribute",
            value: function removeAttribute(attributeName) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapDelete(transaction, _this, attributeName);
                });
                else /** @type {Map<string,any>} */ this._prelimAttrs["delete"](attributeName);
            }
        },
        {
            /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ key: "setAttribute",
            value: function setAttribute(attributeName, attributeValue) {
                var _this = this;
                if (this.doc !== null) $81089639773113c2$export$dac1bad6146b2469(this.doc, function(transaction) {
                    $81089639773113c2$var$typeMapSet(transaction, _this, attributeName, attributeValue);
                });
                else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
            }
        },
        {
            /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ key: "getAttribute",
            value: function getAttribute(attributeName) {
                return /** @type {any} */ $81089639773113c2$var$typeMapGet(this, attributeName);
            }
        },
        {
            /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ key: "hasAttribute",
            value: function hasAttribute(attributeName) {
                return /** @type {any} */ $81089639773113c2$var$typeMapHas(this, attributeName);
            }
        },
        {
            /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ key: "getAttributes",
            value: function getAttributes(snapshot) {
                return /** @type {any} */ snapshot ? $81089639773113c2$export$7769bdedaef2c91b(this, snapshot) : $81089639773113c2$var$typeMapGetAll(this);
            }
        },
        {
            /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ key: "toDOM",
            value: function toDOM() {
                var _document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, binding = arguments.length > 2 ? arguments[2] : void 0;
                var dom = _document.createElement(this.nodeName);
                var attrs = this.getAttributes();
                for(var key in attrs){
                    var value = attrs[key];
                    if (typeof value === 'string') dom.setAttribute(key, value);
                }
                $81089639773113c2$var$typeListForEach(this, function(yxml) {
                    dom.appendChild(yxml.toDOM(_document, hooks, binding));
                });
                if (binding !== undefined) binding._createAssociation(dom, this);
                return dom;
            }
        },
        {
            /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YXmlElementRefID);
                encoder.writeKey(this.nodeName);
            }
        }
    ]);
    return YXmlElement;
}($81089639773113c2$export$d5ce8c3e1731f1a7);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ var $81089639773113c2$var$readYXmlElement = function(decoder) {
    return new $81089639773113c2$export$4db87581d3ca170d(decoder.readKey());
};
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ var $81089639773113c2$export$88c9145a0c3b556c = /*#__PURE__*/ function(YEvent) {
    "use strict";
    (0, $jCmGC._)(YXmlEvent, YEvent);
    function YXmlEvent(target, subs, transaction) {
        (0, $3CDbU._)(this, YXmlEvent);
        var _this;
        _this = (0, $ep9cZ._)(this, YXmlEvent, [
            target,
            transaction
        ]);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ _this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ _this.attributesChanged = new Set();
        subs.forEach(function(sub) {
            if (sub === null) _this.childListChanged = true;
            else _this.attributesChanged.add(sub);
        });
        return _this;
    }
    return YXmlEvent;
}($81089639773113c2$export$80fac438977fb51c);
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ var $81089639773113c2$export$ec64c1dd5e7a264 = /*#__PURE__*/ function(YMap) {
    "use strict";
    (0, $jCmGC._)(YXmlHook, YMap);
    function YXmlHook(hookName) {
        (0, $3CDbU._)(this, YXmlHook);
        var _this;
        _this = (0, $ep9cZ._)(this, YXmlHook);
        /**
     * @type {string}
     */ _this.hookName = hookName;
        return _this;
    }
    (0, $jyA4z._)(YXmlHook, [
        {
            /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ key: "_copy",
            value: function _copy() {
                return new YXmlHook(this.hookName);
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */ key: "clone",
            value: function clone() {
                var el = new YXmlHook(this.hookName);
                this.forEach(function(value, key) {
                    el.set(key, value);
                });
                return el;
            }
        },
        {
            /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ key: "toDOM",
            value: function toDOM() {
                var _document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, binding = arguments.length > 2 ? arguments[2] : void 0;
                var hook = hooks[this.hookName];
                var dom;
                if (hook !== undefined) dom = hook.createDom(this);
                else dom = document.createElement(this.hookName);
                dom.setAttribute('data-yjs-hook', this.hookName);
                if (binding !== undefined) binding._createAssociation(dom, this);
                return dom;
            }
        },
        {
            /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YXmlHookRefID);
                encoder.writeKey(this.hookName);
            }
        }
    ]);
    return YXmlHook;
}($81089639773113c2$export$a5c7b93649eaf8f8);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYXmlHook = function(decoder) {
    return new $81089639773113c2$export$ec64c1dd5e7a264(decoder.readKey());
};
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ var $81089639773113c2$export$b35b8f45887823df = /*#__PURE__*/ function(YText) {
    "use strict";
    (0, $jCmGC._)(YXmlText, YText);
    function YXmlText() {
        (0, $3CDbU._)(this, YXmlText);
        return (0, $ep9cZ._)(this, YXmlText, arguments);
    }
    (0, $jyA4z._)(YXmlText, [
        {
            key: "nextSibling",
            get: /**
   * @type {YXmlElement|YXmlText|null}
   */ function get() {
                var n = this._item ? this._item.next : null;
                return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
            }
        },
        {
            key: "prevSibling",
            get: /**
   * @type {YXmlElement|YXmlText|null}
   */ function get() {
                var n = this._item ? this._item.prev : null;
                return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
            }
        },
        {
            key: "_copy",
            value: function _copy() {
                return new YXmlText();
            }
        },
        {
            /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */ key: "clone",
            value: function clone() {
                var text = new YXmlText();
                text.applyDelta(this.toDelta());
                return text;
            }
        },
        {
            /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ key: "toDOM",
            value: function toDOM() {
                var _document = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, hooks = arguments.length > 1 ? arguments[1] : void 0, binding = arguments.length > 2 ? arguments[2] : void 0;
                var dom = _document.createTextNode(this.toString());
                if (binding !== undefined) binding._createAssociation(dom, this);
                return dom;
            }
        },
        {
            key: "toString",
            value: function toString() {
                // @ts-ignore
                return this.toDelta().map(function(delta) {
                    var nestedNodes = [];
                    for(var nodeName in delta.attributes){
                        var attrs = [];
                        for(var key in delta.attributes[nodeName])attrs.push({
                            key: key,
                            value: delta.attributes[nodeName][key]
                        });
                        // sort attributes to get a unique order
                        attrs.sort(function(a, b) {
                            return a.key < b.key ? -1 : 1;
                        });
                        nestedNodes.push({
                            nodeName: nodeName,
                            attrs: attrs
                        });
                    }
                    // sort node order to get a unique order
                    nestedNodes.sort(function(a, b) {
                        return a.nodeName < b.nodeName ? -1 : 1;
                    });
                    // now convert to dom string
                    var str = '';
                    for(var i = 0; i < nestedNodes.length; i++){
                        var node = nestedNodes[i];
                        str += "<".concat(node.nodeName);
                        for(var j = 0; j < node.attrs.length; j++){
                            var attr = node.attrs[j];
                            str += " ".concat(attr.key, '="').concat(attr.value, '"');
                        }
                        str += '>';
                    }
                    str += delta.insert;
                    for(var i1 = nestedNodes.length - 1; i1 >= 0; i1--)str += "</".concat(nestedNodes[i1].nodeName, ">");
                    return str;
                }).join('');
            }
        },
        {
            /**
   * @return {string}
   */ key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ key: "_write",
            value: function _write(encoder) {
                encoder.writeTypeRef($81089639773113c2$var$YXmlTextRefID);
            }
        }
    ]);
    return YXmlText;
}($81089639773113c2$export$5f1af8db9871e1d6);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ var $81089639773113c2$var$readYXmlText = function(decoder) {
    return new $81089639773113c2$export$b35b8f45887823df();
};
var $81089639773113c2$export$3cf6f9765c5c3196 = /*#__PURE__*/ function() {
    "use strict";
    function AbstractStruct(id, length) {
        (0, $3CDbU._)(this, AbstractStruct);
        this.id = id;
        this.length = length;
    }
    (0, $jyA4z._)(AbstractStruct, [
        {
            key: "deleted",
            get: /**
   * @type {boolean}
   */ function get() {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */ key: "mergeWith",
            value: function mergeWith(right) {
                return false;
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ key: "write",
            value: function write(encoder, offset, encodingRef) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ key: "integrate",
            value: function integrate(transaction, offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        }
    ]);
    return AbstractStruct;
}();
var $81089639773113c2$var$structGCRefNumber = 0;
/**
 * @private
 */ var $81089639773113c2$export$12d259ff017e6b58 = /*#__PURE__*/ function(AbstractStruct) {
    "use strict";
    (0, $jCmGC._)(GC, AbstractStruct);
    function GC() {
        (0, $3CDbU._)(this, GC);
        return (0, $ep9cZ._)(this, GC, arguments);
    }
    (0, $jyA4z._)(GC, [
        {
            key: "deleted",
            get: function get() {
                return true;
            }
        },
        {
            key: "delete",
            value: function _delete() {}
        },
        {
            /**
   * @param {GC} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                if (this.constructor !== right.constructor) return false;
                this.length += right.length;
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ key: "integrate",
            value: function integrate(transaction, offset) {
                if (offset > 0) {
                    this.id.clock += offset;
                    this.length -= offset;
                }
                $81089639773113c2$var$addStruct(transaction.doc.store, this);
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeInfo($81089639773113c2$var$structGCRefNumber);
                encoder.writeLen(this.length - offset);
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ key: "getMissing",
            value: function getMissing(transaction, store) {
                return null;
            }
        }
    ]);
    return GC;
}($81089639773113c2$export$3cf6f9765c5c3196);
var $81089639773113c2$export$e8d530cdf62d1cbd = /*#__PURE__*/ function() {
    "use strict";
    function ContentBinary(content) {
        (0, $3CDbU._)(this, ContentBinary);
        this.content = content;
    }
    (0, $jyA4z._)(ContentBinary, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return 1;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [
                    this.content
                ];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentBinary}
   */ key: "copy",
            value: function copy() {
                return new ContentBinary(this.content);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentBinary}
   */ key: "splice",
            value: function splice(offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                return false;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {}
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeBuf(this.content);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 3;
            }
        }
    ]);
    return ContentBinary;
}();
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ var $81089639773113c2$var$readContentBinary = function(decoder) {
    return new $81089639773113c2$export$e8d530cdf62d1cbd(decoder.readBuf());
};
var $81089639773113c2$export$3b06e0b3a2ece602 = /*#__PURE__*/ function() {
    "use strict";
    function ContentDeleted(len) {
        (0, $3CDbU._)(this, ContentDeleted);
        this.len = len;
    }
    (0, $jyA4z._)(ContentDeleted, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return this.len;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return false;
            }
        },
        {
            /**
   * @return {ContentDeleted}
   */ key: "copy",
            value: function copy() {
                return new ContentDeleted(this.len);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ key: "splice",
            value: function splice(offset) {
                var right = new ContentDeleted(this.len - offset);
                this.len = offset;
                return right;
            }
        },
        {
            /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                this.len += right.len;
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {
                $81089639773113c2$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
                item.markDeleted();
            }
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeLen(this.len - offset);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 1;
            }
        }
    ]);
    return ContentDeleted;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ var $81089639773113c2$var$readContentDeleted = function(decoder) {
    return new $81089639773113c2$export$3b06e0b3a2ece602(decoder.readLen());
};
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ var $81089639773113c2$var$createDocFromOpts = function(guid, opts) {
    return new $81089639773113c2$export$bceacc74c2212615((0, $hiGMu._)((0, $cgG2i._)({
        guid: guid
    }, opts), {
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    }));
};
/**
 * @private
 */ var $81089639773113c2$export$b564c0e69572c0e = /*#__PURE__*/ function() {
    "use strict";
    function ContentDoc(doc) {
        (0, $3CDbU._)(this, ContentDoc);
        if (doc._item) console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ var opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    (0, $jyA4z._)(ContentDoc, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return 1;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [
                    this.doc
                ];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentDoc}
   */ key: "copy",
            value: function copy() {
                return new ContentDoc($81089639773113c2$var$createDocFromOpts(this.doc.guid, this.opts));
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentDoc}
   */ key: "splice",
            value: function splice(offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                return false;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {
                // this needs to be reflected in doc.destroy as well
                this.doc._item = item;
                transaction.subdocsAdded.add(this.doc);
                if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
            }
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {
                if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded["delete"](this.doc);
                else transaction.subdocsRemoved.add(this.doc);
            }
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeString(this.doc.guid);
                encoder.writeAny(this.opts);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 9;
            }
        }
    ]);
    return ContentDoc;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ var $81089639773113c2$var$readContentDoc = function(decoder) {
    return new $81089639773113c2$export$b564c0e69572c0e($81089639773113c2$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
};
/**
 * @private
 */ var $81089639773113c2$export$c3787ba7f6086664 = /*#__PURE__*/ function() {
    "use strict";
    function ContentEmbed(embed) {
        (0, $3CDbU._)(this, ContentEmbed);
        this.embed = embed;
    }
    (0, $jyA4z._)(ContentEmbed, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return 1;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [
                    this.embed
                ];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentEmbed}
   */ key: "copy",
            value: function copy() {
                return new ContentEmbed(this.embed);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ key: "splice",
            value: function splice(offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                return false;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {}
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeJSON(this.embed);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 5;
            }
        }
    ]);
    return ContentEmbed;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ var $81089639773113c2$var$readContentEmbed = function(decoder) {
    return new $81089639773113c2$export$c3787ba7f6086664(decoder.readJSON());
};
/**
 * @private
 */ var $81089639773113c2$export$3194899188fb5a88 = /*#__PURE__*/ function() {
    "use strict";
    function ContentFormat(key, value) {
        (0, $3CDbU._)(this, ContentFormat);
        this.key = key;
        this.value = value;
    }
    (0, $jyA4z._)(ContentFormat, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return 1;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return false;
            }
        },
        {
            /**
   * @return {ContentFormat}
   */ key: "copy",
            value: function copy() {
                return new ContentFormat(this.key, this.value);
            }
        },
        {
            /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ key: "splice",
            value: function splice(_offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(_right) {
                return false;
            }
        },
        {
            /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(_transaction, item) {
                // @todo searchmarker are currently unsupported for rich text documents
                var p = /** @type {YText} */ item.parent;
                p._searchMarker = null;
                p._hasFormatting = true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeKey(this.key);
                encoder.writeJSON(this.value);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 6;
            }
        }
    ]);
    return ContentFormat;
}();
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ var $81089639773113c2$var$readContentFormat = function(decoder) {
    return new $81089639773113c2$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
};
/**
 * @private
 */ var $81089639773113c2$export$6a907ea8f733ecf3 = /*#__PURE__*/ function() {
    "use strict";
    function ContentJSON(arr) {
        (0, $3CDbU._)(this, ContentJSON);
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    (0, $jyA4z._)(ContentJSON, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return this.arr.length;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return this.arr;
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentJSON}
   */ key: "copy",
            value: function copy() {
                return new ContentJSON(this.arr);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentJSON}
   */ key: "splice",
            value: function splice(offset) {
                var right = new ContentJSON(this.arr.slice(offset));
                this.arr = this.arr.slice(0, offset);
                return right;
            }
        },
        {
            /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                this.arr = this.arr.concat(right.arr);
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {}
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                var len = this.arr.length;
                encoder.writeLen(len - offset);
                for(var i = offset; i < len; i++){
                    var c = this.arr[i];
                    encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
                }
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 2;
            }
        }
    ]);
    return ContentJSON;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ var $81089639773113c2$var$readContentJSON = function(decoder) {
    var len = decoder.readLen();
    var cs = [];
    for(var i = 0; i < len; i++){
        var c = decoder.readString();
        if (c === 'undefined') cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $81089639773113c2$export$6a907ea8f733ecf3(cs);
};
var $81089639773113c2$var$isDevMode = $apk8q.getVariable('node_env') === 'development';
var $81089639773113c2$export$1d788b93bbb631a0 = /*#__PURE__*/ function() {
    "use strict";
    function ContentAny(arr) {
        (0, $3CDbU._)(this, ContentAny);
        /**
     * @type {Array<any>}
     */ this.arr = arr;
        $81089639773113c2$var$isDevMode && $eCHRC.deepFreeze(arr);
    }
    (0, $jyA4z._)(ContentAny, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return this.arr.length;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return this.arr;
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentAny}
   */ key: "copy",
            value: function copy() {
                return new ContentAny(this.arr);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentAny}
   */ key: "splice",
            value: function splice(offset) {
                var right = new ContentAny(this.arr.slice(offset));
                this.arr = this.arr.slice(0, offset);
                return right;
            }
        },
        {
            /**
   * @param {ContentAny} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                this.arr = this.arr.concat(right.arr);
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {}
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                var len = this.arr.length;
                encoder.writeLen(len - offset);
                for(var i = offset; i < len; i++){
                    var c = this.arr[i];
                    encoder.writeAny(c);
                }
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 8;
            }
        }
    ]);
    return ContentAny;
}();
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ var $81089639773113c2$var$readContentAny = function(decoder) {
    var len = decoder.readLen();
    var cs = [];
    for(var i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $81089639773113c2$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ var $81089639773113c2$export$ee670b2cf091bbb6 = /*#__PURE__*/ function() {
    "use strict";
    function ContentString(str) {
        (0, $3CDbU._)(this, ContentString);
        /**
     * @type {string}
     */ this.str = str;
    }
    (0, $jyA4z._)(ContentString, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return this.str.length;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return this.str.split('');
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentString}
   */ key: "copy",
            value: function copy() {
                return new ContentString(this.str);
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentString}
   */ key: "splice",
            value: function splice(offset) {
                var right = new ContentString(this.str.slice(offset));
                this.str = this.str.slice(0, offset);
                // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
                var firstCharCode = this.str.charCodeAt(offset - 1);
                if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
                    // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
                    // We don't support splitting of surrogate pairs because this may lead to invalid documents.
                    // Replace the invalid character with a unicode replacement character (� / U+FFFD)
                    this.str = this.str.slice(0, offset - 1) + "\uFFFD";
                    // replace right as well
                    right.str = "\uFFFD" + right.str.slice(1);
                }
                return right;
            }
        },
        {
            /**
   * @param {ContentString} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                this.str += right.str;
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {}
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {}
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {}
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 4;
            }
        }
    ]);
    return ContentString;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ var $81089639773113c2$var$readContentString = function(decoder) {
    return new $81089639773113c2$export$ee670b2cf091bbb6(decoder.readString());
};
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ var $81089639773113c2$var$typeRefs = [
    $81089639773113c2$var$readYArray,
    $81089639773113c2$var$readYMap,
    $81089639773113c2$var$readYText,
    $81089639773113c2$var$readYXmlElement,
    $81089639773113c2$var$readYXmlFragment,
    $81089639773113c2$var$readYXmlHook,
    $81089639773113c2$var$readYXmlText
];
var $81089639773113c2$var$YArrayRefID = 0;
var $81089639773113c2$var$YMapRefID = 1;
var $81089639773113c2$var$YTextRefID = 2;
var $81089639773113c2$var$YXmlElementRefID = 3;
var $81089639773113c2$var$YXmlFragmentRefID = 4;
var $81089639773113c2$var$YXmlHookRefID = 5;
var $81089639773113c2$var$YXmlTextRefID = 6;
/**
 * @private
 */ var $81089639773113c2$export$e2e108cbe2e4f865 = /*#__PURE__*/ function() {
    "use strict";
    function ContentType(type) {
        (0, $3CDbU._)(this, ContentType);
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    (0, $jyA4z._)(ContentType, [
        {
            /**
   * @return {number}
   */ key: "getLength",
            value: function getLength() {
                return 1;
            }
        },
        {
            /**
   * @return {Array<any>}
   */ key: "getContent",
            value: function getContent() {
                return [
                    this.type
                ];
            }
        },
        {
            /**
   * @return {boolean}
   */ key: "isCountable",
            value: function isCountable() {
                return true;
            }
        },
        {
            /**
   * @return {ContentType}
   */ key: "copy",
            value: function copy() {
                return new ContentType(this.type._copy());
            }
        },
        {
            /**
   * @param {number} offset
   * @return {ContentType}
   */ key: "splice",
            value: function splice(offset) {
                throw $4338d6312e5ee7d6$export$73ced5c7e10d6d0f();
            }
        },
        {
            /**
   * @param {ContentType} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                return false;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ key: "integrate",
            value: function integrate(transaction, item) {
                this.type._integrate(transaction.doc, item);
            }
        },
        {
            /**
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {
                var item = this.type._start;
                while(item !== null){
                    if (!item.deleted) item["delete"](transaction);
                    else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
                    // We try to merge all deleted items after each transaction,
                    // but we have no knowledge about that this needs to be merged
                    // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
                    transaction._mergeStructs.push(item);
                    item = item.right;
                }
                this.type._map.forEach(function(item) {
                    if (!item.deleted) item["delete"](transaction);
                    else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
                    transaction._mergeStructs.push(item);
                });
                transaction.changed["delete"](this.type);
            }
        },
        {
            /**
   * @param {StructStore} store
   */ key: "gc",
            value: function gc(store) {
                var item = this.type._start;
                while(item !== null){
                    item.gc(store, true);
                    item = item.right;
                }
                this.type._start = null;
                this.type._map.forEach(/** @param {Item | null} item */ function(item) {
                    while(item !== null){
                        item.gc(store, true);
                        item = item.left;
                    }
                });
                this.type._map = new Map();
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                this.type._write(encoder);
            }
        },
        {
            /**
   * @return {number}
   */ key: "getRef",
            value: function getRef() {
                return 7;
            }
        }
    ]);
    return ContentType;
}();
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ var $81089639773113c2$var$readContentType = function(decoder) {
    return new $81089639773113c2$export$e2e108cbe2e4f865($81089639773113c2$var$typeRefs[decoder.readTypeRef()](decoder));
};
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ var $81089639773113c2$var$followRedone = function(store, id) {
    /**
   * @type {ID|null}
   */ var nextID = id;
    var diff = 0;
    var item;
    do {
        if (diff > 0) nextID = $81089639773113c2$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $81089639773113c2$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $81089639773113c2$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ var $81089639773113c2$var$keepItem = function(item, keep) {
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ var $81089639773113c2$var$splitItem = function(transaction, leftItem, diff) {
    // create rightItem
    var _leftItem_id = leftItem.id, client = _leftItem_id.client, clock = _leftItem_id.clock;
    var rightItem = new $81089639773113c2$export$6d08773d2e66f8f2($81089639773113c2$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $81089639773113c2$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $81089639773113c2$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ var $81089639773113c2$var$isDeletedByUndoStack = function(stack, id) {
    return $397ju.some(stack, /** @param {StackItem} s */ function(s) {
        return $81089639773113c2$export$dcb04af092e44fde(s.deletions, id);
    });
};
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ var $81089639773113c2$var$redoItem = function(transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) {
    var doc = transaction.doc;
    var store = doc.store;
    var ownClientID = doc.clientID;
    var redone = item.redone;
    if (redone !== null) return $81089639773113c2$export$e550586ad633138d(transaction, redone);
    var parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ var left = null;
    /**
   * @type {Item|null}
   */ var right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $81089639773113c2$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $81089639773113c2$export$e550586ad633138d(transaction, parentItem.redone);
    }
    var parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ var leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $81089639773113c2$export$e550586ad633138d(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ var rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $81089639773113c2$export$e550586ad633138d(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $81089639773113c2$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $81089639773113c2$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $81089639773113c2$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $81089639773113c2$export$e550586ad633138d(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    var nextClock = $81089639773113c2$export$50fdfeece43146fd(store, ownClientID);
    var nextId = $81089639773113c2$export$6c7d4e6171d008d0(ownClientID, nextClock);
    var redoneItem = new $81089639773113c2$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $81089639773113c2$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ var $81089639773113c2$export$6d08773d2e66f8f2 = /*#__PURE__*/ function(AbstractStruct) {
    "use strict";
    (0, $jCmGC._)(Item, AbstractStruct);
    function Item(id, left, origin, right, rightOrigin, parent, parentSub, content) {
        (0, $3CDbU._)(this, Item);
        var _this;
        _this = (0, $ep9cZ._)(this, Item, [
            id,
            content.getLength()
        ]);
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ _this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ _this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ _this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ _this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ _this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ _this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ _this.redone = null;
        /**
     * @type {AbstractContent}
     */ _this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ _this.info = _this.content.isCountable() ? $eab0623b6aed22da$export$1f117f3b0edc2676 : 0;
        return _this;
    }
    (0, $jyA4z._)(Item, [
        {
            key: "marker",
            get: function get() {
                return (this.info & $eab0623b6aed22da$export$873ae8db4cef5125) > 0;
            },
            set: /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ function set(isMarked) {
                if ((this.info & $eab0623b6aed22da$export$873ae8db4cef5125) > 0 !== isMarked) this.info ^= $eab0623b6aed22da$export$873ae8db4cef5125;
            }
        },
        {
            key: "keep",
            get: /**
   * If true, do not garbage collect this Item.
   */ function get() {
                return (this.info & $eab0623b6aed22da$export$ee2c6657cb286da4) > 0;
            },
            set: function set(doKeep) {
                if (this.keep !== doKeep) this.info ^= $eab0623b6aed22da$export$ee2c6657cb286da4;
            }
        },
        {
            key: "countable",
            get: function get() {
                return (this.info & $eab0623b6aed22da$export$1f117f3b0edc2676) > 0;
            }
        },
        {
            key: "deleted",
            get: /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ function get() {
                return (this.info & $eab0623b6aed22da$export$e5294f8c78cf7711) > 0;
            },
            set: function set(doDelete) {
                if (this.deleted !== doDelete) this.info ^= $eab0623b6aed22da$export$e5294f8c78cf7711;
            }
        },
        {
            key: "markDeleted",
            value: function markDeleted() {
                this.info |= $eab0623b6aed22da$export$e5294f8c78cf7711;
            }
        },
        {
            /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ key: "getMissing",
            value: function getMissing(transaction, store) {
                if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $81089639773113c2$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
                if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $81089639773113c2$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
                if (this.parent && this.parent.constructor === $81089639773113c2$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $81089639773113c2$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
                // We have all missing ids, now find the items
                if (this.origin) {
                    this.left = $81089639773113c2$export$73a181de908c608(transaction, store, this.origin);
                    this.origin = this.left.lastId;
                }
                if (this.rightOrigin) {
                    this.right = $81089639773113c2$export$e550586ad633138d(transaction, this.rightOrigin);
                    this.rightOrigin = this.right.id;
                }
                if (this.left && this.left.constructor === $81089639773113c2$export$12d259ff017e6b58 || this.right && this.right.constructor === $81089639773113c2$export$12d259ff017e6b58) this.parent = null;
                else if (!this.parent) {
                    // only set parent if this shouldn't be garbage collected
                    if (this.left && this.left.constructor === Item) {
                        this.parent = this.left.parent;
                        this.parentSub = this.left.parentSub;
                    } else if (this.right && this.right.constructor === Item) {
                        this.parent = this.right.parent;
                        this.parentSub = this.right.parentSub;
                    }
                } else if (this.parent.constructor === $81089639773113c2$export$8be180ec26319f9f) {
                    var parentItem = $81089639773113c2$export$f92dfeb71e9bb569(store, this.parent);
                    if (parentItem.constructor === $81089639773113c2$export$12d259ff017e6b58) this.parent = null;
                    else this.parent = /** @type {ContentType} */ parentItem.content.type;
                }
                return null;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ key: "integrate",
            value: function integrate(transaction, offset) {
                if (offset > 0) {
                    this.id.clock += offset;
                    this.left = $81089639773113c2$export$73a181de908c608(transaction, transaction.doc.store, $81089639773113c2$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
                    this.origin = this.left.lastId;
                    this.content = this.content.splice(offset);
                    this.length -= offset;
                }
                if (this.parent) {
                    if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                        /**
         * @type {Item|null}
         */ var left = this.left;
                        /**
         * @type {Item|null}
         */ var o;
                        // set o to the first conflicting item
                        if (left !== null) o = left.right;
                        else if (this.parentSub !== null) {
                            o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                            while(o !== null && o.left !== null)o = o.left;
                        } else o = /** @type {AbstractType<any>} */ this.parent._start;
                        // TODO: use something like DeleteSet here (a tree implementation would be best)
                        // @todo use global set definitions
                        /**
         * @type {Set<Item>}
         */ var conflictingItems = new Set();
                        /**
         * @type {Set<Item>}
         */ var itemsBeforeOrigin = new Set();
                        // Let c in conflictingItems, b in itemsBeforeOrigin
                        // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                        // Note that conflictingItems is a subset of itemsBeforeOrigin
                        while(o !== null && o !== this.right){
                            itemsBeforeOrigin.add(o);
                            conflictingItems.add(o);
                            if ($81089639773113c2$export$c0af976e7e459c02(this.origin, o.origin)) {
                                // case 1
                                if (o.id.client < this.id.client) {
                                    left = o;
                                    conflictingItems.clear();
                                } else if ($81089639773113c2$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                                 // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                            } else if (o.origin !== null && itemsBeforeOrigin.has($81089639773113c2$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                            {
                                if (!conflictingItems.has($81089639773113c2$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                                    left = o;
                                    conflictingItems.clear();
                                }
                            } else break;
                            o = o.right;
                        }
                        this.left = left;
                    }
                    // reconnect left/right + update parent map/start if necessary
                    if (this.left !== null) {
                        var right = this.left.right;
                        this.right = right;
                        this.left.right = this;
                    } else {
                        var r;
                        if (this.parentSub !== null) {
                            r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                            while(r !== null && r.left !== null)r = r.left;
                        } else {
                            r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                            this.parent._start = this;
                        }
                        this.right = r;
                    }
                    if (this.right !== null) this.right.left = this;
                    else if (this.parentSub !== null) {
                        // set as current parent value if right === null and this is parentSub
                        /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                        if (this.left !== null) // this is the current attribute value of parent. delete right
                        this.left["delete"](transaction);
                    }
                    // adjust length of parent
                    if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
                    $81089639773113c2$var$addStruct(transaction.doc.store, this);
                    this.content.integrate(transaction, this);
                    // add parent to transaction.changed
                    $81089639773113c2$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
                    if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
                    this["delete"](transaction);
                } else // parent is not defined. Integrate GC struct instead
                new $81089639773113c2$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
            }
        },
        {
            key: "next",
            get: /**
   * Returns the next non-deleted item
   */ function get() {
                var n = this.right;
                while(n !== null && n.deleted)n = n.right;
                return n;
            }
        },
        {
            key: "prev",
            get: /**
   * Returns the previous non-deleted item
   */ function get() {
                var n = this.left;
                while(n !== null && n.deleted)n = n.left;
                return n;
            }
        },
        {
            key: "lastId",
            get: /**
   * Computes the last content address of this Item.
   */ function get() {
                // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
                return this.length === 1 ? this.id : $81089639773113c2$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
            }
        },
        {
            /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                var _this = this;
                if (this.constructor === right.constructor && $81089639773113c2$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $81089639773113c2$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
                    var searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
                    if (searchMarker) searchMarker.forEach(function(marker) {
                        if (marker.p === right) {
                            // right is going to be "forgotten" so we need to update the marker
                            marker.p = _this;
                            // adjust marker index
                            if (!_this.deleted && _this.countable) marker.index -= _this.length;
                        }
                    });
                    if (right.keep) this.keep = true;
                    this.right = right.right;
                    if (this.right !== null) this.right.left = this;
                    this.length += right.length;
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ key: "delete",
            value: function _delete(transaction) {
                if (!this.deleted) {
                    var parent = /** @type {AbstractType<any>} */ this.parent;
                    // adjust the length of parent
                    if (this.countable && this.parentSub === null) parent._length -= this.length;
                    this.markDeleted();
                    $81089639773113c2$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
                    $81089639773113c2$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
                    this.content["delete"](transaction);
                }
            }
        },
        {
            /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ key: "gc",
            value: function gc(store, parentGCd) {
                if (!this.deleted) throw $4338d6312e5ee7d6$export$965b6bccecbd9673();
                this.content.gc(store);
                if (parentGCd) $81089639773113c2$var$replaceStruct(store, this, new $81089639773113c2$export$12d259ff017e6b58(this.id, this.length));
                else this.content = new $81089639773113c2$export$3b06e0b3a2ece602(this.length);
            }
        },
        {
            /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                var origin = offset > 0 ? $81089639773113c2$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
                var rightOrigin = this.rightOrigin;
                var parentSub = this.parentSub;
                var info = this.content.getRef() & $eab0623b6aed22da$export$bc2aba63e4099c09 | (origin === null ? 0 : $eab0623b6aed22da$export$e25597372303a045) | // origin is defined
                (rightOrigin === null ? 0 : $eab0623b6aed22da$export$eb5a8e0006ab4bb5) | // right origin is defined
                (parentSub === null ? 0 : $eab0623b6aed22da$export$daf23f774967089); // parentSub is non-null
                encoder.writeInfo(info);
                if (origin !== null) encoder.writeLeftID(origin);
                if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
                if (origin === null && rightOrigin === null) {
                    var parent = /** @type {AbstractType<any>} */ this.parent;
                    if (parent._item !== undefined) {
                        var parentItem = parent._item;
                        if (parentItem === null) {
                            // parent type on y._map
                            // find the correct key
                            var ykey = $81089639773113c2$export$e726a40920d54663(parent);
                            encoder.writeParentInfo(true); // write parentYKey
                            encoder.writeString(ykey);
                        } else {
                            encoder.writeParentInfo(false); // write parent id
                            encoder.writeLeftID(parentItem.id);
                        }
                    } else if (parent.constructor === String) {
                        encoder.writeParentInfo(true); // write parentYKey
                        encoder.writeString(parent);
                    } else if (parent.constructor === $81089639773113c2$export$8be180ec26319f9f) {
                        encoder.writeParentInfo(false); // write parent id
                        encoder.writeLeftID(parent);
                    } else $4338d6312e5ee7d6$export$965b6bccecbd9673();
                    if (parentSub !== null) encoder.writeString(parentSub);
                }
                this.content.write(encoder, offset);
            }
        }
    ]);
    return Item;
}($81089639773113c2$export$3cf6f9765c5c3196);
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ var $81089639773113c2$var$readItemContent = function(decoder, info) {
    return $81089639773113c2$var$contentRefs[info & $eab0623b6aed22da$export$bc2aba63e4099c09](decoder);
};
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ var $81089639773113c2$var$contentRefs = [
    function() {
        $4338d6312e5ee7d6$export$965b6bccecbd9673();
    },
    $81089639773113c2$var$readContentDeleted,
    $81089639773113c2$var$readContentJSON,
    $81089639773113c2$var$readContentBinary,
    $81089639773113c2$var$readContentString,
    $81089639773113c2$var$readContentEmbed,
    $81089639773113c2$var$readContentFormat,
    $81089639773113c2$var$readContentType,
    $81089639773113c2$var$readContentAny,
    $81089639773113c2$var$readContentDoc,
    function() {
        $4338d6312e5ee7d6$export$965b6bccecbd9673();
    } // 10 - Skip is not ItemContent
];
var $81089639773113c2$var$structSkipRefNumber = 10;
/**
 * @private
 */ var $81089639773113c2$export$38d24f5c1eb0e4c0 = /*#__PURE__*/ function(AbstractStruct) {
    "use strict";
    (0, $jCmGC._)(Skip, AbstractStruct);
    function Skip() {
        (0, $3CDbU._)(this, Skip);
        return (0, $ep9cZ._)(this, Skip, arguments);
    }
    (0, $jyA4z._)(Skip, [
        {
            key: "deleted",
            get: function get() {
                return true;
            }
        },
        {
            key: "delete",
            value: function _delete() {}
        },
        {
            /**
   * @param {Skip} right
   * @return {boolean}
   */ key: "mergeWith",
            value: function mergeWith(right) {
                if (this.constructor !== right.constructor) return false;
                this.length += right.length;
                return true;
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ key: "integrate",
            value: function integrate(transaction, offset) {
                // skip structs cannot be integrated
                $4338d6312e5ee7d6$export$965b6bccecbd9673();
            }
        },
        {
            /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ key: "write",
            value: function write(encoder, offset) {
                encoder.writeInfo($81089639773113c2$var$structSkipRefNumber);
                // write as VarUint because Skips can't make use of predictable length-encoding
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder.restEncoder, this.length - offset);
            }
        },
        {
            /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ key: "getMissing",
            value: function getMissing(transaction, store) {
                return null;
            }
        }
    ]);
    return Skip;
}($81089639773113c2$export$3cf6f9765c5c3196);
/** eslint-env browser */ var $81089639773113c2$var$glo = /** @type {any} */ typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
var $81089639773113c2$var$importIdentifier = '__ $YJS$ __';
if ($81089639773113c2$var$glo[$81089639773113c2$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error('Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438');
$81089639773113c2$var$glo[$81089639773113c2$var$importIdentifier] = true;


/**
 * @module provider/websocket
 */ /* eslint-env browser */ 
var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

/* eslint-env browser */ /**
 * Helpers for cross-tab communication using broadcastchannel with LocalStorage fallback.
 *
 * ```js
 * // In browser window A:
 * broadcastchannel.subscribe('my events', data => console.log(data))
 * broadcastchannel.publish('my events', 'Hello world!') // => A: 'Hello world!' fires synchronously in same tab
 *
 * // In browser window B:
 * broadcastchannel.publish('my events', 'hello from tab B') // => A: 'hello from tab B'
 * ```
 *
 * @module broadcastchannel
 */ // @todo before next major: use Uint8Array instead as buffer object

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $89wqq = parcelRequire("89wqq");

var $kgvSK = parcelRequire("kgvSK");


var $1JGI6 = parcelRequire("1JGI6");
/**
 * @typedef {Object} Channel
 * @property {Set<function(any, any):any>} Channel.subs
 * @property {any} Channel.bc
 */ /**
 * @type {Map<string, Channel>}
 */ var $3e0fc0c1d7111aec$var$channels = new Map();
/* c8 ignore start */ var $3e0fc0c1d7111aec$var$LocalStoragePolyfill = /*#__PURE__*/ function() {
    "use strict";
    function LocalStoragePolyfill(room) {
        var _this = this;
        (0, $3CDbU._)(this, LocalStoragePolyfill);
        this.room = room;
        /**
     * @type {null|function({data:ArrayBuffer}):void}
     */ this.onmessage = null;
        /**
     * @param {any} e
     */ this._onChange = function(e) {
            return e.key === room && _this.onmessage !== null && _this.onmessage({
                data: $824d4a265ce17f90$export$c537b38001c583b7(e.newValue || '')
            });
        };
        $1JGI6.onChange(this._onChange);
    }
    (0, $jyA4z._)(LocalStoragePolyfill, [
        {
            /**
   * @param {ArrayBuffer} buf
   */ key: "postMessage",
            value: function postMessage(buf) {
                $1JGI6.varStorage.setItem(this.room, $824d4a265ce17f90$export$37cc283d8fbd3462($824d4a265ce17f90$export$1b999ddd54e5bed1(buf)));
            }
        },
        {
            key: "close",
            value: function close() {
                $1JGI6.offChange(this._onChange);
            }
        }
    ]);
    return LocalStoragePolyfill;
}();
/* c8 ignore stop */ // Use BroadcastChannel or Polyfill
/* c8 ignore next */ var $3e0fc0c1d7111aec$var$BC = typeof BroadcastChannel === 'undefined' ? $3e0fc0c1d7111aec$var$LocalStoragePolyfill : BroadcastChannel;
/**
 * @param {string} room
 * @return {Channel}
 */ var $3e0fc0c1d7111aec$var$getChannel = function(room) {
    return $89wqq.setIfUndefined($3e0fc0c1d7111aec$var$channels, room, function() {
        var subs = $kgvSK.create();
        var bc = new $3e0fc0c1d7111aec$var$BC(room);
        /**
     * @param {{data:ArrayBuffer}} e
     */ /* c8 ignore next */ bc.onmessage = function(e) {
            return subs.forEach(function(sub) {
                return sub(e.data, 'broadcastchannel');
            });
        };
        return {
            bc: bc,
            subs: subs
        };
    });
};
var $3e0fc0c1d7111aec$export$ec068583843480e7 = function(room, f) {
    $3e0fc0c1d7111aec$var$getChannel(room).subs.add(f);
    return f;
};
var $3e0fc0c1d7111aec$export$f500693cef883ffd = function(room, f) {
    var channel = $3e0fc0c1d7111aec$var$getChannel(room);
    var unsubscribed = channel.subs["delete"](f);
    if (unsubscribed && channel.subs.size === 0) {
        channel.bc.close();
        $3e0fc0c1d7111aec$var$channels["delete"](room);
    }
    return unsubscribed;
};
var $3e0fc0c1d7111aec$export$89b472e03be495df = function(room, data) {
    var origin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var c = $3e0fc0c1d7111aec$var$getChannel(room);
    c.bc.postMessage(data);
    c.subs.forEach(function(sub) {
        return sub(data, origin);
    });
};



var $gL882 = parcelRequire("gL882");


/**
 * @module sync-protocol
 */ 


var $61ed1827d431d4eb$export$edbc8479a3fd0d51 = 0;
var $61ed1827d431d4eb$export$ff102031071a8f85 = 1;
var $61ed1827d431d4eb$export$f589a35bfce33e17 = 2;
var $61ed1827d431d4eb$export$2a4abf6cf2c7e66f = function(encoder, doc) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $61ed1827d431d4eb$export$edbc8479a3fd0d51);
    var sv = $81089639773113c2$export$3e2f5393f32e71f(doc);
    $917f0b264ff88d53$export$f7d11515275e88a2(encoder, sv);
};
var $61ed1827d431d4eb$export$b2b01faa10f64871 = function(encoder, doc, encodedStateVector) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $61ed1827d431d4eb$export$ff102031071a8f85);
    $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $81089639773113c2$export$e5848df80e65bd53(doc, encodedStateVector));
};
var $61ed1827d431d4eb$export$24e7fa74cb33e063 = function(decoder, encoder, doc) {
    return $61ed1827d431d4eb$export$b2b01faa10f64871(encoder, doc, $182bfc4830c83d2c$export$7418bbc18dee40f3(decoder));
};
var $61ed1827d431d4eb$export$60818ebea09048c1 = function(decoder, doc, transactionOrigin) {
    try {
        $81089639773113c2$export$c271737a9c02e925(doc, $182bfc4830c83d2c$export$7418bbc18dee40f3(decoder), transactionOrigin);
    } catch (error) {
        // This catches errors that are thrown by event handlers
        console.error('Caught error while handling a Yjs update', error);
    }
};
var $61ed1827d431d4eb$export$72c173541034b28e = function(encoder, update) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $61ed1827d431d4eb$export$f589a35bfce33e17);
    $917f0b264ff88d53$export$f7d11515275e88a2(encoder, update);
};
var $61ed1827d431d4eb$export$d67ac8d73b7d336c = $61ed1827d431d4eb$export$60818ebea09048c1;
var $61ed1827d431d4eb$export$26b589e63b591e96 = function(decoder, encoder, doc, transactionOrigin) {
    var messageType = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
    switch(messageType){
        case $61ed1827d431d4eb$export$edbc8479a3fd0d51:
            $61ed1827d431d4eb$export$24e7fa74cb33e063(decoder, encoder, doc);
            break;
        case $61ed1827d431d4eb$export$ff102031071a8f85:
            $61ed1827d431d4eb$export$60818ebea09048c1(decoder, doc, transactionOrigin);
            break;
        case $61ed1827d431d4eb$export$f589a35bfce33e17:
            $61ed1827d431d4eb$export$d67ac8d73b7d336c(decoder, doc, transactionOrigin);
            break;
        default:
            throw new Error('Unknown message type');
    }
    return messageType;
};





var $38198b79de2d8ce0$export$cfc218bc4e82266b = 0;
var $38198b79de2d8ce0$export$492291cd287a058f = function(encoder, reason) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $38198b79de2d8ce0$export$cfc218bc4e82266b);
    $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, reason);
};
var $38198b79de2d8ce0$export$7e13d1a8c99eb68e = function(decoder, y, permissionDeniedHandler) {
    switch($182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder)){
        case $38198b79de2d8ce0$export$cfc218bc4e82266b:
            permissionDeniedHandler(y, $182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder));
    }
};


/**
 * @module awareness-protocol
 */ 
var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $fEm89 = parcelRequire("fEm89");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $cgG2i = parcelRequire("cgG2i");

var $hiGMu = parcelRequire("hiGMu");



var $gL882 = parcelRequire("gL882");

var $02E42 = parcelRequire("02E42");


var $1PYZG = parcelRequire("1PYZG");

var $7850ede759b9532e$export$47b58b45939fff5e = 30000;
var $7850ede759b9532e$export$5bb40478b91fee65 = /*#__PURE__*/ function(Observable) {
    "use strict";
    (0, $jCmGC._)(Awareness, Observable);
    function Awareness(doc) {
        (0, $3CDbU._)(this, Awareness);
        var _this;
        _this = (0, $ep9cZ._)(this, Awareness);
        _this.doc = doc;
        /**
     * @type {number}
     */ _this.clientID = doc.clientID;
        /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */ _this.states = new Map();
        /**
     * @type {Map<number, MetaClientState>}
     */ _this.meta = new Map();
        _this._checkInterval = /** @type {any} */ setInterval(function() {
            var now = $gL882.getUnixTime();
            if (_this.getLocalState() !== null && $7850ede759b9532e$export$47b58b45939fff5e / 2 <= now - /** @type {{lastUpdated:number}} */ _this.meta.get(_this.clientID).lastUpdated) // renew local clock
            _this.setLocalState(_this.getLocalState());
            /**
       * @type {Array<number>}
       */ var remove = [];
            _this.meta.forEach(function(meta, clientid) {
                if (clientid !== _this.clientID && $7850ede759b9532e$export$47b58b45939fff5e <= now - meta.lastUpdated && _this.states.has(clientid)) remove.push(clientid);
            });
            if (remove.length > 0) $7850ede759b9532e$export$3edbfe2f45ae9ff8(_this, remove, 'timeout');
        }, $02E42.floor($7850ede759b9532e$export$47b58b45939fff5e / 10));
        doc.on('destroy', function() {
            _this.destroy();
        });
        _this.setLocalState({});
        return _this;
    }
    (0, $jyA4z._)(Awareness, [
        {
            key: "destroy",
            value: function destroy() {
                this.emit('destroy', [
                    this
                ]);
                this.setLocalState(null);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(Awareness.prototype), "destroy", this).call(this);
                clearInterval(this._checkInterval);
            }
        },
        {
            /**
   * @return {Object<string,any>|null}
   */ key: "getLocalState",
            value: function getLocalState() {
                return this.states.get(this.clientID) || null;
            }
        },
        {
            /**
   * @param {Object<string,any>|null} state
   */ key: "setLocalState",
            value: function setLocalState(state) {
                var clientID = this.clientID;
                var currLocalMeta = this.meta.get(clientID);
                var clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
                var prevState = this.states.get(clientID);
                if (state === null) this.states["delete"](clientID);
                else this.states.set(clientID, state);
                this.meta.set(clientID, {
                    clock: clock,
                    lastUpdated: $gL882.getUnixTime()
                });
                var added = [];
                var updated = [];
                var filteredUpdated = [];
                var removed = [];
                if (state === null) removed.push(clientID);
                else if (prevState == null) {
                    if (state != null) added.push(clientID);
                } else {
                    updated.push(clientID);
                    if (!$1PYZG.equalityDeep(prevState, state)) filteredUpdated.push(clientID);
                }
                if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit('change', [
                    {
                        added: added,
                        updated: filteredUpdated,
                        removed: removed
                    },
                    'local'
                ]);
                this.emit('update', [
                    {
                        added: added,
                        updated: updated,
                        removed: removed
                    },
                    'local'
                ]);
            }
        },
        {
            /**
   * @param {string} field
   * @param {any} value
   */ key: "setLocalStateField",
            value: function setLocalStateField(field, value) {
                var state = this.getLocalState();
                if (state !== null) this.setLocalState((0, $hiGMu._)((0, $cgG2i._)({}, state), (0, $fEm89._)({}, field, value)));
            }
        },
        {
            /**
   * @return {Map<number,Object<string,any>>}
   */ key: "getStates",
            value: function getStates() {
                return this.states;
            }
        }
    ]);
    return Awareness;
}((0, $b78261e7e572625c$export$77cea355fa80b5f4));
var $7850ede759b9532e$export$3edbfe2f45ae9ff8 = function(awareness, clients, origin) {
    var removed = [];
    for(var i = 0; i < clients.length; i++){
        var clientID = clients[i];
        if (awareness.states.has(clientID)) {
            awareness.states["delete"](clientID);
            if (clientID === awareness.clientID) {
                var curMeta = /** @type {MetaClientState} */ awareness.meta.get(clientID);
                awareness.meta.set(clientID, {
                    clock: curMeta.clock + 1,
                    lastUpdated: $gL882.getUnixTime()
                });
            }
            removed.push(clientID);
        }
    }
    if (removed.length > 0) {
        awareness.emit('change', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
        awareness.emit('update', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
    }
};
var $7850ede759b9532e$export$e194fa93ebd743e9 = function(awareness, clients) {
    var states = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : awareness.states;
    var len = clients.length;
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, len);
    for(var i = 0; i < len; i++){
        var clientID = clients[i];
        var state = states.get(clientID) || null;
        var clock = /** @type {MetaClientState} */ awareness.meta.get(clientID).clock;
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, clientID);
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, clock);
        $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, JSON.stringify(state));
    }
    return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
};
var $7850ede759b9532e$export$17dfc8fb4d274726 = function(update, modify) {
    var decoder = $182bfc4830c83d2c$export$f8c898e83b60faaa(update);
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    var len = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, len);
    for(var i = 0; i < len; i++){
        var clientID = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var clock = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var state = JSON.parse($182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder));
        var modifiedState = modify(state);
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, clientID);
        $917f0b264ff88d53$export$872f48c75febcd2b(encoder, clock);
        $917f0b264ff88d53$export$dde49cb52d5f1650(encoder, JSON.stringify(modifiedState));
    }
    return $917f0b264ff88d53$export$73470fd2221e6aef(encoder);
};
var $7850ede759b9532e$export$2f92845406d72d1a = function(awareness, update, origin) {
    var decoder = $182bfc4830c83d2c$export$f8c898e83b60faaa(update);
    var timestamp = $gL882.getUnixTime();
    var added = [];
    var updated = [];
    var filteredUpdated = [];
    var removed = [];
    var len = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
    for(var i = 0; i < len; i++){
        var clientID = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var clock = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var state = JSON.parse($182bfc4830c83d2c$export$3b64b4d753b81ec2(decoder));
        var clientMeta = awareness.meta.get(clientID);
        var prevState = awareness.states.get(clientID);
        var currClock = clientMeta === undefined ? 0 : clientMeta.clock;
        if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
            if (state === null) {
                // never let a remote client remove this local state
                if (clientID === awareness.clientID && awareness.getLocalState() != null) // remote client removed the local state. Do not remote state. Broadcast a message indicating
                // that this client still exists by increasing the clock
                clock++;
                else awareness.states["delete"](clientID);
            } else awareness.states.set(clientID, state);
            awareness.meta.set(clientID, {
                clock: clock,
                lastUpdated: timestamp
            });
            if (clientMeta === undefined && state !== null) added.push(clientID);
            else if (clientMeta !== undefined && state === null) removed.push(clientID);
            else if (state !== null) {
                if (!$1PYZG.equalityDeep(state, prevState)) filteredUpdated.push(clientID);
                updated.push(clientID);
            }
        }
    }
    if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit('change', [
        {
            added: added,
            updated: filteredUpdated,
            removed: removed
        },
        origin
    ]);
    if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit('update', [
        {
            added: added,
            updated: updated,
            removed: removed
        },
        origin
    ]);
};




var $02E42 = parcelRequire("02E42");
/**
 * Utility module to work with urls.
 *
 * @module url
 */ 
var $eCHRC = parcelRequire("eCHRC");
var $1578d003363fba4c$export$6025d61c37f75253 = function(url) {
    /**
   * @type {Object<string,string>}
   */ var query = {};
    var urlQuerySplit = url.split('?');
    var pairs = urlQuerySplit[urlQuerySplit.length - 1].split('&');
    for(var i = 0; i < pairs.length; i++){
        var item = pairs[i];
        if (item.length > 0) {
            var pair = item.split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
    }
    return query;
};
var $1578d003363fba4c$export$8c0ce924e434923b = function(params) {
    return $eCHRC.map(params, function(val, key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val));
    }).join('&');
};



var $cDSXo = parcelRequire("cDSXo");
var $0ade6dec7d8a9f78$export$70790f6f28b13205 = 0;
var $0ade6dec7d8a9f78$export$83b62f7afdd0e333 = 3;
var $0ade6dec7d8a9f78$export$790bca08a5d3ef2c = 1;
var $0ade6dec7d8a9f78$export$89c03a973d1d6923 = 2;
/**
 *                       encoder,          decoder,          provider,          emitSynced, messageType
 * @type {Array<function(encoding.Encoder, decoding.Decoder, WebsocketProvider, boolean,    number):void>}
 */ var $0ade6dec7d8a9f78$var$messageHandlers = [];
$0ade6dec7d8a9f78$var$messageHandlers[$0ade6dec7d8a9f78$export$70790f6f28b13205] = function(encoder, decoder, provider, emitSynced, _messageType) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$70790f6f28b13205);
    var syncMessageType = $61ed1827d431d4eb$export$26b589e63b591e96(decoder, encoder, provider.doc, provider);
    if (emitSynced && syncMessageType === $61ed1827d431d4eb$export$ff102031071a8f85 && !provider.synced) provider.synced = true;
};
$0ade6dec7d8a9f78$var$messageHandlers[$0ade6dec7d8a9f78$export$83b62f7afdd0e333] = function(encoder, _decoder, provider, _emitSynced, _messageType) {
    $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$790bca08a5d3ef2c);
    $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $7850ede759b9532e$export$e194fa93ebd743e9(provider.awareness, Array.from(provider.awareness.getStates().keys())));
};
$0ade6dec7d8a9f78$var$messageHandlers[$0ade6dec7d8a9f78$export$790bca08a5d3ef2c] = function(_encoder, decoder, provider, _emitSynced, _messageType) {
    $7850ede759b9532e$export$2f92845406d72d1a(provider.awareness, $182bfc4830c83d2c$export$7418bbc18dee40f3(decoder), provider);
};
$0ade6dec7d8a9f78$var$messageHandlers[$0ade6dec7d8a9f78$export$89c03a973d1d6923] = function(_encoder, decoder, provider, _emitSynced, _messageType) {
    $38198b79de2d8ce0$export$7e13d1a8c99eb68e(decoder, provider.doc, function(_ydoc, reason) {
        return $0ade6dec7d8a9f78$var$permissionDeniedHandler(provider, reason);
    });
};
// @todo - this should depend on awareness.outdatedTime
var $0ade6dec7d8a9f78$var$messageReconnectTimeout = 30000;
/**
 * @param {WebsocketProvider} provider
 * @param {string} reason
 */ var $0ade6dec7d8a9f78$var$permissionDeniedHandler = function(provider, reason) {
    return console.warn("Permission denied to access ".concat(provider.url, ".\n").concat(reason));
};
/**
 * @param {WebsocketProvider} provider
 * @param {Uint8Array} buf
 * @param {boolean} emitSynced
 * @return {encoding.Encoder}
 */ var $0ade6dec7d8a9f78$var$readMessage = function(provider, buf, emitSynced) {
    var decoder = $182bfc4830c83d2c$export$f8c898e83b60faaa(buf);
    var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
    try {
        var messageType = $182bfc4830c83d2c$export$5a476e4dbe7923d5(decoder);
        var messageHandler = provider.messageHandlers[messageType];
        if (/** @type {any} */ messageHandler) messageHandler(encoder, decoder, provider, emitSynced, messageType);
        else console.error('Unable to compute message');
    } catch (e) {}
    return encoder;
};
/**
 * @param {WebsocketProvider} provider
 */ var $0ade6dec7d8a9f78$var$setupWS = function(provider) {
    if (provider.shouldConnect && provider.ws === null) {
        var websocket = new provider._WS(provider.url);
        websocket.binaryType = 'arraybuffer';
        provider.ws = websocket;
        provider.wsconnecting = true;
        provider.wsconnected = false;
        provider.synced = false;
        websocket.onmessage = function(event) {
            provider.wsLastMessageReceived = $gL882.getUnixTime();
            var ab = new Uint8Array(event.data);
            var stringEventData = String.fromCharCode.apply(null, ab);
            if (stringEventData === 'SedestralSync#!') {
                // always send sync step 1 when connected
                var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$70790f6f28b13205);
                $61ed1827d431d4eb$export$2a4abf6cf2c7e66f(encoder, provider.doc);
                websocket.send($917f0b264ff88d53$export$73470fd2221e6aef(encoder));
                // broadcast local awareness state
                if (provider.awareness.getLocalState() !== null) {
                    var encoderAwarenessState = $917f0b264ff88d53$export$4e76eeb6df88c889();
                    $917f0b264ff88d53$export$872f48c75febcd2b(encoderAwarenessState, $0ade6dec7d8a9f78$export$790bca08a5d3ef2c);
                    $917f0b264ff88d53$export$f7d11515275e88a2(encoderAwarenessState, $7850ede759b9532e$export$e194fa93ebd743e9(provider.awareness, [
                        provider.doc.clientID
                    ]));
                    websocket.send($917f0b264ff88d53$export$73470fd2221e6aef(encoderAwarenessState));
                }
            } else {
                var encoder1 = $0ade6dec7d8a9f78$var$readMessage(provider, ab, true);
                if ($917f0b264ff88d53$export$f24224f1c91d8156(encoder1) > 1) websocket.send($917f0b264ff88d53$export$73470fd2221e6aef(encoder1));
            }
        };
        websocket.onerror = function(event) {
            provider.emit('connection-error', [
                event,
                provider
            ]);
        };
        websocket.onclose = function(event) {
            provider.emit('connection-close', [
                event,
                provider
            ]);
            provider.ws = null;
            provider.wsconnecting = false;
            if (provider.wsconnected) {
                provider.wsconnected = false;
                provider.synced = false;
                // update awareness (all users except local left)
                $7850ede759b9532e$export$3edbfe2f45ae9ff8(provider.awareness, Array.from(provider.awareness.getStates().keys()).filter(function(client) {
                    return client !== provider.doc.clientID;
                }), provider);
                provider.emit('status', [
                    {
                        status: 'disconnected'
                    }
                ]);
            } else provider.wsUnsuccessfulReconnects++;
            // Start with no reconnect timeout and increase timeout by
            // using exponential backoff starting with 100ms
            setTimeout($0ade6dec7d8a9f78$var$setupWS, $02E42.min($02E42.pow(2, provider.wsUnsuccessfulReconnects) * 100, provider.maxBackoffTime), provider);
        };
        websocket.onopen = function() {
            provider.wsLastMessageReceived = $gL882.getUnixTime();
            provider.wsconnecting = false;
            provider.wsconnected = true;
            provider.wsUnsuccessfulReconnects = 0;
            provider.emit('status', [
                {
                    status: 'connected'
                }
            ]);
        };
        provider.emit('status', [
            {
                status: 'connecting'
            }
        ]);
    }
};
/**
 * @param {WebsocketProvider} provider
 * @param {ArrayBuffer} buf
 */ var $0ade6dec7d8a9f78$var$broadcastMessage = function(provider, buf) {
    if (provider.wsconnected) /** @type {WebSocket} */ provider.ws.send(buf);
    if (provider.bcconnected) $3e0fc0c1d7111aec$export$89b472e03be495df(provider.bcChannel, buf, provider);
};
var $0ade6dec7d8a9f78$export$c0e03644998998fb = /*#__PURE__*/ function(Observable) {
    "use strict";
    (0, $jCmGC._)(WebsocketProvider, Observable);
    function WebsocketProvider(serverUrl, roomname, doc) {
        var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_connect = _ref.connect, connect = _ref_connect === void 0 ? true : _ref_connect, _ref_awareness = _ref.awareness, awareness = _ref_awareness === void 0 ? new $7850ede759b9532e$export$5bb40478b91fee65(doc) : _ref_awareness, _ref_params = _ref.params, params = _ref_params === void 0 ? {} : _ref_params, _ref_WebSocketPolyfill = _ref.WebSocketPolyfill, WebSocketPolyfill = _ref_WebSocketPolyfill === void 0 ? WebSocket : _ref_WebSocketPolyfill, _ref_resyncInterval = _ref.resyncInterval, resyncInterval = _ref_resyncInterval === void 0 ? -1 : _ref_resyncInterval, _ref_maxBackoffTime = _ref.maxBackoffTime, maxBackoffTime = _ref_maxBackoffTime === void 0 ? 2500 : _ref_maxBackoffTime, _ref_disableBc = _ref.disableBc, disableBc = _ref_disableBc === void 0 ? false : _ref_disableBc;
        (0, $3CDbU._)(this, WebsocketProvider);
        var _this;
        _this = (0, $ep9cZ._)(this, WebsocketProvider);
        // ensure that url is always ends with /
        while(serverUrl[serverUrl.length - 1] === '/')serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        var encodedParams = $1578d003363fba4c$export$8c0ce924e434923b(params);
        _this.maxBackoffTime = maxBackoffTime;
        _this.bcChannel = serverUrl + '/' + roomname;
        _this.url = serverUrl + '/' + roomname + (encodedParams.length === 0 ? '' : '?' + encodedParams);
        _this.roomname = roomname;
        _this.doc = doc;
        _this._WS = WebSocketPolyfill;
        _this.awareness = awareness;
        _this.wsconnected = false;
        _this.wsconnecting = false;
        _this.bcconnected = false;
        _this.disableBc = disableBc;
        _this.wsUnsuccessfulReconnects = 0;
        _this.messageHandlers = $0ade6dec7d8a9f78$var$messageHandlers.slice();
        /**
     * @type {boolean}
     */ _this._synced = false;
        /**
     * @type {WebSocket?}
     */ _this.ws = null;
        _this.wsLastMessageReceived = 0;
        /**
     * Whether to connect to other peers or not
     * @type {boolean}
     */ _this.shouldConnect = connect;
        /**
     * @type {number}
     */ _this._resyncInterval = 0;
        if (resyncInterval > 0) _this._resyncInterval = /** @type {any} */ setInterval(function() {
            if (_this.ws && _this.ws.readyState === WebSocket.OPEN) {
                // resend sync step 1
                var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$70790f6f28b13205);
                $61ed1827d431d4eb$export$2a4abf6cf2c7e66f(encoder, doc);
                _this.ws.send($917f0b264ff88d53$export$73470fd2221e6aef(encoder));
            }
        }, resyncInterval);
        /**
     * @param {ArrayBuffer} data
     * @param {any} origin
     */ _this._bcSubscriber = function(data, origin) {
            if (origin !== _this) {
                var encoder = $0ade6dec7d8a9f78$var$readMessage(_this, new Uint8Array(data), false);
                if ($917f0b264ff88d53$export$f24224f1c91d8156(encoder) > 1) $3e0fc0c1d7111aec$export$89b472e03be495df(_this.bcChannel, $917f0b264ff88d53$export$73470fd2221e6aef(encoder), _this);
            }
        };
        /**
     * Listens to Yjs updates and sends them to remote peers (ws and broadcastchannel)
     * @param {Uint8Array} update
     * @param {any} origin
     */ _this._updateHandler = function(update, origin) {
            if (origin !== _this) {
                var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$70790f6f28b13205);
                $61ed1827d431d4eb$export$72c173541034b28e(encoder, update);
                $0ade6dec7d8a9f78$var$broadcastMessage(_this, $917f0b264ff88d53$export$73470fd2221e6aef(encoder));
            }
        };
        _this.doc.on('update', _this._updateHandler);
        /**
     * @param {any} changed
     * @param {any} _origin
     */ _this._awarenessUpdateHandler = function(param, _origin) {
            var added = param.added, updated = param.updated, removed = param.removed;
            var changedClients = added.concat(updated).concat(removed);
            var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
            $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$790bca08a5d3ef2c);
            $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $7850ede759b9532e$export$e194fa93ebd743e9(awareness, changedClients));
            $0ade6dec7d8a9f78$var$broadcastMessage(_this, $917f0b264ff88d53$export$73470fd2221e6aef(encoder));
        };
        _this._unloadHandler = function() {
            $7850ede759b9532e$export$3edbfe2f45ae9ff8(_this.awareness, [
                doc.clientID
            ], 'window unload');
        };
        if (typeof window !== 'undefined') window.addEventListener('unload', _this._unloadHandler);
        else if (typeof $cDSXo !== 'undefined') $cDSXo.on('exit', _this._unloadHandler);
        awareness.on('update', _this._awarenessUpdateHandler);
        _this._checkInterval = /** @type {any} */ setInterval(function() {
            if (_this.wsconnected && $0ade6dec7d8a9f78$var$messageReconnectTimeout < $gL882.getUnixTime() - _this.wsLastMessageReceived) // no message received in a long time - not even your own awareness
            // updates (which are updated every 15 seconds)
            /** @type {WebSocket} */ _this.ws.close();
        }, $0ade6dec7d8a9f78$var$messageReconnectTimeout / 10);
        if (connect) _this.connect();
        return _this;
    }
    (0, $jyA4z._)(WebsocketProvider, [
        {
            key: "synced",
            get: /**
   * @type {boolean}
   */ function get() {
                return this._synced;
            },
            set: function set(state) {
                if (this._synced !== state) {
                    this._synced = state;
                    this.emit('synced', [
                        state
                    ]);
                    this.emit('sync', [
                        state
                    ]);
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this._resyncInterval !== 0) clearInterval(this._resyncInterval);
                clearInterval(this._checkInterval);
                this.disconnect();
                if (typeof window !== 'undefined') window.removeEventListener('unload', this._unloadHandler);
                else if (typeof $cDSXo !== 'undefined') $cDSXo.off('exit', this._unloadHandler);
                this.awareness.off('update', this._awarenessUpdateHandler);
                this.doc.off('update', this._updateHandler);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(WebsocketProvider.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "connectBc",
            value: function connectBc() {
                if (this.disableBc) return;
                if (!this.bcconnected) {
                    $3e0fc0c1d7111aec$export$ec068583843480e7(this.bcChannel, this._bcSubscriber);
                    this.bcconnected = true;
                }
                // send sync step1 to bc
                // write sync step 1
                var encoderSync = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoderSync, $0ade6dec7d8a9f78$export$70790f6f28b13205);
                $61ed1827d431d4eb$export$2a4abf6cf2c7e66f(encoderSync, this.doc);
                $3e0fc0c1d7111aec$export$89b472e03be495df(this.bcChannel, $917f0b264ff88d53$export$73470fd2221e6aef(encoderSync), this);
                // broadcast local state
                var encoderState = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoderState, $0ade6dec7d8a9f78$export$70790f6f28b13205);
                $61ed1827d431d4eb$export$b2b01faa10f64871(encoderState, this.doc);
                $3e0fc0c1d7111aec$export$89b472e03be495df(this.bcChannel, $917f0b264ff88d53$export$73470fd2221e6aef(encoderState), this);
                // write queryAwareness
                var encoderAwarenessQuery = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoderAwarenessQuery, $0ade6dec7d8a9f78$export$83b62f7afdd0e333);
                $3e0fc0c1d7111aec$export$89b472e03be495df(this.bcChannel, $917f0b264ff88d53$export$73470fd2221e6aef(encoderAwarenessQuery), this);
                // broadcast local awareness state
                var encoderAwarenessState = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoderAwarenessState, $0ade6dec7d8a9f78$export$790bca08a5d3ef2c);
                $917f0b264ff88d53$export$f7d11515275e88a2(encoderAwarenessState, $7850ede759b9532e$export$e194fa93ebd743e9(this.awareness, [
                    this.doc.clientID
                ]));
                $3e0fc0c1d7111aec$export$89b472e03be495df(this.bcChannel, $917f0b264ff88d53$export$73470fd2221e6aef(encoderAwarenessState), this);
            }
        },
        {
            key: "disconnectBc",
            value: function disconnectBc() {
                // broadcast message with local awareness state set to null (indicating disconnect)
                var encoder = $917f0b264ff88d53$export$4e76eeb6df88c889();
                $917f0b264ff88d53$export$872f48c75febcd2b(encoder, $0ade6dec7d8a9f78$export$790bca08a5d3ef2c);
                $917f0b264ff88d53$export$f7d11515275e88a2(encoder, $7850ede759b9532e$export$e194fa93ebd743e9(this.awareness, [
                    this.doc.clientID
                ], new Map()));
                $0ade6dec7d8a9f78$var$broadcastMessage(this, $917f0b264ff88d53$export$73470fd2221e6aef(encoder));
                if (this.bcconnected) {
                    $3e0fc0c1d7111aec$export$f500693cef883ffd(this.bcChannel, this._bcSubscriber);
                    this.bcconnected = false;
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.shouldConnect = false;
                this.disconnectBc();
                if (this.ws !== null) this.ws.close();
            }
        },
        {
            key: "connect",
            value: function connect() {
                this.shouldConnect = true;
                if (!this.wsconnected && this.ws === null) {
                    $0ade6dec7d8a9f78$var$setupWS(this);
                    this.connectBc();
                }
            }
        }
    ]);
    return WebsocketProvider;
}((0, $b78261e7e572625c$export$77cea355fa80b5f4));



var $gzN0P = parcelRequire("gzN0P");

var $co7RM = parcelRequire("co7RM");

var $9IvVr = parcelRequire("9IvVr");
var $712b8c213114f73d$export$d9845d64048805ae = /*#__PURE__*/ function() {
    "use strict";
    function CollaborationEditorService() {
        (0, $3CDbU._)(this, CollaborationEditorService);
    }
    (0, $jyA4z._)(CollaborationEditorService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.editors = (0, $j2lF8.observable)([]);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8GOyH.Services).beforeInit(this);
                this.products = [
                    (0, $co7RM.ProductType).PANEL,
                    (0, $co7RM.ProductType).COMMUNITY
                ];
                this.products.forEach(function(productType) {
                    (0, $8GOyH.Services).on(_this, productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_METADATA, function(data) {
                        if (data != undefined) _this.metadataEvents.forEach(function(value) {
                            if (value.editorId == data.editorId) value.func(data);
                        });
                    });
                    (0, $8GOyH.Services).on(_this, productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_ATTACHMENTS, function(data) {
                        var attachments = _this.storeAttachments(data);
                        var editor = _this.editors.filter(function(value) {
                            return value.id == data.editorId;
                        })[0];
                        if (editor) editor.attachments = attachments;
                        _this.attachmentsChangesEvents.forEach(function(value) {
                            if (value.editorId == data.editorId) value.func(data.viewerId, attachments);
                        });
                    });
                    (0, $8GOyH.Services).on(_this, productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_VIEWER_JOIN, function(viewer) {
                        viewer = _this.storeViewer(viewer);
                        var editor = _this.editors.filter(function(v) {
                            return v.id == viewer.editorId;
                        })[0];
                        if (editor != undefined) {
                            editor.viewers = (0, $78NO5._)(editor.viewers).concat([
                                viewer
                            ]);
                            _this.viewerJoinEvents.forEach(function(events) {
                                if (events.editorId == viewer.editorId) events.func(viewer);
                            });
                        }
                    });
                    (0, $8GOyH.Services).on(_this, productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_VIEWER_LEAVE, function(viewer) {
                        viewer = _this.storeViewer(viewer);
                        var editor = _this.editors.filter(function(v) {
                            return v.id == viewer.editorId;
                        })[0];
                        if (editor != undefined) {
                            editor.viewers.forEach(function(v) {
                                if (v.id == viewer.id) editor.viewers.splice(editor.viewers.indexOf(v), 1);
                            });
                            _this.viewerLeaveEvents.forEach(function(events) {
                                if (events.editorId == viewer.editorId) events.func(viewer);
                            });
                        }
                    });
                });
            }
        },
        {
            key: "onMetadata",
            value: /**
     * action
     */ function onMetadata(editorId, v, component) {
                var _this = this;
                var i = {
                    editorId: editorId,
                    func: v
                };
                this.metadataEvents.push(i);
                component.onRemove(function() {
                    return _this.metadataEvents.splice(_this.metadataEvents.indexOf(i), 1);
                });
            }
        },
        {
            key: "onAttachmentsChanges",
            value: function onAttachmentsChanges(editorId, v, component) {
                var _this = this;
                var i = {
                    editorId: editorId,
                    func: v
                };
                this.attachmentsChangesEvents.push(i);
                component.onRemove(function() {
                    return _this.attachmentsChangesEvents.splice(_this.attachmentsChangesEvents.indexOf(i), 1);
                });
            }
        },
        {
            key: "onViewerJoin",
            value: function onViewerJoin(editorId, v, component) {
                var _this = this;
                var i = {
                    editorId: editorId,
                    func: v
                };
                this.viewerJoinEvents.push(i);
                component.onRemove(function() {
                    return _this.viewerJoinEvents.splice(_this.viewerJoinEvents.indexOf(i), 1);
                });
            }
        },
        {
            key: "onViewerLeave",
            value: function onViewerLeave(editorId, v, component) {
                var _this = this;
                var i = {
                    editorId: editorId,
                    func: v
                };
                this.viewerLeaveEvents.push(i);
                component.onRemove(function() {
                    return _this.viewerLeaveEvents.splice(_this.viewerLeaveEvents.indexOf(i), 1);
                });
            }
        },
        {
            key: "savingMetadata",
            value: /**
     * saving
     */ function savingMetadata(productType, p) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).emitSync(productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_METADATA, p)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "savingAttachments",
            value: function savingAttachments(productType, p) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).emitSync(productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_ATTACHMENTS, p)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "collaborationJoin",
            value: /**
     * websocket doc
     */ function collaborationJoin(component, productType, editorId, privateId, connect, error) {
                var yDoc = new $81089639773113c2$export$bceacc74c2212615();
                var meta = yDoc.getMap('meta');
                var productName = (0, $9IvVr.ProductName).toString(productType);
                var provider = new (0, $0ade6dec7d8a9f78$export$c0e03644998998fb)("".concat((0, $gzN0P.config).editorCollaborationUrl, "/?productType=").concat(productName, "&private=").concat(privateId, "&editor=").concat(editorId, "&"), editorId, yDoc);
                component.onRemove(function() {
                    return provider.disconnect();
                });
                provider.on("status", function(data) {
                    if (data.status == "connected") connect({
                        yDoc: yDoc,
                        yText: yDoc.getText(editorId),
                        provider: provider
                    });
                    else {
                        provider.disconnect();
                        yDoc.destroy();
                        error();
                    }
                });
                provider.on('connection-error', function(data) {
                    if (!component.isNull()) {
                        provider.disconnect();
                        yDoc.destroy();
                        error();
                    }
                });
            }
        },
        {
            key: "join",
            value: /**
     * websocket handshaking
     */ function join(productType, data) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var join;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).join(productType, data, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_JOIN)
                                ];
                            case 1:
                                join = _state.sent();
                                if (typeof join != "number") {
                                    join.editor = _this.store(join.editor);
                                    join.viewer = _this.storeViewer(join.viewer);
                                }
                                return [
                                    2,
                                    join
                                ];
                            case 2:
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "leave",
            value: function leave(productType, editorId, viewerId) {
                (0, $3Qm5T.Network).emit(productType, (0, $7WDX1.WebSocketPanelEventName).COLLABORATION_EDITOR_LEAVE, {
                    editorId: editorId,
                    viewerId: viewerId
                });
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(editors) {
                for(var key in editors)editors[key] = this.store(editors[key]);
                return (0, $8GOyH.Services).storeAll(editors);
            }
        },
        {
            key: "store",
            value: function store(editor) {
                editor.viewers = this.storeViewersAll(editor.viewers);
                editor.attachments = this.storeAttachments(editor.attachments);
                editor = (0, $8GOyH.Services).store("id", this.editors, editor);
                return editor;
            }
        },
        {
            key: "storeAttachments",
            value: function storeAttachments(attachments) {
                attachments.previews.forEach(function(value) {
                    value.preview = (0, $3PS2c.PreviewService).store(value.preview);
                    value.account = (0, $fIUGb.AccountService).store(value.account);
                });
                attachments.files.forEach(function(value) {
                    value.file = (0, $38D2A.FileService).store(value.file);
                    value.account = (0, $fIUGb.AccountService).store(value.account);
                    if (value.cropping) Object.keys(value.cropping).forEach(function(key) {
                        var crop = value.cropping[key];
                        if (crop) crop.content = (0, $38D2A.FileService).store(crop.content);
                    });
                });
                return attachments;
            }
        },
        {
            key: "storeViewersAll",
            value: function storeViewersAll(viewers) {
                for(var key in viewers)viewers[key] = this.storeViewer(viewers[key]);
                return (0, $8GOyH.Services).storeAll(viewers);
            }
        },
        {
            key: "storeViewer",
            value: function storeViewer(viewer) {
                viewer.account = (0, $fIUGb.AccountService).store(viewer.account);
                viewer = (0, $8GOyH.Services).store("id", this.viewers, viewer);
                return viewer;
            }
        }
    ]);
    return CollaborationEditorService;
}();
$712b8c213114f73d$export$d9845d64048805ae.editors = (0, $j2lF8.observable)([]);
$712b8c213114f73d$export$d9845d64048805ae.viewers = (0, $j2lF8.observable)([]);
$712b8c213114f73d$export$d9845d64048805ae.attachmentsChangesEvents = [];
$712b8c213114f73d$export$d9845d64048805ae.viewerJoinEvents = [];
$712b8c213114f73d$export$d9845d64048805ae.viewerLeaveEvents = [];
$712b8c213114f73d$export$d9845d64048805ae.metadataEvents = [];
$712b8c213114f73d$export$d9845d64048805ae.products = [];



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $8GOyH = parcelRequire("8GOyH");

var $wYO7b = parcelRequire("wYO7b");

var $cKMRi = parcelRequire("cKMRi");
var $1a6dafa86dd08eae$export$961fa99b63baa1c2 = /*#__PURE__*/ function() {
    "use strict";
    function AccountPasswordLostService() {
        (0, $3CDbU._)(this, AccountPasswordLostService);
    }
    (0, $jyA4z._)(AccountPasswordLostService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "lost",
            value: /**
     * rest
     */ function lost(_lost, component) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: (0, $wYO7b.Resources).t("words.forgotPasswordEmailNoFound")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/account/password/lost", _lost, component)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AccountPasswordLostService;
}();




var $co7RM = parcelRequire("co7RM");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");
var $8195002ca55c0d75$export$88eb42c4a6e30051 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityTextsService() {
        (0, $3CDbU._)(this, CommunityTextsService);
    }
    (0, $jyA4z._)(CommunityTextsService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "update",
            value: /**
     * store
     */ function update(id, text) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/text/update/" + id, text)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeAll",
            value: function storeAll(texts) {
                for(var key in texts)texts[key] = this.store(texts[key]);
                return (0, $8GOyH.Services).storeAll(texts);
            }
        },
        {
            key: "store",
            value: function store(text) {
                return (0, $8GOyH.Services).store("id", this.texts, text);
            }
        }
    ]);
    return CommunityTextsService;
}();
$8195002ca55c0d75$export$88eb42c4a6e30051.texts = (0, $j2lF8.observable)([]);



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $fIUGb = parcelRequire("fIUGb");

var $3Qm5T = parcelRequire("3Qm5T");

var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");

var $gzN0P = parcelRequire("gzN0P");

var $9IvVr = parcelRequire("9IvVr");

var $3CDbU = parcelRequire("3CDbU");
var $90cfcb47c334f5cd$export$e473f7e46afe97f7 = function WebSocketCommunityEventName() {
    "use strict";
    (0, $3CDbU._)(this, WebSocketCommunityEventName);
};
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_JOIN = "community/join";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_LEAVE = "community/leave";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_UPDATE = "community/update";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_WRITING_STYLE_UPDATE = "community/writingStyle/update";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE = "community/seo/cluster/keywords/create";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_JOIN = "community/article/join";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_LEAVE = "community/article/leave";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_CREATE = "community/category/create";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_DELETE = "community/category/delete";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_CATEGORY_UPDATE = "community/category/update";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_CREATE = "community/article/create";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_DELETE = "community/article/delete";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_UPDATE = "community/article/update";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_RATING_UPDATE = "community/article/rating/update";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_PROPOSAL_CREATE = "community/article/proposal/create";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_SECTION_CREATE = "community/article/section/create";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE = "community/article/generate";
$90cfcb47c334f5cd$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE_START = "community/article/generate/start";



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $j2lF8 = parcelRequire("j2lF8");

var $8GOyH = parcelRequire("8GOyH");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");

var $gzN0P = parcelRequire("gzN0P");
var $0974ed23d17f50c2$export$3d1acc6bf13b6cd1 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityFilesService() {
        (0, $3CDbU._)(this, CommunityFilesService);
    }
    (0, $jyA4z._)(CommunityFilesService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "create",
            value: function create(communityId, fileType, files, progress, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postFormData((0, $co7RM.ProductType).COMMUNITY, "/community/files", {
                                        communityId: communityId,
                                        files: files,
                                        fileType: fileType
                                    }, component, {
                                        onUploadProgress: function(progressEvent) {
                                            if (progress) progress(progressEvent.loaded * 100 / progressEvent.total);
                                        }
                                    })
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "searchImages",
            value: function searchImages(communityId, query, page, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/files/search/images", {
                                        communityId: communityId,
                                        query: query,
                                        page: page
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadImage",
            value: function downloadImage(communityId, imageId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/files/download/image", {
                                        communityId: communityId,
                                        imageId: imageId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "link",
            value: /**
     * link
     */ function link(file) {
                var _config_httpCommunityUrl;
                return ((_config_httpCommunityUrl = (0, $gzN0P.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $gzN0P.config).domain) + "/community/files/".concat(file.id, ".").concat(file.extension);
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(files) {
                for(var key in files)files[key] = this.store(files[key]);
                return (0, $8GOyH.Services).storeAll(files);
            }
        },
        {
            key: "store",
            value: function store(file) {
                file.link = this.link(file);
                return (0, $8GOyH.Services).store("id", this.files, file);
            }
        }
    ]);
    return CommunityFilesService;
}();
$0974ed23d17f50c2$export$3d1acc6bf13b6cd1.files = (0, $j2lF8.observable)([]);


/**
 * Retire un élément de l'array
 */ function $6affb522515feef1$export$30a014203d0d7e4f(arr, obj) {
    var index = arr.indexOf(obj);
    if (index >= 0) arr.splice(index, 1);
}


var $a902714f509896c1$export$1f6539ddf1c5815 = /*#__PURE__*/ function(CommunityArticleAIState) {
    CommunityArticleAIState[CommunityArticleAIState["NONE"] = 0] = "NONE";
    CommunityArticleAIState[CommunityArticleAIState["WAITING_IA"] = 1] = "WAITING_IA";
    CommunityArticleAIState[CommunityArticleAIState["ERROR"] = 2] = "ERROR";
    CommunityArticleAIState[CommunityArticleAIState["DONE"] = 3] = "DONE";
    return CommunityArticleAIState;
}({});



var $3D7wv = parcelRequire("3D7wv");
var $3bfcd7021f279557$export$439035f52ab89a16 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityArticleService() {
        (0, $3CDbU._)(this, CommunityArticleService);
    }
    (0, $jyA4z._)(CommunityArticleService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.createEvents = [];
                this.deleteEvents = [];
                this.updateEvents = [];
                this.proposalEvents = [];
                this.sectionEvents = [];
                this.generateEvents = [];
                this.ratingUpdateEvents = [];
                this.generateStartEvents = [];
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                if ((0, $gzN0P.config).product != (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).LIVECHAT)) window["CommunityArticleService"] = this;
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_CREATE, function(data) {
                    var article = _this.store(data);
                    _this.createEvents.forEach(function(value) {
                        return value(article);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_UPDATE, function(data) {
                    var article = _this.store(data);
                    _this.updateEvents.forEach(function(value) {
                        return value(article);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_DELETE, function(data) {
                    var article = _this.store(data);
                    _this.deleteEvents.forEach(function(value) {
                        return value(article);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_PROPOSAL_CREATE, function(proposal) {
                    _this.storeProposal(proposal);
                    _this.proposalEvents.forEach(function(value) {
                        return value(proposal);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_SECTION_CREATE, function(section) {
                    _this.storeSection(section);
                    _this.sectionEvents.forEach(function(value) {
                        return value(section);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE, function(data) {
                    _this.generateEvents.forEach(function(value) {
                        return value(data);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_RATING_UPDATE, function(data) {
                    _this.ratingUpdateEvents.forEach(function(value) {
                        return value(data);
                    });
                });
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE_START, function(data) {
                    _this.generateStarts.push(data);
                    _this.generateStartEvents.forEach(function(value) {
                        return value(data);
                    });
                });
            }
        },
        {
            key: "onCreateEvent",
            value: /**
     * websocket
     */ function onCreateEvent(component, func) {
                var _this = this;
                this.createEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.createEvents, func);
                });
            }
        },
        {
            key: "onDeleteEvent",
            value: function onDeleteEvent(component, func) {
                var _this = this;
                this.deleteEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.deleteEvents, func);
                });
            }
        },
        {
            key: "onUpdateEvent",
            value: function onUpdateEvent(component, func) {
                var _this = this;
                this.updateEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.updateEvents, func);
                });
            }
        },
        {
            key: "onProposalEvent",
            value: function onProposalEvent(component, func) {
                var _this = this;
                this.proposalEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.proposalEvents, func);
                });
            }
        },
        {
            key: "onSectionEvent",
            value: function onSectionEvent(component, func) {
                var _this = this;
                this.sectionEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.sectionEvents, func);
                });
            }
        },
        {
            key: "onGenerateEvent",
            value: function onGenerateEvent(component, func) {
                var _this = this;
                this.generateEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.generateEvents, func);
                });
            }
        },
        {
            key: "onRatingUpdateEvent",
            value: function onRatingUpdateEvent(component, func) {
                var _this = this;
                this.ratingUpdateEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.ratingUpdateEvents, func);
                });
            }
        },
        {
            key: "onGenerateStartEvent",
            value: function onGenerateStartEvent(component, articleId, func) {
                var _this = this;
                var start = this.generateStarts.find(function(value) {
                    return value.articleId == articleId;
                });
                if (start) {
                    func(start);
                    (0, $6affb522515feef1$export$30a014203d0d7e4f)(this.generateStarts, start);
                }
                this.generateStartEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.generateStartEvents, func);
                });
            }
        },
        {
            key: "stepOptimization",
            value: /**
     * http
     */ function stepOptimization(communityArticleStepOptimization, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/step/optimization", communityArticleStepOptimization, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stepKeyword",
            value: function stepKeyword(keyword, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                                        message: (0, $wYO7b.Resources).t("words.maxProposalsPerItem")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/step/keyword", keyword, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stepSelectTerms",
            value: function stepSelectTerms(terms, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/step/manual/selectTerms", terms, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLinks",
            value: function getLinks(articleId, proposalItemIndex, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/article/links", {
                                        articleId: articleId,
                                        proposalItemIndex: proposalItemIndex
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiStepRulesValidate",
            value: function aiStepRulesValidate(rules, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/step/ai/rules", rules, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiStepRulesUpdate",
            value: function aiStepRulesUpdate(rules, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).UNAUTHORIZED,
                                        message: "none"
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: "none"
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).putJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/step/ai/rules", rules, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiProposalsRetry",
            value: function aiProposalsRetry(p, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/ai/proposals/retry", p, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiSections",
            value: function aiSections(p, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/ai/sections", p, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiSectionsRetry",
            value: function aiSectionsRetry(p, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/ai/sections/retry", p, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiSectionsUpdate",
            value: function aiSectionsUpdate(p, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/ai/sections/update", p, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "aiGenerate",
            value: function aiGenerate(p, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).GPT_RETRY_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxRetryLimit")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/article/ai/generate", p, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "lastUserContexts",
            value: function lastUserContexts(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/last-user-contexts/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findById",
            value: function findById(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generatedCount",
            value: function generatedCount(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/generated/count/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(_update, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).ROUTE_EXIST,
                                        message: (0, $wYO7b.Resources).t("words.routeExist")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).putJson((0, $co7RM.ProductType).COMMUNITY, "/community/article", _update, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    _this.store(request.data);
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(articleId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/article/".concat(articleId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) _this.unStore(request.data);
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "search",
            value: function search(communityId, language, _search, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/list/".concat(communityId, "/").concat(language, "/").concat(_search), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeArticles(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "alternate",
            value: function alternate(id, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/alternate/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getArticlesMonitoring",
            value: function getArticlesMonitoring(communityId, pagination, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/articles/monitoring/".concat(communityId), pagination, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRatingTermOverview",
            value: function getRatingTermOverview(articleId, term, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/article/rating/term/overview", {
                                        articleId: articleId,
                                        term: term
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "switchContentVersioning",
            value: function switchContentVersioning(articleId, contentVersioningId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/article/switchContentVersioning", {
                                        articleId: articleId,
                                        contentVersioningId: contentVersioningId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContentsVersioning",
            value: function getContentsVersioning(articleId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/contentsVersioning/".concat(articleId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "importContent",
            value: function importContent(communityId, url, remoteId, localId, component) {
                return (0, $hWZw8._)(function() {
                    var request, imported;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: (0, $wYO7b.Resources).t("words.importFailedContentTooSmall")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/article/import", {
                                        communityId: communityId,
                                        url: url,
                                        remoteId: remoteId,
                                        localId: localId
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) {
                                    imported = request.data;
                                    if (imported.title) imported.title = (0, $3D7wv.filterXSS)(imported.title);
                                    if (imported.html) imported.html = (0, $3D7wv.filterXSS)(imported.html);
                                    if (imported.snippet) imported.snippet = (0, $3D7wv.filterXSS)(imported.snippet);
                                    return [
                                        2,
                                        imported
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLastArticlesOverview",
            value: function getLastArticlesOverview(communityId, remote, cursor, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/article/overview", {
                                        communityId: communityId,
                                        remote: remote,
                                        cursor: cursor
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getByCommunity",
            value: function getByCommunity(communityId, nextCursor, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/article/list/".concat(communityId, "/").concat(nextCursor), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "join",
            value: /**
     * websocket
     */ function join(id) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(id != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).join((0, $co7RM.ProductType).COMMUNITY, id, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_JOIN)
                                ];
                            case 1:
                                _state.sent();
                                _this.joinedArticleId = id;
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "leave",
            value: function leave(id) {
                (0, $3Qm5T.Network).emit((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_LEAVE, id);
                this.joinedArticleId = undefined;
            }
        },
        {
            key: "storeArticles",
            value: /**
     * store
     */ function storeArticles(articles) {
                articles.articles = CommunityArticleService.storeAll(articles.articles);
                return articles;
            }
        },
        {
            key: "storeAll",
            value: function storeAll(articles) {
                for(var key in articles)articles[key] = this.store(articles[key]);
                return (0, $8GOyH.Services).storeAll(articles);
            }
        },
        {
            key: "storeProposal",
            value: function storeProposal(proposal) {
                var article = this.articles.find(function(value) {
                    return value.id == proposal.articleId;
                });
                if (article && article.proposals) article.proposals.items[proposal.index].proposals.push(proposal.proposal);
            }
        },
        {
            key: "storeSection",
            value: function storeSection(section) {
                var article = this.articles.find(function(value) {
                    return value.id == section.articleId;
                });
                if (article && article.sections) article.sections.items[section.indexSection].sections.push(section.section);
            }
        },
        {
            key: "store",
            value: function store(article) {
                var storedArticle = (0, $8GOyH.Services).get("id", this.articles, article.id);
                if (storedArticle != undefined) {
                    if (article.writersAccounts.length == 0 && storedArticle.writersAccounts.length !== 0) article.writersAccounts = storedArticle.writersAccounts;
                    if (article.writersRedactors.length == 0 && storedArticle.writersRedactors.length !== 0) article.writersRedactors = storedArticle.writersRedactors;
                }
                if (article.imageFile) article.imageFile = (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).store(article.imageFile);
                (0, $fIUGb.AccountService).storeAll(article.writersAccounts);
                return (0, $8GOyH.Services).store("id", this.articles, article);
            }
        },
        {
            key: "unStore",
            value: function unStore(article) {
                (0, $8GOyH.Services).unStore("id", this.articles, article);
            }
        },
        {
            key: "storeMetadata",
            value: function storeMetadata(metadata) {
                if (metadata.imageFile) metadata.imageFile = (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).store(metadata.imageFile);
                (0, $fIUGb.AccountService).storeAll(metadata.writersAccounts);
            }
        },
        {
            key: "getMainKeyword",
            value: function getMainKeyword(article) {
                var _article_sections, _article_proposals_items_doneSection_index_keywords, _article_proposals_items_doneSection_index, _article_proposals;
                var doneSection = article === null || article === void 0 ? void 0 : (_article_sections = article.sections) === null || _article_sections === void 0 ? void 0 : _article_sections.items.find(function(section) {
                    return section.state === (0, $a902714f509896c1$export$1f6539ddf1c5815).DONE;
                });
                var _article_proposals_items_doneSection_index_keywords_;
                return doneSection ? (_article_proposals_items_doneSection_index_keywords_ = article === null || article === void 0 ? void 0 : (_article_proposals = article.proposals) === null || _article_proposals === void 0 ? void 0 : (_article_proposals_items_doneSection_index = _article_proposals.items[doneSection.index]) === null || _article_proposals_items_doneSection_index === void 0 ? void 0 : (_article_proposals_items_doneSection_index_keywords = _article_proposals_items_doneSection_index.keywords) === null || _article_proposals_items_doneSection_index_keywords === void 0 ? void 0 : _article_proposals_items_doneSection_index_keywords[0]) !== null && _article_proposals_items_doneSection_index_keywords_ !== void 0 ? _article_proposals_items_doneSection_index_keywords_ : "" : "";
            }
        }
    ]);
    return CommunityArticleService;
}();
$3bfcd7021f279557$export$439035f52ab89a16.NB_MAX_SECTIONS_BY_ITEM = 7;
$3bfcd7021f279557$export$439035f52ab89a16.articles = (0, $j2lF8.observable)([]);
$3bfcd7021f279557$export$439035f52ab89a16.createEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.deleteEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.updateEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.proposalEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.sectionEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.generateEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.ratingUpdateEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.generateStartEvents = [];
$3bfcd7021f279557$export$439035f52ab89a16.generateStarts = [];



var $cKMRi = parcelRequire("cKMRi");

var $co7RM = parcelRequire("co7RM");

var $gzN0P = parcelRequire("gzN0P");

var $9IvVr = parcelRequire("9IvVr");

var $wYO7b = parcelRequire("wYO7b");


var $dNI0C = parcelRequire("dNI0C");


var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");
var $22622019e616911c$export$27fb916c8cac12c7 = /*#__PURE__*/ function(CommunityVisitorActionType) {
    CommunityVisitorActionType[CommunityVisitorActionType["LINK"] = 1] = "LINK";
    return CommunityVisitorActionType;
}({});



var $5m1WU = parcelRequire("5m1WU");
var $0c7a6457a5512246$export$d41076a259927884 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityVisitorsService() {
        (0, $3CDbU._)(this, CommunityVisitorsService);
    }
    (0, $jyA4z._)(CommunityVisitorsService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $3Qm5T.Network).onStarted(function() {
                    (0, $3Qm5T.Network).router.pages.stats.onNewPage(function(stats, page) {
                        _this.queuedPages.push({
                            duration: page.duration,
                            route: page.route,
                            endTime: page.endTime,
                            startTime: page.startTime,
                            viewedPercentage: page.viewedPercentage,
                            actions: page.actions.map(function(value) {
                                return {
                                    name: value.name,
                                    value: value.value,
                                    time: value.time,
                                    actionType: value.type == "link" ? (0, $22622019e616911c$export$27fb916c8cac12c7).LINK : (0, $22622019e616911c$export$27fb916c8cac12c7).LINK
                                };
                            })
                        });
                    });
                    (0, $3Qm5T.Network).router.pages.stats.onClosePage(function(stats) {
                        return _this.save();
                    });
                    (0, $5m1WU.SedestralMachine).setInterval(function() {
                        return _this.save();
                    }, 15000);
                });
            }
        },
        {
            key: "save",
            value: function save() {
                if (this.queuedPages.length > 0) {
                    this.insert({
                        frontId: (0, $3Qm5T.Network).router.pages.stats.frontId,
                        referrer: (0, $3Qm5T.Network).router.pages.stats.referrer,
                        pages: this.queuedPages
                    });
                    this.queuedPages = [];
                }
            }
        },
        {
            key: "insert",
            value: function insert(visitor, component) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/visitor", visitor, component)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityVisitorsService;
}();
$0c7a6457a5512246$export$d41076a259927884.queuedPages = [];



var $5m1WU = parcelRequire("5m1WU");

var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");


var $8GOyH = parcelRequire("8GOyH");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $0809f71de61244f0$export$6368a938bdcd0b2 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityAutopilotService() {
        (0, $3CDbU._)(this, CommunityAutopilotService);
    }
    (0, $jyA4z._)(CommunityAutopilotService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "update",
            value: function update(communityId, communityAutopilot, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).COMMUNITY_AUTOPILOT_DAYS_MAX,
                                        message: (0, $wYO7b.Resources).t("words.communityAutopilotDaysMax")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/autopilot/update/".concat(communityId), communityAutopilot)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    (0, $4adbbe1bc8046e85$export$55b7b226f6213252).store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addCluster",
            value: function addCluster(communityId, clusterId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/autopilot/cluster/add/".concat(communityId, "/").concat(clusterId), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    (0, $4adbbe1bc8046e85$export$55b7b226f6213252).store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteCluster",
            value: function deleteCluster(communityId, clusterId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/autopilot/cluster/delete/".concat(communityId, "/").concat(clusterId), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    (0, $4adbbe1bc8046e85$export$55b7b226f6213252).store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityAutopilotService;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");



var $3a4bdebc3753a714$export$106b309753d02dc0 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityWritingStyleService() {
        (0, $3CDbU._)(this, CommunityWritingStyleService);
    }
    (0, $jyA4z._)(CommunityWritingStyleService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.styleEvents = [];
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_WRITING_STYLE_UPDATE, function(data) {
                    (0, $4adbbe1bc8046e85$export$55b7b226f6213252).store(data.community);
                    _this.styleEvents.forEach(function(value) {
                        return value(data);
                    });
                });
            }
        },
        {
            key: "onWritingStyle",
            value: /**
     * websocket
     */ function onWritingStyle(component, func) {
                var _this = this;
                this.styleEvents.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.styleEvents, func);
                });
            }
        },
        {
            key: "create",
            value: function create(style, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/writingStyle", style, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(communityId, writingStyleId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/writingStyle/".concat(communityId, "/").concat(writingStyleId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request && request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    (0, $4adbbe1bc8046e85$export$55b7b226f6213252).store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityWritingStyleService;
}();
$3a4bdebc3753a714$export$106b309753d02dc0.styleEvents = [];



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");

var $8GOyH = parcelRequire("8GOyH");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $8fdfef0e39dd4d00$export$c8c9ba79e1431b49 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityKeywordsService() {
        (0, $3CDbU._)(this, CommunityKeywordsService);
    }
    (0, $jyA4z._)(CommunityKeywordsService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "getKeywordsSite",
            value: function getKeywordsSite(search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).BAD_REQUEST,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/keywords/site", search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "searchKeywords",
            value: function searchKeywords(name, search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/keywords/search/".concat(name), search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "searchKeywordsHistory",
            value: function searchKeywordsHistory(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/keywords/search/history/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createRankingOverview",
            value: function createRankingOverview(communityId, host, owner, dateStart, dateEnd, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).HOST_EXIST,
                                        message: (0, $wYO7b.Resources).t("words.domainAlreadyInStats")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/overview/create/".concat(communityId, "/").concat(host, "/").concat(owner, "/").concat(dateStart, "/").concat(dateEnd), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRankingOverview",
            value: function getRankingOverview(communityId, dateStart, dateEnd, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/overview/".concat(communityId, "/").concat(dateStart, "/").concat(dateEnd), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                if (request.status == (0, $cKMRi.HttpStatus).NOT_FOUND) return [
                                    2,
                                    []
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIndividualsPositioning",
            value: function getIndividualsPositioning(id, search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/individualsPositioning/".concat(id), search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCannibalization",
            value: function getCannibalization(communityId, pagination, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/cannibalization/".concat(communityId), pagination, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getComparativePositioning",
            value: function getComparativePositioning(search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/comparativePositioning", search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteRanking",
            value: function deleteRanking(id, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/ranking/".concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityKeywordsService;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");
var $8023e35a6a632259$export$b7b630d38b5e9168 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityKnowledgeService() {
        (0, $3CDbU._)(this, CommunityKnowledgeService);
    }
    (0, $jyA4z._)(CommunityKnowledgeService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "getByCommunity",
            value: function getByCommunity(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(communityId, name, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/create/".concat(communityId, "/").concat(name), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(communityId, knowledgeId, name, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/update/".concat(communityId, "/").concat(knowledgeId, "/").concat(name), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(communityId, knowledgeId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/delete/".concat(communityId, "/").concat(knowledgeId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createResource",
            value: function createResource(communityId, knowledgeId, resource, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/create/resource/".concat(communityId, "/").concat(knowledgeId), resource, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createResourceFile",
            value: function createResourceFile(communityId, knowledgeId, meshing, file, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postFormData((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/create/resource/file/".concat(communityId, "/").concat(meshing, "/").concat(knowledgeId), {
                                        file: file
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteResource",
            value: function deleteResource(communityId, knowledgeId, resourceId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/knowledge/delete/".concat(communityId, "/").concat(knowledgeId, "/").concat(resourceId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status === (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityKnowledgeService;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");



var $8GOyH = parcelRequire("8GOyH");

var $dNI0C = parcelRequire("dNI0C");

var $wYO7b = parcelRequire("wYO7b");
var $4b99c5a05950c13e$export$19e8f5eea8d43acd = /*#__PURE__*/ function() {
    "use strict";
    function CommunityClustersService() {
        (0, $3CDbU._)(this, CommunityClustersService);
    }
    (0, $jyA4z._)(CommunityClustersService, null, [
        {
            key: "dispose",
            value: function dispose() {
                this.events = [];
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE, function(data) {
                    _this.events.forEach(function(value) {
                        return value(data);
                    });
                });
            }
        },
        {
            key: "create",
            value: function create(communityId, query, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/keywords/create/".concat(communityId, "/").concat(query), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(communityId, clusterId, keywords, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MIN,
                                        message: (0, $wYO7b.Resources).t("words.minKeywords")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SIZE_MAX,
                                        message: (0, $wYO7b.Resources).t("words.maxKeywords")
                                    },
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).MAX_LIMIT,
                                        message: (0, $wYO7b.Resources).t("words.maxClusterModification")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).putJson((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/keywords/update/".concat(communityId, "/").concat(clusterId), keywords, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPreviewsByCommunityId",
            value: function getPreviewsByCommunityId(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/keywords/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getClusters",
            value: function getClusters(communityId, clusterId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/keywords/".concat(communityId, "/").concat(clusterId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCompetitors",
            value: function getCompetitors(communityId, clusterId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/keywords/competitors/".concat(communityId, "/").concat(clusterId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(communityId, id, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/clusters/".concat(communityId, "/").concat(id), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onClusterCreate",
            value: function onClusterCreate(component, func) {
                var _this = this;
                this.events.push(func);
                component.onRemove(function() {
                    return (0, $6affb522515feef1$export$30a014203d0d7e4f)(_this.events, func);
                });
            }
        }
    ]);
    return CommunityClustersService;
}();
$4b99c5a05950c13e$export$19e8f5eea8d43acd.events = [];



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");

var $8GOyH = parcelRequire("8GOyH");

var $wYO7b = parcelRequire("wYO7b");
var $0fe6d8747c3fe7b9$export$d57fb523d3be1724 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityGscService() {
        (0, $3CDbU._)(this, CommunityGscService);
    }
    (0, $jyA4z._)(CommunityGscService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "getGsc",
            value: function getGsc(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/gsc/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/gsc/disconnect/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verification",
            value: function verification(communityId, verificationType, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/gsc/verification/".concat(verificationType, "/").concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addSitemapGsc",
            value: function addSitemapGsc(communityId, url, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).BAD_REQUEST,
                                        message: (0, $wYO7b.Resources).t("words.sitemapRejectedByGoogle")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/gsc/addSitemap/".concat(communityId), {
                                        url: url
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteSitemapGsc",
            value: function deleteSitemapGsc(communityId, url, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).BAD_REQUEST,
                                        message: (0, $wYO7b.Resources).t("words.requestRejectedByGoogle")
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/gsc/deleteSitemap/".concat(communityId), {
                                        url: url
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                return [
                                    2,
                                    request.status == (0, $cKMRi.HttpStatus).OK
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunityGscService;
}();


var $4adbbe1bc8046e85$export$55b7b226f6213252 = /*#__PURE__*/ function() {
    "use strict";
    function CommunityService() {
        (0, $3CDbU._)(this, CommunityService);
    }
    (0, $jyA4z._)(CommunityService, null, [
        {
            key: "dispose",
            value: function dispose() {
                (0, $8195002ca55c0d75$export$88eb42c4a6e30051).dispose();
                (0, $3bfcd7021f279557$export$439035f52ab89a16).dispose();
                (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).dispose();
                (0, $0809f71de61244f0$export$6368a938bdcd0b2).dispose();
                (0, $8fdfef0e39dd4d00$export$c8c9ba79e1431b49).dispose();
                (0, $4b99c5a05950c13e$export$19e8f5eea8d43acd).dispose();
                (0, $8023e35a6a632259$export$b7b630d38b5e9168).dispose();
                (0, $0c7a6457a5512246$export$d41076a259927884).dispose();
                (0, $3a4bdebc3753a714$export$106b309753d02dc0).dispose();
                (0, $0fe6d8747c3fe7b9$export$d57fb523d3be1724).dispose();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                (0, $8195002ca55c0d75$export$88eb42c4a6e30051).init();
                (0, $3bfcd7021f279557$export$439035f52ab89a16).init();
                (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).init();
                (0, $0809f71de61244f0$export$6368a938bdcd0b2).init();
                (0, $8fdfef0e39dd4d00$export$c8c9ba79e1431b49).init();
                (0, $4b99c5a05950c13e$export$19e8f5eea8d43acd).init();
                (0, $8023e35a6a632259$export$b7b630d38b5e9168).init();
                (0, $3a4bdebc3753a714$export$106b309753d02dc0).init();
                (0, $0fe6d8747c3fe7b9$export$d57fb523d3be1724).init();
                if ((0, $gzN0P.config).product != (0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).LIVECHAT)) window["CommunityService"] = this;
                (0, $3Qm5T.Network).on((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_UPDATE, function(data) {
                    _this.store(data);
                });
            }
        },
        {
            key: "addLanguage",
            value: /**
     * http
     */ function addLanguage(communityId, language, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).put((0, $co7RM.ProductType).COMMUNITY, "/community/addLanguage", {
                                        communityId: communityId,
                                        language: language
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateSendEmailNotificationRanking",
            value: function updateSendEmailNotificationRanking(communityId, sendEmailNotificationRanking) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/sendEmailNotificationRanking/update/".concat(communityId, "/").concat(sendEmailNotificationRanking))
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateContext",
            value: function updateContext(communityId, context, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/context/update", {
                                        communityId: communityId,
                                        context: context
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createHost",
            value: function createHost(communityId, host, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/host/create", {
                                        communityId: communityId,
                                        host: host
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findBySite",
            value: function findBySite(siteId, type, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).SERVICE_UNAVAILABLE,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/site/".concat(siteId, "/").concat(type), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request && request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.storeAll(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findLimitsBySite",
            value: function findLimitsBySite(siteId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/site/".concat(siteId, "/limits"), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request && request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(communityId, component) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/".concat(communityId), component)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findById",
            value: function findById(communityId, language, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/".concat(communityId, "/").concat(language), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request && request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createStep0",
            value: function createStep0(communityCreateStep0Model, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/create/step/0", communityCreateStep0Model, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createStep1",
            value: function createStep1(communityCreateStep1Model, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/create/step/1", communityCreateStep1Model, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "configExportNone",
            value: function configExportNone(communityId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/config/export/none/".concat(communityId), {}, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addRedactor",
            value: function addRedactor(communityId, name, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/redactor", {
                                        communityId: communityId,
                                        name: name
                                    }, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteRedactor",
            value: function deleteRedactor(communityId, redactorId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network)["delete"]((0, $co7RM.ProductType).COMMUNITY, "/community/redactor/".concat(communityId, "/").concat(redactorId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkInternalHost",
            value: function checkInternalHost(communityId, hostname, communityType, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        status: (0, $cKMRi.HttpStatus).BAD_REQUEST,
                                        errorCode: (0, $dNI0C.ErrorCode).HOST_EXIST,
                                        message: "none"
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        errorCode: (0, $dNI0C.ErrorCode).HOST_EXIST
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/checkInternalHost/".concat(hostname, "/").concat(communityType, "/").concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getById",
            value: function getById(communityId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $8GOyH.Services).handleErrors(component, [
                                    {
                                        errorCode: (0, $dNI0C.ErrorCode).SUSPENDED,
                                        message: (0, $wYO7b.Resources).t("words.communitySuspendedDueToOfferInsufficiency")
                                    },
                                    {
                                        status: (0, $cKMRi.HttpStatus).NOT_FOUND,
                                        message: "none"
                                    }
                                ]);
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "selectPartnerBlog",
            value: function selectPartnerBlog(communityId, remoteId, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).post((0, $co7RM.ProductType).COMMUNITY, "/community/select/partner/blog/".concat(communityId, "/").concat(remoteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    _this.store(request.data)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPartnerBlogColumns",
            value: function getPartnerBlogColumns(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/list/partner/blog/columns/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updatePartnerBlogColumns",
            value: function updatePartnerBlogColumns(communityId, columns, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).COMMUNITY, "/community/list/partner/blog/columns/".concat(communityId), columns, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getListPartnerBlog",
            value: function getListPartnerBlog(communityId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/list/partner/blog/".concat(communityId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCommunitiesAdmin",
            value: function getCommunitiesAdmin(siteId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/admin/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetCommunityStatsBySiteId",
            value: function resetCommunityStatsBySiteId(siteId, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).get((0, $co7RM.ProductType).COMMUNITY, "/community/admin/resetStats/".concat(siteId), component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    true
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "start",
            value: /**
     * start
     */ function start(options, communityCreateStep0Model, component) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var community;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.createStep0(communityCreateStep0Model, component)
                                ];
                            case 1:
                                community = _state.sent();
                                if (!community) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.reload("/".concat(options.basePath, "/").concat(community.id, "/content/home"))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    community
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startSocket",
            value: /**
     * websocket
     */ function startSocket(onRetry) {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    var retry, socket;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                retry = /*#__PURE__*/ function() {
                                    var _ref = (0, $hWZw8._)(function() {
                                        return (0, $eJDpD.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (onRetry) onRetry();
                                                    return [
                                                        4,
                                                        (0, $5m1WU.SedestralMachine).sleep(2500)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        _this.startSocket()
                                                    ];
                                                case 2:
                                                    if (!_state.sent()) return [
                                                        3,
                                                        4
                                                    ];
                                                    return [
                                                        4,
                                                        (0, $5m1WU.SedestralMachine).sleep(7000)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    window.location.reload();
                                                    _state.label = 4;
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function retry() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    4,
                                    (0, $3Qm5T.Network).startWebSocket((0, $co7RM.ProductType).COMMUNITY, function() {
                                        return retry();
                                    })
                                ];
                            case 1:
                                socket = _state.sent();
                                if (!!socket) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    retry()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    socket
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disposeSocket",
            value: function disposeSocket() {
                (0, $3Qm5T.Network).getSocket((0, $co7RM.ProductType).COMMUNITY).disconnect(true);
            }
        },
        {
            key: "join",
            value: function join(id) {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(id != null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).join((0, $co7RM.ProductType).COMMUNITY, id, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_JOIN)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "leave",
            value: function leave(id) {
                (0, $3Qm5T.Network).emit((0, $co7RM.ProductType).COMMUNITY, (0, $90cfcb47c334f5cd$export$e473f7e46afe97f7).COMMUNITY_LEAVE, id);
            }
        },
        {
            key: "storeAll",
            value: /**
     * store
     */ function storeAll(communities) {
                for(var key in communities)communities[key] = this.store(communities[key]);
                return (0, $8GOyH.Services).storeAll(communities);
            }
        },
        {
            key: "store",
            value: function store(community) {
                var storedCommunity = (0, $8GOyH.Services).get("id", this.communities, community.id);
                if (storedCommunity != undefined) {
                    if (!community.autopilot && storedCommunity.autopilot) community.autopilot = storedCommunity.autopilot;
                    if (!community.partner && storedCommunity.partner) community.partner = storedCommunity.partner;
                    if (!community.context && storedCommunity.context) community.context = storedCommunity.context;
                    if (!community.writingStyles && storedCommunity.writingStyles) community.writingStyles = storedCommunity.writingStyles;
                    if (!community.redactors && storedCommunity.redactors) community.redactors = storedCommunity.redactors;
                }
                if (community.text) community.text = (0, $8195002ca55c0d75$export$88eb42c4a6e30051).store(community.text);
                if (community.logoFile) community.logoFile = (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).store(community.logoFile);
                if (community.footerFile) community.footerFile = (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).store(community.footerFile);
                if (community.faviconFile) community.faviconFile = (0, $0974ed23d17f50c2$export$3d1acc6bf13b6cd1).store(community.faviconFile);
                return (0, $8GOyH.Services).store("id", this.communities, community);
            }
        },
        {
            key: "getHost",
            value: function getHost(community) {
                community.host.startsWith("mon url");
                return community.host.startsWith("http") ? community.host : "https://" + community.host;
            }
        }
    ]);
    return CommunityService;
}();
$4adbbe1bc8046e85$export$55b7b226f6213252.communities = (0, $j2lF8.observable)([]);



var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jCmGC = parcelRequire("jCmGC");


var $hWZw8 = parcelRequire("hWZw8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $eJDpD = parcelRequire("eJDpD");

var $9gCL8 = parcelRequire("9gCL8");

var $ep9cZ = parcelRequire("ep9cZ");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");


var $5q8bQ = parcelRequire("5q8bQ");

var $jCmGC = parcelRequire("jCmGC");

var $9gCL8 = parcelRequire("9gCL8");
var $ef941d18cdb6fbba$exports = {};

$parcel$export($ef941d18cdb6fbba$exports, "globalProgressBar", function () { return $ef941d18cdb6fbba$export$e10d7fe02c4d3a0c; }, function (v) { return $ef941d18cdb6fbba$export$e10d7fe02c4d3a0c = v; });
$parcel$export($ef941d18cdb6fbba$exports, "white", function () { return $ef941d18cdb6fbba$export$8fa4e5556fd77a60; }, function (v) { return $ef941d18cdb6fbba$export$8fa4e5556fd77a60 = v; });
$parcel$export($ef941d18cdb6fbba$exports, "percent", function () { return $ef941d18cdb6fbba$export$626336c2cd4b14de; }, function (v) { return $ef941d18cdb6fbba$export$626336c2cd4b14de = v; });
$parcel$export($ef941d18cdb6fbba$exports, "bar", function () { return $ef941d18cdb6fbba$export$d927737047eb3867; }, function (v) { return $ef941d18cdb6fbba$export$d927737047eb3867 = v; });
$parcel$export($ef941d18cdb6fbba$exports, "orange", function () { return $ef941d18cdb6fbba$export$ad766f34ace1cafd; }, function (v) { return $ef941d18cdb6fbba$export$ad766f34ace1cafd = v; });
$parcel$export($ef941d18cdb6fbba$exports, "red", function () { return $ef941d18cdb6fbba$export$a90204d1394caf30; }, function (v) { return $ef941d18cdb6fbba$export$a90204d1394caf30 = v; });
$parcel$export($ef941d18cdb6fbba$exports, "green", function () { return $ef941d18cdb6fbba$export$955a2ebd2fb142ae; }, function (v) { return $ef941d18cdb6fbba$export$955a2ebd2fb142ae = v; });
var $ef941d18cdb6fbba$export$e10d7fe02c4d3a0c;
var $ef941d18cdb6fbba$export$8fa4e5556fd77a60;
var $ef941d18cdb6fbba$export$626336c2cd4b14de;
var $ef941d18cdb6fbba$export$d927737047eb3867;
var $ef941d18cdb6fbba$export$ad766f34ace1cafd;
var $ef941d18cdb6fbba$export$a90204d1394caf30;
var $ef941d18cdb6fbba$export$955a2ebd2fb142ae;
$ef941d18cdb6fbba$export$e10d7fe02c4d3a0c = "e-V-Z";
$ef941d18cdb6fbba$export$8fa4e5556fd77a60 = "SBf3T";
$ef941d18cdb6fbba$export$626336c2cd4b14de = "rJYe6";
$ef941d18cdb6fbba$export$d927737047eb3867 = "UQ3HL";
$ef941d18cdb6fbba$export$ad766f34ace1cafd = "wAHO5";
$ef941d18cdb6fbba$export$a90204d1394caf30 = "OZINJ";
$ef941d18cdb6fbba$export$955a2ebd2fb142ae = "aOQjW";



var $5m1WU = parcelRequire("5m1WU");
var $ed8411a99200f4e9$export$19e02114ee9734c8 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(ProgressBarComponent, Component);
    function ProgressBarComponent(p) {
        (0, $3CDbU._)(this, ProgressBarComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, ProgressBarComponent);
        _this.p = p;
        //language=HTML
        _this.template = '\n            <div data-tooltip="'.concat(p.tooltip, '" class="').concat($ef941d18cdb6fbba$exports.globalProgressBar, " ").concat(p.white ? $ef941d18cdb6fbba$exports.white : "", '">\n                <div class="').concat($ef941d18cdb6fbba$exports.bar, " ").concat(p.color ? $ef941d18cdb6fbba$exports[p.color] : "", '"></div>\n                ').concat(p.showValue ? '<div class="'.concat($ef941d18cdb6fbba$exports.percent, '">50%</div>') : "", "\n            </div>\n        ");
        return _this;
    }
    (0, $jyA4z._)(ProgressBarComponent, [
        {
            key: "commit",
            value: function commit() {
                this.barComponent = this.el($ef941d18cdb6fbba$exports.bar);
                if (this.p.tooltip) (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(ProgressBarComponent.prototype), "commitTooltips", this).call(this);
                this.barComponent.setStyle("width:0%;");
                this.setBar(this.p.value);
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(ProgressBarComponent.prototype), "commit", this).call(this);
            }
        },
        {
            key: "setBar",
            value: function setBar(value) {
                var _this = this;
                this.p.value = value;
                if (this.p.autoTooltip) {
                    this.clearTooltipListeners();
                    this.setTooltip("".concat(this.p.value, "/").concat(this.p.maxValue));
                }
                if (this.p.autoColor || this.p.autoColorInvert) {
                    this.barComponent.setAttribute("class", $ef941d18cdb6fbba$exports.bar);
                    this.barComponent.addClass($ef941d18cdb6fbba$exports[this.p.autoColorInvert ? this.getColorInvert() : this.getColor()]);
                }
                var width = Math.round(this.p.value * 100 / this.p.maxValue);
                (0, $5m1WU.SedestralMachine).requestFrame()(function() {
                    _this.barComponent.setStyle("width:".concat(width, "%;transition-duration: ").concat(_this.p.animationDelay / 1000, "s;"));
                });
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                var percentage = this.p.value / this.p.maxValue * 100;
                if (percentage < 30) return "red";
                else if (percentage >= 30 && percentage <= 60) return "orange";
                else return "green";
            }
        },
        {
            key: "getColorInvert",
            value: function getColorInvert() {
                var percentage = this.p.value / this.p.maxValue * 100;
                if (percentage < 50) return "green";
                else if (percentage < 65) return "orange";
                else return "red";
            }
        }
    ]);
    return ProgressBarComponent;
}((0, $9gCL8.Component));


var $a286755e58af7ca1$export$a43cfac3bb87a4c;
var $a286755e58af7ca1$export$6d59db4903f20f7d;
var $a286755e58af7ca1$export$504d7abb21fa8c9;
var $a286755e58af7ca1$export$2ba01fb71ed41cb6;
var $a286755e58af7ca1$export$1ca1ec8b29a4ce27;
$a286755e58af7ca1$export$a43cfac3bb87a4c = "ynzIG";
$a286755e58af7ca1$export$6d59db4903f20f7d = "nPGy9";
$a286755e58af7ca1$export$504d7abb21fa8c9 = "d0vhn";
$a286755e58af7ca1$export$2ba01fb71ed41cb6 = "DozN7";
$a286755e58af7ca1$export$1ca1ec8b29a4ce27 = "AEdIg";



var $co7RM = parcelRequire("co7RM");


var $wYO7b = parcelRequire("wYO7b");

var $lThic = parcelRequire("lThic");

var $3Qm5T = parcelRequire("3Qm5T");
var $6c46cf8fdfb47606$export$713337cf8164d1db = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $jCmGC._)(OfferBlockedComponent, Component);
    function OfferBlockedComponent(currentQuantity, limitQuantity, solutionType, productType) {
        (0, $3CDbU._)(this, OfferBlockedComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferBlockedComponent);
        //language=HTML
        _this.template = '\n            <div class="'.concat($a286755e58af7ca1$export$a43cfac3bb87a4c, '">\n                <div class="').concat($a286755e58af7ca1$export$6d59db4903f20f7d, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerBlockedDesc"), '\n                </div>\n                <div class="').concat($a286755e58af7ca1$export$504d7abb21fa8c9, '">\n                    ').concat(_this.draw(new (0, $ed8411a99200f4e9$export$19e02114ee9734c8)({
            animationDelay: 500,
            maxValue: limitQuantity,
            value: currentQuantity,
            tooltip: "".concat(currentQuantity, "/").concat(limitQuantity)
        })), '\n                </div>\n                <div class="').concat($a286755e58af7ca1$export$2ba01fb71ed41cb6, '">\n                    ').concat((0, $wYO7b.Resources).t("words.offerBlockedButton"), '\n                </div>\n                <div class="').concat($a286755e58af7ca1$export$1ca1ec8b29a4ce27, '"></div>\n            </div>\n        ');
        return _this;
    }
    (0, $jyA4z._)(OfferBlockedComponent, [
        {
            key: "commit",
            value: function commit() {
                this.el($a286755e58af7ca1$export$2ba01fb71ed41cb6).onClick(/*#__PURE__*/ (0, $hWZw8._)(function() {
                    var offerModal;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $lThic.EntityService).activeOfferIsFailureToPay) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3Qm5T.Network).router.pages.redirect("/b/home/content/subscriptions/home")
                                ];
                            case 1:
                                _state.sent();
                                location.reload();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                offerModal = new (0, $fd89a7af4beb2b9e$export$6191bb88e92acd1c)((0, $co7RM.ProductType).BLOG);
                                offerModal.screenRender();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }));
                (0, $2a50ed38ddeef305$export$71511d61b312f219)((0, $5q8bQ._)(OfferBlockedComponent.prototype), "commit", this).call(this);
            }
        }
    ]);
    return OfferBlockedComponent;
}((0, $9gCL8.Component));



var $wYO7b = parcelRequire("wYO7b");
var $ae179e9fcdafc484$export$3c54fb971d2da0a3 = /*#__PURE__*/ function(VisualModalComponent) {
    "use strict";
    (0, $jCmGC._)(OfferBlockedModalComponent, VisualModalComponent);
    function OfferBlockedModalComponent(currentQuantity, limitQuantity, solutionType, productType) {
        (0, $3CDbU._)(this, OfferBlockedModalComponent);
        var _this;
        _this = (0, $ep9cZ._)(this, OfferBlockedModalComponent);
        _this.name = (0, $wYO7b.Resources).t("words.offerBlocked");
        _this.modalStyle = "width: 300px;";
        _this.modalTemplate = _this.draw(new (0, $6c46cf8fdfb47606$export$713337cf8164d1db)(currentQuantity, limitQuantity, solutionType, productType));
        return _this;
    }
    return OfferBlockedModalComponent;
}((0, $4c1003e9348fedb7$export$2a517e1cac1c1f85));



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");
var $ff082db34c85c19b$export$73044afb89dc5de3 = /*#__PURE__*/ function() {
    "use strict";
    function AccountLogService() {
        (0, $3CDbU._)(this, AccountLogService);
    }
    (0, $jyA4z._)(AccountLogService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "searchLogs",
            value: /**
     * rest
     */ function searchLogs(search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/account/logs", search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AccountLogService;
}();



var $hWZw8 = parcelRequire("hWZw8");

var $3CDbU = parcelRequire("3CDbU");

var $jyA4z = parcelRequire("jyA4z");

var $eJDpD = parcelRequire("eJDpD");

var $3Qm5T = parcelRequire("3Qm5T");

var $co7RM = parcelRequire("co7RM");

var $cKMRi = parcelRequire("cKMRi");
var $dcad801922d79c99$export$8700658f21c9a426 = /*#__PURE__*/ function() {
    "use strict";
    function TrackingLogService() {
        (0, $3CDbU._)(this, TrackingLogService);
    }
    (0, $jyA4z._)(TrackingLogService, null, [
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "searchLogs",
            value: /**
     * rest
     */ function searchLogs(search, component) {
                return (0, $hWZw8._)(function() {
                    var request;
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $3Qm5T.Network).postJson((0, $co7RM.ProductType).PANEL, "/tracking/logs", search, component)
                                ];
                            case 1:
                                request = _state.sent();
                                if (request.status == (0, $cKMRi.HttpStatus).OK) return [
                                    2,
                                    request.data
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TrackingLogService;
}();


var $e913106c378d0993$export$cec36545a5eebac5 = /*#__PURE__*/ function() {
    "use strict";
    function PanelNetwork() {
        (0, $3CDbU._)(this, PanelNetwork);
    }
    (0, $jyA4z._)(PanelNetwork, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        /**
         * override
         */ (0, $3Qm5T.Network).onToken = /*#__PURE__*/ (0, $hWZw8._)(function() {
                            var _tmp;
                            return (0, $eJDpD.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(0, $17004beb65fc22e9$export$f650c34b939fcf30).hasSsr()) return [
                                            3,
                                            1
                                        ];
                                        _tmp = true;
                                        return [
                                            3,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4,
                                            (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).token()
                                        ];
                                    case 2:
                                        _tmp = _state.sent();
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2,
                                            _tmp
                                        ];
                                }
                            });
                        });
                        (0, $3Qm5T.Network).onLogin = /*#__PURE__*/ (0, $hWZw8._)(function() {
                            var connected;
                            return (0, $eJDpD.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        (0, $3Qm5T.Network).logged = true;
                                        return [
                                            4,
                                            (0, $3Qm5T.Network).startWebSocket((0, $co7RM.ProductType).PANEL)
                                        ];
                                    case 1:
                                        connected = _state.sent();
                                        if (!connected) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).onLogin()
                                        ];
                                    case 2:
                                        _state.sent();
                                        _this.initServices();
                                        _this.initEvents();
                                        return [
                                            2,
                                            true
                                        ];
                                    case 3:
                                        return [
                                            2,
                                            false
                                        ];
                                }
                            });
                        });
                        (0, $3Qm5T.Network).onLogout = /*#__PURE__*/ (0, $hWZw8._)(function() {
                            return (0, $eJDpD.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        (0, $3Qm5T.Network).logged = false;
                                        (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).onLogout();
                                        _this.disposeServices();
                                        return [
                                            4,
                                            (0, $3Qm5T.Network).disconnect((0, $co7RM.ProductType).PANEL, true)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2,
                                            true
                                        ];
                                }
                            });
                        });
                        (0, $3Qm5T.Network).onError = function(message) {
                            var _Network_router_static, _Network_router_static1;
                            if ((_Network_router_static = (0, $3Qm5T.Network).router["static"]) === null || _Network_router_static === void 0 ? void 0 : _Network_router_static.components.notifications) (_Network_router_static1 = (0, $3Qm5T.Network).router["static"]) === null || _Network_router_static1 === void 0 ? void 0 : _Network_router_static1.components.notifications.notify(message, undefined, 8000);
                        };
                        (0, $3Qm5T.Network).onPaymentRequired = function(currentQuantity, limitQuantity, solutionType, productType) {
                            var modal = new (0, $ae179e9fcdafc484$export$3c54fb971d2da0a3)(currentQuantity, limitQuantity, solutionType, productType);
                            modal.screenRender();
                        };
                        /**
         * on error
         */ (0, $3Qm5T.Network).lostFunctions = [];
                        (0, $3Qm5T.Network).onNetworkLost(function() {
                            (0, $eQCFs.SedestralInterface).body.render(new (0, $f6bb03a8aeeb2fca$export$cb3fc5fbc3cd8ca6)());
                        });
                        (0, $3Qm5T.Network).lostSolvedFunctions = [];
                        (0, $3Qm5T.Network).onNetworkLostSolved(function() {
                            return window.location.reload();
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initServices",
            value: function initServices() {
                (0, $lThic.EntityService).init();
                (0, $1LZ0s.SiteService).init();
                (0, $htL4C.SiteChannelService).init();
                (0, $1cwwH.RoleService).init();
                (0, $8FuDB.RoleAccountService).init();
                (0, $1a6dafa86dd08eae$export$961fa99b63baa1c2).init();
                (0, $25a36d1d7e7edd70$export$1ad9ba1937b657a1).init();
                (0, $fIUGb.AccountService).init();
                (0, $ff082db34c85c19b$export$73044afb89dc5de3).init();
                (0, $dcad801922d79c99$export$8700658f21c9a426).init();
                (0, $712b8c213114f73d$export$d9845d64048805ae).init();
                (0, $bb21924d01b29d74$export$dcb66d9e8650d51c).init();
                (0, $jaTWB.AvatarService).init();
                (0, $8zF1W.AvatarColorService).init();
                (0, $38D2A.FileService).init();
                (0, $7d1bda405ba71b14$export$3aed5f2d684ba248).init();
                (0, $dmlE6.PreferencesService).init();
                (0, $3bf4287f7ed05e66$export$2ba536885b8718d9).init();
                (0, $97d6e5c8b4e5da89$export$bcc04e5ab52ff38).init();
                (0, $4adbbe1bc8046e85$export$55b7b226f6213252).init();
            }
        },
        {
            key: "disposeServices",
            value: function disposeServices() {
                (0, $1LZ0s.SiteService).dispose();
                (0, $htL4C.SiteChannelService).dispose();
                (0, $1a6dafa86dd08eae$export$961fa99b63baa1c2).dispose();
                (0, $25a36d1d7e7edd70$export$1ad9ba1937b657a1).dispose();
                (0, $e25d7635d2d87041$export$8b2d45e406ebb5ab).dispose();
                (0, $fIUGb.AccountService).dispose();
                (0, $ff082db34c85c19b$export$73044afb89dc5de3).dispose();
                (0, $dcad801922d79c99$export$8700658f21c9a426).dispose();
                (0, $bb21924d01b29d74$export$dcb66d9e8650d51c).dispose();
                (0, $jaTWB.AvatarService).dispose();
                (0, $8zF1W.AvatarColorService).dispose();
                (0, $38D2A.FileService).dispose();
                (0, $lThic.EntityService).dispose();
                (0, $7d1bda405ba71b14$export$3aed5f2d684ba248).dispose();
                (0, $dmlE6.PreferencesService).dispose();
                (0, $3bf4287f7ed05e66$export$2ba536885b8718d9).dispose();
                (0, $97d6e5c8b4e5da89$export$bcc04e5ab52ff38).dispose();
                (0, $4adbbe1bc8046e85$export$55b7b226f6213252).dispose();
            }
        },
        {
            key: "initEvents",
            value: function initEvents() {
                (0, $1LZ0s.SiteService).onReload = function() {
                    location.reload();
                };
            }
        }
    ]);
    return PanelNetwork;
}();



var $3Qm5T = parcelRequire("3Qm5T");

var $dmlE6 = parcelRequire("dmlE6");
var $8e6ff1559575bced$export$6570986f4924cf71 = /*#__PURE__*/ function(PanelNetwork1) {
    "use strict";
    (0, $jCmGC._)(WebsiteNetwork, PanelNetwork1);
    function WebsiteNetwork() {
        (0, $3CDbU._)(this, WebsiteNetwork);
        return (0, $ep9cZ._)(this, WebsiteNetwork, arguments);
    }
    (0, $jyA4z._)(WebsiteNetwork, null, [
        {
            key: "init",
            value: function init() {
                return (0, $hWZw8._)(function() {
                    return (0, $eJDpD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $e913106c378d0993$export$cec36545a5eebac5).init()
                                ];
                            case 1:
                                _state.sent();
                                (0, $3Qm5T.Network).onToken = /*#__PURE__*/ (0, $hWZw8._)(function() {
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            true
                                        ];
                                    });
                                });
                                (0, $3Qm5T.Network).onLogout = /*#__PURE__*/ (0, $hWZw8._)(function() {
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            true
                                        ];
                                    });
                                });
                                (0, $3Qm5T.Network).onLogin = /*#__PURE__*/ (0, $hWZw8._)(function() {
                                    return (0, $eJDpD.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            true
                                        ];
                                    });
                                });
                                (0, $3Qm5T.Network).lostFunctions = [];
                                (0, $3Qm5T.Network).onNetworkLost(function() {});
                                (0, $3Qm5T.Network).lostSolvedFunctions = [];
                                (0, $3Qm5T.Network).onNetworkLostSolved(function() {});
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initServices",
            value: function initServices() {
                (0, $dmlE6.PreferencesService).init();
            }
        }
    ]);
    return WebsiteNetwork;
}((0, $e913106c378d0993$export$cec36545a5eebac5));



var $9IvVr = parcelRequire("9IvVr");

var $co7RM = parcelRequire("co7RM");


var $78NO5 = parcelRequire("78NO5");
var $6b7abc8c0062c3cc$var$r = function() {
    return "undefined" != typeof window;
}, $6b7abc8c0062c3cc$var$t = function() {
    return !(!$6b7abc8c0062c3cc$var$r() || !window.hj);
}, $6b7abc8c0062c3cc$var$e = function(t) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    var _window;
    if ($6b7abc8c0062c3cc$var$r() && window.hj) return (_window = window).hj.apply(_window, [
        t
    ].concat((0, $78NO5._)(e)));
    throw Error("Hotjar is not available, make sure init has been called.");
}, $6b7abc8c0062c3cc$var$n = function(r, e, n) {
    if (!function(r, t, e) {
        try {
            var _$n = document.getElementById(t) || document.createElement("script");
            return _$n.id = t, _$n.nonce = e, _$n.innerText = r, _$n.crossOrigin = "anonymous", document.head.appendChild(_$n), !0;
        } catch (r) {
            return !1;
        }
    }("(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:".concat(r, ",hjsv:").concat(e, ",hjdebug:").concat((null == n ? void 0 : n.debug) || !1, "};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"), "hotjar-init-script", null == n ? void 0 : n.nonce) || !$6b7abc8c0062c3cc$var$t()) throw Error("Failed to initialize Hotjar tracking script.");
}, $6b7abc8c0062c3cc$var$o = {
    init: function(r, t, e) {
        try {
            return $6b7abc8c0062c3cc$var$n(r, t, e), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    event: function(r) {
        try {
            return $6b7abc8c0062c3cc$var$e("event", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    identify: function(r, t) {
        try {
            return $6b7abc8c0062c3cc$var$e("identify", r, t), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    stateChange: function(r) {
        try {
            return $6b7abc8c0062c3cc$var$e("stateChange", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    isReady: $6b7abc8c0062c3cc$var$t
};
var $6b7abc8c0062c3cc$export$2e2bcd8739ae039 = $6b7abc8c0062c3cc$var$o;



(0, $gzN0P.config)["import"]("website");
(0, $446e07ea1e729403$export$d1af847c14d84dee).ready(/*#__PURE__*/ (0, $hWZw8._)(function() {
    var hotjarId, hotjarVersion;
    return (0, $eJDpD.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0, $446e07ea1e729403$export$d1af847c14d84dee).init()
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0, $8e6ff1559575bced$export$6570986f4924cf71).init()
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0, $3Qm5T.Network).init((0, $9IvVr.ProductName).toString((0, $co7RM.ProductType).WEBSITE))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0, $66039daec1c37d8f$export$e9fe003e12bfbc08).init()
                ];
            case 4:
                _state.sent();
                if (!(0, $17004beb65fc22e9$export$f650c34b939fcf30).hasSsr() && !/Googlebot|Spiders|Crawlers/i.test(navigator.userAgent)) {
                    (0, $3ea28b5e58cb3479$export$2cb99e4be0dc4646)("https://js-na1.hs-scripts.com/48111012.js", function() {});
                    try {
                        if (!(0, $gzN0P.config).isDev && !(0, $17004beb65fc22e9$export$f650c34b939fcf30).hasSsr()) {
                            hotjarId = (0, $gzN0P.config).hotjarId;
                            hotjarVersion = 6;
                            (0, $6b7abc8c0062c3cc$export$2e2bcd8739ae039).init(Number(hotjarId), hotjarVersion);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
                return [
                    2
                ];
        }
    });
}));

})();
//# sourceMappingURL=website.9c1d486a.js.map
 }());